import React from "react"

export default function AppLogo(props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="110"
      viewBox="0 0 1080 755"
      enableBackground="new 0 0 1080 755"
      xmlSpace="preserve"
      style={props.style}
      className={props.className}
    >
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M702.000000,756.000000 
	C468.000000,756.000000 234.500031,756.000000 1.000031,756.000000 
	C1.000021,504.333374 1.000021,252.666718 1.000010,1.000065 
	C360.999969,1.000043 720.999939,1.000043 1081.000000,1.000022 
	C1081.000000,252.666611 1081.000000,504.333221 1081.000000,755.999878 
	C954.833313,756.000000 828.666687,756.000000 702.000000,756.000000 
M758.002319,588.995056 
	C758.002319,588.995056 758.013367,589.036865 758.505066,588.867004 
	C758.686401,588.578613 758.867737,588.290222 758.994995,587.993164 
	C758.994995,587.993164 758.998840,588.047791 759.546448,587.838013 
	C759.824158,587.562683 760.101807,587.287292 760.834717,586.557983 
	C763.239441,583.445740 765.644165,580.333557 768.612244,576.815613 
	C771.427246,572.216492 774.242310,567.617310 776.997253,563.011230 
	C776.997253,563.011230 777.035950,563.057678 777.739929,562.966919 
	C778.549927,561.655945 779.359924,560.344971 780.617310,558.685547 
	C780.765320,558.146851 780.913269,557.608154 781.575012,556.655273 
	C782.054688,555.436035 782.534302,554.216797 783.455200,552.811646 
	C783.738953,552.630371 783.921814,552.376404 784.498291,551.699768 
	C784.666382,551.132385 784.834412,550.564941 785.620911,549.699280 
	C788.264099,544.758484 790.545715,539.577332 793.633240,534.931824 
	C798.543945,527.543030 799.632507,518.542053 804.487244,511.070038 
	C806.754517,507.580414 806.562805,502.586212 808.034302,498.470154 
	C814.361023,480.773132 816.762390,462.234680 819.978821,443.874023 
	C820.890442,438.670380 821.712341,433.384857 821.812744,428.122375 
	C821.934265,421.753601 821.245850,415.369354 821.012695,408.069397 
	C820.977295,404.044800 820.941956,400.020203 821.173157,395.274597 
	C821.113220,394.514587 821.053284,393.754547 821.284729,392.208710 
	C821.223083,391.099030 821.161438,389.989380 821.342651,388.173187 
	C821.251587,387.941406 821.160522,387.709656 821.590454,386.981171 
	C821.314636,383.964111 821.038757,380.947052 821.195618,377.234253 
	C821.308594,374.605011 821.421631,371.975800 821.855652,368.417328 
	C821.789734,364.264160 821.723816,360.110992 821.585144,355.028900 
	C821.499939,349.053650 821.414795,343.078369 821.716064,336.259888 
	C821.611023,333.507172 821.505981,330.754425 821.732910,327.496063 
	C821.801392,327.306396 821.869873,327.116760 822.296692,326.824646 
	C822.356262,326.716797 822.490234,326.542542 822.463013,326.512085 
	C822.313416,326.344513 822.124451,326.212128 821.819580,325.289734 
	C821.863953,324.505005 821.908325,323.720245 822.545410,322.368042 
	C822.369080,313.925354 822.192749,305.482666 821.897644,296.150238 
	C821.955750,293.760376 822.013855,291.370514 822.620178,288.443817 
	C822.453735,285.962982 822.287231,283.482178 822.005371,280.132812 
	C822.049683,278.092041 822.093994,276.051300 822.482422,273.847778 
	C822.538818,273.734802 822.672607,273.572632 822.637695,273.517670 
	C822.512878,273.321350 822.330750,273.161377 822.056458,272.058289 
	C822.146667,264.393341 822.236877,256.728394 822.925659,248.946701 
	C825.792053,245.362061 823.217407,242.254135 821.817871,238.308792 
	C820.093140,238.067764 818.331299,237.971283 816.655212,237.540802 
	C815.269287,237.184875 813.984680,236.434448 813.060242,235.218933 
	C813.145386,234.478668 813.230530,233.738403 813.726196,232.565399 
	C813.426758,231.381363 813.127319,230.197327 812.984741,228.189194 
	C813.299194,226.876770 813.613586,225.564346 814.672852,224.587601 
	C817.742004,225.273300 820.811096,225.959000 823.880249,226.644699 
	C824.092224,226.244751 824.304260,225.844818 824.516296,225.444885 
	C821.433594,222.267715 818.350891,219.090561 814.910156,215.461121 
	C814.748291,215.355698 814.586426,215.250259 814.727356,214.518051 
	C815.050232,214.188644 815.373169,213.859253 816.393982,213.754761 
	C818.512756,212.219925 820.631531,210.685089 822.831360,208.440552 
	C819.652954,204.030121 814.958496,203.895615 810.017639,203.293350 
	C811.565369,201.743790 813.113098,200.194229 815.346436,198.575043 
	C820.052979,193.403366 820.052979,193.403366 814.566040,189.688324 
	C816.663330,186.534714 818.759460,183.382690 820.855652,180.230667 
	C820.767151,179.798828 820.678650,179.366989 820.590149,178.935150 
	C816.182007,181.344696 813.287903,179.976578 811.618408,175.931839 
	C809.384338,177.146790 807.518005,178.161774 805.431335,179.296600 
	C804.562988,178.025909 803.774841,176.872574 802.997681,175.735382 
	C798.441162,177.431000 795.878113,180.797989 795.295654,185.309387 
	C794.819885,188.994568 792.980591,189.668274 789.679626,188.303131 
	C788.461975,185.778473 787.244324,183.253830 785.969971,180.051498 
	C780.642883,173.708160 775.315796,167.364807 769.532349,160.984680 
	C769.532349,160.984680 769.075195,160.954987 769.031555,160.231400 
	C765.077698,153.689774 760.191589,148.126953 752.997314,144.485687 
	C752.997314,144.485687 752.970398,143.998474 752.699341,143.391815 
	C748.133667,139.593796 743.568054,135.795776 738.496094,131.765335 
	C738.013184,131.489151 737.530212,131.212967 736.991150,130.353226 
	C736.665466,129.900665 736.339783,129.448105 735.903748,128.322281 
	C726.454834,117.991905 714.541748,110.820274 703.153015,103.014008 
	C698.877563,100.083473 694.001648,98.041115 689.475403,95.460701 
	C685.270874,93.063744 681.167480,90.489540 676.622803,87.471054 
	C675.415466,86.972290 674.208069,86.473534 672.630188,85.436050 
	C671.422546,84.957672 670.214966,84.479301 668.577332,83.449615 
	C657.850342,79.067398 647.304626,74.156487 636.361267,70.405617 
	C607.586060,60.542870 577.683472,57.022045 547.444519,56.107121 
	C539.676575,55.872097 531.875366,56.735504 523.234253,57.062790 
	C521.612000,57.368786 519.973572,58.007515 518.370056,57.929161 
	C502.822113,57.169418 488.021515,61.652031 473.075439,64.675362 
	C461.138397,67.090027 449.389221,70.640617 437.774078,74.365059 
	C430.261017,76.774139 422.964752,80.054169 415.889648,83.582268 
	C407.963440,87.534775 400.431824,92.272018 392.662079,96.546997 
	C386.188629,100.108749 379.558289,103.388565 373.132812,107.031998 
	C371.419495,108.003487 370.380615,110.116524 368.714844,111.231461 
	C366.494293,112.717705 363.644531,113.355255 361.621979,115.029945 
	C353.240601,121.969742 345.049988,129.141022 336.827667,136.271500 
	C332.232056,140.256851 327.536255,144.150620 323.205139,148.410522 
	C318.608490,152.931564 314.098694,157.605377 310.091461,162.642441 
	C306.347839,167.348129 303.313019,172.617722 299.279236,177.891663 
	C296.843109,178.965942 294.406952,180.040207 291.484100,180.824768 
	C291.301788,180.775848 291.119446,180.726929 290.712616,180.111801 
	C289.479828,178.891327 288.247040,177.670853 286.941315,175.800125 
	C285.399780,174.752335 283.858246,173.704559 282.376282,172.697250 
	C281.081268,174.149261 280.242401,175.089813 279.628021,175.778687 
	C277.040863,174.917831 272.931702,173.308655 272.820312,173.549377 
	C270.838287,177.832703 266.771912,176.955399 261.910553,177.606567 
	C264.143127,179.941269 265.599487,181.464264 267.191132,183.650314 
	C268.139496,184.770996 269.087891,185.891678 269.358704,187.214630 
	C268.000885,188.539688 263.309357,188.551422 267.639221,192.519196 
	C267.911957,192.686661 268.184692,192.854126 268.714325,193.622803 
	C269.155212,194.094742 269.596130,194.566681 269.963928,195.433426 
	C270.297699,195.646240 270.631470,195.859039 271.301636,196.593277 
	C272.688324,197.746964 274.075043,198.900665 275.679321,200.691315 
	C275.685394,201.125305 275.691467,201.559280 274.848022,202.017105 
	C270.488770,202.547668 265.715851,201.863144 262.047089,206.460587 
	C263.942688,207.388672 265.477509,208.140121 267.250275,209.135529 
	C267.250275,209.135529 267.582611,209.210846 267.721527,209.665787 
	C267.721527,209.665787 267.979431,210.065552 267.929626,210.771835 
	C266.229584,212.709198 264.317444,214.507050 262.914368,216.639801 
	C262.154541,217.794830 262.262878,219.520996 262.292358,221.604614 
	C263.151276,221.871353 264.010223,222.138077 265.010010,222.936630 
	C267.058319,226.299210 267.113708,222.685410 268.668549,221.944534 
	C269.102112,221.897141 269.535645,221.849731 270.130371,222.304932 
	C270.386688,222.538116 270.642975,222.771286 270.889923,223.866562 
	C270.947327,225.575684 271.004730,227.284805 270.931396,229.664780 
	C270.202393,230.773682 269.473389,231.882599 268.061157,233.024384 
	C266.907745,233.592194 265.802704,234.494370 264.592468,234.669586 
	C259.492035,235.408051 258.803223,236.820724 261.097229,243.011246 
	C261.041626,244.839951 260.964142,246.668289 260.933929,248.497421 
	C260.694733,262.968933 260.464447,277.440582 259.625305,292.329529 
	C259.425415,301.662598 259.177490,310.995117 259.073334,320.329254 
	C259.056122,321.870819 259.668640,323.419403 260.140808,325.668304 
	C260.255920,326.128662 260.371002,326.589020 260.244629,327.910645 
	C260.322906,330.289062 260.401154,332.667450 260.242493,335.948944 
	C260.182556,342.620422 260.122620,349.291870 259.421814,356.437439 
	C259.401062,357.763062 259.380310,359.088715 259.443604,360.796661 
	C259.481506,361.058594 259.469513,361.318237 259.119537,362.300873 
	C259.391876,363.193054 259.664185,364.085205 259.896545,365.887024 
	C259.978882,368.914490 260.061249,371.941956 259.535675,375.345734 
	C259.516296,377.580109 259.496948,379.814484 259.550934,382.458496 
	C259.550934,382.458496 259.822174,382.773956 259.656952,383.560028 
	C259.741119,384.344452 259.825317,385.128876 259.717163,386.749023 
	C259.820831,388.162720 259.924500,389.576416 259.769257,391.890533 
	C259.749176,396.276428 259.729065,400.662292 259.137451,405.646118 
	C259.052673,407.295105 258.933319,408.943176 258.888428,410.593262 
	C258.427734,427.525299 259.827942,444.304291 262.998199,461.657196 
	C263.279907,462.783386 263.561584,463.909546 263.926239,465.851837 
	C265.629456,472.559875 267.332672,479.267883 269.275818,486.715210 
	C271.274048,493.327606 272.809662,500.125763 275.373383,506.511108 
	C279.794617,517.522949 284.254974,528.597168 289.814423,539.052063 
	C295.500732,549.745422 302.527527,559.726074 309.049255,570.689819 
	C310.001068,571.502563 310.952911,572.315369 311.990967,573.765320 
	C312.669403,574.839966 313.347839,575.914551 314.295502,577.605225 
	C320.330322,584.970947 325.966614,592.713745 332.495117,599.612305 
	C341.853088,609.500610 351.454773,619.241150 361.715790,628.167175 
	C370.749390,636.025452 380.664948,642.918396 390.525665,649.754883 
	C394.908936,652.793762 400.115417,654.645264 405.629517,657.084045 
	C406.083801,657.072815 406.538055,657.061523 406.992706,656.995911 
	C406.992706,656.995911 406.947968,657.026978 407.007507,657.728943 
	C409.325073,659.205750 411.642639,660.682617 414.431519,662.647522 
	C416.284790,663.434998 418.138062,664.222534 420.433258,665.539368 
	C424.626831,667.359985 428.820404,669.180542 433.608398,671.096680 
	C434.008759,671.123291 434.409149,671.149902 435.257324,671.717468 
	C439.505188,673.469299 443.753082,675.221130 448.627472,677.268005 
	C449.734253,677.527771 450.841003,677.787537 452.411438,678.555847 
	C453.937439,679.023193 455.463440,679.490540 457.724731,680.102295 
	C461.148987,681.069275 464.573273,682.036316 468.455200,683.508850 
	C470.004425,683.889954 471.553650,684.271057 473.901031,684.815552 
	C479.585083,685.909485 485.269135,687.003357 491.405731,688.573792 
	C493.220459,690.111450 495.035156,691.649109 497.114258,693.657837 
	C497.433960,694.092285 497.753693,694.526733 498.096619,695.608093 
	C498.728546,696.076538 499.360474,696.544922 500.457062,697.473755 
	C502.942749,700.005920 505.428406,702.538025 508.036255,705.740112 
	C509.739594,707.081482 511.442932,708.422852 513.705933,710.063171 
	C514.835083,710.959045 515.964233,711.854919 517.340271,713.396851 
	C521.562561,715.990417 525.784912,718.583984 530.337402,721.439270 
	C530.337402,721.439270 530.739319,721.565674 531.035339,722.102844 
	C532.709290,722.971497 534.383179,723.840210 536.665771,725.130310 
	C537.724854,725.321411 538.974670,725.970947 539.809692,725.623474 
	C543.265076,724.185913 546.594910,722.446594 550.666626,720.805481 
	C563.744629,714.149963 574.226440,704.400208 583.021057,692.865295 
	C585.233398,689.963684 587.392151,688.143921 591.643372,688.070801 
	C592.111023,688.054443 592.578735,688.038025 593.793579,688.025757 
	C594.538635,687.978760 595.283691,687.931824 596.785034,687.839783 
	C601.524231,686.557190 606.263367,685.274597 611.704163,684.013794 
	C612.801941,683.672302 613.899780,683.330811 615.794250,682.988403 
	C625.018555,679.917358 634.362427,677.156860 643.425293,673.666626 
	C649.504456,671.325378 655.185303,667.949707 660.995483,665.005554 
	C660.995483,665.005554 661.021606,665.057495 661.567627,665.108032 
	C661.750305,665.101379 661.932922,665.094788 662.745911,665.033508 
	C663.854370,664.464600 664.962769,663.895630 666.754028,663.137817 
	C668.248169,662.109436 669.742371,661.080994 671.599060,660.086121 
	C671.599060,660.086121 671.961365,660.050659 672.642883,659.975403 
	C674.075134,658.980713 675.507324,657.985962 677.689636,656.992676 
	C683.327759,653.935364 689.236145,651.281616 694.541931,647.728210 
	C702.920349,642.117004 711.186279,636.254883 718.948914,629.832947 
	C725.385559,624.507996 731.027405,618.222351 737.661560,612.081787 
	C738.457642,611.062012 739.253723,610.042236 740.000000,609.000061 
	C740.000000,609.000061 740.022644,609.049927 740.717957,609.013672 
	C745.827515,603.352661 750.937073,597.691650 756.019470,591.993958 
	C756.019470,591.993958 756.028809,592.035828 756.583740,591.746582 
	C756.733765,591.172180 756.883850,590.597839 757.002441,590.000000 
	C757.002441,590.000000 757.028015,590.025330 757.566162,589.955139 
	C757.724304,589.641846 757.882446,589.328552 758.002319,588.995056 
z"
      />
      <path
        fill="#0C1C1F"
        opacity="1.000000"
        stroke="none"
        d="
M813.315674,232.998138 
	C813.230530,233.738403 813.145386,234.478668 812.554688,235.571442 
	C811.312561,236.865005 810.575867,237.806046 809.381042,238.757751 
	C806.091003,238.751709 803.258911,238.705231 800.427185,238.723129 
	C781.949524,238.839966 763.471863,238.970703 744.589355,238.977081 
	C742.788452,238.930481 741.392517,239.003723 739.645142,238.970978 
	C738.891602,239.575027 738.489319,240.285049 737.968018,241.384552 
	C737.919312,242.849731 737.989746,243.925446 737.933105,245.322327 
	C737.862915,246.094986 737.919739,246.546463 737.860718,247.454498 
	C737.418823,296.639984 737.072449,345.368805 736.783691,394.097961 
	C736.726624,403.729523 736.890808,413.362366 736.832153,423.420013 
	C736.801025,425.897461 736.890808,427.949524 736.867310,430.248932 
	C736.821167,430.664795 736.888306,430.833282 736.842285,431.427979 
	C736.643005,433.901947 736.556885,435.949646 736.102539,438.012207 
	C731.681885,438.888428 733.173706,442.087067 733.118225,444.502045 
	C732.928894,452.734924 733.532959,461.044006 732.625610,469.189392 
	C731.101074,482.875031 725.866394,495.534821 720.097107,507.956573 
	C719.384399,509.491089 719.568665,511.442200 719.303467,513.187988 
	C719.269653,513.175781 719.216064,513.127930 718.851685,513.224121 
	C718.030212,514.662354 717.573120,516.004395 717.062012,517.652832 
	C716.164124,519.046753 715.320251,520.134277 714.086792,521.162598 
	C711.904236,523.322815 710.112427,525.543152 708.317871,527.761292 
	C707.178284,529.169861 706.277283,531.438599 704.852600,531.838989 
	C696.793091,534.104126 693.554688,540.690979 690.149170,547.446899 
	C690.126587,547.644043 690.013855,548.025635 689.657715,548.062073 
	C687.355530,549.194824 685.043457,549.932556 683.542480,551.464722 
	C680.727234,554.338623 678.381165,557.672180 675.493835,560.874817 
	C673.401917,562.258667 671.656189,563.582275 669.549683,564.940674 
	C663.098877,567.675903 657.394897,570.873413 653.508911,576.916992 
	C649.456177,579.318054 645.692200,581.575928 642.124939,584.110474 
	C641.215027,584.757080 640.928101,586.280457 640.271851,587.397583 
	C640.188721,587.394165 640.336975,587.469421 639.958252,587.319580 
	C634.158813,588.119934 630.683777,591.469055 630.042725,596.481873 
	C629.805176,596.916626 629.579651,597.063477 628.904907,597.080322 
	C627.518005,597.695923 626.153442,598.119934 625.584412,599.037354 
	C623.580322,602.268188 621.849243,605.668335 619.600159,608.987671 
	C618.459473,607.086975 617.154053,605.217773 617.105408,603.316345 
	C616.869141,594.071350 616.676697,593.872009 608.411743,597.681641 
	C607.364441,598.164368 606.252197,598.545288 605.132935,598.825012 
	C602.058533,599.593201 600.578796,601.373474 601.142212,604.835083 
	C600.705872,605.350708 600.358643,605.651978 599.682434,605.986938 
	C598.898865,606.677063 598.444336,607.333557 597.994873,607.994995 
	C598.000000,608.000000 597.990295,607.989624 597.672363,608.003174 
	C597.006348,608.465942 596.658325,608.915161 596.318176,609.369629 
	C596.325989,609.374878 596.334595,609.393677 595.930481,609.279114 
	C591.654236,609.214783 593.477478,612.217529 592.943726,614.258362 
	C592.757202,614.813843 592.520813,615.002747 591.787720,615.041748 
	C586.233582,617.632263 584.948792,623.584290 587.972900,631.316162 
	C587.994507,632.101868 588.001465,632.550964 588.044373,633.317505 
	C588.700623,634.092102 589.321045,634.549377 589.959045,635.014343 
	C589.976685,635.022034 589.992493,635.058411 589.993652,635.427246 
	C590.347961,637.190430 590.701111,638.584839 590.985474,640.249512 
	C590.838684,640.688721 590.760864,640.857605 590.320496,641.088379 
	C589.316956,642.028259 588.274109,642.833008 588.098694,643.795837 
	C586.709656,651.417969 592.330200,658.304443 600.123169,659.067139 
	C602.416626,659.291565 604.627258,660.361694 606.875793,661.044250 
	C606.754761,661.739014 606.633728,662.433838 606.512756,663.128601 
	C602.313293,663.420654 598.117310,663.796204 593.912903,663.969727 
	C591.785950,664.057556 589.762695,663.938171 589.733948,667.187622 
	C589.253601,668.283813 589.027649,669.153564 588.571045,670.292725 
	C587.910095,674.321960 590.834839,673.005371 592.332520,672.850037 
	C596.570251,672.410706 600.834229,671.817993 604.955505,670.766663 
	C609.978271,669.485413 615.297546,668.407227 619.659912,665.835510 
	C622.544495,664.135132 623.971863,659.962585 626.372437,656.904419 
	C627.119812,656.947144 627.546204,656.982361 628.028931,657.397217 
	C630.346863,658.668030 632.545227,659.914917 634.891174,660.332336 
	C636.612793,660.638733 639.257446,660.462524 640.147888,659.388306 
	C641.007080,658.351807 640.217285,655.880615 640.013733,654.055115 
	C639.879089,652.847351 639.500977,651.666687 639.211304,650.383057 
	C642.484558,650.550598 644.905701,650.674561 647.597900,650.805298 
	C648.231750,650.839478 648.594666,650.866943 649.043518,651.082153 
	C649.430969,651.178711 649.732422,651.087524 650.330200,651.014648 
	C651.122864,651.321838 651.619202,651.610596 652.123108,652.250916 
	C652.854248,652.975647 653.577759,653.348877 654.555908,653.723389 
	C655.149109,653.751953 655.487610,653.779297 656.112183,653.880493 
	C656.592346,653.981262 656.786438,654.008240 656.987305,654.497375 
	C657.061035,656.191528 657.127991,657.423645 656.987244,658.917236 
	C633.412170,669.887268 609.225342,677.878540 583.667053,681.408264 
	C582.200134,681.610840 580.863464,682.756775 579.208923,683.678833 
	C577.428406,686.263672 576.194031,688.896240 574.323975,690.950073 
	C569.974365,695.727234 565.318298,700.225464 560.840942,704.863708 
	C560.895447,704.890686 560.904846,704.769409 560.614502,704.828369 
	C560.113647,705.195190 559.903137,705.503052 559.758423,705.766724 
	C559.824219,705.722473 559.695251,705.630249 559.375366,705.685486 
	C557.673218,706.760315 556.290894,707.779907 554.561157,708.877930 
	C550.195190,711.224609 546.273254,713.698975 542.106384,715.650574 
	C540.619507,716.347046 538.249084,716.380005 536.783569,715.674194 
	C532.048584,713.393738 527.546753,710.629150 522.773987,707.773071 
	C520.155640,705.877747 517.718323,704.260620 515.238525,702.752319 
	C515.196106,702.861206 515.340454,702.677368 515.258057,702.357544 
	C510.671631,697.335327 506.167572,692.632935 501.548889,687.577759 
	C500.976807,687.069641 500.519379,686.914368 500.128296,686.830444 
	C500.194641,686.901794 500.316284,686.749573 500.265198,686.393982 
	C499.043610,682.589233 497.076019,680.278870 492.714844,680.841064 
	C489.139130,679.986816 485.840271,679.297791 482.550964,678.565857 
	C460.733765,673.710754 439.807495,666.349731 420.062653,655.946533 
	C424.692200,654.065247 429.215424,652.705261 433.487274,650.785828 
	C434.976929,650.116516 435.846191,648.066528 437.094208,646.613525 
	C437.189606,646.580017 437.393280,646.595947 437.809479,646.698730 
	C439.714142,647.008301 441.202576,647.215088 443.648163,647.554810 
	C441.588470,649.774780 440.131622,651.070435 439.021851,652.615417 
	C437.828156,654.277222 436.830170,656.204102 440.075348,657.171387 
	C440.111755,657.360962 440.153595,657.744751 440.176147,657.952271 
	C440.414734,658.017151 440.630768,657.874634 441.102753,657.522705 
	C442.226410,657.199585 443.094116,657.085754 444.117981,657.206970 
	C444.872559,657.268921 445.470978,657.095764 446.384827,656.925171 
	C447.120209,656.914429 447.540131,656.901062 448.198547,657.186523 
	C450.516235,657.308777 452.694641,657.467957 454.654572,656.888306 
	C459.229218,655.535461 463.698853,653.827576 467.594177,652.477356 
	C468.965790,654.177856 470.058014,655.532043 471.547882,656.905151 
	C473.286407,656.936279 474.627319,656.948486 476.228882,657.250854 
	C477.931091,657.689270 479.397980,658.084412 480.809479,657.939697 
	C485.157166,657.493958 490.040131,650.732178 488.908142,646.526367 
	C488.956543,644.746704 488.998901,643.377869 489.202454,641.923096 
	C489.427734,641.735352 489.569855,641.582031 489.542603,641.540833 
	C489.417358,641.351624 489.244843,641.193787 489.064423,640.752686 
	C489.024841,640.299194 489.010071,640.117676 488.994202,639.578247 
	C488.330841,637.501282 487.668610,635.782166 487.351837,633.992249 
	C489.116760,631.660522 491.631470,629.434326 491.704559,627.130798 
	C491.820526,623.474243 490.456451,619.720703 489.374573,616.111206 
	C489.103027,615.205200 487.522736,614.691406 486.405334,613.683777 
	C486.113403,612.940735 485.960114,612.511353 486.080292,611.907959 
	C485.735046,606.883545 482.744720,604.520691 478.076233,603.508728 
	C474.546967,599.074402 470.653015,595.648865 464.952484,594.594604 
	C463.885071,593.944824 462.905121,593.653748 461.925201,593.362671 
	C461.676331,594.580139 461.080139,595.844482 461.236847,597.007324 
	C462.046661,603.016418 463.049194,608.999573 463.646027,614.959351 
	C462.185577,613.590942 461.063599,612.254944 459.898132,610.602539 
	C459.229584,609.202515 458.604584,608.118958 457.899780,606.815308 
	C457.658539,606.317566 457.432770,606.109985 457.098755,605.649170 
	C457.031982,604.892212 457.009155,604.458496 456.988342,603.647034 
	C455.516510,595.412842 449.275177,591.350769 443.674072,586.915100 
	C438.882080,583.120239 434.172028,578.511902 426.942017,580.689880 
	C426.533264,579.240417 426.238892,578.120544 426.222290,576.805969 
	C426.035400,572.242065 422.835938,569.937317 418.650208,571.088989 
	C417.918854,570.646667 417.475067,570.279053 416.996552,569.589722 
	C415.978485,568.177063 414.995117,567.086060 413.968506,565.644897 
	C409.340149,561.638123 404.761505,557.973328 400.134308,554.370911 
	C400.012756,554.276306 399.361542,554.862061 398.638916,555.035339 
	C397.102539,553.675232 395.884491,552.410339 394.954102,550.979858 
	C394.544189,550.031372 393.975861,548.812439 393.121338,548.559204 
	C391.488068,548.075195 389.691803,548.140930 387.907440,547.625305 
	C387.807007,546.557190 387.762360,545.842285 388.021240,544.939758 
	C388.249542,543.727051 388.571503,542.363586 388.033813,541.732544 
	C384.876526,538.027100 381.580811,534.430542 378.139832,530.989197 
	C377.763092,530.612488 376.162079,531.459961 375.037048,531.859131 
	C374.945160,531.978577 374.646912,532.022095 374.377197,531.781372 
	C373.343811,528.921997 373.019775,526.059937 371.730835,523.732117 
	C368.362671,517.649109 364.621063,511.769135 360.908051,505.884125 
	C360.196503,504.756287 358.935394,503.975159 357.694580,502.859863 
	C357.284607,502.142395 357.107819,501.599091 357.223083,500.800720 
	C356.859131,497.439758 356.355438,494.290253 355.483398,491.246246 
	C355.042267,489.706390 353.476349,488.439606 353.201874,486.908966 
	C351.026489,474.777130 349.033966,462.612427 346.997864,450.455719 
	C346.301636,446.298553 345.641296,442.135406 344.846680,437.520386 
	C345.059998,372.249847 345.332153,307.433472 345.837677,242.618927 
	C345.876892,237.590347 344.693146,236.183807 339.544495,236.223709 
	C317.219543,236.396729 294.890625,236.093262 272.563690,235.897568 
	C270.749420,235.881653 267.669098,237.021225 268.744415,232.991516 
	C269.473389,231.882599 270.202393,230.773682 271.238068,229.361145 
	C271.544739,229.057526 272.028717,229.004532 272.256592,229.265564 
	C281.033295,228.989471 289.582153,228.452332 298.449951,228.082855 
	C303.717590,231.042450 306.718384,228.995636 308.028900,224.783020 
	C313.191589,225.191086 317.768219,225.691559 322.357025,225.858734 
	C324.758240,225.946243 327.163544,225.427887 326.956543,221.665436 
	C326.775787,217.190811 324.734619,214.769272 320.833496,213.314133 
	C318.306946,212.371735 316.165253,210.397552 313.712585,208.561539 
	C309.112610,205.087738 304.599274,206.766190 299.726318,208.070251 
	C297.966614,208.378708 296.570312,208.709320 295.117432,208.709564 
	C294.366394,207.941299 293.671875,207.503403 292.729126,206.775818 
	C290.303192,206.918915 288.125519,207.351700 285.622925,207.849625 
	C284.862244,207.990417 284.426422,208.066055 283.786652,207.849457 
	C281.947876,207.098022 280.313049,206.638794 278.488434,206.120789 
	C278.061066,205.918976 277.805115,205.867691 277.420319,205.515961 
	C277.004181,204.373825 276.698578,203.623901 276.774231,202.824371 
	C278.443939,202.163361 279.732300,201.551941 281.422363,200.961517 
	C282.898712,200.969269 283.973389,200.956009 285.440338,200.916168 
	C288.056610,200.811829 290.316833,200.447372 292.496277,200.722473 
	C295.897552,201.151779 299.245605,202.520828 302.613281,202.510895 
	C304.758606,202.504578 306.973755,200.851608 308.985138,199.648636 
	C309.452850,199.368927 309.641663,197.448776 309.236206,197.081802 
	C307.237976,195.273193 304.996674,193.733200 302.622528,192.054199 
	C302.111298,191.893524 301.903076,191.690491 301.815857,191.022110 
	C299.966614,189.301224 298.253265,187.447845 296.153687,186.739838 
	C293.189941,185.740448 291.546448,184.355438 291.970795,181.114471 
	C294.406952,180.040207 296.843109,178.965942 299.824341,178.027802 
	C301.525665,179.167053 302.681885,180.170151 303.840149,181.515076 
	C304.557526,181.847397 305.272827,181.837875 306.267700,181.766006 
	C307.026062,181.464203 307.504822,181.224731 308.290649,181.143433 
	C310.325378,183.406631 312.052979,185.511673 313.780579,187.616699 
	C315.339935,186.283554 316.194366,191.960236 318.315643,188.073975 
	C318.434906,189.735275 318.252197,191.364990 318.175415,192.049774 
	C319.600311,193.886154 320.819092,195.456848 321.865784,197.055511 
	C321.787323,197.043289 321.880890,197.003113 322.332581,196.970978 
	C323.136841,197.658279 323.582977,198.337524 323.866882,199.073288 
	C323.795135,199.075302 323.885681,199.020798 324.351837,198.927948 
	C326.052277,199.959198 328.659576,201.340286 328.488037,202.046402 
	C327.565002,205.846634 330.599182,207.432281 332.189728,209.737305 
	C334.585876,213.209900 339.153778,215.473526 338.052887,220.822098 
	C337.987671,221.138885 338.572571,221.589493 338.950073,222.317017 
	C340.678345,223.721069 342.311493,224.785950 344.089233,226.176331 
	C347.805786,228.047455 351.377808,229.593079 355.080902,231.319061 
	C355.442139,231.694778 355.701385,231.837173 355.993439,232.402313 
	C355.996582,251.671143 356.021393,270.464325 355.981750,289.257324 
	C355.967712,295.907715 358.690643,301.098297 363.976013,305.420227 
	C367.318298,310.876373 370.640778,315.955261 373.973694,321.426453 
	C377.021698,328.850403 378.567139,336.176239 378.485870,343.855804 
	C378.466736,345.661682 378.695496,347.495239 379.028564,349.275177 
	C380.084503,354.917755 379.368591,361.645905 387.603668,362.931396 
	C388.881561,363.130890 390.188965,364.493439 391.071167,365.635956 
	C394.488800,370.062073 397.798187,374.575287 401.040497,379.132477 
	C406.952026,387.441254 412.529358,396.006165 418.807404,404.024811 
	C420.749634,406.505493 424.321625,408.406036 427.474854,409.114319 
	C437.580719,411.384399 447.834229,413.004883 458.050812,414.759430 
	C458.865967,414.899475 459.990051,414.339935 460.703552,413.770752 
	C463.040314,411.906525 465.087921,412.180389 467.456421,413.859070 
	C469.313477,415.175262 471.619141,416.417572 473.275208,412.933197 
	C474.014587,412.233673 474.450134,411.622009 475.181366,410.799438 
	C473.396210,404.336548 471.565857,397.986359 469.163879,391.860291 
	C466.780609,385.781952 463.661438,379.996033 461.148315,373.963867 
	C455.645233,360.755249 450.442657,347.419556 444.770020,334.285767 
	C444.066162,332.656067 441.253876,331.937012 439.380859,330.721863 
	C439.343109,330.647797 439.201538,330.560577 439.409851,330.217346 
	C438.782837,326.697327 437.543213,324.008301 433.415894,324.691406 
	C433.381439,324.621674 433.245361,324.546326 433.441559,324.204468 
	C431.245697,319.248444 428.642090,314.873352 422.835632,314.146393 
	C422.928741,314.069000 422.778290,314.258698 422.846161,313.868164 
	C422.840942,309.717224 420.471741,308.849670 417.106506,308.953247 
	C416.926849,308.895844 416.810608,308.536957 416.845886,308.155029 
	C415.916565,305.820404 414.951935,303.867676 414.345581,301.976929 
	C421.028046,304.994476 427.408295,307.836792 433.662445,310.933685 
	C441.841766,314.983856 449.968842,314.066742 458.421021,311.104614 
	C459.213898,311.117828 459.742371,311.156860 460.387085,311.634705 
	C461.302277,319.073883 462.101227,326.074280 462.857697,333.484192 
	C463.540588,337.585114 464.265961,341.276550 464.968018,345.309509 
	C465.181366,346.516937 465.417999,347.382904 465.667480,348.636047 
	C466.441589,351.694366 467.202850,354.365479 468.098389,357.362671 
	C469.468903,358.525818 470.705200,359.362976 472.396637,360.508301 
	C473.733765,355.496185 474.891235,351.372375 475.932343,347.219391 
	C481.602905,324.599152 481.064911,301.603363 479.978729,278.583618 
	C479.937164,277.702484 479.289581,276.850006 478.960754,275.650452 
	C478.908356,274.664368 478.819641,274.011993 478.812439,273.023438 
	C478.959473,272.232483 479.025055,271.777710 479.485962,271.244324 
	C486.078949,270.655121 483.369781,275.254578 483.570221,278.301239 
	C482.516113,282.252380 484.431000,283.208344 487.694061,283.149811 
	C494.442749,283.028778 501.194061,283.054199 508.000671,283.430756 
	C508.026123,285.223297 507.995178,286.604431 507.660889,288.036011 
	C506.891266,288.431946 506.424927,288.777466 505.524384,288.935669 
	C498.233124,288.748291 491.376068,288.748291 484.186157,288.748291 
	C484.290131,291.111053 484.367004,292.857788 484.440521,294.528687 
	C486.149841,295.144806 487.535492,295.644257 488.882538,296.490112 
	C488.937378,297.526489 489.030853,298.216492 489.080261,299.342010 
	C490.163361,304.131897 488.668945,309.283081 492.179504,312.913086 
	C492.690094,312.853577 493.200714,312.794067 493.711334,312.734589 
	C493.817139,310.732910 493.922943,308.731262 494.334808,306.847534 
	C495.504700,307.934784 496.368530,308.904114 497.204895,310.227783 
	C498.511841,313.885315 500.119263,313.741943 502.150024,310.833557 
	C502.629913,310.495667 502.821686,310.229919 503.221863,309.827515 
	C503.721741,308.826080 503.939301,307.907928 504.195129,306.715210 
	C504.496521,305.967041 504.759583,305.493500 505.257294,304.858704 
	C505.937500,304.394287 506.383057,304.091125 506.828613,303.787964 
	C506.926331,304.243347 507.024048,304.698730 507.062286,305.486145 
	C507.318817,306.548553 507.634827,307.278931 508.022522,308.459045 
	C509.100616,318.233337 510.107025,327.557922 511.034546,337.295715 
	C511.923859,342.162170 512.892029,346.615448 513.838501,351.442932 
	C514.280457,353.478271 514.744202,355.139374 515.174438,357.155151 
	C516.036743,358.700653 516.932556,359.891479 518.372253,361.805298 
	C519.550476,359.434540 520.633667,358.073303 520.912659,356.563477 
	C523.036194,345.071686 525.568726,333.613342 526.848328,322.020325 
	C527.980530,311.762421 527.663452,301.344543 528.301758,290.949890 
	C529.443237,288.185547 530.269165,285.468628 531.416382,282.814270 
	C532.150024,283.017853 532.562439,283.158844 532.983704,283.630768 
	C533.659302,285.474152 534.326172,286.986542 534.667542,288.594238 
	C533.901489,288.617798 533.460938,288.546021 532.943420,288.208008 
	C532.259766,288.328491 531.653015,288.715240 531.070435,289.519348 
	C531.040405,292.837616 530.338989,296.125214 534.853760,296.640259 
	C534.924133,297.963684 535.024292,298.925293 535.077148,300.319763 
	C535.799927,304.863647 536.570068,308.974640 537.340210,313.085663 
	C537.972717,313.028656 538.605286,312.971649 539.237793,312.914642 
	C539.560974,310.823700 539.884094,308.732758 540.527405,306.768097 
	C542.692444,308.863129 544.537354,310.831909 546.844360,313.293793 
	C548.070496,311.679382 549.085510,310.342987 550.392883,308.971130 
	C552.077209,308.629456 553.469177,308.323242 554.939453,308.474426 
	C555.052185,313.281921 555.086609,317.631989 554.932373,322.075989 
	C554.902283,322.450623 555.060852,322.731384 555.365784,323.391052 
	C556.960144,331.900208 558.408203,340.030457 559.786865,348.554749 
	C560.506470,351.934814 561.295410,354.920776 562.074280,358.264282 
	C563.012939,359.778748 563.961731,360.935760 565.708252,363.065491 
	C569.447083,352.480835 571.467712,342.900879 571.986938,332.572021 
	C572.664124,329.688538 573.806519,327.225128 573.891296,324.725800 
	C574.385620,310.154602 574.631897,295.575012 575.217041,280.899658 
	C575.949646,280.539429 576.427124,280.277771 576.952820,280.420410 
	C577.911438,281.883209 578.743286,283.770905 579.744873,283.865814 
	C586.321655,284.488556 592.935059,284.724457 599.679260,285.094421 
	C599.970032,285.870026 600.369812,286.936523 600.499634,288.032227 
	C599.819275,288.378265 599.408875,288.695099 598.530029,289.003357 
	C591.480530,288.994843 584.899475,288.994843 578.043152,288.994843 
	C578.132385,292.466614 576.459412,296.280975 581.894409,296.886292 
	C582.718445,301.160004 583.559204,305.048920 584.437317,309.110748 
	C584.955078,307.999573 585.378418,307.091003 586.018982,305.716125 
	C588.366455,308.500977 590.324646,310.824097 593.182190,314.214111 
	C595.422363,310.014038 597.281189,306.529022 599.479553,303.029907 
	C600.274109,303.009399 600.729065,303.002960 601.292297,303.438354 
	C601.306641,306.599945 601.212646,309.319733 600.866943,312.071411 
	C600.788025,312.387115 600.960754,312.670898 601.271729,313.349396 
	C601.955017,317.990265 602.500000,322.236420 602.894409,326.771515 
	C602.877075,327.700348 603.010254,328.340271 603.126404,329.357727 
	C603.347717,331.476562 603.586060,333.217865 603.516907,334.984436 
	C602.802185,334.978119 602.394958,334.946564 601.893860,334.536133 
	C599.418213,325.358032 599.418213,325.358032 589.792847,325.350769 
	C589.462097,325.350525 589.131348,325.349396 588.800598,325.350159 
	C575.491394,325.380829 578.188354,324.255463 576.074341,337.446808 
	C576.003479,338.522156 576.001526,339.240814 575.871948,340.273499 
	C575.755676,341.030365 575.767029,341.473175 575.583862,342.179871 
	C575.297791,343.306061 575.206299,344.168457 574.906006,345.291016 
	C574.644104,346.416870 574.591003,347.282501 574.397339,348.534119 
	C573.903687,351.628571 573.550537,354.337128 572.995361,357.390533 
	C572.837769,363.159271 572.882263,368.583160 572.864380,374.471741 
	C572.794617,386.595703 572.787292,398.254913 572.624329,410.292053 
	C572.394592,412.325592 572.320374,413.981171 571.840332,415.612091 
	C570.901123,415.554047 570.367676,415.520660 569.520752,415.350281 
	C568.179382,415.579041 567.151489,415.944794 565.723511,416.316498 
	C564.816101,416.486725 564.308716,416.651031 563.503662,416.590637 
	C561.865784,416.143524 560.525696,415.921051 558.809509,415.584534 
	C557.918030,415.383301 557.402649,415.296143 556.795715,414.812195 
	C556.586304,413.339569 556.468384,412.263672 556.547485,410.743652 
	C556.630554,403.515533 556.516724,396.731598 556.470703,389.544556 
	C556.463074,379.106812 556.387573,369.072174 556.489014,358.671692 
	C556.069702,351.194244 555.473511,344.082672 554.727295,336.585327 
	C554.357544,335.153076 554.137817,334.106598 554.038208,332.633057 
	C553.738892,325.177612 553.738892,325.174988 546.981995,325.190918 
	C545.170532,325.195190 543.359070,325.216522 541.547668,325.237610 
	C531.167664,325.358521 531.159180,325.357910 529.487183,335.497589 
	C529.386230,336.109955 529.585083,336.771759 529.522949,337.780518 
	C529.254700,339.432098 529.107849,340.713776 528.744385,342.303436 
	C528.330750,344.075531 528.133789,345.539642 527.777466,347.318909 
	C527.561035,348.794830 527.504028,349.955536 527.353943,351.528595 
	C527.190063,353.630188 527.119263,355.319458 526.891357,357.371246 
	C526.767822,361.498779 526.801392,365.263763 526.775391,369.466248 
	C526.734009,372.257385 526.752136,374.610992 526.578613,377.257080 
	C526.498779,379.382446 526.610596,381.215424 526.664978,383.510681 
	C526.596619,393.326172 526.585754,402.679352 526.425415,412.382538 
	C525.864685,413.876923 525.453369,415.021271 524.770386,416.218689 
	C524.314819,416.255402 524.130981,416.239075 523.611694,416.029358 
	C522.573181,415.467163 521.836304,414.730042 521.172791,414.791046 
	C517.610535,415.118561 514.066528,415.644775 509.911011,416.180389 
	C509.911011,407.234924 509.911011,399.623291 510.031311,391.555481 
	C510.206024,384.302032 510.501404,377.496063 510.259216,370.709320 
	C509.882050,360.139435 509.139771,349.582611 508.625793,338.654572 
	C508.085144,335.561401 507.470947,332.833923 506.924805,329.692139 
	C507.281281,325.929382 505.567169,324.929749 502.454712,325.064331 
	C498.630280,325.229706 494.792542,325.086426 490.960541,325.077515 
	C483.823181,325.060913 483.371399,325.524445 483.042419,333.492676 
	C482.687103,335.593414 482.403137,337.324310 481.995178,339.424255 
	C480.992523,348.991760 479.687134,358.173615 479.329407,367.392303 
	C478.700714,383.592438 478.651978,399.815094 478.039307,416.237183 
	C474.783844,417.593994 471.609070,420.073761 468.967712,419.597137 
	C464.278412,418.751007 461.136841,420.518646 457.435211,422.921051 
	C454.945709,423.208191 452.861511,423.540649 450.392975,423.856415 
	C443.795349,426.297089 436.618591,426.966888 431.552521,433.300201 
	C433.380890,434.018219 434.379730,434.513123 435.434357,434.808990 
	C448.034027,438.343842 460.653076,441.810059 473.240723,445.386780 
	C476.880066,446.420898 480.435486,447.750427 483.990784,448.956146 
	C483.952179,448.967773 483.947754,449.048279 484.012787,449.377380 
	C484.816071,449.976898 485.554352,450.247253 486.516602,450.738159 
	C487.432190,451.415161 488.123749,451.871552 488.801025,452.507751 
	C488.786743,452.687592 488.935394,453.017212 488.947510,453.453400 
	C489.085083,455.638245 489.210541,457.386902 489.257202,459.190125 
	C489.178375,459.244690 489.098541,459.419006 488.909332,459.415283 
	C488.433350,459.546478 488.358337,459.756927 488.243713,460.240234 
	C487.342896,460.988556 486.693481,461.539551 485.727448,462.100769 
	C484.900848,462.716034 484.390869,463.321106 483.594025,464.070984 
	C482.249725,464.943390 481.192291,465.670959 479.810547,466.315796 
	C478.601410,467.094055 477.716614,467.955078 476.834045,468.902832 
	C476.836243,468.989563 477.006714,469.022186 476.688660,469.035339 
	C475.192444,469.916718 474.014252,470.785004 472.508911,471.671631 
	C471.452606,472.119354 470.723511,472.548706 469.629822,472.971619 
	C459.883026,476.943207 452.768097,484.622833 453.910065,489.277283 
	C455.914612,488.526917 457.939117,487.769073 459.879761,487.249451 
	C459.767120,487.821136 459.738342,488.154633 459.419006,488.691132 
	C459.082855,490.599335 459.037292,492.304535 458.998688,494.369385 
	C462.005585,497.474487 465.005554,500.219971 468.281677,503.089355 
	C469.278046,503.535553 469.998260,503.857880 470.825592,504.482117 
	C471.673828,505.044403 472.414917,505.304810 473.477173,505.745361 
	C476.768616,507.080933 479.738892,508.236389 482.854004,509.695374 
	C485.665344,511.266632 488.270996,512.687317 491.008667,513.776001 
	C503.863037,518.887634 517.261780,522.927368 528.120483,532.016296 
	C531.331421,534.703918 534.031860,538.001404 537.019165,541.333740 
	C537.217163,542.046448 537.362305,542.444885 537.389404,543.139404 
	C537.556274,543.936890 537.841187,544.438354 538.113892,545.287415 
	C538.188049,546.088806 538.274231,546.542542 538.269531,547.433472 
	C538.229431,550.246399 538.280273,552.622253 538.236267,555.328003 
	C538.103394,556.113098 538.065247,556.568237 537.765869,557.213623 
	C537.074890,558.601990 536.645142,559.799927 536.080200,561.267517 
	C535.564819,562.243164 535.184509,562.949158 534.493408,563.789429 
	C531.787781,566.278748 529.392883,568.633789 526.724121,571.094849 
	C525.966858,571.534180 525.483398,571.867554 524.652466,572.194946 
	C522.466248,573.421265 520.627380,574.653625 518.436340,575.940308 
	C508.064575,579.124695 498.045074,582.254761 487.739929,585.305420 
	C486.983185,585.513123 486.512054,585.800232 485.702026,586.076721 
	C484.920349,586.150879 484.477570,586.235657 483.678558,586.237061 
	C481.959381,586.628906 480.596405,587.104126 479.233459,587.579346 
	C479.299774,587.996460 479.366089,588.413513 479.432404,588.830627 
	C480.971497,589.113281 482.510559,589.395996 484.406738,589.783813 
	C485.504608,589.902527 486.245361,589.916077 487.382965,589.991394 
	C488.847748,590.036255 489.915680,590.019348 491.315735,590.065186 
	C492.712891,591.088501 493.777893,592.049194 495.109283,593.282715 
	C502.014648,592.082092 508.653656,590.608643 515.202148,589.575195 
	C512.669922,591.831482 510.228210,593.647827 507.786530,595.464111 
	C507.937317,595.889526 508.088074,596.314880 508.238831,596.740295 
	C512.489441,595.773560 516.740112,594.806763 521.097046,594.162354 
	C521.852234,595.934631 522.501160,597.384583 523.509460,598.806274 
	C528.376404,596.922607 532.883911,595.067139 537.757385,593.188232 
	C539.959473,592.638184 541.795593,592.111633 543.915466,591.776672 
	C544.473816,592.327209 544.748535,592.686218 544.797119,593.294434 
	C542.141113,594.995605 539.711121,596.447449 537.281128,597.899231 
	C537.540344,598.411804 537.799500,598.924316 538.058716,599.436829 
	C543.037476,597.287292 548.016296,595.137695 553.120728,593.276855 
	C553.568787,594.112488 553.891296,594.659546 553.949890,595.417969 
	C552.587036,596.146729 551.488037,596.663940 550.389038,597.181152 
	C550.497742,597.729187 550.606445,598.277161 550.715149,598.825195 
	C553.107361,598.565063 555.843384,598.962341 557.828735,597.924194 
	C564.327393,594.526306 570.552856,590.606018 577.155762,587.023926 
	C577.935547,587.762146 578.442871,588.362976 578.756531,589.234253 
	C576.486755,590.989258 574.410645,592.473694 571.604126,594.480469 
	C578.094788,595.932922 580.200745,590.729919 584.353882,589.076172 
	C585.797791,590.055969 586.904480,590.978638 588.359985,591.864441 
	C590.123230,591.168030 591.537537,590.508484 593.288513,589.820435 
	C594.205322,588.956177 594.785583,588.120361 595.642578,587.137207 
	C597.168213,586.236877 598.417114,585.484009 600.100952,584.813782 
	C601.419189,584.907715 602.302429,584.919006 603.162903,585.261108 
	C603.403625,585.935791 603.750793,586.616516 603.918579,586.574890 
	C610.460632,584.950134 615.048035,580.987732 618.067688,574.701660 
	C619.554382,573.262573 620.728333,571.949585 621.949768,571.024231 
	C622.071655,573.358643 622.145996,575.305359 622.150452,577.537903 
	C621.957458,578.196045 621.834412,578.568420 621.448364,578.993286 
	C620.964111,579.511169 620.742798,579.976562 620.521484,580.441895 
	C621.010010,580.299255 621.498535,580.156555 622.351318,579.974854 
	C624.514038,578.478455 626.633911,577.273499 628.027649,575.498413 
	C629.683411,573.389587 630.716431,571.060608 633.383423,574.385742 
	C633.730164,574.818054 634.882202,574.604370 636.015198,574.756836 
	C636.899597,574.188843 637.429932,573.553894 638.222656,572.759216 
	C639.272461,571.696655 640.059937,570.793823 641.183716,569.900513 
	C642.652771,569.345398 643.785522,568.780762 645.286255,568.137268 
	C655.947266,565.117737 651.163086,557.004639 651.739746,550.518188 
	C652.846680,552.217651 653.587036,553.951965 654.136414,555.744812 
	C654.738953,557.711060 655.165405,559.731384 655.677307,561.762695 
	C663.385803,558.433411 666.351074,553.390320 665.018555,546.953857 
	C665.929565,546.976074 666.446716,546.985718 667.218506,547.231323 
	C668.601074,548.140991 669.728882,548.814697 670.856750,549.488403 
	C671.134155,547.680664 671.411499,545.872925 672.029541,543.926147 
	C673.928772,543.178589 675.487427,542.570068 677.410645,541.995850 
	C679.195984,541.208679 680.616638,540.387146 683.187134,538.900757 
	C667.345520,529.871399 651.724182,524.542419 635.129883,521.785767 
	C635.126526,521.709045 635.143494,521.556396 635.054688,521.312927 
	C634.314392,521.031372 633.663025,520.993347 632.683350,520.941040 
	C631.932739,520.817017 631.510437,520.707397 630.970459,520.284241 
	C627.893982,519.326416 624.934998,518.682129 621.588928,518.002197 
	C619.153320,517.514709 617.104858,517.062927 614.951050,516.283569 
	C607.718262,512.175171 598.846436,511.911407 592.905396,505.738495 
	C593.482910,505.662170 594.060425,505.585876 594.637939,505.509583 
	C595.110962,503.437500 595.583984,501.365417 596.320496,499.066345 
	C597.970276,498.157379 599.356506,497.475403 601.068848,496.835754 
	C601.968567,496.361206 602.542297,495.844269 603.505737,495.241455 
	C605.481628,494.995789 607.067871,494.836029 609.070435,494.747742 
	C612.668518,494.224915 615.850342,493.630524 619.087891,493.378967 
	C620.638062,493.712708 622.163879,493.513885 623.617371,493.753693 
	C624.811340,493.950653 625.919312,494.668793 626.823669,495.412048 
	C622.453857,497.191742 618.296997,498.642639 614.207703,500.264008 
	C611.399292,501.377563 608.511902,502.454987 605.981445,504.056610 
	C603.864685,505.396423 603.618103,507.024628 607.000732,507.492432 
	C619.407227,510.857239 631.747437,513.852173 644.455994,516.971497 
	C645.835022,517.044495 646.845581,516.993103 648.052490,517.078613 
	C648.248840,517.215576 648.723083,517.280701 648.878784,517.483154 
	C649.339417,517.823486 649.644348,517.961426 650.248291,518.212524 
	C651.367188,518.522034 652.187073,518.718262 653.250244,519.216858 
	C658.044617,520.548096 662.595703,521.576904 667.535034,522.712952 
	C673.873108,524.338928 679.795776,525.980408 685.788025,527.307373 
	C687.779419,527.748352 690.704285,528.257935 691.901550,527.226440 
	C696.073608,523.631897 700.643066,520.175354 700.106628,513.374023 
	C699.598083,506.927185 699.876526,500.402405 700.107971,493.922577 
	C700.179260,491.926392 700.812683,489.686584 701.907410,488.034637 
	C707.858032,479.055511 714.105469,470.273621 720.097839,461.321411 
	C722.679993,457.463867 725.355774,453.469971 723.307800,448.149780 
	C723.208069,447.280975 723.016846,446.662933 722.889771,445.608154 
	C723.555725,440.489136 723.311951,435.179138 718.771057,433.367188 
	C711.835144,430.599579 704.248596,429.462555 696.541504,427.459656 
	C692.237915,426.672241 688.351013,425.804718 684.420166,425.494476 
	C674.594299,424.719025 664.748474,424.196503 654.473206,423.430115 
	C649.698364,423.175262 645.360962,423.062744 640.585571,422.925415 
	C638.111389,422.933197 636.075195,422.965790 633.852539,422.912140 
	C633.666199,422.825928 633.260071,422.887268 633.124756,422.500183 
	C628.650452,421.394623 624.311401,420.676178 619.736450,419.689301 
	C618.565979,419.373260 617.631409,419.325623 616.811401,419.178589 
	C616.925903,419.079224 616.729675,419.310486 616.815308,418.897827 
	C617.553833,417.683594 618.235168,416.164673 618.855042,416.189362 
	C626.586609,416.497345 634.304077,417.259674 642.035767,417.433868 
	C648.687866,417.583679 655.353699,417.128143 662.335938,416.922668 
	C663.088745,416.909576 663.519043,416.914062 664.222290,417.221130 
	C668.400879,418.537964 672.267700,419.755737 676.223145,420.507385 
	C679.938721,421.213348 684.837524,423.109161 687.295410,421.517029 
	C692.912598,417.878235 697.406250,419.822083 702.759888,421.208649 
	C710.733032,423.273560 716.115967,421.372314 717.831360,413.094147 
	C718.063049,411.975922 718.256226,410.762543 718.833496,409.816772 
	C723.668152,401.896545 725.113342,392.934052 726.736572,384.055237 
	C727.260986,381.186890 722.888062,377.750427 720.782593,379.405365 
	C717.509277,381.978180 714.539612,385.142944 712.128174,388.543884 
	C710.058960,391.462097 708.801086,395.003143 707.469421,398.381134 
	C706.468750,400.919647 705.919861,403.636261 705.140625,406.580933 
	C704.767151,407.604126 704.422974,408.319977 703.709961,409.058960 
	C702.252075,410.215637 701.120178,411.311768 700.084656,412.492310 
	C698.839966,413.911377 697.677368,415.402405 696.479248,416.862274 
	C696.390503,414.828186 696.255066,412.794159 696.251038,410.759918 
	C696.250183,410.336395 696.816101,409.941528 696.985291,409.483429 
	C700.010986,401.290833 702.553101,392.878754 706.175903,384.960754 
	C708.926392,378.949280 712.982300,373.523346 716.576904,367.913452 
	C719.553223,363.268311 724.410706,359.073486 725.401428,354.077637 
	C727.144165,345.289612 726.738831,336.044739 726.877258,326.985748 
	C726.927429,323.700836 725.212158,321.025970 720.351440,320.029694 
	C718.071594,322.652527 715.374146,325.589355 712.875916,328.686798 
	C711.136597,330.843323 708.957520,333.013855 708.226196,335.540344 
	C706.537231,341.375244 705.425537,347.400269 704.437561,353.407043 
	C703.775879,357.430328 704.257080,361.683594 700.053711,364.363708 
	C699.392029,364.785553 699.737000,366.786163 699.535767,368.322449 
	C698.934998,369.350372 698.414978,370.112610 697.678101,370.825562 
	C697.461182,370.776215 697.043152,370.623993 696.955261,370.302521 
	C696.327576,368.869385 695.133423,367.598206 695.358948,366.673126 
	C696.447327,362.208649 698.009705,357.862579 699.230103,353.426697 
	C700.786804,347.768463 703.351562,342.046967 703.267639,336.385529 
	C703.200317,331.836304 703.600098,328.395203 706.703186,325.227448 
	C707.591736,324.320312 708.281555,323.218384 709.061646,322.205139 
	C712.355469,317.927094 715.546814,313.565094 718.967407,309.390900 
	C723.648193,303.678986 727.449524,298.049683 727.161438,289.874207 
	C726.575928,273.262115 727.018738,256.614655 726.952026,239.982101 
	C726.944275,238.037445 726.396362,236.094971 726.329346,234.040939 
	C726.719482,233.870850 726.879150,233.811310 727.376709,233.830505 
	C728.811707,233.614471 729.908813,233.319687 731.382629,233.018051 
	C734.497864,231.421646 737.236450,229.832092 740.338257,228.236908 
	C742.070740,226.485413 743.439880,224.739517 745.081482,222.815735 
	C748.248230,218.424072 751.142456,214.210297 754.356750,209.961761 
	C755.349121,208.620834 756.021545,207.314667 756.515747,205.694702 
	C756.196960,204.921463 756.056458,204.462006 756.285583,204.046112 
	C760.235596,204.979324 762.824585,204.333649 763.011108,199.989014 
	C763.002502,199.997711 762.988953,200.016769 763.331604,199.976746 
	C770.232544,195.993362 773.214600,188.133301 780.591431,184.671417 
	C782.601074,183.297394 784.313904,182.013290 786.026672,180.729187 
	C787.244324,183.253830 788.461975,185.778473 789.598022,188.927521 
	C787.329956,190.950165 785.143433,192.348419 782.745972,193.562256 
	C782.045776,193.950409 781.556641,194.523026 781.040710,195.063629 
	C781.013916,195.031616 781.097107,195.038651 780.847595,195.143585 
	C780.411255,195.548264 780.224487,195.848007 779.991089,196.403946 
	C779.690796,197.111877 779.437134,197.563583 778.887573,197.994675 
	C778.394409,197.981064 778.197266,197.988068 777.778137,198.102539 
	C777.277771,198.414597 777.103088,198.685974 777.022949,199.026627 
	C777.013672,199.029099 777.037903,199.041901 776.699829,199.072632 
	C776.560120,200.064423 776.758545,201.025497 776.986633,202.215851 
	C777.016235,202.445129 777.048279,202.906403 777.093994,203.285156 
	C781.518921,205.875549 785.789429,207.984085 790.988281,205.695282 
	C792.471802,205.042175 794.670227,206.012955 797.396423,206.342468 
	C794.022705,207.979156 792.001587,208.959656 789.643250,209.987244 
	C788.505554,210.356628 787.705139,210.678894 786.544312,210.929413 
	C782.314819,209.908127 778.481689,208.703369 774.556641,208.150024 
	C773.215820,207.960983 771.644409,209.406937 770.139282,210.324127 
	C770.100220,210.542374 770.017639,210.979080 769.733826,211.185944 
	C768.178589,212.272675 767.019348,213.449936 765.615784,213.979584 
	C760.271057,215.996445 756.208679,220.641449 756.156006,225.101654 
	C756.142700,225.084335 756.113708,225.090500 755.849304,225.074829 
	C755.334045,225.163330 755.083252,225.267487 754.832397,225.371643 
	C755.248779,225.578735 755.665222,225.785828 756.256470,226.310364 
	C762.533691,230.349899 768.673218,227.965240 775.119019,226.930511 
	C781.002625,232.234879 781.002625,232.234879 789.475647,228.003540 
	C791.567810,228.067642 793.242981,228.089508 795.097290,228.423752 
	C796.670532,229.471085 798.022461,230.723038 799.466919,230.840866 
	C803.292480,231.152954 807.158142,230.974457 811.262817,231.176453 
	C812.117126,231.907196 812.716431,232.452667 813.315674,232.998138 
M368.843872,491.601013 
	C368.843872,491.601013 369.164215,491.873596 369.106232,492.319092 
	C369.106232,492.319092 369.253967,492.743317 369.169952,493.510895 
	C372.822296,500.003906 376.474670,506.496918 380.264252,513.774902 
	C380.505280,514.529724 380.746338,515.284485 380.979431,516.830505 
	C380.744232,519.944031 381.924164,522.126404 385.237396,523.150269 
	C385.237396,523.150269 385.220490,523.370728 385.128815,524.146240 
	C387.570007,527.407410 389.747986,530.923035 392.556885,533.828796 
	C394.099670,535.424683 396.656281,536.737671 398.841431,536.882141 
	C404.870026,537.280640 410.943726,536.996765 417.060211,537.420166 
	C417.060211,537.420166 417.087097,537.861023 417.095520,538.593811 
	C419.075806,540.066650 421.056122,541.539429 422.949066,543.710266 
	C421.718506,544.955383 420.479401,546.192200 419.259216,547.447388 
	C416.901581,549.872681 415.044525,552.438354 417.312286,556.493469 
	C417.852356,556.684631 418.392456,556.875793 419.091431,557.774048 
	C423.064270,562.620239 428.010834,561.358276 433.619720,559.949097 
	C434.413635,559.634705 435.207550,559.320312 436.745911,559.005310 
	C437.490326,559.009338 438.234711,559.013367 439.091583,559.666382 
	C440.726959,559.107666 442.362305,558.548950 444.212982,557.556091 
	C444.410767,557.285339 444.669434,557.099121 445.661072,556.902649 
	C447.610107,555.437744 447.241577,554.507690 445.000000,554.000000 
	C445.000000,554.000000 444.989716,554.005798 444.820709,553.663757 
	C444.542877,553.774231 444.265045,553.884644 443.310852,553.992920 
	C442.859497,553.999939 442.408173,554.006897 441.464417,553.691223 
	C441.265533,553.148438 441.066620,552.605591 441.381042,551.680237 
	C440.961182,550.428040 440.541321,549.175842 439.971130,547.475220 
	C441.546570,547.287659 442.782593,547.140503 444.699463,547.353027 
	C447.013519,547.900635 449.313019,548.523071 451.645233,548.977722 
	C454.830627,549.598633 458.109833,549.855896 461.205383,550.760071 
	C462.388031,551.105530 463.174561,552.807007 464.441376,554.226379 
	C461.822815,554.747620 460.384705,555.033936 458.190247,555.347656 
	C457.191345,555.442078 456.192444,555.536499 454.906433,554.990479 
	C451.903900,554.339661 449.795990,555.497864 450.463226,558.599304 
	C451.517212,563.498352 451.465942,569.663025 459.090149,569.634216 
	C459.613831,569.632202 460.140167,570.331665 460.603180,570.660767 
	C459.533813,576.746277 461.647888,579.462463 467.757080,579.007446 
	C468.829285,578.984253 469.901520,578.961060 471.118683,579.695068 
	C475.034851,581.771606 478.653625,580.713928 480.516876,577.027527 
	C480.516876,577.027527 481.002106,576.980286 481.552429,576.627930 
	C482.466797,576.499756 483.510254,576.019714 484.274689,576.300171 
	C489.452026,578.199646 493.529510,576.904846 497.658417,571.955322 
	C498.092957,571.942322 498.527496,571.929321 499.390564,572.480225 
	C501.246582,571.612305 503.102631,570.744446 505.360687,569.390625 
	C506.176300,569.223389 506.991943,569.056152 508.632385,568.969238 
	C511.985657,567.810608 515.681702,567.184082 518.578857,565.317444 
	C520.722656,563.936218 521.402832,560.969177 518.114807,558.486206 
	C518.070068,558.312012 518.025269,558.137817 517.876160,557.278809 
	C516.335876,556.228271 514.795593,555.177734 513.255310,554.127197 
	C513.281982,553.586121 513.308655,553.045044 513.335266,552.503967 
	C516.727844,552.334167 520.189880,552.514893 523.486450,551.861084 
	C525.419922,551.477539 527.991577,550.156738 528.682678,548.565552 
	C529.955444,545.634766 523.984558,539.217529 519.949890,539.064087 
	C518.968750,538.317627 517.987549,537.571106 516.984070,536.098633 
	C515.406372,533.659241 513.659790,532.044678 510.212128,535.019470 
	C508.141296,535.302002 506.070496,535.584473 503.995575,535.134949 
	C502.683350,534.085083 501.371124,533.035217 500.385376,531.483826 
	C500.668091,530.964233 500.950806,530.444641 501.667908,529.941162 
	C501.829376,529.701965 501.990814,529.462830 502.152283,529.223633 
	C501.813202,529.400879 501.474152,529.578186 500.531342,529.459167 
	C495.175140,525.344360 489.392365,523.289368 482.098083,525.278687 
	C481.462921,523.869202 480.827759,522.459778 480.003662,520.229492 
	C478.110138,519.283936 476.216614,518.338379 473.761902,516.980713 
	C468.839020,515.656860 463.916138,514.332947 458.932190,512.213928 
	C457.466522,508.803101 456.000854,505.392273 454.273804,501.333038 
	C452.975128,499.853333 451.676483,498.373657 450.143250,496.232544 
	C443.379425,490.281769 436.053833,486.620667 426.777008,490.132568 
	C424.476471,491.003448 421.750061,490.986816 419.692932,492.188629 
	C418.022217,493.164764 417.060547,495.354553 415.046448,497.000000 
	C413.011047,495.677673 410.975647,494.355316 408.370575,492.589233 
	C404.951508,491.571533 401.589386,490.006104 398.102173,489.643341 
	C389.202362,488.717560 380.272369,485.176086 370.898804,489.242889 
	C370.587219,489.226562 370.360687,489.357483 369.532806,489.687286 
	C369.352661,489.829376 369.172485,489.971466 368.501678,490.060944 
	C368.415497,490.201019 368.222992,490.402435 368.262085,490.470276 
	C368.412079,490.730286 368.636444,490.947418 368.843872,491.601013 
M385.707672,373.753510 
	C385.414551,373.534607 385.121429,373.315674 384.941101,373.070557 
	C384.941101,373.070557 384.866364,373.158966 384.943146,372.351532 
	C383.746674,371.318695 382.550232,370.285828 380.787628,369.065277 
	C379.809937,367.812317 378.832245,366.559387 377.934326,364.479218 
	C376.618042,355.739594 375.480835,346.967255 373.892853,338.277283 
	C373.300140,335.033813 374.485229,330.706024 369.987274,329.086090 
	C369.987274,329.086090 369.863098,329.140564 369.949646,328.377258 
	C366.223450,324.411804 362.497253,320.446350 358.771057,316.480896 
	C358.297302,316.805786 357.823547,317.130676 357.349792,317.455566 
	C357.265991,318.691376 357.182190,319.927216 357.075775,321.594757 
	C357.075775,321.594757 356.987030,322.017914 356.194000,322.183136 
	C355.798553,323.670715 355.081238,325.153992 355.061218,326.646637 
	C354.950653,334.887085 354.960632,343.130432 355.055237,351.371307 
	C355.073090,352.924103 355.660187,354.470337 355.988098,356.870728 
	C355.989380,358.576599 355.990662,360.282440 355.455200,362.474609 
	C355.987183,363.987946 356.519165,365.501251 357.109528,367.672302 
	C357.086487,368.111420 357.063446,368.550507 356.445312,369.044434 
	C356.296356,369.698700 356.147400,370.352997 355.994873,371.804382 
	C355.994507,372.867218 355.994141,373.930084 355.542603,375.337311 
	C356.013397,375.892426 356.484161,376.447540 357.246033,377.053284 
	C357.246033,377.053284 357.539368,377.088806 357.681488,377.706909 
	C357.632416,378.123932 357.583344,378.540955 357.137146,379.033966 
	C356.960358,379.213928 356.783600,379.393890 356.606842,379.573853 
	C356.965057,379.728851 357.323242,379.883881 357.901031,380.653595 
	C357.982819,381.080383 358.064606,381.507202 357.471771,382.040283 
	C357.176758,382.627777 356.881744,383.215271 356.586731,383.802765 
	C357.736664,384.190521 358.886627,384.578308 360.017670,384.995453 
	C360.017670,384.995453 360.024445,384.969666 360.193420,385.430359 
	C360.377899,385.719025 360.634094,385.912933 361.241028,386.495544 
	C361.496796,386.988281 361.752563,387.481049 361.483368,388.383881 
	C362.041473,389.252258 362.599548,390.120605 363.267670,391.286957 
	C363.267670,391.286957 363.205872,391.598511 363.088898,392.408142 
	C364.530975,394.203247 365.973053,395.998322 367.746307,397.813568 
	C367.746307,397.813568 368.052338,397.941681 368.133148,398.692963 
	C371.338013,400.966736 374.555145,402.841370 377.989624,398.240723 
	C377.998657,397.485138 378.007690,396.729523 378.561096,395.517029 
	C378.453400,393.153534 378.345703,390.790009 378.222260,388.081360 
	C380.296051,388.931427 381.601532,389.466553 383.044281,390.409302 
	C383.044281,390.409302 383.124725,390.831848 383.104889,391.585907 
	C384.063843,395.451569 385.693176,398.776489 390.258362,400.550842 
	C391.182159,401.019073 392.105957,401.487305 393.146118,402.699615 
	C398.835785,405.941193 401.866943,405.757996 404.942261,401.491058 
	C404.942261,401.491058 404.920746,400.996399 405.584412,400.922150 
	C407.280029,397.764648 405.669403,396.139954 402.359985,394.995209 
	C402.190582,395.022430 402.021210,395.049683 401.679596,394.466492 
	C401.452972,393.653687 401.226349,392.840851 400.936676,391.339569 
	C400.443481,390.943054 399.950287,390.546539 398.923431,389.816101 
	C397.239380,387.635529 395.555328,385.454956 393.946503,382.493561 
	C392.507477,381.106567 391.068451,379.719574 389.781067,377.977814 
	C389.781067,377.977814 389.657654,378.342926 389.798126,377.620087 
	C389.314728,377.423187 388.831299,377.226288 388.115356,376.838318 
	C388.115356,376.838318 387.923309,376.606628 388.455872,375.941010 
	C387.536713,375.394104 386.617554,374.847198 385.825806,374.083221 
	C385.825806,374.083221 385.750702,374.323456 385.707672,373.753510 
M400.099884,478.722412 
	C401.062134,478.489777 402.024384,478.257111 403.044830,477.504395 
	C403.070557,477.331879 403.096313,477.159393 403.915100,476.994232 
	C405.236877,476.993713 406.558624,476.993225 408.286346,477.510040 
	C409.199127,477.338593 410.111908,477.167145 411.849487,476.998260 
	C413.224121,476.995483 414.598785,476.992737 416.304321,477.454681 
	C416.840088,477.593536 417.375824,477.732361 418.716827,477.942932 
	C420.507416,477.588715 422.297974,477.234497 424.736511,476.839630 
	C425.171265,474.894409 425.606018,472.949158 426.760773,470.906433 
	C428.168732,470.611755 429.576691,470.317108 430.989075,470.684845 
	C430.994751,471.126648 431.000458,471.568451 430.579437,472.232788 
	C430.308685,472.437592 430.150024,472.708130 430.136230,473.755310 
	C431.030334,474.440399 431.924469,475.125519 432.818604,475.810608 
	C433.235992,474.885315 433.653412,473.959991 434.789215,473.017029 
	C436.162476,473.373901 437.535706,473.730804 438.948975,474.982758 
	C438.948975,478.183014 438.948975,481.383270 438.948975,484.583496 
	C439.415100,484.726166 439.881195,484.868805 440.347321,485.011444 
	C441.319336,483.850464 442.267792,482.668701 443.268646,481.533112 
	C444.986633,479.584015 446.409210,477.122284 448.536133,475.833374 
	C454.808960,472.032013 461.417664,468.789734 467.786865,465.140106 
	C470.366943,463.661713 472.667419,461.695435 475.690796,459.601471 
	C476.785217,459.157227 477.879669,458.712952 478.974091,458.268707 
	C479.056000,457.775452 479.137909,457.282227 479.219818,456.788971 
	C474.121399,454.145264 469.227814,450.945557 463.881042,448.976135 
	C453.430511,445.126709 442.696747,442.053131 432.142761,438.474060 
	C427.928619,437.044952 422.482819,435.531555 422.330780,430.541443 
	C422.167847,425.192352 427.733734,423.520325 432.050568,421.853149 
	C435.140289,420.659851 438.435822,419.999451 441.639557,419.101288 
	C441.609344,418.686188 441.579163,418.271057 441.548950,417.855927 
	C433.019409,416.569031 424.514099,415.083771 415.955109,414.037506 
	C399.284363,411.999603 382.583588,410.207642 365.826569,407.891693 
	C365.540863,407.990021 365.255127,408.088318 364.314026,408.312561 
	C363.888306,408.198029 363.462616,408.083496 362.860321,407.622833 
	C362.561615,407.712952 362.262909,407.803070 361.321655,408.032501 
	C360.885406,408.060547 360.449127,408.088593 359.293457,407.816620 
	C358.465454,408.534882 357.637451,409.253113 356.048676,410.198639 
	C355.749939,410.574524 355.193146,410.948547 355.190491,411.326508 
	C355.133453,419.417847 354.868774,427.521912 355.236115,435.596588 
	C355.445007,440.187866 356.005402,444.823151 361.091980,447.577118 
	C363.248383,448.744598 364.361145,451.839783 365.963501,454.912170 
	C366.002533,456.912750 366.041565,458.913361 365.516083,461.429169 
	C365.951019,463.313751 366.385956,465.198364 366.885071,467.864624 
	C367.362518,468.908569 367.839966,469.952545 368.317444,470.996490 
	C368.850708,470.868378 369.384003,470.740295 369.917267,470.612183 
	C369.917267,468.748596 369.917267,466.884979 370.513000,464.486084 
	C371.303741,461.669189 372.094482,458.852264 372.954773,456.961273 
	C372.988983,460.948975 373.200104,464.945496 373.002899,468.921692 
	C372.837006,472.265717 374.150574,473.527710 377.710022,473.560333 
	C378.140656,475.198395 378.571289,476.836426 379.001892,478.474457 
	C380.661438,477.681763 382.321014,476.889038 384.738525,475.897949 
	C385.170898,473.932678 385.603271,471.967377 386.766235,469.996948 
	C388.162231,470.362000 389.558258,470.727051 391.008240,471.709320 
	C391.015289,472.122986 391.022339,472.536682 390.436371,473.062958 
	C390.627655,473.722931 390.818970,474.382904 391.044678,475.782135 
	C391.674744,476.499695 392.304779,477.217255 392.934845,477.934814 
	C393.617004,477.293488 394.299133,476.652191 395.693878,475.991211 
	C397.049286,476.355530 398.404663,476.719879 399.882263,477.578705 
	C399.913239,477.745605 399.944244,477.912476 400.099884,478.722412 
M529.252563,698.645752 
	C529.811096,698.817505 530.369690,698.989319 531.357483,699.708130 
	C534.645142,700.558228 538.408020,702.895264 541.144470,702.020691 
	C561.002441,695.674072 576.357971,680.687988 579.868225,660.147949 
	C583.870605,636.727722 566.797424,614.031067 544.243347,612.073181 
	C519.788818,609.950256 498.198273,628.950195 497.932190,653.201111 
	C497.689240,675.343689 510.735229,688.591919 529.252563,698.645752 
M570.080322,612.248779 
	C573.193848,615.555908 576.307312,618.863037 579.640381,622.403320 
	C581.908752,616.764160 583.916809,611.772095 586.496765,605.358398 
	C580.123657,607.039062 574.810120,608.426636 569.524475,609.913330 
	C569.394104,609.950073 569.572693,611.085144 570.080322,612.248779 
M500.743103,622.220337 
	C503.900757,618.272461 507.058411,614.324585 510.543427,609.967407 
	C504.500122,608.277649 499.036682,606.750000 492.590698,604.947632 
	C495.393097,611.476318 497.773865,617.022766 500.743103,622.220337 
M468.658325,665.929626 
	C475.855377,667.372314 482.943146,670.085083 490.531128,667.442017 
	C479.910339,664.962463 469.289520,662.482910 458.668701,660.003357 
	C458.430939,660.683716 458.193176,661.364136 457.955414,662.044495 
	C461.258118,663.281616 464.560822,664.518738 468.658325,665.929626 
M585.451416,311.592560 
	C585.451416,311.592560 585.380981,311.462616 585.451416,311.592560 
z"
      />
      <path
        fill="#F7EBD5"
        opacity="1.000000"
        stroke="none"
        d="
M307.983551,180.985275 
	C307.504822,181.224731 307.026062,181.464203 306.107758,181.500671 
	C305.058136,181.256195 304.448120,181.214722 303.838074,181.173248 
	C302.681885,180.170151 301.525665,179.167053 300.167847,177.901535 
	C303.313019,172.617722 306.347839,167.348129 310.091461,162.642441 
	C314.098694,157.605377 318.608490,152.931564 323.205139,148.410522 
	C327.536255,144.150620 332.232056,140.256851 336.827667,136.271500 
	C345.049988,129.141022 353.240601,121.969742 361.621979,115.029945 
	C363.644531,113.355255 366.494293,112.717705 368.714844,111.231461 
	C370.380615,110.116524 371.419495,108.003487 373.132812,107.031998 
	C379.558289,103.388565 386.188629,100.108749 392.662079,96.546997 
	C400.431824,92.272018 407.963440,87.534775 415.889648,83.582268 
	C422.964752,80.054169 430.261017,76.774139 437.774078,74.365059 
	C449.389221,70.640617 461.138397,67.090027 473.075439,64.675362 
	C488.021515,61.652031 502.822113,57.169418 518.370056,57.929161 
	C519.973572,58.007515 521.612000,57.368786 523.954468,57.355965 
	C536.441223,58.094265 548.205078,58.810463 559.974792,58.923615 
	C579.666321,59.112926 598.927246,62.640877 617.733643,67.703430 
	C633.810120,72.031128 649.241272,78.745544 665.000427,84.283279 
	C666.159851,84.690697 667.663635,84.117973 669.007324,84.000931 
	C670.214966,84.479301 671.422546,84.957672 672.858154,86.033516 
	C674.397278,87.085106 675.708435,87.539238 677.019531,87.993362 
	C681.167480,90.489540 685.270874,93.063744 689.475403,95.460701 
	C694.001648,98.041115 698.877563,100.083473 703.153015,103.014008 
	C714.541748,110.820274 726.454834,117.991905 735.579895,128.671600 
	C734.588562,130.027451 733.921143,131.033981 733.253662,132.040497 
	C734.518188,131.672577 735.782776,131.304672 737.047302,130.936768 
	C737.530212,131.212967 738.013184,131.489151 738.797791,132.219238 
	C740.654297,134.505264 741.964478,136.651703 743.820740,138.096512 
	C746.673584,140.317001 749.901611,142.055481 752.970398,143.998474 
	C752.970398,143.998474 752.997314,144.485687 753.034302,145.087708 
	C756.870056,151.940155 761.608704,157.274521 767.831909,161.255707 
	C764.568359,164.019699 767.965210,164.058060 769.313599,165.166718 
	C771.341248,167.268631 772.182312,169.048523 768.506226,170.029388 
	C767.842346,169.832977 767.470337,169.693848 767.060547,169.230881 
	C764.681030,166.592651 762.339294,164.278244 759.991699,161.737671 
	C759.655090,161.299194 759.324402,161.086868 758.745239,160.891754 
	C758.496887,160.908951 757.999084,160.897476 758.000854,160.501282 
	C757.352905,158.551834 756.975830,156.774872 755.952637,155.528137 
	C755.326416,154.765106 753.533813,154.304977 752.580322,154.630951 
	C751.395020,155.036179 750.221802,156.225540 749.605957,157.377090 
	C748.605408,159.247986 748.061829,161.363281 747.325439,163.375412 
	C747.015381,163.262711 746.705383,163.150009 746.395386,163.037308 
	C746.805115,164.169632 747.214905,165.301971 747.581116,166.314056 
	C744.789185,167.248917 742.364868,168.060699 740.075439,168.827286 
	C736.891113,166.285889 739.730530,158.099518 732.939270,160.097260 
	C727.640869,167.880829 741.959717,173.734879 733.462402,181.375977 
	C734.183167,182.352341 734.891968,183.312500 736.399414,185.354538 
	C730.811646,183.212082 728.271667,184.232819 729.486572,188.640625 
	C727.208069,189.047836 725.052856,189.010895 723.466736,189.942673 
	C722.902527,190.274094 723.720215,192.957962 723.980042,195.196930 
	C721.641724,195.005859 719.083801,194.796860 716.554504,194.590195 
	C716.184692,197.144424 715.811768,199.720367 715.145691,202.174377 
	C711.629578,199.182770 708.527283,196.162292 705.163086,193.468994 
	C689.197144,180.687134 672.684021,168.724670 653.737793,159.855576 
	C646.366699,156.548935 639.260376,153.484329 631.907715,150.212830 
	C630.443848,149.632401 629.226257,149.258865 627.824829,148.714935 
	C627.475220,148.524323 627.309326,148.504120 626.947144,148.281357 
	C626.204590,147.985794 625.658325,147.892761 624.844421,147.557404 
	C615.469604,144.675690 606.406494,141.871307 597.247314,139.426895 
	C565.663269,130.997696 533.590149,130.471054 501.634064,135.818573 
	C464.959167,141.955750 430.517365,154.843491 399.933960,176.322220 
	C385.852875,186.211365 373.099915,197.991592 359.439880,209.031342 
	C354.071594,214.715836 349.008148,220.283340 343.944672,225.850830 
	C342.311493,224.785950 340.678345,223.721069 339.211945,222.106445 
	C340.964600,219.040359 342.550507,216.524048 344.475830,214.021347 
	C346.322845,212.389862 347.830414,210.744751 349.639252,209.020477 
	C350.449921,207.915527 350.900055,206.854004 351.489227,205.876251 
	C351.895447,205.202057 352.494202,204.643860 353.061462,204.172577 
	C353.206726,204.357513 353.297424,204.403687 353.388123,204.449860 
	C353.270294,204.302124 353.152466,204.154388 353.032959,203.631058 
	C353.025330,202.504410 353.019379,201.753372 353.291504,201.202454 
	C355.116943,203.491943 355.894501,203.174866 357.364777,200.957138 
	C359.437225,197.831131 359.271362,195.774414 355.946777,193.857498 
	C355.804382,193.668716 355.718048,193.618881 355.631683,193.569031 
	C355.753235,193.713623 355.874786,193.858200 355.968994,194.343903 
	C355.359283,195.714981 354.776947,196.744934 354.206512,197.753830 
	C353.361420,195.848969 352.508820,194.421432 352.086487,192.876282 
	C351.092072,189.237823 350.578613,185.444290 349.311188,181.914352 
	C348.703552,180.222061 346.928375,178.865479 345.459625,177.618790 
	C345.040588,177.263123 343.842224,177.825592 342.691650,177.997894 
	C340.392120,179.851135 339.231140,178.270187 338.008057,176.615570 
	C338.535095,174.832260 339.057770,173.395645 339.580444,171.959015 
	C338.643616,172.863708 337.706787,173.768387 336.769989,174.673065 
	C336.513733,172.781830 336.257477,170.890594 336.000610,168.999680 
	C336.000000,169.000000 336.001221,168.998779 335.999207,168.661438 
	C335.670410,167.548065 335.343628,166.772049 334.970154,165.688507 
	C331.741302,164.438477 331.233398,166.658432 330.619965,168.921539 
	C330.488556,168.934128 330.224579,168.940063 329.929596,168.972382 
	C329.437744,169.024048 329.240845,169.043396 329.037231,168.719666 
	C329.030151,167.920181 329.029785,167.463776 329.278625,166.836365 
	C330.225494,165.764893 330.923187,164.864410 331.878204,163.631775 
	C330.538269,163.802567 329.768524,163.900665 329.036865,163.650375 
	C329.474609,162.591217 330.158600,161.902634 330.216156,161.165176 
	C330.344635,159.519272 330.160492,157.848969 330.103729,156.188599 
	C328.734375,157.051407 327.364990,157.914230 325.659485,158.872833 
	C322.843597,161.943817 320.363831,164.919037 317.626587,167.988678 
	C317.203186,168.160690 317.037323,168.238297 316.544800,168.284225 
	C314.380341,170.031540 312.255280,171.604721 310.789795,173.650421 
	C309.464752,175.500092 308.860199,177.865906 307.893250,180.252014 
	C307.893555,180.661682 307.938538,180.823471 307.983551,180.985275 
M728.984192,145.195038 
	C728.664856,145.115677 728.345459,145.036331 727.689392,144.668381 
	C727.451233,144.493271 727.218628,144.311127 726.794678,143.450775 
	C724.794800,141.781097 722.794861,140.111420 720.596985,138.276428 
	C719.542725,145.066086 701.063354,166.691437 695.801697,167.315521 
	C701.641113,172.005676 707.278625,176.533630 713.142090,181.592636 
	C714.217957,181.469162 715.293884,181.345673 716.865845,181.018906 
	C717.224426,180.628006 717.583069,180.237091 718.504822,179.651505 
	C718.830017,178.873184 719.155212,178.094864 719.480408,177.316528 
	C718.993347,177.566147 718.506348,177.815765 717.193665,178.165237 
	C712.588318,178.324615 707.671631,175.922440 707.998718,172.107239 
	C708.389709,167.547821 712.312805,163.291260 714.733276,158.853439 
	C722.935791,164.248657 723.251282,164.739624 722.242371,171.026886 
	C722.812500,172.990280 723.009705,176.378098 724.024231,176.643661 
	C726.802673,177.370987 730.439514,178.006958 731.975098,173.023285 
	C730.479370,172.715515 729.127625,172.576340 727.876343,172.145432 
	C726.232544,171.579315 724.667786,170.783432 723.320496,169.476639 
	C724.866150,167.841843 726.411865,166.207047 727.850342,164.685623 
	C724.296692,161.973160 721.079590,159.517578 717.693176,156.932724 
	C719.758545,154.033325 721.373352,151.358978 723.425415,149.078064 
	C724.297607,148.108521 726.085754,147.963074 727.780640,148.049927 
	C730.434875,150.867294 734.728638,152.630234 733.143188,158.908035 
	C735.659485,156.162704 737.176208,154.507965 738.891602,152.636475 
	C735.406494,150.101578 732.338013,147.869675 728.984192,145.195038 
M381.717590,123.736153 
	C378.691101,125.663246 375.664612,127.590347 371.865143,130.009628 
	C377.380341,129.849243 388.880707,142.618103 390.862000,149.957092 
	C377.773529,147.804306 364.736694,145.660019 350.389526,143.300201 
	C351.854309,145.878433 352.546356,147.311264 353.429108,148.614975 
	C358.649811,156.324951 364.025269,163.933609 369.075409,171.752823 
	C370.136169,173.395218 370.055420,175.774826 370.534180,177.968170 
	C372.500610,176.575455 375.207367,174.658401 376.949188,173.424744 
	C371.550293,166.480453 366.414398,159.874451 360.409393,152.150604 
	C374.822388,154.314438 387.629395,156.237152 401.803558,158.365128 
	C400.205505,155.593933 399.560913,154.297165 398.755859,153.109100 
	C393.626587,145.539673 388.334473,138.075714 383.410614,130.375793 
	C382.356750,128.727676 382.595795,126.252785 382.405609,123.783005 
	C382.256226,123.712318 382.106842,123.641632 381.957458,123.570946 
	C382.092651,123.784477 382.227844,123.998009 381.717590,123.736153 
M526.665100,103.773880 
	C528.401001,105.794685 530.113953,107.835739 531.877075,109.832535 
	C537.131287,115.783150 540.494080,116.707802 546.954407,114.798485 
	C541.541260,109.985062 535.571838,104.677032 529.472900,99.253799 
	C530.690186,97.659973 531.354675,96.745834 532.064514,95.868385 
	C534.888672,92.377220 537.216980,88.724037 534.950439,84.047546 
	C532.612915,79.224747 528.176392,78.447952 523.506165,78.710037 
	C517.818604,79.029221 512.149414,79.675415 507.618500,80.078255 
	C508.658691,81.937988 510.433899,83.753387 510.653717,85.740822 
	C511.587158,94.179733 512.203735,102.662888 512.601807,111.145569 
	C512.706055,113.367012 511.608643,115.644852 511.025330,118.052696 
	C515.337219,117.692154 519.918945,117.309036 525.483521,116.843742 
	C519.799866,114.983482 518.345093,110.670975 519.716248,100.721519 
	C522.017456,101.606102 524.103638,102.408043 526.665100,103.773880 
M464.028625,127.374771 
	C466.737427,125.737144 465.671112,123.667557 465.069122,121.308235 
	C464.001434,117.123886 460.078857,113.352501 463.383179,108.162514 
	C459.290131,109.659088 455.730286,110.960716 453.081696,111.929153 
	C454.936401,116.137909 456.950409,120.202980 458.434753,124.453033 
	C458.780212,125.442101 457.660797,127.804657 456.640442,128.267365 
	C450.529694,131.038422 444.260071,131.339783 438.729156,127.004486 
	C432.716949,122.291893 429.531647,115.937340 430.899872,108.204033 
	C432.081787,101.523529 437.445618,99.029892 443.389740,97.583908 
	C448.130249,96.430695 452.470581,97.037170 456.199799,100.829002 
	C455.803772,98.336411 455.313629,96.090279 454.398254,94.033371 
	C454.046448,93.242836 452.597839,92.269066 451.866333,92.421532 
	C443.554993,94.153801 435.091187,95.722885 428.947083,102.379257 
	C423.405457,108.382965 422.509949,115.465675 425.415283,122.812813 
	C428.204346,129.865784 433.592194,133.999664 441.384033,134.456482 
	C449.526611,134.933868 456.728516,132.171143 464.028625,127.374771 
M642.802490,118.310143 
	C637.419922,122.239761 634.336243,129.414597 625.552734,129.904541 
	C629.545410,131.744354 632.783142,133.236328 636.285156,134.850067 
	C634.127502,129.734268 638.480225,128.179474 640.859497,126.014748 
	C641.968933,125.005325 644.834839,124.989578 646.458862,125.638733 
	C655.234558,129.146591 655.192444,129.267776 654.088745,138.784821 
	C653.945374,140.021301 653.701172,141.246109 653.493713,142.538666 
	C657.193726,144.194687 660.602234,145.720230 663.355530,146.952515 
	C662.599487,143.854263 661.323425,140.967163 661.290894,138.066116 
	C661.179077,128.084991 661.517395,118.099182 661.644714,108.114655 
	C661.666260,106.425201 661.492371,104.733261 661.331177,101.472710 
	C654.542053,107.651474 648.940125,112.749718 642.802490,118.310143 
M493.034393,121.383820 
	C502.904877,119.704018 502.904877,119.704018 501.215881,112.987640 
	C498.517609,117.095650 492.625977,120.100304 489.292542,117.978783 
	C484.120178,114.686928 486.025818,108.664337 484.488770,103.327980 
	C489.214294,103.327980 493.083374,103.327980 497.150116,103.327980 
	C497.039001,101.989510 496.855530,99.779587 496.682190,97.691795 
	C492.178467,98.805466 488.255676,99.775490 483.840576,100.867241 
	C482.920685,96.119659 482.151764,92.151245 481.226105,87.373863 
	C486.210938,87.373863 490.432983,87.373863 494.924194,87.373863 
	C494.806366,86.183250 494.607849,84.176697 494.395447,82.030182 
	C486.483856,83.591576 479.278564,85.013580 471.598694,86.529243 
	C476.393311,92.344124 480.664734,119.549088 477.774109,124.006401 
	C482.748016,123.165451 487.473877,122.366440 493.034393,121.383820 
M615.355164,88.352303 
	C612.528198,87.483528 609.701172,86.614754 606.549011,85.646049 
	C605.567383,87.618225 604.653564,89.454132 604.160400,90.444992 
	C608.962280,90.943581 613.561401,91.421127 619.029419,91.988892 
	C615.575378,104.140594 612.454407,115.120728 609.302917,126.208176 
	C612.665894,127.052177 616.866943,128.106506 620.256287,128.957123 
	C619.561768,126.985367 618.012573,124.903091 618.377502,123.241158 
	C620.468994,113.717545 623.014954,104.293732 625.693848,93.700493 
	C630.322998,95.855743 634.263855,97.690529 638.551514,99.686783 
	C638.825806,98.666405 639.343933,96.738503 639.905823,94.647942 
	C631.553833,92.509010 623.849365,90.535927 615.355164,88.352303 
M680.391052,113.007729 
	C678.660645,114.421791 676.930237,115.835861 675.975891,116.615768 
	C680.655701,118.471375 684.981079,120.186440 689.780884,122.089630 
	C684.310852,131.264740 679.556946,139.458176 674.531799,147.481750 
	C673.530945,149.079788 671.492737,150.028183 669.820496,151.366089 
	C672.764587,153.201218 676.231384,155.362137 679.579712,157.449219 
	C679.676025,153.179688 691.078369,131.840591 696.828430,126.001160 
	C699.988708,128.894882 703.174194,131.811646 706.532715,134.886887 
	C707.152893,133.864609 708.213684,132.115845 709.199585,130.490677 
	C699.467285,124.561195 690.254395,118.948166 680.391052,113.007729 
M585.421204,81.933327 
	C580.730774,82.141266 575.985718,82.247780 573.910095,87.682167 
	C572.206055,92.143921 573.747009,96.674400 578.466492,100.921227 
	C580.075562,102.369125 581.856201,103.631165 583.421387,105.121956 
	C586.309692,107.873024 588.115112,111.082932 585.265991,114.782707 
	C582.540833,118.321426 578.622925,118.034836 575.342651,116.070358 
	C573.092224,114.722610 571.645630,112.032677 570.000183,110.128418 
	C566.988953,114.800629 567.835327,117.540970 573.553162,119.040718 
	C574.839905,119.378220 576.150391,119.656860 577.466858,119.843735 
	C584.271606,120.809654 589.722473,118.488152 591.995483,113.700806 
	C594.459656,108.510818 592.796753,102.984520 587.328918,98.238441 
	C585.195984,96.387062 582.704956,94.815613 581.029480,92.619072 
	C580.008057,91.280045 579.477722,88.664284 580.106140,87.223778 
	C580.728882,85.796410 583.244202,84.104790 584.644836,84.326538 
	C587.870728,84.837318 590.923889,86.438988 594.725708,87.849838 
	C596.650879,85.811028 595.984680,83.763885 592.004578,82.781357 
	C590.136658,82.320244 588.183411,82.204964 585.421204,81.933327 
M397.008118,115.637054 
	C404.934601,125.864174 410.470703,137.220474 413.918030,149.717239 
	C416.874329,148.222717 420.477814,146.401031 424.340942,144.448059 
	C418.279053,141.923264 405.555206,115.930931 407.410583,110.448853 
	C404.081909,111.997231 400.790131,113.528435 397.008118,115.637054 
M739.882385,150.722672 
	C740.426025,150.530838 740.969666,150.339005 741.513306,150.147171 
	C741.385620,149.868408 741.257935,149.589630 741.130310,149.310852 
	C740.570984,149.636383 740.011658,149.961914 739.882385,150.722672 
M343.894958,172.706207 
	C344.166687,172.451385 344.443665,172.201401 344.696747,171.929245 
	C344.711365,171.913528 344.532074,171.717514 344.443024,171.605408 
	C344.158203,171.872299 343.873352,172.139206 343.894958,172.706207 
M719.663269,137.674088 
	C719.338623,137.661880 719.013916,137.649673 718.689270,137.637466 
	C718.934082,137.771393 719.178833,137.905334 719.663269,137.674088 
M341.255096,174.812439 
	C341.372223,174.972961 341.489349,175.133484 341.606476,175.294006 
	C341.582458,175.070328 341.558411,174.846634 341.255096,174.812439 
M729.516968,159.410004 
	C729.516968,159.410004 729.583984,159.522232 729.516968,159.410004 
M352.519318,190.402222 
	C352.519318,190.402222 352.594238,190.523315 352.519318,190.402222 
M741.412048,153.482681 
	C741.412048,153.482681 741.523071,153.416275 741.412048,153.482681 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M736.953003,422.994629 
	C736.890808,413.362366 736.726624,403.729523 736.783691,394.097961 
	C737.072449,345.368805 737.418823,296.639984 738.238037,247.515442 
	C739.459106,248.153442 740.754333,249.150726 740.823181,250.226501 
	C741.273926,257.269318 741.329285,264.337402 741.776245,271.380554 
	C742.086792,276.274963 742.816528,281.142822 743.496704,286.286865 
	C743.743530,286.717346 743.852539,286.883484 743.880127,287.380219 
	C743.892639,288.148987 743.986755,288.587128 743.967957,289.476532 
	C743.915039,294.283936 743.974976,298.640076 743.911133,303.427795 
	C743.854065,306.243286 743.920898,308.627136 743.868530,311.398773 
	C743.817810,312.857147 743.886292,313.927734 743.829956,315.429626 
	C743.677673,332.567047 743.650269,349.273254 743.495972,366.368103 
	C743.441467,367.834167 743.513733,368.911621 743.458618,370.441833 
	C743.283142,376.571075 743.235046,382.247528 743.127686,388.329102 
	C743.186768,389.540039 743.305115,390.345886 743.342163,391.602753 
	C743.290527,397.373932 743.320129,402.694122 743.241455,408.428314 
	C743.148499,410.552612 743.163818,412.262848 743.052551,414.392517 
	C743.030273,416.549316 743.134521,418.286774 743.191528,420.383972 
	C743.189026,421.466187 743.233765,422.188660 743.153687,423.286346 
	C744.050781,424.341278 745.072693,425.020966 746.553589,425.759888 
	C757.999512,425.739441 768.986389,425.659698 780.411987,425.704346 
	C783.571838,425.767609 786.293091,425.706451 789.436829,425.759583 
	C791.901062,425.899414 793.942871,425.924957 796.282654,426.049011 
	C796.827026,425.841034 797.073364,425.534546 797.693665,425.225433 
	C800.230713,424.207489 802.645325,423.524689 804.509766,422.114532 
	C810.091309,417.892944 815.457581,413.386841 820.907959,408.991821 
	C821.245850,415.369354 821.934265,421.753601 821.812744,428.122375 
	C821.712341,433.384857 820.890442,438.670380 819.978821,443.874023 
	C816.762390,462.234680 814.361023,480.773132 808.034302,498.470154 
	C806.562805,502.586212 806.754517,507.580414 804.487244,511.070038 
	C799.632507,518.542053 798.543945,527.543030 793.633240,534.931824 
	C790.545715,539.577332 788.264099,544.758484 785.065796,550.023315 
	C784.341675,550.914856 784.172791,551.482300 784.003906,552.049805 
	C783.921814,552.376404 783.738953,552.630371 782.907166,552.951904 
	C781.926514,554.417908 781.493835,555.743713 781.061218,557.069458 
	C780.913269,557.608154 780.765320,558.146851 780.034302,558.886230 
	C778.646118,560.410583 777.841064,561.734131 777.036011,563.057678 
	C777.035950,563.057678 776.997253,563.011230 776.708740,563.149536 
	C773.629761,567.932373 770.839294,572.576904 768.048828,577.221375 
	C765.644165,580.333557 763.239441,583.445740 760.300537,586.847778 
	C759.510498,587.440918 759.254639,587.744385 758.998840,588.047791 
	C758.998840,588.047791 758.994995,587.993164 758.778076,588.088013 
	C758.378540,588.467529 758.195984,588.752197 758.013428,589.036865 
	C758.013367,589.036865 758.002319,588.995056 757.774231,589.080322 
	C757.373413,589.452148 757.200745,589.738708 757.028015,590.025330 
	C757.028015,590.025330 757.002441,590.000000 756.739258,590.148071 
	C756.326965,590.876099 756.177856,591.455933 756.028809,592.035828 
	C756.028809,592.035828 756.019470,591.993958 755.680298,591.998840 
	C750.234985,597.685791 745.128784,603.367859 740.022583,609.049927 
	C740.022644,609.049927 740.000000,609.000061 739.665039,609.034424 
	C738.560547,610.166626 737.791016,611.264526 737.021423,612.362366 
	C731.027405,618.222351 725.385559,624.507996 718.948914,629.832947 
	C711.186279,636.254883 702.920349,642.117004 694.541931,647.728210 
	C689.236145,651.281616 683.327759,653.935364 676.939697,657.005676 
	C674.780334,658.029358 673.370850,659.040039 671.961365,660.050659 
	C671.961365,660.050659 671.599060,660.086121 671.017456,660.053345 
	C668.980957,661.122620 667.526123,662.224609 666.071228,663.326660 
	C664.962769,663.895630 663.854370,664.464600 662.322754,664.880249 
	C661.606873,664.837158 661.314270,664.947327 661.021606,665.057495 
	C661.021606,665.057495 660.995483,665.005554 660.636230,665.016846 
	C645.616516,670.383118 630.950806,675.723511 616.315369,681.145813 
	C615.728943,681.363098 615.430298,682.357239 614.997559,682.989380 
	C613.899780,683.330811 612.801941,683.672302 611.086548,683.719971 
	C605.968140,684.039429 601.455139,684.583191 596.985474,685.372375 
	C596.532776,685.452332 596.341370,687.011963 596.028748,687.884888 
	C595.283691,687.931824 594.538635,687.978760 593.393311,687.725342 
	C592.321411,687.243774 591.649780,687.062683 590.558167,686.914490 
	C586.310791,686.613647 581.306580,689.884583 579.466187,683.463684 
	C580.863464,682.756775 582.200134,681.610840 583.667053,681.408264 
	C609.225342,677.878540 633.412170,669.887268 657.371826,658.875854 
	C662.339905,656.122925 666.715637,653.672974 671.419189,651.218750 
	C672.192444,650.882080 672.637878,650.549744 673.439453,650.200134 
	C674.893616,649.474304 675.991760,648.765747 677.051819,648.034973 
	C677.013733,648.012817 677.052246,648.092041 677.387329,648.058960 
	C678.523682,647.378967 679.325012,646.732056 680.083801,646.057983 
	C680.041260,646.030884 680.074097,646.126282 680.425049,646.109863 
	C681.882263,645.407715 682.988525,644.722046 684.321411,643.975708 
	C684.868408,643.777039 685.044067,643.534241 685.410034,643.166138 
	C686.494141,642.732117 687.243164,642.318665 688.261963,642.006104 
	C688.772705,641.833557 689.013672,641.560059 689.122070,641.193237 
	C688.989563,641.099976 689.234558,641.312317 689.467529,641.317749 
	C690.033264,641.251160 690.261108,641.056396 690.390320,640.719604 
	C690.396545,640.700317 690.433411,640.722534 690.775024,640.613525 
	C691.739258,639.991211 692.316528,639.407104 692.991089,638.974854 
	C715.784973,624.370544 735.079468,605.925964 752.429199,585.019165 
	C752.871704,584.530334 753.072266,584.100586 753.578064,583.524414 
	C754.312012,582.606445 754.740723,581.834961 755.404358,580.998047 
	C755.851990,580.513550 756.064636,580.094604 756.576904,579.518921 
	C757.311584,578.598267 757.746643,577.834167 758.464844,576.950439 
	C759.030151,576.301208 759.312378,575.771606 759.848511,575.115479 
	C760.466919,574.351318 760.831299,573.713806 761.489014,572.920959 
	C764.214600,569.248962 766.646912,565.732300 769.334106,562.106262 
	C769.704712,561.658936 769.820312,561.320923 770.211426,560.794922 
	C771.785461,558.328857 773.083923,556.050781 774.674744,553.605835 
	C775.607300,552.288086 776.247498,551.137085 777.127991,549.738708 
	C800.261047,511.155426 812.863098,469.869720 814.074036,423.910889 
	C806.945129,429.498688 802.162231,435.898621 794.232605,438.511322 
	C794.385193,436.252014 794.492371,434.665710 794.651978,432.303070 
	C789.173889,432.303070 784.079407,432.303070 778.743408,432.197784 
	C778.340210,432.160828 778.178467,432.229126 777.621460,432.218628 
	C776.155884,432.180634 775.085571,432.221466 773.605469,432.133179 
	C771.778931,432.089142 770.362183,432.174225 768.487427,432.185669 
	C763.021606,432.144562 758.013733,432.177155 752.750793,432.099915 
	C752.323975,432.059448 752.152344,432.128845 751.545105,432.127014 
	C748.484131,432.069000 745.858704,432.082214 742.915161,431.856293 
	C741.335876,428.337006 743.417786,422.868622 736.953003,422.994629 
z"
      />
      <path
        fill="#35761E"
        opacity="1.000000"
        stroke="none"
        d="
M260.231445,291.912201 
	C260.464447,277.440582 260.694733,262.968933 260.933929,248.497421 
	C260.964142,246.668289 261.041626,244.839951 261.623566,242.622299 
	C286.478790,242.421387 310.807495,242.652420 335.136719,242.746094 
	C338.383972,242.758591 340.114868,243.449738 339.975677,247.160049 
	C339.488708,260.138428 339.197144,273.124146 338.501923,286.158020 
	C333.447052,294.552734 326.699280,300.133606 316.974030,301.506805 
	C314.030579,301.922424 311.043732,302.030548 307.730408,302.204285 
	C306.539459,302.703979 305.694824,303.278870 304.545471,303.871490 
	C303.834076,303.906128 303.427429,303.923065 302.841248,303.731628 
	C302.049866,303.956848 301.438019,304.390503 300.520203,304.847382 
	C299.807648,304.915894 299.401062,304.961151 298.827393,304.774475 
	C297.798706,305.040283 296.937134,305.538055 295.752869,306.165894 
	C293.304474,307.261078 291.178802,308.226227 288.655029,309.175568 
	C280.934967,309.896271 274.794006,313.176880 269.488770,318.091553 
	C266.385193,320.966614 263.480347,324.056274 260.486115,327.049377 
	C260.371002,326.589020 260.255920,326.128662 260.193359,324.874084 
	C260.241119,313.357330 260.236298,302.634766 260.231445,291.912201 
M304.996338,293.998779 
	C304.996338,293.998779 304.940979,294.068329 305.257629,294.710266 
	C306.528656,294.485565 307.799652,294.260864 309.682526,293.758972 
	C311.854828,291.330505 314.027161,288.902039 317.186798,285.369812 
	C313.773834,284.763153 311.403748,284.341827 308.561279,283.623901 
	C308.012573,283.592560 307.463837,283.561218 306.467224,283.011963 
	C305.516724,282.035400 304.566193,281.058868 303.710297,279.476135 
	C302.748322,278.897064 301.786316,278.317993 300.903809,277.048584 
	C300.620209,276.704773 300.336639,276.360962 300.016998,275.363403 
	C300.330536,274.856781 300.644073,274.350189 301.632172,273.823517 
	C305.513031,270.114746 309.393921,266.405945 313.311035,262.662567 
	C316.342041,265.423126 318.839508,267.697784 321.786469,270.381805 
	C321.030762,261.036377 311.214172,251.378098 303.930420,252.512085 
	C306.119751,254.898666 308.151276,257.113281 310.164703,259.308105 
	C306.051025,263.775055 302.370453,267.771698 298.019501,272.000671 
	C297.330139,272.135712 296.640747,272.270782 295.718811,271.748840 
	C293.055298,269.194153 290.391815,266.639465 287.666809,263.271698 
	C287.735901,262.734680 287.804993,262.197693 288.522247,261.482788 
	C290.282257,259.760742 291.080963,258.138855 287.841553,256.491486 
	C287.668304,256.206482 287.419464,256.025177 286.997070,255.327148 
	C286.353760,254.844910 285.710419,254.362671 284.748047,253.288483 
	C283.151184,252.596100 281.554352,251.903702 279.588623,250.785172 
	C278.737061,250.912354 277.885529,251.039536 276.400726,251.148209 
	C275.571777,251.723236 274.742798,252.298264 273.310394,253.142105 
	C273.216522,253.764801 273.122650,254.387512 272.852234,255.825409 
	C272.348846,261.008759 275.537323,264.089203 279.249268,267.515289 
	C280.414459,267.294891 281.579681,267.074493 282.878662,266.869751 
	C282.878662,266.869751 282.865448,266.735748 283.666962,266.722809 
	C284.170105,266.546326 284.673248,266.369873 285.550598,266.610565 
	C286.004547,266.923431 286.458527,267.236267 287.201294,268.217255 
	C289.243439,270.132782 291.285583,272.048309 293.566681,274.937897 
	C293.184479,276.188965 292.802277,277.440033 292.474060,278.679047 
	C292.474060,278.679047 292.440002,278.755768 291.692993,278.769592 
	C287.982208,282.275757 284.214142,285.725189 280.624054,289.350891 
	C280.100708,289.879456 280.427155,291.249542 280.360382,292.230225 
	C281.365112,292.130066 282.743927,292.414154 283.309845,291.863190 
	C285.761200,289.476624 287.975159,286.846161 290.767242,283.758850 
	C290.713409,283.520020 290.659576,283.281189 291.100525,283.575806 
	C292.039856,282.639923 292.979218,281.704041 294.455414,280.601898 
	C294.919922,280.027527 295.384430,279.453156 296.461914,278.764648 
	C296.665283,278.721863 296.868652,278.679077 297.358337,279.224304 
	C298.241089,279.818176 299.123871,280.412018 300.272949,281.618469 
	C301.746246,283.910736 303.219543,286.203003 304.315033,288.902466 
	C304.339264,289.255066 304.363525,289.607697 304.241852,290.710815 
	C304.258942,291.475403 304.276001,292.239960 304.103790,293.496765 
	C304.380768,293.686066 304.657776,293.875366 304.996338,293.998779 
z"
      />
      <path
        fill="#34761D"
        opacity="1.000000"
        stroke="none"
        d="
M743.961609,287.049591 
	C743.852539,286.883484 743.743530,286.717346 743.660828,285.842590 
	C743.728027,273.315674 743.886780,261.495941 743.737305,249.680084 
	C743.692932,246.173782 744.833862,244.828247 748.308167,245.037231 
	C751.626953,245.236847 754.965332,245.115494 758.295105,245.126328 
	C777.608276,245.189209 796.921509,245.228088 816.234436,245.335251 
	C818.917603,245.350128 822.178650,244.756546 822.327026,249.063461 
	C822.236877,256.728394 822.146667,264.393341 821.996582,272.775208 
	C822.003967,273.664917 822.071106,273.837708 822.138306,274.010529 
	C822.093994,276.051300 822.049683,278.092041 821.927612,280.993744 
	C821.923889,284.230011 821.997986,286.605316 822.072021,288.980652 
	C822.013855,291.370514 821.955750,293.760376 821.824585,297.043030 
	C821.818542,306.269073 821.885620,314.602295 821.952759,322.935516 
	C821.908325,323.720245 821.863953,324.505005 821.777710,325.891907 
	C821.735779,326.494110 821.938293,326.927094 821.938293,326.927094 
	C821.869873,327.116760 821.801392,327.306396 821.242371,327.742432 
	C819.604248,327.100342 818.422302,326.252563 817.315308,325.316040 
	C813.431580,322.030212 809.810852,318.356232 805.602539,315.564941 
	C803.597229,314.234924 800.493042,314.561676 797.576355,314.089355 
	C796.514099,313.681824 795.762085,313.322906 794.965332,312.637329 
	C794.236023,311.918365 793.551575,311.526001 792.485779,311.114380 
	C782.925171,306.586884 772.951721,305.202911 763.039429,303.370728 
	C756.364136,302.136841 750.490540,299.129059 747.780701,292.072510 
	C747.319092,290.870392 745.955688,290.014587 744.995728,288.700012 
	C744.642273,287.950714 744.301941,287.500153 743.961609,287.049591 
M760.732361,265.056305 
	C760.732361,265.056305 760.745789,265.245483 760.783936,265.876984 
	C761.423462,266.347870 762.062927,266.818756 762.724670,267.301025 
	C762.724670,267.301025 762.733337,267.325897 762.859741,267.973846 
	C763.853882,269.488983 764.848022,271.004120 765.702576,272.306519 
	C770.927063,268.540039 774.575928,270.656311 779.518616,278.891754 
	C774.816345,283.854065 770.051025,288.882935 765.285645,293.911774 
	C765.676880,294.440063 766.068054,294.968323 766.459229,295.496582 
	C768.172180,294.655945 770.161377,294.128296 771.541199,292.910339 
	C774.522949,290.278351 777.012756,287.072906 780.081482,284.563873 
	C781.235962,283.619965 784.160950,283.121857 785.019348,283.868439 
	C787.295837,285.848724 788.885437,288.618622 790.441589,291.735260 
	C790.451477,292.454041 790.461365,293.172791 790.231140,294.550934 
	C791.106323,295.806641 791.981506,297.062317 792.856689,298.317993 
	C794.011841,297.277588 795.166992,296.237213 796.930908,294.878387 
	C798.357422,293.329803 799.783936,291.781189 801.770264,290.020111 
	C801.082153,288.802612 800.394043,287.585114 799.769653,285.980438 
	C799.545959,286.041779 799.322266,286.103149 798.309509,286.102356 
	C797.519470,286.057098 796.729431,286.011841 795.492554,285.461060 
	C794.375671,285.312164 793.258789,285.163239 791.574829,284.709900 
	C790.591553,283.592316 789.608337,282.474762 788.732849,280.673523 
	C788.110840,280.170074 787.488831,279.666595 786.699524,278.433929 
	C788.291443,276.561005 789.761475,274.565887 791.496399,272.836487 
	C798.812744,265.543671 798.841614,265.572662 806.663086,271.652252 
	C807.131592,266.915131 802.285645,259.445953 797.000854,257.057465 
	C795.536743,256.395752 793.834961,256.259796 792.242249,255.882599 
	C793.016174,257.291931 793.759644,258.719208 794.576782,260.103027 
	C794.981812,260.788910 795.522400,261.394745 795.614563,261.518188 
	C791.309021,266.244720 787.239624,270.712036 783.094116,275.262878 
	C779.751282,272.069427 776.701599,269.156067 773.770691,266.356201 
	C776.462891,261.531219 776.462891,261.531219 772.910461,258.262909 
	C772.329590,257.804077 771.748718,257.345245 771.060608,256.254700 
	C770.368042,255.850906 769.675415,255.447128 768.614624,254.651199 
	C768.267761,254.581375 767.920837,254.511551 767.106262,253.917191 
	C764.272522,253.073517 761.521301,252.529648 759.601135,256.148682 
	C759.601135,256.148682 759.550476,256.487915 758.994873,256.833679 
	C759.041443,258.212372 759.088013,259.591095 759.118286,261.634186 
	C759.286560,262.038666 759.454773,262.443146 759.399048,263.422394 
	C759.835510,264.029785 760.271973,264.637177 760.732361,265.056305 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M338.831360,286.107056 
	C339.197144,273.124146 339.488708,260.138428 339.975677,247.160049 
	C340.114868,243.449738 338.383972,242.758591 335.136719,242.746094 
	C310.807495,242.652420 286.478790,242.421387 261.702515,242.165421 
	C258.803223,236.820724 259.492035,235.408051 264.592468,234.669586 
	C265.802704,234.494370 266.907745,233.592194 268.402771,233.007950 
	C267.669098,237.021225 270.749420,235.881653 272.563690,235.897568 
	C294.890625,236.093262 317.219543,236.396729 339.544495,236.223709 
	C344.693146,236.183807 345.876892,237.590347 345.837677,242.618927 
	C345.332153,307.433472 345.059998,372.249847 344.696136,437.761078 
	C344.566742,438.618927 344.470001,438.781464 344.097534,438.839844 
	C343.213623,437.894012 342.605438,437.052368 342.052399,436.287018 
	C340.684326,436.930664 339.540070,437.468994 338.290405,437.589661 
	C338.124512,435.449493 338.064056,433.726959 338.136749,431.677002 
	C337.854492,430.899719 337.439056,430.449890 336.594299,429.860107 
	C328.127991,429.739075 320.091003,429.757996 311.615143,429.592834 
	C303.618805,429.751038 296.061401,430.093353 288.356171,430.667725 
	C288.287842,431.246277 288.367310,431.592773 288.364807,432.345764 
	C287.477783,433.457672 286.594482,434.813812 285.884583,434.728455 
	C284.545441,434.567383 283.306183,433.576324 281.881348,432.668732 
	C281.198486,432.171478 280.659698,431.935730 279.975555,431.407471 
	C276.183899,427.925232 272.537598,424.735535 268.891327,421.545837 
	C268.300110,421.753632 267.708893,421.961426 267.117706,422.169220 
	C268.096649,432.114197 269.075623,442.059143 269.974792,452.338501 
	C270.011627,453.110229 270.128235,453.547577 270.156860,454.398682 
	C270.780792,458.865570 271.492706,462.918640 272.178680,467.320374 
	C272.504639,468.772461 272.856506,469.875885 273.167725,471.346100 
	C273.850098,474.203552 274.573090,476.694244 275.261719,479.412872 
	C275.227356,479.640808 275.464966,480.035858 275.439484,480.418640 
	C275.914734,482.212372 276.415497,483.623291 276.891083,485.412109 
	C277.611603,488.190063 278.357300,490.590118 279.070129,493.334900 
	C279.620270,495.151001 280.203247,496.622437 280.800659,498.462982 
	C281.609039,500.883575 282.402924,502.935028 283.190826,505.346252 
	C284.047028,507.687164 284.909210,509.668335 285.730804,511.978271 
	C286.441833,513.877930 287.193451,515.448853 287.939514,517.382812 
	C288.950226,519.832275 289.966461,521.918823 290.984375,524.329590 
	C291.616394,525.770813 292.246765,526.887756 292.895081,528.360962 
	C293.753510,530.104431 294.594025,531.491638 295.425568,533.178955 
	C295.937134,534.320618 296.457642,535.162048 296.982391,536.348938 
	C298.342834,538.902405 299.699036,541.110474 301.078857,543.562256 
	C301.102478,543.805908 301.460876,544.139587 301.532471,544.488770 
	C302.681824,546.376587 303.759613,547.915222 304.872009,549.786621 
	C310.800842,558.736511 316.695007,567.353699 322.578583,576.258179 
	C323.060638,577.358032 323.553345,578.170532 323.737671,579.024414 
	C322.214996,579.139160 320.919830,579.516296 319.804138,579.219238 
	C317.820862,578.691223 315.946320,577.754822 314.026276,576.989197 
	C313.347839,575.914551 312.669403,574.839966 311.951263,573.090515 
	C310.930237,571.616699 309.948883,570.817688 308.967529,570.018677 
	C302.527527,559.726074 295.500732,549.745422 289.814423,539.052063 
	C284.254974,528.597168 279.794617,517.522949 275.373383,506.511108 
	C272.809662,500.125763 271.274048,493.327606 269.425964,486.110382 
	C268.328186,479.071625 267.118378,472.629608 265.759125,466.219238 
	C265.651611,465.712128 264.506287,465.425049 263.843262,465.035706 
	C263.561584,463.909546 263.279907,462.783386 263.331238,461.048584 
	C263.763275,459.296326 264.009521,458.143494 263.939026,457.010345 
	C262.991760,441.785522 261.958740,426.565826 261.085846,411.336884 
	C261.000854,409.854645 261.836609,408.319580 262.526276,406.980713 
	C269.521027,412.141815 276.234497,417.131195 283.167542,422.381042 
	C284.261932,422.709595 285.136719,422.777679 286.428864,422.956787 
	C288.561859,422.980377 290.277527,422.892975 292.433899,422.932434 
	C295.921143,422.946838 298.967621,422.834412 302.468384,422.840179 
	C314.274628,422.957855 325.626587,422.957397 337.363770,422.840576 
	C337.796234,421.147003 337.843506,419.569763 338.016632,417.590576 
	C338.088562,415.796844 338.034576,414.405121 338.122070,412.612244 
	C338.193756,410.809662 338.123932,409.408173 338.204895,407.704468 
	C338.277466,406.291504 338.199249,405.180786 338.293610,403.628540 
	C338.438812,398.238983 338.411438,393.290955 338.518860,388.016418 
	C338.578766,386.787323 338.503906,385.884735 338.417969,384.717407 
	C338.312378,384.303375 338.217896,384.154114 338.228607,383.682495 
	C338.263184,382.919250 338.192535,382.478363 338.287598,381.725983 
	C338.344971,380.257690 338.236664,379.100952 338.253906,377.567444 
	C338.302460,376.145935 338.225433,375.101135 338.315063,373.630920 
	C338.377380,370.790680 338.273071,368.375885 338.293121,365.584839 
	C338.334595,364.166473 338.251678,363.124298 338.329468,361.690369 
	C338.380463,360.192383 338.270782,359.086182 338.280792,357.556824 
	C338.334412,355.099548 338.268341,353.065460 338.363098,350.665466 
	C338.424011,349.522156 338.324036,348.744812 338.348694,347.541016 
	C338.402924,344.757446 338.332520,342.400299 338.412781,339.620300 
	C338.493042,337.118469 338.422638,335.039459 338.485138,332.514557 
	C338.587463,327.054535 338.556885,322.040405 338.650391,316.694641 
	C338.693695,315.905334 338.612854,315.447601 338.639893,314.602783 
	C338.712250,308.478851 338.676758,302.742004 338.769470,296.564301 
	C338.875549,292.784637 338.853455,289.445862 338.831360,286.107056 
z"
      />
      <path
        fill="#0F181C"
        opacity="1.000000"
        stroke="none"
        d="
M338.501923,286.158020 
	C338.853455,289.445862 338.875549,292.784637 338.407776,296.693634 
	C337.611969,299.595917 337.422821,301.951050 336.969147,304.254028 
	C336.456665,306.855530 335.706329,309.410187 334.688599,311.878815 
	C325.525818,308.148224 317.370270,309.305695 312.772003,314.851318 
	C312.288788,314.969696 312.097626,315.025543 311.703430,315.009033 
	C311.500366,314.936615 311.071472,314.892151 311.035065,314.510437 
	C310.521484,313.160858 310.205383,311.505463 309.538055,311.349121 
	C307.174225,310.795380 304.401306,309.947601 302.315613,310.695435 
	C298.621155,312.020081 294.377228,313.590668 294.454834,319.215179 
	C293.371277,320.376617 292.534729,321.268219 291.569885,321.868774 
	C289.411530,321.115692 286.871826,319.668365 285.458679,320.399231 
	C282.618683,321.868073 279.422241,323.869781 279.791260,328.273499 
	C279.421783,328.971039 279.271423,329.501343 278.807129,330.156799 
	C277.670654,331.820648 276.848114,333.359344 275.655975,334.988647 
	C270.905090,335.363617 269.002197,337.944977 268.566101,342.404846 
	C268.309692,344.781128 268.274902,346.843781 268.150452,349.285461 
	C268.022064,350.698822 267.983337,351.733124 267.697571,352.760193 
	C267.450531,352.753021 267.009003,352.975250 266.646729,352.859009 
	C264.210510,353.816315 262.136597,354.889832 260.062683,355.963348 
	C260.122620,349.291870 260.182556,342.620422 260.702118,335.489868 
	C262.336853,334.205566 263.722961,333.566742 264.647736,332.520264 
	C267.484436,329.310120 269.830078,325.605255 272.943909,322.714508 
	C278.075653,317.950439 283.659698,313.673553 289.053131,309.191345 
	C291.178802,308.226227 293.304474,307.261078 296.082031,306.162109 
	C297.487457,305.687622 298.240967,305.347015 298.994476,305.006409 
	C299.401062,304.961151 299.807648,304.915894 300.844788,304.889130 
	C301.990448,304.585083 302.505615,304.262543 303.020782,303.940002 
	C303.427429,303.923065 303.834076,303.906128 304.899597,303.916138 
	C306.397888,303.388580 307.237305,302.834015 308.076752,302.279480 
	C311.043732,302.030548 314.030579,301.922424 316.974030,301.506805 
	C326.699280,300.133606 333.447052,294.552734 338.501923,286.158020 
z"
      />
      <path
        fill="#EFE7D6"
        opacity="1.000000"
        stroke="none"
        d="
M314.160889,577.297241 
	C315.946320,577.754822 317.820862,578.691223 319.804138,579.219238 
	C320.919830,579.516296 322.214996,579.139160 323.972534,579.054932 
	C324.515747,579.044067 324.989380,579.036560 325.070404,579.353027 
	C326.435608,581.110840 327.719788,582.552185 329.053467,584.330444 
	C333.237976,589.447144 336.935974,594.711121 341.592224,598.913269 
	C354.152649,610.248718 367.121246,621.131897 380.100037,632.478027 
	C387.159363,637.229065 394.046570,641.696655 401.076508,646.482666 
	C404.107971,648.297058 406.996674,649.793030 410.000122,651.542114 
	C410.645386,651.908386 411.175873,652.021484 411.781128,652.473999 
	C412.569214,653.245483 413.282532,653.677612 413.993103,654.474976 
	C413.658875,656.246094 413.327393,657.651855 412.672058,658.910217 
	C410.548157,658.184143 408.748077,657.605591 406.947968,657.026978 
	C406.947968,657.026978 406.992706,656.995911 406.851868,656.786133 
	C406.123444,656.729492 405.535828,656.882629 404.948212,657.035767 
	C400.115417,654.645264 394.908936,652.793762 390.525665,649.754883 
	C380.664948,642.918396 370.749390,636.025452 361.715790,628.167175 
	C351.454773,619.241150 341.853088,609.500610 332.495117,599.612305 
	C325.966614,592.713745 320.330322,584.970947 314.160889,577.297241 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M795.010071,312.963989 
	C795.762085,313.322906 796.514099,313.681824 797.647644,314.419586 
	C804.328186,321.648438 810.563965,328.558838 816.992493,335.285095 
	C817.985291,336.323944 819.861816,336.518219 821.329590,337.103119 
	C821.414795,343.078369 821.499939,349.053650 821.325439,355.522858 
	C820.378052,356.349579 819.690491,356.682343 818.846802,356.668457 
	C817.422546,356.196808 816.154358,356.071838 814.734741,355.662933 
	C814.340149,354.582489 814.097046,353.785950 813.913208,352.964111 
	C813.972412,352.938812 813.926575,352.818420 814.241882,352.676392 
	C814.520142,351.106750 814.483093,349.679077 814.546875,347.883972 
	C813.891113,345.893707 813.134521,344.270874 812.287720,342.305969 
	C809.791626,340.630737 807.385803,339.297638 804.984741,337.525940 
	C804.823242,332.197083 805.925598,326.694000 798.869385,324.745209 
	C795.066589,321.378174 792.503540,322.921692 790.222534,325.766113 
	C789.564331,323.878387 788.981750,322.426025 788.260376,320.638458 
	C786.307312,318.285706 784.834778,315.702454 782.612610,314.360046 
	C776.708862,310.793457 773.568665,311.685608 770.712524,316.906555 
	C769.933350,316.941406 769.487732,316.943787 769.034119,316.962067 
	C769.026123,316.977966 769.053894,316.962402 769.030518,316.744934 
	C768.899597,316.216278 768.681885,316.046448 768.142456,315.713074 
	C766.783691,314.762329 765.707214,313.798828 764.477112,313.524841 
	C758.612000,312.218353 752.624512,310.213776 746.864502,315.029541 
	C745.617554,315.013092 744.786133,315.005737 743.954773,314.998352 
	C743.886292,313.927734 743.817810,312.857147 744.155151,311.133728 
	C744.385681,307.986053 744.210327,305.491119 744.034912,302.996216 
	C743.974976,298.640076 743.915039,294.283936 744.200073,289.471924 
	C744.544983,289.016052 745.008911,288.998779 745.008911,288.998779 
	C745.955688,290.014587 747.319092,290.870392 747.780701,292.072510 
	C750.490540,299.129059 756.364136,302.136841 763.039429,303.370728 
	C772.951721,305.202911 782.925171,306.586884 792.557251,311.424133 
	C793.676697,312.156799 794.343384,312.560394 795.010071,312.963989 
z"
      />
      <path
        fill="#DFE5BC"
        opacity="1.000000"
        stroke="none"
        d="
M822.626343,249.005081 
	C822.178650,244.756546 818.917603,245.350128 816.234436,245.335251 
	C796.921509,245.228088 777.608276,245.189209 758.295105,245.126328 
	C754.965332,245.115494 751.626953,245.236847 748.308167,245.037231 
	C744.833862,244.828247 743.692932,246.173782 743.737305,249.680084 
	C743.886780,261.495941 743.728027,273.315674 743.523071,285.578247 
	C742.816528,281.142822 742.086792,276.274963 741.776245,271.380554 
	C741.329285,264.337402 741.273926,257.269318 740.823181,250.226501 
	C740.754333,249.150726 739.459106,248.153442 738.353882,247.058899 
	C737.919739,246.546463 737.862915,246.094986 738.336121,245.323822 
	C743.156982,245.367218 745.372803,243.577789 744.994202,239.096893 
	C763.471863,238.970703 781.949524,238.839966 800.427185,238.723129 
	C803.258911,238.705231 806.091003,238.751709 809.836060,238.891403 
	C814.518250,239.017044 818.287170,239.019714 822.056152,239.022385 
	C823.217407,242.254135 825.792053,245.362061 822.626343,249.005081 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M412.995880,659.057678 
	C413.327393,657.651855 413.658875,656.246094 414.343292,654.410034 
	C416.416656,654.735779 418.137085,655.491821 419.857513,656.247864 
	C439.807495,666.349731 460.733765,673.710754 482.550964,678.565857 
	C485.840271,679.297791 489.139130,679.986816 492.717285,681.201416 
	C492.322388,683.140930 491.643799,684.574768 490.544312,686.004761 
	C484.425262,685.025269 478.727112,684.049622 472.803894,682.791748 
	C471.051758,682.674133 469.524658,682.838745 467.997559,683.003296 
	C464.573273,682.036316 461.148987,681.069275 457.320801,679.676880 
	C455.785858,676.682007 454.148865,676.200684 451.947784,678.047302 
	C450.841003,677.787537 449.734253,677.527771 448.306885,676.738281 
	C443.594055,674.531250 439.201782,672.853882 434.809509,671.176575 
	C434.409149,671.149902 434.008759,671.123291 433.302063,670.672241 
	C429.619019,666.123108 425.109924,664.809937 419.991333,665.010010 
	C418.138062,664.222534 416.284790,663.434998 414.192749,662.068359 
	C413.634644,660.678711 413.315277,659.868164 412.995880,659.057678 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M260.143585,374.969421 
	C260.061249,371.941956 259.978882,368.914490 260.186340,365.441345 
	C260.649506,364.947388 260.822876,364.899170 261.256592,365.041443 
	C262.360016,366.469147 263.203003,367.706299 264.084900,369.307678 
	C265.050201,370.533600 266.020294,371.353394 266.895081,372.264679 
	C269.885986,375.380524 272.622467,374.647736 274.257385,369.927063 
	C274.289276,366.753906 274.162445,363.960846 273.966125,360.845642 
	C273.277283,359.987701 272.657928,359.451874 272.035767,358.954346 
	C272.032928,358.992615 272.098389,358.952484 272.074646,358.614136 
	C271.757874,357.201965 271.464844,356.128143 271.484558,354.877136 
	C273.598755,353.972229 275.364380,353.133209 277.208801,352.538300 
	C282.003052,350.992004 283.627991,347.884247 282.070740,342.732758 
	C281.338562,340.573090 280.641083,338.782227 280.384308,336.927582 
	C285.772095,337.363556 290.485992,337.247437 293.490295,332.559265 
	C294.211914,333.695648 294.752136,334.409790 295.208191,335.441437 
	C294.921478,336.148071 294.718964,336.537231 294.242218,337.100433 
	C292.783325,340.585419 287.979980,343.184479 292.065582,347.861511 
	C297.348480,350.631042 302.200684,349.204712 306.943115,347.330811 
	C304.505096,349.135345 302.063232,350.519897 299.734344,352.073761 
	C298.362335,352.989227 297.169464,354.173187 295.662048,355.209534 
	C295.428101,355.182678 294.957153,355.180176 294.763489,354.902252 
	C293.041321,353.347137 291.512787,352.069916 289.926300,350.407379 
	C289.356415,347.393036 288.844513,344.763977 288.283295,341.881836 
	C284.633636,342.738617 283.732941,344.793518 284.037933,347.810516 
	C284.195160,349.366333 284.047363,350.952972 283.747986,352.771027 
	C280.234192,354.788971 279.492828,357.611694 279.993011,361.326843 
	C280.664886,362.886627 281.426788,364.117188 282.586975,365.350464 
	C287.007935,365.631531 291.030640,365.909851 294.987915,366.543823 
	C293.932770,367.588654 293.033203,368.570435 291.935364,368.908539 
	C289.349426,369.704895 286.668945,370.194305 283.642609,370.843933 
	C280.617401,369.806091 278.202271,369.029266 277.672729,373.235535 
	C277.301819,376.181732 276.594177,379.085602 275.734924,382.212341 
	C274.146271,381.592926 272.859589,380.769531 271.475891,379.579773 
	C268.651245,378.115967 265.923645,377.018524 263.024658,375.618042 
	C261.950073,375.199799 261.046814,375.084625 260.143585,374.969421 
z"
      />
      <path
        fill="#0F181C"
        opacity="1.000000"
        stroke="none"
        d="
M282.947968,422.120575 
	C276.234497,417.131195 269.521027,412.141815 262.421204,406.663025 
	C261.259583,405.798492 260.484283,405.423340 259.708984,405.048187 
	C259.729065,400.662292 259.749176,396.276428 260.244293,391.480347 
	C263.484161,393.039368 266.006805,395.891876 269.080475,396.734589 
	C272.288391,397.614105 273.268188,398.928864 272.967957,401.770782 
	C272.494904,406.248077 274.474091,408.631622 278.986359,409.454285 
	C282.115936,414.290710 286.819489,412.681580 291.020020,413.394348 
	C292.351868,414.842896 293.642029,415.955383 294.947815,417.423798 
	C293.973328,419.455017 292.983246,421.130310 291.993164,422.805603 
	C290.277527,422.892975 288.561859,422.980377 286.370026,422.639038 
	C284.911865,422.180420 283.929932,422.150482 282.947968,422.120575 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M522.955017,708.051147 
	C527.546753,710.629150 532.048584,713.393738 536.783569,715.674194 
	C538.249084,716.380005 540.619507,716.347046 542.106384,715.650574 
	C546.273254,713.698975 550.195190,711.224609 554.743286,709.151855 
	C556.746948,708.108337 558.221069,706.869263 559.695251,705.630249 
	C559.695251,705.630249 559.824219,705.722473 560.048950,705.715881 
	C560.484131,705.395996 560.694458,705.082703 560.904846,704.769409 
	C560.904846,704.769409 560.895447,704.890686 561.228394,704.911255 
	C564.152039,703.751160 566.742859,702.570618 570.274475,700.961304 
	C569.552490,702.681702 569.422607,703.908203 568.743835,704.462952 
	C563.517090,708.734802 558.140015,712.822815 552.916748,717.098755 
	C551.721130,718.077515 550.941772,719.564880 549.970825,720.818176 
	C546.594910,722.446594 543.265076,724.185913 539.809692,725.623474 
	C538.974670,725.970947 537.724854,725.321411 536.383423,724.615234 
	C535.713196,720.619873 534.251953,719.929138 530.739319,721.565674 
	C530.739319,721.565674 530.337402,721.439270 530.041565,720.980774 
	C525.626709,717.771545 523.065613,712.484436 517.093384,712.750732 
	C515.964233,711.854919 514.835083,710.959045 513.407227,709.625732 
	C513.062439,708.804077 513.016418,708.419861 512.978210,707.622192 
	C513.770874,705.698242 514.555664,704.187805 515.340454,702.677368 
	C515.340454,702.677368 515.196106,702.861206 515.185913,703.123657 
	C517.155701,705.963562 518.613281,709.412048 522.955017,708.051147 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M278.886536,409.111725 
	C274.474091,408.631622 272.494904,406.248077 272.967957,401.770782 
	C273.268188,398.928864 272.288391,397.614105 269.080475,396.734589 
	C266.006805,395.891876 263.484161,393.039368 260.373779,391.030121 
	C259.924500,389.576416 259.820831,388.162720 260.133179,386.362885 
	C260.975250,386.018219 261.401276,386.059692 261.975647,386.336487 
	C262.430695,387.034485 262.737335,387.497223 263.041260,388.323547 
	C265.238831,390.143646 267.263153,392.169708 269.682495,392.917358 
	C272.953674,393.928253 276.916473,394.662354 277.004944,388.609192 
	C276.963745,387.159698 276.915192,386.105927 277.143616,385.042908 
	C277.604675,385.019928 277.788727,385.006195 278.258087,385.052673 
	C278.969696,385.500397 279.395935,385.887878 279.906891,386.617371 
	C284.516235,392.208740 288.420898,388.933868 292.280426,386.494690 
	C292.439331,389.713989 292.672577,392.498749 292.982788,395.627380 
	C294.565125,396.217041 296.090424,396.381073 297.568115,396.740601 
	C298.398132,396.942596 299.149506,397.467712 299.625336,398.000336 
	C297.898468,401.075378 296.482574,403.997314 295.021912,407.321533 
	C296.586243,408.498566 298.240906,410.006195 299.795898,409.909576 
	C304.330566,409.627747 308.825409,408.704865 313.262817,408.362427 
	C313.778748,409.548981 314.367676,410.406464 314.972839,411.638123 
	C318.367828,415.949310 322.210358,413.594635 325.922668,413.185425 
	C324.075073,414.442566 322.130035,416.252716 320.428864,416.046875 
	C315.888245,415.497528 311.452423,414.081757 306.622498,412.969299 
	C304.845856,413.269012 303.421692,413.609802 301.657623,413.964386 
	C300.864807,414.000793 300.411865,414.023438 299.678131,414.154724 
	C298.641144,414.506378 297.884979,414.749451 296.883545,414.738495 
	C295.052155,411.297302 293.466003,408.110138 291.845764,404.582031 
	C290.608704,402.410400 289.405670,400.579651 288.204651,398.837616 
	C288.206604,398.926331 288.261902,398.757690 288.200653,398.425842 
	C286.797638,396.928375 285.550171,395.626160 284.096466,394.622650 
	C279.636322,391.543610 275.619812,393.346039 274.165375,399.296631 
	C274.699005,401.114899 275.307678,402.588501 275.940033,404.393127 
	C277.015869,406.100220 278.068024,407.476257 279.062683,408.917999 
	C279.005188,408.983673 278.886536,409.111725 278.886536,409.111725 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M821.534607,369.346558 
	C821.421631,371.975800 821.308594,374.605011 820.616455,377.575653 
	C815.125122,379.289215 810.305847,380.803223 807.537415,386.072266 
	C806.698364,387.475494 806.155884,388.710358 805.399536,390.248047 
	C804.572449,393.812592 806.050842,395.440399 809.213562,394.930878 
	C812.372620,394.421906 815.446228,393.382721 818.678467,392.691895 
	C818.799561,392.807800 819.040771,393.040588 819.024719,393.359619 
	C818.995361,394.104309 818.981995,394.529907 818.653809,395.013428 
	C817.555725,396.040039 816.772522,397.008820 815.637451,398.018188 
	C813.008545,399.025177 810.731506,399.991577 808.216797,400.950867 
	C807.979126,400.943756 807.504822,400.923218 807.495117,400.539673 
	C801.853882,394.359283 799.247803,394.688477 793.389282,402.068695 
	C792.321411,403.780701 791.544922,405.323883 790.799866,406.922211 
	C790.831299,406.977325 790.945740,406.922455 790.611389,406.986145 
	C790.079346,407.683533 789.881653,408.317261 789.530457,408.935974 
	C789.376892,408.920959 789.117188,409.087616 788.819275,409.071411 
	C788.127075,409.003998 787.732727,408.952759 787.295654,408.638611 
	C787.022888,407.916809 786.793030,407.457947 786.475586,406.662598 
	C785.937439,405.862457 785.486816,405.398773 785.029419,404.970276 
	C785.022583,405.005463 785.070740,404.952362 785.036743,404.608337 
	C782.695435,402.435455 780.388062,400.606628 778.104858,398.535461 
	C778.370789,397.903900 778.612671,397.514709 779.213135,397.194946 
	C780.055664,397.310303 780.539612,397.356201 781.281616,397.636017 
	C789.657043,399.940125 790.082703,399.659882 792.691528,390.527252 
	C801.261414,390.813141 804.335205,389.045563 805.986206,382.559143 
	C805.870911,380.428284 805.657654,378.676727 805.477295,376.690491 
	C805.510254,376.455780 805.528931,375.982178 805.714478,375.795227 
	C806.368469,375.379669 806.836914,375.151001 807.555725,375.108215 
	C809.503052,378.416565 812.265076,378.264313 814.554626,376.687927 
	C816.430969,375.395966 817.597778,373.073425 819.268738,370.996033 
	C820.150452,370.305145 820.842529,369.825867 821.534607,369.346558 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M815.989319,397.977600 
	C816.772522,397.008820 817.555725,396.040039 818.811401,395.262085 
	C819.824768,395.633759 820.365601,395.814667 820.906494,395.995605 
	C820.941956,400.020203 820.977295,404.044800 820.960327,408.530609 
	C815.457581,413.386841 810.091309,417.892944 804.509766,422.114532 
	C802.645325,423.524689 800.230713,424.207489 797.421021,425.226624 
	C796.511169,425.470459 796.247864,425.710480 795.984619,425.950500 
	C793.942871,425.924957 791.901062,425.899414 789.427612,425.415863 
	C788.024902,420.243011 790.476624,416.848846 795.404846,417.099976 
	C800.460266,417.357574 803.934387,414.481720 806.749329,411.420532 
	C810.393127,407.457977 812.959229,402.504456 815.989319,397.977600 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M779.183472,198.015305 
	C779.437134,197.563583 779.690796,197.111877 780.247192,196.303940 
	C780.732361,195.644699 780.914734,195.341675 781.097107,195.038651 
	C781.097107,195.038651 781.013916,195.031616 781.318481,194.967514 
	C782.067688,194.517838 782.512329,194.132263 782.956970,193.746689 
	C785.143433,192.348419 787.329956,190.950165 789.699707,189.274994 
	C792.980591,189.668274 794.819885,188.994568 795.295654,185.309387 
	C795.878113,180.797989 798.441162,177.431000 802.997681,175.735382 
	C803.774841,176.872574 804.562988,178.025909 805.431335,179.296600 
	C807.518005,178.161774 809.384338,177.146790 811.618408,175.931839 
	C813.287903,179.976578 816.182007,181.344696 820.590149,178.935150 
	C820.678650,179.366989 820.767151,179.798828 820.855652,180.230667 
	C818.759460,183.382690 816.663330,186.534714 814.566040,189.688324 
	C820.052979,193.403366 820.052979,193.403366 814.990112,198.276260 
	C814.755310,197.326279 814.876892,196.675079 814.988892,195.641327 
	C813.886963,193.993149 812.794556,192.727539 811.721375,191.096313 
	C811.054932,184.449829 805.468262,187.625381 802.335632,186.256851 
	C800.800476,185.586227 797.948425,187.930161 794.509460,189.423386 
	C797.295776,190.668167 798.572388,191.238464 800.599854,192.144226 
	C798.818054,194.040421 797.419128,195.529160 796.013184,196.601395 
	C794.990173,195.117249 794.052490,193.230316 792.944458,193.124344 
	C788.255432,192.675934 784.562561,194.765442 781.630981,198.804840 
	C780.639160,198.794968 779.974854,198.695206 779.333191,198.438507 
	C779.355896,198.281540 779.183472,198.015305 779.183472,198.015305 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M668.792358,83.725266 
	C667.663635,84.117973 666.159851,84.690697 665.000427,84.283279 
	C649.241272,78.745544 633.810120,72.031128 617.733643,67.703430 
	C598.927246,62.640877 579.666321,59.112926 559.974792,58.923615 
	C548.205078,58.810463 536.441223,58.094265 524.382080,57.371712 
	C531.875366,56.735504 539.676575,55.872097 547.444519,56.107121 
	C577.683472,57.022045 607.586060,60.542870 636.361267,70.405617 
	C647.304626,74.156487 657.850342,79.067398 668.792358,83.725266 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M550.318726,720.811829 
	C550.941772,719.564880 551.721130,718.077515 552.916748,717.098755 
	C558.140015,712.822815 563.517090,708.734802 568.743835,704.462952 
	C569.422607,703.908203 569.552490,702.681702 570.274475,700.961304 
	C566.742859,702.570618 564.152039,703.751160 561.173828,704.884277 
	C565.318298,700.225464 569.974365,695.727234 574.323975,690.950073 
	C576.194031,688.896240 577.428406,686.263672 579.208923,683.678833 
	C581.306580,689.884583 586.310791,686.613647 590.556274,687.189697 
	C590.965149,687.614624 590.955994,687.797241 590.946899,687.979858 
	C587.392151,688.143921 585.233398,689.963684 583.021057,692.865295 
	C574.226440,704.400208 563.744629,714.149963 550.318726,720.811829 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M814.998474,196.023880 
	C814.876892,196.675079 814.755310,197.326279 814.647339,198.311066 
	C813.113098,200.194229 811.565369,201.743790 810.088013,203.879715 
	C810.350830,204.918030 810.543213,205.369965 810.400269,205.805618 
	C809.052246,206.227219 808.039551,206.665100 806.852783,206.743454 
	C805.531494,205.902328 804.406799,205.354279 803.232117,204.952744 
	C800.642273,204.067581 798.027161,203.256256 794.166321,202.009079 
	C789.712463,204.707657 783.441101,204.523895 777.048279,202.906403 
	C777.048279,202.906403 777.016235,202.445129 777.001282,201.847885 
	C777.003479,200.514389 777.020691,199.778152 777.037903,199.041901 
	C777.037903,199.041901 777.013672,199.029099 777.247803,198.924438 
	C777.750549,198.605087 777.923218,198.330170 778.000061,197.995056 
	C778.197266,197.988068 778.394409,197.981064 778.887573,197.994675 
	C779.183472,198.015305 779.355896,198.281540 779.249756,198.861237 
	C782.036926,203.400528 789.509766,203.203751 792.304443,198.924194 
	C792.723328,198.604736 792.879456,198.462402 793.322632,198.451294 
	C794.258362,198.134201 794.906921,197.685898 795.698242,197.238846 
	C795.840942,197.240112 796.020203,197.017899 796.020203,197.017883 
	C797.419128,195.529160 798.818054,194.040421 800.599854,192.144226 
	C798.572388,191.238464 797.295776,190.668167 794.509460,189.423386 
	C797.948425,187.930161 800.800476,185.586227 802.335632,186.256851 
	C805.468262,187.625381 811.054932,184.449829 811.334839,191.171555 
	C803.814575,192.770218 801.384766,194.843018 800.214050,202.261490 
	C805.678040,199.956223 810.338257,197.990051 814.998474,196.023880 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M291.727448,180.969620 
	C291.546448,184.355438 293.189941,185.740448 296.153687,186.739838 
	C298.253265,187.447845 299.966614,189.301224 301.485626,190.922272 
	C300.448120,191.091812 299.777374,190.982407 298.911865,190.573120 
	C296.172668,189.289444 293.687469,187.804718 291.063416,187.494354 
	C289.253571,187.280304 287.251526,188.691284 285.335358,189.376038 
	C286.127533,190.894394 286.919739,192.412750 287.656189,193.982666 
	C287.600494,194.034225 287.605621,194.309540 287.871704,194.597488 
	C292.015656,199.540436 297.200714,200.465546 302.843079,199.966690 
	C306.008881,199.686813 306.390289,198.104309 304.643372,195.411133 
	C304.092499,194.445770 303.547180,193.757858 302.958252,192.827606 
	C302.914703,192.585297 302.841125,192.098404 302.841125,192.098404 
	C304.996674,193.733200 307.237976,195.273193 309.236206,197.081802 
	C309.641663,197.448776 309.452850,199.368927 308.985138,199.648636 
	C306.973755,200.851608 304.758606,202.504578 302.613281,202.510895 
	C299.245605,202.520828 295.897552,201.151779 292.496277,200.722473 
	C290.316833,200.447372 288.056610,200.811829 285.413269,200.522217 
	C284.890930,199.374786 284.787933,198.594742 284.675598,197.527435 
	C283.774078,196.085815 282.881927,194.931427 281.829041,193.442780 
	C279.536621,191.561584 277.404968,190.014664 275.174744,188.115448 
	C275.160797,186.593811 275.245392,185.424438 275.275604,185.006683 
	C280.110535,185.294830 284.267548,185.542557 288.244751,185.779587 
	C289.253296,183.868546 290.095184,182.273285 290.937073,180.678009 
	C291.119446,180.726929 291.301788,180.775848 291.727448,180.969620 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M288.655029,309.175568 
	C283.659698,313.673553 278.075653,317.950439 272.943909,322.714508 
	C269.830078,325.605255 267.484436,329.310120 264.647736,332.520264 
	C263.722961,333.566742 262.336853,334.205566 260.820587,335.038330 
	C260.401154,332.667450 260.322906,330.289062 260.365356,327.480011 
	C263.480347,324.056274 266.385193,320.966614 269.488770,318.091553 
	C274.794006,313.176880 280.934967,309.896271 288.655029,309.175568 
z"
      />
      <path
        fill="#2C4E1C"
        opacity="1.000000"
        stroke="none"
        d="
M821.522827,336.681519 
	C819.861816,336.518219 817.985291,336.323944 816.992493,335.285095 
	C810.563965,328.558838 804.328186,321.648438 797.957886,314.468201 
	C800.493042,314.561676 803.597229,314.234924 805.602539,315.564941 
	C809.810852,318.356232 813.431580,322.030212 817.315308,325.316040 
	C818.422302,326.252563 819.604248,327.100342 821.076416,327.995270 
	C821.505981,330.754425 821.611023,333.507172 821.522827,336.681519 
z"
      />
      <path
        fill="#F1F0D4"
        opacity="1.000000"
        stroke="none"
        d="
M768.798096,170.086685 
	C772.182312,169.048523 771.341248,167.268631 769.317261,164.818024 
	C769.331238,163.206955 769.659973,162.114197 769.988708,161.021454 
	C775.315796,167.364807 780.642883,173.708160 785.998291,180.390350 
	C784.313904,182.013290 782.601074,183.297394 780.458496,184.378311 
	C778.966736,182.819489 777.904785,181.463852 776.820557,179.822021 
	C776.111023,178.909271 775.423767,178.282730 774.635132,177.532166 
	C774.533813,177.408157 774.213684,177.418594 774.203369,177.089966 
	C772.394775,174.536438 770.596436,172.311569 768.798096,170.086685 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M515.258057,702.357544 
	C514.555664,704.187805 513.770874,705.698242 512.679688,707.476013 
	C510.886871,706.852295 509.400452,705.961243 507.914062,705.070190 
	C505.428406,702.538025 502.942749,700.005920 500.196411,696.924927 
	C499.314972,695.904480 498.694183,695.432861 498.073425,694.961243 
	C497.753693,694.526733 497.433960,694.092285 497.027008,693.026978 
	C496.190613,690.766785 495.441467,689.137451 494.721344,687.571167 
	C496.567413,687.300049 498.441864,687.024841 500.316284,686.749573 
	C500.316284,686.749573 500.194641,686.901794 500.292664,687.141968 
	C500.815002,687.565002 501.239258,687.747803 501.663513,687.930542 
	C506.167572,692.632935 510.671631,697.335327 515.258057,702.357544 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M267.055847,182.987259 
	C265.599487,181.464264 264.143127,179.941269 261.910553,177.606567 
	C266.771912,176.955399 270.838287,177.832703 272.820312,173.549377 
	C272.931702,173.308655 277.040863,174.917831 279.628021,175.778687 
	C280.242401,175.089813 281.081268,174.149261 282.376282,172.697250 
	C283.858246,173.704559 285.399780,174.752335 286.946045,176.558716 
	C286.938477,181.518494 286.085602,184.008972 281.816925,179.928360 
	C281.495880,179.621429 280.725525,179.707092 280.170776,179.736603 
	C278.516052,179.824600 276.864655,179.975540 274.988617,180.118958 
	C272.571899,180.992798 269.813873,181.990036 267.055847,182.987259 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M264.046021,368.943451 
	C263.203003,367.706299 262.360016,366.469147 261.241638,364.707855 
	C260.446747,363.314331 259.927185,362.444946 259.407654,361.575562 
	C259.469513,361.318237 259.481506,361.058594 259.672729,360.512146 
	C260.259369,360.083771 260.616882,359.939850 261.304413,359.895935 
	C262.667084,360.378540 263.786743,361.227264 264.715576,361.053802 
	C267.220001,360.586151 269.643036,359.682892 272.098389,358.952484 
	C272.098389,358.952484 272.032928,358.992615 272.018494,359.265259 
	C272.392059,360.403717 272.780090,361.269501 273.168121,362.135315 
	C273.457306,361.812805 273.746460,361.490295 274.035614,361.167755 
	C274.162445,363.960846 274.289276,366.753906 273.817993,369.842102 
	C270.161926,369.739288 267.103973,369.341370 264.046021,368.943451 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M267.123474,183.318787 
	C269.813873,181.990036 272.571899,180.992798 274.988617,180.118958 
	C276.864655,179.975540 278.516052,179.824600 280.170776,179.736603 
	C280.725525,179.707092 281.495880,179.621429 281.816925,179.928360 
	C286.085602,184.008972 286.938477,181.518494 286.982513,176.883850 
	C288.247040,177.670853 289.479828,178.891327 290.824829,180.394897 
	C290.095184,182.273285 289.253296,183.868546 288.244751,185.779587 
	C284.267548,185.542557 280.110535,185.294830 275.275604,185.006683 
	C275.245392,185.424438 275.160797,186.593811 274.817810,188.230469 
	C273.051666,188.135971 271.543945,187.574173 270.036255,187.012360 
	C269.087891,185.891678 268.139496,184.770996 267.123474,183.318787 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M259.423218,405.347168 
	C260.484283,405.423340 261.259583,405.798492 262.139893,406.491364 
	C261.836609,408.319580 261.000854,409.854645 261.085846,411.336884 
	C261.958740,426.565826 262.991760,441.785522 263.939026,457.010345 
	C264.009521,458.143494 263.763275,459.296326 263.361481,460.685547 
	C259.827942,444.304291 258.427734,427.525299 258.888428,410.593262 
	C258.933319,408.943176 259.052673,407.295105 259.423218,405.347168 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M815.268250,215.913391 
	C818.350891,219.090561 821.433594,222.267715 824.516296,225.444885 
	C824.304260,225.844818 824.092224,226.244751 823.880249,226.644699 
	C820.811096,225.959000 817.742004,225.273300 814.014526,224.288055 
	C812.295654,223.979874 811.234985,223.971222 810.135437,223.652618 
	C809.917969,222.541656 809.739441,221.740646 809.857788,220.633881 
	C810.442017,219.249222 810.729492,218.170319 811.373962,217.006485 
	C812.460327,216.851791 813.189636,216.782028 814.154236,216.715561 
	C814.389465,216.718857 814.695007,216.364532 814.695007,216.364532 
	C814.695007,216.364532 814.439148,215.972916 814.636597,215.820648 
	C814.833984,215.668381 815.268250,215.913376 815.268250,215.913391 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M615.395874,682.988892 
	C615.430298,682.357239 615.728943,681.363098 616.315369,681.145813 
	C630.950806,675.723511 645.616516,670.383118 660.660645,665.032593 
	C655.185303,667.949707 649.504456,671.325378 643.425293,673.666626 
	C634.362427,677.156860 625.018555,679.917358 615.395874,682.988892 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M807.833923,385.903900 
	C810.305847,380.803223 815.125122,379.289215 820.400085,377.923523 
	C821.038757,380.947052 821.314636,383.964111 821.081787,387.434387 
	C820.374207,388.255402 820.175354,388.623199 819.883240,389.205261 
	C819.611755,389.679199 819.396179,389.902832 818.859314,389.866760 
	C818.575439,387.851379 818.575439,386.059692 818.575439,383.111298 
	C816.243591,384.418732 814.697449,385.285645 812.707031,386.102448 
	C810.786499,386.002869 809.310242,385.953369 807.833923,385.903900 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M821.695129,368.881958 
	C820.842529,369.825867 820.150452,370.305145 819.045532,370.862976 
	C818.471375,370.879547 818.310120,370.817535 818.308289,370.439575 
	C818.673462,369.003784 819.051392,367.882538 819.042053,366.764496 
	C819.029846,365.296722 818.712402,363.831482 818.526245,362.365173 
	C816.832092,362.607635 814.805603,362.348175 813.516052,363.201782 
	C811.156677,364.763641 809.232727,366.983337 807.039795,368.545837 
	C808.170166,365.271973 809.387939,362.380981 810.828247,359.781921 
	C814.061584,359.990509 817.598755,361.275513 819.002869,357.015106 
	C819.690491,356.682343 820.378052,356.349579 821.361816,355.987305 
	C821.723816,360.110992 821.789734,364.264160 821.695129,368.881958 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M272.028717,229.004532 
	C272.028717,229.004532 271.544739,229.057526 271.303467,229.025726 
	C271.004730,227.284805 270.947327,225.575684 270.995361,223.204269 
	C270.723633,222.295425 270.346436,222.048874 269.969208,221.802307 
	C269.535645,221.849731 269.102112,221.897141 267.948242,221.940292 
	C266.441681,222.092300 265.655396,222.248550 264.869141,222.404800 
	C264.010223,222.138077 263.151276,221.871353 262.442078,221.151550 
	C265.940033,218.547012 269.288269,216.395554 272.935181,214.172638 
	C273.435150,214.063660 273.636414,214.026123 274.104004,214.039810 
	C274.601868,214.346695 274.833405,214.602356 274.921082,215.216278 
	C273.391937,218.731628 271.034180,221.905380 274.947144,225.262817 
	C274.903107,225.936737 274.850128,226.319733 274.578369,226.914764 
	C273.582642,227.752716 272.805664,228.378616 272.028717,229.004532 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M273.837646,213.988586 
	C273.636414,214.026123 273.435150,214.063660 272.609131,214.155594 
	C271.458893,213.685760 270.831512,213.228470 270.432526,212.621140 
	C269.875641,211.773483 269.489349,210.813766 268.849121,209.680130 
	C268.306305,209.375793 267.944458,209.293320 267.582611,209.210846 
	C267.582611,209.210846 267.250275,209.135529 267.144440,208.629852 
	C266.938751,204.180710 269.342804,203.874115 272.331207,204.537598 
	C274.079651,204.925766 275.798615,205.446854 277.530823,205.908157 
	C277.805115,205.867691 278.061066,205.918976 278.517761,206.497314 
	C277.104736,208.383362 275.472565,209.834106 273.351898,211.719009 
	C273.368896,211.798416 273.603271,212.893509 273.837646,213.988586 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M811.016968,217.091431 
	C810.729492,218.170319 810.442017,219.249222 809.629578,220.367035 
	C807.767029,219.561188 806.429504,218.716476 805.065796,217.674744 
	C805.039612,217.477737 804.980164,217.084747 805.155762,216.832748 
	C805.893494,216.300751 806.455750,216.020752 807.017944,215.740784 
	C805.737244,213.612701 801.787598,211.935455 806.104248,209.198578 
	C808.058472,210.036728 809.823608,210.456116 811.468506,211.157333 
	C812.946289,211.787277 814.292114,212.726837 815.696106,213.529846 
	C815.373169,213.859253 815.050232,214.188644 814.233643,214.830597 
	C812.832214,215.792557 811.924622,216.441986 811.016968,217.091431 
z"
      />
      <path
        fill="#F1F0D4"
        opacity="1.000000"
        stroke="none"
        d="
M767.995850,161.002106 
	C761.608704,157.274521 756.870056,151.940155 753.041016,145.331604 
	C760.191589,148.126953 765.077698,153.689774 768.783325,160.609253 
	C768.355286,160.992111 768.175537,160.997116 767.995850,161.002106 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M816.045044,213.642303 
	C814.292114,212.726837 812.946289,211.787277 811.468506,211.157333 
	C809.823608,210.456116 808.058472,210.036728 806.248840,208.972672 
	C806.443604,208.001450 806.735168,207.552216 807.026794,207.102997 
	C808.039551,206.665100 809.052246,206.227219 810.600342,206.147583 
	C815.007202,207.387314 818.878723,208.268768 822.750305,209.150238 
	C820.631531,210.685089 818.512756,212.219925 816.045044,213.642303 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M269.697479,187.113495 
	C271.543945,187.574173 273.051666,188.135971 274.916321,188.582748 
	C277.404968,190.014664 279.536621,191.561584 281.369751,193.497971 
	C277.667023,193.647614 274.262817,193.407776 270.630371,193.146225 
	C270.402100,193.124512 269.948914,193.054352 269.745972,192.759064 
	C268.847290,192.324158 268.151550,192.184525 267.455811,192.044907 
	C263.309357,188.551422 268.000885,188.539688 269.697479,187.113495 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M500.265198,686.393982 
	C498.441864,687.024841 496.567413,687.300049 494.721344,687.571167 
	C495.441467,689.137451 496.190613,690.766785 496.894836,692.791443 
	C495.035156,691.649109 493.220459,690.111450 491.196899,687.987000 
	C490.980438,686.936340 490.972839,686.472473 490.965210,686.008606 
	C491.643799,684.574768 492.322388,683.140930 492.998566,681.346802 
	C497.076019,680.278870 499.043610,682.589233 500.265198,686.393982 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M804.980164,217.084747 
	C804.980164,217.084747 805.039612,217.477737 804.733643,217.765015 
	C802.981995,221.583008 804.606323,223.253540 810.174377,223.962570 
	C811.234985,223.971222 812.295654,223.979874 813.642151,224.120209 
	C813.613586,225.564346 813.299194,226.876770 812.545654,228.604797 
	C811.384644,229.038727 810.662842,229.057053 809.646606,228.912857 
	C806.185608,224.817108 803.018982,220.883881 800.240845,216.910202 
	C801.124695,216.723160 801.620239,216.576553 802.455566,216.574677 
	C803.523682,216.841171 804.251953,216.962952 804.980164,217.084747 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M259.928375,292.120850 
	C260.236298,302.634766 260.241119,313.357330 260.118042,324.522308 
	C259.668640,323.419403 259.056122,321.870819 259.073334,320.329254 
	C259.177490,310.995117 259.425415,301.662598 259.928375,292.120850 
z"
      />
      <path
        fill="#925627"
        opacity="1.000000"
        stroke="none"
        d="
M269.948914,193.054352 
	C269.948914,193.054352 270.402100,193.124512 270.840118,193.432922 
	C275.747070,195.099121 280.216003,196.456894 284.684937,197.814682 
	C284.787933,198.594742 284.890930,199.374786 285.020996,200.548798 
	C283.973389,200.956009 282.898712,200.969269 281.129395,200.678864 
	C278.777069,200.268250 277.119415,200.161301 275.461731,200.054352 
	C274.075043,198.900665 272.688324,197.746964 271.084167,196.081848 
	C270.590118,195.393143 270.313568,195.215866 270.037018,195.038605 
	C269.596130,194.566681 269.155212,194.094742 268.958923,193.365799 
	C269.451996,193.090652 269.700470,193.072495 269.948914,193.054352 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M740.370239,609.031738 
	C745.128784,603.367859 750.234985,597.685791 755.693909,592.017212 
	C750.937073,597.691650 745.827515,603.352661 740.370239,609.031738 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M277.420319,205.515961 
	C275.798615,205.446854 274.079651,204.925766 272.331207,204.537598 
	C269.342804,203.874115 266.938751,204.180710 267.025452,208.507874 
	C265.477509,208.140121 263.942688,207.388672 262.047089,206.460587 
	C265.715851,201.863144 270.488770,202.547668 275.459412,202.080643 
	C276.123291,202.411682 276.230652,202.654938 276.392944,202.873962 
	C276.698578,203.623901 277.004181,204.373825 277.420319,205.515961 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M269.030060,209.901993 
	C269.489349,210.813766 269.875641,211.773483 270.432526,212.621140 
	C270.831512,213.228470 271.458893,213.685760 272.310425,214.227036 
	C269.288269,216.395554 265.940033,218.547012 262.285706,220.843994 
	C262.262878,219.520996 262.154541,217.794830 262.914368,216.639801 
	C264.317444,214.507050 266.229584,212.709198 268.217041,210.377228 
	C268.679688,209.955765 268.854858,209.928879 269.030060,209.901993 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M822.790833,208.795380 
	C818.878723,208.268768 815.007202,207.387314 810.935608,206.163879 
	C810.543213,205.369965 810.350830,204.918030 810.176025,204.212921 
	C814.958496,203.895615 819.652954,204.030121 822.790833,208.795380 
z"
      />
      <path
        fill="#F1F0D4"
        opacity="1.000000"
        stroke="none"
        d="
M752.834839,143.695160 
	C749.901611,142.055481 746.673584,140.317001 743.820740,138.096512 
	C741.964478,136.651703 740.654297,134.505264 739.050964,132.335464 
	C743.568054,135.795776 748.133667,139.593796 752.834839,143.695160 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M490.544312,686.004761 
	C490.972839,686.472473 490.980438,686.936340 490.970612,687.748779 
	C485.269135,687.003357 479.585083,685.909485 473.479126,684.474426 
	C473.047821,683.780151 473.038391,683.427063 473.028961,683.073975 
	C478.727112,684.049622 484.425262,685.025269 490.544312,686.004761 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M263.884766,465.443787 
	C264.506287,465.425049 265.651611,465.712128 265.759125,466.219238 
	C267.118378,472.629608 268.328186,479.071625 269.306030,485.740723 
	C267.332672,479.267883 265.629456,472.559875 263.884766,465.443787 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M768.330566,577.018494 
	C770.839294,572.576904 773.629761,567.932373 776.738770,563.153076 
	C774.242310,567.617310 771.427246,572.216492 768.330566,577.018494 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M517.216797,713.073792 
	C523.065613,712.484436 525.626709,717.771545 529.876465,720.849854 
	C525.784912,718.583984 521.562561,715.990417 517.216797,713.073792 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M435.033417,671.447021 
	C439.201782,672.853882 443.594055,674.531250 447.993652,676.590759 
	C443.753082,675.221130 439.505188,673.469299 435.033417,671.447021 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M420.212280,665.274658 
	C425.109924,664.809937 429.619019,666.123108 433.004883,670.624451 
	C428.820404,669.180542 424.626831,667.359985 420.212280,665.274658 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M596.406860,687.862305 
	C596.341370,687.011963 596.532776,685.452332 596.985474,685.372375 
	C601.455139,684.583191 605.968140,684.039429 610.735718,683.709106 
	C606.263367,685.274597 601.524231,686.557190 596.406860,687.862305 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M821.937012,238.665588 
	C818.287170,239.019714 814.518250,239.017044 810.294189,238.880737 
	C810.575867,237.806046 811.312561,236.865005 812.352173,235.891388 
	C813.984680,236.434448 815.269287,237.184875 816.655212,237.540802 
	C818.331299,237.971283 820.093140,238.067764 821.937012,238.665588 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M260.974396,359.795929 
	C260.616882,359.939850 260.259369,360.083771 259.630737,360.320984 
	C259.380310,359.088715 259.401062,357.763062 259.742249,356.200378 
	C262.136597,354.889832 264.210510,353.816315 266.610748,353.219849 
	C265.756073,354.720917 264.511139,355.681580 263.413971,356.788727 
	C262.509918,357.701050 261.780945,358.786957 260.974396,359.795929 
z"
      />
      <path
        fill="#DFE5BC"
        opacity="1.000000"
        stroke="none"
        d="
M822.249084,322.651794 
	C821.885620,314.602295 821.818542,306.269073 821.883972,297.487915 
	C822.192749,305.482666 822.369080,313.925354 822.249084,322.651794 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M530.887329,721.834229 
	C534.251953,719.929138 535.713196,720.619873 536.079102,724.404541 
	C534.383179,723.840210 532.709290,722.971497 530.887329,721.834229 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M412.672058,658.910217 
	C413.315277,659.868164 413.634644,660.678711 413.957092,661.824341 
	C411.642639,660.682617 409.325073,659.205750 406.977722,657.377930 
	C408.748077,657.605591 410.548157,658.184143 412.672058,658.910217 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M259.839630,375.157593 
	C261.046814,375.084625 261.950073,375.199799 262.707367,375.763214 
	C261.749786,377.527252 260.938141,378.843079 260.060181,380.488037 
	C259.821777,381.227722 259.649658,381.638275 259.477570,382.048859 
	C259.496948,379.814484 259.516296,377.580109 259.839630,375.157593 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M737.019226,130.644989 
	C735.782776,131.304672 734.518188,131.672577 733.253662,132.040497 
	C733.921143,131.033981 734.588562,130.027451 735.635010,129.008240 
	C736.339783,129.448105 736.665466,129.900665 737.019226,130.644989 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M507.975159,705.405151 
	C509.400452,705.961243 510.886871,706.852295 512.671814,707.889526 
	C513.016418,708.419861 513.062439,708.804077 513.127380,709.476257 
	C511.442932,708.422852 509.739594,707.081482 507.975159,705.405151 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M452.179626,678.301575 
	C454.148865,676.200684 455.785858,676.682007 456.953125,679.604614 
	C455.463440,679.490540 453.937439,679.023193 452.179626,678.301575 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M472.803894,682.791748 
	C473.038391,683.427063 473.047821,683.780151 473.080048,684.392700 
	C471.553650,684.271057 470.004425,683.889954 468.226379,683.256104 
	C469.524658,682.838745 471.051758,682.674133 472.803894,682.791748 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M276.774231,202.824371 
	C276.230652,202.654938 276.123291,202.411682 275.884216,202.068726 
	C275.691467,201.559280 275.685394,201.125305 275.570526,200.372833 
	C277.119415,200.161301 278.777069,200.268250 280.727722,200.657867 
	C279.732300,201.551941 278.443939,202.163361 276.774231,202.824371 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M666.412598,663.232239 
	C667.526123,662.224609 668.980957,661.122620 670.836182,660.036621 
	C669.742371,661.080994 668.248169,662.109436 666.412598,663.232239 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M672.302124,660.013062 
	C673.370850,659.040039 674.780334,658.029358 676.564697,657.005005 
	C675.507324,657.985962 674.075134,658.980713 672.302124,660.013062 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M809.940918,229.075378 
	C810.662842,229.057053 811.384644,229.038727 812.467163,229.016846 
	C813.127319,230.197327 813.426758,231.381363 813.520935,232.781769 
	C812.716431,232.452667 812.117126,231.907196 811.159912,230.920624 
	C810.514954,230.011490 810.227966,229.543442 809.940918,229.075378 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M767.831909,161.255707 
	C768.175537,160.997116 768.355286,160.992111 768.805176,160.971039 
	C769.075195,160.954987 769.532349,160.984680 769.760498,161.003067 
	C769.659973,162.114197 769.331238,163.206955 768.998779,164.648407 
	C767.965210,164.058060 764.568359,164.019699 767.831909,161.255707 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M777.387939,563.012329 
	C777.841064,561.734131 778.646118,560.410583 779.810547,559.060547 
	C779.359924,560.344971 778.549927,561.655945 777.387939,563.012329 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M676.821167,87.732208 
	C675.708435,87.539238 674.397278,87.085106 673.043457,86.302879 
	C674.208069,86.473534 675.415466,86.972290 676.821167,87.732208 
z"
      />
      <path
        fill="#DFE5BC"
        opacity="1.000000"
        stroke="none"
        d="
M822.346069,288.712219 
	C821.997986,286.605316 821.923889,284.230011 821.985352,281.428009 
	C822.287231,283.482178 822.453735,285.962982 822.346069,288.712219 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M781.318115,556.862366 
	C781.493835,555.743713 781.926514,554.417908 782.686523,553.044922 
	C782.534302,554.216797 782.054688,555.436035 781.318115,556.862366 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M811.373962,217.006500 
	C811.924622,216.441986 812.832214,215.792557 814.082153,215.143982 
	C814.586426,215.250259 814.748291,215.355698 815.089233,215.687256 
	C815.268250,215.913376 814.833984,215.668381 814.537598,215.932755 
	C814.126587,216.364304 814.019165,216.536011 813.919006,216.712280 
	C813.189636,216.782028 812.460327,216.851791 811.373962,217.006500 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M819.143188,390.090424 
	C819.396179,389.902832 819.611755,389.679199 820.170227,389.238647 
	C820.733582,388.998383 820.916687,388.939056 821.099792,388.879700 
	C821.161438,389.989380 821.223083,391.099030 820.813232,392.608459 
	C819.908142,393.019012 819.474426,393.029785 819.040771,393.040588 
	C819.040771,393.040588 818.799561,392.807800 818.767944,392.385559 
	C818.871887,391.339050 819.007568,390.714752 819.143188,390.090424 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M737.341492,612.222046 
	C737.791016,611.264526 738.560547,610.166626 739.689941,609.045654 
	C739.253723,610.042236 738.457642,611.062012 737.341492,612.222046 
z"
      />
      <path
        fill="#EFE7D6"
        opacity="1.000000"
        stroke="none"
        d="
M309.008392,570.354248 
	C309.948883,570.817688 310.930237,571.616699 311.908142,572.771912 
	C310.952911,572.315369 310.001068,571.502563 309.008392,570.354248 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M259.263611,361.938232 
	C259.927185,362.444946 260.446747,363.314331 260.981262,364.517334 
	C260.822876,364.899170 260.649506,364.947388 260.206299,364.986511 
	C259.664185,364.085205 259.391876,363.193054 259.263611,361.938232 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M819.024719,393.359619 
	C819.474426,393.029785 819.908142,393.019012 820.667603,393.001404 
	C821.053284,393.754547 821.113220,394.514587 821.039795,395.635101 
	C820.365601,395.814667 819.824768,395.633759 819.126282,395.204193 
	C818.981995,394.529907 818.995361,394.104309 819.024719,393.359619 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M264.939575,222.670715 
	C265.655396,222.248550 266.441681,222.092300 267.627472,222.005417 
	C267.113708,222.685410 267.058319,226.299210 264.939575,222.670715 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M591.295166,688.025330 
	C590.955994,687.797241 590.965149,687.614624 590.976196,687.156738 
	C591.649780,687.062683 592.321411,687.243774 593.019775,687.723267 
	C592.578735,688.038025 592.111023,688.054443 591.295166,688.025330 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M498.085022,695.284668 
	C498.694183,695.432861 499.314972,695.904480 499.964081,696.694702 
	C499.360474,696.544922 498.728546,696.076538 498.085022,695.284668 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M261.827301,386.101135 
	C261.401276,386.059692 260.975250,386.018219 260.229370,385.945007 
	C259.825317,385.128876 259.741119,384.344452 260.006104,383.266693 
	C260.540863,383.011230 260.726471,383.049072 260.961304,383.401367 
	C261.282806,384.510925 261.555054,385.306030 261.827301,386.101135 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M260.912109,383.086914 
	C260.726471,383.049072 260.540863,383.011230 260.088684,382.873657 
	C259.822174,382.773956 259.550934,382.458496 259.514221,382.253662 
	C259.649658,381.638275 259.821777,381.227722 260.295959,380.654144 
	C260.826355,381.227844 261.054688,381.964600 261.190552,382.797974 
	C261.098114,382.894653 260.912109,383.086914 260.912109,383.086914 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M270.000488,195.236008 
	C270.313568,195.215866 270.590118,195.393143 270.915955,195.821136 
	C270.631470,195.859039 270.297699,195.646240 270.000488,195.236008 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M784.251099,551.874756 
	C784.172791,551.482300 784.341675,550.914856 784.756531,550.172485 
	C784.834412,550.564941 784.666382,551.132385 784.251099,551.874756 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M270.049805,222.053619 
	C270.346436,222.048874 270.723633,222.295425 271.000061,222.773224 
	C270.642975,222.771286 270.386688,222.538116 270.049805,222.053619 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M269.745972,192.759064 
	C269.700470,193.072495 269.451996,193.090652 268.830475,193.065186 
	C268.184692,192.854126 267.911957,192.686661 267.547516,192.282043 
	C268.151550,192.184525 268.847290,192.324158 269.745972,192.759064 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M756.306274,591.891235 
	C756.177856,591.455933 756.326965,590.876099 756.754944,590.159790 
	C756.883850,590.597839 756.733765,591.172180 756.306274,591.891235 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M405.288879,657.059937 
	C405.535828,656.882629 406.123444,656.729492 406.851685,656.813293 
	C406.538055,657.061523 406.083801,657.072815 405.288879,657.059937 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M661.294617,665.082764 
	C661.314270,664.947327 661.606873,664.837158 662.007568,664.907593 
	C661.932922,665.094788 661.750305,665.101379 661.294617,665.082764 
z"
      />
      <path
        fill="#DFE5BC"
        opacity="1.000000"
        stroke="none"
        d="
M822.117493,326.875854 
	C821.938293,326.927094 821.735779,326.494110 821.842407,326.280884 
	C822.124451,326.212128 822.313416,326.344513 822.463013,326.512085 
	C822.490234,326.542542 822.356262,326.716797 822.117493,326.875854 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M821.221191,388.526428 
	C820.916687,388.939056 820.733582,388.998383 820.263489,389.024353 
	C820.175354,388.623199 820.374207,388.255402 820.821289,387.682739 
	C821.160522,387.709656 821.251587,387.941406 821.221191,388.526428 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M268.849121,209.680130 
	C268.854858,209.928879 268.679688,209.955765 268.241943,210.024094 
	C267.979431,210.065552 267.721527,209.665787 267.652069,209.438324 
	C267.944458,209.293320 268.306305,209.375793 268.849121,209.680130 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M759.272644,587.942871 
	C759.254639,587.744385 759.510498,587.440918 760.072937,587.074707 
	C760.101807,587.287292 759.824158,587.562683 759.272644,587.942871 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M758.259277,588.951904 
	C758.195984,588.752197 758.378540,588.467529 758.805054,588.092346 
	C758.867737,588.290222 758.686401,588.578613 758.259277,588.951904 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M757.297119,589.990234 
	C757.200745,589.738708 757.373413,589.452148 757.793335,589.090393 
	C757.882446,589.328552 757.724304,589.641846 757.297119,589.990234 
z"
      />
      <path
        fill="#DFE5BC"
        opacity="1.000000"
        stroke="none"
        d="
M822.310364,273.929138 
	C822.071106,273.837708 822.003967,273.664917 822.053589,273.239899 
	C822.330750,273.161377 822.512878,273.321350 822.637695,273.517670 
	C822.672607,273.572632 822.538818,273.734802 822.310364,273.929138 
z"
      />
      <path
        fill="#F9EDD2"
        opacity="1.000000"
        stroke="none"
        d="
M483.824615,278.038757 
	C483.369781,275.254578 486.078949,270.655121 479.047089,271.075500 
	C473.788605,270.771057 469.364349,270.556824 464.821747,269.958130 
	C464.530426,267.737640 464.357452,265.901520 464.421509,263.855072 
	C465.801910,262.154083 466.945251,260.663452 468.477661,259.007629 
	C469.387299,253.771484 469.847412,248.693329 470.449341,243.632034 
	C470.864899,240.137939 469.306519,238.804077 465.751770,238.868622 
	C464.019196,238.683289 462.516113,238.742813 460.634216,238.792694 
	C458.745789,237.875565 457.220856,236.992477 455.729950,236.055191 
	C453.171936,234.447083 450.635254,232.805130 447.779053,230.953140 
	C445.964813,230.548019 444.461090,230.367142 442.709778,229.860138 
	C440.195038,229.387161 437.784271,228.671478 435.687744,229.200699 
	C429.528931,230.755219 421.955719,228.805130 417.595154,236.054550 
	C416.528931,237.168839 415.768341,238.157745 414.558807,239.134033 
	C412.012360,239.164505 409.913116,239.167709 407.817749,239.259644 
	C404.331848,239.412613 402.241669,240.737732 403.311676,245.150879 
	C403.240295,247.835281 403.320099,250.059250 403.351410,252.610260 
	C403.709930,254.296906 404.116974,255.656479 404.627106,257.356842 
	C406.954651,260.017487 409.179077,262.337341 411.288086,265.102905 
	C410.531738,272.981415 409.890778,280.414215 409.016113,288.128967 
	C407.867950,288.667358 406.953461,288.923767 405.639832,289.136658 
	C404.098145,288.035095 402.513947,287.190643 401.882721,285.885376 
	C396.707611,275.183746 392.739502,263.920410 381.337250,257.389801 
	C375.252380,253.904678 370.274170,248.487396 364.886353,243.596359 
	C365.103210,242.548126 365.230164,241.845688 365.703918,241.134460 
	C369.363708,237.756287 372.676666,234.386887 376.231262,230.933960 
	C376.655151,230.569778 376.837433,230.289139 377.008484,230.006073 
	C376.997284,230.003647 377.013885,230.022110 377.348999,229.960297 
	C379.523071,227.965393 381.362061,226.032318 383.493591,224.055145 
	C384.222107,223.419205 384.658020,222.827362 385.401062,222.149323 
	C386.462646,221.375671 387.217102,220.688202 388.317566,219.955490 
	C390.452332,218.931702 392.241119,217.953156 394.462341,217.012283 
	C396.920502,216.998642 398.946259,216.947327 401.440491,216.940552 
	C417.608887,216.969299 433.308777,216.953476 449.422668,216.977509 
	C451.220551,216.978867 452.604462,216.940369 454.405396,216.951508 
	C456.219330,216.959305 457.616272,216.917496 459.473816,216.929321 
	C464.127411,216.982986 468.320343,216.982986 472.513306,216.982986 
	C472.056183,215.229858 471.291779,214.153625 470.693451,214.239151 
	C465.993378,214.911118 463.259186,212.411423 460.393738,209.096939 
	C456.719574,204.847015 453.117706,205.099884 448.977570,208.981796 
	C449.004272,208.993118 448.972046,208.944839 448.602539,209.021912 
	C446.427826,209.044830 444.622925,208.974869 442.817352,208.940445 
	C440.514618,208.896545 438.211334,208.881317 435.550537,208.839783 
	C434.701355,208.762482 433.939453,208.879776 433.758545,208.608963 
	C430.380310,203.551483 425.457031,202.399307 419.804016,202.841156 
	C419.002869,202.903778 418.154968,202.368591 417.140106,202.051056 
	C435.849915,182.221344 492.979126,156.228165 557.299377,161.102524 
	C598.083618,164.193268 634.965454,177.949753 667.537842,203.242935 
	C664.872009,203.888153 662.292175,203.976883 659.720520,203.868851 
	C655.023132,203.671509 650.777710,204.085785 648.201599,208.979218 
	C647.731262,209.872833 645.459717,209.903549 643.989990,210.168732 
	C640.486084,210.800980 636.976318,211.432632 633.444214,211.861053 
	C632.038330,212.031570 630.569214,211.630325 629.125488,211.549667 
	C626.206543,211.386673 622.937927,210.377487 620.452698,211.350296 
	C617.330994,212.572205 614.850098,215.431305 611.504761,218.042847 
	C614.336304,218.042847 617.182617,218.012100 620.028137,218.047684 
	C642.504822,218.328796 664.982849,218.550461 687.455811,219.014832 
	C689.923340,219.065826 692.948303,219.878326 694.709045,221.458344 
	C701.304077,227.376633 707.445923,233.797562 713.851440,239.932068 
	C714.882812,240.919769 716.391968,241.408524 717.754272,242.462433 
	C718.499695,243.608521 719.171143,244.420090 719.868652,245.581024 
	C719.664673,246.700623 719.677673,247.741043 719.167603,248.199890 
	C713.017273,253.732407 706.682190,259.063904 700.637756,264.707489 
	C698.383850,266.811920 696.579041,269.475525 694.895142,272.093628 
	C692.460022,275.879761 690.706055,280.160217 687.941833,283.661682 
	C685.459717,286.805939 682.006348,289.183472 678.595947,291.877686 
	C677.181946,291.810730 676.153442,291.765350 675.089111,291.406158 
	C674.994324,290.673889 674.935303,290.255432 674.903809,289.605133 
	C674.931396,289.373291 674.796814,288.926147 674.867493,288.503204 
	C674.089172,280.679260 673.240173,273.278229 672.598877,265.597656 
	C674.930847,263.296783 677.055115,261.275513 679.537842,259.072144 
	C680.359924,252.952026 680.823547,247.014038 681.358459,240.162766 
	C676.486755,240.162766 672.710938,240.162766 668.759399,239.870575 
	C665.383301,233.054947 659.663696,231.197586 652.684692,230.853821 
	C645.847595,231.138947 639.179688,231.190674 632.800842,232.574707 
	C630.480530,233.078171 628.849426,236.758209 626.550903,239.186737 
	C625.401672,239.590042 624.607300,239.966232 623.808777,239.975449 
	C611.681396,240.115479 614.063477,241.520325 614.225037,251.256683 
	C614.400696,252.401474 614.670349,253.212753 614.908691,254.427399 
	C615.532166,256.587097 616.186890,258.343445 617.057129,260.350586 
	C618.157532,262.093597 619.042419,263.585785 619.897400,265.471008 
	C619.718933,267.667603 619.570374,269.471130 618.996155,271.369080 
	C612.309692,271.463440 606.048889,271.463440 599.363037,271.463440 
	C599.363037,274.204102 599.684875,276.076843 599.249268,277.752716 
	C598.961243,278.860901 597.591675,280.501465 596.696533,280.507721 
	C590.401855,280.551758 584.104675,280.233032 577.763245,279.623901 
	C577.555054,276.790466 577.391846,274.363403 577.200684,271.519531 
	C569.933655,271.519531 562.997803,271.398529 556.075439,271.650757 
	C555.044250,271.688354 553.695862,273.317719 553.183350,274.507568 
	C552.630005,275.792084 552.885864,277.425232 552.334229,278.907471 
	C545.027039,278.894348 538.174377,278.880035 531.163940,278.462952 
	C530.845093,276.107208 530.683960,274.154175 530.442261,271.224365 
	C523.168396,271.224365 516.090271,271.224365 508.702942,271.090881 
	C507.581482,271.640747 506.769165,272.324097 505.864868,273.374878 
	C505.812653,274.492767 505.852356,275.243225 505.717316,276.371185 
	C504.371094,277.733887 503.254364,279.479431 502.018311,279.568512 
	C497.430359,279.899048 492.797119,279.813141 488.194061,279.599457 
	C486.716614,279.530853 485.279938,278.583862 483.824615,278.038757 
M503.000793,225.001419 
	C503.000793,225.001419 503.014862,224.977020 502.996765,225.735718 
	C503.985779,227.496780 504.974792,229.257828 506.181519,230.885239 
	C506.181519,230.885239 506.432861,230.839386 506.161957,231.580215 
	C506.483459,232.488434 506.808655,234.185638 507.125824,234.184143 
	C510.723328,234.167236 511.624237,237.237274 513.585022,239.225281 
	C515.587646,241.255676 518.837402,244.455109 520.541870,243.925674 
	C525.439880,242.404358 528.883362,243.388718 532.241760,246.781937 
	C532.864319,247.410965 534.037170,247.499908 534.960327,247.826035 
	C539.709839,249.503799 544.423523,251.296127 549.226318,252.804733 
	C551.776489,253.605774 554.569397,254.621567 557.101196,254.309830 
	C564.858337,253.354767 567.885193,255.025421 572.177856,261.573547 
	C574.422119,264.996979 578.227661,267.396912 582.205322,271.068878 
	C583.239380,267.997620 584.973694,265.278503 584.903198,262.607056 
	C584.678284,254.087784 583.782715,245.586212 584.001099,236.994873 
	C587.731262,237.623520 591.461426,238.252167 595.959290,239.010193 
	C599.203064,235.947205 599.163452,235.959778 597.644470,231.170380 
	C597.378601,230.332214 597.230286,229.073456 597.665039,228.462708 
	C599.562622,225.797180 600.643616,223.349091 597.746033,220.606857 
	C597.378662,220.259186 597.965149,218.893829 598.123230,218.002350 
	C599.003418,213.041458 597.320190,211.117081 592.393555,210.917419 
	C590.057617,210.822769 587.747009,210.103638 584.555969,209.504166 
	C586.900146,206.608459 588.504822,204.626312 590.036560,202.734146 
	C586.886780,198.714081 583.973633,194.995972 581.060425,191.277863 
	C580.885803,191.787857 580.711182,192.297852 580.536560,192.807861 
	C577.338806,193.061829 574.115356,193.151337 570.955322,193.646088 
	C569.580566,193.861313 568.195007,194.729324 567.064026,195.618454 
	C565.122131,197.145050 563.376038,198.920776 561.367249,200.756897 
	C560.591248,200.026733 559.543762,199.041153 558.781921,197.312195 
	C558.954651,194.086487 558.875671,190.822525 559.358582,187.643936 
	C560.096375,182.787979 558.054016,179.087433 552.230225,177.006851 
	C551.100586,177.122986 549.666260,176.836060 548.891602,177.421707 
	C544.394958,180.821304 540.137329,180.602646 535.986877,177.009979 
	C535.986877,177.009979 535.926331,177.099197 535.976868,176.247559 
	C535.478210,174.449066 535.559021,171.924149 534.377502,170.981796 
	C529.995117,167.486496 517.658569,170.788864 514.978027,175.979065 
	C514.978027,175.979065 514.826538,175.975098 514.144348,176.105759 
	C511.238525,180.391983 515.197998,181.035629 517.573181,182.172089 
	C521.287598,183.949356 523.232544,186.251907 520.992004,190.328461 
	C520.602722,191.036728 519.563538,191.836472 518.869202,191.797546 
	C518.222290,191.761307 517.487915,190.750992 517.051208,190.015549 
	C516.082642,188.384338 515.670227,186.197464 514.333191,185.051193 
	C509.636841,181.024918 503.885834,180.526627 498.020660,181.318024 
	C497.249542,181.422073 496.665924,182.915649 495.339874,183.986923 
	C494.883514,183.957794 494.427155,183.928665 493.892639,183.157700 
	C489.822723,181.220245 485.752808,179.282791 481.326294,177.175583 
	C481.203430,178.724380 481.114044,179.851166 480.940948,181.662689 
	C481.007874,182.109772 481.074829,182.556854 481.093750,183.639725 
	C481.135925,184.062668 481.178101,184.485626 480.610046,185.376266 
	C479.786377,188.436508 479.562744,191.295181 482.985382,192.947861 
	C482.985382,192.947861 483.119995,192.859421 483.029602,193.740570 
	C483.091888,197.150772 483.365051,200.076538 479.072418,202.101013 
	C477.007446,203.074905 476.635345,207.638275 475.496613,210.576172 
	C477.183624,211.149780 478.870605,211.723389 480.565521,212.425507 
	C480.565521,212.425507 480.673889,212.495087 480.358948,213.298370 
	C481.172791,213.854675 482.045197,214.957245 482.790863,214.877319 
	C487.145142,214.410492 490.642853,215.616821 493.838989,218.742630 
	C495.437988,220.306427 497.990143,220.895645 500.015137,221.973190 
	C500.015137,221.973190 500.078857,221.886993 500.012512,222.646896 
	C501.016571,223.426300 502.020630,224.205704 503.000793,225.001419 
M437.877930,203.257416 
	C439.745331,203.418549 441.612701,203.579681 443.480103,203.740814 
	C443.677002,203.167664 443.873932,202.594498 444.070862,202.021347 
	C441.452148,201.037079 438.864960,199.481171 436.200104,199.334290 
	C435.044556,199.270584 433.729065,202.109131 432.486206,203.629425 
	C432.863617,203.993439 433.240997,204.357468 433.618408,204.721481 
	C434.800323,204.311859 435.982239,203.902237 437.877930,203.257416 
z"
      />
      <path
        fill="#336054"
        opacity="1.000000"
        stroke="none"
        d="
M359.744751,208.914337 
	C373.099915,197.991592 385.852875,186.211365 399.933960,176.322220 
	C430.517365,154.843491 464.959167,141.955750 501.634064,135.818573 
	C533.590149,130.471054 565.663269,130.997696 597.247314,139.426895 
	C606.406494,141.871307 615.469604,144.675690 624.594238,147.872864 
	C619.888855,149.657303 615.166016,150.883957 609.988220,152.228745 
	C607.202698,149.337234 609.441345,147.463867 612.633484,145.986755 
	C606.163025,144.711182 600.074280,143.513153 593.986694,142.309082 
	C592.543152,142.023544 591.107605,141.696243 589.661377,141.425262 
	C585.706055,140.684097 581.709045,139.321320 577.808289,139.552277 
	C576.269470,139.643387 574.942078,143.304886 573.123962,145.904648 
	C578.630798,146.594299 583.288452,146.421906 587.401917,147.834412 
	C599.758118,152.077301 612.922729,153.622925 624.733337,159.792038 
	C632.181946,163.682739 640.471069,165.941147 648.026733,169.656616 
	C655.391479,173.278214 662.295166,177.835114 669.415894,181.956161 
	C673.261841,184.181961 677.264587,186.163223 680.968628,188.601151 
	C685.437073,191.542145 689.663757,194.850357 694.187988,198.269379 
	C702.294006,205.919067 710.466919,213.046097 718.008057,220.788452 
	C721.633301,224.510498 724.066101,229.394135 727.038879,233.751755 
	C726.879150,233.811310 726.719482,233.870850 726.091431,234.008316 
	C725.623108,234.086243 725.148376,234.032745 724.969727,233.737732 
	C721.390686,229.362686 718.245117,225.034241 714.548950,221.242477 
	C688.653381,194.677643 657.794922,175.653320 623.493835,162.014191 
	C597.743958,151.775269 570.952942,146.485916 543.239014,146.417969 
	C510.757507,146.338348 479.543884,152.927429 449.599426,165.413040 
	C443.847778,167.811234 438.444580,171.045212 432.941406,173.902527 
	C433.002197,173.911469 432.894348,173.852615 432.532715,173.874542 
	C427.358917,176.824203 422.546692,179.751923 417.713745,182.733154 
	C417.692993,182.786667 417.769531,182.701233 417.415833,182.721985 
	C411.634766,186.441040 406.207428,190.139343 400.804474,193.802719 
	C400.828888,193.767792 400.746643,193.745422 400.406860,193.791840 
	C393.681335,198.867432 387.295563,203.896606 380.959045,208.944916 
	C381.008301,208.964035 380.926270,208.897278 380.586792,208.942368 
	C376.465454,212.634613 372.683594,216.281769 368.944275,219.959198 
	C368.986816,219.989456 368.931488,219.900940 368.596069,219.960297 
	C364.804291,223.982681 361.347961,227.945694 357.574707,231.918335 
	C356.835114,231.927521 356.412415,231.927063 355.989716,231.926605 
	C355.701385,231.837173 355.442139,231.694778 355.130859,230.950562 
	C357.992340,226.507858 360.483246,222.138290 363.974884,218.822556 
	C370.557678,212.571442 377.659821,206.858536 384.655884,201.054291 
	C389.584656,196.965149 394.612305,192.983582 399.751434,189.163345 
	C403.529724,186.354675 407.717773,184.082031 411.383850,181.146667 
	C412.515381,180.240616 412.530243,177.939896 413.056396,176.277771 
	C411.283936,176.128952 409.118317,175.251862 407.808075,175.959244 
	C402.535675,178.805740 397.468018,182.050812 392.446075,185.334229 
	C389.760345,187.090210 387.321747,189.224258 383.809082,191.928787 
	C385.826447,192.714401 386.990692,193.167786 388.154907,193.621170 
	C387.859619,194.081100 387.564331,194.541016 387.269012,195.000946 
	C385.475220,195.000946 383.668457,194.868774 381.891693,195.042755 
	C380.472168,195.181747 378.793182,195.306412 377.743134,196.109329 
	C373.990326,198.978958 370.572510,202.289825 366.793976,205.121521 
	C364.682587,206.703827 362.109680,207.670349 359.744751,208.914337 
M420.008240,175.227280 
	C418.750244,175.595642 417.492218,175.963989 416.234222,176.332352 
	C416.558990,176.967957 416.883759,177.603577 417.208527,178.239182 
	C418.314667,177.386841 419.420837,176.534500 420.008240,175.227280 
z"
      />
      <path
        fill="#F1F0D4"
        opacity="1.000000"
        stroke="none"
        d="
M509.911011,392.011627 
	C509.911011,399.623291 509.911011,407.234924 509.911011,416.180389 
	C514.066528,415.644775 517.610535,415.118561 521.172791,414.791046 
	C521.836304,414.730042 522.573181,415.467163 523.681030,416.272278 
	C524.404602,416.527618 524.723328,416.346649 525.042053,416.165649 
	C525.453369,415.021271 525.864685,413.876923 526.762451,412.377258 
	C528.144470,412.022614 529.040039,412.023285 529.946533,412.385193 
	C530.088013,413.830597 530.218567,414.914703 530.349182,415.998840 
	C530.901062,415.981018 531.453003,415.963196 532.004883,415.945374 
	C532.004883,404.300781 532.004883,392.656189 532.325745,381.010925 
	C533.073486,381.020355 533.500427,381.030457 533.939697,381.500488 
	C533.958191,382.957703 533.999756,383.956268 533.964905,384.952118 
	C533.657654,393.723083 533.276794,402.492401 533.110962,411.265869 
	C533.093994,412.163147 534.341614,413.084290 535.262329,413.888733 
	C536.016479,413.519043 536.510681,413.254913 537.010620,413.318207 
	C537.675903,414.093658 538.335510,414.541718 539.254395,414.887939 
	C540.004333,414.525848 540.495056,414.265564 541.135254,414.168701 
	C541.541870,413.894440 541.799011,413.456787 542.381348,413.014465 
	C543.140991,413.002563 543.575378,412.995331 544.013794,413.309479 
	C544.233276,414.185394 544.448669,414.739899 544.664124,415.294403 
	C545.117249,414.198944 545.570435,413.103485 546.350098,412.006805 
	C547.112061,412.004547 547.547485,412.003479 547.994141,412.352173 
	C548.374512,413.284302 548.743652,413.866699 549.112732,414.449097 
	C549.409302,413.297760 549.705872,412.146454 550.302063,410.974182 
	C551.069397,410.627502 551.537170,410.301697 552.333130,409.984802 
	C553.098755,409.988037 553.536194,409.982391 554.281128,409.978149 
	C554.793579,409.976685 554.998535,409.973816 555.278198,410.180786 
	C555.685425,410.656311 556.018005,410.922058 556.350525,411.187805 
	C556.468384,412.263672 556.586304,413.339569 556.786255,415.082306 
	C557.640747,415.732300 558.413147,415.715424 559.185608,415.698578 
	C560.525696,415.921051 561.865784,416.143524 563.618896,416.809845 
	C564.729126,416.939301 565.426331,416.624908 566.123596,416.310547 
	C567.151489,415.944794 568.179382,415.579041 569.584839,415.613220 
	C570.723694,415.887665 571.484924,415.762207 572.246155,415.636749 
	C572.320374,413.981171 572.394592,412.325592 572.999023,410.317993 
	C574.030151,409.969971 574.531006,409.973999 575.031677,410.299622 
	C575.242554,411.175781 575.453552,411.730408 575.664551,412.285034 
	C576.107239,411.186523 576.549988,410.088043 577.246948,408.991821 
	C577.670654,408.993408 577.840088,408.992676 578.012451,409.426941 
	C578.168945,412.043274 578.322449,414.224701 578.475952,416.406097 
	C578.994629,416.367004 579.513306,416.327881 580.031982,416.288788 
	C580.031982,414.528198 580.031982,412.767639 580.356079,411.004944 
	C581.112305,411.003174 581.544434,411.003571 581.983826,411.314758 
	C582.259338,412.346191 582.527588,413.066803 582.976013,414.271271 
	C583.452209,412.724854 583.719971,411.855347 584.238403,410.990051 
	C584.656250,410.995209 584.823364,410.996246 584.994812,411.392761 
	C585.158386,413.034271 585.317627,414.280304 585.476929,415.526306 
	C585.922729,415.496918 586.368530,415.467499 586.814331,415.438110 
	C586.891846,413.959381 586.969299,412.480682 587.296936,410.891693 
	C588.027710,410.522369 588.508301,410.263306 588.992310,410.399048 
	C589.067749,412.256134 589.139832,413.718445 589.211975,415.180756 
	C589.617371,415.206512 590.022766,415.232269 590.428162,415.258057 
	C590.625854,413.839691 590.823547,412.421356 591.339722,411.004089 
	C592.082214,411.011932 592.506226,411.018707 592.943176,411.369202 
	C593.099304,412.468964 593.242371,413.225037 593.385498,413.981140 
	C593.570251,413.956757 593.754944,413.932373 593.939697,413.907990 
	C593.981750,412.947021 594.023865,411.986084 594.386780,411.018677 
	C595.135925,411.007782 595.564331,411.003418 595.995850,411.377014 
	C596.110229,412.910431 596.221375,414.065857 596.332520,415.221313 
	C596.700317,415.246948 597.068176,415.272583 597.435974,415.298218 
	C597.628906,413.533081 597.821777,411.767975 598.339355,410.003296 
	C599.096375,410.006622 599.528870,410.009491 599.967773,410.389160 
	C600.043152,411.855225 600.112183,412.944519 600.181213,414.033783 
	C600.772156,414.024384 601.363159,414.014954 601.954163,414.005554 
	C601.954163,405.674774 601.954163,397.344025 602.205750,389.013977 
	C602.792175,389.024445 603.127014,389.034180 603.577454,389.495941 
	C603.868774,396.966095 604.044495,403.984222 604.113647,411.368225 
	C604.550293,416.239044 607.352051,418.015137 611.620667,418.271332 
	C613.338257,418.374420 615.027527,418.949982 616.729675,419.310486 
	C616.729675,419.310486 616.925903,419.079224 616.915894,419.452881 
	C617.927979,419.870270 618.950195,419.913971 619.972351,419.957703 
	C624.311401,420.676178 628.650452,421.394623 632.762939,422.652161 
	C628.203003,424.402771 623.869751,425.614319 619.575867,426.814850 
	C620.436829,427.973511 621.241699,429.056641 621.651733,430.140594 
	C618.894897,430.386658 616.532837,430.631897 614.119141,430.470581 
	C612.928345,429.042725 611.773621,427.150726 610.652832,427.170593 
	C607.797241,427.221161 604.952759,428.108307 602.123718,428.748596 
	C602.004578,428.775513 602.084961,429.684326 601.667603,430.143433 
	C600.179321,430.110870 599.095825,430.117188 597.872070,429.776001 
	C595.715820,428.305176 593.808533,426.868988 591.661377,426.123444 
	C587.161987,424.561279 584.416382,428.384705 580.655029,430.035156 
	C579.902405,429.986481 579.471680,429.969330 579.036011,429.551819 
	C577.718262,423.687408 573.343262,426.728943 570.338318,426.281219 
	C569.792114,426.199829 568.853149,428.754211 567.670288,430.081604 
	C565.827454,430.057343 564.409851,430.043274 562.991089,429.670166 
	C562.320496,428.570831 561.651123,427.830536 560.559448,427.075165 
	C557.836426,427.346191 555.535706,427.632233 552.946106,428.222900 
	C550.299011,428.316101 547.940796,428.104675 545.604980,427.523254 
	C542.254883,425.784698 538.891602,424.531525 535.587524,427.975647 
	C534.863220,428.451996 534.451294,428.883270 533.687744,429.301147 
	C531.942444,429.473328 530.548767,429.658875 529.096252,429.518311 
	C528.928040,428.761505 528.818787,428.330841 528.715027,427.517273 
	C525.531494,427.215302 522.173950,426.689911 519.192566,427.518158 
	C514.629700,428.785736 510.326111,430.986633 505.912506,432.791351 
	C505.597198,432.444366 505.281891,432.097382 504.966583,431.750427 
	C507.046082,430.323151 509.125580,428.895844 511.205048,427.468567 
	C510.846283,426.944794 510.487488,426.421021 510.128693,425.897217 
	C506.416290,427.338684 502.703857,428.780121 498.746826,429.997986 
	C498.502228,428.610565 498.502228,427.446716 498.502228,424.845856 
	C496.390961,426.543976 495.187164,427.512177 493.628754,428.597748 
	C492.542267,428.852112 491.810394,428.989136 490.644470,429.084595 
	C487.106140,429.000366 484.001862,428.957672 481.146301,428.684143 
	C482.791626,427.627411 484.188263,426.801483 485.584869,425.975555 
	C485.350403,425.466614 485.115967,424.957703 484.881500,424.448761 
	C481.599060,425.625122 478.316620,426.801453 474.641754,427.965393 
	C471.428680,427.290405 468.608032,426.627899 465.908020,425.669189 
	C464.010773,424.950806 461.992950,424.528564 459.824982,423.816895 
	C459.063416,423.340424 458.451935,423.153412 457.840485,422.966370 
	C461.136841,420.518646 464.278412,418.751007 468.967712,419.597137 
	C471.609070,420.073761 474.783844,417.593994 478.365112,416.171387 
	C479.617645,414.716736 480.223389,413.536682 481.035248,411.955109 
	C481.779846,413.393433 482.272369,414.344849 482.764893,415.296234 
	C483.179047,415.213806 483.593201,415.131348 484.007355,415.048920 
	C484.007355,411.702118 484.007355,408.355286 484.268250,405.005798 
	C484.703033,405.002533 484.876984,405.001984 485.045410,405.414764 
	C485.466553,408.520203 485.893188,411.212311 486.319824,413.904419 
	C486.551056,413.875885 486.782288,413.847382 487.013519,413.818848 
	C487.013519,412.547516 487.013519,411.276215 487.338928,410.004456 
	C488.097961,410.007172 488.531555,410.010315 488.971741,410.391296 
	C489.046753,411.851898 489.115204,412.934631 489.183685,414.017365 
	C489.787048,414.006378 490.390442,413.995361 490.993835,413.984344 
	C490.993835,406.989960 490.993835,399.995605 491.251892,393.002075 
	C491.681976,393.003021 491.853973,393.003082 492.020782,393.471130 
	C492.022980,399.946747 492.030365,405.954376 492.049622,412.281372 
	C492.433258,413.236877 492.805054,413.873016 493.686462,415.381165 
	C493.849762,413.564209 493.920013,412.782745 493.992676,411.749725 
	C493.998444,411.330475 494.001801,411.162811 494.336060,410.996948 
	C495.108124,410.997955 495.549225,410.997131 495.996246,411.377136 
	C496.254456,412.670990 496.506805,413.584045 496.759125,414.497070 
	C497.175903,414.438324 497.592682,414.379578 498.009460,414.320831 
	C498.009460,407.216217 498.009460,400.111603 498.333588,393.005981 
	C499.089325,393.010864 499.520905,393.016815 499.956848,393.489868 
	C499.961182,400.561859 499.961182,407.166718 499.961182,413.771545 
	C500.192352,413.762878 500.423492,413.754211 500.654663,413.745544 
	C501.095398,404.159851 501.536133,394.574127 502.310852,384.992126 
	C503.089264,385.001312 503.533722,385.006805 503.983185,385.461456 
	C503.678040,389.030518 503.256531,392.144440 503.089691,395.272003 
	C502.930420,398.258240 502.926727,401.263397 503.056976,404.251404 
	C503.183746,407.160675 503.567017,410.058746 503.837677,412.961731 
	C504.223083,412.931061 504.608490,412.900421 504.993896,412.869751 
	C504.993896,411.907471 504.993896,410.945190 505.347168,410.013550 
	C506.468933,409.279999 507.854187,408.552002 507.901398,407.745636 
	C508.132050,403.806976 507.848602,399.837738 508.092987,395.900757 
	C508.175507,394.571869 509.275818,393.306183 509.911011,392.011627 
z"
      />
      <path
        fill="#F0E5CF"
        opacity="1.000000"
        stroke="none"
        d="
M528.958435,698.127869 
	C510.735229,688.591919 497.689240,675.343689 497.932190,653.201111 
	C498.198273,628.950195 519.788818,609.950256 544.243347,612.073181 
	C566.797424,614.031067 583.870605,636.727722 579.868225,660.147949 
	C576.357971,680.687988 561.002441,695.674072 541.144470,702.020691 
	C538.408020,702.895264 534.645142,700.558228 531.354248,699.153198 
	C531.976074,698.596863 532.651672,698.436951 533.218384,698.617859 
	C540.860107,701.057068 547.149170,698.924988 552.367065,693.056458 
	C552.799744,692.569824 553.186951,691.810852 553.718689,691.679993 
	C558.874390,690.411438 562.572632,686.997437 565.508118,682.970154 
	C568.910889,678.301758 571.541870,673.078735 574.786804,668.285339 
	C578.103760,663.385559 576.201660,658.697937 574.958374,653.617920 
	C574.096375,650.816284 573.363525,648.102356 571.860535,645.918457 
	C571.366516,645.200623 568.644958,645.397095 567.380188,646.038940 
	C566.487366,646.492004 565.968628,648.392517 565.940247,649.661438 
	C565.903564,651.303589 566.521423,652.960327 566.857483,654.610840 
	C566.238953,654.787048 565.620483,654.963318 565.002014,655.139587 
	C564.043152,651.752563 563.084229,648.365540 562.240723,644.737976 
	C562.623657,644.043457 562.891235,643.589478 563.466675,642.956177 
	C569.427002,637.415466 567.255615,630.437622 559.594727,627.939697 
	C555.255676,627.563843 552.669373,629.771057 551.761047,633.157043 
	C551.409119,634.468994 553.469971,636.428101 554.669861,638.504578 
	C553.819702,640.115784 552.666443,642.301331 551.253906,644.689941 
	C550.358826,646.258850 549.723083,647.624878 548.786743,649.023438 
	C548.285156,649.039612 548.084229,649.023132 547.586487,648.844788 
	C545.885010,647.951538 544.470459,646.585327 543.077393,646.606934 
	C538.766846,646.673706 534.464539,647.268982 529.939026,647.354614 
	C527.805237,643.662048 525.891357,640.273926 524.351929,636.902893 
	C525.363342,635.186584 527.020935,632.778137 526.417175,631.865234 
	C525.287231,630.156555 522.846558,629.314636 520.749268,627.837585 
	C518.490417,628.470337 516.433472,629.377747 514.061523,630.473755 
	C513.316956,632.338989 512.177551,634.224487 512.597351,635.651245 
	C513.649963,639.229065 515.408386,642.599304 516.900879,646.452087 
	C516.547546,648.841675 516.177063,650.831970 515.449341,652.783203 
	C514.197754,650.462708 513.303467,648.181152 512.312134,645.651978 
	C506.678528,644.531677 505.131409,645.903687 504.268280,653.826660 
	C505.748383,653.752991 507.140686,653.683594 508.697815,653.750183 
	C508.862640,653.886108 509.192078,654.158203 509.229950,654.489990 
	C510.717255,659.703979 513.369629,657.393188 516.156616,656.152710 
	C516.567078,657.534302 516.701477,658.690979 516.557251,659.904907 
	C515.900757,659.993652 515.522888,660.025085 514.751770,660.040771 
	C513.275208,660.856567 512.191772,661.688171 511.108337,662.519775 
	C512.013123,662.695068 512.917969,662.870361 513.847900,663.457642 
	C513.896118,665.241882 513.919250,666.614014 513.794556,668.257996 
	C513.538879,669.353638 513.430969,670.177490 512.940552,671.037598 
	C512.061218,672.081482 511.564362,673.089050 511.051453,674.052368 
	C511.035400,674.008057 511.112274,674.062500 510.749451,674.099976 
	C506.572662,676.835449 511.939392,678.469299 511.160767,680.815491 
	C512.142944,680.857910 513.125122,680.900330 514.405273,681.046997 
	C516.821045,681.189514 518.938843,681.227600 521.029785,681.606079 
	C518.883789,686.218872 520.213074,690.083252 524.204041,692.900146 
	C526.082825,694.226196 527.391479,696.360046 528.958435,698.127869 
M536.928833,635.927734 
	C536.928833,635.927734 537.284241,636.276672 537.315430,637.049072 
	C536.611267,639.220764 535.907104,641.392395 535.178955,643.638062 
	C539.121582,643.638062 542.864014,643.638062 546.757629,643.638062 
	C545.948425,640.828552 545.282715,638.516907 544.273621,635.013306 
	C546.761230,637.027283 548.233643,638.219360 550.274719,639.871765 
	C549.644287,634.847229 549.297241,630.430298 548.401184,626.127808 
	C548.183533,625.082336 546.227966,623.844727 544.950256,623.688782 
	C542.240479,623.358154 539.160278,624.451599 536.765381,623.547791 
	C533.538696,622.330139 532.071045,623.823242 531.546021,626.042542 
	C530.470459,630.589417 530.047363,635.290649 529.264587,640.538757 
	C532.034058,638.658386 534.307373,637.114929 536.928833,635.927734 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M430.984680,470.022461 
	C429.576691,470.317108 428.168732,470.611755 426.377441,470.525909 
	C425.994141,468.226135 425.994141,466.306885 425.994141,464.387634 
	C425.399353,464.228485 424.804535,464.069336 424.209747,463.910187 
	C423.784729,464.967102 422.952820,466.046570 423.009888,467.076782 
	C423.191437,470.354492 423.703918,473.613831 424.088562,476.880249 
	C422.297974,477.234497 420.507416,477.588715 418.349121,477.484253 
	C418.321014,473.303864 418.944244,469.579956 418.915985,465.861023 
	C418.890503,462.503601 417.100433,461.093933 413.467773,463.036255 
	C412.398804,463.405029 411.664948,463.783081 410.616730,464.126404 
	C409.881714,464.114594 409.461029,464.137543 409.000671,463.811493 
	C407.869110,461.857849 406.777252,460.253265 405.067902,457.741241 
	C404.260986,461.743439 403.629395,464.875977 402.663513,467.961609 
	C401.341675,467.506317 400.354156,467.097931 398.911957,466.501526 
	C399.220520,470.351654 399.490295,473.717926 399.760071,477.084198 
	C398.404663,476.719879 397.049286,476.355530 395.310455,475.546387 
	C394.926392,472.643799 395.334198,470.088531 394.779083,467.763092 
	C394.419647,466.257141 392.652832,465.087158 391.516632,463.766632 
	C391.216949,464.112152 390.917236,464.457703 390.617523,464.803223 
	C390.729797,466.899506 390.842041,468.995789 390.954285,471.092072 
	C389.558258,470.727051 388.162231,470.362000 386.385315,469.610077 
	C386.013062,468.395508 385.749084,467.436951 386.073669,466.760925 
	C388.599396,461.500305 385.529724,461.482452 381.539368,461.785095 
	C381.800537,458.252197 382.151764,455.010437 378.345581,453.354492 
	C378.189697,453.286713 377.509430,454.424194 376.823059,455.086914 
	C375.343475,455.460938 374.114349,455.748169 372.885223,456.035370 
	C372.094482,458.852264 371.303741,461.669189 369.948669,464.446930 
	C369.267548,461.993774 369.468231,459.502197 368.904724,457.197388 
	C368.607788,455.982880 366.976868,455.094482 365.948242,454.058838 
	C364.361145,451.839783 363.248383,448.744598 361.091980,447.577118 
	C356.005402,444.823151 355.445007,440.187866 355.236115,435.596588 
	C354.868774,427.521912 355.133453,419.417847 355.190491,411.326508 
	C355.193146,410.948547 355.749939,410.574524 356.640564,410.272583 
	C357.337555,410.502655 357.442719,410.658752 357.365387,411.267395 
	C357.097717,418.844360 356.985504,425.968689 356.955322,433.093353 
	C356.950592,434.210480 357.243286,436.282471 357.525452,436.304749 
	C362.044983,436.661560 360.590973,440.668610 361.678467,444.341400 
	C362.666626,441.025940 363.277710,438.975677 363.888763,436.925446 
	C364.279236,436.935059 364.669708,436.944672 365.060150,436.954285 
	C365.503632,438.712158 365.947083,440.470001 366.474365,442.560059 
	C367.115051,440.524170 367.664307,438.778839 368.506775,436.101776 
	C369.702271,437.956543 370.322784,438.919281 370.268341,438.834778 
	C373.366272,438.077698 375.759674,437.492798 378.446106,436.836273 
	C378.942291,439.336029 379.349335,441.386780 379.756378,443.437500 
	C380.837402,441.797821 380.602325,440.198975 381.131592,438.915222 
	C381.483795,438.060760 382.926910,437.656036 383.862976,437.450562 
	C383.844177,439.317841 383.844177,440.784607 383.844177,442.251373 
	C384.174683,442.241791 384.505188,442.232208 384.835693,442.222626 
	C385.271912,440.504456 385.708130,438.786255 386.420227,437.122437 
	C387.066223,437.236786 387.436310,437.296692 387.824066,437.758179 
	C388.018707,440.012878 388.195679,441.866028 388.372650,443.719177 
	C388.742828,443.716675 389.113007,443.714203 389.483215,443.711700 
	C389.907471,441.669800 390.331726,439.627899 390.755981,437.585968 
	C391.179718,437.558289 391.603455,437.530609 392.027161,437.502899 
	C392.504242,439.742615 392.981323,441.982330 393.659271,445.165131 
	C393.947601,442.425323 394.140076,440.596619 394.332520,438.767914 
	C394.702515,438.670013 395.072479,438.572083 395.442444,438.474182 
	C396.560303,440.661713 397.678162,442.849213 398.740265,444.927582 
	C398.952271,443.222595 399.190674,441.305420 399.429047,439.388245 
	C399.833130,439.369324 400.237183,439.350403 400.641235,439.331482 
	C401.272888,441.601257 401.904510,443.871033 402.566315,446.249237 
	C402.998932,444.491974 403.399017,442.866882 403.799103,441.241821 
	C404.171631,441.210907 404.544189,441.180023 404.916718,441.149139 
	C405.738800,443.164917 406.560913,445.180664 407.177002,446.691345 
	C407.974731,445.287964 408.855103,443.739227 409.753754,442.175385 
	C409.772034,442.160278 409.818512,442.157776 409.877747,442.533325 
	C410.510620,445.104279 411.084198,447.299652 411.689545,449.616547 
	C412.322083,447.758240 412.904480,446.047211 413.702911,444.400055 
	C414.215820,444.499451 414.512390,444.537415 414.826019,444.896851 
	C415.394196,445.985352 415.790802,447.194519 416.521545,447.450775 
	C420.370514,448.800446 424.382355,449.707153 428.177765,451.179779 
	C430.379028,452.033905 432.190613,454.522369 434.335876,454.744232 
	C437.604523,455.082275 438.757660,456.444092 438.843018,459.344452 
	C438.964844,463.483765 439.038727,467.624542 439.082031,472.149902 
	C438.990295,473.052643 438.949646,473.570160 438.908966,474.087708 
	C437.535706,473.730804 436.162476,473.373901 434.406311,472.602905 
	C434.164948,469.336426 434.306458,466.484070 434.447937,463.631714 
	C433.887512,463.557709 433.327087,463.483734 432.766663,463.409760 
	C432.172668,465.613983 431.578674,467.818237 430.984680,470.022461 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M723.216309,448.400543 
	C725.355774,453.469971 722.679993,457.463867 720.097839,461.321411 
	C714.105469,470.273621 707.858032,479.055511 701.907410,488.034637 
	C700.812683,489.686584 700.179260,491.926392 700.107971,493.922577 
	C699.876526,500.402405 699.598083,506.927185 700.106628,513.374023 
	C700.643066,520.175354 696.073608,523.631897 691.901550,527.226440 
	C690.704285,528.257935 687.779419,527.748352 685.788025,527.307373 
	C679.795776,525.980408 673.873108,524.338928 667.549438,522.400635 
	C668.004028,520.356873 668.832520,518.732483 669.817444,516.801453 
	C672.404236,520.347839 672.404236,520.347839 674.215515,518.855286 
	C674.930298,517.827271 675.442261,517.007141 676.298279,516.098694 
	C684.098328,510.039581 690.272705,503.375854 689.855347,492.860901 
	C689.778320,490.919647 690.576416,488.957855 690.648315,486.993713 
	C690.823181,482.217682 690.808594,477.434723 690.886230,472.264496 
	C691.091370,470.865448 691.280579,469.856415 691.376038,468.511841 
	C697.318970,464.491974 703.405334,460.885834 709.375183,457.096130 
	C713.374634,454.557251 717.208740,451.757965 721.389771,449.025696 
	C722.180603,448.784302 722.698425,448.592407 723.216309,448.400543 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M601.231384,604.620728 
	C600.578796,601.373474 602.058533,599.593201 605.132935,598.825012 
	C606.252197,598.545288 607.364441,598.164368 608.411743,597.681641 
	C616.676697,593.872009 616.869141,594.071350 617.105408,603.316345 
	C617.154053,605.217773 618.459473,607.086975 619.545654,609.402100 
	C619.605530,613.406250 619.112366,616.975830 619.046570,620.553223 
	C618.921204,627.375244 619.546082,627.786255 626.233459,628.084534 
	C627.852722,628.156677 629.422363,629.341919 630.686279,630.211121 
	C629.945068,631.097229 629.340637,631.738464 629.149780,632.485291 
	C627.570984,638.664490 632.467285,644.119568 638.655579,646.724670 
	C641.596558,647.962708 644.439514,649.433289 647.326904,650.798523 
	C644.905701,650.674561 642.484558,650.550598 639.211304,650.383057 
	C639.500977,651.666687 639.879089,652.847351 640.013733,654.055115 
	C640.217285,655.880615 641.007080,658.351807 640.147888,659.388306 
	C639.257446,660.462524 636.612793,660.638733 634.891174,660.332336 
	C632.545227,659.914917 630.346863,658.668030 628.464722,657.374573 
	C631.232544,657.150757 633.620667,657.411255 636.009338,657.415833 
	C636.352844,657.416504 636.698792,656.184265 637.068237,655.125610 
	C632.661316,644.609741 624.496460,641.350525 612.733276,645.119751 
	C612.567749,646.506592 612.236755,648.682556 613.011047,649.197815 
	C617.207092,651.990723 621.676453,654.373047 626.051575,656.896851 
	C623.971863,659.962585 622.544495,664.135132 619.659912,665.835510 
	C615.297546,668.407227 609.978271,669.485413 604.955505,670.766663 
	C600.834229,671.817993 596.570251,672.410706 592.332520,672.850037 
	C590.834839,673.005371 587.910095,674.321960 588.928589,670.421387 
	C600.476624,669.700012 610.914795,667.188232 620.661560,661.953613 
	C619.028381,661.313782 617.579468,661.505249 616.148254,661.786377 
	C607.426025,663.500000 598.707825,665.233948 589.988281,666.961060 
	C589.762695,663.938171 591.785950,664.057556 593.912903,663.969727 
	C598.117310,663.796204 602.313293,663.420654 606.512756,663.128601 
	C606.633728,662.433838 606.754761,661.739014 606.875793,661.044250 
	C604.627258,660.361694 602.416626,659.291565 600.123169,659.067139 
	C592.330200,658.304443 586.709656,651.417969 588.098694,643.795837 
	C588.274109,642.833008 589.316956,642.028259 590.518555,641.141296 
	C591.079285,641.132324 591.484558,641.114685 591.454346,641.353271 
	C591.444092,641.911011 591.480774,642.228333 591.354919,642.894470 
	C589.025146,648.229858 591.960815,652.073486 595.309326,654.287903 
	C598.280701,656.252930 602.671631,656.071289 606.435974,656.837219 
	C606.584656,655.564880 606.733276,654.292542 606.826050,652.650024 
	C604.945129,644.003784 602.729553,642.108521 592.808472,640.324219 
	C592.094055,640.089966 591.574219,640.034607 591.054321,639.979187 
	C590.701111,638.584839 590.347961,637.190430 590.444824,635.411865 
	C592.888733,635.004089 595.085327,635.507507 596.830200,634.836426 
	C599.613892,633.765991 603.912842,635.328247 605.089355,630.456177 
	C607.375671,627.894104 610.657532,625.869141 611.291321,623.212463 
	C613.291992,614.826355 614.300537,606.203674 615.692932,597.672546 
	C615.220154,597.435303 614.747314,597.198059 614.274536,596.960876 
	C609.926819,599.514160 605.579102,602.067444 601.231384,604.620728 
M622.279541,631.546936 
	C616.774109,633.622070 611.268616,635.697144 605.227234,637.974304 
	C605.531616,640.119873 607.662415,640.708191 610.304199,639.663818 
	C614.003967,638.201233 617.612183,636.477844 621.146118,634.647217 
	C621.930237,634.241089 622.241455,632.921875 622.279541,631.546936 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M362.008331,387.973785 
	C361.752563,387.481049 361.496796,386.988281 361.039734,386.008423 
	C360.567078,385.337433 360.295776,385.153564 360.024445,384.969666 
	C360.024445,384.969666 360.017670,384.995453 360.003845,384.666260 
	C359.375458,383.536041 358.760925,382.735016 358.146362,381.933990 
	C358.064606,381.507202 357.982819,381.080383 357.827484,380.065796 
	C357.680695,379.304626 357.607452,379.131287 357.534241,378.957977 
	C357.583344,378.540955 357.632416,378.123932 357.741699,377.005310 
	C357.580963,374.520905 357.360046,372.738129 357.141052,370.627075 
	C357.108795,369.862396 357.074585,369.426025 357.040405,368.989624 
	C357.063446,368.550507 357.086487,368.111420 357.121948,366.930237 
	C357.143372,364.810608 357.152435,363.433044 357.395477,361.750732 
	C357.641022,359.619415 357.652557,357.792816 357.748169,355.507446 
	C357.550507,344.038422 357.268768,333.028168 356.987030,322.017914 
	C356.987030,322.017914 357.075775,321.594757 357.429443,321.378387 
	C361.809753,323.821533 365.836426,326.481049 369.863098,329.140564 
	C369.863098,329.140564 369.987274,329.086090 370.007263,329.503265 
	C370.690399,335.152710 371.498779,340.371948 371.970978,345.621399 
	C372.351898,349.855682 372.326996,354.126526 372.147125,358.331299 
	C369.155090,355.526825 366.498108,352.772125 363.146790,349.297607 
	C363.381104,356.029999 364.361389,360.979980 368.830353,365.139832 
	C374.269897,370.203125 379.072845,375.950317 384.135254,381.826782 
	C383.979095,384.266510 386.933838,386.972931 382.537506,387.909546 
	C379.758820,384.063934 377.255341,380.406433 374.751831,376.748932 
	C374.104889,377.021057 373.457947,377.293213 372.811005,377.565338 
	C374.546234,383.701538 376.281464,389.837738 378.016693,395.973938 
	C378.007690,396.729523 377.998657,397.485138 377.542725,398.606903 
	C374.081360,398.629272 371.066833,398.285492 368.052338,397.941711 
	C368.052338,397.941681 367.746307,397.813568 367.481842,397.464600 
	C365.880219,395.276581 364.543030,393.437561 363.205872,391.598511 
	C363.205872,391.598511 363.267670,391.286957 363.203918,390.795959 
	C362.762878,389.527893 362.385620,388.750854 362.008331,387.973785 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M758.993652,160.874542 
	C759.324402,161.086868 759.655090,161.299194 759.977600,162.100800 
	C758.644592,164.128433 757.319824,165.566757 755.994446,166.670532 
	C755.995056,165.890045 755.996338,165.444138 756.206238,164.866486 
	C756.400391,164.374924 756.385803,164.015091 756.371216,163.655243 
	C756.248352,164.104431 756.125427,164.553619 755.693970,165.037323 
	C755.051147,165.484726 754.716736,165.897598 754.382324,166.310486 
	C754.923157,166.538727 755.464050,166.766968 756.004639,167.352219 
	C756.147095,169.978989 756.289917,172.248764 756.432739,174.518555 
	C755.800537,174.669693 755.168335,174.820847 754.536133,174.971985 
	C753.355408,173.312759 752.174683,171.653534 751.282715,169.956848 
	C751.881592,169.520630 752.191772,169.121887 752.501892,168.723129 
	C752.242004,168.634079 751.782043,168.425903 751.753174,168.474442 
	C751.463440,168.960846 751.244568,169.489426 750.680786,170.051483 
	C749.558899,172.410477 748.762024,174.724136 747.642456,177.051910 
	C746.889038,177.084610 746.458252,177.103241 745.878418,176.878754 
	C745.314941,176.649323 744.900513,176.663010 744.486084,176.676712 
	C744.989929,177.118408 745.493713,177.560120 745.996155,178.376282 
	C745.987305,179.499405 745.979858,180.248062 745.673462,181.033676 
	C745.312927,181.740265 745.251404,182.409912 745.183777,183.313446 
	C745.177673,183.547348 745.180481,184.015289 744.784302,184.012878 
	C743.595703,184.003128 742.803345,183.995789 741.966553,183.669083 
	C741.282227,182.899048 740.642334,182.448395 739.966309,181.712860 
	C739.623840,181.104797 739.317505,180.781616 739.011108,180.458435 
	C738.828796,180.668884 738.646484,180.879333 738.464172,181.089752 
	C738.975281,181.393967 739.486450,181.698196 740.037598,182.323212 
	C740.714294,183.099701 741.351074,183.555405 741.985474,184.356201 
	C741.165100,185.252945 740.417664,186.031235 739.515381,186.312042 
	C737.177063,187.039749 736.614685,188.204926 737.982788,190.362793 
	C739.142456,192.222977 740.396667,193.645630 741.420105,195.218369 
	C742.394470,196.715439 743.128052,198.369232 743.625183,200.014954 
	C741.760742,200.784409 740.238586,201.493027 739.714966,201.736771 
	C737.701233,205.128830 736.037415,207.931427 734.239441,210.959961 
	C737.690552,214.889069 741.249817,218.941330 744.809021,222.993622 
	C743.439880,224.739517 742.070740,226.485413 740.262146,227.910217 
	C738.999939,226.843979 738.177124,226.098785 737.329468,225.235016 
	C737.304565,225.116455 737.083618,225.016876 736.984253,224.688904 
	C729.736206,217.006058 722.587524,209.651169 715.438843,202.296295 
	C715.811768,199.720367 716.184692,197.144424 716.554504,194.590195 
	C719.083801,194.796860 721.641724,195.005859 723.980042,195.196930 
	C723.720215,192.957962 722.902527,190.274094 723.466736,189.942673 
	C725.052856,189.010895 727.208069,189.047836 729.486572,188.640625 
	C728.271667,184.232819 730.811646,183.212082 736.399414,185.354538 
	C734.891968,183.312500 734.183167,182.352341 733.462402,181.375977 
	C741.959717,173.734879 727.640869,167.880829 732.939270,160.097260 
	C739.730530,158.099518 736.891113,166.285889 740.075439,168.827286 
	C742.364868,168.060699 744.789185,167.248917 747.581116,166.314056 
	C747.214905,165.301971 746.805115,164.169632 746.395386,163.037308 
	C746.705383,163.150009 747.015381,163.262711 747.325439,163.375412 
	C748.061829,161.363281 748.605408,159.247986 749.605957,157.377090 
	C750.221802,156.225540 751.395020,155.036179 752.580322,154.630951 
	C753.533813,154.304977 755.326416,154.765106 755.952637,155.528137 
	C756.975830,156.774872 757.352905,158.551834 758.077759,160.704742 
	C758.433167,161.161087 758.713379,161.017807 758.993652,160.874542 
M731.391296,193.201675 
	C731.786133,193.206009 732.181030,193.210358 732.575806,193.214691 
	C732.577209,193.050858 732.589661,192.744659 732.578430,192.743790 
	C732.185547,192.713287 731.790466,192.711563 731.391296,193.201675 
M749.389465,164.202286 
	C749.785034,164.206451 750.180664,164.210617 750.576233,164.214783 
	C750.577759,164.050613 750.590210,163.743759 750.579163,163.742920 
	C750.185547,163.712570 749.789673,163.710876 749.389465,164.202286 
M735.626404,196.473511 
	C735.839905,196.528229 736.053406,196.582947 736.266907,196.637680 
	C736.129639,196.503143 735.992432,196.368607 735.626404,196.473511 
M745.481201,172.379227 
	C745.535461,172.163956 745.589661,171.948669 745.643921,171.733414 
	C745.510010,171.871460 745.376099,172.009491 745.481201,172.379227 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M363.036896,407.968994 
	C363.462616,408.083496 363.888306,408.198029 364.859619,408.381500 
	C365.568542,408.404938 365.731873,408.359406 365.895233,408.313873 
	C382.583588,410.207642 399.284363,411.999603 415.955109,414.037506 
	C424.514099,415.083771 433.019409,416.569031 441.548950,417.855927 
	C441.579163,418.271057 441.609344,418.686188 441.639557,419.101288 
	C438.435822,419.999451 435.140289,420.659851 432.050568,421.853149 
	C427.733734,423.520325 422.167847,425.192352 422.330780,430.541443 
	C422.482819,435.531555 427.928619,437.044952 432.142761,438.474060 
	C442.696747,442.053131 453.430511,445.126709 463.881042,448.976135 
	C469.227814,450.945557 474.121399,454.145264 479.219818,456.788971 
	C479.137909,457.282227 479.056000,457.775452 478.974091,458.268707 
	C477.879669,458.712952 476.785217,459.157227 475.579895,459.647003 
	C475.468994,459.692535 475.310822,459.264252 475.215027,458.957703 
	C474.329529,458.081635 473.619263,457.288177 472.738403,456.975739 
	C456.527863,451.226013 440.296906,445.533783 423.824036,439.583038 
	C421.859344,438.453735 420.215332,437.354065 418.406982,436.732941 
	C414.646362,435.441193 410.798676,434.402954 406.544922,433.177734 
	C403.407349,433.104156 400.711609,433.113373 397.678101,433.064056 
	C396.887207,433.051392 396.434082,433.097229 395.616577,433.059540 
	C394.508453,433.009125 393.764648,433.042206 392.937256,432.821106 
	C398.168945,431.409790 403.569519,430.538940 408.768188,428.990204 
	C411.978943,428.033752 414.882263,426.045105 417.923584,424.519867 
	C417.655579,423.807892 417.387543,423.095917 417.119537,422.383942 
	C409.680756,423.380524 402.241974,424.377106 394.638794,425.395691 
	C398.083649,423.097198 401.253784,420.982025 404.423920,418.866821 
	C404.186249,418.333313 403.948608,417.799805 403.710938,417.266296 
	C389.152191,415.006104 374.593475,412.745911 360.030609,410.189514 
	C360.021942,409.301056 360.017395,408.708862 360.012878,408.116638 
	C360.449127,408.088593 360.885406,408.060547 361.905060,408.070679 
	C362.671295,408.062195 362.854095,408.015564 363.036896,407.968994 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M463.984528,614.991760 
	C463.049194,608.999573 462.046661,603.016418 461.236847,597.007324 
	C461.080139,595.844482 461.676331,594.580139 461.925201,593.362671 
	C462.905121,593.653748 463.885071,593.944824 464.918304,594.644653 
	C464.971588,595.053406 464.913849,595.160095 464.589508,595.178589 
	C464.175751,596.152771 464.086304,597.108582 464.107239,598.344116 
	C464.345245,599.003479 464.472900,599.383118 464.464508,600.111206 
	C464.569061,601.653748 464.809631,602.847778 465.059082,604.488770 
	C465.388580,611.971619 465.368866,619.088684 469.961548,625.449463 
	C472.685974,627.682678 475.331238,629.591125 478.090271,631.827698 
	C481.138123,632.791565 484.072266,633.427307 487.006378,634.063110 
	C487.668610,635.782166 488.330841,637.501282 488.768005,639.645996 
	C488.207092,640.373047 487.871277,640.674377 487.272278,640.608521 
	C478.299927,638.606689 473.410614,642.488831 471.324524,652.989258 
	C471.166962,654.563416 471.158630,655.724792 471.150269,656.886230 
	C470.058014,655.532043 468.965790,654.177856 467.594177,652.477356 
	C463.698853,653.827576 459.229218,655.535461 454.654572,656.888306 
	C452.694641,657.467957 450.516235,657.308777 448.454956,656.923462 
	C451.806366,655.461121 455.358246,655.013550 458.415253,653.539612 
	C461.834198,651.891113 466.957672,651.688782 466.990112,645.648315 
	C466.320312,644.684692 465.594757,644.067505 464.542297,643.314392 
	C457.040100,642.020020 450.239410,642.039856 445.400269,649.235229 
	C444.027771,650.923950 442.924408,652.452637 441.544739,654.121887 
	C440.858582,655.168823 440.448761,656.075317 440.038940,656.981812 
	C436.830170,656.204102 437.828156,654.277222 439.021851,652.615417 
	C440.131622,651.070435 441.588470,649.774780 443.648163,647.554810 
	C441.202576,647.215088 439.714142,647.008301 438.097015,646.474609 
	C440.146118,643.582703 445.472198,645.011047 446.120331,639.990234 
	C448.286560,638.506226 451.754791,636.656677 451.524353,635.679199 
	C450.945770,633.225525 448.694580,631.166138 446.893768,628.739502 
	C445.948181,628.222778 445.222992,627.915222 444.228699,627.421143 
	C443.142639,626.935242 442.325714,626.635803 441.402893,626.157715 
	C441.093079,625.778198 440.961639,625.537781 441.001221,624.963440 
	C441.008728,624.093384 441.127350,623.309937 440.794373,622.973633 
	C437.086029,619.227539 433.586060,615.525452 433.678070,609.622375 
	C433.757721,604.510559 433.168091,599.391663 433.040527,594.271790 
	C432.982239,591.930725 432.566650,590.595581 429.682312,591.722839 
	C428.550446,588.247253 427.675842,585.038940 426.837524,581.619263 
	C426.873779,581.407776 427.056396,581.019531 427.056396,581.019531 
	C434.172028,578.511902 438.882080,583.120239 443.674072,586.915100 
	C449.275177,591.350769 455.516510,595.412842 456.682861,603.655029 
	C456.172546,604.061279 455.969666,604.081848 455.530640,603.871216 
	C450.203766,593.498962 441.374939,587.641479 431.351807,581.910583 
	C432.828705,585.896057 433.949707,588.921143 434.987305,592.414856 
	C435.047485,600.732849 433.551910,608.795471 437.962463,616.356567 
	C438.296692,616.786133 438.591217,616.954102 439.020172,617.312195 
	C439.335175,617.761902 439.563263,617.969360 439.916199,618.450195 
	C441.989716,620.205017 443.985931,621.634216 446.049469,623.411011 
	C446.910950,624.067505 447.705109,624.376404 448.638885,624.661255 
	C448.778503,624.637329 449.020111,624.785217 449.169556,625.065674 
	C449.711517,625.460693 450.103973,625.575256 450.775208,625.640747 
	C451.609802,625.644775 452.165619,625.697815 453.115631,625.832092 
	C455.325317,624.929199 457.140808,623.945007 459.003998,623.312988 
	C460.663910,626.917542 462.276123,630.169983 463.536621,633.314819 
	C460.760559,632.259644 458.336212,631.312073 455.911865,630.364563 
	C455.677551,630.967468 455.443207,631.570374 455.208862,632.173340 
	C459.116425,634.111206 463.142029,635.847412 466.897461,638.045288 
	C470.449982,640.124451 472.496033,638.939453 473.884583,636.587402 
	C471.115753,635.809814 468.491028,635.072693 466.067841,634.020752 
	C468.085114,633.521973 469.900818,633.338074 472.855621,633.038879 
	C467.872833,628.333191 464.627777,623.293518 463.995758,616.667358 
	C463.994965,615.885437 463.989746,615.438599 463.984528,614.991760 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M458.156586,311.130402 
	C449.968842,314.066742 441.841766,314.983856 433.662445,310.933685 
	C427.408295,307.836792 421.028046,304.994476 414.078522,301.782623 
	C412.030945,301.063599 410.608734,300.600891 408.951782,299.869751 
	C407.857788,297.978699 406.998566,296.355988 406.098297,294.428467 
	C405.890533,293.749847 405.723755,293.376068 405.642029,292.583984 
	C405.793823,291.597565 405.860565,291.029449 406.391541,290.546448 
	C423.898041,290.746460 440.940308,290.861359 458.024048,291.444733 
	C458.095886,298.318909 458.126251,304.724670 458.156586,311.130402 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M542.056152,413.019104 
	C541.799011,413.456787 541.541870,413.894440 541.142944,413.699402 
	C541.001099,388.938263 541.001099,364.809845 541.001099,340.681396 
	C540.332458,340.680695 539.663757,340.679962 538.995117,340.679260 
	C538.995117,365.449432 538.995117,390.219604 538.995117,414.989777 
	C538.335510,414.541718 537.675903,414.093658 537.015503,412.850647 
	C537.014771,388.603760 537.014771,365.151794 537.014771,341.699829 
	C536.757629,341.698212 536.500427,341.696594 536.243286,341.694977 
	C535.829712,365.794739 535.416077,389.894531 535.002441,413.994324 
	C534.341614,413.084290 533.093994,412.163147 533.110962,411.265869 
	C533.276794,402.492401 533.657654,393.723083 533.964905,384.952118 
	C533.999756,383.956268 533.958191,382.957703 533.963379,381.027710 
	C533.974609,367.283661 533.974609,354.472290 533.974609,341.660950 
	C533.318909,341.674835 532.663208,341.688721 532.007507,341.702637 
	C532.007507,343.303558 532.008301,344.904510 532.007324,346.505463 
	C532.001953,355.294098 531.994629,364.082764 531.991394,372.871399 
	C531.990356,375.584808 532.000061,378.298187 532.004883,381.011597 
	C532.004883,392.656189 532.004883,404.300781 532.004883,415.945374 
	C531.453003,415.963196 530.901062,415.981018 530.349182,415.998840 
	C530.218567,414.914703 530.088013,413.830597 529.967773,411.914185 
	C530.265503,388.659454 530.567749,366.237091 530.760742,343.813812 
	C530.765930,343.212891 529.587463,342.601776 528.960938,341.995422 
	C529.107849,340.713776 529.254700,339.432098 529.770020,337.783783 
	C530.707947,337.676544 531.297791,338.197174 531.843872,338.154755 
	C536.982300,337.755524 542.170898,337.575836 547.221008,336.653625 
	C549.593018,336.220428 551.694214,334.304230 553.918152,333.060120 
	C554.137817,334.106598 554.357544,335.153076 554.399414,336.656036 
	C554.120667,338.088501 554.019897,339.064514 553.502625,340.028229 
	C549.193298,339.749756 550.016846,342.605408 550.014404,344.782532 
	C549.989685,366.853363 550.001160,388.924255 550.002441,410.995117 
	C549.705872,412.146454 549.409302,413.297760 549.112732,414.449097 
	C548.743652,413.866699 548.374512,413.284302 548.003540,411.883301 
	C548.001770,387.944397 548.001770,364.824066 548.001770,341.703766 
	C547.673950,341.699371 547.346191,341.695007 547.018372,341.690643 
	C546.686768,365.129761 546.355164,388.568909 546.023560,412.008026 
	C545.570435,413.103485 545.117249,414.198944 544.664124,415.294403 
	C544.448669,414.739899 544.233276,414.185394 544.017517,412.842133 
	C544.017151,388.281525 544.017151,364.509613 544.017151,340.737732 
	C543.455078,341.830780 543.027344,343.030579 543.009155,344.236542 
	C542.662598,367.163635 542.364380,390.091461 542.056152,413.019104 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M472.971375,413.021057 
	C471.619141,416.417572 469.313477,415.175262 467.456421,413.859070 
	C465.087921,412.180389 463.040314,411.906525 460.703552,413.770752 
	C459.990051,414.339935 458.865967,414.899475 458.050812,414.759430 
	C447.834229,413.004883 437.580719,411.384399 427.474854,409.114319 
	C424.321625,408.406036 420.749634,406.505493 418.807404,404.024811 
	C412.529358,396.006165 406.952026,387.441254 401.040497,379.132477 
	C397.798187,374.575287 394.488800,370.062073 391.071167,365.635956 
	C390.188965,364.493439 388.881561,363.130890 387.603668,362.931396 
	C379.368591,361.645905 380.084503,354.917755 379.028564,349.275177 
	C378.695496,347.495239 378.466736,345.661682 378.485870,343.855804 
	C378.567139,336.176239 377.021698,328.850403 374.067932,321.346771 
	C374.151703,320.874817 374.340851,320.716339 374.592896,320.906616 
	C375.924530,322.343292 377.004120,323.589752 378.220917,325.145416 
	C378.929047,326.630219 379.500000,327.805817 380.005859,329.425140 
	C380.255920,332.929474 380.571075,335.990051 380.888702,339.461182 
	C380.989899,341.234741 381.088562,342.597748 381.128021,344.381470 
	C381.511139,348.072601 382.069489,351.332428 382.366516,354.615936 
	C382.742706,358.774597 384.835602,360.874237 389.368164,360.879150 
	C390.840485,361.636169 391.989044,362.298981 393.231659,363.274963 
	C394.848785,365.415405 396.371857,367.242615 397.931976,369.074615 
	C397.969025,369.079407 397.901733,369.111938 397.942078,369.433777 
	C398.948425,370.902924 399.914398,372.050293 400.919983,373.475098 
	C401.288361,374.179596 401.617188,374.606628 401.987946,375.383698 
	C403.958038,378.252594 405.886169,380.771484 407.844543,383.638336 
	C410.196899,387.019287 412.519073,390.052216 414.880005,393.444580 
	C416.621857,396.384949 418.545197,398.849945 419.978302,401.572998 
	C422.331085,406.043579 426.157562,407.688843 430.858276,408.080963 
	C436.927399,408.587219 442.992981,409.135590 449.463593,409.742981 
	C451.235077,409.913086 452.603088,410.005981 454.242981,410.343079 
	C456.555695,410.928345 458.596527,411.269440 461.801270,411.805023 
	C460.084259,408.636322 458.899353,406.372833 457.645325,404.148315 
	C451.784027,393.751007 442.868225,385.080414 440.034973,372.603210 
	C439.988770,371.491882 439.937103,370.751709 439.911377,369.756226 
	C439.886993,369.337433 439.836700,369.173950 439.793030,368.677185 
	C439.262421,366.900543 438.725098,365.457214 438.187256,363.590790 
	C437.637665,360.751068 436.773590,358.354218 436.620361,355.912781 
	C436.434875,352.956726 436.850616,349.962921 437.144470,347.307556 
	C438.867554,350.926971 440.471252,354.215332 442.033905,357.523102 
	C449.984802,374.352966 457.987122,391.159027 465.814819,408.046021 
	C467.321411,411.296326 469.351929,413.132721 472.971375,413.021057 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M529.105469,698.386841 
	C527.391479,696.360046 526.082825,694.226196 524.204041,692.900146 
	C520.213074,690.083252 518.883789,686.218872 521.038940,681.496033 
	C521.074890,681.045532 520.964172,680.854431 521.353210,680.960693 
	C533.833374,681.698792 545.923889,682.341370 558.015869,682.955933 
	C561.750854,683.145752 564.158264,681.260010 565.678101,677.623169 
	C565.678650,676.907227 565.577942,676.495056 565.725830,675.791870 
	C565.637756,674.645691 565.301086,673.790527 564.963074,672.483643 
	C564.452026,667.260376 566.164185,662.018555 561.991455,657.547363 
	C562.003967,656.438721 562.021545,655.803833 562.294922,655.445312 
	C566.030823,659.122070 568.420776,658.072815 569.851074,653.912048 
	C571.624268,653.912048 573.205994,653.912048 574.787720,653.912048 
	C576.201660,658.697937 578.103760,663.385559 574.786804,668.285339 
	C571.541870,673.078735 568.910889,678.301758 565.508118,682.970154 
	C562.572632,686.997437 558.874390,690.411438 553.718689,691.679993 
	C553.186951,691.810852 552.799744,692.569824 552.367065,693.056458 
	C547.149170,698.924988 540.860107,701.057068 533.218384,698.617859 
	C532.651672,698.436951 531.976074,698.596863 531.139648,698.879700 
	C530.369690,698.989319 529.811096,698.817505 529.105469,698.386841 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M644.087585,516.847107 
	C631.747437,513.852173 619.407227,510.857239 607.281128,507.212433 
	C619.988586,502.063751 632.482056,497.564911 645.370605,493.048248 
	C647.864807,492.020050 651.011658,491.560028 651.881531,489.903961 
	C655.617126,482.792236 658.683105,475.328796 662.343506,467.813354 
	C666.591309,466.986755 670.488770,466.340393 674.273438,466.048889 
	C671.684509,468.728729 668.511047,470.645325 666.864563,473.456360 
	C662.196899,481.425354 658.153809,489.760193 653.578491,498.129639 
	C650.224060,504.487885 647.155823,510.667511 644.087585,516.847107 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M699.616516,368.056763 
	C699.737000,366.786163 699.392029,364.785553 700.053711,364.363708 
	C704.257080,361.683594 703.775879,357.430328 704.437561,353.407043 
	C705.425537,347.400269 706.537231,341.375244 708.226196,335.540344 
	C708.957520,333.013855 711.136597,330.843323 712.875916,328.686798 
	C715.374146,325.589355 718.071594,322.652527 720.351440,320.029694 
	C725.212158,321.025970 726.927429,323.700836 726.877258,326.985748 
	C726.738831,336.044739 727.144165,345.289612 725.401428,354.077637 
	C724.410706,359.073486 719.553223,363.268311 716.576904,367.913452 
	C712.982300,373.523346 708.926392,378.949280 706.175903,384.960754 
	C702.553101,392.878754 700.010986,401.290833 696.985291,409.483429 
	C696.816101,409.941528 696.250183,410.336395 696.251038,410.759918 
	C696.255066,412.794159 696.390503,414.828186 696.479248,416.862274 
	C697.677368,415.402405 698.839966,413.911377 700.084656,412.492310 
	C701.120178,411.311768 702.252075,410.215637 703.683716,409.426331 
	C702.727417,412.555328 701.428528,415.340027 700.098816,418.190948 
	C709.668701,420.647064 711.068787,420.063110 714.852112,412.372345 
	C716.465820,409.091858 718.589539,405.972534 719.638977,402.523621 
	C721.613831,396.033356 722.977173,389.356964 724.594727,382.757935 
	C724.060364,382.551239 723.525940,382.344513 722.991577,382.137787 
	C719.261475,384.995056 714.892456,386.666656 713.075012,392.175568 
	C711.418213,397.197632 707.879211,401.598755 705.169861,406.273590 
	C705.919861,403.636261 706.468750,400.919647 707.469421,398.381134 
	C708.801086,395.003143 710.058960,391.462097 712.128174,388.543884 
	C714.539612,385.142944 717.509277,381.978180 720.782593,379.405365 
	C722.888062,377.750427 727.260986,381.186890 726.736572,384.055237 
	C725.113342,392.934052 723.668152,401.896545 718.833496,409.816772 
	C718.256226,410.762543 718.063049,411.975922 717.831360,413.094147 
	C716.115967,421.372314 710.733032,423.273560 702.759888,421.208649 
	C697.406250,419.822083 692.912598,417.878235 687.295410,421.517029 
	C684.837524,423.109161 679.938721,421.213348 676.223145,420.507385 
	C672.267700,419.755737 668.400879,418.537964 664.253906,416.969238 
	C664.012634,416.245270 664.012878,416.075714 664.281372,415.863190 
	C664.908630,415.771332 665.267517,415.722473 666.045593,415.836212 
	C673.542969,416.708191 680.611633,417.608215 687.707581,417.963348 
	C689.097412,418.032867 691.268921,416.302643 691.925232,414.872589 
	C695.176025,407.789246 698.079956,400.544708 701.028320,393.325195 
	C704.007812,386.029449 706.628845,378.572845 709.933289,371.430206 
	C711.679749,367.655151 714.546814,364.398529 717.080933,360.622040 
	C722.868164,356.230164 725.216614,350.788147 724.044556,343.427429 
	C724.104126,336.339203 724.104126,329.705231 724.104126,322.432404 
	C708.216858,331.158478 708.251892,345.477875 707.303345,359.740509 
	C704.642822,362.712494 702.129639,365.384644 699.616516,368.056763 
z"
      />
      <path
        fill="#30655D"
        opacity="1.000000"
        stroke="none"
        d="
M359.439880,209.031342 
	C362.109680,207.670349 364.682587,206.703827 366.793976,205.121521 
	C370.572510,202.289825 373.990326,198.978958 377.743134,196.109329 
	C378.793182,195.306412 380.472168,195.181747 381.891693,195.042755 
	C383.668457,194.868774 385.475220,195.000946 387.269012,195.000946 
	C387.564331,194.541016 387.859619,194.081100 388.154907,193.621170 
	C386.990692,193.167786 385.826447,192.714401 383.809082,191.928787 
	C387.321747,189.224258 389.760345,187.090210 392.446075,185.334229 
	C397.468018,182.050812 402.535675,178.805740 407.808075,175.959244 
	C409.118317,175.251862 411.283936,176.128952 413.056396,176.277771 
	C412.530243,177.939896 412.515381,180.240616 411.383850,181.146667 
	C407.717773,184.082031 403.529724,186.354675 399.751434,189.163345 
	C394.612305,192.983582 389.584656,196.965149 384.655884,201.054291 
	C377.659821,206.858536 370.557678,212.571442 363.974884,218.822556 
	C360.483246,222.138290 357.992340,226.507858 354.999756,230.770203 
	C351.377808,229.593079 347.805786,228.047455 344.089233,226.176331 
	C349.008148,220.283340 354.071594,214.715836 359.439880,209.031342 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M497.014923,572.061890 
	C493.529510,576.904846 489.452026,578.199646 484.274689,576.300171 
	C483.510254,576.019714 482.466797,576.499756 481.296143,576.417114 
	C480.015961,574.498474 478.992065,572.790588 477.584381,571.005310 
	C472.828094,568.212402 467.137482,568.165100 463.645721,571.076477 
	C463.061127,571.563904 463.309753,573.050598 463.104523,574.370605 
	C463.346222,575.152832 463.656769,575.640015 464.103699,576.402588 
	C465.143433,577.462341 466.046753,578.246521 466.950073,579.030762 
	C461.647888,579.462463 459.533813,576.746277 460.603180,570.660767 
	C460.140167,570.331665 459.613831,569.632202 459.090149,569.634216 
	C451.465942,569.663025 451.517212,563.498352 450.463226,558.599304 
	C449.795990,555.497864 451.903900,554.339661 454.822693,555.559692 
	C450.985107,559.383789 453.138641,562.335388 456.222717,563.196533 
	C459.809082,564.197876 463.889374,563.430054 468.321381,563.430054 
	C466.714844,557.257874 462.201752,557.113281 458.946625,555.320190 
	C460.384705,555.033936 461.822815,554.747620 464.441376,554.226379 
	C463.174561,552.807007 462.388031,551.105530 461.205383,550.760071 
	C458.109833,549.855896 454.830627,549.598633 451.645233,548.977722 
	C449.313019,548.523071 447.013519,547.900635 444.195129,546.864868 
	C442.827026,544.874878 441.963226,543.373108 441.437836,541.949951 
	C444.162384,543.679626 446.361816,546.290100 448.970459,546.797791 
	C456.158020,548.196411 471.595398,541.119812 473.969604,532.667114 
	C474.000244,532.449768 474.120667,532.027710 474.318726,531.891663 
	C474.778015,531.544800 474.939453,531.274414 475.125000,530.845093 
	C475.248840,530.745728 475.563385,530.702271 475.879547,530.906738 
	C478.047424,536.247009 481.952087,538.242615 487.154877,538.539795 
	C491.660767,538.797180 497.533630,535.822205 499.270447,532.096191 
	C499.688995,531.958557 499.873932,531.971985 500.058899,531.985352 
	C501.371124,533.035217 502.683350,534.085083 503.828369,535.803467 
	C502.811646,537.247620 501.962189,538.023254 500.793823,538.837036 
	C496.598602,539.188416 499.350342,541.847595 498.469788,543.289917 
	C494.287994,542.683777 490.292786,542.781006 486.798798,541.505371 
	C477.804993,538.221741 471.341278,541.798401 465.350800,548.421326 
	C465.649200,550.113403 465.749756,552.220093 466.777832,552.878418 
	C470.334747,555.156433 474.214478,556.930176 478.115051,559.212280 
	C478.884827,560.738708 479.510925,561.948792 480.178406,563.388794 
	C480.420563,563.912903 480.695007,564.022217 481.053894,564.165222 
	C481.064667,564.383789 481.117554,564.818176 481.067902,565.180420 
	C481.017944,566.029602 481.017639,566.516602 481.204590,567.287720 
	C483.722565,569.318604 486.053253,571.065308 488.383942,572.812073 
	C488.044495,573.096008 487.705078,573.380005 487.365631,573.663940 
	C490.582062,573.129944 493.798492,572.595886 497.014923,572.061890 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M473.275208,412.933197 
	C469.351929,413.132721 467.321411,411.296326 465.814819,408.046021 
	C457.987122,391.159027 449.984802,374.352966 442.033905,357.523102 
	C440.471252,354.215332 438.867554,350.926971 437.025055,346.972473 
	C435.499725,342.871765 434.232117,339.428192 433.395630,335.960205 
	C436.830566,336.287201 439.834320,336.638672 443.165161,337.148132 
	C448.947021,350.503235 454.299805,363.743683 459.887299,376.884369 
	C464.749054,388.318237 469.875946,399.639404 474.885681,411.010345 
	C474.450134,411.622009 474.014587,412.233673 473.275208,412.933197 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M442.838074,336.990112 
	C439.834320,336.638672 436.830566,336.287201 433.104645,335.810303 
	C429.244812,332.795288 426.107117,329.905731 422.892883,326.688171 
	C415.765656,319.339569 408.622406,312.408417 401.713379,305.251190 
	C399.213776,302.661743 396.706024,299.799225 395.194153,296.593384 
	C391.594879,288.961334 388.587341,281.050201 385.763428,273.190430 
	C390.712189,272.190857 391.592773,276.034851 393.284149,278.662964 
	C396.865417,284.227783 400.291992,289.892334 403.894928,295.442688 
	C404.008728,295.618011 405.363220,294.987915 406.139313,294.733307 
	C406.998566,296.355988 407.857788,297.978699 409.039001,300.181976 
	C411.844147,303.354034 414.327393,305.945496 416.810608,308.536957 
	C416.810608,308.536957 416.926849,308.895844 417.213867,309.251556 
	C419.260040,311.157745 421.019165,312.708221 422.778290,314.258698 
	C422.778290,314.258698 422.928741,314.069000 422.961639,314.457794 
	C426.411469,318.079834 429.828400,321.313080 433.245361,324.546326 
	C433.245361,324.546326 433.381439,324.621674 433.535950,324.975677 
	C435.527466,327.073334 437.364502,328.816956 439.201538,330.560577 
	C439.201538,330.560577 439.343109,330.647797 439.470398,331.021729 
	C440.677856,333.260468 441.757965,335.125275 442.838074,336.990112 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M490.993835,393.001221 
	C490.993835,399.995605 490.993835,406.989960 490.993835,413.984344 
	C490.390442,413.995361 489.787048,414.006378 489.183685,414.017365 
	C489.115204,412.934631 489.046753,411.851898 488.985046,409.921265 
	C488.991821,386.794037 488.991821,364.514740 488.991821,342.235413 
	C488.332397,342.235626 487.672943,342.235840 487.013519,342.236053 
	C487.013519,364.825653 487.013519,387.415283 487.013519,410.004883 
	C487.013519,411.276215 487.013519,412.547516 487.013519,413.818848 
	C486.782288,413.847382 486.551056,413.875885 486.319824,413.904419 
	C485.893188,411.212311 485.466553,408.520203 485.330200,405.113159 
	C485.746277,403.585175 485.980896,402.772217 485.981812,401.959015 
	C486.003693,382.975525 486.003937,363.992004 485.985077,345.008514 
	C485.984467,344.401520 485.740143,343.794800 485.609436,343.187958 
	C485.075409,343.214111 484.541382,343.240234 484.007355,343.266388 
	C484.007355,363.847076 484.007355,384.427795 484.007355,405.008484 
	C484.007355,408.355286 484.007355,411.702118 484.007355,415.048920 
	C483.593201,415.131348 483.179047,415.213806 482.764893,415.296234 
	C482.272369,414.344849 481.779846,413.393433 481.035248,411.955109 
	C480.223389,413.536682 479.617645,414.716736 478.686096,415.962524 
	C478.651978,399.815094 478.700714,383.592438 479.329407,367.392303 
	C479.687134,358.173615 480.992523,348.991760 482.387573,339.474731 
	C485.612915,339.454865 488.321869,339.753540 491.029724,340.515411 
	C491.017029,358.319489 491.005432,375.660339 490.993835,393.001221 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M745.081482,222.815735 
	C741.249817,218.941330 737.690552,214.889069 734.239441,210.959961 
	C736.037415,207.931427 737.701233,205.128830 739.714966,201.736771 
	C740.238586,201.493027 741.760742,200.784409 744.000793,200.042694 
	C746.746643,198.744034 748.774658,197.478470 750.912720,196.370987 
	C751.224976,196.495346 751.427124,196.461624 751.629211,196.427887 
	C751.469727,196.240463 751.310303,196.053055 751.118164,195.526672 
	C752.190613,194.406998 753.295715,193.626312 754.901001,192.492294 
	C753.811401,191.955643 752.648315,191.382782 751.457153,190.514374 
	C751.435181,189.823563 751.441284,189.428299 751.663330,188.851151 
	C752.970520,188.669250 754.061768,188.669250 755.500549,188.669250 
	C755.073853,186.729843 754.662842,184.862030 754.395996,182.740204 
	C756.723572,183.722412 758.906982,184.958664 760.743652,185.998581 
	C762.575378,185.798187 764.234314,185.616714 765.266235,185.503815 
	C764.079834,183.247620 761.444763,180.561768 761.864380,178.496521 
	C762.515137,175.293671 765.248047,172.513840 767.098267,169.554688 
	C767.470337,169.693848 767.842346,169.832977 768.506226,170.029404 
	C770.596436,172.311569 772.394775,174.536438 773.879089,177.281586 
	C769.786377,179.848419 774.617249,181.217010 773.985962,183.009247 
	C773.996216,183.001968 774.008057,182.981171 773.648071,182.959351 
	C771.822876,184.430725 770.437256,186.013794 768.874512,187.396790 
	C766.313477,189.663208 763.637451,191.799606 761.040283,193.719482 
	C760.950195,193.177414 760.829773,192.906769 760.709351,192.636124 
	C760.531799,192.774323 760.354248,192.912506 760.176758,193.050690 
	C760.448975,193.368729 760.721191,193.686783 760.956909,194.348373 
	C759.449768,195.885696 757.979187,197.079453 756.138916,198.573288 
	C755.869629,199.170776 755.075623,200.437653 754.780212,201.811768 
	C754.646912,202.431992 755.506653,203.265717 755.915894,204.002563 
	C756.056458,204.462006 756.196960,204.921463 756.116699,205.687500 
	C752.368469,207.906921 752.135742,208.408035 754.036743,209.996536 
	C751.142456,214.210297 748.248230,218.424072 745.081482,222.815735 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M513.860229,351.068695 
	C512.892029,346.615448 511.923859,342.162170 511.310120,336.999878 
	C511.330688,328.527496 510.760925,320.764587 510.747528,313.000732 
	C510.738892,307.985443 511.545166,302.968719 512.444824,298.016632 
	C516.599670,298.053894 520.296021,298.027130 524.291138,298.277802 
	C524.612488,302.000244 524.635010,305.445251 524.354980,309.001709 
	C524.055054,310.411530 524.057678,311.709930 524.048340,313.417267 
	C523.910156,315.179077 523.784058,316.531952 523.372192,317.976837 
	C523.041626,319.042938 522.996765,320.016998 522.916992,321.389862 
	C522.166504,325.826782 521.450867,329.864929 520.403564,334.008240 
	C517.179810,337.320374 515.679565,340.793854 517.979675,345.322205 
	C517.935669,346.080322 517.899719,346.512817 517.526794,347.031616 
	C516.079956,348.434845 514.970093,349.751770 513.860229,351.068695 
M512.505310,338.442047 
	C512.505310,338.442047 512.504395,338.500488 512.505310,338.442047 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M537.507385,542.843262 
	C537.362305,542.444885 537.217163,542.046448 537.017090,540.973389 
	C535.305786,537.191467 533.649475,534.084229 532.352539,531.012756 
	C534.556335,532.011658 536.400696,532.974670 539.046814,534.356384 
	C538.525208,532.746765 538.517944,532.136292 538.211426,531.868591 
	C534.806763,528.895752 531.355774,525.975952 528.191284,522.845703 
	C528.652405,521.800720 528.839539,520.951782 529.271667,520.072510 
	C529.516663,520.042053 530.006897,519.982971 530.298523,520.034668 
	C531.051636,520.411865 531.513123,520.737305 531.982666,521.397827 
	C533.031799,522.126831 534.072876,522.520813 535.420715,522.924988 
	C536.134399,522.978516 536.541321,523.021851 536.981934,523.353394 
	C537.347351,524.086304 537.679138,524.531067 538.062439,525.328735 
	C540.728271,526.785828 543.342651,527.890015 546.276489,529.117004 
	C549.356934,531.232971 552.117798,533.226196 555.029785,535.485962 
	C555.443115,536.505676 555.705261,537.258789 555.599487,538.006226 
	C551.154236,535.897827 547.076904,533.795227 542.999573,531.692566 
	C545.603882,538.065491 548.884888,543.397644 552.167480,548.728882 
	C553.043945,550.152405 553.925476,551.572937 554.852417,553.416138 
	C554.347961,557.615356 553.795837,561.393311 553.193237,565.469849 
	C553.049255,566.161133 552.955811,566.553894 552.518005,566.951660 
	C551.092285,565.966858 550.010803,564.976990 548.935669,563.567139 
	C549.001099,561.748779 549.060181,560.350464 549.390869,558.692139 
	C549.779663,556.614990 549.896790,554.797729 550.012512,552.576172 
	C549.603882,550.529846 549.196655,548.887878 548.789429,547.245850 
	C548.127197,547.434143 547.464905,547.622437 546.802673,547.810730 
	C547.191284,549.542908 547.579956,551.275146 547.974121,553.432739 
	C547.985901,555.555664 547.992126,557.253174 547.952515,559.303040 
	C546.987000,561.362854 546.026794,563.049988 545.155029,564.781616 
	C541.903259,571.240662 537.342041,576.477783 530.881104,579.787292 
	C529.816589,578.650024 528.880005,577.807983 528.130249,576.705933 
	C529.564209,575.300415 530.811218,574.155029 532.357056,572.860229 
	C538.706482,567.858398 541.572632,561.048035 542.607605,553.816833 
	C543.113281,550.283875 543.634644,545.418640 538.755859,542.955444 
	C538.171997,542.903076 537.839661,542.873169 537.507385,542.843262 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M577.808289,280.030243 
	C584.104675,280.233032 590.401855,280.551758 596.696533,280.507721 
	C597.591675,280.501465 598.961243,278.860901 599.249268,277.752716 
	C599.684875,276.076843 599.363037,274.204102 599.363037,271.463440 
	C606.048889,271.463440 612.309692,271.463440 619.284790,271.380188 
	C620.669434,271.550354 621.339905,271.803772 622.035645,272.432983 
	C622.309021,282.999756 623.295471,293.239502 622.625671,303.369751 
	C621.703613,317.314423 619.714722,331.202484 617.760071,345.055145 
	C617.276733,348.480560 615.163208,351.675934 613.585449,354.703735 
	C614.775085,344.287323 616.640503,334.180481 617.439819,323.990021 
	C618.115967,315.369324 617.557495,306.651825 617.410645,297.679352 
	C617.179504,297.186432 617.083069,296.991333 616.966064,296.394287 
	C616.949768,294.645386 616.953979,293.298431 617.171387,291.590881 
	C617.651611,286.568878 617.918518,281.907471 618.533936,277.155884 
	C619.562927,276.537170 620.243286,276.008667 620.923706,275.480164 
	C620.854248,275.058228 620.784851,274.636322 620.715393,274.214386 
	C617.473083,274.214386 614.230713,274.213501 610.988342,274.214539 
	C599.887085,274.218018 601.982056,273.624207 601.762634,283.065002 
	C601.724121,284.723175 601.581177,286.378876 601.305603,288.063446 
	C601.124756,288.091156 600.769653,288.003021 600.769653,288.003021 
	C600.369812,286.936523 599.970032,285.870026 599.679260,285.094421 
	C592.935059,284.724457 586.321655,284.488556 579.744873,283.865814 
	C578.743286,283.770905 577.911438,281.883209 577.179565,280.388458 
	C577.358093,279.952179 577.808289,280.030243 577.808289,280.030243 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M664.624695,546.941406 
	C666.351074,553.390320 663.385803,558.433411 655.677307,561.762695 
	C655.165405,559.731384 654.738953,557.711060 654.136414,555.744812 
	C653.587036,553.951965 652.846680,552.217651 651.739746,550.518188 
	C651.163086,557.004639 655.947266,565.117737 645.322876,567.738647 
	C645.124146,564.909607 645.256775,562.400269 645.718506,559.905151 
	C646.518372,559.793640 647.108154,559.806641 647.441284,559.520630 
	C650.681946,556.739014 649.598999,550.815918 644.968384,545.642456 
	C641.950928,542.202454 638.968872,539.108459 635.990662,535.634766 
	C635.997864,534.495422 636.001343,533.735718 636.344116,533.033936 
	C639.087585,534.768799 641.491821,536.445862 643.896057,538.122925 
	C644.119019,537.830383 644.341980,537.537842 644.564941,537.245300 
	C644.187927,536.416260 643.810913,535.587219 643.419373,534.726379 
	C644.576111,534.519592 645.602905,534.335999 647.555786,533.986877 
	C643.903259,531.989197 641.206970,530.514465 638.510681,529.039795 
	C638.777893,528.527588 639.045105,528.015320 639.312317,527.503113 
	C643.203613,529.350525 647.094971,531.197876 650.708069,533.076172 
	C650.189026,533.292603 649.928284,533.459229 649.721558,533.677124 
	C649.669434,533.732056 649.743347,534.004333 649.837830,534.086670 
	C654.761414,538.377686 659.693542,542.659058 664.624695,546.941406 
M649.670654,547.537231 
	C649.670654,547.537231 649.460449,547.422607 649.460449,547.422607 
	C649.460449,547.422607 649.497803,547.678711 649.670654,547.537231 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M465.654663,348.248840 
	C465.417999,347.382904 465.181366,346.516937 465.274719,345.061096 
	C465.169342,340.669434 464.733978,336.867706 464.251465,332.595947 
	C464.100403,325.003021 463.941071,317.880371 463.904724,310.757111 
	C463.840302,298.125702 463.871521,298.125549 476.524902,298.282532 
	C476.738464,302.037872 476.705902,305.467621 476.371216,309.011475 
	C476.094940,310.423248 476.120728,311.721008 476.129822,313.460022 
	C476.048431,316.257202 475.983673,318.613037 475.555878,321.067871 
	C474.940155,321.367188 474.520538,321.526123 474.459167,321.773804 
	C472.604248,329.260315 470.904175,336.788452 468.860443,344.222260 
	C468.442291,345.743286 466.756256,346.915741 465.654663,348.248840 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M527.943359,576.965942 
	C528.880005,577.807983 529.816589,578.650024 530.725830,580.086609 
	C526.441467,583.300903 522.184509,585.920715 517.531860,588.640381 
	C516.594910,588.814209 516.053711,588.888184 515.469971,588.990662 
	C515.427429,589.019165 515.292664,589.135193 515.292664,589.135193 
	C508.653656,590.608643 502.014648,592.082092 495.218018,592.930176 
	C498.497131,590.872437 501.946503,589.469360 505.367432,588.000061 
	C509.564270,586.197449 513.737366,584.339600 517.920776,582.505676 
	C517.745178,582.125305 517.569580,581.744934 517.393982,581.364563 
	C508.589691,583.898865 499.785370,586.433228 490.761719,588.707153 
	C489.356995,588.940979 488.171539,589.435364 486.986084,589.929688 
	C486.245361,589.916077 485.504608,589.902527 484.394897,589.450684 
	C484.028839,588.115051 484.031799,587.217712 484.034760,586.320374 
	C484.477570,586.235657 484.920349,586.150879 485.854370,586.286011 
	C486.905548,586.132263 487.465546,585.758606 488.025543,585.384888 
	C498.045074,582.254761 508.064575,579.124695 518.808777,575.952637 
	C521.355652,574.674133 523.177795,573.437561 524.999939,572.200989 
	C525.483398,571.867554 525.966858,571.534180 527.090088,571.097839 
	C530.087952,568.548279 532.446106,566.101685 534.804260,563.655151 
	C535.184509,562.949158 535.564819,562.243164 536.380981,561.215332 
	C537.220337,559.603394 537.623718,558.313354 538.027100,557.023315 
	C538.065247,556.568237 538.103394,556.113098 538.575806,555.218018 
	C538.793518,552.184082 538.576965,549.590149 538.360413,546.996277 
	C538.274231,546.542542 538.188049,546.088806 538.339783,545.119019 
	C538.721008,544.061340 538.864197,543.519653 539.007385,542.978027 
	C543.634644,545.418640 543.113281,550.283875 542.607605,553.816833 
	C541.572632,561.048035 538.706482,567.858398 531.980957,572.859497 
	C526.656921,574.816101 522.657104,577.535767 518.727295,580.353760 
	C519.075989,580.891541 519.424683,581.429260 519.773376,581.966980 
	C522.496704,580.299988 525.220032,578.632996 527.943359,576.965942 
z"
      />
      <path
        fill="#925627"
        opacity="1.000000"
        stroke="none"
        d="
M648.723083,517.280701 
	C648.723083,517.280701 648.248840,517.215576 648.082031,516.721802 
	C648.859558,514.698120 649.837463,513.187561 650.741821,511.634247 
	C652.944885,507.850159 655.113831,504.046204 657.580627,500.060760 
	C661.528687,494.805878 665.626343,489.992432 668.750916,484.613708 
	C673.001892,477.295837 679.711365,473.909637 687.169739,471.612061 
	C681.739868,479.947998 676.282898,487.929718 670.479858,495.972656 
	C669.422119,496.864929 668.569214,497.612549 668.021057,498.540253 
	C663.705994,505.843506 660.541077,513.984131 653.006958,518.914490 
	C652.187073,518.718262 651.367188,518.522034 650.135498,517.961670 
	C649.390137,517.491943 649.056580,517.386292 648.723083,517.280701 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M601.142212,604.835083 
	C605.579102,602.067444 609.926819,599.514160 614.274536,596.960876 
	C614.747314,597.198059 615.220154,597.435303 615.692932,597.672546 
	C614.300537,606.203674 613.291992,614.826355 611.291321,623.212463 
	C610.657532,625.869141 607.375671,627.894104 604.730347,630.462158 
	C603.445740,630.819153 602.736450,630.922180 601.831787,630.745605 
	C600.377808,629.927124 599.119141,629.388245 597.728943,628.498657 
	C605.192505,622.248474 609.359009,614.358276 611.238953,604.919312 
	C611.393433,604.445679 611.336365,604.070496 611.279297,603.695251 
	C611.145203,604.097046 611.011108,604.498901 610.531738,604.893433 
	C605.804138,610.974182 601.299133,616.979065 597.092285,623.185974 
	C595.039124,626.215271 593.638306,629.754333 589.051208,628.582642 
	C589.094971,626.799683 589.075867,625.424683 589.308960,623.791504 
	C589.749329,622.343994 589.937439,621.154602 590.260254,619.767212 
	C590.565918,619.269836 590.589539,618.959290 590.699951,618.445007 
	C591.037109,617.866821 591.140076,617.481079 591.453186,616.895813 
	C591.833618,616.148743 592.003906,615.601135 592.174194,615.053589 
	C592.520813,615.002747 592.757202,614.813843 593.222534,614.088440 
	C594.486023,612.257874 595.410339,610.825745 596.334595,609.393677 
	C596.334595,609.393677 596.325989,609.374878 596.610779,609.330688 
	C597.260437,608.854187 597.625366,608.421936 597.990295,607.989624 
	C597.990295,607.989624 598.000000,608.000000 598.286499,607.913452 
	C599.052429,607.202271 599.531921,606.577759 600.011475,605.953247 
	C600.358643,605.651978 600.705872,605.350708 601.142212,604.835083 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M725.148376,234.032745 
	C725.148376,234.032745 725.623108,234.086243 725.860962,234.118866 
	C726.396362,236.094971 726.944275,238.037445 726.952026,239.982101 
	C727.018738,256.614655 726.575928,273.262115 727.161438,289.874207 
	C727.449524,298.049683 723.648193,303.678986 718.967407,309.390900 
	C715.546814,313.565094 712.355469,317.927094 709.061646,322.205139 
	C708.281555,323.218384 707.591736,324.320312 706.703186,325.227448 
	C703.600098,328.395203 703.200317,331.836304 703.267639,336.385529 
	C703.351562,342.046967 700.786804,347.768463 699.230103,353.426697 
	C698.009705,357.862579 696.447327,362.208649 695.358948,366.673126 
	C695.133423,367.598206 696.327576,368.869385 696.667542,370.557617 
	C695.317566,371.825470 694.167358,372.516785 692.483093,373.529114 
	C692.232178,371.443207 692.082825,370.201324 691.950134,368.646423 
	C691.994385,367.916229 692.022034,367.499023 692.337952,366.858032 
	C693.376648,363.753937 694.126953,360.873657 695.030396,357.706909 
	C695.389526,356.613647 695.595520,355.806854 695.994690,354.675171 
	C697.481812,350.571106 698.775696,346.791931 700.133057,342.690277 
	C700.232788,341.712158 700.269043,341.056519 700.607544,340.245728 
	C703.575684,336.220703 699.554077,335.693146 697.916504,333.671783 
	C698.000610,332.903137 698.033691,332.462280 698.331299,331.822632 
	C701.115540,327.870758 703.635376,324.117676 706.468750,320.229004 
	C708.231995,318.134033 709.681702,316.174652 711.457825,314.110504 
	C713.974670,311.166870 715.985596,308.164062 718.395630,305.525818 
	C722.469604,301.066040 725.101135,296.234955 723.910645,289.604431 
	C723.937195,288.499451 723.919983,287.761597 723.966064,286.594177 
	C723.981628,284.432037 723.934021,282.699371 723.931763,280.502869 
	C723.969116,274.364105 723.961182,268.689209 724.002319,262.565186 
	C723.999817,259.702454 723.948181,257.288849 723.949890,254.460007 
	C724.180115,250.731583 724.356995,247.418427 724.672180,243.663635 
	C724.923157,240.158920 725.035767,237.095840 725.148376,234.032745 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M737.083618,225.016876 
	C737.083618,225.016876 737.304565,225.116455 737.147217,225.616669 
	C735.681519,227.458237 734.325317,228.757050 733.082336,230.156387 
	C732.302368,231.034485 731.692261,232.063553 731.005920,233.024902 
	C729.908813,233.319687 728.811707,233.614471 727.376709,233.830505 
	C724.066101,229.394135 721.633301,224.510498 718.008057,220.788452 
	C710.466919,213.046097 702.294006,205.919067 694.188477,197.873291 
	C693.402039,195.064163 692.807983,192.920883 692.168152,190.612640 
	C695.340820,189.449387 697.180054,189.936768 698.391602,193.343063 
	C699.110596,195.364716 700.886536,198.071732 702.637634,198.464966 
	C707.771973,199.617950 710.684265,203.308762 714.100220,206.574844 
	C720.046326,212.260025 725.975891,217.968750 732.113464,223.442078 
	C733.297058,224.497589 735.403076,224.518646 737.083618,225.016876 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M596.057007,499.293335 
	C595.583984,501.365417 595.110962,503.437500 594.637939,505.509583 
	C594.060425,505.585876 593.482910,505.662170 592.905396,505.738495 
	C598.846436,511.911407 607.718262,512.175171 614.552917,516.400574 
	C611.470642,516.061646 608.597229,515.494873 605.907288,514.454102 
	C597.441956,511.178925 588.773560,508.263489 580.703430,504.181244 
	C573.472412,500.523468 573.021545,496.130157 577.626404,489.505371 
	C577.883240,489.135956 577.833191,488.553284 578.352661,488.034485 
	C582.209717,487.486511 585.628418,486.871429 589.072571,486.480408 
	C599.411377,485.306641 609.760132,484.220367 620.001160,483.453186 
	C617.950806,484.528259 616.056641,485.494568 614.047729,485.924591 
	C608.733459,487.062164 603.369568,487.967468 597.595581,488.969360 
	C585.673218,489.800476 580.414185,492.234131 578.792969,497.270966 
	C581.430115,496.172089 584.212952,495.012573 587.366943,493.907745 
	C587.985168,494.001587 588.232239,494.040741 588.350220,494.423248 
	C583.888367,500.957703 583.955261,501.753479 589.036133,504.164337 
	C589.175537,504.378052 589.275940,504.431335 589.376343,504.484619 
	C589.251953,504.322144 589.127625,504.159637 589.003906,503.592407 
	C588.669739,498.198853 591.029236,495.829346 595.998291,495.997559 
	C596.000000,496.000000 596.004700,496.003174 595.916016,496.301300 
	C595.903870,497.497406 595.980469,498.395355 596.057007,499.293335 
M593.538757,501.388611 
	C593.538757,501.388611 593.607910,501.508392 593.538757,501.388611 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M577.925964,488.069855 
	C577.833191,488.553284 577.883240,489.135956 577.626404,489.505371 
	C573.021545,496.130157 573.472412,500.523468 580.703430,504.181244 
	C588.773560,508.263489 597.441956,511.178925 605.907288,514.454102 
	C608.597229,515.494873 611.470642,516.061646 614.658203,516.728271 
	C617.104858,517.062927 619.153320,517.514709 621.604065,518.237427 
	C622.006348,518.508301 622.098022,518.970764 621.828308,519.165283 
	C622.812256,520.449707 623.974182,521.678589 625.348389,522.585693 
	C626.464966,523.322754 627.836121,523.673950 629.094421,524.196289 
	C628.989929,524.512512 628.885376,524.828796 628.780823,525.145020 
	C627.520569,525.423401 626.260254,525.701843 624.666748,525.982483 
	C623.889465,525.969299 623.445496,525.953918 622.944702,525.589966 
	C620.968384,524.116760 619.173828,522.597961 617.105591,521.941406 
	C610.981995,519.997559 604.343994,519.233826 598.648010,516.477478 
	C587.740112,511.199036 577.343567,504.863739 566.083557,498.604950 
	C567.834229,501.054352 569.438171,503.443420 571.198975,505.710632 
	C572.357971,507.202881 573.743103,508.519470 574.679504,509.909424 
	C572.546997,508.972534 570.761963,508.040955 568.826965,506.836975 
	C568.100342,506.392303 567.523682,506.220062 566.974121,506.026947 
	C567.001282,506.006104 566.974548,506.069183 566.822510,505.803192 
	C566.099426,505.371765 565.528381,505.206329 564.979004,505.035339 
	C565.000671,505.029816 564.957764,505.056488 564.934204,504.725220 
	C564.255676,503.948883 563.600830,503.503845 562.930176,503.066650 
	C562.914368,503.074493 562.882568,503.096466 562.916138,502.778198 
	C562.972046,501.820251 562.994446,501.180603 563.054077,500.083435 
	C562.134155,492.394836 566.291016,488.591705 572.580322,486.043335 
	C574.593018,486.757141 576.259460,487.413483 577.925964,488.069855 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M621.902222,570.636597 
	C620.728333,571.949585 619.554382,573.262573 617.784302,574.538574 
	C617.452026,571.672729 617.715881,568.843872 618.341736,565.950806 
	C622.679321,561.145874 623.131714,556.030945 619.979126,550.658447 
	C616.352966,540.338074 608.084961,534.755005 600.056213,528.667114 
	C601.738464,527.574463 603.374268,526.806396 605.361084,526.073059 
	C608.837219,527.920471 612.093384,529.544312 615.051819,531.597168 
	C618.222839,533.797607 621.113586,536.401672 623.860229,539.045288 
	C625.772766,543.191406 627.951782,547.121826 630.166992,551.321411 
	C630.224487,551.951843 630.245667,552.313232 630.201782,553.029907 
	C630.506165,553.937073 630.875732,554.488831 631.258423,555.435669 
	C631.328186,556.627563 631.384766,557.424377 631.097168,558.148865 
	C629.538574,557.596130 628.324280,557.115662 627.109924,556.635193 
	C626.990112,557.415894 626.870361,558.196533 626.755493,559.325317 
	C625.141052,563.327820 623.521667,566.982239 621.902222,570.636597 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M705.140625,406.580933 
	C707.879211,401.598755 711.418213,397.197632 713.075012,392.175568 
	C714.892456,386.666656 719.261475,384.995056 722.991577,382.137787 
	C723.525940,382.344513 724.060364,382.551239 724.594727,382.757935 
	C722.977173,389.356964 721.613831,396.033356 719.638977,402.523621 
	C718.589539,405.972534 716.465820,409.091858 714.852112,412.372345 
	C711.068787,420.063110 709.668701,420.647064 700.098816,418.190948 
	C701.428528,415.340027 702.727417,412.555328 704.052490,409.403198 
	C704.422974,408.319977 704.767151,407.604126 705.140625,406.580933 
z"
      />
      <path
        fill="#394746"
        opacity="1.000000"
        stroke="none"
        d="
M476.673309,308.897400 
	C476.705902,305.467621 476.738464,302.037872 476.486633,297.958679 
	C475.775604,296.564667 475.348938,295.820068 475.162781,294.846252 
	C475.544708,293.539124 475.686127,292.461151 476.169739,291.090851 
	C476.993164,285.861511 477.474426,280.924500 478.197693,275.935913 
	C478.439697,275.884369 478.924408,275.984161 478.924408,275.984161 
	C479.289581,276.850006 479.937164,277.702484 479.978729,278.583618 
	C481.064911,301.603363 481.602905,324.599152 475.932343,347.219391 
	C474.891235,351.372375 473.733765,355.496185 472.396637,360.508301 
	C470.705200,359.362976 469.468903,358.525818 468.479187,357.297058 
	C469.636871,353.683990 470.798889,350.509430 471.410522,347.232117 
	C473.039886,338.501343 474.432312,329.726318 475.918945,320.968903 
	C475.983673,318.613037 476.048431,316.257202 476.369568,313.194092 
	C476.641754,311.290375 476.657532,310.093872 476.673309,308.897400 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M384.151184,381.401672 
	C379.072845,375.950317 374.269897,370.203125 368.830353,365.139832 
	C364.361389,360.979980 363.381104,356.029999 363.146790,349.297607 
	C366.498108,352.772125 369.155090,355.526825 372.238586,358.665771 
	C374.394867,361.135498 376.124725,363.220947 377.854553,365.306427 
	C378.832245,366.559387 379.809937,367.812317 381.188416,369.474915 
	C382.681580,370.976044 383.773956,372.067505 384.866364,373.158966 
	C384.866364,373.158966 384.941101,373.070557 384.927734,373.360657 
	C385.193146,373.874969 385.471924,374.099213 385.750702,374.323456 
	C385.750702,374.323456 385.825806,374.083221 385.871674,374.451752 
	C386.586121,375.415741 387.254700,376.011200 387.923309,376.606628 
	C387.923309,376.606628 388.115356,376.838318 388.289215,377.172241 
	C388.861267,377.785065 389.259460,378.063995 389.657654,378.342926 
	C389.657654,378.342926 389.781067,377.977814 389.793274,378.469849 
	C391.160736,380.399414 392.516022,381.836914 393.871277,383.274414 
	C395.555328,385.454956 397.239380,387.635529 399.263062,390.296936 
	C400.068390,391.194519 400.534058,391.611298 400.999725,392.028046 
	C401.226349,392.840851 401.452972,393.653687 401.524231,394.926270 
	C399.595703,394.386902 397.604034,393.641602 396.091461,392.339722 
	C392.002472,388.820190 388.117249,385.063995 384.151184,381.401672 
z"
      />
      <path
        fill="#394746"
        opacity="1.000000"
        stroke="none"
        d="
M517.863770,346.945312 
	C517.899719,346.512817 517.935669,346.080322 518.259155,345.075104 
	C519.276245,340.969269 520.005676,337.436157 520.735229,333.903046 
	C521.450867,329.864929 522.166504,325.826782 523.194824,321.183533 
	C523.557678,319.680573 523.607788,318.782715 523.657898,317.884827 
	C523.784058,316.531952 523.910156,315.179077 524.309814,313.166687 
	C524.608093,311.301514 524.632812,310.095917 524.657593,308.890289 
	C524.635010,305.445251 524.612488,302.000244 524.301025,297.960388 
	C523.818787,296.992981 523.625488,296.620453 523.839111,296.055115 
	C524.459839,293.891083 524.673584,291.919800 524.916870,289.494324 
	C524.941406,285.689148 524.936401,282.338165 525.195068,278.812378 
	C525.670593,277.829224 525.882385,277.020905 526.317383,276.137939 
	C526.540588,276.063232 527.007812,276.005280 527.300415,276.190308 
	C527.563538,279.243317 527.467041,282.112671 527.527283,284.978729 
	C527.569458,286.987244 527.825684,288.991272 527.986206,290.997284 
	C527.663452,301.344543 527.980530,311.762421 526.848328,322.020325 
	C525.568726,333.613342 523.036194,345.071686 520.912659,356.563477 
	C520.633667,358.073303 519.550476,359.434540 518.372253,361.805298 
	C516.932556,359.891479 516.036743,358.700653 515.532349,357.116089 
	C516.570435,353.463348 517.217102,350.204315 517.863770,346.945312 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M690.171692,547.249695 
	C693.554688,540.690979 696.793091,534.104126 704.852600,531.838989 
	C706.277283,531.438599 707.178284,529.169861 708.317871,527.761292 
	C710.112427,525.543152 711.904236,523.322815 714.013306,521.346436 
	C714.329346,521.589539 714.091492,521.904968 714.092896,522.014648 
	C714.094238,522.124390 714.096863,522.343323 713.910889,522.660522 
	C712.767761,524.637634 711.810547,526.297546 710.646851,528.188354 
	C710.482178,529.902405 710.524109,531.385620 710.391602,533.213867 
	C710.299438,535.695679 710.381775,537.832458 710.382263,540.343079 
	C710.764160,542.190552 711.227905,543.664124 711.588379,545.509399 
	C711.429810,546.899292 711.374390,547.917603 711.176880,549.323181 
	C711.022461,550.807434 711.010132,551.904297 710.892334,553.397705 
	C710.886780,555.150818 710.986572,556.507507 711.091064,558.214050 
	C712.760498,560.084473 714.425232,561.604919 715.911255,563.404053 
	C711.815430,566.533997 707.898315,569.385315 703.976440,571.841187 
	C704.654236,567.976929 705.336731,564.508179 706.013611,560.588989 
	C705.647705,555.758911 705.287415,551.379333 704.935730,546.624634 
	C704.944397,542.293640 704.944397,538.337646 704.944397,533.139404 
	C699.343750,538.488892 694.757751,542.869263 690.171692,547.249695 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M576.143188,337.090149 
	C578.188354,324.255463 575.491394,325.380829 588.800598,325.350159 
	C589.131348,325.349396 589.462097,325.350525 589.792847,325.350769 
	C599.418213,325.358032 599.418213,325.358032 601.813354,334.830566 
	C601.765076,335.697144 601.703430,335.890381 601.378845,336.096161 
	C593.372742,337.092926 585.629639,338.077148 577.690674,338.878021 
	C577.044312,338.159821 576.593750,337.624969 576.143188,337.090149 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M577.763245,279.623901 
	C577.808289,280.030243 577.358093,279.952179 577.131348,279.984131 
	C576.427124,280.277771 575.949646,280.539429 574.980103,280.678192 
	C573.861084,279.416748 573.234192,278.278229 572.648010,276.654480 
	C572.203064,275.479919 571.733643,274.205505 571.229065,274.191376 
	C565.990601,274.044830 560.746521,274.101166 554.861084,274.101166 
	C554.861084,285.831573 554.861084,296.924316 554.861084,308.017059 
	C553.469177,308.323242 552.077209,308.629456 550.404968,308.592499 
	C551.034363,304.110168 551.944092,299.971008 552.956726,295.398071 
	C553.059631,293.077545 553.059631,291.190765 553.059631,288.498962 
	C546.683105,288.498962 540.838013,288.498962 534.992981,288.498962 
	C534.326172,286.986542 533.659302,285.474152 533.442200,283.516479 
	C539.019409,283.009613 544.150085,282.813171 549.273132,282.937012 
	C552.349609,283.011322 553.669128,282.044769 552.788757,278.906281 
	C552.885864,277.425232 552.630005,275.792084 553.183350,274.507568 
	C553.695862,273.317719 555.044250,271.688354 556.075439,271.650757 
	C562.997803,271.398529 569.933655,271.519531 577.200684,271.519531 
	C577.391846,274.363403 577.555054,276.790466 577.763245,279.623901 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M510.031311,391.555481 
	C509.275818,393.306183 508.175507,394.571869 508.092987,395.900757 
	C507.848602,399.837738 508.132050,403.806976 507.901398,407.745636 
	C507.854187,408.552002 506.468933,409.279999 505.345520,409.546814 
	C505.329498,385.694000 505.668427,362.338470 506.326324,338.957520 
	C507.280975,338.961456 507.916626,338.990845 508.552246,339.020233 
	C509.139771,349.582611 509.882050,360.139435 510.259216,370.709320 
	C510.501404,377.496063 510.206024,384.302032 510.031311,391.555481 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M484.029358,448.944519 
	C480.435486,447.750427 476.880066,446.420898 473.240723,445.386780 
	C460.653076,441.810059 448.034027,438.343842 435.434357,434.808990 
	C434.379730,434.513123 433.380890,434.018219 431.552521,433.300201 
	C436.618591,426.966888 443.795349,426.297089 450.607544,424.127991 
	C452.195251,424.757324 453.184052,425.098450 454.323578,425.491547 
	C444.715820,430.440674 444.603180,430.593079 447.776367,432.986023 
	C449.967468,431.596466 451.922485,430.356628 453.911255,429.519714 
	C453.027985,434.329224 455.458679,437.007446 459.093903,438.297760 
	C462.886108,439.643738 466.966156,440.178833 470.914001,441.079346 
	C470.907623,441.090179 470.923523,441.117859 470.967896,441.396149 
	C471.673126,441.834442 472.334045,441.994446 473.342896,442.173889 
	C475.423828,442.846893 477.156799,443.500488 478.971985,444.489075 
	C480.712616,446.197540 482.370972,447.571014 484.029358,448.944519 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M371.300446,489.317871 
	C380.272369,485.176086 389.202362,488.717560 398.102173,489.643341 
	C401.589386,490.006104 404.951508,491.571533 408.683289,493.166199 
	C409.444824,494.837158 409.893585,495.931122 410.262573,497.264404 
	C410.464813,497.632141 410.746826,497.760559 411.082184,498.163788 
	C411.193207,498.616089 411.250885,498.793579 411.206207,499.316925 
	C409.444092,501.253082 407.784271,502.843353 406.091980,504.023895 
	C405.524292,502.674683 405.172791,501.119324 404.423981,500.895996 
	C399.633118,499.467163 394.754913,498.330963 389.686462,497.071655 
	C389.467499,497.044769 389.030457,496.984161 388.978333,496.658203 
	C388.244171,495.939758 387.562134,495.547302 386.514893,495.086914 
	C381.199951,493.118622 376.250214,491.218262 371.300446,489.317871 
z"
      />
      <path
        fill="#3F8C82"
        opacity="1.000000"
        stroke="none"
        d="
M554.038208,332.633057 
	C551.694214,334.304230 549.593018,336.220428 547.221008,336.653625 
	C542.170898,337.575836 536.982300,337.755524 531.843872,338.154755 
	C531.297791,338.197174 530.707947,337.676544 529.891357,337.413818 
	C529.585083,336.771759 529.386230,336.109955 529.487183,335.497589 
	C531.159180,325.357910 531.167664,325.358521 541.547668,325.237610 
	C543.359070,325.216522 545.170532,325.195190 546.981995,325.190918 
	C553.738892,325.174988 553.738892,325.177612 554.038208,332.633057 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M474.323059,517.392822 
	C476.216614,518.338379 478.110138,519.283936 479.832916,520.908081 
	C479.258820,522.518188 478.855469,523.449646 477.999023,524.253784 
	C472.214020,522.791199 469.080139,525.757935 466.159485,529.631592 
	C461.929138,526.609558 459.440704,529.584473 456.325012,531.694763 
	C451.161621,531.906799 446.414276,532.111389 441.367401,532.188110 
	C440.074554,531.657959 439.081299,531.255676 438.053650,530.631165 
	C438.019257,530.408936 438.081543,529.963562 438.409882,529.780701 
	C440.080200,529.068176 441.442993,528.035950 442.760803,528.090637 
	C451.216431,528.441040 456.602478,522.705383 462.264709,517.993713 
	C464.605652,516.045715 465.828613,515.578064 467.970764,517.457642 
	C470.089386,519.316589 472.232910,520.032654 474.323059,517.392822 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M415.784424,497.006134 
	C417.060547,495.354553 418.022217,493.164764 419.692932,492.188629 
	C421.750061,490.986816 424.476471,491.003448 426.777008,490.132568 
	C436.053833,486.620667 443.379425,490.281769 449.819855,496.587311 
	C444.960724,495.950348 440.424988,494.958618 435.063812,493.786438 
	C436.059418,495.620941 436.665924,496.568787 437.105103,497.588684 
	C437.714905,499.004913 438.199127,500.475281 438.737091,501.922424 
	C437.067993,502.214294 435.399811,502.735504 433.729614,502.742096 
	C431.452240,502.751099 429.173279,502.367737 426.527557,502.111237 
	C424.486420,501.648926 422.812775,501.227997 421.105286,500.481750 
	C420.563171,496.867310 418.337433,497.516144 416.086914,497.763306 
	C415.927612,497.339294 415.856018,497.172729 415.784424,497.006134 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M641.023560,422.950256 
	C645.360962,423.062744 649.698364,423.175262 654.636353,423.744690 
	C662.942139,426.034912 671.299805,425.698303 677.993042,431.342957 
	C678.686340,432.432220 679.339417,433.210083 679.560059,433.995392 
	C677.213440,433.757324 675.302917,433.477234 673.384277,433.273529 
	C669.535950,432.864929 665.683167,432.498077 661.533081,432.110596 
	C660.835632,432.086029 660.437378,432.064819 659.983154,431.706146 
	C658.958740,431.567444 657.990112,431.766205 656.570923,431.981262 
	C648.126831,431.304626 640.133362,430.611664 631.871338,429.813843 
	C631.083618,429.458191 630.564636,429.207367 630.022156,428.699036 
	C629.989746,428.269440 629.980713,428.097321 630.306885,427.942505 
	C631.089478,427.960571 631.536865,427.961334 632.368469,427.986969 
	C637.208496,429.100616 638.319702,424.724182 641.023560,422.950256 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M723.307800,448.149780 
	C722.698425,448.592407 722.180603,448.784302 720.963135,448.991608 
	C717.551880,449.355255 714.840149,449.703461 711.700439,450.028229 
	C709.164978,450.636566 707.021790,451.170319 704.957031,451.919952 
	C700.335815,453.597809 695.849915,455.731018 691.131348,457.037079 
	C685.172546,458.686432 679.036987,459.697144 672.551270,460.984863 
	C670.418640,460.998291 668.712402,461.010162 666.706421,461.035004 
	C665.933777,461.364502 665.460754,461.681030 664.609253,462.005737 
	C659.924927,463.149780 656.943970,465.667480 655.014709,469.800476 
	C651.829346,476.624054 648.294678,483.284546 644.584839,489.974152 
	C643.835876,489.262604 643.409363,488.590668 642.992676,487.546326 
	C643.477234,485.802612 643.951904,484.431396 644.641479,482.914886 
	C645.022949,482.281738 645.189453,481.793854 645.622192,481.103699 
	C646.662476,479.305542 647.436523,477.709656 648.438599,475.922333 
	C648.840942,475.166626 649.015320,474.602356 649.481934,473.812073 
	C650.083435,472.656921 650.392639,471.727814 650.905273,470.620361 
	C651.574036,469.621735 652.039490,468.801483 652.675537,467.801727 
	C652.953979,467.129883 653.061707,466.637543 653.453247,465.861420 
	C653.965881,464.555115 654.194763,463.532593 654.450378,462.387177 
	C654.477173,462.264282 654.558472,461.775513 654.934814,461.664307 
	C659.541382,460.728546 663.771912,459.905426 668.001831,459.079285 
	C679.316528,456.869446 691.281677,456.883301 701.447632,449.335327 
	C703.870605,448.702972 705.902893,448.145966 708.309570,447.709442 
	C710.125000,447.551361 711.566040,447.272827 713.377319,447.052368 
	C714.483215,447.008301 715.218933,446.906097 716.341248,446.907928 
	C718.760498,446.689575 720.793091,446.367218 722.825684,446.044861 
	C723.016846,446.662933 723.208069,447.280975 723.307800,448.149780 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M356.931030,501.055817 
	C357.107819,501.599091 357.284607,502.142395 357.723267,503.224762 
	C359.973022,507.760315 361.272675,512.345947 364.087677,515.634399 
	C370.576202,523.214111 370.801819,531.781677 369.428436,540.798645 
	C366.902863,537.497925 364.694885,534.230591 362.378418,530.592651 
	C361.774780,529.007996 361.249451,527.805359 360.789520,526.578064 
	C358.164551,519.573242 355.555176,512.562683 352.947021,505.156525 
	C352.604980,503.847809 352.256348,502.936584 351.921387,502.104553 
	C351.935028,502.183746 351.797211,502.266327 351.854828,501.880096 
	C352.611389,499.909912 349.960022,496.557220 354.564362,497.119080 
	C355.508606,498.569397 356.219818,499.812622 356.931030,501.055817 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M616.815308,418.897827 
	C615.027527,418.949982 613.338257,418.374420 611.620667,418.271332 
	C607.352051,418.015137 604.550293,416.239044 604.493103,411.359985 
	C606.050537,410.242493 607.716431,409.726898 608.101746,408.720825 
	C612.212097,397.989410 615.986877,387.128387 620.174622,376.428497 
	C621.233459,373.723053 623.431885,371.463623 625.112488,369.387360 
	C624.979126,370.536041 624.839966,371.296631 624.703491,372.124817 
	C624.706116,372.192444 624.739075,372.323730 624.441284,372.560730 
	C623.314209,375.165131 622.484802,377.532501 621.434753,380.087769 
	C621.101929,380.830292 620.989746,381.384949 620.636108,382.205200 
	C617.060181,391.386749 613.725708,400.302673 610.115112,409.443176 
	C609.744751,411.090881 607.051453,413.112305 611.232666,413.756195 
	C619.823853,414.216675 627.939148,414.614655 636.057495,414.935791 
	C642.301453,415.182800 648.549316,415.333069 655.164551,415.520508 
	C657.017151,415.609283 658.500610,415.703857 660.128235,416.072754 
	C660.852783,416.544830 661.433105,416.742554 662.013428,416.940247 
	C655.353699,417.128143 648.687866,417.583679 642.035767,417.433868 
	C634.304077,417.259674 626.586609,416.497345 618.855042,416.189362 
	C618.235168,416.164673 617.553833,417.683594 616.815308,418.897827 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M554.939453,308.474426 
	C554.861084,296.924316 554.861084,285.831573 554.861084,274.101166 
	C560.746521,274.101166 565.990601,274.044830 571.229065,274.191376 
	C571.733643,274.205505 572.203064,275.479919 572.435181,276.524048 
	C572.181519,276.878815 571.687622,276.804840 571.249268,276.818359 
	C556.754089,277.085602 555.515747,278.581421 558.978516,291.456726 
	C558.934143,293.260498 558.955994,294.652130 558.889038,296.449585 
	C559.105835,308.899200 559.411377,320.942932 559.758301,333.428314 
	C559.818542,338.633514 559.837402,343.397125 559.856201,348.160706 
	C558.408203,340.030457 556.960144,331.900208 555.424927,323.125458 
	C555.265503,322.314636 555.193237,322.148346 555.121033,321.982086 
	C555.086609,317.631989 555.052185,313.281921 554.939453,308.474426 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M699.535767,368.322449 
	C702.129639,365.384644 704.642822,362.712494 707.628784,359.667847 
	C709.885132,357.567261 711.669922,355.840546 713.451904,354.110870 
	C716.963745,350.702026 720.473999,347.291504 723.984924,343.881653 
	C725.216614,350.788147 722.868164,356.230164 716.741394,360.650208 
	C712.104675,364.824280 707.980469,368.684448 703.541626,372.723969 
	C701.113037,376.613739 699.031677,380.343933 696.819946,383.995178 
	C696.651367,384.273499 695.559326,383.992401 694.876099,383.565063 
	C695.868774,379.064117 696.881836,374.969513 697.894958,370.874878 
	C698.414978,370.112610 698.934998,369.350372 699.535767,368.322449 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M626.750549,558.977234 
	C626.870361,558.196533 626.990112,557.415894 627.109924,556.635193 
	C628.324280,557.115662 629.538574,557.596130 631.224976,558.491333 
	C631.660828,563.015015 631.624695,567.124023 631.817749,571.438171 
	C632.515930,571.107666 632.984985,570.571960 633.739746,569.789795 
	C634.367615,566.022217 634.709778,562.501099 635.291748,559.136108 
	C636.665649,558.369324 638.251282,557.668518 638.837769,556.476135 
	C639.979980,554.154419 640.562317,551.557312 641.517334,548.644714 
	C645.669128,551.704956 646.995361,554.705750 644.817017,558.821167 
	C643.237976,562.591553 642.042664,566.241272 640.847412,569.890991 
	C640.059937,570.793823 639.272461,571.696655 637.915955,572.806763 
	C636.784973,573.572632 636.223083,574.131226 635.661194,574.689880 
	C634.882202,574.604370 633.730164,574.818054 633.383423,574.385742 
	C630.716431,571.060608 629.683411,573.389587 628.027649,575.498413 
	C626.633911,577.273499 624.514038,578.478455 622.322021,579.696411 
	C621.856079,579.284851 621.783691,579.112793 621.711304,578.940796 
	C621.834412,578.568420 621.957458,578.196045 622.473267,577.399292 
	C624.428467,572.923950 626.254272,568.947327 627.427856,564.786682 
	C627.917175,563.051941 627.018250,560.925537 626.750549,558.977234 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M478.960754,275.650452 
	C478.924408,275.984161 478.439697,275.884369 477.786621,275.913727 
	C475.760040,276.011536 474.386505,276.079987 472.558899,276.090454 
	C469.235046,276.032501 466.365265,276.032501 463.232910,276.032501 
	C463.232910,278.498932 463.232910,280.259369 463.174225,282.450256 
	C463.172241,284.902161 463.228943,286.923584 463.230896,289.265656 
	C463.512115,290.072266 463.848083,290.558289 464.067444,291.424561 
	C464.605499,293.110413 465.260193,294.416016 466.274719,295.807068 
	C467.118652,295.821899 467.602814,295.751221 468.458740,295.747498 
	C470.212097,295.492676 471.593658,295.170929 473.293365,294.930054 
	C474.048401,295.032410 474.485352,295.053925 474.922272,295.075439 
	C475.348938,295.820068 475.775604,296.564667 476.240540,297.633118 
	C463.871521,298.125549 463.840302,298.125702 463.904724,310.757111 
	C463.941071,317.880371 464.100403,325.003021 463.900513,332.592041 
	C463.364471,333.063690 463.132294,333.069183 462.900146,333.074677 
	C462.101227,326.074280 461.302277,319.073883 460.552551,311.193054 
	C460.431854,303.198608 460.261902,296.084656 460.146271,288.644470 
	C460.170837,287.878815 460.141144,287.439331 460.129578,286.701172 
	C459.841705,286.172882 459.535675,285.943237 459.213531,285.276123 
	C459.576874,281.035217 459.956329,277.231750 460.718933,273.359863 
	C462.392334,273.205963 463.682526,273.120575 465.432068,273.115417 
	C470.171265,273.250336 474.451080,273.304993 478.730927,273.359650 
	C478.819641,274.011993 478.908356,274.664368 478.960754,275.650452 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M369.746063,540.832031 
	C370.801819,531.781677 370.576202,523.214111 364.087677,515.634399 
	C361.272675,512.345947 359.973022,507.760315 357.956451,503.398987 
	C358.935394,503.975159 360.196503,504.756287 360.908051,505.884125 
	C364.621063,511.769135 368.362671,517.649109 371.730835,523.732117 
	C373.019775,526.059937 373.343811,528.921997 374.450073,532.226440 
	C375.064606,535.861511 375.336517,538.810852 375.438599,542.102661 
	C375.153534,543.185303 375.038361,543.925476 374.707184,544.881714 
	C374.015442,545.737915 373.539673,546.377869 372.833069,547.134888 
	C372.660095,547.825562 372.717957,548.399170 372.824554,549.427307 
	C372.839600,552.931580 372.805939,555.981323 372.561218,559.244141 
	C372.582489,560.300598 372.814789,561.143799 373.278198,562.141724 
	C373.905579,562.913879 374.301819,563.531250 374.698120,564.499512 
	C374.892792,565.521973 375.087402,566.193604 374.932312,567.009888 
	C373.375977,567.440186 372.169403,567.725952 370.716980,567.801147 
	C368.245056,565.521790 366.018951,563.453125 363.929504,561.064941 
	C364.381134,559.915161 364.696106,559.084900 365.375366,558.194580 
	C366.756195,557.047058 367.772675,555.959534 368.810730,554.859680 
	C368.832367,554.847351 368.860718,554.806580 369.043854,554.791138 
	C369.306854,554.684875 369.469849,554.536072 369.453400,554.512512 
	C369.324463,554.327820 369.161102,554.167053 369.050232,553.591187 
	C368.952881,552.387085 368.813690,551.590759 368.709778,550.428955 
	C368.469208,548.385803 368.193451,546.708130 368.195923,544.834045 
	C368.898132,543.369141 369.322083,542.100586 369.746063,540.832031 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M629.292053,597.114929 
	C629.579651,597.063477 629.805176,596.916626 630.352478,596.331665 
	C633.936584,593.149170 637.136780,590.309265 640.336975,587.469421 
	C640.336975,587.469421 640.188721,587.394165 640.617737,587.382507 
	C643.429810,586.152832 645.812866,584.934814 649.190674,583.208374 
	C646.956055,587.359802 645.437195,590.181458 643.662354,593.133545 
	C642.653442,593.844971 641.900452,594.426025 640.804321,595.077393 
	C635.604675,603.076599 630.748169,611.005554 625.621338,618.736877 
	C624.153076,616.671692 622.955078,614.804199 621.765015,612.546021 
	C624.279297,607.141907 626.785645,602.128418 629.292053,597.114929 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M647.597900,650.805298 
	C644.439514,649.433289 641.596558,647.962708 638.655579,646.724670 
	C632.467285,644.119568 627.570984,638.664490 629.149780,632.485291 
	C629.340637,631.738464 629.945068,631.097229 630.992676,630.258301 
	C631.829346,630.154907 632.031128,630.200256 632.258606,630.587402 
	C639.717834,632.028687 647.151367,633.128296 654.696472,634.596863 
	C653.423340,635.616333 652.090942,636.440674 650.641724,636.877136 
	C648.441467,637.540039 646.160095,637.933533 643.506226,638.501099 
	C640.110840,638.985962 636.821228,638.949890 636.130493,642.102661 
	C643.380615,645.562378 650.171387,648.802856 656.897034,652.302856 
	C656.496643,652.977173 656.161316,653.391907 655.826050,653.806641 
	C655.487610,653.779297 655.149109,653.751953 654.446228,653.436279 
	C653.426331,652.731750 652.770874,652.315613 652.115479,651.899414 
	C651.619202,651.610596 651.122864,651.321838 650.062744,650.969788 
	C649.318420,650.902466 649.137939,650.898438 648.957520,650.894409 
	C648.594666,650.866943 648.231750,650.839478 647.597900,650.805298 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M617.979736,566.015076 
	C617.715881,568.843872 617.452026,571.672729 617.471558,574.664612 
	C615.048035,580.987732 610.460632,584.950134 603.918579,586.574890 
	C603.750793,586.616516 603.403625,585.935791 603.378662,585.026672 
	C606.020447,579.468567 608.595215,574.545654 610.684021,569.424622 
	C611.107483,568.386414 609.696899,566.600037 609.113892,564.769226 
	C609.530762,562.512390 609.965515,560.644958 610.487488,558.403198 
	C611.140930,559.023865 611.542053,559.504822 612.039062,559.846558 
	C612.470642,560.143372 613.010620,560.282410 613.502686,560.491211 
	C613.976318,560.247681 614.449890,560.004211 614.923462,559.760681 
	C613.365295,554.619751 611.807068,549.478821 610.189880,544.143188 
	C610.477539,544.118774 611.253418,544.052917 612.137634,544.201660 
	C612.440125,544.685059 612.693237,544.875305 613.041321,545.345093 
	C617.438965,551.815430 618.574097,558.706543 617.979736,566.015076 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M344.136414,214.007721 
	C342.550507,216.524048 340.964600,219.040359 339.116821,221.767258 
	C338.572571,221.589493 337.987671,221.138885 338.052887,220.822098 
	C339.153778,215.473526 334.585876,213.209900 332.189728,209.737305 
	C330.599182,207.432281 327.565002,205.846634 328.488037,202.046402 
	C328.659576,201.340286 326.052277,199.959198 324.363403,198.942413 
	C323.999390,198.995209 324.029144,199.016769 324.029144,199.016769 
	C323.582977,198.337524 323.136841,197.658279 322.346924,196.988602 
	C322.003174,196.998169 322.037842,197.027542 322.037842,197.027542 
	C320.819092,195.456848 319.600311,193.886154 318.175415,192.049774 
	C318.252197,191.364990 318.434906,189.735275 318.314667,187.734970 
	C318.011475,186.912704 318.011292,186.461014 318.377686,186.009644 
	C320.123993,186.348907 321.503693,186.687836 323.098694,187.289795 
	C325.169708,188.795944 327.025482,190.039078 328.894775,191.608826 
	C328.457611,193.117569 328.006927,194.299667 327.487762,195.661362 
	C329.225616,195.415512 330.502838,195.234833 331.823151,195.292297 
	C331.866272,195.530426 331.996582,195.996582 331.987244,196.408539 
	C331.915405,205.460815 340.997894,207.631836 344.136414,214.007721 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M653.250244,519.216858 
	C660.541077,513.984131 663.705994,505.843506 668.021057,498.540253 
	C668.569214,497.612549 669.422119,496.864929 670.541992,496.441040 
	C670.985718,499.337494 670.732422,501.872498 671.117371,504.306549 
	C671.900024,509.254272 673.027344,514.147522 674.012695,519.063171 
	C672.404236,520.347839 672.404236,520.347839 669.817444,516.801453 
	C668.832520,518.732483 668.004028,520.356873 667.161133,522.293457 
	C662.595703,521.576904 658.044617,520.548096 653.250244,519.216858 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M675.840027,560.814575 
	C678.381165,557.672180 680.727234,554.338623 683.542480,551.464722 
	C685.043457,549.932556 687.355530,549.194824 689.704712,548.489136 
	C690.747498,551.906616 691.387146,554.933350 692.055542,558.346313 
	C693.302185,559.517639 694.520081,560.302856 695.709229,561.497559 
	C695.536316,563.534607 695.392029,565.162170 695.121826,567.196777 
	C695.404663,573.811646 696.954102,574.836304 703.087280,573.340271 
	C698.389465,577.836670 693.743225,581.981689 688.809814,585.914673 
	C688.539246,584.289001 688.555969,582.875366 688.641785,581.133789 
	C689.136169,579.532593 689.561462,578.259277 690.216553,576.867065 
	C690.403503,576.149170 690.360779,575.550232 690.162231,574.894714 
	C690.006531,574.838196 689.709473,574.985046 689.845154,574.586670 
	C689.951660,572.789856 689.922546,571.391418 689.998657,569.629028 
	C689.999878,568.524292 689.895813,567.783630 689.846436,566.659424 
	C689.539978,564.517029 689.178772,562.758240 688.740356,560.680420 
	C687.918640,557.752625 687.174133,555.143921 686.395508,552.415527 
	C683.108093,555.117981 679.542480,558.049011 675.942505,560.938843 
	C675.908203,560.897522 675.840027,560.814575 675.840027,560.814575 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M370.962830,568.011719 
	C372.169403,567.725952 373.375977,567.440186 375.116272,567.008850 
	C375.649963,566.863220 375.980225,567.026550 375.998077,567.383911 
	C377.517212,570.239746 379.476898,572.100708 382.370789,570.033813 
	C385.734467,567.631409 385.874084,564.393982 383.693176,560.653625 
	C383.452698,559.228699 383.244507,558.136108 383.387878,557.049805 
	C384.530487,556.420288 385.321472,555.784302 386.174622,554.841675 
	C386.300507,554.122681 386.364288,553.710510 386.728271,553.133545 
	C387.166168,551.907898 387.303864,550.846985 387.525818,549.484131 
	C387.727783,548.780945 387.845490,548.379700 387.963196,547.978516 
	C389.691803,548.140930 391.488068,548.075195 393.121338,548.559204 
	C393.975861,548.812439 394.544189,550.031372 394.643616,550.917969 
	C390.216797,549.730591 392.595825,553.186951 391.469482,554.386230 
	C391.187531,555.797729 391.111816,556.943176 391.027496,558.288696 
	C391.018890,558.488831 391.055267,558.887634 390.744873,559.139771 
	C390.064087,565.234802 389.693665,571.077576 389.217773,577.220947 
	C389.113525,577.946167 389.114807,578.370850 388.970703,579.107178 
	C388.134705,579.992188 387.444092,580.565491 386.458221,580.986023 
	C381.096252,576.559387 376.029541,572.285583 370.962830,568.011719 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M474.042480,517.186768 
	C472.232910,520.032654 470.089386,519.316589 467.970764,517.457642 
	C465.828613,515.578064 464.605652,516.045715 462.264709,517.993713 
	C456.602478,522.705383 451.216431,528.441040 442.760803,528.090637 
	C441.442993,528.035950 440.080200,529.068176 438.382446,529.787415 
	C438.026703,529.976990 438.043488,529.923035 438.023132,529.622375 
	C437.417236,528.897705 436.831665,528.473694 436.159698,527.727661 
	C436.099701,526.963196 436.126099,526.520813 436.423248,525.984314 
	C436.854401,525.358337 437.014740,524.826416 437.514679,524.251099 
	C439.236176,523.416565 440.618073,522.625305 442.343506,521.792175 
	C448.122467,518.836548 453.557861,515.922791 458.993256,513.009094 
	C463.916138,514.332947 468.839020,515.656860 474.042480,517.186768 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M295.174011,209.039917 
	C296.570312,208.709320 297.966614,208.378708 299.583740,208.368378 
	C300.998749,209.474609 302.266602,211.015121 303.373596,210.907120 
	C306.898315,210.563248 310.363129,209.605988 313.851105,208.885712 
	C316.165253,210.397552 318.306946,212.371735 320.833496,213.314133 
	C324.734619,214.769272 326.775787,217.190811 326.718353,221.467560 
	C325.835541,221.205734 325.211761,220.748978 324.354218,220.049500 
	C321.547455,214.969513 317.004486,213.670059 312.099945,213.613327 
	C308.812408,213.575317 305.792725,214.647552 305.701904,219.144257 
	C303.007355,221.245285 300.593506,223.170364 297.912384,224.953674 
	C297.413055,224.491119 297.181000,224.170334 297.110321,223.561249 
	C298.358246,222.080215 299.884186,221.051270 300.407074,219.648438 
	C300.923859,218.261826 300.427277,216.497528 300.285767,214.510025 
	C299.472900,213.474136 298.814484,212.367996 298.015533,212.254944 
	C293.006195,211.546021 291.351868,215.177948 289.505676,218.966125 
	C287.988892,219.619354 286.812286,220.210907 286.787750,220.223251 
	C285.323639,217.731201 284.163086,215.755798 283.000488,213.478088 
	C282.995636,212.772736 282.992828,212.369690 283.355560,211.804016 
	C287.538757,210.774246 291.356384,209.907074 295.174011,209.039917 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M669.910461,564.905884 
	C671.656189,563.582275 673.401917,562.258667 675.493835,560.874817 
	C675.840027,560.814575 675.908203,560.897522 675.851440,561.290894 
	C676.000305,564.174561 676.122864,566.677979 676.512939,569.138977 
	C676.563721,569.459351 677.991455,569.561523 679.129150,569.837585 
	C679.943726,569.953430 680.410706,569.996399 680.888428,570.405579 
	C680.823303,571.500977 680.747253,572.230164 680.440430,573.238708 
	C679.956970,576.175476 679.704285,578.832886 679.337097,581.868469 
	C681.228394,584.509766 683.234131,586.772888 685.001526,589.284729 
	C678.236694,594.413818 671.710205,599.294128 665.126404,603.714600 
	C665.103149,601.417786 665.137207,599.580933 665.499756,597.836060 
	C671.037903,599.145081 673.889099,596.447876 674.601013,589.317383 
	C674.547180,588.250854 674.440063,587.546509 674.478699,586.414429 
	C674.110291,581.850403 673.596130,577.714050 673.066895,573.172424 
	C672.955139,571.120667 672.858398,569.474243 672.774048,567.493103 
	C672.810242,566.489624 672.834106,565.820923 672.796631,564.884888 
	C672.169556,564.741394 671.603821,564.865173 670.812500,565.027222 
	C670.586914,565.065491 670.135071,565.137329 670.078735,565.079590 
	C670.022461,565.021912 669.910461,564.905884 669.910461,564.905884 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M599.139954,303.044006 
	C597.281189,306.529022 595.422363,310.014038 593.182190,314.214111 
	C590.324646,310.824097 588.366455,308.500977 586.018982,305.716125 
	C585.378418,307.091003 584.955078,307.999573 584.437317,309.110748 
	C583.559204,305.048920 582.718445,301.160004 582.347778,296.746582 
	C588.233154,296.180511 593.648499,296.138977 599.118530,296.527161 
	C599.162109,298.985901 599.151001,301.014923 599.139954,303.044006 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M487.351837,633.992188 
	C484.072266,633.427307 481.138123,632.791565 478.484222,631.694763 
	C480.441956,631.089294 482.119446,630.944885 483.796936,630.800476 
	C483.952271,630.341797 484.107635,629.883179 484.262970,629.424500 
	C481.676544,627.264343 479.090149,625.104187 476.352356,622.633545 
	C475.491943,621.841248 474.782959,621.359497 474.121338,620.883057 
	C474.168732,620.888428 474.224518,620.811035 474.186401,620.451172 
	C471.845337,614.796631 469.542389,609.501953 467.481018,603.825317 
	C467.811188,603.155518 467.899750,602.867554 468.260406,602.803345 
	C472.994232,609.036682 477.455994,615.046326 481.950500,621.408813 
	C484.027863,624.369873 486.072388,626.978088 488.116913,629.586365 
	C488.686340,629.228210 489.255768,628.870056 489.825165,628.511841 
	C490.307404,623.851074 489.912079,619.366150 486.559082,615.202637 
	C486.330750,614.630737 486.165955,614.317383 486.137604,614.064331 
	C486.274048,614.124512 486.543915,613.997375 486.543915,613.997375 
	C487.522736,614.691406 489.103027,615.205200 489.374573,616.111206 
	C490.456451,619.720703 491.820526,623.474243 491.704559,627.130798 
	C491.631470,629.434326 489.116760,631.660522 487.351837,633.992188 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M443.165161,337.148132 
	C441.757965,335.125275 440.677856,333.260468 439.508148,331.095825 
	C441.253876,331.937012 444.066162,332.656067 444.770020,334.285767 
	C450.442657,347.419556 455.645233,360.755249 461.148315,373.963867 
	C463.661438,379.996033 466.780609,385.781952 469.163879,391.860291 
	C471.565857,397.986359 473.396210,404.336548 475.181335,410.799438 
	C469.875946,399.639404 464.749054,388.318237 459.887299,376.884369 
	C454.299805,363.743683 448.947021,350.503235 443.165161,337.148132 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M389.030457,496.984161 
	C389.030457,496.984161 389.467499,497.044769 389.747131,497.406586 
	C391.826538,499.815826 393.467773,502.038269 395.475311,503.856323 
	C397.139313,505.363281 399.235016,506.393555 400.813660,507.812256 
	C399.028412,507.784271 397.568970,507.579010 395.934753,507.033813 
	C385.448151,507.481323 378.689026,501.191681 371.971436,494.787994 
	C371.156464,494.011139 370.164124,493.420349 369.253967,492.743317 
	C369.253967,492.743317 369.106232,492.319092 369.365112,491.881226 
	C369.822388,490.840790 370.020782,490.238190 370.219177,489.635590 
	C370.360687,489.357483 370.587219,489.226562 371.099609,489.280396 
	C376.250214,491.218262 381.199951,493.118622 386.592834,495.391724 
	C387.700775,496.170990 388.365601,496.577576 389.030457,496.984161 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M552.853821,295.831818 
	C551.944092,299.971008 551.034363,304.110168 550.112549,308.627991 
	C549.085510,310.342987 548.070496,311.679382 546.844360,313.293793 
	C544.537354,310.831909 542.692444,308.863129 540.407532,306.469940 
	C538.353149,303.992676 536.738831,301.939789 535.124451,299.886932 
	C535.024292,298.925293 534.924133,297.963684 535.307922,296.485992 
	C541.479187,295.923889 547.166504,295.877838 552.853821,295.831818 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M483.113739,333.122833 
	C483.371399,325.524445 483.823181,325.060913 490.960541,325.077515 
	C494.792542,325.086426 498.630280,325.229706 502.454712,325.064331 
	C505.567169,324.929749 507.281281,325.929382 506.649780,329.916290 
	C505.347198,331.071808 504.443237,331.814087 503.418549,332.066864 
	C499.134338,333.123718 494.851532,334.418274 490.491821,334.844360 
	C488.111267,335.076996 485.578094,333.747742 483.113739,333.122833 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M527.007812,276.005280 
	C527.007812,276.005280 526.540588,276.063232 525.981567,276.055420 
	C524.964233,276.085236 524.505798,276.122833 523.586792,276.066956 
	C508.667236,276.231750 510.984924,272.642517 511.077515,288.961182 
	C511.082092,289.769409 511.394867,290.575836 511.505981,291.739441 
	C511.611237,293.532593 511.774719,294.969452 511.939880,296.664429 
	C511.956482,297.265900 511.971344,297.609283 511.986237,297.952637 
	C511.545166,302.968719 510.738892,307.985443 510.747528,313.000732 
	C510.760925,320.764587 511.330688,328.527496 511.388977,336.586639 
	C510.107025,327.557922 509.100616,318.233337 508.286865,308.310669 
	C508.362183,306.817322 508.244843,305.922119 508.185028,304.560425 
	C508.149780,298.724518 508.057007,293.355042 507.964233,287.985596 
	C507.995178,286.604431 508.026123,285.223297 508.122711,282.998474 
	C508.120728,279.769989 508.053131,277.385193 508.121155,274.679657 
	C514.325623,274.320404 520.394714,274.266174 526.462891,274.317535 
	C526.649292,274.319122 526.826416,275.417969 527.007812,276.005280 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M595.996643,495.995117 
	C591.029236,495.829346 588.669739,498.198853 589.002319,503.593811 
	C589.000000,504.000000 588.997070,504.003906 588.997070,504.003906 
	C583.955261,501.753479 583.888367,500.957703 588.713013,494.425110 
	C602.743042,491.568726 616.237915,488.764099 629.848633,486.737000 
	C633.375183,486.211792 637.264282,488.121643 640.785828,489.017456 
	C640.584778,489.121887 640.136169,489.185577 639.708862,489.113312 
	C637.545044,489.054535 635.808655,489.068054 633.782593,489.060242 
	C633.305359,489.086884 633.117737,489.134857 632.630005,489.173615 
	C631.930786,489.191193 631.531799,489.217987 630.691162,489.175354 
	C622.875671,490.282318 614.985596,489.457977 608.654175,494.676208 
	C607.067871,494.836029 605.481628,494.995789 603.188721,495.165466 
	C601.902344,495.714691 601.322571,496.254059 600.742798,496.793427 
	C599.356506,497.475403 597.970276,498.157379 596.320496,499.066345 
	C595.980469,498.395355 595.903870,497.497406 596.064941,496.253296 
	C596.200562,495.936493 596.098572,495.965820 595.996643,495.995117 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M497.336670,572.008606 
	C493.798492,572.595886 490.582062,573.129944 487.365631,573.663940 
	C487.705078,573.380005 488.044495,573.096008 488.383942,572.812073 
	C486.053253,571.065308 483.722565,569.318604 481.504028,567.271240 
	C482.079071,566.642395 482.541962,566.314270 483.384155,565.943298 
	C490.416534,570.728943 496.116516,568.422729 501.832825,563.566284 
	C503.892334,562.860596 505.590637,562.123596 507.571625,561.273560 
	C508.228363,560.701355 508.602417,560.242126 509.355469,559.763184 
	C512.106262,559.213196 514.478149,558.682922 517.129089,558.084473 
	C517.598938,557.998657 517.789734,557.981079 517.980469,557.963562 
	C518.025269,558.137817 518.070068,558.312012 518.115601,559.124634 
	C517.200378,561.139099 516.538757,562.827759 515.313904,563.824097 
	C512.981689,565.721252 510.327850,567.223022 507.807556,568.888916 
	C506.991943,569.056152 506.176300,569.223389 504.793701,569.662903 
	C502.471832,570.595520 500.716949,571.255920 498.962036,571.916260 
	C498.527496,571.929321 498.092957,571.942322 497.336670,572.008606 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M640.136169,489.185577 
	C640.136169,489.185577 640.584778,489.121887 641.074219,489.006104 
	C642.036682,488.566498 642.509766,488.242615 642.982849,487.918762 
	C643.409363,488.590668 643.835876,489.262604 644.605530,490.014954 
	C644.948669,490.095337 644.986877,490.177856 644.989014,490.536530 
	C644.986023,491.618835 644.980835,492.342499 644.975586,493.066101 
	C632.482056,497.564911 619.988586,502.063751 607.214722,506.842560 
	C603.618103,507.024628 603.864685,505.396423 605.981445,504.056610 
	C608.511902,502.454987 611.399292,501.377563 614.207703,500.264008 
	C618.296997,498.642639 622.453857,497.191742 627.200134,495.411072 
	C631.924316,493.164520 636.030212,491.175049 640.136169,489.185577 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M719.337219,513.200256 
	C719.568665,511.442200 719.384399,509.491089 720.097107,507.956573 
	C725.866394,495.534821 731.101074,482.875031 732.625610,469.189392 
	C733.532959,461.044006 732.928894,452.734924 733.118225,444.502045 
	C733.173706,442.087067 731.681885,438.888428 736.180542,438.387573 
	C736.737366,439.500610 736.848022,440.253174 736.827393,441.367126 
	C736.766602,442.486694 736.837158,443.244965 736.782837,444.400696 
	C736.711731,446.180420 736.765442,447.562653 736.629761,449.278625 
	C736.397156,451.723572 736.353943,453.834778 736.181641,456.383972 
	C735.828003,459.459534 735.640198,462.100861 735.372986,464.734131 
	C733.855347,479.688232 728.946411,493.699860 723.218384,507.793030 
	C721.777039,509.761688 720.557129,511.480957 719.337219,513.200256 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M389.116058,578.795471 
	C389.114807,578.370850 389.113525,577.946167 389.585571,577.227112 
	C392.815857,577.418457 397.267914,579.225281 396.710205,574.595337 
	C396.061523,569.210510 393.044464,564.110962 391.055267,558.887634 
	C391.055267,558.887634 391.018890,558.488831 391.317688,558.069946 
	C391.636230,556.474182 391.656006,555.297180 391.675781,554.120239 
	C392.595825,553.186951 390.216797,549.730591 394.355957,551.083557 
	C395.884491,552.410339 397.102539,553.675232 398.779144,555.340881 
	C400.509735,557.494446 401.781769,559.247253 403.013702,561.405518 
	C402.652435,563.897522 402.331268,565.984070 401.729919,568.136841 
	C400.519196,568.300476 399.588684,568.397949 398.247375,568.538452 
	C398.866974,570.099670 399.444611,571.554993 400.049744,573.388000 
	C399.735992,576.545410 399.394745,579.325195 398.680176,582.020081 
	C395.829193,581.382202 393.351593,580.829224 390.674622,580.065918 
	C390.022156,579.502197 389.569122,579.148865 389.116058,578.795471 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M527.917297,523.041809 
	C531.355774,525.975952 534.806763,528.895752 538.211426,531.868591 
	C538.517944,532.136292 538.525208,532.746765 539.046814,534.356384 
	C536.400696,532.974670 534.556335,532.011658 532.175171,530.727539 
	C526.681946,527.446899 522.000977,523.805176 516.711853,521.668945 
	C505.546143,517.159241 494.062408,513.437134 482.709137,509.391846 
	C479.738892,508.236389 476.768616,507.080933 473.423279,505.494934 
	C472.705261,504.696533 472.362335,504.328705 472.140137,503.734741 
	C472.536560,503.312378 472.812225,503.116150 473.399658,502.936829 
	C474.128540,502.975342 474.545624,502.996979 475.173828,503.298523 
	C487.925751,508.048615 500.466522,512.518799 513.365967,517.036560 
	C518.455505,519.070068 523.186401,521.055908 527.917297,523.041809 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M625.000000,525.980225 
	C626.260254,525.701843 627.520569,525.423401 628.780823,525.145020 
	C628.885376,524.828796 628.989929,524.512512 629.094421,524.196289 
	C627.836121,523.673950 626.464966,523.322754 625.348389,522.585693 
	C623.974182,521.678589 622.812256,520.449707 622.211548,519.146057 
	C625.605713,519.487427 628.346863,520.042603 631.088074,520.597778 
	C631.510437,520.707397 631.932739,520.817017 632.874817,521.180664 
	C633.977539,521.475220 634.560486,521.515808 635.143494,521.556396 
	C635.143494,521.556396 635.126526,521.709045 635.102600,522.175415 
	C637.738708,524.063354 640.398804,525.484863 643.365479,527.085144 
	C647.696228,528.902710 651.720459,530.541626 655.990723,532.320007 
	C656.531799,532.932678 656.826660,533.405823 657.076538,534.314575 
	C656.993591,535.039734 656.955750,535.329285 656.574158,535.462769 
	C654.482361,534.552917 652.734375,533.799133 650.986328,533.045288 
	C647.094971,531.197876 643.203613,529.350525 639.312317,527.503113 
	C639.045105,528.015320 638.777893,528.527588 638.510681,529.039795 
	C641.206970,530.514465 643.903259,531.989197 647.555786,533.986877 
	C645.602905,534.335999 644.576111,534.519592 643.419373,534.726379 
	C643.810913,535.587219 644.187927,536.416260 644.564941,537.245300 
	C644.341980,537.537842 644.119019,537.830383 643.896057,538.122925 
	C641.491821,536.445862 639.087585,534.768799 636.144287,532.761902 
	C632.068787,530.953857 628.532532,529.475708 624.998108,527.998779 
	C625.000000,528.000000 625.002441,528.002441 625.003723,527.665527 
	C625.003296,526.879150 625.001648,526.429749 625.000000,525.980225 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M384.135254,381.826782 
	C388.117249,385.063995 392.002472,388.820190 396.091461,392.339722 
	C397.604034,393.641602 399.595703,394.386902 401.610352,395.231506 
	C402.021210,395.049683 402.190582,395.022430 402.629883,395.400482 
	C403.573425,397.535980 404.247070,399.266174 404.920746,400.996399 
	C404.920746,400.996399 404.942261,401.491058 404.491943,401.756653 
	C400.371033,402.000000 396.700409,401.977753 393.029785,401.955505 
	C392.105957,401.487305 391.182159,401.019073 390.077942,399.935699 
	C387.639893,396.490997 385.382324,393.661407 383.124725,390.831848 
	C383.124725,390.831848 383.044281,390.409302 382.993042,389.887085 
	C382.898743,388.942474 382.855713,388.520081 382.812683,388.097687 
	C386.933838,386.972931 383.979095,384.266510 384.135254,381.826782 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M692.026794,557.960144 
	C691.387146,554.933350 690.747498,551.906616 690.060852,548.452759 
	C690.013855,548.025635 690.126587,547.644043 690.149170,547.446899 
	C694.757751,542.869263 699.343750,538.488892 704.944397,533.139404 
	C704.944397,538.337646 704.944397,542.293640 704.664062,546.766418 
	C703.390869,548.568542 702.397949,549.853882 701.198975,550.947388 
	C700.669617,551.187744 700.346375,551.619873 700.014648,552.023926 
	C700.006226,551.995972 700.057434,552.024231 699.704956,551.967651 
	C696.910522,553.927368 694.468689,555.943787 692.026794,557.960144 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M528.744385,342.303436 
	C529.587463,342.601776 530.765930,343.212891 530.760742,343.813812 
	C530.567749,366.237091 530.265503,388.659454 529.956848,411.552917 
	C529.040039,412.023285 528.144470,412.022614 526.911865,412.027222 
	C526.585754,402.679352 526.596619,393.326172 526.943604,383.263367 
	C527.109802,380.690674 526.940002,378.827667 526.770264,376.964630 
	C526.752136,374.610992 526.734009,372.257385 527.042664,369.160797 
	C527.262390,364.614807 527.155396,360.811768 527.048340,357.008728 
	C527.119263,355.319458 527.190063,353.630188 527.636597,351.411316 
	C527.987183,349.589020 527.962036,348.296387 527.936829,347.003723 
	C528.133789,345.539642 528.330750,344.075531 528.744385,342.303436 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M572.394409,277.009247 
	C573.234192,278.278229 573.861084,279.416748 574.724976,280.776764 
	C574.631897,295.575012 574.385620,310.154602 573.891296,324.725800 
	C573.806519,327.225128 572.664124,329.688538 571.604248,332.490784 
	C570.500610,329.545593 569.803101,326.278137 568.940063,322.977112 
	C568.774475,322.943542 568.436707,322.937042 568.410706,322.551086 
	C569.417542,313.954163 570.450439,305.743134 571.592529,297.300903 
	C571.420288,295.224915 571.138794,293.380096 571.167542,291.200562 
	C571.547729,286.178833 571.617676,281.491821 571.687622,276.804840 
	C571.687622,276.804840 572.181519,276.878815 572.394409,277.009247 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M588.988342,628.990601 
	C593.638306,629.754333 595.039124,626.215271 597.092285,623.185974 
	C601.299133,616.979065 605.804138,610.974182 610.569336,604.922729 
	C610.952271,604.959290 611.027405,605.017639 611.027405,605.017639 
	C609.359009,614.358276 605.192505,622.248474 597.746094,628.537354 
	C597.894714,628.926636 597.978149,628.909424 597.687134,628.638428 
	C596.903564,628.536621 596.411011,628.705933 595.581726,629.020996 
	C595.494568,630.131165 595.802063,631.942444 595.984680,631.929932 
	C598.010010,631.791321 600.015930,631.370056 602.027100,631.025146 
	C602.736450,630.922180 603.445740,630.819153 604.514038,630.710205 
	C603.912842,635.328247 599.613892,633.765991 596.830200,634.836426 
	C595.085327,635.507507 592.888733,635.004089 590.443665,635.042969 
	C589.992493,635.058411 589.976685,635.022034 589.934509,634.694031 
	C589.264404,633.910706 588.636475,633.455383 588.008484,633.000122 
	C588.001465,632.550964 587.994507,632.101868 588.003235,631.018433 
	C588.342102,629.919678 588.665222,629.455139 588.988342,628.990601 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M773.975708,183.016541 
	C774.617249,181.217010 769.786377,179.848419 773.889404,177.610229 
	C774.213684,177.418594 774.533813,177.408157 774.434082,177.836578 
	C775.170532,178.879410 776.006714,179.493820 776.842896,180.108215 
	C777.904785,181.463852 778.966736,182.819489 780.161621,184.468231 
	C773.214600,188.133301 770.232544,195.993362 763.219116,199.769165 
	C762.417358,199.626770 762.070862,199.651947 761.724304,199.677139 
	C762.156067,199.778198 762.587891,199.879257 763.019653,199.980331 
	C762.824585,204.333649 760.235596,204.979324 756.285522,204.046112 
	C755.506653,203.265717 754.646912,202.431992 754.780212,201.811768 
	C755.075623,200.437653 755.869629,199.170776 756.138916,198.573288 
	C757.979187,197.079453 759.449768,195.885696 760.960510,194.345688 
	C761.000610,193.999451 761.009888,193.990875 761.009888,193.990875 
	C763.637451,191.799606 766.313477,189.663208 768.874512,187.396790 
	C770.437256,186.013794 771.822876,184.430725 773.728271,183.063141 
	C774.232910,183.235184 774.297180,183.281616 774.361511,183.328049 
	C774.232910,183.224213 774.104309,183.120377 773.975708,183.016541 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M385.220490,523.370728 
	C385.220490,523.370728 385.237396,523.150269 385.141418,522.764160 
	C384.577087,521.226074 384.108734,520.074219 383.696655,518.498413 
	C384.050323,515.057800 385.162354,514.529114 387.881287,516.206421 
	C391.436340,518.399536 395.283966,520.118347 399.155182,522.331482 
	C403.052460,524.167786 406.764252,525.813354 410.572662,527.191956 
	C411.565796,527.551514 412.859894,527.079529 414.383972,526.972900 
	C415.488434,526.964478 416.224670,526.972534 416.958313,527.412964 
	C416.555695,528.228333 416.155731,528.611328 415.779236,528.947815 
	C415.802734,528.901367 415.874786,528.834656 415.883820,529.094055 
	C415.906860,529.526001 415.920837,529.698486 415.555817,530.009460 
	C414.466553,530.509094 413.756256,530.870300 412.907959,530.893677 
	C410.458740,529.363708 408.147583,528.171570 404.879791,526.485962 
	C405.490021,529.384644 405.840057,531.047363 405.800964,532.622986 
	C400.255432,530.439880 395.099030,528.343811 389.678528,526.025879 
	C388.016479,524.992859 386.618469,524.181763 385.220490,523.370728 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M355.993439,232.402313 
	C356.412415,231.927063 356.835114,231.927521 357.680176,232.340027 
	C358.275604,235.191315 358.448639,237.630585 358.541260,240.522629 
	C358.616455,244.718613 358.772095,248.461807 358.873383,252.613770 
	C358.577667,259.312683 358.336365,265.602844 358.011780,272.253723 
	C358.450348,273.953094 358.972260,275.291687 359.214478,276.987244 
	C358.725861,281.973022 358.516907,286.601868 358.284302,291.490601 
	C358.506927,292.190979 358.753265,292.631409 358.998871,293.035828 
	C358.998138,292.999756 358.926025,293.001923 358.952393,293.369324 
	C360.771790,297.392426 362.564850,301.048126 364.257141,304.788208 
	C364.156372,304.872589 363.956207,305.042938 363.956207,305.042938 
	C358.690643,301.098297 355.967712,295.907715 355.981750,289.257324 
	C356.021393,270.464325 355.996582,251.671143 355.993439,232.402313 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M458.962708,512.611511 
	C453.557861,515.922791 448.122467,518.836548 442.246643,521.444336 
	C439.876617,520.410400 437.946991,519.682434 436.258301,518.687378 
	C439.761902,518.094116 441.559326,516.540955 441.428650,512.973083 
	C447.096313,513.770203 449.905731,511.093048 451.264832,506.353271 
	C451.232849,506.337830 451.287292,506.292236 451.567993,506.225220 
	C452.034332,505.830109 452.220001,505.502045 452.657654,504.971405 
	C453.451447,503.839691 453.993317,502.910583 454.535156,501.981445 
	C456.000854,505.392273 457.466522,508.803101 458.962708,512.611511 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M497.232330,309.873444 
	C496.368530,308.904114 495.504700,307.934784 494.299561,306.514221 
	C492.346954,303.677460 490.735657,301.291992 489.124329,298.906494 
	C489.030853,298.216492 488.937378,297.526489 489.331299,296.325256 
	C494.886505,295.897400 499.954254,295.980804 505.040466,296.509583 
	C505.046783,299.643280 505.034698,302.331604 505.022644,305.019958 
	C504.759583,305.493500 504.496521,305.967041 503.909119,306.897339 
	C503.369690,308.206329 503.154633,309.058594 502.939575,309.910828 
	C502.821686,310.229919 502.629913,310.495667 501.797302,310.832397 
	C499.897705,310.595642 498.565002,310.234558 497.232330,309.873444 
z"
      />
      <path
        fill="#2C4E1C"
        opacity="1.000000"
        stroke="none"
        d="
M438.928955,474.535217 
	C438.949646,473.570160 438.990295,473.052643 439.478607,472.271637 
	C441.696777,471.809326 443.610657,471.977722 445.214478,471.351715 
	C455.285004,467.420990 465.286499,463.313354 475.310822,459.264221 
	C475.310822,459.264252 475.468994,459.692535 475.282043,459.821838 
	C472.667419,461.695435 470.366943,463.661713 467.786865,465.140106 
	C461.417664,468.789734 454.808960,472.032013 448.536133,475.833374 
	C446.409210,477.122284 444.986633,479.584015 443.268646,481.533112 
	C442.267792,482.668701 441.319336,483.850464 440.347321,485.011444 
	C439.881195,484.868805 439.415100,484.726166 438.948975,484.583496 
	C438.948975,481.383270 438.948975,478.183014 438.928955,474.535217 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M426.942017,580.689880 
	C427.056396,581.019531 426.873779,581.407776 426.465698,581.664001 
	C422.705566,580.950928 419.353546,579.981567 416.000092,579.005005 
	C415.998688,578.997681 415.985657,578.998047 415.894836,578.778503 
	C415.580688,578.291077 415.296387,578.182251 414.568268,578.151184 
	C413.403564,578.061768 412.621796,578.053650 411.552826,577.882507 
	C409.845612,575.785095 408.425568,573.850769 407.108154,571.578796 
	C407.175018,568.519531 407.139252,565.797852 407.372284,563.233398 
	C409.054504,564.277771 410.467926,565.164978 412.059143,566.327942 
	C413.835022,567.706299 415.433167,568.808838 417.031281,569.911438 
	C417.475067,570.279053 417.918854,570.646667 418.807800,571.376160 
	C421.483490,573.492249 423.713989,575.246521 425.944489,577.000732 
	C426.238892,578.120544 426.533264,579.240417 426.942017,580.689880 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M416.960938,526.980591 
	C416.224670,526.972534 415.488434,526.964478 414.318848,526.627808 
	C411.281433,524.729370 408.436584,523.446777 406.135040,521.516296 
	C403.340057,519.171997 401.164246,518.799805 399.005768,522.041138 
	C395.283966,520.118347 391.436340,518.399536 387.881287,516.206421 
	C385.162354,514.529114 384.050323,515.057800 383.444641,518.272522 
	C382.420013,517.660095 381.703705,516.849731 380.987366,516.039307 
	C380.746338,515.284485 380.505280,514.529724 380.598145,513.319519 
	C383.307434,511.988678 385.682861,511.113190 388.364380,510.397858 
	C395.719940,513.818420 402.769348,517.078857 410.040222,520.593079 
	C412.440765,522.053711 414.619843,523.260559 416.816406,524.650269 
	C416.833862,524.833130 417.171997,524.976624 417.135254,525.238159 
	C417.079590,525.674683 417.060608,525.849731 416.975250,526.280396 
	C416.957489,526.705322 417.006134,526.874512 417.019470,527.045532 
	C416.984161,527.047363 416.960938,526.980530 416.960938,526.980591 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M388.058289,510.237701 
	C385.682861,511.113190 383.307434,511.988678 380.529510,512.927002 
	C376.474670,506.496918 372.822296,500.003906 369.211975,493.127106 
	C370.164124,493.420349 371.156464,494.011139 371.971436,494.787994 
	C378.689026,501.191681 385.448151,507.481323 395.879272,507.412842 
	C394.574554,508.342987 393.089020,508.909882 391.741943,508.676697 
	C389.992432,508.373932 388.235321,507.141571 388.058289,510.237701 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M643.058838,526.906433 
	C640.398804,525.484863 637.738708,524.063354 635.105957,522.252136 
	C651.724182,524.542419 667.345520,529.871399 683.187134,538.900757 
	C680.616638,540.387146 679.195984,541.208679 677.266235,541.691467 
	C671.584534,535.186035 664.102295,533.338318 656.760254,530.540771 
	C652.035461,529.165833 647.547119,528.036133 643.058838,526.906433 
M641.515320,524.414246 
	C641.515320,524.414246 641.597107,524.536255 641.515320,524.414246 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M552.862305,566.946594 
	C552.955811,566.553894 553.049255,566.161133 553.526489,565.424194 
	C554.590271,565.063660 555.270386,565.047363 555.939331,565.418945 
	C553.273071,570.844727 550.617981,575.882629 547.660645,581.070679 
	C543.206299,584.430237 539.054138,587.639648 534.541992,590.894470 
	C530.504639,593.571411 526.827332,596.202942 523.150024,598.834473 
	C522.501160,597.384583 521.852234,595.934631 521.292114,593.907104 
	C522.966003,592.350464 524.551147,591.371582 526.494995,590.293701 
	C530.806091,588.171997 535.000732,586.508911 538.657288,584.046814 
	C544.992493,579.781006 550.465698,574.584717 552.862305,566.946594 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M454.404480,501.657227 
	C453.993317,502.910583 453.451447,503.839691 452.355164,505.017761 
	C451.629578,505.608582 451.458435,505.950409 451.287292,506.292236 
	C451.287292,506.292236 451.232849,506.337830 450.873291,506.203308 
	C447.196350,505.716949 443.849457,505.536804 440.568787,504.971924 
	C435.984985,504.182617 431.450562,503.106171 426.895020,502.152588 
	C429.173279,502.367737 431.452240,502.751099 433.729614,502.742096 
	C435.399811,502.735504 437.067993,502.214294 438.737091,501.922424 
	C438.199127,500.475281 437.714905,499.004913 437.105103,497.588684 
	C436.665924,496.568787 436.059418,495.620941 435.063812,493.786438 
	C440.424988,494.958618 444.960724,495.950348 449.937134,496.918030 
	C451.676483,498.373657 452.975128,499.853333 454.404480,501.657227 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M482.854004,509.695374 
	C494.062408,513.437134 505.546143,517.159241 516.711853,521.668945 
	C522.000977,523.805176 526.681946,527.446899 531.815796,530.691772 
	C533.649475,534.084229 535.305786,537.191467 536.964172,540.659119 
	C534.031860,538.001404 531.331421,534.703918 528.120483,532.016296 
	C517.261780,522.927368 503.863037,518.887634 491.008667,513.776001 
	C488.270996,512.687317 485.665344,511.266632 482.854004,509.695374 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M568.436707,322.937073 
	C568.436707,322.937042 568.774475,322.943542 568.885376,323.389008 
	C567.664612,331.958313 566.454163,340.104828 564.942627,348.195038 
	C564.326050,351.495087 563.056702,354.673187 562.084412,357.906769 
	C561.295410,354.920776 560.506470,351.934814 559.786865,348.554749 
	C559.837402,343.397125 559.818542,338.633514 560.143738,333.414673 
	C562.339966,330.416473 564.156494,327.846344 566.063538,325.345245 
	C566.741455,324.456207 567.639282,323.734924 568.436707,322.937073 
z"
      />
      <path
        fill="#EFE7D6"
        opacity="1.000000"
        stroke="none"
        d="
M552.956726,295.398071 
	C547.166504,295.877838 541.479187,295.923889 535.337769,296.124207 
	C530.338989,296.125214 531.040405,292.837616 531.413025,289.461426 
	C532.161072,288.815491 532.590698,288.644867 533.020325,288.474274 
	C533.460938,288.546021 533.901489,288.617798 534.667542,288.594238 
	C540.838013,288.498962 546.683105,288.498962 553.059631,288.498962 
	C553.059631,291.190765 553.059631,293.077545 552.956726,295.398071 
z"
      />
      <path
        fill="#394746"
        opacity="1.000000"
        stroke="none"
        d="
M562.074280,358.264282 
	C563.056702,354.673187 564.326050,351.495087 564.942627,348.195038 
	C566.454163,340.104828 567.664612,331.958313 569.050903,323.422577 
	C569.803101,326.278137 570.500610,329.545593 571.580933,332.894257 
	C571.467712,342.900879 569.447083,352.480835 565.708252,363.065491 
	C563.961731,360.935760 563.012939,359.778748 562.074280,358.264282 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M480.134827,466.398499 
	C481.192291,465.670959 482.249725,464.943390 483.944336,464.109924 
	C485.049744,463.993713 485.517975,463.983307 486.181458,464.224518 
	C488.850311,463.314209 491.323853,462.152283 494.045654,461.253632 
	C497.201843,460.349274 500.109772,459.181641 503.380219,457.976318 
	C506.183502,456.367828 508.624268,454.797028 511.409302,453.166687 
	C512.845886,452.742584 513.938171,452.378052 515.401001,451.974976 
	C516.993530,451.620850 518.215637,451.305176 519.335449,451.341309 
	C516.001465,453.783569 512.794189,455.913147 509.531555,457.954285 
	C505.707214,460.346924 501.834808,462.662689 497.989990,465.002899 
	C497.996796,464.994049 498.018494,464.987823 497.688049,464.947449 
	C496.919708,464.972198 496.481812,465.037292 495.702698,465.193726 
	C491.918823,466.865784 488.476166,468.446472 484.708862,469.879089 
	C482.694580,469.924927 481.001648,470.277466 479.316833,470.242249 
	C478.538635,470.225952 477.776276,469.452393 477.006714,469.022186 
	C477.006714,469.022186 476.836243,468.989563 477.170532,468.948944 
	C478.381531,468.071716 479.258179,467.235107 480.134827,466.398499 
z"
      />
      <path
        fill="#EFE7D6"
        opacity="1.000000"
        stroke="none"
        d="
M505.022034,296.064240 
	C499.954254,295.980804 494.886505,295.897400 489.369934,295.978851 
	C487.535492,295.644257 486.149841,295.144806 484.440521,294.528687 
	C484.367004,292.857788 484.290131,291.111053 484.186157,288.748291 
	C491.376068,288.748291 498.233124,288.748291 505.465179,289.336121 
	C505.567474,291.970703 505.294769,294.017456 505.022034,296.064240 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M569.843750,611.978333 
	C569.572693,611.085144 569.394104,609.950073 569.524475,609.913330 
	C574.810120,608.426636 580.123657,607.039062 586.496765,605.358398 
	C583.916809,611.772095 581.908752,616.764160 579.640381,622.403320 
	C576.307312,618.863037 573.193848,615.555908 569.843750,611.978333 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M483.042419,333.492676 
	C485.578094,333.747742 488.111267,335.076996 490.491821,334.844360 
	C494.851532,334.418274 499.134338,333.123718 503.418549,332.066864 
	C504.443237,331.814087 505.347198,331.071808 506.581726,330.330566 
	C507.470947,332.833923 508.085144,335.561401 508.625793,338.654572 
	C507.916626,338.990845 507.280975,338.961456 505.981812,338.956116 
	C504.861664,339.024811 504.405060,339.069397 503.629639,339.066345 
	C502.881287,339.025513 502.451782,339.032379 501.704773,338.977783 
	C499.933655,338.925690 498.480011,338.935028 496.711060,338.911072 
	C495.889191,339.192902 495.382690,339.508026 494.563171,339.871460 
	C493.827606,339.958405 493.405090,339.997101 492.776978,339.975677 
	C492.571411,339.915558 492.145905,339.865967 492.019287,339.696655 
	C491.609680,339.694702 491.326721,339.862030 491.032837,340.023010 
	C491.021942,340.016693 491.030792,340.052185 491.030792,340.052185 
	C488.321869,339.753540 485.612915,339.454865 482.511597,339.105713 
	C482.403137,337.324310 482.687103,335.593414 483.042419,333.492676 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M575.031860,409.978058 
	C574.531006,409.973999 574.030151,409.969971 573.154663,409.940033 
	C572.787292,398.254913 572.794617,386.595703 573.140625,374.166107 
	C573.385315,367.945709 573.291382,362.495667 573.197388,357.045654 
	C573.550537,354.337128 573.903687,351.628571 574.637451,348.497986 
	C575.297607,347.910767 575.579529,347.749573 575.910034,348.084686 
	C575.969849,367.607025 576.004272,386.637115 575.955322,405.666962 
	C575.951599,407.104797 575.353577,408.541077 575.031860,409.978058 
z"
      />
      <path
        fill="#EFE7D6"
        opacity="1.000000"
        stroke="none"
        d="
M599.063843,296.097443 
	C593.648499,296.138977 588.233154,296.180511 582.364502,296.361786 
	C576.459412,296.280975 578.132385,292.466614 578.043152,288.994843 
	C584.899475,288.994843 591.480530,288.994843 598.614014,289.439514 
	C599.132263,291.955261 599.098083,294.026337 599.063843,296.097443 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M500.448853,622.394775 
	C497.773865,617.022766 495.393097,611.476318 492.590698,604.947632 
	C499.036682,606.750000 504.500122,608.277649 510.543427,609.967407 
	C507.058411,614.324585 503.900757,618.272461 500.448853,622.394775 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M805.155762,216.832748 
	C804.251953,216.962952 803.523682,216.841171 802.428223,216.263458 
	C802.018677,215.180267 801.976318,214.552994 801.782532,213.606628 
	C797.747559,212.171738 793.864014,211.055954 789.980469,209.940155 
	C792.001587,208.959656 794.022705,207.979156 797.396423,206.342468 
	C794.670227,206.012955 792.471802,205.042175 790.988281,205.695282 
	C785.789429,207.984085 781.518921,205.875549 777.093994,203.285156 
	C783.441101,204.523895 789.712463,204.707657 794.166321,202.009079 
	C798.027161,203.256256 800.642273,204.067581 803.232117,204.952744 
	C804.406799,205.354279 805.531494,205.902328 806.852783,206.743439 
	C806.735168,207.552216 806.443604,208.001450 806.007324,208.676605 
	C801.787598,211.935455 805.737244,213.612701 807.017944,215.740784 
	C806.455750,216.020752 805.893494,216.300751 805.155762,216.832748 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M416.798950,524.467407 
	C414.619843,523.260559 412.440765,522.053711 410.138733,520.213135 
	C417.585175,516.788269 415.851837,511.200531 414.091064,505.710876 
	C413.351166,503.404083 412.247070,501.214142 411.308533,498.971069 
	C411.250885,498.793579 411.193207,498.616089 411.045258,497.967743 
	C410.832306,497.233734 410.628082,497.076477 410.342346,497.025116 
	C409.893585,495.931122 409.444824,494.837158 408.968140,493.388062 
	C410.975647,494.355316 413.011047,495.677673 415.415436,497.003052 
	C415.856018,497.172729 415.927612,497.339294 416.004028,498.112976 
	C416.388763,499.812439 416.768646,500.904785 417.111481,502.364868 
	C418.029877,505.227356 418.985352,507.722076 419.979431,510.550568 
	C423.020752,513.225037 426.023468,515.565735 428.791260,518.195190 
	C425.136230,517.681396 421.716125,516.878967 417.181824,515.815125 
	C417.067780,518.392639 416.933350,521.430054 416.798950,524.467407 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M517.928345,557.621216 
	C517.789734,557.981079 517.598938,557.998657 516.810547,557.918823 
	C511.123352,555.214417 505.978149,552.859802 499.994019,553.867493 
	C500.401825,552.682495 500.638184,551.669556 501.274780,551.120911 
	C505.484406,547.492920 510.341705,549.176025 515.076233,549.487732 
	C518.536133,549.715515 522.023132,549.532349 526.448608,549.532349 
	C525.295715,546.558411 524.622925,544.822998 523.647705,542.948792 
	C522.411560,541.612183 521.477722,540.414307 520.543945,539.216431 
	C523.984558,539.217529 529.955444,545.634766 528.682678,548.565552 
	C527.991577,550.156738 525.419922,551.477539 523.486450,551.861084 
	C520.189880,552.514893 516.727844,552.334167 513.335266,552.503967 
	C513.308655,553.045044 513.281982,553.586121 513.255310,554.127197 
	C514.795593,555.177734 516.335876,556.228271 517.928345,557.621216 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M386.428070,553.298279 
	C386.364288,553.710510 386.300507,554.122681 385.829773,554.746948 
	C382.151337,550.559326 378.879883,546.159790 375.608459,541.760193 
	C375.336517,538.810852 375.064606,535.861511 374.719788,532.467163 
	C374.646912,532.022095 374.945160,531.978577 375.288330,532.088013 
	C379.660248,536.507385 383.688965,540.817383 387.717712,545.127380 
	C387.762360,545.842285 387.807007,546.557190 387.907440,547.625305 
	C387.845490,548.379700 387.727783,548.780945 387.245880,549.653320 
	C386.730469,551.182495 386.579254,552.240356 386.428070,553.298279 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M584.016602,589.019104 
	C580.200745,590.729919 578.094788,595.932922 571.604126,594.480469 
	C574.410645,592.473694 576.486755,590.989258 579.069885,589.109497 
	C581.479370,586.664612 583.593689,584.770752 585.239441,582.532410 
	C588.483704,578.119873 591.468201,573.516296 594.906067,568.869873 
	C596.439331,568.114441 597.626709,567.480896 598.864136,567.191284 
	C598.927246,567.996094 598.940247,568.457092 598.909973,569.271790 
	C596.025146,577.704590 589.240845,582.764526 584.016602,589.019104 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M357.223083,500.800720 
	C356.219818,499.812622 355.508606,498.569397 354.499207,496.735291 
	C352.791229,491.221008 351.019226,486.367981 350.046021,481.359772 
	C347.939362,470.518707 346.241791,459.598175 344.453308,448.278961 
	C344.477570,444.879852 344.425446,441.911957 344.373291,438.944031 
	C344.470001,438.781464 344.566742,438.618927 344.814026,438.215698 
	C345.641296,442.135406 346.301636,446.298553 346.997864,450.455719 
	C349.033966,462.612427 351.026489,474.777130 353.201874,486.908966 
	C353.476349,488.439606 355.042267,489.706390 355.483398,491.246246 
	C356.355438,494.290253 356.859131,497.439758 357.223083,500.800720 
z"
      />
      <path
        fill="#3F8C82"
        opacity="1.000000"
        stroke="none"
        d="
M722.889771,445.608154 
	C720.793091,446.367218 718.760498,446.689575 716.399658,446.548645 
	C720.455017,438.807648 716.388489,432.578491 706.579346,432.027496 
	C705.859924,432.044861 705.449036,432.052582 704.799255,431.779388 
	C702.016541,430.671844 699.472656,429.845215 696.935547,428.785980 
	C696.934143,428.246704 696.932800,427.940002 696.938293,427.633240 
	C704.248596,429.462555 711.835144,430.599579 718.771057,433.367188 
	C723.311951,435.179138 723.555725,440.489136 722.889771,445.608154 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M298.179626,225.095459 
	C300.593506,223.170364 303.007355,221.245285 306.025940,219.295441 
	C311.524353,223.242096 317.307526,223.003952 323.066162,222.574844 
	C323.627014,222.533066 324.083191,221.086639 324.587982,220.292236 
	C325.211761,220.748978 325.835541,221.205734 326.697510,221.860352 
	C327.163544,225.427887 324.758240,225.946243 322.357025,225.858734 
	C317.768219,225.691559 313.191589,225.191086 308.028900,224.783020 
	C306.718384,228.995636 303.717590,231.042450 298.428406,227.730881 
	C298.118530,226.505981 298.149078,225.800720 298.179626,225.095459 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M601.118652,312.039490 
	C601.212646,309.319733 601.306641,306.599945 601.397888,303.134796 
	C601.503296,301.762817 601.611450,301.136261 601.760498,300.809143 
	C601.821045,301.308685 601.840820,301.508759 602.167664,301.936340 
	C603.236938,304.217590 604.465332,306.222931 604.684509,308.333069 
	C605.962341,320.638031 607.027039,332.965546 608.090393,345.291748 
	C608.204956,346.620636 607.847412,347.990265 607.449707,349.167480 
	C606.823486,348.800415 606.456482,348.606903 606.163452,348.017212 
	C605.433044,343.400452 604.628723,339.179810 603.824402,334.959198 
	C603.586060,333.217865 603.347717,331.476562 603.357971,329.079285 
	C603.419434,327.776428 603.232239,327.129517 603.045044,326.482605 
	C602.500000,322.236420 601.955017,317.990265 601.357544,313.119171 
	C601.304993,312.494263 601.118652,312.039490 601.118652,312.039490 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M576.883362,586.886536 
	C570.552856,590.606018 564.327393,594.526306 557.828735,597.924194 
	C555.843384,598.962341 553.107361,598.565063 550.715149,598.825195 
	C550.606445,598.277161 550.497742,597.729187 550.389038,597.181152 
	C551.488037,596.663940 552.587036,596.146729 554.296021,595.363953 
	C560.265930,591.395752 565.625671,587.693054 571.057434,584.349060 
	C573.375610,584.780273 575.621704,584.852844 577.800781,585.193726 
	C577.450195,585.936829 577.166748,586.411682 576.883362,586.886536 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M696.541504,427.459656 
	C696.932800,427.940002 696.934143,428.246704 696.533020,428.779816 
	C694.967041,428.920227 693.784302,428.635437 692.658020,428.782562 
	C687.741272,429.424927 682.181458,425.947113 677.952698,431.031525 
	C671.299805,425.698303 662.942139,426.034912 655.073730,423.887085 
	C664.748474,424.196503 674.594299,424.719025 684.420166,425.494476 
	C688.351013,425.804718 692.237915,426.672241 696.541504,427.459656 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M438.054138,529.970276 
	C438.081543,529.963562 438.019257,530.408936 438.013000,531.031494 
	C438.996918,534.770386 439.987122,537.886780 440.681213,540.982300 
	C439.923065,540.637695 439.461029,540.313965 438.880737,539.713867 
	C438.273926,538.836243 437.785431,538.235107 437.296936,537.633972 
	C436.866058,538.425049 436.435181,539.216187 435.992950,540.406616 
	C435.641235,542.905273 435.300873,545.004639 434.559265,547.055054 
	C428.870270,545.303162 423.997375,545.519531 419.733765,550.199646 
	C419.123749,552.150146 418.837708,553.954712 418.160950,555.829468 
	C417.508148,555.936035 417.246033,555.972412 416.983887,556.008850 
	C415.044525,552.438354 416.901581,549.872681 419.259216,547.447388 
	C420.479401,546.192200 421.718506,544.955383 423.365814,543.357666 
	C424.856720,542.330078 425.930908,541.655090 427.425873,540.967896 
	C431.510651,540.898193 435.658112,541.427368 434.504822,535.311035 
	C434.534058,534.858276 434.653015,534.652466 434.864075,534.231934 
	C434.633301,533.648926 434.426025,533.347351 434.045166,532.833130 
	C433.825134,532.443420 433.778778,532.266418 434.034271,531.916260 
	C435.001099,531.112854 435.666107,530.482666 436.617004,529.829163 
	C437.283112,529.844971 437.663300,529.884033 438.043488,529.923035 
	C438.043488,529.923035 438.026703,529.976990 438.054138,529.970276 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M697.678101,370.825562 
	C696.881836,374.969513 695.868774,379.064117 694.552734,383.623810 
	C692.080627,388.174042 691.597473,393.544525 685.964294,394.602020 
	C686.663574,391.829224 687.347595,389.431732 688.376160,386.967468 
	C688.773621,385.581024 688.826538,384.261322 688.886047,382.566589 
	C689.253235,380.487152 689.613708,378.782745 690.012756,376.629272 
	C690.067932,373.810120 690.084534,371.440002 690.407471,369.065155 
	C691.120300,369.026764 691.526917,368.993103 691.933472,368.959473 
	C692.082825,370.201324 692.232178,371.443207 692.483093,373.529114 
	C694.167358,372.516785 695.317566,371.825470 696.755432,370.879089 
	C697.043152,370.623993 697.461182,370.776215 697.678101,370.825562 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M555.203491,409.970978 
	C554.998535,409.973816 554.793579,409.976685 554.287109,409.512115 
	C553.976379,395.690338 553.967102,382.335968 553.966064,368.515381 
	C553.651917,361.029388 553.329651,354.009613 553.361450,346.996948 
	C554.189148,347.009003 554.662781,347.013947 555.158447,347.476288 
	C555.557739,351.634979 555.934998,355.336273 556.312134,359.037567 
	C556.387573,369.072174 556.463074,379.106812 556.141602,389.811676 
	C555.564331,396.978271 555.383911,403.474640 555.203491,409.970978 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M632.232910,630.245605 
	C632.031128,630.200256 631.829346,630.154907 631.321289,630.062439 
	C629.422363,629.341919 627.852722,628.156677 626.233459,628.084534 
	C619.546082,627.786255 618.921204,627.375244 619.046570,620.553223 
	C619.112366,616.975830 619.605530,613.406250 619.960205,609.418701 
	C621.849243,605.668335 623.580322,602.268188 625.584412,599.037354 
	C626.153442,598.119934 627.518005,597.695923 628.904907,597.080322 
	C626.785645,602.128418 624.279297,607.141907 621.546936,612.826965 
	C618.860779,618.422974 622.604309,621.868958 624.122925,626.218201 
	C627.677246,625.739990 631.041870,625.287292 634.854553,624.989136 
	C636.484741,625.622375 637.666748,626.100952 638.605164,626.828369 
	C636.318604,628.133301 634.275757,629.189453 632.232910,630.245605 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M377.073486,455.000122 
	C377.509430,454.424194 378.189697,453.286713 378.345581,453.354492 
	C382.151764,455.010437 381.800537,458.252197 381.596191,462.239807 
	C381.904449,464.778320 381.696503,466.641205 382.010590,468.411499 
	C382.471313,471.007874 383.305511,473.538025 383.980591,476.096375 
	C382.321014,476.889038 380.661438,477.681763 379.001892,478.474487 
	C378.571289,476.836426 378.140656,475.198395 377.464874,472.825867 
	C377.177612,468.999725 377.124420,465.908112 377.096832,462.816315 
	C377.073608,460.211060 377.080139,457.605530 377.073486,455.000122 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M527.300415,276.190308 
	C526.826416,275.417969 526.649292,274.319122 526.462891,274.317535 
	C520.394714,274.266174 514.325623,274.320404 507.855133,274.796753 
	C506.933075,275.487610 506.412567,275.740662 505.892059,275.993713 
	C505.852356,275.243225 505.812653,274.492767 506.144409,273.263855 
	C507.347931,272.265045 508.180023,271.744720 509.012085,271.224365 
	C516.090271,271.224365 523.168396,271.224365 530.442261,271.224365 
	C530.683960,274.154175 530.845093,276.107208 531.061279,278.841553 
	C531.109253,280.665833 531.102173,281.708740 531.095154,282.751678 
	C530.269165,285.468628 529.443237,288.185547 528.301758,290.949890 
	C527.825684,288.991272 527.569458,286.987244 527.527283,284.978729 
	C527.467041,282.112671 527.563538,279.243317 527.300415,276.190308 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M575.031738,410.299622 
	C575.353577,408.541077 575.951599,407.104797 575.955322,405.666962 
	C576.004272,386.637115 575.969849,367.607025 575.911255,347.832458 
	C575.893921,346.743073 575.921692,346.398193 576.221069,345.826019 
	C576.254578,344.371155 576.016479,343.143585 575.778381,341.916016 
	C575.767029,341.473175 575.755676,341.030365 576.240845,340.324890 
	C576.983337,340.096954 577.229248,340.131683 577.464844,340.222351 
	C577.454468,340.278290 577.577637,340.465820 577.701782,340.628174 
	C577.825989,340.790558 578.069824,341.118713 578.046997,341.574585 
	C577.680359,364.350128 577.336548,386.669830 576.992676,408.989532 
	C576.549988,410.088043 576.107239,411.186523 575.664551,412.285034 
	C575.453552,411.730408 575.242554,411.175781 575.031738,410.299622 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M545.023193,593.045166 
	C544.748535,592.686218 544.473816,592.327209 544.084595,591.495728 
	C547.728882,588.462830 551.487732,585.902405 555.575562,583.225708 
	C558.972473,580.887207 562.248169,578.895874 565.047058,576.375061 
	C567.599670,574.076050 569.635193,571.203003 572.137817,568.821838 
	C572.509827,569.691589 572.642761,570.322510 572.541199,571.176331 
	C570.192444,574.244141 568.078064,577.089050 565.672363,580.101807 
	C558.595093,584.528198 551.809143,588.786682 545.023193,593.045166 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M475.555878,321.067871 
	C474.432312,329.726318 473.039886,338.501343 471.410522,347.232117 
	C470.798889,350.509430 469.636871,353.683990 468.344971,356.971008 
	C467.202850,354.365479 466.441589,351.694366 465.667480,348.636047 
	C466.756256,346.915741 468.442291,345.743286 468.860443,344.222260 
	C470.904175,336.788452 472.604248,329.260315 474.459167,321.773804 
	C474.520538,321.526123 474.940155,321.367188 475.555878,321.067871 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M505.717316,276.371216 
	C506.412567,275.740662 506.933075,275.487610 507.719543,275.117493 
	C508.053131,277.385193 508.120728,279.769989 508.066284,282.587097 
	C501.194061,283.054199 494.442749,283.028778 487.694061,283.149811 
	C484.431000,283.208344 482.516113,282.252380 483.570221,278.301239 
	C485.279938,278.583862 486.716614,279.530853 488.194061,279.599457 
	C492.797119,279.813141 497.430359,279.899048 502.018311,279.568512 
	C503.254364,279.479431 504.371094,277.733887 505.717316,276.371216 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M420.062653,655.946533 
	C418.137085,655.491821 416.416656,654.735779 414.346039,654.044678 
	C413.282532,653.677612 412.569214,653.245483 412.185120,652.440125 
	C417.903809,653.624512 419.934753,650.752625 420.501221,645.987976 
	C420.694550,644.361877 420.818420,642.727539 421.385681,641.017578 
	C423.171448,640.821838 424.545563,640.705444 426.171448,640.804565 
	C426.666321,641.380493 426.909393,641.741028 426.983002,642.348511 
	C426.133026,643.323120 425.452545,644.050781 424.484741,644.953613 
	C423.127380,646.802917 422.057281,648.477173 420.216553,651.357117 
	C423.478302,650.249695 425.231476,649.654419 427.092072,649.216187 
	C427.450775,649.202393 427.702057,649.031616 428.245300,648.739563 
	C429.349426,648.417542 430.161591,648.216736 431.072693,648.188416 
	C431.439941,648.201355 431.708252,648.041809 432.315033,647.733643 
	C434.101929,647.272400 435.550385,646.959778 436.998810,646.647095 
	C435.846191,648.066528 434.976929,650.116516 433.487274,650.785828 
	C429.215424,652.705261 424.692200,654.065247 420.062653,655.946533 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M555.246582,583.342041 
	C551.487732,585.902405 547.728882,588.462830 543.800903,591.304199 
	C541.795593,592.111633 539.959473,592.638184 537.382324,593.092163 
	C536.061584,592.296021 535.481812,591.572510 534.902039,590.848999 
	C539.054138,587.639648 543.206299,584.430237 547.713501,581.395264 
	C548.930786,581.653015 549.875000,581.998291 550.636047,581.759521 
	C551.827454,581.385681 552.895020,580.616943 554.020447,580.387573 
	C554.432800,581.620422 554.839722,582.481201 555.246582,583.342041 
z"
      />
      <path
        fill="#F9EDD2"
        opacity="1.000000"
        stroke="none"
        d="
M736.958618,441.005768 
	C736.848022,440.253174 736.737366,439.500610 736.548767,438.372711 
	C736.556885,435.949646 736.643005,433.901947 737.019653,431.347260 
	C737.377441,430.730621 737.526245,430.558105 737.498230,430.521820 
	C737.350159,430.329529 737.157654,430.171478 736.980530,430.001587 
	C736.890808,427.949524 736.801025,425.897461 736.832153,423.420013 
	C743.417786,422.868622 741.335876,428.337006 742.850952,432.311157 
	C742.920044,437.328827 742.735229,441.652496 742.456665,445.836456 
	C742.362976,445.696777 742.062683,445.545227 742.015137,445.304199 
	C741.634155,444.716766 741.300781,444.370331 740.722900,444.013611 
	C740.478394,444.003326 739.990540,443.962616 739.957520,443.623657 
	C738.935913,442.525055 737.947266,441.765411 736.958618,441.005768 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M756.169250,225.118958 
	C756.208679,220.641449 760.271057,215.996445 765.615784,213.979584 
	C767.019348,213.449936 768.178589,212.272675 769.964478,211.482239 
	C774.332886,212.266434 778.186768,212.961182 781.984253,214.056000 
	C781.624512,216.304504 781.321167,218.152908 780.615723,220.003632 
	C779.410583,220.042877 778.607483,220.079773 777.536255,219.897873 
	C771.143433,214.087784 765.053833,215.182022 759.244019,222.914795 
	C758.024109,223.682541 757.096680,224.400742 756.169250,225.118958 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M468.260925,665.842773 
	C464.560822,664.518738 461.258118,663.281616 457.955414,662.044495 
	C458.193176,661.364136 458.430939,660.683716 458.668701,660.003357 
	C469.289520,662.482910 479.910339,664.962463 490.531128,667.442017 
	C482.943146,670.085083 475.855377,667.372314 468.260925,665.842773 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M458.568420,555.333923 
	C462.201752,557.113281 466.714844,557.257874 468.321381,563.430054 
	C463.889374,563.430054 459.809082,564.197876 456.222717,563.196533 
	C453.138641,562.335388 450.985107,559.383789 454.966248,555.879883 
	C456.192444,555.536499 457.191345,555.442078 458.568420,555.333923 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M385.174652,523.758484 
	C386.618469,524.181763 388.016479,524.992859 389.712585,526.360107 
	C391.247009,528.645508 392.385406,530.455994 393.739960,532.086975 
	C396.630402,535.567139 404.119995,536.723450 407.361450,534.252869 
	C408.978607,534.035217 410.213470,533.796204 411.823120,533.678284 
	C413.874023,532.532104 415.550110,531.264771 417.447083,530.196960 
	C417.859833,530.742310 418.051727,531.088135 418.303467,531.733948 
	C418.375000,532.644531 418.386749,533.255249 418.079224,534.045105 
	C417.506500,535.143799 417.253052,536.063232 416.999603,536.982788 
	C410.943726,536.996765 404.870026,537.280640 398.841431,536.882141 
	C396.656281,536.737671 394.099670,535.424683 392.556885,533.828796 
	C389.747986,530.923035 387.570007,527.407410 385.174652,523.758484 
z"
      />
      <path
        fill="#30655D"
        opacity="1.000000"
        stroke="none"
        d="
M544.797119,593.294434 
	C551.809143,588.786682 558.595093,584.528198 565.710815,580.432495 
	C566.412109,581.115906 566.783691,581.636414 567.075989,582.491882 
	C562.329529,586.213928 557.662354,589.601013 552.995117,592.988159 
	C548.016296,595.137695 543.037476,597.287292 538.058716,599.436829 
	C537.799500,598.924316 537.540344,598.411804 537.281128,597.899231 
	C539.711121,596.447449 542.141113,594.995605 544.797119,593.294434 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M500.222137,531.734619 
	C499.873932,531.971985 499.688995,531.958557 498.918701,532.037415 
	C497.645355,532.312317 496.957367,532.495056 496.066345,532.292114 
	C490.347809,531.230896 484.832306,530.555359 479.229919,529.558105 
	C480.319427,528.077820 481.495819,526.919250 482.672211,525.760620 
	C489.392365,523.289368 495.175140,525.344360 500.800476,529.682983 
	C501.069580,529.906799 501.233521,529.924988 501.233521,529.924988 
	C500.950806,530.444641 500.668091,530.964233 500.222137,531.734619 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M553.120728,593.276855 
	C557.662354,589.601013 562.329529,586.213928 567.397095,582.399292 
	C570.593506,578.691589 573.389587,575.411377 576.414062,571.979492 
	C577.104858,571.551331 577.567322,571.274902 578.108154,571.385986 
	C575.786194,575.845703 573.385803,579.918030 570.985413,583.990356 
	C565.625671,587.693054 560.265930,591.395752 554.559937,595.152466 
	C553.891296,594.659546 553.568787,594.112488 553.120728,593.276855 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M471.547913,656.905151 
	C471.158630,655.724792 471.166962,654.563416 471.681213,653.059875 
	C473.760345,652.444275 475.819397,652.707520 476.820282,651.801697 
	C480.579102,648.399719 483.992584,644.616272 487.535461,640.975708 
	C487.871277,640.674377 488.207092,640.373047 488.769104,640.003906 
	C489.010071,640.117676 489.024841,640.299194 489.032501,640.997681 
	C489.025421,641.514648 489.041260,642.009033 489.041260,642.009033 
	C488.998901,643.377869 488.956543,644.746704 488.652008,646.743408 
	C486.397552,653.350525 480.522522,654.300171 475.968231,656.960632 
	C474.627319,656.948486 473.286407,656.936279 471.547913,656.905151 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M589.733948,667.187561 
	C598.707825,665.233948 607.426025,663.500000 616.148254,661.786377 
	C617.579468,661.505249 619.028381,661.313782 620.661560,661.953613 
	C610.914795,667.188232 600.476624,669.700012 589.159302,670.151978 
	C589.027649,669.153564 589.253601,668.283813 589.733948,667.187561 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M459.963593,487.011261 
	C457.939117,487.769073 455.914612,488.526917 453.910065,489.277283 
	C452.768097,484.622833 459.883026,476.943207 469.743347,473.224518 
	C470.469330,473.978302 470.717255,474.472748 470.850433,475.178711 
	C470.536377,475.654968 470.279907,475.840912 469.574768,475.954712 
	C468.197662,476.358276 466.749603,476.473511 466.306641,477.200867 
	C464.376068,480.370575 462.737732,483.718292 460.735870,487.005188 
	C460.306854,487.009766 460.135223,487.010498 459.963593,487.011261 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M626.372437,656.904419 
	C621.676453,654.373047 617.207092,651.990723 613.011047,649.197815 
	C612.236755,648.682556 612.567749,646.506592 612.785767,645.457031 
	C614.600403,646.819275 615.885132,648.182373 617.458435,648.761047 
	C623.939209,651.144409 630.507446,653.289734 637.043579,655.522583 
	C636.698792,656.184265 636.352844,657.416504 636.009338,657.415833 
	C633.620667,657.411255 631.232544,657.150757 628.408447,656.994995 
	C627.546204,656.982361 627.119812,656.947144 626.372437,656.904419 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M643.918335,593.003174 
	C645.437195,590.181458 646.956055,587.359802 649.190674,583.208374 
	C645.812866,584.934814 643.429810,586.152832 640.700806,587.385864 
	C640.928101,586.280457 641.215027,584.757080 642.124939,584.110474 
	C645.692200,581.575928 649.456177,579.318054 653.554565,576.960938 
	C653.961975,576.964539 654.051880,577.053894 653.955078,577.389526 
	C653.246887,579.481262 652.635498,581.237366 651.726257,583.280212 
	C651.257874,587.194885 651.087341,590.822876 650.901489,594.776123 
	C652.825989,594.411682 653.913025,594.205811 654.957825,594.366516 
	C651.582764,598.210327 650.821472,597.951172 647.875244,592.335571 
	C646.703674,592.896423 645.532593,593.458435 644.234436,593.773193 
	C644.044312,593.351746 643.981323,593.177429 643.918335,593.003174 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M377.894440,364.892822 
	C376.124725,363.220947 374.394867,361.135498 372.573608,358.715576 
	C372.326996,354.126526 372.351898,349.855682 371.970978,345.621399 
	C371.498779,340.371948 370.690399,335.152710 369.946045,329.523163 
	C374.485229,330.706024 373.300140,335.033813 373.892853,338.277283 
	C375.480835,346.967255 376.618042,355.739594 377.894440,364.892822 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M656.996826,530.786072 
	C664.102295,533.338318 671.584534,535.186035 676.901672,541.657104 
	C675.487427,542.570068 673.928772,543.178589 671.718018,543.867310 
	C669.728210,542.783875 668.479553,541.492920 667.034790,540.482422 
	C663.781982,538.207458 660.432007,536.071533 657.121582,533.878967 
	C656.826660,533.405823 656.531799,532.932678 656.155396,532.047241 
	C656.381592,531.351990 656.689209,531.069031 656.996826,530.786072 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M770.178345,210.105850 
	C771.644409,209.406937 773.215820,207.960983 774.556641,208.150024 
	C778.481689,208.703369 782.314819,209.908127 786.769043,211.228455 
	C790.864868,212.432678 794.375671,213.266113 797.936401,214.466156 
	C798.022766,215.574005 798.059082,216.315216 798.055176,217.374664 
	C797.982239,218.119324 797.949524,218.545746 797.614868,219.025467 
	C796.302185,219.695328 795.291443,220.311890 794.045166,220.660599 
	C791.906555,216.952942 789.609680,214.144562 785.004395,214.609940 
	C784.475952,213.839935 784.008667,213.399704 783.432739,212.645203 
	C778.942261,211.589233 774.560303,210.847534 770.178345,210.105850 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M657.296570,500.250275 
	C655.113831,504.046204 652.944885,507.850159 650.741821,511.634247 
	C649.837463,513.187561 648.859558,514.698120 647.885681,516.584900 
	C646.845581,516.993103 645.835022,517.044495 644.455994,516.971497 
	C647.155823,510.667511 650.224060,504.487885 653.891357,498.274414 
	C655.425842,498.910431 656.361206,499.580353 657.296570,500.250275 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M482.385132,525.519653 
	C481.495819,526.919250 480.319427,528.077820 479.131348,529.912109 
	C483.299286,537.464172 489.097961,538.170776 496.269379,532.677734 
	C496.957367,532.495056 497.645355,532.312317 498.685120,532.188416 
	C497.533630,535.822205 491.660767,538.797180 487.154877,538.539795 
	C481.952087,538.242615 478.047424,536.247009 476.019775,530.579407 
	C476.713257,528.158813 477.582672,526.269958 478.452087,524.381104 
	C478.855469,523.449646 479.258820,522.518188 479.927368,521.318481 
	C480.827759,522.459778 481.462921,523.869202 482.385132,525.519653 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M356.590515,322.100525 
	C357.268768,333.028168 357.550507,344.038422 357.471802,355.516785 
	C356.735809,355.996460 356.360229,356.008026 355.984619,356.019592 
	C355.660187,354.470337 355.073090,352.924103 355.055237,351.371307 
	C354.960632,343.130432 354.950653,334.887085 355.061218,326.646637 
	C355.081238,325.153992 355.798553,323.670715 356.590515,322.100525 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M797.916870,218.972168 
	C797.949524,218.545746 797.982239,218.119324 798.347046,217.348480 
	C799.070251,216.986252 799.461304,216.968460 799.852417,216.950653 
	C803.018982,220.883881 806.185608,224.817108 809.646545,228.912872 
	C810.227966,229.543442 810.514954,230.011490 810.904907,230.735352 
	C807.158142,230.974457 803.292480,231.152954 799.466919,230.840866 
	C798.022461,230.723038 796.670532,229.471085 795.141357,228.089478 
	C795.340454,226.622803 795.674500,225.802750 796.399902,224.992706 
	C802.764709,224.037384 799.537842,221.354904 797.916870,218.972168 
z"
      />
      <path
        fill="#3F8C82"
        opacity="1.000000"
        stroke="none"
        d="
M599.666016,584.731140 
	C598.417114,585.484009 597.168213,586.236877 595.549805,587.069946 
	C595.180298,587.150146 595.009094,587.009094 595.006226,586.603516 
	C594.986755,585.114990 594.970154,584.032043 595.026978,582.608398 
	C596.887573,578.834717 598.674744,575.401794 600.804688,571.973267 
	C603.186646,571.355957 605.225891,570.734253 607.232300,570.485046 
	C604.688354,575.482117 602.177185,580.106628 599.666016,584.731140 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M531.416382,282.814270 
	C531.102173,281.708740 531.109253,280.665833 531.218994,279.244324 
	C538.174377,278.880035 545.027039,278.894348 552.334229,278.907471 
	C553.669128,282.044769 552.349609,283.011322 549.273132,282.937012 
	C544.150085,282.813171 539.019409,283.009613 533.433411,283.185516 
	C532.562439,283.158844 532.150024,283.017853 531.416382,282.814270 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M520.246948,539.140259 
	C521.477722,540.414307 522.411560,541.612183 523.613647,543.322266 
	C522.627136,544.128113 521.372375,544.421753 520.039429,544.391418 
	C516.175049,539.196777 508.306946,537.806763 501.098633,540.261963 
	C501.056213,539.450500 501.084473,539.124634 501.112701,538.798828 
	C501.962189,538.023254 502.811646,537.247620 503.830383,536.169556 
	C506.070496,535.584473 508.141296,535.302002 510.927368,535.101807 
	C513.430542,535.731018 515.218445,536.277832 517.006409,536.824646 
	C517.987549,537.571106 518.968750,538.317627 520.246948,539.140259 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M777.804382,220.116684 
	C778.607483,220.079773 779.410583,220.042877 780.768921,220.331833 
	C781.953186,222.045944 782.239014,223.839783 783.290100,224.729172 
	C784.941956,226.126831 787.109558,226.915039 789.058716,227.961334 
	C781.002625,232.234879 781.002625,232.234879 775.167725,226.591553 
	C774.940308,225.368118 774.977539,224.674484 775.326355,223.835510 
	C776.360168,222.499008 777.082275,221.307846 777.804382,220.116684 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M577.155762,587.023926 
	C577.166748,586.411682 577.450195,585.936829 578.025391,584.946777 
	C580.504089,582.220398 582.690979,580.009155 585.190186,577.724609 
	C586.001709,576.767273 586.500854,575.883179 587.283691,574.807739 
	C589.404846,571.095093 591.242371,567.573914 593.372559,564.052246 
	C594.054016,564.069580 594.442749,564.087341 594.839844,564.513062 
	C594.752136,566.277893 594.656128,567.634827 594.560181,568.991760 
	C591.468201,573.516296 588.483704,578.119873 585.239441,582.532410 
	C583.593689,584.770752 581.479370,586.664612 579.263550,588.838989 
	C578.442871,588.362976 577.935547,587.762146 577.155762,587.023926 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M402.997833,468.008514 
	C403.629395,464.875977 404.260986,461.743439 405.067902,457.741241 
	C406.777252,460.253265 407.869110,461.857849 408.795563,464.158569 
	C408.380219,468.900726 408.130310,472.946716 407.880402,476.992737 
	C406.558624,476.993225 405.236877,476.993713 403.483612,476.543091 
	C403.034027,473.397491 403.015930,470.703003 402.997833,468.008514 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M600.461853,571.968811 
	C598.674744,575.401794 596.887573,578.834717 594.734131,582.750549 
	C593.542542,584.443787 592.717285,585.654175 591.879944,586.874878 
	C591.867859,586.885315 591.830933,586.873962 591.488892,586.938477 
	C590.101685,588.635742 589.056396,590.268494 588.011169,591.901306 
	C586.904480,590.978638 585.797791,590.055969 584.353882,589.076172 
	C589.240845,582.764526 596.025146,577.704590 599.340820,569.311218 
	C600.102234,569.019043 600.389404,569.041260 600.574097,569.418945 
	C600.468384,570.505920 600.465088,571.237366 600.461853,571.968811 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M430.973755,648.015930 
	C430.161591,648.216736 429.349426,648.417542 427.994446,648.746643 
	C427.295990,648.936340 427.140350,648.997742 426.984680,649.059204 
	C425.231476,649.654419 423.478302,650.249695 420.216553,651.357117 
	C422.057281,648.477173 423.127380,646.802917 424.563416,645.338623 
	C425.037567,645.852051 425.145813,646.155457 425.254089,646.458923 
	C431.143738,644.301453 437.035431,642.149536 442.909882,639.951416 
	C443.041138,639.902344 442.976318,639.329285 443.302979,639.003967 
	C444.314819,639.345459 445.026672,639.683594 445.738525,640.021667 
	C445.472198,645.011047 440.146118,643.582703 437.680817,646.371826 
	C437.393280,646.595947 437.189606,646.580017 437.094208,646.613525 
	C435.550385,646.959778 434.101929,647.272400 432.057739,647.717773 
	C431.299225,647.905640 431.136475,647.960815 430.973755,648.015930 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M789.475647,228.003540 
	C787.109558,226.915039 784.941956,226.126831 783.290100,224.729172 
	C782.239014,223.839783 781.953186,222.045944 781.171021,220.329498 
	C781.321167,218.152908 781.624512,216.304504 782.127136,213.893127 
	C782.731384,213.206589 783.136353,213.083023 783.541321,212.959473 
	C784.008667,213.399704 784.475952,213.839935 784.760742,214.832886 
	C784.647095,216.940170 784.170837,219.488022 784.879578,219.877045 
	C787.926147,221.549393 791.320923,222.587387 794.821045,223.908737 
	C795.371643,224.301590 795.690125,224.642151 796.008545,224.982712 
	C795.674500,225.802750 795.340454,226.622803 794.962280,227.777130 
	C793.242981,228.089508 791.567810,228.067642 789.475647,228.003540 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M657.076538,534.314575 
	C660.432007,536.071533 663.781982,538.207458 667.034790,540.482422 
	C668.479553,541.492920 669.728210,542.783875 671.377441,544.006348 
	C671.411499,545.872925 671.134155,547.680664 670.856750,549.488403 
	C669.728882,548.814697 668.601074,548.140991 667.189087,546.889404 
	C663.575989,542.747253 660.246948,539.183044 656.917908,535.618774 
	C656.955750,535.329285 656.993591,535.039734 657.076538,534.314575 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M466.934326,645.994873 
	C466.957672,651.688782 461.834198,651.891113 458.415253,653.539612 
	C455.358246,655.013550 451.806366,655.461121 448.216431,656.624634 
	C447.540131,656.901062 447.120209,656.914429 446.354797,656.581299 
	C445.993500,655.773804 445.977783,655.312866 446.136780,654.544189 
	C451.532227,652.130493 456.752991,650.024475 462.303253,647.840942 
	C464.066620,647.173950 465.500488,646.584412 466.934326,645.994873 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M376.823059,455.086914 
	C377.080139,457.605530 377.073608,460.211060 377.096832,462.816315 
	C377.124420,465.908112 377.177612,468.999725 377.293610,472.554382 
	C374.150574,473.527710 372.837006,472.265717 373.002899,468.921692 
	C373.200104,464.945496 372.988983,460.948975 372.919983,456.498322 
	C374.114349,455.748169 375.343475,455.460938 376.823059,455.086914 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M490.981049,588.967529 
	C499.785370,586.433228 508.589691,583.898865 517.393982,581.364563 
	C517.569580,581.744934 517.745178,582.125305 517.920776,582.505676 
	C513.737366,584.339600 509.564270,586.197449 505.367432,588.000061 
	C501.946503,589.469360 498.497131,590.872437 494.951660,592.657349 
	C493.777893,592.049194 492.712891,591.088501 491.316956,589.806396 
	C490.984375,589.312500 490.982697,589.140015 490.981049,588.967529 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M382.537506,387.909546 
	C382.855713,388.520081 382.898743,388.942474 382.924377,389.683289 
	C381.601532,389.466553 380.296051,388.931427 378.222260,388.081360 
	C378.345703,390.790009 378.453400,393.153534 378.288879,395.745483 
	C376.281464,389.837738 374.546234,383.701538 372.811005,377.565338 
	C373.457947,377.293213 374.104889,377.021057 374.751831,376.748932 
	C377.255341,380.406433 379.758820,384.063934 382.537506,387.909546 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M526.136292,590.392700 
	C524.551147,591.371582 522.966003,592.350464 521.185791,593.584717 
	C516.740112,594.806763 512.489441,595.773560 508.238831,596.740295 
	C508.088074,596.314880 507.937317,595.889526 507.786530,595.464111 
	C510.228210,593.647827 512.669922,591.831482 515.202148,589.575195 
	C515.292664,589.135193 515.427429,589.019165 515.573242,589.283813 
	C516.513184,589.747864 517.307373,589.947205 518.476135,590.132568 
	C521.199036,589.339417 523.547363,588.560242 525.936279,588.215332 
	C526.029968,589.230591 526.083130,589.811646 526.136292,590.392700 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M775.014771,223.980865 
	C774.977539,224.674484 774.940308,225.368118 774.854370,226.400681 
	C768.673218,227.965240 762.533691,230.349899 756.282837,226.085480 
	C756.134399,225.543182 756.113708,225.090500 756.113708,225.090500 
	C756.113708,225.090500 756.142700,225.084335 756.156006,225.101639 
	C757.096680,224.400742 758.024109,223.682541 759.482117,223.257111 
	C761.800781,223.978745 763.589966,224.763702 765.376770,224.758545 
	C768.590149,224.749283 771.802185,224.266068 775.014771,223.980865 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M459.879761,487.249451 
	C460.135223,487.010498 460.306854,487.009766 460.915070,487.269348 
	C462.211365,488.660492 463.071045,489.791260 463.955658,491.341919 
	C463.803894,494.523346 463.913727,497.028442 467.192566,498.212280 
	C468.024933,498.512817 468.439148,499.971497 468.795898,501.075256 
	C468.366028,501.823486 468.185760,502.394470 468.005524,502.965454 
	C465.005554,500.219971 462.005585,497.474487 459.291016,494.090942 
	C459.620789,491.798004 459.665161,490.143066 459.709564,488.488159 
	C459.738342,488.154633 459.767120,487.821136 459.879761,487.249451 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M600.100952,584.813782 
	C602.177185,580.106628 604.688354,575.482117 607.504089,570.277344 
	C608.249756,568.184326 608.690857,566.671448 609.131897,565.158630 
	C609.696899,566.600037 611.107483,568.386414 610.684021,569.424622 
	C608.595215,574.545654 606.020447,579.468567 603.401428,584.695801 
	C602.302429,584.919006 601.419189,584.907715 600.100952,584.813782 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M297.912354,224.953674 
	C298.149078,225.800720 298.118530,226.505981 298.109497,227.563217 
	C289.582153,228.452332 281.033295,228.989471 272.256592,229.265564 
	C272.805664,228.378616 273.582642,227.752716 274.951416,226.962250 
	C278.480530,226.006088 281.407166,221.943466 284.412781,226.821701 
	C284.631805,227.177170 286.004608,227.018143 286.762695,226.811325 
	C290.173553,225.880692 293.556152,224.846420 296.948944,223.849548 
	C297.181000,224.170334 297.413055,224.491119 297.912354,224.953674 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M476.688660,469.035339 
	C477.776276,469.452393 478.538635,470.225952 479.316833,470.242249 
	C481.001648,470.277466 482.694580,469.924927 484.596649,470.130127 
	C484.550690,471.381714 484.292236,472.234222 483.966705,473.432068 
	C480.713318,478.188293 476.735138,475.528931 472.996735,474.581116 
	C472.944061,473.326691 472.890076,472.489990 472.836090,471.653259 
	C474.014252,470.785004 475.192444,469.916718 476.688660,469.035339 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M417.029907,537.201416 
	C417.253052,536.063232 417.506500,535.143799 418.268066,534.040771 
	C418.776215,533.857178 419.120239,534.013672 419.217407,534.345703 
	C424.152740,538.985046 429.271759,538.059204 434.478882,535.491455 
	C435.658112,541.427368 431.510651,540.898193 427.059448,540.923706 
	C423.210480,539.881470 420.148804,538.871277 417.087097,537.861023 
	C417.087097,537.861023 417.060211,537.420166 417.029907,537.201416 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M639.708862,489.113312 
	C636.030212,491.175049 631.924316,493.164520 627.441895,495.154968 
	C625.919312,494.668793 624.811340,493.950653 623.617371,493.753693 
	C622.163879,493.513885 620.638062,493.712708 619.342529,493.091125 
	C623.405273,491.388550 627.269043,490.316650 631.132751,489.244751 
	C631.531799,489.217987 631.930786,489.191193 632.753540,489.318481 
	C633.475525,489.342224 633.773865,489.211884 634.072205,489.081573 
	C635.808655,489.068054 637.545044,489.054535 639.708862,489.113312 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M453.877533,429.116821 
	C451.922485,430.356628 449.967468,431.596466 447.776367,432.986023 
	C444.603180,430.593079 444.715820,430.440674 454.323578,425.491547 
	C453.184052,425.098450 452.195251,424.757324 450.991882,424.144653 
	C452.861511,423.540649 454.945709,423.208191 457.435211,422.921051 
	C458.451935,423.153412 459.063416,423.340424 459.798889,424.155151 
	C457.907776,426.227509 455.892639,427.672150 453.877533,429.116821 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M671.091431,651.223022 
	C666.715637,653.672974 662.339905,656.122925 657.579590,658.614258 
	C657.127991,657.423645 657.061035,656.191528 657.331421,654.438477 
	C657.775208,652.279968 657.881653,650.642334 658.342407,649.063232 
	C661.480286,650.857422 664.126343,652.888245 667.661865,650.426697 
	C668.307373,649.977295 669.923401,650.921936 671.091431,651.223022 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M434.960480,547.104065 
	C435.300873,545.004639 435.641235,542.905273 436.367249,540.402588 
	C437.501617,539.996216 438.250336,539.993225 438.999023,539.990234 
	C439.461029,540.313965 439.923065,540.637695 440.715332,541.198853 
	C441.045624,541.436279 441.099457,541.871338 441.099426,541.871338 
	C441.963226,543.373108 442.827026,544.874878 443.854706,546.684998 
	C442.782593,547.140503 441.546570,547.287659 439.971130,547.475220 
	C440.541321,549.175842 440.961182,550.428040 440.902527,551.840942 
	C440.127441,551.880981 439.832916,551.885803 439.403564,551.692017 
	C437.831268,549.946472 436.395874,548.525269 434.960480,547.104065 
z"
      />
      <path
        fill="#2C4E1C"
        opacity="1.000000"
        stroke="none"
        d="
M384.359558,475.997162 
	C383.305511,473.538025 382.471313,471.007874 382.010590,468.411499 
	C381.696503,466.641205 381.904449,464.778320 381.822144,462.502075 
	C385.529724,461.482452 388.599396,461.500305 386.073669,466.760925 
	C385.749084,467.436951 386.013062,468.395508 386.019989,469.612671 
	C385.603271,471.967377 385.170898,473.932678 384.359558,475.997162 
z"
      />
      <path
        fill="#0B6A39"
        opacity="1.000000"
        stroke="none"
        d="
M656.574158,535.462769 
	C660.246948,539.183044 663.575989,542.747253 666.934448,546.653442 
	C666.446716,546.985718 665.929565,546.976074 665.018555,546.953857 
	C659.693542,542.659058 654.761414,538.377686 649.837830,534.086670 
	C649.743347,534.004333 649.669434,533.732056 649.721558,533.677124 
	C649.928284,533.459229 650.189026,533.292603 650.708069,533.076172 
	C652.734375,533.799133 654.482361,534.552917 656.574158,535.462769 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M631.984253,427.962097 
	C631.536865,427.961334 631.089478,427.960571 630.064453,427.682861 
	C628.161438,427.405914 626.835999,427.405914 625.510498,427.405914 
	C625.528564,427.922791 625.546570,428.439667 625.564636,428.956543 
	C627.058289,428.956543 628.551941,428.956543 630.045593,428.956543 
	C630.564636,429.207367 631.083618,429.458191 631.577759,430.115479 
	C628.384094,430.394562 625.215271,430.267151 622.046509,430.139771 
	C621.241699,429.056641 620.436829,427.973511 619.575867,426.814850 
	C623.869751,425.614319 628.203003,424.402771 632.898193,423.039246 
	C633.260071,422.887268 633.666199,422.825928 633.810730,423.232056 
	C633.298279,425.079468 632.641296,426.520782 631.984253,427.962097 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M390.981262,471.400696 
	C390.842041,468.995789 390.729797,466.899506 390.617523,464.803223 
	C390.917236,464.457703 391.216949,464.112152 391.516632,463.766632 
	C392.652832,465.087158 394.419647,466.257141 394.779083,467.763092 
	C395.334198,470.088531 394.926392,472.643799 394.954163,475.556213 
	C394.299133,476.652191 393.617004,477.293488 392.934845,477.934814 
	C392.304779,477.217255 391.674744,476.499695 391.045166,475.063782 
	C391.040192,473.880402 391.034790,473.415375 391.029388,472.950348 
	C391.022339,472.536682 391.015289,472.122986 390.981262,471.400696 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M460.091980,288.970703 
	C460.261902,296.084656 460.431854,303.198608 460.436310,310.754272 
	C459.742371,311.156860 459.213898,311.117828 458.421021,311.104614 
	C458.126251,304.724670 458.095886,298.318909 458.085236,291.107239 
	C458.114166,289.846527 458.123352,289.391785 458.459229,288.921844 
	C459.221252,288.928009 459.656616,288.949341 460.091980,288.970703 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M410.931061,464.161133 
	C411.664948,463.783081 412.398804,463.405029 413.657959,463.407593 
	C414.779938,468.188782 415.376709,472.589386 415.973450,476.989990 
	C414.598785,476.992737 413.224121,476.995483 411.404785,476.535797 
	C410.950439,472.102600 410.940735,468.131866 410.931061,464.161133 
z"
      />
      <path
        fill="#35761E"
        opacity="1.000000"
        stroke="none"
        d="
M416.138885,477.222351 
	C415.376709,472.589386 414.779938,468.188782 413.993011,463.416840 
	C417.100433,461.093933 418.890503,462.503601 418.915985,465.861023 
	C418.944244,469.579956 418.321014,473.303864 417.946533,477.448395 
	C417.375824,477.732361 416.840088,477.593536 416.138885,477.222351 
z"
      />
      <path
        fill="#394746"
        opacity="1.000000"
        stroke="none"
        d="
M603.516907,334.984436 
	C604.628723,339.179810 605.433044,343.400452 606.019348,348.329590 
	C604.872009,349.691284 603.942688,350.344452 602.785828,351.010437 
	C602.558289,351.023224 602.112183,350.929901 602.074463,350.532227 
	C601.968628,349.073608 601.900452,348.012695 601.880249,346.637299 
	C601.886414,345.902618 601.844421,345.482391 601.857300,344.804260 
	C601.943848,344.373444 601.975586,344.200531 602.244995,343.925568 
	C602.355957,343.420593 602.229126,343.017700 602.144531,342.448181 
	C602.186768,342.281525 601.993225,341.997345 602.025269,341.750610 
	C602.057373,341.503845 601.906433,341.029602 601.958252,340.622192 
	C601.887329,338.837708 601.764526,337.460663 601.641724,336.083618 
	C601.703430,335.890381 601.765076,335.697144 601.907227,335.209442 
	C602.394958,334.946564 602.802185,334.978119 603.516907,334.984436 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M626.755493,559.325317 
	C627.018250,560.925537 627.917175,563.051941 627.427856,564.786682 
	C626.254272,568.947327 624.428467,572.923950 622.543091,577.113525 
	C622.145996,575.305359 622.071655,573.358643 621.949829,571.024231 
	C623.521667,566.982239 625.141052,563.327820 626.755493,559.325317 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M719.303467,513.187988 
	C720.557129,511.480957 721.777039,509.761688 723.360352,507.908966 
	C723.723755,507.775513 724.002441,508.001221 724.001953,508.397583 
	C723.515869,510.511230 722.749573,512.212830 722.652954,513.951782 
	C722.597595,514.949097 723.629272,516.006775 724.119507,517.336365 
	C723.494446,518.449829 722.921387,519.264221 721.939331,520.049438 
	C720.344849,520.670776 719.159302,521.321350 717.562988,521.982300 
	C716.331665,522.035339 715.511230,522.077942 714.536865,522.080383 
	C714.382996,522.040222 714.091492,521.904968 714.091492,521.904968 
	C714.091492,521.904968 714.329346,521.589539 714.402832,521.405640 
	C715.320251,520.134277 716.164124,519.046753 717.343872,517.433594 
	C718.191895,515.647888 718.703979,514.387939 719.216064,513.127930 
	C719.216064,513.127930 719.269653,513.175781 719.303467,513.187988 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M388.021240,544.939758 
	C383.688965,540.817383 379.660248,536.507385 375.380219,531.968506 
	C376.162079,531.459961 377.763092,530.612488 378.139832,530.989197 
	C381.580811,534.430542 384.876526,538.027100 388.033813,541.732544 
	C388.571503,542.363586 388.249542,543.727051 388.021240,544.939758 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M477.968201,571.082703 
	C478.992065,572.790588 480.015961,574.498474 481.020966,576.593323 
	C481.002106,576.980286 480.516876,577.027527 479.861542,577.016907 
	C476.462036,577.650208 473.717896,578.294067 470.973724,578.937927 
	C469.901520,578.961060 468.829285,578.984253 467.353577,579.019104 
	C466.046753,578.246521 465.143433,577.462341 464.490082,576.375183 
	C469.144928,577.523193 472.992157,576.767639 476.400421,573.080139 
	C477.105164,572.338196 477.536682,571.710449 477.968201,571.082703 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M534.541992,590.894470 
	C535.481812,591.572510 536.061584,592.296021 537.016357,593.115601 
	C532.883911,595.067139 528.376404,596.922607 523.509460,598.806274 
	C526.827332,596.202942 530.504639,593.571411 534.541992,590.894470 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M369.906372,328.758911 
	C365.836426,326.481049 361.809753,323.821533 357.440735,321.162537 
	C357.182190,319.927216 357.265991,318.691376 357.349792,317.455566 
	C357.823547,317.130676 358.297302,316.805786 358.771057,316.480896 
	C362.497253,320.446350 366.223450,324.411804 369.906372,328.758911 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M313.712585,208.561554 
	C310.363129,209.605988 306.898315,210.563248 303.373596,210.907120 
	C302.266602,211.015121 300.998749,209.474609 299.947113,208.390503 
	C304.599274,206.766190 309.112610,205.087738 313.712585,208.561554 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M653.916321,576.920532 
	C657.394897,570.873413 663.098877,567.675903 669.549683,564.940674 
	C669.910461,564.905884 670.022461,565.021912 669.989563,565.406250 
	C664.655029,569.545044 659.353455,573.299438 654.051880,577.053833 
	C654.051880,577.053894 653.961975,576.964539 653.916321,576.920532 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M439.540436,552.016296 
	C439.832916,551.885803 440.127441,551.880981 440.645844,552.032227 
	C441.066620,552.605591 441.265533,553.148438 441.713776,554.237000 
	C439.962738,555.817383 437.962341,556.851990 435.592346,557.896057 
	C434.483215,557.933655 433.743713,557.961731 432.545044,557.972717 
	C430.886780,557.784241 429.687622,557.612793 428.678192,557.166443 
	C431.266907,555.610352 433.665863,554.329163 436.427124,553.014160 
	C437.706390,552.658936 438.623413,552.337585 439.540436,552.016296 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M282.989990,211.966629 
	C282.992828,212.369690 282.995636,212.772736 282.939911,213.639328 
	C282.881378,214.102859 282.838135,214.442154 282.448425,214.296112 
	C279.727448,214.386047 277.396179,214.622040 275.064911,214.858017 
	C274.833405,214.602356 274.601868,214.346695 274.104004,214.039810 
	C273.603271,212.893509 273.368896,211.798416 273.351898,211.719009 
	C275.472565,209.834106 277.104736,208.383362 278.707581,206.556091 
	C280.313049,206.638794 281.947876,207.098022 283.575745,208.091827 
	C282.445831,209.368378 281.322845,210.110352 279.390228,211.387222 
	C281.260101,211.688187 282.125061,211.827408 282.989990,211.966629 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M365.955872,454.485474 
	C366.976868,455.094482 368.607788,455.982880 368.904724,457.197388 
	C369.468231,459.502197 369.267548,461.993774 369.650787,464.714600 
	C369.917267,466.884979 369.917267,468.748596 369.917267,470.612183 
	C369.384003,470.740295 368.850708,470.868378 368.317444,470.996490 
	C367.839966,469.952545 367.362518,468.908569 366.910217,467.065033 
	C366.650452,464.481598 366.365509,462.697784 366.080566,460.913940 
	C366.041565,458.913361 366.002533,456.912750 365.955872,454.485474 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M318.011108,186.009338 
	C318.011292,186.461014 318.011475,186.912704 318.012665,187.703384 
	C316.194366,191.960236 315.339935,186.283554 313.780579,187.616699 
	C312.052979,185.511673 310.325378,183.406631 308.290649,181.143433 
	C307.938538,180.823471 307.893555,180.661682 308.297668,180.249191 
	C311.497955,180.343109 314.249115,180.687729 317.009460,181.280151 
	C317.018585,181.527954 317.019287,182.024414 316.765320,182.226379 
	C317.011292,183.622009 317.511200,184.815674 318.011108,186.009338 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M489.080261,299.342010 
	C490.735657,301.291992 492.346954,303.677460 493.993530,306.396271 
	C493.922943,308.731262 493.817139,310.732910 493.711334,312.734589 
	C493.200714,312.794067 492.690094,312.853577 492.179504,312.913086 
	C488.668945,309.283081 490.163361,304.131897 489.080261,299.342010 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M630.691162,489.175354 
	C627.269043,490.316650 623.405273,491.388550 619.286865,492.748291 
	C615.850342,493.630524 612.668518,494.224915 609.070435,494.747742 
	C614.985596,489.457977 622.875671,490.282318 630.691162,489.175354 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M476.228882,657.250854 
	C480.522522,654.300171 486.397552,653.350525 488.645966,647.154236 
	C490.040131,650.732178 485.157166,657.493958 480.809479,657.939697 
	C479.397980,658.084412 477.931091,657.689270 476.228882,657.250854 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M411.881348,566.052185 
	C410.467926,565.164978 409.054504,564.277771 407.071289,563.081848 
	C405.352264,562.182129 404.203033,561.591064 403.053802,561.000061 
	C401.781769,559.247253 400.509735,557.494446 399.097534,555.436096 
	C399.361542,554.862061 400.012756,554.276306 400.134308,554.370911 
	C404.761505,557.973328 409.340149,561.638123 413.613464,565.649414 
	C412.828217,566.020203 412.354797,566.036194 411.881348,566.052185 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M283.355591,211.804016 
	C282.125061,211.827408 281.260101,211.688187 279.390228,211.387222 
	C281.322845,210.110352 282.445831,209.368378 283.779724,208.384033 
	C284.426422,208.066055 284.862244,207.990417 286.016388,207.895416 
	C288.815613,207.605850 290.896515,207.335678 292.977386,207.065491 
	C293.671875,207.503403 294.366394,207.941299 295.117432,208.709564 
	C291.356384,209.907074 287.538757,210.774246 283.355591,211.804016 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M797.886414,214.099533 
	C794.375671,213.266113 790.864868,212.432678 787.129395,211.300201 
	C787.705139,210.678894 788.505554,210.356628 789.643250,209.987259 
	C793.864014,211.055954 797.747559,212.171738 801.380310,213.626007 
	C800.048462,214.009491 798.967468,214.054520 797.886414,214.099533 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M493.797424,460.990356 
	C491.323853,462.152283 488.850311,463.314209 486.191650,463.910828 
	C486.019012,462.927155 486.031525,462.508850 486.044067,462.090515 
	C486.693481,461.539551 487.342896,460.988556 488.363159,460.160645 
	C488.885559,459.752472 489.007080,459.597565 489.098541,459.419006 
	C489.098541,459.419006 489.178375,459.244690 489.576355,459.066711 
	C490.309540,457.596710 490.644714,456.304688 491.343994,455.044678 
	C493.580353,455.762054 495.452576,456.447388 497.157288,457.416504 
	C495.925720,458.797028 494.861572,459.893707 493.797424,460.990356 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M555.278198,410.180786 
	C555.383911,403.474640 555.564331,396.978271 556.073792,390.214783 
	C556.516724,396.731598 556.630554,403.515533 556.547485,410.743652 
	C556.018005,410.922058 555.685425,410.656311 555.278198,410.180786 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M505.040466,296.509583 
	C505.294769,294.017456 505.567474,291.970703 505.899384,289.523468 
	C506.424927,288.777466 506.891266,288.431946 507.660950,288.036011 
	C508.057007,293.355042 508.149780,298.724518 507.931793,304.577972 
	C507.454620,305.092682 507.288177,305.123383 507.121765,305.154114 
	C507.024048,304.698730 506.926331,304.243347 506.828613,303.787964 
	C506.383057,304.091125 505.937500,304.394287 505.257294,304.858704 
	C505.034698,302.331604 505.046783,299.643280 505.040466,296.509583 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M465.005768,595.003296 
	C470.653015,595.648865 474.546967,599.074402 477.980896,603.616516 
	C477.923340,604.094055 477.733582,604.310547 477.393524,604.221802 
	C473.345795,601.783447 469.638123,599.433899 465.890228,596.807983 
	C465.537994,596.074402 465.225922,595.617249 464.913849,595.160095 
	C464.913849,595.160095 464.971588,595.053406 465.005768,595.003296 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M410.616730,464.126404 
	C410.940735,468.131866 410.950439,472.102600 410.992401,476.534515 
	C410.111908,477.167145 409.199127,477.338593 408.083374,477.251404 
	C408.130310,472.946716 408.380219,468.900726 408.835236,464.507629 
	C409.461029,464.137543 409.881714,464.114594 410.616730,464.126404 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M428.488464,557.441345 
	C429.687622,557.612793 430.886780,557.784241 432.544495,558.305908 
	C432.993622,559.099854 432.984192,559.543518 432.974762,559.987183 
	C428.010834,561.358276 423.064270,562.620239 419.146210,557.264526 
	C419.200989,556.755066 419.465454,556.442383 419.850403,556.484741 
	C422.986389,556.831909 425.737427,557.136597 428.488464,557.441345 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M556.489014,358.671692 
	C555.934998,355.336273 555.557739,351.634979 555.171875,347.099060 
	C555.115295,345.512665 555.067322,344.760834 555.022461,343.641998 
	C554.656738,342.196808 554.287903,341.118652 553.919067,340.040497 
	C554.019897,339.064514 554.120667,338.088501 554.549438,337.041809 
	C555.473511,344.082672 556.069702,351.194244 556.489014,358.671692 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M508.219971,568.929077 
	C510.327850,567.223022 512.981689,565.721252 515.313904,563.824097 
	C516.538757,562.827759 517.200378,561.139099 518.188904,559.384277 
	C521.402832,560.969177 520.722656,563.936218 518.578857,565.317444 
	C515.681702,567.184082 511.985657,567.810608 508.219971,568.929077 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M535.077148,300.319763 
	C536.738831,301.939789 538.353149,303.992676 540.087402,306.343689 
	C539.884094,308.732758 539.560974,310.823700 539.237793,312.914642 
	C538.605286,312.971649 537.972717,313.028656 537.340210,313.085663 
	C536.570068,308.974640 535.799927,304.863647 535.077148,300.319763 
z"
      />
      <path
        fill="#2C4E1C"
        opacity="1.000000"
        stroke="none"
        d="
M430.986877,470.353638 
	C431.578674,467.818237 432.172668,465.613983 432.766663,463.409760 
	C433.327087,463.483734 433.887512,463.557709 434.447937,463.631714 
	C434.306458,466.484070 434.164948,469.336426 434.047119,472.611725 
	C433.653412,473.959991 433.235992,474.885315 432.818604,475.810608 
	C431.924469,475.125519 431.030334,474.440399 430.322632,473.278809 
	C430.764404,472.594574 430.930084,472.330566 431.006134,472.010254 
	C431.000458,471.568451 430.994751,471.126648 430.986877,470.353638 
z"
      />
      <path
        fill="#2C4E1C"
        opacity="1.000000"
        stroke="none"
        d="
M402.663513,467.961609 
	C403.015930,470.703003 403.034027,473.397491 403.087097,476.539429 
	C403.096313,477.159393 403.070557,477.331879 402.639771,477.767487 
	C401.481537,478.046844 400.728363,478.063110 399.975220,478.079346 
	C399.944244,477.912476 399.913239,477.745605 399.821167,477.331451 
	C399.490295,473.717926 399.220520,470.351654 398.911957,466.501526 
	C400.354156,467.097931 401.341675,467.506317 402.663513,467.961609 
z"
      />
      <path
        fill="#35761E"
        opacity="1.000000"
        stroke="none"
        d="
M424.412537,476.859955 
	C423.703918,473.613831 423.191437,470.354492 423.009888,467.076782 
	C422.952820,466.046570 423.784729,464.967102 424.209747,463.910187 
	C424.804535,464.069336 425.399353,464.228485 425.994141,464.387634 
	C425.994141,466.306885 425.994141,468.226135 426.017456,470.574646 
	C425.606018,472.949158 425.171265,474.894409 424.412537,476.859955 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M601.719604,300.509674 
	C601.611450,301.136261 601.503296,301.762817 601.289612,302.692963 
	C600.729065,303.002960 600.274109,303.009399 599.479553,303.029907 
	C599.151001,301.014923 599.162109,298.985901 599.118530,296.527161 
	C599.098083,294.026337 599.132263,291.955261 599.082520,289.448029 
	C599.408875,288.695099 599.819275,288.378265 600.499634,288.032227 
	C600.769653,288.003021 601.124756,288.091156 601.319580,288.485840 
	C601.582764,292.756927 601.651184,296.633301 601.719604,300.509674 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M374.057465,320.954468 
	C370.640778,315.955261 367.318298,310.876373 363.976013,305.420227 
	C363.956207,305.042938 364.156372,304.872589 364.500916,305.006622 
	C366.202576,307.110352 367.559723,309.080048 368.987396,311.393555 
	C370.818909,314.730316 372.579895,317.723328 374.340851,320.716339 
	C374.340851,320.716339 374.151703,320.874817 374.057465,320.954468 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M589.051208,628.582642 
	C588.665222,629.455139 588.342102,629.919678 587.988647,630.681885 
	C584.948792,623.584290 586.233582,617.632263 591.787720,615.041748 
	C592.003906,615.601135 591.833618,616.148743 591.157227,617.043396 
	C590.589355,617.806152 590.527588,618.221802 590.465820,618.637451 
	C590.589539,618.959290 590.565918,619.269836 589.972473,619.923889 
	C589.385620,621.535583 589.221191,622.792603 589.056763,624.049622 
	C589.075867,625.424683 589.094971,626.799683 589.051208,628.582642 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M744.589355,238.977081 
	C745.372803,243.577789 743.156982,245.367218 738.463135,245.002640 
	C737.989746,243.925446 737.919312,242.849731 738.272583,241.344406 
	C739.129639,240.302185 739.563049,239.689560 739.996521,239.076950 
	C741.392517,239.003723 742.788452,238.930481 744.589355,238.977081 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M783.432739,212.645203 
	C783.136353,213.083023 782.731384,213.206589 782.183594,213.493027 
	C778.186768,212.961182 774.332886,212.266434 770.248291,211.275391 
	C770.017639,210.979080 770.100220,210.542374 770.139282,210.324097 
	C774.560303,210.847534 778.942261,211.589233 783.432739,212.645203 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M572.995361,357.390533 
	C573.291382,362.495667 573.385315,367.945709 573.203003,373.701355 
	C572.882263,368.583160 572.837769,363.159271 572.995361,357.390533 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M639.958252,587.319580 
	C637.136780,590.309265 633.936584,593.149170 630.426636,596.139160 
	C630.683777,591.469055 634.158813,588.119934 639.958252,587.319580 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M483.990784,448.956146 
	C482.370972,447.571014 480.712616,446.197540 479.348480,444.465973 
	C483.761353,446.400787 487.879974,448.693665 491.628784,451.002686 
	C490.444397,451.455200 489.629852,451.891602 488.815277,452.327972 
	C488.123749,451.871552 487.432190,451.415161 486.409668,450.450317 
	C485.368378,449.644012 484.658051,449.346130 483.947754,449.048279 
	C483.947754,449.048279 483.952179,448.967773 483.990784,448.956146 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M632.368469,427.986969 
	C632.641296,426.520782 633.298279,425.079468 633.997070,423.318237 
	C636.075195,422.965790 638.111389,422.933197 640.585571,422.925415 
	C638.319702,424.724182 637.208496,429.100616 632.368469,427.986969 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M478.812439,273.023438 
	C474.451080,273.304993 470.171265,273.250336 465.447021,272.778442 
	C464.981750,271.688324 464.960938,271.015442 464.940125,270.342560 
	C469.364349,270.556824 473.788605,270.771057 478.651733,271.154144 
	C479.025055,271.777710 478.959473,272.232483 478.812439,273.023438 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M393.087952,402.327576 
	C396.700409,401.977753 400.371033,402.000000 404.496613,402.004150 
	C401.866943,405.757996 398.835785,405.941193 393.087952,402.327576 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M641.183716,569.900513 
	C642.042664,566.241272 643.237976,562.591553 644.818604,559.127441 
	C645.265747,559.505676 645.327637,559.698303 645.389404,559.890869 
	C645.256775,562.400269 645.124146,564.909607 644.954895,567.817627 
	C643.785522,568.780762 642.652771,569.345398 641.183716,569.900513 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M433.441559,324.204468 
	C429.828400,321.313080 426.411469,318.079834 422.868530,314.535187 
	C428.642090,314.873352 431.245697,319.248444 433.441559,324.204468 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M471.046204,579.316528 
	C473.717896,578.294067 476.462036,577.650208 479.619751,577.047852 
	C478.653625,580.713928 475.034851,581.771606 471.046204,579.316528 
z"
      />
      <path
        fill="#30655D"
        opacity="1.000000"
        stroke="none"
        d="
M731.382629,233.018036 
	C731.692261,232.063553 732.302368,231.034485 733.082336,230.156387 
	C734.325317,228.757050 735.681519,227.458237 737.172058,225.735245 
	C738.177124,226.098785 738.999939,226.843979 739.898804,227.915848 
	C737.236450,229.832092 734.497864,231.421646 731.382629,233.018036 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M426.222290,576.805969 
	C423.713989,575.246521 421.483490,573.492249 419.095398,571.450806 
	C422.835938,569.937317 426.035400,572.242065 426.222290,576.805969 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M417.091309,538.227417 
	C420.148804,538.871277 423.210480,539.881470 426.638611,540.935852 
	C425.930908,541.655090 424.856720,542.330078 423.409485,543.008667 
	C421.056122,541.539429 419.075806,540.066650 417.091309,538.227417 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M416.845886,308.155029 
	C414.327393,305.945496 411.844147,303.354034 409.273743,300.450378 
	C410.608734,300.600891 412.030945,301.063599 413.720215,301.720642 
	C414.951935,303.867676 415.916565,305.820404 416.845886,308.155029 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M517.526794,347.031616 
	C517.217102,350.204315 516.570435,353.463348 515.565796,356.761414 
	C514.744202,355.139374 514.280457,353.478271 513.838501,351.442932 
	C514.970093,349.751770 516.079956,348.434845 517.526794,347.031616 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M478.018677,603.986267 
	C482.744720,604.520691 485.735046,606.883545 485.844086,611.778381 
	C484.894531,611.542908 484.454651,611.263062 484.009216,610.990845 
	C484.003601,610.998474 484.016968,610.985657 484.000732,610.664429 
	C483.361206,609.862061 482.737885,609.380981 482.083496,608.939575 
	C482.052368,608.979187 482.080109,608.882324 481.980988,608.576233 
	C480.918213,607.520874 479.954590,606.771606 478.864380,605.785889 
	C478.403015,605.136536 478.068298,604.723511 477.733582,604.310547 
	C477.733582,604.310547 477.923340,604.094055 478.018677,603.986267 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M526.891296,357.371246 
	C527.155396,360.811768 527.262390,364.614807 527.102173,368.723328 
	C526.801392,365.263763 526.767822,361.498779 526.891296,357.371246 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M383.114807,391.208862 
	C385.382324,393.661407 387.639893,396.490997 389.901672,399.669189 
	C385.693176,398.776489 384.063843,395.451569 383.114807,391.208862 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M435.961914,557.886597 
	C437.962341,556.851990 439.962738,555.817383 441.959961,554.398315 
	C442.408173,554.006897 442.859497,553.999939 443.899719,553.999390 
	C444.655609,554.005798 444.822662,554.005798 444.989716,554.005798 
	C444.989716,554.005798 445.000000,554.000000 444.996582,554.378784 
	C444.991791,555.504211 444.990387,556.250916 444.989014,556.997559 
	C444.669434,557.099121 444.410767,557.285339 443.739532,557.814636 
	C441.837097,558.387939 440.408112,558.702698 438.979126,559.017456 
	C438.234711,559.013367 437.490326,559.009338 436.366058,558.725647 
	C435.978119,558.259460 435.970001,558.072998 435.961914,557.886597 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M462.857697,333.484192 
	C463.132294,333.069183 463.364471,333.063690 463.947632,333.062073 
	C464.733978,336.867706 465.169342,340.669434 465.298004,344.719604 
	C464.265961,341.276550 463.540588,337.585114 462.857697,333.484192 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M522.773987,707.773071 
	C518.613281,709.412048 517.155701,705.963562 515.228394,703.014771 
	C517.718323,704.260620 520.155640,705.877747 522.773987,707.773071 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M534.493408,563.789429 
	C532.446106,566.101685 530.087952,568.548279 527.363892,570.991821 
	C529.392883,568.633789 531.787781,566.278748 534.493408,563.789429 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M368.092743,398.317322 
	C371.066833,398.285492 374.081360,398.629272 377.522217,398.984222 
	C374.555145,402.841370 371.338013,400.966736 368.092743,398.317322 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M463.646027,614.959351 
	C463.989746,615.438599 463.994965,615.885437 463.564941,616.666626 
	C461.692200,617.011047 460.254730,617.021118 458.747986,616.619080 
	C458.491760,614.569885 458.304749,612.932861 458.573914,611.202637 
	C459.333984,611.045898 459.637817,610.982422 459.941650,610.918945 
	C461.063599,612.254944 462.185577,613.590942 463.646027,614.959351 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M588.359985,591.864441 
	C589.056396,590.268494 590.101685,588.635742 591.558960,587.255432 
	C592.297974,588.288269 592.624939,589.068604 592.951904,589.848938 
	C591.537537,590.508484 590.123230,591.168030 588.359985,591.864441 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M380.983398,516.434937 
	C381.703705,516.849731 382.420013,517.660095 383.388367,518.696411 
	C384.108734,520.074219 384.577087,521.226074 385.050293,522.701538 
	C381.924164,522.126404 380.744232,519.944031 380.983398,516.434937 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M630.970459,520.284241 
	C628.346863,520.042603 625.605713,519.487427 622.481262,518.951538 
	C622.098022,518.970764 622.006348,518.508301 621.991211,518.273071 
	C624.934998,518.682129 627.893982,519.326416 630.970459,520.284241 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M483.678558,586.237061 
	C484.031799,587.217712 484.028839,588.115051 484.037750,589.345520 
	C482.510559,589.395996 480.971497,589.113281 479.432404,588.830627 
	C479.366089,588.413513 479.299774,587.996460 479.233459,587.579346 
	C480.596405,587.104126 481.959381,586.628906 483.678558,586.237061 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M754.356750,209.961761 
	C752.135742,208.408035 752.368469,207.906921 756.294922,206.001297 
	C756.021545,207.314667 755.349121,208.620834 754.356750,209.961761 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M405.252563,400.959290 
	C404.247070,399.266174 403.573425,397.535980 402.884735,395.436096 
	C405.669403,396.139954 407.280029,397.764648 405.252563,400.959290 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M538.269531,547.433472 
	C538.576965,549.590149 538.793518,552.184082 538.670532,554.888000 
	C538.280273,552.622253 538.229431,550.246399 538.269531,547.433472 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M439.409851,330.217346 
	C437.364502,328.816956 435.527466,327.073334 433.570374,325.045410 
	C437.543213,324.008301 438.782837,326.697327 439.409851,330.217346 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M422.846161,313.868164 
	C421.019165,312.708221 419.260040,311.157745 417.393555,309.308960 
	C420.471741,308.849670 422.840942,309.717224 422.846161,313.868164 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M516.995239,536.461670 
	C515.218445,536.277832 513.430542,535.731018 511.322876,535.028992 
	C513.659790,532.044678 515.406372,533.659241 516.995239,536.461670 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M524.652466,572.194946 
	C523.177795,573.437561 521.355652,574.674133 519.161011,575.898315 
	C520.627380,574.653625 522.466248,573.421265 524.652466,572.194946 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M363.147400,392.003326 
	C364.543030,393.437561 365.880219,395.276581 367.316254,397.454529 
	C365.973053,395.998322 364.530975,394.203247 363.147400,392.003326 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M355.986359,356.445160 
	C356.360229,356.008026 356.735809,355.996460 357.387756,355.975555 
	C357.652557,357.792816 357.641022,359.619415 357.102661,361.730225 
	C356.381256,362.005768 356.186615,361.997040 355.991943,361.988312 
	C355.990662,360.282440 355.989380,358.576599 355.986359,356.445160 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M499.176300,572.198242 
	C500.716949,571.255920 502.471832,570.595520 504.592712,569.905884 
	C503.102631,570.744446 501.246582,571.612305 499.176300,572.198242 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M559.375366,705.685486 
	C558.221069,706.869263 556.746948,708.108337 555.090698,709.073425 
	C556.290894,707.779907 557.673218,706.760315 559.375366,705.685486 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M365.798309,461.171570 
	C366.365509,462.697784 366.650452,464.481598 366.878174,466.674194 
	C366.385956,465.198364 365.951019,463.313751 365.798309,461.171570 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M526.578613,377.257080 
	C526.940002,378.827667 527.109802,380.690674 527.000977,382.801025 
	C526.610596,381.215424 526.498779,379.382446 526.578613,377.257080 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M490.979858,455.012634 
	C490.644714,456.304688 490.309540,457.596710 489.655212,459.012146 
	C489.210541,457.386902 489.085083,455.638245 489.252319,453.449371 
	C489.950165,453.026184 490.355316,453.043243 490.817932,453.289703 
	C490.875427,453.519135 490.917419,453.990265 490.762634,454.087280 
	C490.731842,454.460388 490.855835,454.736511 490.979858,455.012634 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M393.908875,382.883972 
	C392.516022,381.836914 391.160736,380.399414 389.717468,378.647217 
	C391.068451,379.719574 392.507477,381.106567 393.908875,382.883972 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M355.723572,362.231445 
	C356.186615,361.997040 356.381256,362.005768 356.868713,362.034973 
	C357.152435,363.433044 357.143372,364.810608 357.092773,366.601379 
	C356.519165,365.501251 355.987183,363.987946 355.723572,362.231445 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M357.139130,370.955353 
	C357.360046,372.738129 357.580963,374.520905 357.670654,376.696228 
	C357.539368,377.088806 357.246033,377.053284 357.092163,376.729492 
	C356.623474,375.934784 356.308624,375.463867 355.993774,374.992920 
	C355.994141,373.930084 355.994507,372.867218 356.281982,371.395874 
	C356.759125,370.976685 356.949127,370.966003 357.139130,370.955353 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M357.809082,381.987122 
	C358.760925,382.735016 359.375458,383.536041 360.013275,384.651550 
	C358.886627,384.578308 357.736664,384.190521 356.586731,383.802765 
	C356.881744,383.215271 357.176758,382.627777 357.809082,381.987122 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M459.419006,488.691132 
	C459.665161,490.143066 459.620789,491.798004 459.284058,493.731323 
	C459.037292,492.304535 459.082855,490.599335 459.419006,488.691132 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M595.930481,609.279114 
	C595.410339,610.825745 594.486023,612.257874 593.282959,613.859863 
	C593.477478,612.217529 591.654236,609.214783 595.930481,609.279114 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M412.059143,566.327942 
	C412.354797,566.036194 412.828217,566.020203 413.656738,565.999634 
	C414.995117,567.086060 415.978485,568.177063 416.996552,569.589722 
	C415.433167,568.808838 413.835022,567.706299 412.059143,566.327942 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M292.729126,206.775818 
	C290.896515,207.335678 288.815613,207.605850 286.341309,207.830261 
	C288.125519,207.351700 290.303192,206.918915 292.729126,206.775818 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M497.204895,310.227783 
	C498.565002,310.234558 499.897705,310.595642 501.583069,310.957886 
	C500.119263,313.741943 498.511841,313.885315 497.204895,310.227783 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M440.075317,657.171387 
	C440.448761,656.075317 440.858582,655.168823 441.739319,654.399292 
	C442.832458,654.788940 443.454742,655.041687 444.084076,655.575317 
	C444.048035,656.228088 444.004944,656.599976 443.961853,656.971863 
	C443.094116,657.085754 442.226410,657.199585 440.930237,657.548828 
	C440.501801,657.784302 440.153595,657.744751 440.153595,657.744751 
	C440.153595,657.744751 440.111755,657.360962 440.075317,657.171387 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M468.281677,503.089355 
	C468.185760,502.394470 468.366028,501.823486 469.162781,501.102936 
	C470.516602,500.966095 471.253876,500.978851 471.995789,500.995911 
	C472.000397,501.000214 472.010986,501.007904 472.109436,501.265564 
	C472.501190,501.988770 472.794525,502.454346 473.087860,502.919922 
	C472.812225,503.116150 472.536560,503.312378 471.812256,503.774445 
	C471.148529,504.086945 470.933502,504.133575 470.718445,504.180206 
	C469.998260,503.857880 469.278046,503.535553 468.281677,503.089355 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M299.106628,190.872986 
	C299.777374,190.982407 300.448120,191.091812 301.449097,191.301056 
	C301.903076,191.690491 302.111298,191.893524 302.622528,192.054199 
	C302.841125,192.098404 302.914703,192.585297 302.750916,193.058563 
	C301.386414,192.693680 300.185730,191.855530 299.015533,190.981354 
	C299.046021,190.945328 299.106628,190.872986 299.106628,190.872986 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M657.988037,649.004761 
	C657.881653,650.642334 657.775208,652.279968 657.324646,653.976440 
	C656.786438,654.008240 656.592346,653.981262 656.112183,653.880493 
	C656.161316,653.391907 656.496643,652.977173 656.919067,651.921631 
	C657.008301,650.519714 657.010437,649.758606 657.256470,648.994507 
	C657.500366,648.991577 657.988037,649.004761 657.988037,649.004761 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M359.653168,407.966614 
	C360.017395,408.708862 360.021942,409.301056 359.731934,410.298279 
	C358.807526,410.740448 358.177704,410.777618 357.547852,410.814819 
	C357.442719,410.658752 357.337555,410.502655 357.020935,410.158936 
	C357.637451,409.253113 358.465454,408.534882 359.653168,407.966614 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M439.035339,559.341919 
	C440.408112,558.702698 441.837097,558.387939 443.631866,558.031677 
	C442.362305,558.548950 440.726959,559.107666 439.035339,559.341919 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M459.898132,610.602539 
	C459.637817,610.982422 459.333984,611.045898 458.344727,610.995117 
	C457.397461,609.625366 457.135559,608.370056 456.938354,607.055298 
	C457.003082,606.995850 457.131775,606.876221 457.341492,606.927917 
	C457.551239,606.979614 457.979614,607.035400 457.979614,607.035400 
	C458.604584,608.118958 459.229584,609.202515 459.898132,610.602539 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M490.761719,588.707092 
	C490.982697,589.140015 490.984375,589.312500 490.984833,589.743713 
	C489.915680,590.019348 488.847748,590.036255 487.382965,589.991455 
	C488.171539,589.435364 489.356995,588.940979 490.761719,588.707092 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M384.904755,372.755249 
	C383.773956,372.067505 382.681580,370.976044 381.471497,369.568756 
	C382.550232,370.285828 383.746674,371.318695 384.904755,372.755249 
z"
      />
      <path
        fill="#3F8C82"
        opacity="1.000000"
        stroke="none"
        d="
M593.288513,589.820435 
	C592.624939,589.068604 592.297974,588.288269 591.901001,587.190918 
	C591.830933,586.873962 591.867859,586.885315 592.269287,586.922363 
	C593.450195,586.976013 594.229614,586.992554 595.009094,587.009094 
	C595.009094,587.009094 595.180298,587.150146 595.273071,587.217407 
	C594.785583,588.120361 594.205322,588.956177 593.288513,589.820435 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M537.765869,557.213623 
	C537.623718,558.313354 537.220337,559.603394 536.516113,560.945679 
	C536.645142,559.799927 537.074890,558.601990 537.765869,557.213623 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M527.777466,347.318909 
	C527.962036,348.296387 527.987183,349.589020 527.729675,350.998962 
	C527.504028,349.955536 527.561035,348.794830 527.777466,347.318909 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M472.508911,471.671631 
	C472.890076,472.489990 472.944061,473.326691 472.999023,474.581726 
	C473.000000,475.000000 472.998932,474.995453 472.660156,474.994629 
	C471.869293,474.984924 471.417267,474.976044 470.965210,474.967163 
	C470.717255,474.472748 470.469330,473.978302 470.107910,473.230957 
	C470.723511,472.548706 471.452606,472.119354 472.508911,471.671631 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M662.335938,416.922668 
	C661.433105,416.742554 660.852783,416.544830 660.349243,415.837524 
	C661.621643,415.520691 662.817383,415.713440 664.013062,415.906189 
	C664.012878,416.075714 664.012634,416.245270 663.980835,416.666687 
	C663.519043,416.914062 663.088745,416.909576 662.335938,416.922668 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M479.810516,466.315796 
	C479.258179,467.235107 478.381531,468.071716 477.168335,468.862183 
	C477.716614,467.955078 478.601410,467.094055 479.810516,466.315796 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M444.117981,657.206970 
	C444.004944,656.599976 444.048035,656.228088 444.380402,655.437256 
	C445.100464,654.962830 445.531281,654.907410 445.962067,654.851929 
	C445.977783,655.312866 445.993500,655.773804 446.039307,656.578613 
	C445.470978,657.095764 444.872559,657.268921 444.117981,657.206970 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M507.062286,305.486145 
	C507.288177,305.123383 507.454620,305.092682 507.874268,305.044434 
	C508.244843,305.922119 508.362183,306.817322 508.215210,307.860901 
	C507.634827,307.278931 507.318817,306.548553 507.062286,305.486145 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M575.949524,346.053345 
	C575.921692,346.398193 575.893921,346.743073 575.864929,347.340149 
	C575.579529,347.749573 575.297607,347.910767 574.778015,348.112061 
	C574.591003,347.282501 574.644104,346.416870 575.117737,345.388733 
	C575.763184,345.458282 575.900269,345.733978 575.949524,346.053345 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M576.221069,345.826019 
	C575.900269,345.733978 575.763184,345.458282 575.326538,345.128540 
	C575.206299,344.168457 575.297791,343.306061 575.583862,342.179871 
	C576.016479,343.143585 576.254578,344.371155 576.221069,345.826019 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M490.760498,453.060303 
	C490.355316,453.043243 489.950165,453.026184 489.240204,453.013184 
	C488.935394,453.017212 488.786743,452.687592 488.801025,452.507812 
	C489.629852,451.891602 490.444397,451.455200 491.631104,451.008820 
	C492.003235,450.998840 492.013580,451.001282 491.974487,451.321045 
	C491.543762,452.113953 491.152130,452.587128 490.760498,453.060303 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M718.851685,513.224121 
	C718.703979,514.387939 718.191895,515.647888 717.397888,517.127197 
	C717.573120,516.004395 718.030212,514.662354 718.851685,513.224121 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M445.325043,556.950073 
	C444.990387,556.250916 444.991791,555.504211 444.993500,554.384460 
	C447.241577,554.507690 447.610107,555.437744 445.325043,556.950073 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M619.736450,419.689301 
	C618.950195,419.913971 617.927979,419.870270 616.801331,419.552277 
	C617.631409,419.325623 618.565979,419.373260 619.736450,419.689301 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M361.745850,388.178833 
	C362.385620,388.750854 362.762878,389.527893 363.148895,390.646973 
	C362.599548,390.120605 362.041473,389.252258 361.745850,388.178833 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M400.037537,478.400879 
	C400.728363,478.063110 401.481537,478.046844 402.610657,478.027527 
	C402.024384,478.257111 401.062134,478.489777 400.037537,478.400879 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M776.699829,199.072632 
	C777.020691,199.778152 777.003479,200.514389 776.971680,201.618591 
	C776.758545,201.025497 776.560120,200.064423 776.699829,199.072632 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M435.592346,557.896057 
	C435.970001,558.072998 435.978119,558.259460 435.993835,558.725952 
	C435.207550,559.320312 434.413635,559.634705 433.297241,559.968140 
	C432.984192,559.543518 432.993622,559.099854 433.003601,558.322998 
	C433.743713,557.961731 434.483215,557.933655 435.592346,557.896057 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M503.221863,309.827515 
	C503.154633,309.058594 503.369690,308.206329 503.870819,307.171936 
	C503.939301,307.907928 503.721741,308.826080 503.221863,309.827515 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M388.189575,376.273804 
	C387.254700,376.011200 386.586121,375.415741 385.807983,374.560303 
	C386.617554,374.847198 387.536713,375.394104 388.189575,376.273804 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M484.014801,610.983154 
	C484.454651,611.263062 484.894531,611.542908 485.570587,611.952393 
	C485.960114,612.511353 486.113403,612.940735 486.405334,613.683777 
	C486.543915,613.997375 486.274048,614.124512 485.787750,614.024414 
	C484.872559,612.943909 484.443695,611.963501 484.014801,610.983154 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M636.015198,574.756836 
	C636.223083,574.131226 636.784973,573.572632 637.653564,572.966492 
	C637.429932,573.553894 636.899597,574.188843 636.015198,574.756836 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M485.727417,462.100769 
	C486.031525,462.508850 486.019012,462.927155 485.996338,463.659180 
	C485.517975,463.983307 485.049744,463.993713 484.231201,463.965149 
	C484.390869,463.321106 484.900848,462.716034 485.727417,462.100769 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M635.054688,521.312988 
	C634.560486,521.515808 633.977539,521.475220 633.203064,521.194946 
	C633.663025,520.993347 634.314392,521.031372 635.054688,521.312988 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M621.448364,578.993286 
	C621.783691,579.112793 621.856079,579.284851 621.957764,579.735413 
	C621.498535,580.156555 621.010010,580.299255 620.521484,580.441895 
	C620.742798,579.976562 620.964111,579.511169 621.448364,578.993286 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M484.012787,449.377380 
	C484.658051,449.346130 485.368378,449.644012 486.185638,450.229736 
	C485.554352,450.247253 484.816071,449.976898 484.012787,449.377380 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M303.840149,181.515076 
	C304.448120,181.214722 305.058136,181.256195 305.828125,181.563019 
	C305.272827,181.837875 304.557526,181.847397 303.840149,181.515076 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M390.732880,473.006653 
	C391.034790,473.415375 391.040192,473.880402 391.027954,474.694153 
	C390.818970,474.382904 390.627655,473.722931 390.732880,473.006653 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M470.825592,504.482117 
	C470.933502,504.133575 471.148529,504.086945 471.691498,504.000580 
	C472.362335,504.328705 472.705261,504.696533 473.102081,505.314819 
	C472.414917,505.304810 471.673828,505.044403 470.825592,504.482117 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M588.044373,633.317505 
	C588.636475,633.455383 589.264404,633.910706 589.916870,634.686340 
	C589.321045,634.549377 588.700623,634.092102 588.044373,633.317505 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M532.943420,288.208008 
	C532.590698,288.644867 532.161072,288.815491 531.388855,289.044006 
	C531.653015,288.715240 532.259766,288.328491 532.943420,288.208008 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M487.739929,585.305420 
	C487.465546,585.758606 486.905548,586.132263 486.193237,586.296631 
	C486.512054,585.800232 486.983185,585.513123 487.739929,585.305420 
z"
      />
      <path
        fill="#DFE5BC"
        opacity="1.000000"
        stroke="none"
        d="
M739.645142,238.970978 
	C739.563049,239.689560 739.129639,240.302185 738.391602,240.954926 
	C738.489319,240.285049 738.891602,239.575027 739.645142,238.970978 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M571.840332,415.612091 
	C571.484924,415.762207 570.723694,415.887665 569.898315,415.750183 
	C570.367676,415.520660 570.901123,415.554047 571.840332,415.612091 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M355.768188,375.165100 
	C356.308624,375.463867 356.623474,375.934784 356.946625,376.704224 
	C356.484161,376.447540 356.013397,375.892426 355.768188,375.165100 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M565.723511,416.316467 
	C565.426331,416.624908 564.729126,416.939301 563.916626,417.034485 
	C564.308716,416.651031 564.816101,416.486725 565.723511,416.316467 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M538.755859,542.955444 
	C538.864197,543.519653 538.721008,544.061340 538.351929,544.771362 
	C537.841187,544.438354 537.556274,543.936890 537.389404,543.139404 
	C537.839661,542.873169 538.171997,542.903076 538.755859,542.955444 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M558.809509,415.584534 
	C558.413147,415.715424 557.640747,415.732300 556.877808,415.479065 
	C557.402649,415.296143 557.918030,415.383301 558.809509,415.584534 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M652.123108,652.250916 
	C652.770874,652.315613 653.426331,652.731750 654.191528,653.435059 
	C653.577759,653.348877 652.854248,652.975647 652.123108,652.250916 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M357.141052,370.627075 
	C356.949127,370.966003 356.759125,370.976685 356.283783,370.997314 
	C356.147400,370.352997 356.296356,369.698700 356.742859,369.017029 
	C357.074585,369.426025 357.108795,369.862396 357.141052,370.627075 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M601.068848,496.835754 
	C601.322571,496.254059 601.902344,495.714691 602.799072,495.251343 
	C602.542297,495.844269 601.968567,496.361206 601.068848,496.835754 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M577.475220,340.166443 
	C577.229248,340.131683 576.983337,340.096954 576.368530,340.010864 
	C576.001526,339.240814 576.003479,338.522156 576.074341,337.446808 
	C576.593750,337.624969 577.044312,338.159821 577.638550,339.189453 
	C577.701294,339.879395 577.620361,340.074585 577.516235,340.248352 
	C577.493103,340.226929 577.475220,340.166443 577.475220,340.166443 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M455.766785,604.102356 
	C455.969666,604.081848 456.172546,604.061279 456.680908,604.032715 
	C457.009155,604.458496 457.031982,604.892212 457.075867,605.875000 
	C457.096954,606.423950 457.131775,606.876221 457.131775,606.876221 
	C457.131775,606.876221 457.003082,606.995850 456.741028,606.994202 
	C456.478973,606.992554 456.065735,606.971497 456.045471,606.610840 
	C455.939056,605.534302 455.852905,604.818298 455.766785,604.102356 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M599.682434,605.986938 
	C599.531921,606.577759 599.052429,607.202271 598.281372,607.908447 
	C598.444336,607.333557 598.898865,606.677063 599.682434,605.986938 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M782.745972,193.562256 
	C782.512329,194.132263 782.067688,194.517838 781.345337,194.999527 
	C781.556641,194.523026 782.045776,193.950409 782.745972,193.562256 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M369.875977,489.661438 
	C370.020782,490.238190 369.822388,490.840790 369.394104,491.658508 
	C369.164215,491.873596 368.843872,491.601013 368.942749,491.133667 
	C369.025177,490.482056 369.008759,490.297791 368.992340,490.113556 
	C369.172485,489.971466 369.352661,489.829376 369.875977,489.661438 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M755.849304,225.074829 
	C756.113708,225.090500 756.134399,225.543182 756.108032,225.768051 
	C755.665222,225.785828 755.248779,225.578735 754.832397,225.371643 
	C755.083252,225.267487 755.334045,225.163330 755.849304,225.074829 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M590.985474,640.249512 
	C591.574219,640.034607 592.094055,640.089966 592.584290,640.494141 
	C592.197937,640.933472 591.841248,641.024109 591.484558,641.114685 
	C591.484558,641.114685 591.079285,641.132324 590.881226,641.079346 
	C590.760864,640.857605 590.838684,640.688721 590.985474,640.249512 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M357.335693,378.995972 
	C357.607452,379.131287 357.680695,379.304626 357.717712,379.758423 
	C357.323242,379.883881 356.965057,379.728851 356.606842,379.573853 
	C356.783600,379.393890 356.960358,379.213928 357.335693,378.995972 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M501.102325,529.831116 
	C501.474152,529.578186 501.813202,529.400879 502.152283,529.223633 
	C501.990814,529.462830 501.829376,529.701965 501.450714,529.933105 
	C501.233521,529.924988 501.069580,529.906799 501.102325,529.831116 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M389.727905,377.981506 
	C389.259460,378.063995 388.861267,377.785065 388.405457,377.267761 
	C388.831299,377.226288 389.314728,377.423187 389.727905,377.981506 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M400.968201,391.683807 
	C400.534058,391.611298 400.068390,391.194519 399.529907,390.463928 
	C399.950287,390.546539 400.443481,390.943054 400.968201,391.683807 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M597.672363,608.003174 
	C597.625366,608.421936 597.260437,608.854187 596.602966,609.325439 
	C596.658325,608.915161 597.006348,608.465942 597.672363,608.003174 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M417.148071,556.251160 
	C417.246033,555.972412 417.508148,555.936035 418.359619,555.867798 
	C419.206421,555.965393 419.378571,556.167603 419.465454,556.442383 
	C419.465454,556.442383 419.200989,556.755066 419.066772,556.911011 
	C418.392456,556.875793 417.852356,556.684631 417.148071,556.251160 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M602.894409,326.771515 
	C603.232239,327.129517 603.419434,327.776428 603.375000,328.701782 
	C603.010254,328.340271 602.877075,327.700348 602.894409,326.771515 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M649.043518,651.082153 
	C649.137939,650.898438 649.318420,650.902466 649.766418,650.951416 
	C649.732422,651.087524 649.430969,651.178711 649.043518,651.082153 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M440.176147,657.952271 
	C440.153595,657.744751 440.501801,657.784302 440.674316,657.758179 
	C440.630768,657.874634 440.414734,658.017151 440.176147,657.952271 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M560.614502,704.828369 
	C560.694458,705.082703 560.484131,705.395996 559.983154,705.760132 
	C559.903137,705.503052 560.113647,705.195190 560.614502,704.828369 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M368.747009,490.087250 
	C369.008759,490.297791 369.025177,490.482056 368.937347,490.923401 
	C368.636444,490.947418 368.412079,490.730286 368.262085,490.470276 
	C368.222992,490.402435 368.415497,490.201019 368.747009,490.087250 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M489.202454,641.923096 
	C489.041260,642.009033 489.025421,641.514648 489.057343,641.269653 
	C489.244843,641.193787 489.417358,641.351624 489.542603,641.540833 
	C489.569855,641.582031 489.427734,641.735352 489.202454,641.923096 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M501.548889,687.577759 
	C501.239258,687.747803 500.815002,687.565002 500.226318,687.070618 
	C500.519379,686.914368 500.976807,687.069641 501.548889,687.577759 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M365.860901,408.102783 
	C365.731873,408.359406 365.568542,408.404938 365.187317,408.318542 
	C365.255127,408.088318 365.540863,407.990021 365.860901,408.102783 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M362.948608,407.795898 
	C362.854095,408.015564 362.671295,408.062195 362.226318,408.001007 
	C362.262909,407.803070 362.561615,407.712952 362.948608,407.795898 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M360.108948,385.200012 
	C360.295776,385.153564 360.567078,385.337433 360.900208,385.766724 
	C360.634094,385.912933 360.377899,385.719025 360.108948,385.200012 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M524.770386,416.218689 
	C524.723328,416.346649 524.404602,416.527618 524.016479,416.465698 
	C524.130981,416.239075 524.314819,416.255402 524.770386,416.218689 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M385.729187,374.038483 
	C385.471924,374.099213 385.193146,373.874969 384.871338,373.373749 
	C385.121429,373.315674 385.414551,373.534607 385.729187,374.038483 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M736.867310,430.248932 
	C737.157654,430.171478 737.350159,430.329529 737.498230,430.521820 
	C737.526245,430.558105 737.377441,430.730621 737.132812,430.921021 
	C736.888306,430.833282 736.821167,430.664795 736.867310,430.248932 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M444.905212,553.834778 
	C444.822662,554.005798 444.655609,554.005798 444.237885,554.000488 
	C444.265045,553.884644 444.542877,553.774231 444.905212,553.834778 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M457.341492,606.927917 
	C457.131775,606.876221 457.096954,606.423950 457.119812,606.198120 
	C457.432770,606.109985 457.658539,606.317566 457.899780,606.815308 
	C457.979614,607.035400 457.551239,606.979614 457.341492,606.927917 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M430.792786,472.121521 
	C430.930084,472.330566 430.764404,472.594574 430.306274,472.923340 
	C430.150024,472.708130 430.308685,472.437592 430.792786,472.121521 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M488.909332,459.415283 
	C489.007080,459.597565 488.885559,459.752472 488.614563,459.963318 
	C488.358337,459.756927 488.433350,459.546478 488.909332,459.415283 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M323.987793,198.980743 
	C323.885681,199.020798 323.795135,199.075302 323.866882,199.073288 
	C324.029144,199.016769 323.999390,198.995209 323.987793,198.980743 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M777.778137,198.102539 
	C777.923218,198.330170 777.750549,198.605087 777.257080,198.921967 
	C777.103088,198.685974 777.277771,198.414597 777.778137,198.102539 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M321.988831,196.980560 
	C321.880890,197.003113 321.787323,197.043289 321.865784,197.055511 
	C322.037842,197.027542 322.003174,196.998169 321.988831,196.980560 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M780.847595,195.143585 
	C780.914734,195.341675 780.732361,195.644699 780.293823,196.047729 
	C780.224487,195.848007 780.411255,195.548264 780.847595,195.143585 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M648.878784,517.483154 
	C649.056580,517.386292 649.390137,517.491943 649.836487,517.848450 
	C649.644348,517.961426 649.339417,517.823486 648.878784,517.483154 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M554.932373,322.075989 
	C555.193237,322.148346 555.265503,322.314636 555.278564,322.746582 
	C555.060852,322.731384 554.902283,322.450623 554.932373,322.075989 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M600.866943,312.071411 
	C601.118652,312.039490 601.304993,312.494263 601.219238,312.724487 
	C600.960754,312.670898 600.788025,312.387115 600.866943,312.071411 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M585.416199,311.527588 
	C585.380981,311.462616 585.451416,311.592560 585.416199,311.527588 
z"
      />
      <path
        fill="#30655D"
        opacity="1.000000"
        stroke="none"
        d="
M736.984253,224.688904 
	C735.403076,224.518646 733.297058,224.497589 732.113464,223.442078 
	C725.975891,217.968750 720.046326,212.260025 714.100220,206.574844 
	C710.684265,203.308762 707.771973,199.617950 702.637634,198.464966 
	C700.886536,198.071732 699.110596,195.364716 698.391602,193.343063 
	C697.180054,189.936768 695.340820,189.449387 692.168152,190.612640 
	C692.807983,192.920883 693.402039,195.064163 693.995605,197.603531 
	C689.663757,194.850357 685.437073,191.542145 680.968628,188.601151 
	C677.264587,186.163223 673.261841,184.181961 669.415894,181.956161 
	C662.295166,177.835114 655.391479,173.278214 648.026733,169.656616 
	C640.471069,165.941147 632.181946,163.682739 624.733337,159.792038 
	C612.922729,153.622925 599.758118,152.077301 587.401917,147.834412 
	C583.288452,146.421906 578.630798,146.594299 573.123962,145.904648 
	C574.942078,143.304886 576.269470,139.643387 577.808289,139.552277 
	C581.709045,139.321320 585.706055,140.684097 589.661377,141.425262 
	C591.107605,141.696243 592.543152,142.023544 593.986694,142.309082 
	C600.074280,143.513153 606.163025,144.711182 612.633484,145.986755 
	C609.441345,147.463867 607.202698,149.337234 609.988220,152.228745 
	C615.166016,150.883957 619.888855,149.657303 624.861938,148.115189 
	C625.658325,147.892761 626.204590,147.985794 626.921692,148.573715 
	C627.242004,149.399673 627.391479,149.730713 627.540955,150.061768 
	C627.696838,149.669617 627.852722,149.277481 628.008606,148.885345 
	C629.226257,149.258865 630.443848,149.632401 631.888550,150.617950 
	C633.312378,152.408905 634.330688,154.282715 635.737549,154.644180 
	C641.254272,156.061554 646.388489,157.739441 648.510742,164.594711 
	C650.678711,162.819443 652.340637,161.458527 654.002563,160.097626 
	C672.684021,168.724670 689.197144,180.687134 705.163086,193.468994 
	C708.527283,196.162292 711.629578,199.182770 715.145691,202.174377 
	C722.587524,209.651169 729.736206,217.006058 736.984253,224.688904 
M593.483276,145.589371 
	C593.483276,145.589371 593.415649,145.476593 593.483276,145.589371 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M382.239258,124.158760 
	C382.595795,126.252785 382.356750,128.727676 383.410614,130.375793 
	C388.334473,138.075714 393.626587,145.539673 398.755859,153.109100 
	C399.560913,154.297165 400.205505,155.593933 401.803558,158.365128 
	C387.629395,156.237152 374.822388,154.314438 360.409393,152.150604 
	C366.414398,159.874451 371.550293,166.480453 376.949188,173.424744 
	C375.207367,174.658401 372.500610,176.575455 370.534180,177.968170 
	C370.055420,175.774826 370.136169,173.395218 369.075409,171.752823 
	C364.025269,163.933609 358.649811,156.324951 353.429108,148.614975 
	C352.546356,147.311264 351.854309,145.878433 350.389526,143.300201 
	C364.736694,145.660019 377.773529,147.804306 390.862000,149.957092 
	C388.880707,142.618103 377.380341,129.849243 371.865143,130.009628 
	C375.664612,127.590347 378.691101,125.663246 382.008972,123.961609 
	C382.300323,124.187065 382.239258,124.158760 382.239258,124.158760 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M526.427490,103.491928 
	C524.103638,102.408043 522.017456,101.606102 519.716248,100.721519 
	C518.345093,110.670975 519.799866,114.983482 525.483521,116.843742 
	C519.918945,117.309036 515.337219,117.692154 511.025330,118.052696 
	C511.608643,115.644852 512.706055,113.367012 512.601807,111.145569 
	C512.203735,102.662888 511.587158,94.179733 510.653717,85.740822 
	C510.433899,83.753387 508.658691,81.937988 507.618500,80.078255 
	C512.149414,79.675415 517.818604,79.029221 523.506165,78.710037 
	C528.176392,78.447952 532.612915,79.224747 534.950439,84.047546 
	C537.216980,88.724037 534.888672,92.377220 532.064514,95.868385 
	C531.354675,96.745834 530.690186,97.659973 529.472900,99.253799 
	C535.571838,104.677032 541.541260,109.985062 546.954407,114.798485 
	C540.494080,116.707802 537.131287,115.783150 531.877075,109.832535 
	C530.113953,107.835739 528.401001,105.794685 526.427490,103.491928 
M518.051453,92.226250 
	C518.628418,94.360168 518.586548,97.545341 519.947937,98.346779 
	C521.456848,99.235031 524.549866,98.498085 526.413818,97.480873 
	C529.635864,95.722519 530.292908,89.637253 528.198059,85.698479 
	C526.105530,81.764130 522.735413,80.856270 517.482544,82.935265 
	C517.645813,85.679672 517.812988,88.487968 518.051453,92.226250 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M463.740356,127.615135 
	C456.728516,132.171143 449.526611,134.933868 441.384033,134.456482 
	C433.592194,133.999664 428.204346,129.865784 425.415283,122.812813 
	C422.509949,115.465675 423.405457,108.382965 428.947083,102.379257 
	C435.091187,95.722885 443.554993,94.153801 451.866333,92.421532 
	C452.597839,92.269066 454.046448,93.242836 454.398254,94.033371 
	C455.313629,96.090279 455.803772,98.336411 456.199799,100.829002 
	C452.470581,97.037170 448.130249,96.430695 443.389740,97.583908 
	C437.445618,99.029892 432.081787,101.523529 430.899872,108.204033 
	C429.531647,115.937340 432.716949,122.291893 438.729156,127.004486 
	C444.260071,131.339783 450.529694,131.038422 456.640442,128.267365 
	C457.660797,127.804657 458.780212,125.442101 458.434753,124.453033 
	C456.950409,120.202980 454.936401,116.137909 453.081696,111.929153 
	C455.730286,110.960716 459.290131,109.659088 463.383179,108.162514 
	C460.078857,113.352501 464.001434,117.123886 465.069122,121.308235 
	C465.671112,123.667557 466.737427,125.737144 463.740356,127.615135 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M643.070374,118.079056 
	C648.940125,112.749718 654.542053,107.651474 661.331177,101.472710 
	C661.492371,104.733261 661.666260,106.425201 661.644714,108.114655 
	C661.517395,118.099182 661.179077,128.084991 661.290894,138.066116 
	C661.323425,140.967163 662.599487,143.854263 663.355530,146.952515 
	C660.602234,145.720230 657.193726,144.194687 653.493713,142.538666 
	C653.701172,141.246109 653.945374,140.021301 654.088745,138.784821 
	C655.192444,129.267776 655.234558,129.146591 646.458862,125.638733 
	C644.834839,124.989578 641.968933,125.005325 640.859497,126.014748 
	C638.480225,128.179474 634.127502,129.734268 636.285156,134.850067 
	C632.783142,133.236328 629.545410,131.744354 625.552734,129.904541 
	C634.336243,129.414597 637.419922,122.239761 643.070374,118.079056 
M647.387451,119.109863 
	C645.325867,122.477081 647.902588,124.557449 654.893005,124.851952 
	C654.893005,120.888206 654.893005,116.941315 654.893005,112.055962 
	C652.146973,114.646912 650.046082,116.629135 647.387451,119.109863 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M492.617065,121.475624 
	C487.473877,122.366440 482.748016,123.165451 477.774109,124.006401 
	C480.664734,119.549088 476.393311,92.344124 471.598694,86.529243 
	C479.278564,85.013580 486.483856,83.591576 494.395447,82.030182 
	C494.607849,84.176697 494.806366,86.183250 494.924194,87.373863 
	C490.432983,87.373863 486.210938,87.373863 481.226105,87.373863 
	C482.151764,92.151245 482.920685,96.119659 483.840576,100.867241 
	C488.255676,99.775490 492.178467,98.805466 496.682190,97.691795 
	C496.855530,99.779587 497.039001,101.989510 497.150116,103.327980 
	C493.083374,103.327980 489.214294,103.327980 484.488770,103.327980 
	C486.025818,108.664337 484.120178,114.686928 489.292542,117.978783 
	C492.625977,120.100304 498.517609,117.095650 501.215881,112.987640 
	C502.904877,119.704018 502.904877,119.704018 492.617065,121.475624 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M615.750061,88.457573 
	C623.849365,90.535927 631.553833,92.509010 639.905823,94.647942 
	C639.343933,96.738503 638.825806,98.666405 638.551514,99.686783 
	C634.263855,97.690529 630.322998,95.855743 625.693848,93.700493 
	C623.014954,104.293732 620.468994,113.717545 618.377502,123.241158 
	C618.012573,124.903091 619.561768,126.985367 620.256287,128.957123 
	C616.866943,128.106506 612.665894,127.052177 609.302917,126.208176 
	C612.454407,115.120728 615.575378,104.140594 619.029419,91.988892 
	C613.561401,91.421127 608.962280,90.943581 604.160400,90.444992 
	C604.653564,89.454132 605.567383,87.618225 606.549011,85.646049 
	C609.701172,86.614754 612.528198,87.483528 615.750061,88.457573 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M680.716309,113.171432 
	C690.254395,118.948166 699.467285,124.561195 709.199585,130.490677 
	C708.213684,132.115845 707.152893,133.864609 706.532715,134.886887 
	C703.174194,131.811646 699.988708,128.894882 696.828430,126.001160 
	C691.078369,131.840591 679.676025,153.179688 679.579712,157.449219 
	C676.231384,155.362137 672.764587,153.201218 669.820496,151.366089 
	C671.492737,150.028183 673.530945,149.079788 674.531799,147.481750 
	C679.556946,139.458176 684.310852,131.264740 689.780884,122.089630 
	C684.981079,120.186440 680.655701,118.471375 675.975891,116.615768 
	C676.930237,115.835861 678.660645,114.421791 680.716309,113.171432 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M717.941711,179.846191 
	C717.583069,180.237091 717.224426,180.628006 716.187195,181.076782 
	C714.644409,181.110291 713.780212,181.085938 712.916077,181.061584 
	C707.278625,176.533630 701.641113,172.005676 695.801697,167.315521 
	C701.063354,166.691437 719.542725,145.066086 720.596985,138.276428 
	C722.794861,140.111420 724.794800,141.781097 726.948486,144.041504 
	C727.410217,144.740479 727.718140,144.848724 728.026123,144.956970 
	C728.345459,145.036331 728.664856,145.115677 728.912109,145.795822 
	C728.379211,146.745438 727.918457,147.094284 727.457703,147.443130 
	C726.085754,147.963074 724.297607,148.108521 723.425415,149.078064 
	C721.373352,151.358978 719.758545,154.033325 717.693176,156.932724 
	C721.079590,159.517578 724.296692,161.973160 727.850342,164.685623 
	C726.411865,166.207047 724.866150,167.841843 723.130005,169.831573 
	C722.939514,170.186508 722.589905,170.053909 722.589905,170.053909 
	C723.251282,164.739624 722.935791,164.248657 714.733276,158.853439 
	C712.312805,163.291260 708.389709,167.547821 707.998718,172.107239 
	C707.671631,175.922440 712.588318,178.324615 717.554199,178.409698 
	C717.923645,179.051514 717.932678,179.448853 717.941711,179.846191 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M585.844971,81.933136 
	C588.183411,82.204964 590.136658,82.320244 592.004578,82.781357 
	C595.984680,83.763885 596.650879,85.811028 594.725708,87.849838 
	C590.923889,86.438988 587.870728,84.837318 584.644836,84.326538 
	C583.244202,84.104790 580.728882,85.796410 580.106140,87.223778 
	C579.477722,88.664284 580.008057,91.280045 581.029480,92.619072 
	C582.704956,94.815613 585.195984,96.387062 587.328918,98.238441 
	C592.796753,102.984520 594.459656,108.510818 591.995483,113.700806 
	C589.722473,118.488152 584.271606,120.809654 577.466858,119.843735 
	C576.150391,119.656860 574.839905,119.378220 573.553162,119.040718 
	C567.835327,117.540970 566.988953,114.800629 570.000183,110.128418 
	C571.645630,112.032677 573.092224,114.722610 575.342651,116.070358 
	C578.622925,118.034836 582.540833,118.321426 585.265991,114.782707 
	C588.115112,111.082932 586.309692,107.873024 583.421387,105.121956 
	C581.856201,103.631165 580.075562,102.369125 578.466492,100.921227 
	C573.747009,96.674400 572.206055,92.143921 573.910095,87.682167 
	C575.985718,82.247780 580.730774,82.141266 585.844971,81.933136 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M397.253235,115.348343 
	C400.790131,113.528435 404.081909,111.997231 407.410583,110.448853 
	C405.555206,115.930931 418.279053,141.923264 424.340942,144.448059 
	C420.477814,146.401031 416.874329,148.222717 413.918030,149.717239 
	C410.470703,137.220474 404.934601,125.864174 397.253235,115.348343 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M328.881226,191.282211 
	C327.025482,190.039078 325.169708,188.795944 323.134277,186.915497 
	C322.977814,185.529114 323.001038,184.780045 323.012756,184.015793 
	C323.001221,184.000610 323.031403,184.024551 323.304199,184.040558 
	C323.923157,183.678024 324.269318,183.299484 324.615509,182.920944 
	C324.083344,182.848434 323.551208,182.775925 323.018066,182.332947 
	C326.839355,177.082184 321.540100,173.137131 321.667664,168.335815 
	C320.419189,168.190109 319.151611,168.042175 317.884064,167.894257 
	C320.363831,164.919037 322.843597,161.943817 325.642914,159.266968 
	C325.654358,161.045944 325.346252,162.526566 325.041931,164.252289 
	C325.045746,164.497406 325.109161,164.983749 325.121460,165.323547 
	C326.046448,166.793762 326.959167,167.924194 327.985291,169.243027 
	C328.410126,169.303818 328.721558,169.176208 329.031067,169.040665 
	C329.029175,169.032730 329.043976,169.062759 329.043976,169.062759 
	C329.240845,169.043396 329.437744,169.024048 329.877380,169.223145 
	C330.111420,169.611221 330.102722,169.780823 330.054077,170.210037 
	C330.002991,170.644424 329.991882,170.819199 330.019440,171.321106 
	C330.701447,172.113556 331.344818,172.578873 331.994720,173.285995 
	C332.001251,173.527817 332.062775,174.007721 332.021454,174.363419 
	C332.081512,176.466675 327.502747,178.236221 332.045349,180.295868 
	C333.712494,182.084991 335.339111,183.541336 336.952911,185.323547 
	C336.933685,186.084213 336.927246,186.518997 336.618713,187.017303 
	C336.552460,189.401077 336.788300,191.721344 337.008545,194.028259 
	C336.992950,194.014923 337.033600,194.011154 336.807617,194.104797 
	C336.300385,194.390762 336.113220,194.650772 335.699829,195.125519 
	C334.251923,195.513885 333.124268,195.755234 331.996582,195.996582 
	C331.996582,195.996582 331.866272,195.530426 332.136902,195.232162 
	C332.157562,193.486115 331.907593,192.038330 331.657623,190.590546 
	C330.732147,190.821106 329.806702,191.051666 328.881226,191.282211 
M333.617157,185.524811 
	C333.617157,185.524811 333.441345,185.422974 333.441345,185.422974 
	C333.441345,185.422974 333.465851,185.628326 333.617157,185.524811 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M767.060486,169.230865 
	C765.248047,172.513840 762.515137,175.293671 761.864380,178.496521 
	C761.444763,180.561768 764.079834,183.247620 765.266235,185.503815 
	C764.234314,185.616714 762.575378,185.798187 760.743652,185.998581 
	C758.906982,184.958664 756.723572,183.722412 754.040039,182.720032 
	C752.355896,181.673721 751.171814,180.393524 749.954529,178.774841 
	C749.270569,177.964722 748.619751,177.493103 747.977661,177.016022 
	C747.986389,177.010574 747.965149,177.037796 747.965210,177.037811 
	C748.762024,174.724136 749.558899,172.410477 750.677856,170.048401 
	C751.000000,170.000000 750.993958,169.994278 750.993958,169.994293 
	C752.174683,171.653534 753.355408,173.312759 754.536133,174.971985 
	C755.168335,174.820847 755.800537,174.669693 756.432739,174.518555 
	C756.289917,172.248764 756.147095,169.978989 756.002197,167.354614 
	C756.000000,167.000000 755.995117,167.005096 755.995117,167.005096 
	C757.319824,165.566757 758.644592,164.128433 759.983459,162.326965 
	C762.339294,164.278244 764.681030,166.592651 767.060486,169.230865 
M753.198853,179.792313 
	C753.288025,180.025253 753.377197,180.258194 753.466370,180.491135 
	C753.488464,180.179291 753.510559,179.867447 753.198853,179.792313 
M751.519104,175.403671 
	C751.519104,175.403671 751.590698,175.520264 751.519104,175.403671 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M336.920837,186.953781 
	C336.927246,186.518997 336.933685,186.084213 337.318298,185.358948 
	C338.806244,185.313721 339.978088,185.911942 341.012695,185.730011 
	C343.099762,185.363007 344.189575,182.473099 343.002686,181.003571 
	C342.999756,180.999725 342.991699,180.991898 342.990295,180.614197 
	C342.992981,179.480026 342.997101,178.723526 343.001221,177.967041 
	C343.842224,177.825592 345.040588,177.263123 345.459625,177.618790 
	C346.928375,178.865479 348.703552,180.222061 349.311188,181.914352 
	C350.578613,185.444290 351.092072,189.237823 352.086487,192.876282 
	C352.508820,194.421432 353.361420,195.848969 354.206512,197.753830 
	C354.776947,196.744934 355.359283,195.714981 355.970825,194.342514 
	C356.000000,194.000000 356.002777,193.996429 356.002777,193.996429 
	C359.271362,195.774414 359.437225,197.831131 357.364777,200.957138 
	C355.894501,203.174866 355.116943,203.491943 352.939331,201.168274 
	C349.988312,198.724548 347.778625,196.378128 345.297363,194.366745 
	C344.151855,193.438141 342.643036,189.510300 340.601746,194.090393 
	C339.494354,194.042206 338.756165,194.009018 338.154327,193.677185 
	C339.192749,191.917969 340.094849,190.457397 341.287537,189.000397 
	C342.094055,188.802887 342.610016,188.601822 343.125977,188.400757 
	C342.891937,188.197205 342.515594,187.778717 342.446594,187.824402 
	C341.931183,188.165695 341.476593,188.598816 340.666870,188.974030 
	C339.194122,188.281189 338.057495,187.617493 336.920837,186.953781 
M346.485016,185.592087 
	C346.485016,185.592087 346.416687,185.477570 346.485016,185.592087 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M338.018005,193.975845 
	C338.756165,194.009018 339.494354,194.042206 340.620392,194.437561 
	C340.512726,195.920959 340.017181,197.042175 339.546204,198.107849 
	C341.015961,199.808624 343.767975,201.561737 343.687378,203.173157 
	C343.461914,207.679779 345.987152,208.544113 349.337982,209.099640 
	C347.830414,210.744751 346.322845,212.389862 344.475830,214.021332 
	C340.997894,207.631836 331.915405,205.460815 331.987244,196.408539 
	C333.124268,195.755234 334.251923,195.513885 335.927795,195.036057 
	C336.758423,194.605103 336.944305,194.342300 337.033600,194.011154 
	C337.033600,194.011154 336.992950,194.014923 337.257141,194.014648 
	C337.521301,194.014389 338.018005,193.975845 338.018005,193.975845 
M341.801727,203.747879 
	C341.433167,203.644699 341.064636,203.541519 340.696075,203.438324 
	C340.878387,203.984512 341.060699,204.530685 341.242981,205.076874 
	C341.464417,204.810852 341.685852,204.544846 341.801727,203.747879 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M349.639252,209.020477 
	C345.987152,208.544113 343.461914,207.679779 343.687378,203.173157 
	C343.767975,201.561737 341.015961,199.808624 339.546204,198.107849 
	C340.017181,197.042175 340.512726,195.920959 340.989624,194.452576 
	C342.643036,189.510300 344.151855,193.438141 345.297363,194.366745 
	C347.778625,196.378128 349.988312,198.724548 352.661255,200.968140 
	C353.019379,201.753372 353.025330,202.504410 353.016357,203.628113 
	C353.001404,204.000748 353.006927,204.033813 353.006927,204.033813 
	C352.494202,204.643860 351.895447,205.202057 351.489227,205.876251 
	C350.900055,206.854004 350.449921,207.915527 349.639252,209.020477 
M343.164032,195.754837 
	C343.107147,195.581985 343.050262,195.409134 342.993378,195.236298 
	C342.936981,195.409195 342.880585,195.582092 343.164032,195.754837 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M317.000305,181.032364 
	C314.249115,180.687729 311.497955,180.343109 308.342346,180.001297 
	C308.860199,177.865906 309.464752,175.500092 310.789795,173.650421 
	C312.255280,171.604721 314.380341,170.031540 316.563293,168.624466 
	C316.419250,170.316727 315.929993,171.637100 315.944977,171.596649 
	C317.176788,175.158707 318.027191,177.617889 318.595032,180.078430 
	C317.875092,180.397324 317.437714,180.714844 317.000305,181.032364 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M318.877594,180.077072 
	C318.027191,177.617889 317.176788,175.158707 315.944977,171.596649 
	C315.929993,171.637100 316.419250,170.316727 316.889984,168.656128 
	C317.037323,168.238297 317.203186,168.160690 317.626587,167.988678 
	C319.151611,168.042175 320.419189,168.190109 321.667664,168.335815 
	C321.540100,173.137131 326.839355,177.082184 322.989349,182.664566 
	C322.984863,183.585953 323.008118,183.805252 323.031403,184.024551 
	C323.031403,184.024551 323.001221,184.000610 322.653107,183.984711 
	C321.584015,183.973267 320.863007,183.977707 320.117035,183.630066 
	C319.687225,182.210999 319.282410,181.144028 318.877594,180.077072 
z"
      />
      <path
        fill="#336054"
        opacity="1.000000"
        stroke="none"
        d="
M653.737793,159.855591 
	C652.340637,161.458527 650.678711,162.819443 648.510742,164.594711 
	C646.388489,157.739441 641.254272,156.061554 635.737549,154.644180 
	C634.330688,154.282715 633.312378,152.408905 632.134766,150.824860 
	C639.260376,153.484329 646.366699,156.548935 653.737793,159.855591 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M342.691650,177.997894 
	C342.997101,178.723526 342.992981,179.480026 342.666870,180.647247 
	C341.896973,181.705750 341.449097,182.353485 340.755798,183.005646 
	C340.230408,183.132339 339.950409,183.254593 339.670441,183.376831 
	C339.758606,183.504242 339.846771,183.631653 339.934906,183.759064 
	C340.289520,183.505646 340.644165,183.252213 341.264709,182.876968 
	C342.022278,182.172562 342.513947,181.589981 343.005615,181.007401 
	C344.189575,182.473099 343.099762,185.363007 341.012695,185.730011 
	C339.978088,185.911942 338.806244,185.313721 337.331116,185.033066 
	C335.339111,183.541336 333.712494,182.084991 332.158875,180.039948 
	C334.155792,178.621582 336.079712,177.791916 338.003662,176.962250 
	C339.231140,178.270187 340.392120,179.851135 342.691650,177.997894 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M727.619141,147.746521 
	C727.918457,147.094284 728.379211,146.745438 729.054688,146.017181 
	C732.338013,147.869675 735.406494,150.101578 738.891602,152.636475 
	C737.176208,154.507965 735.659485,156.162704 733.143188,158.908035 
	C734.728638,152.630234 730.434875,150.867294 727.619141,147.746521 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M338.008057,176.615570 
	C336.079712,177.791916 334.155792,178.621582 332.118347,179.707169 
	C327.502747,178.236221 332.081512,176.466675 332.362000,174.321533 
	C333.829620,172.282410 334.915405,170.640900 336.001221,168.999374 
	C336.257477,170.890594 336.513733,172.781830 336.769989,174.673065 
	C337.706787,173.768387 338.643616,172.863708 339.580444,171.959015 
	C339.057770,173.395645 338.535095,174.832260 338.008057,176.615570 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M722.416138,170.540405 
	C722.589905,170.053909 722.939514,170.186508 723.004272,170.136444 
	C724.667786,170.783432 726.232544,171.579315 727.876343,172.145432 
	C729.127625,172.576340 730.479370,172.715515 731.975098,173.023285 
	C730.439514,178.006958 726.802673,177.370987 724.024231,176.643661 
	C723.009705,176.378098 722.812500,172.990280 722.416138,170.540405 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M325.038147,164.007172 
	C325.346252,162.526566 325.654358,161.045944 325.979065,159.171204 
	C327.364990,157.914230 328.734375,157.051407 330.103729,156.188599 
	C330.160492,157.848969 330.344635,159.519272 330.216156,161.165176 
	C330.158600,161.902634 329.474609,162.591217 328.640259,163.650665 
	C327.149780,164.001968 326.093964,164.004578 325.038147,164.007172 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M336.000610,168.999695 
	C334.915405,170.640900 333.829620,172.282410 332.403320,173.965820 
	C332.062775,174.007721 332.001251,173.527817 331.959137,172.957428 
	C331.271606,171.922699 330.626221,171.458328 329.980804,170.993973 
	C329.991882,170.819199 330.002991,170.644424 330.241547,170.095001 
	C330.710968,169.501480 330.805084,169.231018 330.751373,168.908966 
	C331.233398,166.658432 331.741302,164.438477 334.711914,165.886414 
	C335.000702,167.260803 335.500946,168.129791 336.001221,168.998779 
	C336.001221,168.998779 336.000000,169.000000 336.000610,168.999695 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M327.871887,169.054611 
	C326.959167,167.924194 326.046448,166.793762 325.455048,165.333313 
	C326.860718,165.671326 327.945068,166.339355 329.029419,167.007385 
	C329.029785,167.463776 329.030151,167.920181 329.037231,168.719666 
	C329.043976,169.062759 329.029175,169.032730 328.740662,169.029831 
	C328.258728,169.036163 328.065308,169.045380 327.871887,169.054611 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M329.278625,166.836365 
	C327.945068,166.339355 326.860718,165.671326 325.442749,164.993515 
	C325.109161,164.983749 325.045746,164.497406 325.041962,164.252289 
	C326.093964,164.004578 327.149780,164.001968 328.602173,163.999069 
	C329.768524,163.900665 330.538269,163.802567 331.878204,163.631775 
	C330.923187,164.864410 330.225494,165.764893 329.278625,166.836365 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M335.999207,168.661438 
	C335.500946,168.129791 335.000702,167.260803 334.758667,166.193909 
	C335.343628,166.772049 335.670410,167.548065 335.999207,168.661438 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M718.223267,179.748856 
	C717.932678,179.448853 717.923645,179.051514 717.966980,178.359772 
	C718.506348,177.815765 718.993347,177.566147 719.480469,177.316528 
	C719.155212,178.094864 718.830017,178.873184 718.223267,179.748856 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M739.667358,150.505066 
	C740.011658,149.961914 740.570984,149.636383 741.130310,149.310852 
	C741.257935,149.589630 741.385620,149.868408 741.513306,150.147171 
	C740.969666,150.339005 740.426025,150.530838 739.667358,150.505066 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M713.029053,181.327118 
	C713.780212,181.085938 714.644409,181.110291 715.939148,181.178421 
	C715.293884,181.345673 714.217957,181.469162 713.029053,181.327118 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M343.741760,172.556152 
	C343.873352,172.139206 344.158203,171.872299 344.443024,171.605408 
	C344.532074,171.717514 344.711365,171.913528 344.696747,171.929245 
	C344.443665,172.201401 344.166687,172.451385 343.741760,172.556152 
z"
      />
      <path
        fill="#336054"
        opacity="1.000000"
        stroke="none"
        d="
M627.824829,148.714935 
	C627.852722,149.277481 627.696838,149.669617 627.540955,150.061768 
	C627.391479,149.730713 627.242004,149.399673 627.117981,148.776260 
	C627.309326,148.504120 627.475220,148.524323 627.824829,148.714935 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M719.543457,137.856689 
	C719.178833,137.905334 718.934082,137.771393 718.689270,137.637466 
	C719.013916,137.649673 719.338623,137.661880 719.543457,137.856689 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M341.394714,174.717697 
	C341.558411,174.846634 341.582458,175.070328 341.606476,175.294006 
	C341.489349,175.133484 341.372223,174.972961 341.394714,174.717697 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M355.998169,194.001389 
	C355.874786,193.858200 355.753235,193.713623 355.631683,193.569031 
	C355.718048,193.618881 355.804382,193.668716 355.946777,193.857498 
	C356.002777,193.996429 356.000000,194.000000 355.998169,194.001389 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M382.331665,124.199310 
	C382.227844,123.998009 382.092651,123.784477 381.957458,123.570946 
	C382.106842,123.641632 382.256226,123.712318 382.322449,123.970886 
	C382.239258,124.158760 382.300323,124.187065 382.331665,124.199310 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M758.745239,160.891739 
	C758.713379,161.017807 758.433167,161.161087 758.076050,161.100922 
	C757.999084,160.897476 758.496887,160.908951 758.745239,160.891739 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M729.550476,159.466125 
	C729.583984,159.522232 729.516968,159.410004 729.550476,159.466125 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M352.556763,190.462769 
	C352.594238,190.523315 352.519318,190.402222 352.556763,190.462769 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M727.857788,144.812683 
	C727.718140,144.848724 727.410217,144.740479 727.046875,144.377075 
	C727.218628,144.311127 727.451233,144.493271 727.857788,144.812683 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M741.467529,153.449478 
	C741.523071,153.416275 741.412048,153.482681 741.467529,153.449478 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M330.619965,168.921539 
	C330.805084,169.231018 330.710968,169.501480 330.281555,169.835373 
	C330.102722,169.780823 330.111420,169.611221 330.172363,169.190826 
	C330.224579,168.940063 330.488556,168.934128 330.619965,168.921539 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M353.018036,204.003693 
	C353.152466,204.154388 353.270294,204.302124 353.388123,204.449860 
	C353.297424,204.403687 353.206726,204.357513 353.061462,204.172577 
	C353.006927,204.033813 353.001404,204.000748 353.018036,204.003693 
z"
      />
      <path
        fill="#0F181C"
        opacity="1.000000"
        stroke="none"
        d="
M753.272827,583.670837 
	C753.072266,584.100586 752.871704,584.530334 752.035461,584.994385 
	C749.265503,584.887268 747.131226,584.745850 744.693604,584.747070 
	C743.320618,585.608582 742.251099,586.327515 740.788940,587.036255 
	C739.286194,588.410278 738.176025,589.794495 737.030640,591.486206 
	C736.331055,592.527100 735.666748,593.260437 734.859680,593.675537 
	C733.711670,592.526062 732.706360,591.694885 731.759583,590.589050 
	C731.770325,589.768982 731.722595,589.223572 731.840698,588.279419 
	C732.339355,585.930664 732.672119,583.980713 733.370972,582.006348 
	C734.470886,581.962524 735.204590,581.943115 736.170532,582.206787 
	C737.959839,582.344360 739.675415,581.702332 741.046143,582.140076 
	C746.686218,583.941528 746.031006,580.217285 745.943359,576.597839 
	C745.890381,576.118835 745.852966,575.929260 746.079956,575.580322 
	C746.552185,574.506226 746.760132,573.591614 746.883179,572.328491 
	C743.739868,570.968750 740.681519,569.957581 736.850159,568.690857 
	C740.070801,568.026062 743.229797,568.276245 744.924255,566.820984 
	C747.737122,564.405334 753.716736,567.247864 754.396973,561.096008 
	C756.176636,560.011658 757.602295,559.025574 759.142334,557.646484 
	C758.506104,556.664551 757.755432,556.075623 756.866272,555.153442 
	C754.284607,554.351013 751.841431,553.881836 749.398315,553.412720 
	C749.298096,552.928223 749.197815,552.443726 749.097595,551.959290 
	C751.436035,551.303955 753.748474,550.527588 756.118286,550.018311 
	C761.163330,548.934021 766.318176,548.130798 769.197998,542.560059 
	C770.859070,541.841370 772.255798,541.342041 773.652588,540.842712 
	C773.600586,540.224731 773.548523,539.606750 773.496521,538.988708 
	C765.744995,538.698303 757.993408,538.407837 749.825317,538.068237 
	C747.493530,537.321106 745.578308,536.623169 743.769409,535.597412 
	C744.883118,534.392761 745.890564,533.515991 747.124756,532.980225 
	C753.816711,533.500732 760.494690,534.740845 766.675049,533.500916 
	C771.063110,532.620544 774.779663,528.393860 778.876038,525.428162 
	C779.130371,524.899902 779.190308,524.582581 779.420044,524.143066 
	C780.180725,523.712097 780.657288,523.381775 781.477905,523.041504 
	C782.490173,522.354858 783.158203,521.678223 783.826294,521.001526 
	C783.223022,520.978577 782.619812,520.955566 781.554871,520.881104 
	C777.087402,521.000244 773.081604,521.170776 768.668518,521.238037 
	C763.555420,522.480835 758.849548,523.826904 753.807373,525.080017 
	C753.181030,524.314514 752.464355,523.428955 752.675293,523.006531 
	C753.575867,521.202820 754.750488,519.535889 756.304138,517.858521 
	C760.373840,517.924683 764.114807,518.596130 767.514709,517.803894 
	C771.199646,516.945312 774.566833,514.722778 778.398071,512.983154 
	C781.475464,510.520111 784.227539,508.168915 787.251465,505.658203 
	C788.774414,504.319641 790.025452,503.140625 791.276489,501.961609 
	C791.115906,501.565552 790.955261,501.169495 790.794617,500.773438 
	C786.889160,501.316772 782.983643,501.860077 779.067993,502.024658 
	C781.516296,499.684235 783.866577,497.563751 786.458191,495.797272 
	C790.593872,492.978394 795.891541,491.268524 796.024536,484.633789 
	C796.452271,483.730316 796.756042,483.098816 797.153381,482.272919 
	C793.263489,482.828064 789.821411,483.319305 786.299194,483.428986 
	C787.491821,481.684723 788.761414,480.319153 790.037781,478.959869 
	C793.181030,475.612701 798.465698,473.784637 798.060303,467.517761 
	C799.010437,466.323792 799.829773,465.440887 801.366943,463.784363 
	C798.183105,464.153900 796.027588,464.404083 793.921448,464.268768 
	C796.475220,458.614777 801.363220,454.387451 801.055054,447.546997 
	C801.316833,446.410889 801.495911,445.582092 801.768250,444.321075 
	C799.156555,445.122620 797.128174,445.745148 794.970337,446.010834 
	C793.274475,438.806885 788.575684,437.308990 782.278687,437.916992 
	C779.918152,438.144928 777.457153,437.332184 774.875732,436.819916 
	C774.486450,436.413055 774.237000,436.212982 773.943420,435.759552 
	C773.955505,434.402985 773.985413,433.332642 774.015259,432.262268 
	C775.085571,432.221466 776.155884,432.180634 777.698730,432.376282 
	C778.442505,432.509491 778.713684,432.406311 778.984863,432.303101 
	C784.079407,432.303070 789.173889,432.303070 794.651978,432.303070 
	C794.492371,434.665710 794.385193,436.252014 794.232605,438.511322 
	C802.162231,435.898621 806.945129,429.498688 814.074036,423.910889 
	C812.863098,469.869720 800.261047,511.155426 776.722656,549.757385 
	C775.512085,551.273132 774.947266,552.522888 774.382385,553.772644 
	C773.083923,556.050781 771.785461,558.328857 769.980713,560.929077 
	C769.342590,561.572693 769.210876,561.894165 769.079163,562.215576 
	C766.646912,565.732300 764.214600,569.248962 761.159119,572.917358 
	C760.222107,573.793457 759.908325,574.517761 759.594543,575.242065 
	C759.312378,575.771606 759.030151,576.301208 758.077271,576.990723 
	C757.030151,577.992310 756.653748,578.833923 756.277344,579.675598 
	C756.064636,580.094604 755.851990,580.513550 755.017334,581.035889 
	C754.021179,581.983093 753.646973,582.826965 753.272827,583.670837 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M743.829956,315.429626 
	C744.786133,315.005737 745.617554,315.013092 747.023560,315.271423 
	C748.170593,316.277344 748.743042,317.032288 749.235840,318.068909 
	C749.252930,318.726532 749.349731,319.102478 749.398804,319.848236 
	C751.960632,330.246796 763.138733,333.423889 770.469238,326.256226 
	C778.219421,332.532410 782.739624,332.744110 788.546631,327.061554 
	C789.327942,327.027954 789.640564,327.013763 789.876404,327.362335 
	C789.581360,328.432556 789.363098,329.140045 788.778015,330.006470 
	C789.230042,332.829254 790.048828,335.493134 790.843689,338.515869 
	C792.320557,344.434326 795.868896,344.019409 800.055542,342.291382 
	C800.262512,342.735107 800.377991,342.896027 800.452881,343.490356 
	C800.407959,345.933258 800.403625,347.942749 800.262207,350.203613 
	C800.068237,350.637207 800.011353,350.819458 799.786438,351.112671 
	C799.810852,351.484406 800.003235,351.745117 800.307617,352.214264 
	C800.547546,352.729431 800.557373,353.039886 800.260864,353.661896 
	C799.487549,354.304138 798.902466,354.638580 797.998901,354.802490 
	C795.639038,354.200226 793.597656,353.768494 791.166260,353.235291 
	C790.512573,353.081696 790.248962,353.029633 790.001831,352.628113 
	C790.010742,352.045441 790.003174,351.812164 790.284180,351.510162 
	C790.904236,350.280121 791.235596,349.118805 791.567810,347.548096 
	C789.207336,337.555817 780.280334,331.778046 770.618774,333.856812 
	C768.562439,334.299286 765.126221,333.540192 765.114624,337.883545 
	C764.467712,338.548248 764.040405,338.871033 763.332764,339.003815 
	C759.883911,337.646637 756.796265,335.893524 753.528992,335.442780 
	C747.939758,334.671814 747.628235,335.296997 748.238403,341.222626 
	C748.841187,342.624084 749.526062,343.705353 750.168335,345.158447 
	C751.720337,351.766388 756.060059,353.676025 762.094238,353.223907 
	C762.459229,353.260620 762.729614,353.137665 763.246704,352.984253 
	C763.493530,352.953857 763.989014,352.912445 764.166138,353.187073 
	C764.950684,354.068634 765.557983,354.675568 766.140747,355.651337 
	C765.821838,357.648010 765.527466,359.275818 765.160522,361.265991 
	C765.047241,361.871338 765.006470,362.114319 764.645386,362.180206 
	C759.669128,357.437500 754.006348,357.699890 747.545959,358.270752 
	C748.078125,359.967743 748.446960,361.143921 748.772095,362.685791 
	C750.150940,365.704254 751.573547,368.357025 753.037720,371.360840 
	C755.166931,372.865875 757.189453,374.164642 759.357422,375.139984 
	C762.637024,376.615417 765.086975,375.855164 766.030029,372.040649 
	C766.011902,372.012695 766.069336,372.046600 766.435669,371.990997 
	C767.056702,370.846893 767.311401,369.758392 767.570007,368.390198 
	C767.556519,367.738037 767.539185,367.365540 767.877563,366.842102 
	C768.475098,366.249298 768.716919,365.807465 769.382202,365.508850 
	C771.524536,366.133850 773.243408,366.615601 774.657227,367.313538 
	C772.712341,369.670258 771.072510,371.810822 769.208862,374.288513 
	C768.819214,375.416840 768.653381,376.208069 768.381592,377.128235 
	C768.411804,377.524261 768.547913,377.791321 768.791382,378.280609 
	C768.898804,378.502808 769.020203,378.981232 768.981262,379.229675 
	C768.955933,379.645172 768.969604,379.812225 768.991638,379.989044 
	C769.000000,379.998779 768.985962,379.982147 768.711548,379.970703 
	C768.257812,379.996399 768.078491,380.033508 767.571655,379.909424 
	C763.680176,376.252075 760.457642,378.693054 757.135437,379.933411 
	C752.926453,375.028473 748.776428,370.511230 744.593018,366.025208 
	C744.434998,365.855743 743.953552,365.987854 743.622803,365.979431 
	C743.650269,349.273254 743.677673,332.567047 743.829956,315.429626 
M746.113586,353.073090 
	C747.399109,355.966095 747.399109,355.966095 750.722839,352.991974 
	C749.234680,352.813080 747.746521,352.634186 746.113586,353.073090 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M742.550354,445.976135 
	C742.735229,441.652496 742.920044,437.328827 743.169067,432.550323 
	C745.858704,432.082214 748.484131,432.069000 751.629456,432.294067 
	C752.434875,432.424805 752.720398,432.317291 753.005920,432.209778 
	C758.013733,432.177155 763.021606,432.144562 768.504883,432.543457 
	C768.976929,433.927307 768.973633,434.879730 768.905396,436.246521 
	C768.856689,437.767303 768.872742,438.873718 768.648010,440.267181 
	C767.461426,442.119263 766.515686,443.684296 765.318115,445.036713 
	C763.470032,443.004944 762.023132,441.007080 760.188477,439.472931 
	C759.620605,438.998108 757.998230,439.784363 756.599854,440.305756 
	C756.229797,442.570160 756.052368,444.520996 756.022217,446.474121 
	C755.973328,449.648743 756.020813,452.824860 755.714966,456.087219 
	C754.993591,457.140472 754.584778,458.106873 753.843445,459.314392 
	C752.904724,463.604340 752.298584,467.653076 751.358276,471.520142 
	C750.267700,473.202576 749.511353,475.066681 748.442627,477.034821 
	C748.089172,479.095978 748.048035,481.053101 747.732483,483.209229 
	C746.622559,484.715393 745.786987,486.022583 744.634827,487.261169 
	C743.858643,487.813080 743.399170,488.433594 742.655273,489.283020 
	C741.242676,493.410980 740.114441,497.309967 738.734009,501.304565 
	C738.013611,501.946136 737.545410,502.492065 736.695068,502.958710 
	C735.922119,501.265594 734.914612,499.500397 735.266174,498.068939 
	C736.041443,494.911896 737.695129,491.978821 738.599609,488.841705 
	C739.041565,487.308716 738.609192,485.523621 738.614990,483.541077 
	C738.771179,482.826263 738.885010,482.423035 739.384644,481.962830 
	C740.675964,478.939758 742.198486,476.009094 742.371277,473.000916 
	C742.887207,464.014313 742.874390,454.997314 742.939819,445.948425 
	C742.811646,445.904694 742.550354,445.976135 742.550354,445.976135 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M744.997070,584.604492 
	C747.131226,584.745850 749.265503,584.887268 751.793457,585.053467 
	C735.079468,605.925964 715.784973,624.370544 692.991089,638.974854 
	C692.316528,639.407104 691.739258,639.991211 690.686279,640.234375 
	C690.316956,638.783020 690.378052,637.601868 690.401062,637.155823 
	C680.147400,639.846313 670.047302,642.409302 660.021179,645.234314 
	C658.723999,645.599915 657.808533,647.320374 656.451660,648.197083 
	C654.844238,646.370117 653.501526,644.759277 652.453674,642.885010 
	C653.198792,642.345825 653.648987,642.070068 654.543701,641.902161 
	C664.087341,642.514832 672.812134,641.118591 681.348633,636.956787 
	C684.867554,635.379822 688.017944,633.739319 691.505920,632.046143 
	C694.900024,630.002686 697.956421,628.011963 701.357361,625.974365 
	C713.436462,615.799438 725.238159,605.746948 736.837158,595.465698 
	C738.688599,593.824524 739.630676,591.157471 740.995605,588.983765 
	C740.998108,589.002808 740.960876,589.000427 741.320312,588.983459 
	C742.785461,587.512512 743.891235,586.058533 744.997070,584.604492 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M743.179077,413.973114 
	C743.163818,412.262848 743.148499,410.552612 743.570801,408.481262 
	C746.973083,410.088806 749.937866,412.057465 753.145996,414.261169 
	C755.247864,415.318878 757.106323,416.141510 759.110962,417.196747 
	C759.845093,417.297577 760.432983,417.165802 761.428345,417.002625 
	C763.197388,416.943054 764.558960,416.914886 766.131531,417.167480 
	C767.173218,416.838898 768.003906,416.229553 768.824463,415.462555 
	C768.814331,415.304871 768.910706,415.003876 769.309509,415.009216 
	C773.887817,416.705261 778.067383,418.395996 782.175415,420.403931 
	C782.051453,421.151611 781.998962,421.582153 781.666321,422.153595 
	C780.915222,423.389679 780.444275,424.484833 779.973328,425.579956 
	C768.986389,425.659698 757.999512,425.739441 746.532898,425.447266 
	C745.128296,424.353943 744.203430,423.632507 743.278503,422.911102 
	C743.233765,422.188660 743.189026,421.466187 743.424744,420.111084 
	C743.529846,417.643311 743.354492,415.808228 743.179077,413.973114 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M752.902588,414.026123 
	C749.937866,412.057465 746.973083,410.088806 743.679077,408.067200 
	C743.320129,402.694122 743.290527,397.373932 743.682312,391.595917 
	C746.513123,392.490479 748.803223,394.164032 751.361755,395.114899 
	C754.642517,396.334137 758.123718,397.601868 761.547180,397.686005 
	C765.077881,397.772766 766.263977,395.644562 766.012939,391.716858 
	C765.671326,390.938690 765.370056,390.459412 765.008301,389.672607 
	C764.295105,388.927368 763.642334,388.489655 762.897339,387.831512 
	C762.598999,387.334686 762.323669,387.193665 761.835754,386.962158 
	C761.520020,386.691284 761.347534,386.646179 761.126404,386.331696 
	C760.966492,385.714691 760.855164,385.367065 760.918274,384.701538 
	C762.019592,384.232880 762.946594,384.082092 764.185425,384.068390 
	C765.349426,384.492615 766.201416,384.779724 767.124146,385.393555 
	C769.572571,389.869751 771.950256,394.019257 774.055115,398.406677 
	C769.931213,400.103943 766.511047,401.890839 767.230286,406.827576 
	C766.512085,406.754089 766.005127,406.838196 765.261353,406.643402 
	C759.887756,402.046204 754.123535,400.077545 746.578430,401.334320 
	C747.566223,403.311157 748.260620,404.700806 748.888672,406.426758 
	C749.355103,407.752533 749.887878,408.742004 750.400269,410.048279 
	C751.220764,411.585419 752.061707,412.805786 752.902588,414.026123 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M656.716187,648.413208 
	C657.808533,647.320374 658.723999,645.599915 660.021179,645.234314 
	C670.047302,642.409302 680.147400,639.846313 690.401062,637.155823 
	C690.378052,637.601868 690.316956,638.783020 690.344666,640.343384 
	C690.433411,640.722534 690.396545,640.700317 690.132874,640.595886 
	C689.657654,640.765076 689.446106,641.038696 689.234558,641.312317 
	C689.234558,641.312317 688.989563,641.099976 688.813232,641.089478 
	C688.421570,641.053894 688.206360,641.028809 687.626404,641.011353 
	C686.532837,641.741577 685.803894,642.464172 685.074951,643.186707 
	C685.044067,643.534241 684.868408,643.777039 683.932739,643.966919 
	C682.236328,644.721191 681.155212,645.423706 680.074097,646.126282 
	C680.074097,646.126282 680.041260,646.030884 679.715027,646.037964 
	C678.609924,646.727356 677.831116,647.409668 677.052246,648.092041 
	C677.052246,648.092041 677.013733,648.012817 676.657959,648.019104 
	C675.229248,648.756104 674.156311,649.486755 673.083374,650.217407 
	C672.637878,650.549744 672.192444,650.882080 671.419189,651.218750 
	C669.923401,650.921936 668.307373,649.977295 667.661865,650.426697 
	C664.126343,652.888245 661.480286,650.857422 658.342407,649.063232 
	C657.988037,649.004761 657.500366,648.991577 657.135254,648.872375 
	C656.770081,648.753174 656.716187,648.413147 656.716187,648.413208 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M743.495972,366.368103 
	C743.953552,365.987854 744.434998,365.855743 744.593018,366.025208 
	C748.776428,370.511230 752.926453,375.028473 757.175842,380.194092 
	C757.278137,381.198730 757.286865,381.549591 756.939026,381.958160 
	C756.057983,382.952576 755.533508,383.889313 754.753296,384.881653 
	C754.328735,384.893890 754.159790,384.850464 753.719849,384.571350 
	C745.009644,384.322449 745.083130,384.321198 744.927551,375.282379 
	C744.897095,373.510773 744.054199,371.753113 743.586060,369.989044 
	C743.513733,368.911621 743.441467,367.834167 743.495972,366.368103 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M780.411987,425.704346 
	C780.444275,424.484833 780.915222,423.389679 782.032227,422.144226 
	C785.504211,419.393860 788.330017,416.793762 791.539185,414.188934 
	C795.092651,414.872589 798.391907,416.530426 801.309875,412.880890 
	C802.145142,411.927032 802.666443,411.066559 803.104004,410.123901 
	C803.020203,410.041748 803.206604,410.184204 803.540649,410.151306 
	C804.535522,409.053406 805.196472,407.988434 806.141357,406.690674 
	C806.578735,405.749939 806.732117,405.041992 807.159180,404.187195 
	C807.773376,403.012878 808.113892,401.985413 808.454407,400.957977 
	C810.731506,399.991577 813.008545,399.025177 815.637451,398.018188 
	C812.959229,402.504456 810.393127,407.457977 806.749329,411.420532 
	C803.934387,414.481720 800.460266,417.357574 795.404846,417.099976 
	C790.476624,416.848846 788.024902,420.243011 789.005127,425.301575 
	C786.293091,425.706451 783.571838,425.767609 780.411987,425.704346 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M766.053345,392.015717 
	C766.263977,395.644562 765.077881,397.772766 761.547180,397.686005 
	C758.123718,397.601868 754.642517,396.334137 751.361755,395.114899 
	C748.803223,394.164032 746.513123,392.490479 743.763611,391.144897 
	C743.305115,390.345886 743.186768,389.540039 743.456421,388.333801 
	C744.273193,388.015503 744.702148,388.097656 745.201172,388.520752 
	C751.912109,391.800629 758.552368,394.744019 766.053345,392.015717 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M745.131042,388.179810 
	C744.702148,388.097656 744.273193,388.015503 743.515625,387.928680 
	C743.235046,382.247528 743.283142,376.571075 743.458618,370.441833 
	C744.054199,371.753113 744.897095,373.510773 744.927551,375.282379 
	C745.083130,384.321198 745.009644,384.322449 753.397705,384.727112 
	C751.876648,385.802399 750.406555,386.486267 748.595947,387.108276 
	C747.213989,387.424225 746.172546,387.802002 745.131042,388.179810 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M768.970276,435.832123 
	C768.973633,434.879730 768.976929,433.927307 768.962891,432.617126 
	C770.362183,432.174225 771.778931,432.089142 773.605469,432.133179 
	C773.985413,433.332642 773.955505,434.402985 773.527588,435.751831 
	C771.743164,435.964233 770.356689,435.898163 768.970276,435.832123 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M743.911133,303.427795 
	C744.210327,305.491119 744.385681,307.986053 744.274414,310.745972 
	C743.920898,308.627136 743.854065,306.243286 743.911133,303.427795 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M743.153687,423.286346 
	C744.203430,423.632507 745.128296,424.353943 746.073975,425.388000 
	C745.072693,425.020966 744.050781,424.341278 743.153687,423.286346 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M774.674744,553.605835 
	C774.947266,552.522888 775.512085,551.273132 776.482300,550.004700 
	C776.247498,551.137085 775.607300,552.288086 774.674744,553.605835 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M673.439453,650.200134 
	C674.156311,649.486755 675.229248,648.756104 676.696045,648.041260 
	C675.991760,648.765747 674.893616,649.474304 673.439453,650.200134 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M680.425049,646.109863 
	C681.155212,645.423706 682.236328,644.721191 683.706116,644.027466 
	C682.988525,644.722046 681.882263,645.407715 680.425049,646.109863 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M743.052612,414.392517 
	C743.354492,415.808228 743.529846,417.643311 743.472046,419.751312 
	C743.134521,418.286774 743.030273,416.549316 743.052612,414.392517 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M759.848511,575.115479 
	C759.908325,574.517761 760.222107,573.793457 760.865845,573.072754 
	C760.831299,573.713806 760.466919,574.351318 759.848511,575.115479 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M677.387329,648.058960 
	C677.831116,647.409668 678.609924,646.727356 679.757568,646.065063 
	C679.325012,646.732056 678.523682,647.378967 677.387329,648.058960 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M685.410034,643.166138 
	C685.803894,642.464172 686.532837,641.741577 687.626404,641.236694 
	C687.991089,641.454346 687.992126,641.905212 687.992126,641.905212 
	C687.243164,642.318665 686.494141,642.732117 685.410034,643.166138 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M753.578064,583.524414 
	C753.646973,582.826965 754.021179,581.983093 754.782410,581.101318 
	C754.740723,581.834961 754.312012,582.606445 753.578064,583.524414 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M756.576904,579.518921 
	C756.653748,578.833923 757.030151,577.992310 757.794128,577.110352 
	C757.746643,577.834167 757.311584,578.598267 756.576904,579.518921 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M744.995728,288.700012 
	C745.008911,288.998779 744.544983,289.016052 744.312866,289.020660 
	C743.986755,288.587128 743.892639,288.148987 743.880127,287.380219 
	C744.301941,287.500153 744.642273,287.950714 744.995728,288.700012 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M689.467529,641.317749 
	C689.446106,641.038696 689.657654,640.765076 690.126648,640.615234 
	C690.261108,641.056396 690.033264,641.251160 689.467529,641.317749 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M688.261963,642.006104 
	C687.992126,641.905212 687.991089,641.454346 687.991089,641.229004 
	C688.206360,641.028809 688.421570,641.053894 688.945679,641.182739 
	C689.013672,641.560059 688.772705,641.833557 688.261963,642.006104 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M769.334106,562.106262 
	C769.210876,561.894165 769.342590,561.572693 769.705078,561.117065 
	C769.820312,561.320923 769.704712,561.658936 769.334106,562.106262 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M796.282654,426.049011 
	C796.247864,425.710480 796.511169,425.470459 797.047058,425.229248 
	C797.073364,425.534546 796.827026,425.841034 796.282654,426.049011 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M752.750793,432.099915 
	C752.720398,432.317291 752.434875,432.424805 752.065002,432.365295 
	C752.152344,432.128845 752.323975,432.059448 752.750793,432.099915 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M778.743408,432.197815 
	C778.713684,432.406311 778.442505,432.509491 778.093994,432.455078 
	C778.178467,432.229126 778.340210,432.160828 778.743408,432.197815 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M279.957489,251.211304 
	C281.554352,251.903702 283.151184,252.596100 284.894165,253.932343 
	C285.725220,255.033325 286.410156,255.490448 287.095093,255.947556 
	C287.419464,256.025177 287.668304,256.206482 287.913147,257.100403 
	C287.947876,259.026428 287.910980,260.343567 287.874084,261.660675 
	C287.804993,262.197693 287.735901,262.734680 287.467163,263.882202 
	C287.149170,265.511505 287.030823,266.530304 286.912476,267.549133 
	C286.458527,267.236267 286.004547,266.923431 285.264191,266.154602 
	C284.273682,266.044342 283.569580,266.390045 282.865448,266.735748 
	C282.865448,266.735748 282.878662,266.869751 282.453369,266.852173 
	C281.075317,266.861969 280.122589,266.889374 279.169830,266.916748 
	C275.537323,264.089203 272.348846,261.008759 273.196594,255.234955 
	C273.665253,254.054092 273.789551,253.463699 273.913818,252.873291 
	C274.742798,252.298264 275.571777,251.723236 276.887085,251.399719 
	C278.234802,251.504578 279.096130,251.357941 279.957489,251.211304 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M298.689880,271.768372 
	C302.370453,267.771698 306.051025,263.775055 310.164703,259.308105 
	C308.151276,257.113281 306.119751,254.898666 303.930420,252.512085 
	C311.214172,251.378098 321.030762,261.036377 321.786469,270.381805 
	C318.839508,267.697784 316.342041,265.423126 313.311035,262.662567 
	C309.393921,266.405945 305.513031,270.114746 301.235626,273.500275 
	C300.122681,272.707489 299.406281,272.237915 298.689880,271.768372 
z"
      />
      <path
        fill="#F1F0D4"
        opacity="1.000000"
        stroke="none"
        d="
M304.692810,288.495270 
	C303.219543,286.203003 301.746246,283.910736 300.341736,281.051819 
	C301.478882,280.350891 302.547302,280.216583 303.615692,280.082306 
	C304.566193,281.058868 305.516724,282.035400 306.759705,283.526306 
	C307.712646,284.000610 308.373138,283.960571 309.033630,283.920532 
	C311.403748,284.341827 313.773834,284.763153 317.186798,285.369812 
	C314.027161,288.902039 311.854828,291.330505 308.963593,293.882263 
	C307.143433,294.026489 306.042206,294.047424 304.940979,294.068329 
	C304.940979,294.068329 304.996338,293.998779 304.931641,293.817322 
	C304.755707,293.352692 304.564423,293.142273 304.293091,293.004547 
	C304.276001,292.239960 304.258942,291.475403 304.486633,290.129150 
	C304.718536,289.196747 304.705688,288.846008 304.692810,288.495270 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M290.275452,284.304352 
	C287.975159,286.846161 285.761200,289.476624 283.309845,291.863190 
	C282.743927,292.414154 281.365112,292.130066 280.360382,292.230225 
	C280.427155,291.249542 280.100708,289.879456 280.624054,289.350891 
	C284.214142,285.725189 287.982208,282.275757 292.377106,279.309998 
	C293.347015,280.156311 293.632782,280.462250 293.918579,280.768158 
	C292.979218,281.704041 292.039856,282.639923 290.596680,283.357605 
	C290.153717,283.527740 290.214569,283.916046 290.275452,284.304352 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M287.056885,267.883179 
	C287.030823,266.530304 287.149170,265.511505 287.497925,264.288727 
	C290.391815,266.639465 293.055298,269.194153 295.845062,272.385651 
	C295.090118,273.336273 294.208923,273.650055 293.327728,273.963837 
	C291.285583,272.048309 289.243439,270.132782 287.056885,267.883179 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M293.447205,274.450867 
	C294.208923,273.650055 295.090118,273.336273 295.961365,272.714142 
	C296.640747,272.270782 297.330139,272.135712 298.354675,271.884521 
	C299.406281,272.237915 300.122681,272.707489 300.898376,273.510315 
	C300.644073,274.350189 300.330536,274.856781 299.776581,275.847198 
	C299.374390,276.896942 299.212585,277.462891 298.771759,278.021729 
	C298.019165,278.221832 297.545593,278.429077 297.072021,278.636322 
	C296.868652,278.679077 296.665283,278.721863 295.826965,278.651459 
	C294.268036,278.589233 293.344055,278.640198 292.420105,278.691132 
	C292.802277,277.440033 293.184479,276.188965 293.447205,274.450867 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M297.215179,278.930298 
	C297.545593,278.429077 298.019165,278.221832 299.219604,277.978210 
	C300.239105,277.874176 300.531738,277.806549 300.824341,277.738892 
	C301.786316,278.317993 302.748322,278.897064 303.662994,279.779236 
	C302.547302,280.216583 301.478882,280.350891 300.208557,280.745544 
	C299.123871,280.412018 298.241089,279.818176 297.215179,278.930298 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M288.198181,261.571716 
	C287.910980,260.343567 287.947876,259.026428 288.015564,257.312897 
	C291.080963,258.138855 290.282257,259.760742 288.198181,261.571716 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M279.773071,250.998245 
	C279.096130,251.357941 278.234802,251.504578 277.203705,251.408966 
	C277.885529,251.039536 278.737061,250.912354 279.773071,250.998245 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M279.209534,267.216003 
	C280.122589,266.889374 281.075317,266.861969 282.386475,266.844360 
	C281.579681,267.074493 280.414459,267.294891 279.209534,267.216003 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M307.730408,302.204285 
	C307.237305,302.834015 306.397888,303.388580 305.204346,303.898438 
	C305.694824,303.278870 306.539459,302.703979 307.730408,302.204285 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M292.447083,278.685089 
	C293.344055,278.640198 294.268036,278.589233 295.520477,278.708527 
	C295.384430,279.453156 294.919922,280.027527 294.187012,280.685028 
	C293.632782,280.462250 293.347015,280.156311 292.750610,279.303101 
	C292.440002,278.755768 292.474060,278.679047 292.447083,278.685089 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M298.827393,304.774475 
	C298.240967,305.347015 297.487457,305.687622 296.404724,306.032043 
	C296.937134,305.538055 297.798706,305.040283 298.827393,304.774475 
z"
      />
      <path
        fill="#22350E"
        opacity="1.000000"
        stroke="none"
        d="
M302.841248,303.731598 
	C302.505615,304.262543 301.990448,304.585083 301.150757,304.865875 
	C301.438019,304.390503 302.049866,303.956848 302.841248,303.731598 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M305.099304,294.389282 
	C306.042206,294.047424 307.143433,294.026489 308.657654,294.020874 
	C307.799652,294.260864 306.528656,294.485565 305.099304,294.389282 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M308.797455,283.772217 
	C308.373138,283.960571 307.712646,284.000610 306.983643,283.785278 
	C307.463837,283.561218 308.012573,283.592560 308.797455,283.772217 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M283.266205,266.729279 
	C283.569580,266.390045 284.273682,266.044342 285.077087,265.946045 
	C284.673248,266.369873 284.170105,266.546326 283.266205,266.729279 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M287.046082,255.637360 
	C286.410156,255.490448 285.725220,255.033325 285.053680,254.228333 
	C285.710419,254.362671 286.353760,254.844910 287.046082,255.637360 
z"
      />
      <path
        fill="#F1F0D4"
        opacity="1.000000"
        stroke="none"
        d="
M300.864075,277.393738 
	C300.531738,277.806549 300.239105,277.874176 299.498596,277.985352 
	C299.212585,277.462891 299.374390,276.896942 299.794617,276.174072 
	C300.336639,276.360962 300.620209,276.704773 300.864075,277.393738 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M273.612122,253.007690 
	C273.789551,253.463699 273.665253,254.054092 273.284882,254.827362 
	C273.122650,254.387512 273.216522,253.764801 273.612122,253.007690 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M304.198425,293.250671 
	C304.564423,293.142273 304.755707,293.352692 304.900848,293.850250 
	C304.657776,293.875366 304.380768,293.686066 304.198425,293.250671 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M304.503937,288.698853 
	C304.705688,288.846008 304.718536,289.196747 304.559570,289.753906 
	C304.363525,289.607697 304.339264,289.255066 304.503937,288.698853 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M290.521332,284.031616 
	C290.214569,283.916046 290.153717,283.527740 290.349304,283.090881 
	C290.659576,283.281189 290.713409,283.520020 290.521332,284.031616 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M790.748291,291.074402 
	C788.885437,288.618622 787.295837,285.848724 785.019348,283.868439 
	C784.160950,283.121857 781.235962,283.619965 780.081482,284.563873 
	C777.012756,287.072906 774.522949,290.278351 771.541199,292.910339 
	C770.161377,294.128296 768.172180,294.655945 766.459229,295.496582 
	C766.068054,294.968323 765.676880,294.440063 765.285645,293.911774 
	C770.051025,288.882935 774.816345,283.854065 779.518616,278.891754 
	C774.575928,270.656311 770.927063,268.540039 765.702576,272.306519 
	C764.848022,271.004120 763.853882,269.488983 763.208496,267.548645 
	C770.869507,267.810333 770.869568,267.810364 772.672363,260.701752 
	C772.835510,260.058258 772.996155,259.414093 773.157959,258.770264 
	C776.462891,261.531219 776.462891,261.531219 773.770691,266.356201 
	C776.701599,269.156067 779.751282,272.069427 783.094116,275.262878 
	C787.239624,270.712036 791.309021,266.244720 795.614563,261.518188 
	C795.522400,261.394745 794.981812,260.788910 794.576782,260.103027 
	C793.759644,258.719208 793.016174,257.291931 792.242249,255.882599 
	C793.834961,256.259796 795.536743,256.395752 797.000854,257.057465 
	C802.285645,259.445953 807.131592,266.915131 806.663086,271.652252 
	C798.841614,265.572662 798.812744,265.543671 791.496399,272.836487 
	C789.761475,274.565887 788.291443,276.561005 786.813232,279.095306 
	C787.493042,280.290192 788.059082,280.823700 788.625122,281.357178 
	C789.608337,282.474762 790.591553,283.592316 791.928528,285.117004 
	C792.598572,285.948151 792.914917,286.372223 792.958008,286.995911 
	C792.039246,288.488495 791.393799,289.781464 790.748291,291.074402 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M773.034180,258.516602 
	C772.996155,259.414093 772.835510,260.058258 772.672363,260.701752 
	C770.869568,267.810364 770.869507,267.810333 763.145325,267.224670 
	C762.733337,267.325897 762.724670,267.301025 762.780273,266.937683 
	C762.139221,266.131409 761.442505,265.688446 760.745789,265.245483 
	C760.745789,265.245483 760.732361,265.056305 760.806519,264.858887 
	C760.461548,264.056824 760.042297,263.452209 759.623047,262.847626 
	C759.454773,262.443146 759.286560,262.038666 759.407227,261.024963 
	C759.647522,259.106476 759.598999,257.797180 759.550415,256.487915 
	C759.550476,256.487915 759.601135,256.148682 760.153198,256.028961 
	C762.994873,255.420074 765.284424,254.930908 767.573975,254.441727 
	C767.920837,254.511551 768.267761,254.581375 768.822144,255.185547 
	C769.742371,256.108734 770.455139,256.497589 771.167847,256.886414 
	C771.748718,257.345245 772.329590,257.804077 773.034180,258.516602 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M790.594971,291.404846 
	C791.393799,289.781464 792.039246,288.488495 793.273682,287.005524 
	C794.493652,286.812653 795.124573,286.809784 796.133179,286.949158 
	C798.077393,288.138458 799.643921,289.185516 801.210449,290.232605 
	C799.783936,291.781189 798.357422,293.329803 796.243042,294.962708 
	C793.860535,294.661835 792.165894,294.276703 790.471252,293.891571 
	C790.461365,293.172791 790.451477,292.454041 790.594971,291.404846 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M790.351196,294.221252 
	C792.165894,294.276703 793.860535,294.661835 795.938660,295.121918 
	C795.166992,296.237213 794.011841,297.277588 792.856689,298.317993 
	C791.981506,297.062317 791.106323,295.806641 790.351196,294.221252 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M801.490356,290.126343 
	C799.643921,289.185516 798.077393,288.138458 796.188477,286.741211 
	C795.866089,286.391052 795.939392,285.966553 795.939392,285.966553 
	C796.729431,286.011841 797.519470,286.057098 798.833069,286.250885 
	C799.356628,286.399414 799.705872,286.367645 799.705872,286.367645 
	C800.394043,287.585114 801.082153,288.802612 801.490356,290.126343 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M767.340088,254.179459 
	C765.284424,254.930908 762.994873,255.420074 760.278564,255.911865 
	C761.521301,252.529648 764.272522,253.073517 767.340088,254.179459 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M759.272644,256.660797 
	C759.598999,257.797180 759.647522,259.106476 759.415344,260.692749 
	C759.088013,259.591095 759.041443,258.212372 759.272644,256.660797 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M795.715942,285.713806 
	C795.939392,285.966553 795.866089,286.391052 795.810791,286.598999 
	C795.124573,286.809784 794.493652,286.812653 793.546997,286.805908 
	C792.914917,286.372223 792.598572,285.948151 792.212036,285.269196 
	C793.258789,285.163239 794.375671,285.312164 795.715942,285.713806 
z"
      />
      <path
        fill="#2C4E1C"
        opacity="1.000000"
        stroke="none"
        d="
M794.965332,312.637360 
	C794.343384,312.560394 793.676697,312.156799 792.938538,311.443420 
	C793.551575,311.526001 794.236023,311.918365 794.965332,312.637360 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M788.678955,281.015350 
	C788.059082,280.823700 787.493042,280.290192 786.896912,279.459900 
	C787.488831,279.666595 788.110840,280.170074 788.678955,281.015350 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M760.764893,265.561218 
	C761.442505,265.688446 762.139221,266.131409 762.769165,266.932007 
	C762.062927,266.818756 761.423462,266.347870 760.764893,265.561218 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M759.511047,263.135010 
	C760.042297,263.452209 760.461548,264.056824 760.794556,264.953003 
	C760.271973,264.637177 759.835510,264.029785 759.511047,263.135010 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M771.114258,256.570557 
	C770.455139,256.497589 769.742371,256.108734 769.006226,255.381622 
	C769.675415,255.447128 770.368042,255.850906 771.114258,256.570557 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M799.737793,286.174042 
	C799.705872,286.367645 799.356628,286.399414 799.227600,286.281952 
	C799.322266,286.103149 799.545959,286.041779 799.737793,286.174042 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M329.003967,583.993469 
	C327.719788,582.552185 326.435608,581.110840 325.080811,579.012634 
	C324.203186,577.560791 323.396179,576.765808 322.589203,575.970886 
	C316.695007,567.353699 310.800842,558.736511 304.919739,549.356934 
	C305.079681,546.093201 304.819336,543.909180 301.460876,544.139587 
	C301.460876,544.139587 301.102478,543.805908 301.430664,543.441650 
	C302.611359,539.066284 299.951233,537.429138 296.978149,536.003540 
	C296.457642,535.162048 295.937134,534.320618 295.585938,532.762390 
	C294.795898,530.698669 293.836548,529.351685 292.877167,528.004700 
	C292.246765,526.887756 291.616394,525.770813 291.249329,524.122437 
	C290.323425,521.400574 289.134247,519.210205 287.945068,517.019775 
	C287.193451,515.448853 286.441833,513.877930 285.799530,511.551636 
	C285.004883,508.859711 284.100861,506.923096 283.196838,504.986511 
	C282.402924,502.935028 281.609039,500.883575 281.096039,498.255219 
	C282.593079,495.158112 281.960815,493.534424 279.102997,492.990204 
	C278.357300,490.590118 277.611603,488.190063 277.175629,485.188843 
	C276.811890,483.070404 276.138428,481.553131 275.464966,480.035858 
	C275.464966,480.035858 275.227356,479.640808 275.637299,479.237549 
	C277.468811,475.360168 277.753967,472.296814 273.208374,470.979340 
	C272.856506,469.875885 272.504639,468.772461 272.429596,467.006042 
	C272.269318,462.147308 275.286713,457.263458 270.244843,453.984924 
	C270.128235,453.547577 270.011627,453.110229 270.338470,452.268555 
	C270.698486,445.289032 270.581604,438.713928 270.562531,432.138580 
	C270.559113,430.955017 270.958740,429.770294 271.172302,428.586090 
	C272.276978,429.050049 273.359344,429.580078 274.491425,429.963074 
	C276.350983,430.592224 278.242737,431.126038 280.120941,431.700012 
	C280.659698,431.935730 281.198486,432.171478 281.897095,433.020630 
	C281.374329,436.088898 280.691681,438.543793 279.752991,441.161621 
	C279.382690,442.107880 279.268402,442.891144 279.091309,444.039917 
	C277.729523,449.627899 281.170380,451.943542 284.963379,454.434540 
	C283.953674,456.683105 282.926270,458.551178 281.590698,460.365356 
	C280.876068,460.919830 280.469635,461.528168 280.046295,462.502686 
	C282.786041,467.297028 285.542694,471.725220 288.298828,476.152557 
	C287.708679,476.934662 286.899628,478.006897 285.747803,479.217316 
	C285.272400,479.999237 285.139740,480.643005 284.990387,481.649902 
	C286.976318,484.657745 288.767273,487.504608 291.044128,489.887177 
	C293.104340,492.043091 295.694916,493.692169 298.257080,495.727966 
	C296.372742,496.870239 295.183167,497.591339 293.599854,498.369324 
	C291.660950,498.426239 290.115814,498.426239 287.148804,498.426239 
	C290.529480,501.044434 292.854187,502.844818 295.146545,505.013855 
	C298.403229,507.927490 301.692261,510.472443 304.981934,513.377319 
	C303.985413,515.122498 302.988190,516.507751 301.641968,517.956909 
	C300.162811,518.169983 299.032654,518.319214 297.073212,518.578003 
	C299.896606,520.476013 301.889435,521.815735 304.027161,523.334595 
	C304.397614,523.722229 304.613342,523.940369 304.928101,524.494751 
	C308.346527,526.580505 311.656128,528.339905 315.028961,530.477539 
	C316.243713,531.574829 317.480377,532.189941 318.522064,533.043091 
	C319.505096,533.848267 320.282959,534.903931 320.717499,535.893555 
	C316.693024,536.054871 313.094910,536.086304 309.519653,536.388184 
	C309.025391,536.429932 308.644165,537.810486 308.175781,538.967590 
	C309.792389,540.210266 311.443909,541.056641 313.046631,541.917297 
	C312.997833,541.931580 313.094238,541.885986 313.098389,542.270447 
	C314.826111,543.388855 316.549683,544.122864 318.563232,544.867004 
	C319.223480,544.986023 319.593719,545.094849 320.029602,545.525208 
	C321.940979,547.793884 325.045990,549.210876 322.731506,552.916626 
	C320.522186,553.340210 318.913544,553.771973 321.313293,556.152832 
	C321.762726,556.464905 322.110931,556.518250 322.639191,556.605591 
	C322.819244,556.639465 323.131378,556.831421 323.162354,557.180847 
	C332.473907,564.350525 342.479187,567.535522 354.033630,564.233643 
	C356.070221,563.651672 358.487610,564.402344 360.729126,564.537598 
	C359.802399,566.166321 358.875671,567.795105 357.638367,569.299561 
	C356.890198,569.088440 356.452637,569.001709 355.810974,568.601196 
	C352.731842,568.427917 349.856781,568.568481 346.544159,568.771606 
	C342.657990,569.278076 339.166290,569.529358 335.787811,570.286255 
	C334.804382,570.506592 334.144470,572.170959 333.308655,573.564331 
	C335.538635,574.942322 337.796234,575.929260 340.341461,576.946167 
	C341.104370,577.267883 341.579681,577.559570 342.076416,578.233032 
	C343.026764,579.398499 343.953033,580.847778 344.885101,580.851501 
	C349.101898,580.868225 348.989471,583.139282 347.902557,586.192383 
	C347.776581,586.305908 347.439514,586.268433 346.970093,586.192139 
	C344.289764,586.090271 342.078888,586.064758 339.666504,585.930664 
	C339.210175,585.626709 339.051056,585.371643 338.953552,584.723999 
	C338.258026,583.936584 337.596588,583.482056 336.621307,582.863647 
	C335.405792,582.456909 334.504120,582.213989 333.242004,581.982056 
	C331.645508,582.594727 330.409424,583.196350 329.117981,583.835571 
	C329.062592,583.873108 329.003967,583.993469 329.003967,583.993469 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M312.054016,429.776917 
	C320.091003,429.757996 328.127991,429.739075 336.586975,430.161346 
	C337.340515,431.069824 337.672058,431.537140 338.003601,432.004456 
	C338.064056,433.726959 338.124512,435.449493 338.151001,437.913452 
	C338.052948,439.121887 337.988861,439.588867 337.642578,440.347839 
	C337.776825,445.147400 338.193298,449.654938 338.687927,454.511902 
	C338.815063,455.575134 338.864105,456.288910 338.677673,457.238953 
	C338.701385,458.655304 338.960571,459.835388 339.267090,461.346039 
	C339.506287,462.772491 339.698151,463.868408 339.672974,465.223206 
	C339.990570,467.321533 340.525146,469.160950 341.113708,471.289551 
	C341.208557,471.968842 341.249420,472.358887 341.208893,473.131653 
	C341.511108,474.621429 341.894714,475.728485 342.412048,477.086273 
	C342.661469,477.890747 342.777069,478.444489 342.701904,479.159363 
	C342.832367,479.946075 343.153564,480.571655 343.591736,481.530884 
	C343.812744,482.562408 343.916809,483.260315 343.738983,484.210632 
	C343.266113,489.298431 343.776520,493.871399 348.277649,497.210083 
	C348.538116,497.749878 348.517792,498.070618 348.249512,498.812164 
	C349.499084,503.550781 350.727570,507.901459 352.240875,512.150696 
	C353.085876,514.523254 352.234344,515.131775 349.994080,514.734131 
	C349.331024,514.047974 348.766876,513.652039 347.839966,513.158569 
	C346.490936,511.358887 345.504578,509.656830 344.349243,507.634857 
	C344.011108,507.143066 343.841980,506.971130 343.746216,506.616028 
	C343.819580,506.432861 343.969940,506.066162 344.210449,505.900116 
	C344.175690,505.182312 343.900452,504.630554 343.491028,503.758423 
	C342.580078,501.998138 341.803345,500.558228 340.986511,498.721649 
	C339.885986,496.164001 338.825562,494.003021 337.638855,491.523743 
	C337.466431,490.521698 337.420288,489.837921 337.680054,489.053833 
	C337.697754,488.309082 337.409515,487.664612 337.035889,486.722778 
	C336.380371,486.017609 335.810242,485.609863 334.899933,485.014221 
	C334.305389,483.247925 334.028229,481.672821 333.802063,480.090393 
	C333.454285,477.656525 335.677338,474.535736 331.736664,472.711639 
	C331.384766,471.139374 331.307343,469.846344 330.924103,468.651367 
	C330.825073,468.342651 329.766266,468.341736 328.798462,467.934204 
	C328.271942,464.539215 328.388580,461.355774 327.829620,458.295807 
	C327.347321,455.655579 326.096069,453.155853 325.025787,450.147003 
	C324.603027,446.855957 324.099915,442.939575 323.597870,438.695099 
	C323.791321,435.572296 322.828125,434.809753 320.720978,436.933136 
	C318.437714,439.234009 316.344696,441.723663 313.794678,444.072815 
	C312.924591,442.996368 312.428497,441.978149 312.192749,440.957520 
	C312.695587,440.841888 312.938080,440.728638 313.180573,440.615356 
	C312.761902,440.425629 312.343201,440.235901 311.915344,439.699860 
	C311.919678,438.891876 311.933105,438.430176 312.251953,437.943573 
	C312.889435,437.514679 313.221527,437.110687 313.553589,436.706726 
	C313.027466,436.478058 312.501312,436.249390 311.964264,435.673279 
	C311.687378,434.215698 311.421387,433.105530 311.357605,431.844910 
	C311.724548,431.055267 311.889282,430.416107 312.054016,429.776917 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M299.958923,414.046082 
	C300.411865,414.023438 300.864807,414.000793 302.014832,413.982178 
	C304.132935,413.660919 305.553925,413.335632 306.974945,413.010345 
	C311.452423,414.081757 315.888245,415.497528 320.428864,416.046875 
	C322.130035,416.252716 324.075073,414.442566 326.116516,412.973694 
	C327.164185,411.909607 328.004272,411.423401 329.227905,410.929688 
	C330.757507,409.286713 331.903564,407.651276 333.366089,405.961487 
	C335.162018,405.294739 336.641541,404.682404 338.121033,404.070068 
	C338.199249,405.180786 338.277466,406.291504 337.920471,407.918823 
	C337.650360,409.961395 337.815491,411.487396 337.980591,413.013367 
	C338.034576,414.405121 338.088562,415.796844 337.754608,417.850708 
	C337.237305,419.994202 337.107941,421.475555 336.978577,422.956909 
	C325.626587,422.957397 314.274628,422.957855 302.379456,422.491486 
	C301.210480,419.365112 300.584686,416.705566 299.958923,414.046082 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M338.293610,403.628540 
	C336.641541,404.682404 335.162018,405.294739 333.084625,405.962463 
	C332.299622,406.024536 332.112488,406.031189 331.947876,406.033386 
	C331.970428,406.028931 331.952637,406.061981 331.976685,405.941925 
	C332.000732,405.821869 332.085663,405.592224 332.104553,405.227264 
	C332.105652,404.619324 332.087891,404.376343 332.169647,403.964874 
	C332.269196,403.796417 332.164429,403.419342 332.461121,403.180756 
	C333.171936,401.498077 333.586090,400.054016 334.123779,398.179260 
	C326.743256,398.216064 320.984100,400.063690 316.147614,404.724609 
	C315.610870,404.564087 315.308594,404.655334 315.026245,404.903442 
	C315.011414,404.945343 315.098328,404.963959 315.140137,404.597900 
	C312.723541,401.527283 310.265198,398.822693 307.863708,395.734955 
	C309.846130,391.748566 311.317719,387.763458 313.890686,384.704742 
	C315.158325,383.197845 318.462341,383.403931 320.539307,383.011536 
	C317.815277,384.840546 314.923798,386.198547 315.972778,390.381592 
	C319.951202,395.840942 325.606140,396.018311 330.812561,391.782776 
	C332.892578,390.090637 335.834503,389.457916 338.384064,388.342926 
	C338.411438,393.290955 338.438812,398.238983 338.293610,403.628540 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M338.121887,382.037506 
	C338.192535,382.478363 338.263184,382.919250 337.917633,383.694733 
	C337.001099,384.344147 336.500702,384.658905 335.914703,385.132721 
	C335.829071,385.291748 335.885773,385.648499 335.556183,385.463623 
	C332.481628,384.196259 329.736694,383.113739 326.881165,381.710571 
	C325.186981,379.874908 323.603302,378.359924 322.009705,376.462769 
	C323.041687,375.051361 324.001862,373.919464 325.141571,373.013336 
	C327.978821,370.757477 330.954468,368.673889 333.761932,366.383118 
	C335.346008,365.090546 336.707184,363.524811 338.168762,362.082153 
	C338.251678,363.124298 338.334595,364.166473 338.012024,365.768616 
	C337.787170,368.904510 337.967804,371.480438 338.148407,374.056366 
	C338.225433,375.101135 338.302460,376.145935 337.995209,377.725739 
	C337.781250,379.519684 337.951569,380.778595 338.121887,382.037506 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M311.615112,429.592834 
	C311.889282,430.416107 311.724548,431.055267 310.991028,431.821716 
	C309.268921,432.130341 308.115631,432.311707 306.683960,432.612854 
	C305.986511,433.156219 305.567352,433.579803 304.723419,434.046875 
	C301.605652,434.391937 298.880798,434.532745 296.232086,435.057617 
	C294.733215,435.354614 293.359314,436.282257 291.567902,437.024048 
	C289.062042,438.699585 290.881073,443.412292 286.079407,443.198181 
	C283.823639,442.488190 281.916351,441.743408 280.009033,440.998657 
	C280.691681,438.543793 281.374329,436.088898 282.041199,433.282166 
	C283.306183,433.576324 284.545441,434.567383 285.884583,434.728455 
	C286.594482,434.813812 287.477783,433.457672 288.524231,432.117432 
	C288.678436,431.133606 288.591187,430.784637 288.503967,430.435669 
	C296.061401,430.093353 303.618805,429.751038 311.615112,429.592834 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M338.329468,361.690369 
	C336.707184,363.524811 335.346008,365.090546 333.761932,366.383118 
	C330.954468,368.673889 327.978821,370.757477 325.141571,373.013336 
	C324.001862,373.919464 323.041687,375.051361 321.588898,376.522491 
	C318.121796,376.630615 315.065552,376.296783 312.001770,375.741577 
	C311.994202,375.520203 312.044403,375.077576 312.269592,374.862244 
	C312.263947,373.606476 312.033112,372.566040 311.760315,371.260773 
	C311.568207,370.678589 311.418030,370.361237 311.247345,369.676880 
	C309.891968,367.655365 308.557129,366.000885 307.553406,364.064087 
	C310.651489,362.465027 313.418396,361.148285 316.248474,360.249817 
	C316.041748,362.133514 315.233704,363.771027 315.633911,365.022003 
	C316.172913,366.706787 317.376404,369.056671 318.760223,369.439850 
	C324.426575,371.008789 329.934296,368.093323 332.514648,362.656281 
	C333.501160,360.577515 334.187164,358.356140 335.245209,356.499634 
	C336.373901,357.193024 337.267517,357.586517 338.161102,357.980011 
	C338.270782,359.086182 338.380463,360.192383 338.329468,361.690369 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M338.526306,317.026276 
	C338.556885,322.040405 338.587463,327.054535 338.133850,332.523895 
	C336.712616,333.010590 335.775604,333.042084 334.456635,332.982971 
	C328.397797,331.349335 323.203156,332.774933 318.138428,335.107910 
	C317.655426,334.174225 317.248535,333.601532 316.573181,332.826294 
	C314.168213,331.911072 312.031647,331.198334 309.942749,330.083954 
	C311.569824,324.855408 314.849396,327.462830 317.296661,328.297729 
	C324.503418,330.756378 330.343536,328.320831 333.417358,321.255310 
	C334.388306,319.023407 335.104034,316.353912 338.526306,317.026276 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M338.650391,316.694641 
	C335.104034,316.353912 334.388306,319.023407 333.417358,321.255310 
	C330.343536,328.320831 324.503418,330.756378 317.296661,328.297729 
	C314.849396,327.462830 311.569824,324.855408 309.541595,330.135834 
	C303.719666,329.748352 299.408691,332.139984 295.292389,335.123962 
	C294.752136,334.409790 294.211914,333.695648 293.526154,332.246490 
	C293.306885,330.891144 293.233154,330.270782 293.345032,329.300659 
	C293.494751,327.897156 293.458893,326.843414 293.796661,325.858643 
	C295.087921,326.323029 296.005524,326.718414 297.040466,327.325226 
	C297.157806,327.536621 297.573486,327.781830 297.573486,327.781830 
	C297.573486,327.781830 298.053925,327.735596 298.379761,327.793182 
	C299.144684,327.884949 299.583801,327.919128 300.272888,328.000366 
	C300.686584,328.003113 300.850281,327.958862 301.361755,327.876953 
	C303.740479,326.799011 305.771423,325.758667 308.165283,324.820007 
	C310.604279,324.892059 313.013489,324.159546 314.697357,324.957550 
	C321.127808,328.004974 331.123291,325.200836 333.125305,316.856049 
	C333.322937,316.097260 333.443573,315.590332 333.771606,314.865021 
	C334.304718,314.421631 334.630432,314.196594 335.249115,314.090546 
	C336.538727,314.469666 337.535370,314.729797 338.532043,314.989899 
	C338.612854,315.447601 338.693695,315.905334 338.650391,316.694641 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M338.280792,357.556824 
	C337.267517,357.586517 336.373901,357.193024 335.143005,356.250977 
	C331.152588,355.483673 327.499481,355.264893 323.883484,354.534027 
	C323.944885,353.337860 323.969208,352.653778 324.310425,351.949677 
	C325.399536,351.599213 326.171722,351.268738 327.271606,350.919037 
	C328.064575,350.264954 328.529846,349.630127 329.198547,348.717987 
	C330.460724,346.440826 331.519501,344.440948 332.624695,342.119263 
	C332.932495,341.206604 333.193909,340.615784 333.598877,340.234497 
	C335.249023,340.310394 336.755554,340.176788 338.262115,340.043152 
	C338.332520,342.400299 338.402924,344.757446 338.110199,347.639008 
	C337.898773,349.119415 338.050507,350.075378 338.202271,351.031372 
	C338.268341,353.065460 338.334412,355.099548 338.280792,357.556824 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M279.975555,431.407471 
	C278.242737,431.126038 276.350983,430.592224 274.491425,429.963074 
	C273.359344,429.580078 272.276978,429.050049 271.172302,428.586090 
	C270.958740,429.770294 270.559113,430.955017 270.562531,432.138580 
	C270.581604,438.713928 270.698486,445.289032 270.418274,451.934143 
	C269.075623,442.059143 268.096649,432.114197 267.117706,422.169220 
	C267.708893,421.961426 268.300110,421.753632 268.891327,421.545837 
	C272.537598,424.735535 276.183899,427.925232 279.975555,431.407471 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M338.518860,388.016418 
	C335.834503,389.457916 332.892578,390.090637 330.812561,391.782776 
	C325.606140,396.018311 319.951202,395.840942 316.399231,390.345276 
	C323.187195,388.511810 329.536469,387.080170 335.885773,385.648499 
	C335.885773,385.648499 335.829071,385.291748 336.316711,385.196777 
	C337.345917,385.061920 337.887482,385.022034 338.429047,384.982147 
	C338.503906,385.884735 338.578766,386.787323 338.518860,388.016418 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M337.924744,440.055817 
	C337.988861,439.588867 338.052948,439.121887 338.256470,438.331116 
	C339.540070,437.468994 340.684326,436.930664 342.052399,436.287018 
	C342.605438,437.052368 343.213623,437.894012 344.097534,438.839844 
	C344.425446,441.911957 344.477570,444.879852 344.178955,448.212402 
	C342.048950,447.019379 340.269623,445.461731 338.457703,443.511597 
	C338.258331,442.097992 338.091553,441.076904 337.924744,440.055817 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M299.678131,414.154694 
	C300.584686,416.705566 301.210480,419.365112 301.925171,422.373322 
	C298.967621,422.834412 295.921143,422.946838 292.433899,422.932434 
	C292.983246,421.130310 293.973328,419.455017 295.024902,417.346222 
	C295.086365,416.912720 295.239105,416.758759 295.529541,416.825043 
	C296.213959,416.926758 296.607910,416.962189 297.061523,417.152893 
	C297.226715,417.350128 297.332245,417.392090 297.437775,417.434082 
	C297.290802,417.290283 297.143829,417.146515 297.077698,416.674042 
	C297.148651,415.894409 297.138702,415.443451 297.128784,414.992493 
	C297.884979,414.749451 298.641144,414.506378 299.678131,414.154694 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M338.639893,314.602783 
	C337.535370,314.729797 336.538727,314.469666 335.250916,313.758606 
	C334.993011,312.866882 335.026215,312.426025 335.059448,311.985199 
	C335.706329,309.410187 336.456665,306.855530 336.969147,304.254028 
	C337.422821,301.951050 337.611969,299.595917 338.279602,297.134491 
	C338.676758,302.742004 338.712250,308.478851 338.639893,314.602783 
z"
      />
      <path
        fill="#221B13"
        opacity="1.000000"
        stroke="none"
        d="
M338.412781,339.620300 
	C336.755554,340.176788 335.249023,340.310394 333.537903,339.946228 
	C333.303436,339.060455 333.273560,338.672455 333.446899,338.004211 
	C334.046234,336.173798 334.442383,334.623688 334.838562,333.073547 
	C335.775604,333.042084 336.712616,333.010590 338.000946,332.969788 
	C338.422638,335.039459 338.493042,337.118469 338.412781,339.620300 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M270.156860,454.398682 
	C275.286713,457.263458 272.269318,462.147308 272.455536,466.657410 
	C271.492706,462.918640 270.780792,458.865570 270.156860,454.398682 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M273.167725,471.346100 
	C277.753967,472.296814 277.468811,475.360168 275.671692,479.009583 
	C274.573090,476.694244 273.850098,474.203552 273.167725,471.346100 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M296.982391,536.348938 
	C299.951233,537.429138 302.611359,539.066284 301.407043,543.197937 
	C299.699036,541.110474 298.342834,538.902405 296.982391,536.348938 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M338.315063,373.630920 
	C337.967804,371.480438 337.787170,368.904510 337.887634,366.144836 
	C338.273071,368.375885 338.377380,370.790680 338.315063,373.630920 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M287.939514,517.382812 
	C289.134247,519.210205 290.323425,521.400574 291.247650,523.798157 
	C289.966461,521.918823 288.950226,519.832275 287.939514,517.382812 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M301.532471,544.488770 
	C304.819336,543.909180 305.079681,546.093201 304.885071,549.024231 
	C303.759613,547.915222 302.681824,546.376587 301.532471,544.488770 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M279.070129,493.334900 
	C281.960815,493.534424 282.593079,495.158112 281.081604,497.886108 
	C280.203247,496.622437 279.620270,495.151001 279.070129,493.334900 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M283.190826,505.346252 
	C284.100861,506.923096 285.004883,508.859711 285.840149,511.222900 
	C284.909210,509.668335 284.047028,507.687164 283.190826,505.346252 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M292.895081,528.360962 
	C293.836548,529.351685 294.795898,530.698669 295.594879,532.462280 
	C294.594025,531.491638 293.753510,530.104431 292.895081,528.360962 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M275.439484,480.418640 
	C276.138428,481.553131 276.811890,483.070404 277.200806,484.810944 
	C276.415497,483.623291 275.914734,482.212372 275.439484,480.418640 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M338.287598,381.725983 
	C337.951569,380.778595 337.781250,379.519684 337.869629,378.102478 
	C338.236664,379.100952 338.344971,380.257690 338.287598,381.725983 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M338.363098,350.665466 
	C338.050507,350.075378 337.898773,349.119415 337.985565,348.065430 
	C338.324036,348.744812 338.424011,349.522156 338.363098,350.665466 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M322.578583,576.258179 
	C323.396179,576.765808 324.203186,577.560791 324.999756,578.696167 
	C324.989380,579.036560 324.515747,579.044067 324.280884,579.013550 
	C323.553345,578.170532 323.060638,577.358032 322.578583,576.258179 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M283.167542,422.381042 
	C283.929932,422.150482 284.911865,422.180420 285.952667,422.528076 
	C285.136719,422.777679 284.261932,422.709595 283.167542,422.381042 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M338.122101,412.612244 
	C337.815491,411.487396 337.650360,409.961395 337.769653,408.221069 
	C338.123932,409.408173 338.193756,410.809662 338.122101,412.612244 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M337.363770,422.840576 
	C337.107941,421.475555 337.237305,419.994202 337.628723,418.252686 
	C337.843506,419.569763 337.796234,421.147003 337.363770,422.840576 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M338.417969,384.717407 
	C337.887482,385.022034 337.345917,385.061920 336.402344,385.037750 
	C336.500702,384.658905 337.001099,384.344147 337.812439,384.017120 
	C338.217896,384.154114 338.312378,384.303375 338.417969,384.717407 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M338.136749,431.677002 
	C337.672058,431.537140 337.340515,431.069824 337.016327,430.301270 
	C337.439056,430.449890 337.854492,430.899719 338.136749,431.677002 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M288.356140,430.667725 
	C288.591187,430.784637 288.678436,431.133606 288.606201,431.710938 
	C288.367310,431.592773 288.287842,431.246277 288.356140,430.667725 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M296.923157,327.113831 
	C296.005524,326.718414 295.087921,326.323029 293.594849,325.648926 
	C292.508545,324.545929 291.997742,323.721680 291.512604,322.705261 
	C291.538300,322.513092 291.698181,322.159851 291.698181,322.159851 
	C292.534729,321.268219 293.371277,320.376617 294.880127,319.233093 
	C297.894440,318.443024 300.481903,318.358276 302.518341,317.255737 
	C305.267700,315.767181 307.713837,313.909607 311.071472,314.892151 
	C311.071472,314.892151 311.500366,314.936615 311.727325,315.283356 
	C312.259888,316.050293 312.565491,316.470459 312.923828,317.243835 
	C313.052307,318.299164 313.128021,319.001251 312.859070,319.793457 
	C310.943756,321.495148 309.373047,323.106750 307.802368,324.718353 
	C305.771423,325.758667 303.740479,326.799011 301.271790,327.716248 
	C300.563690,327.713226 300.293304,327.833252 300.022919,327.953308 
	C299.583801,327.919128 299.144684,327.884949 298.241211,327.613861 
	C297.531403,327.162598 297.246826,327.074860 296.923157,327.113831 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M293.159393,329.650421 
	C293.233154,330.270782 293.306885,330.891144 293.344788,331.824280 
	C290.485992,337.247437 285.772095,337.363556 280.413696,336.930786 
	C280.002380,336.997803 279.996094,337.057068 280.065979,336.664154 
	C279.797638,334.191376 279.459351,332.111542 279.121063,330.031677 
	C279.271423,329.501343 279.421783,328.971039 279.868164,328.563171 
	C280.430450,329.400787 280.696747,330.115875 281.148193,331.126678 
	C285.275330,330.831726 289.217377,330.241058 293.159393,329.650421 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M311.035065,314.510437 
	C307.713837,313.909607 305.267700,315.767181 302.518341,317.255737 
	C300.481903,318.358276 297.894440,318.443024 295.127136,318.963257 
	C294.377228,313.590668 298.621155,312.020081 302.315613,310.695435 
	C304.401306,309.947601 307.174225,310.795380 309.538055,311.349121 
	C310.205383,311.505463 310.521484,313.160858 311.035065,314.510437 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M334.688568,311.878815 
	C335.026215,312.426025 334.993011,312.866882 334.958008,313.639648 
	C334.630432,314.196594 334.304718,314.421631 333.345032,314.604492 
	C329.901825,314.495270 327.092499,314.428223 323.867798,314.257874 
	C320.134155,314.724823 316.815918,315.295044 313.435486,315.577515 
	C313.270233,315.122772 313.167145,314.955780 313.064087,314.788788 
	C317.370270,309.305695 325.525818,308.148224 334.688568,311.878815 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M282.105469,343.101593 
	C283.627991,347.884247 282.003052,350.992004 277.208801,352.538300 
	C275.364380,353.133209 273.598755,353.972229 271.187500,354.717590 
	C269.700012,354.079254 268.822327,353.423309 267.944611,352.767395 
	C267.983337,351.733124 268.022064,350.698822 268.436188,349.292603 
	C269.181091,349.017365 269.550598,349.114105 269.977844,349.489380 
	C274.991608,349.734650 280.395203,350.460236 281.354797,343.173706 
	C281.768402,343.108154 281.936920,343.104889 282.105469,343.101593 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M280.963043,330.830994 
	C280.696747,330.115875 280.430450,329.400787 280.087280,328.395996 
	C279.422241,323.869781 282.618683,321.868073 285.458679,320.399231 
	C286.871826,319.668365 289.411530,321.115692 291.569885,321.868774 
	C291.698181,322.159851 291.538300,322.513092 291.232666,322.728638 
	C286.290192,323.911133 282.709717,326.212677 280.963043,330.830994 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M282.070740,342.732758 
	C281.936920,343.104889 281.768402,343.108154 281.047668,342.971252 
	C279.187592,342.459442 277.881195,341.777710 276.571503,341.771362 
	C271.668823,341.747559 271.780334,346.395782 269.920105,349.210876 
	C269.550598,349.114105 269.181091,349.017365 268.525818,348.913513 
	C268.274902,346.843781 268.309692,344.781128 268.946106,342.353455 
	C272.670166,340.385193 275.792572,338.781952 279.182465,337.123810 
	C279.632050,337.064972 279.814087,337.061005 279.996094,337.057068 
	C279.996094,337.057068 280.002380,336.997803 279.973022,336.994598 
	C280.641083,338.782227 281.338562,340.573090 282.070740,342.732758 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M267.697571,352.760193 
	C268.822327,353.423309 269.700012,354.079254 270.874786,354.894745 
	C271.464844,356.128143 271.757874,357.201965 272.074646,358.614136 
	C269.643036,359.682892 267.220001,360.586151 264.715576,361.053802 
	C263.786743,361.227264 262.667084,360.378540 261.304413,359.895935 
	C261.780945,358.786957 262.509918,357.701050 263.413971,356.788727 
	C264.511139,355.681580 265.756073,354.720917 266.973022,353.336060 
	C267.009003,352.975250 267.450531,352.753021 267.697571,352.760193 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M278.914948,337.178711 
	C275.792572,338.781952 272.670166,340.385193 269.167725,342.039795 
	C269.002197,337.944977 270.905090,335.363617 275.944641,335.104065 
	C277.373596,335.812164 278.144287,336.495422 278.914948,337.178711 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M279.182465,337.123810 
	C278.144287,336.495422 277.373596,335.812164 276.314270,335.013458 
	C276.848114,333.359344 277.670654,331.820648 278.807129,330.156799 
	C279.459351,332.111542 279.797638,334.191376 280.065979,336.664154 
	C279.814087,337.061005 279.632050,337.064972 279.182465,337.123810 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M312.772003,314.851318 
	C313.167145,314.955780 313.270233,315.122772 313.238342,315.809631 
	C313.025970,316.516541 312.948517,316.703613 312.871094,316.890656 
	C312.565491,316.470459 312.259888,316.050293 311.930389,315.355774 
	C312.097626,315.025543 312.288788,314.969696 312.772003,314.851318 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M379.927887,632.194519 
	C367.121246,621.131897 354.152649,610.248718 341.592224,598.913269 
	C336.935974,594.711121 333.237976,589.447144 329.053467,584.330444 
	C329.003967,583.993469 329.062592,583.873108 329.414917,583.931152 
	C331.077759,583.653809 332.388245,583.318359 333.894440,583.252319 
	C334.957001,584.141968 335.823822,584.762329 336.786407,585.708435 
	C337.918335,587.520142 338.748657,589.217957 340.024323,590.457520 
	C347.854706,598.066101 355.622162,605.753906 363.755127,613.030212 
	C367.596558,616.466980 372.202698,619.048950 376.643066,622.288208 
	C377.236450,622.376465 377.649139,622.194763 378.240540,622.049072 
	C378.419281,622.085144 378.758484,621.951355 378.962280,621.961304 
	C379.166046,621.971313 379.583374,621.981140 379.583374,621.981140 
	C379.583374,621.981140 380.000793,621.981079 380.016083,622.227478 
	C380.056183,622.803711 380.043945,623.132141 379.852539,623.818542 
	C380.833832,625.366760 381.957275,626.555603 382.876343,628.052490 
	C381.757263,629.638428 380.842590,630.916504 379.927887,632.194519 
z"
      />
      <path
        fill="#0F181C"
        opacity="1.000000"
        stroke="none"
        d="
M380.100037,632.478027 
	C380.842590,630.916504 381.757263,629.638428 383.154907,628.144897 
	C384.090088,628.281311 384.542328,628.633301 385.030945,629.337036 
	C387.089233,631.745300 388.755005,634.616272 391.207336,635.688843 
	C396.305145,637.918640 401.734039,639.623169 407.192474,640.717712 
	C411.011230,641.483398 415.104492,640.880249 419.397064,640.845947 
	C420.137329,640.901367 420.555664,640.999146 420.974030,641.096924 
	C420.818420,642.727539 420.694550,644.361877 420.501221,645.987976 
	C419.934753,650.752625 417.903809,653.624512 412.110352,652.100708 
	C411.175873,652.021484 410.645386,651.908386 410.006348,651.170593 
	C408.022675,646.808716 405.623199,644.144043 400.933777,646.164246 
	C394.046570,641.696655 387.159363,637.229065 380.100037,632.478027 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M401.076508,646.482666 
	C405.623199,644.144043 408.022675,646.808716 409.891602,650.917480 
	C406.996674,649.793030 404.107971,648.297058 401.076508,646.482666 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M788.077942,327.080933 
	C782.739624,332.744110 778.219421,332.532410 770.469238,326.256226 
	C763.138733,333.423889 751.960632,330.246796 749.524658,319.781799 
	C749.698303,319.345551 749.983643,319.357330 750.182617,319.682373 
	C753.921021,324.135925 758.406860,326.581573 763.824707,325.907043 
	C765.697083,325.673920 767.313354,323.384003 769.097107,321.654877 
	C769.114380,320.517853 769.081177,319.759583 769.062500,318.658936 
	C769.065369,317.859772 769.053772,317.402954 769.042114,316.946167 
	C769.487732,316.943787 769.933350,316.941406 770.783997,317.235870 
	C771.226379,317.976227 771.263733,318.419739 771.260315,319.205750 
	C772.132263,320.708313 773.045044,321.868347 774.097046,323.349243 
	C778.147339,327.203552 782.406921,329.178497 787.770996,326.775757 
	C787.873596,326.877197 788.077942,327.080933 788.077942,327.080933 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M799.954407,351.001678 
	C800.011353,350.819458 800.068237,350.637207 800.558716,350.244293 
	C801.802002,348.968353 802.611633,347.903137 804.013855,346.058258 
	C806.964539,345.167236 810.255066,345.334991 811.140320,350.692108 
	C811.287537,351.583038 812.912109,352.229797 813.853943,352.989410 
	C814.097046,353.785950 814.340149,354.582489 814.491211,355.831848 
	C813.407776,356.927612 812.416504,357.570496 811.173828,357.870789 
	C807.431335,356.136810 803.940247,354.745422 800.449158,353.354065 
	C800.557373,353.039886 800.547546,352.729431 800.316406,351.946533 
	C800.126953,351.314148 800.040649,351.157898 799.954407,351.001678 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M769.034119,316.962067 
	C769.053772,317.402954 769.065369,317.859772 768.652710,318.685730 
	C765.258301,318.262421 762.317322,316.988007 759.310486,316.806915 
	C756.010437,316.608215 752.649719,317.417328 749.315430,317.787231 
	C748.743042,317.032288 748.170593,316.277344 747.439209,315.280487 
	C752.624512,310.213776 758.612000,312.218353 764.477112,313.524841 
	C765.707214,313.798828 766.783691,314.762329 768.082153,315.952332 
	C768.400391,316.839081 768.673889,316.994354 769.053894,316.962402 
	C769.053894,316.962402 769.026123,316.977966 769.034119,316.962067 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M771.301025,318.863220 
	C771.263733,318.419739 771.226379,317.976227 771.117554,317.203430 
	C773.568665,311.685608 776.708862,310.793457 782.612610,314.360046 
	C784.834778,315.702454 786.307312,318.285706 788.113770,320.557770 
	C788.105957,320.812286 787.782593,320.902588 787.428162,320.874237 
	C781.967285,318.982880 777.028381,315.786835 771.301025,318.863220 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M813.913208,352.964111 
	C812.912109,352.229797 811.287537,351.583038 811.140320,350.692108 
	C810.255066,345.334991 806.964539,345.167236 804.013855,346.058258 
	C802.611633,347.903137 801.802002,348.968353 800.695801,349.992920 
	C800.403625,347.942749 800.407959,345.933258 800.701904,343.503540 
	C801.321777,343.048859 801.652771,343.023956 802.415405,343.029419 
	C806.023621,342.916199 809.200745,342.782135 812.377930,342.648071 
	C813.134521,344.270874 813.891113,345.893707 814.371216,348.155701 
	C814.038757,350.136017 813.982666,351.477234 813.926575,352.818420 
	C813.926575,352.818420 813.972412,352.938812 813.913208,352.964111 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M789.144775,329.847534 
	C789.363098,329.140045 789.581360,328.432556 790.000732,327.319885 
	C790.400024,326.691010 790.432068,326.453278 790.298035,326.201477 
	C792.503540,322.921692 795.066589,321.378174 798.851074,325.097229 
	C799.461853,326.775604 799.810669,327.850952 799.758301,328.964691 
	C795.953064,329.284546 792.548889,329.566040 789.144775,329.847534 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M812.287720,342.305969 
	C809.200745,342.782135 806.023621,342.916199 802.443481,342.695038 
	C802.003479,341.895813 801.966309,341.451813 801.983887,340.680481 
	C802.044617,339.910797 802.050720,339.468445 802.028198,339.016174 
	C801.999634,339.006256 801.998901,339.066681 802.332031,339.067261 
	C803.436707,338.700073 804.208313,338.332306 804.979919,337.964539 
	C807.385803,339.297638 809.791626,340.630737 812.287720,342.305969 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M804.984741,337.525940 
	C804.208313,338.332306 803.436707,338.700073 802.260742,338.674255 
	C801.572571,335.187683 801.288696,332.094666 800.765381,328.923004 
	C800.358887,328.862122 800.191772,328.879944 800.051208,328.938660 
	C800.077698,328.979584 800.159424,328.926331 800.159424,328.926331 
	C799.810669,327.850952 799.461853,326.775604 799.131348,325.348206 
	C805.925598,326.694000 804.823242,332.197083 804.984741,337.525940 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M811.425232,358.213409 
	C812.416504,357.570496 813.407776,356.927612 814.642578,356.115784 
	C816.154358,356.071838 817.422546,356.196808 818.846802,356.668457 
	C817.598755,361.275513 814.061584,359.990509 810.916626,359.541321 
	C810.996765,358.743652 811.210999,358.478546 811.425232,358.213409 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M790.222534,325.766113 
	C790.432068,326.453278 790.400024,326.691010 790.077515,326.957153 
	C789.640564,327.013763 789.327942,327.027954 788.546631,327.061554 
	C788.077942,327.080933 787.873596,326.877197 787.859375,326.454651 
	C787.902466,325.365479 787.959717,324.698883 788.060181,323.636688 
	C787.996399,322.461609 787.889526,321.682098 787.782593,320.902588 
	C787.782593,320.902588 788.105957,320.812286 788.252563,320.892975 
	C788.981750,322.426025 789.564331,323.878387 790.222534,325.766113 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M814.241882,352.676392 
	C813.982666,351.477234 814.038757,350.136017 814.270447,348.523132 
	C814.483093,349.679077 814.520142,351.106750 814.241882,352.676392 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M769.030518,316.744934 
	C768.673889,316.994354 768.400391,316.839081 768.293701,316.257294 
	C768.681885,316.046448 768.899597,316.216278 769.030518,316.744934 
z"
      />
      <path
        fill="#975624"
        opacity="1.000000"
        stroke="none"
        d="
M306.986725,346.981964 
	C302.200684,349.204712 297.348480,350.631042 292.292450,347.577301 
	C298.796448,340.267578 306.088074,335.506165 315.887939,336.202820 
	C316.002808,336.726746 316.039459,336.938324 316.058594,337.104797 
	C316.041138,337.059692 316.136688,337.044556 315.804352,337.135254 
	C313.563995,339.760284 311.656006,342.294586 309.450073,344.897156 
	C308.430328,345.637604 307.708527,346.309784 306.986725,346.981964 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M306.943115,347.330811 
	C307.708527,346.309784 308.430328,345.637604 309.822601,344.975311 
	C311.676971,345.321259 312.860931,345.657288 314.115509,346.146301 
	C314.186157,346.299286 314.186584,346.636322 314.155182,347.032623 
	C315.543060,348.592957 316.809265,350.093414 318.423859,350.828339 
	C320.105225,351.593628 322.122894,351.620148 323.993500,351.969696 
	C323.969208,352.653778 323.944885,353.337860 323.664917,354.676239 
	C321.656067,356.374115 319.902863,357.417725 318.044342,358.161865 
	C317.640594,357.573883 317.342133,357.285431 316.971375,356.719238 
	C316.809265,356.272552 316.719543,356.103607 316.703033,355.675049 
	C315.272888,354.002472 313.327209,351.150757 312.350464,351.451019 
	C309.612671,352.292633 307.274780,354.435303 304.526367,356.210205 
	C304.065674,356.897919 303.857788,357.440094 303.259308,357.985779 
	C301.056091,357.745056 299.243439,357.500854 297.244415,357.079437 
	C296.670685,356.346924 296.283356,355.791626 295.896027,355.236359 
	C297.169464,354.173187 298.362335,352.989227 299.734344,352.073761 
	C302.063232,350.519897 304.505096,349.135345 306.943115,347.330811 
M320.573639,354.300415 
	C320.298645,354.012817 320.026154,353.722504 319.734528,353.452911 
	C319.726898,353.445892 319.510010,353.665253 319.390717,353.779053 
	C319.666077,354.066681 319.941467,354.354279 320.573639,354.300415 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M261.975647,386.336456 
	C261.555054,385.306030 261.282806,384.510925 260.961304,383.401367 
	C260.912109,383.086914 261.098114,382.894653 261.529297,382.803040 
	C263.265076,379.642639 265.143646,378.035919 268.648315,379.752228 
	C269.460144,380.149780 270.589600,379.898743 271.572906,379.946167 
	C272.859589,380.769531 274.146271,381.592926 275.716675,382.209686 
	C276.000427,382.003052 276.017273,381.969330 275.795166,382.268738 
	C276.004242,383.396118 276.435425,384.224152 276.866638,385.052155 
	C276.915192,386.105927 276.963745,387.159698 276.587891,388.632751 
	C271.763062,389.015686 267.105743,392.065125 263.044006,387.959930 
	C262.737335,387.497223 262.430695,387.034485 261.975647,386.336456 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M284.026672,370.807861 
	C286.668945,370.194305 289.349426,369.704895 291.935364,368.908539 
	C293.033203,368.570435 293.932770,367.588654 295.177979,366.304016 
	C296.000061,365.489044 296.566589,365.269440 297.571228,365.042114 
	C298.884766,365.101501 299.760162,365.168671 300.477020,365.537933 
	C299.781769,366.834473 299.245026,367.828918 298.421417,369.035400 
	C295.791443,372.143585 296.908722,374.557129 299.148926,377.156738 
	C299.155334,377.968445 299.201904,378.431885 298.974243,379.047974 
	C298.469330,379.763824 298.238617,380.327087 297.702454,381.000671 
	C296.449402,381.606934 295.501801,382.102905 294.293030,382.398285 
	C293.825195,382.123291 293.618591,382.048950 293.370728,381.648193 
	C293.031433,380.547852 292.733398,379.773895 292.365845,378.636536 
	C289.539795,375.784729 286.783234,373.296295 284.026672,370.807861 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M315.809784,335.890503 
	C306.088074,335.506165 298.796448,340.267578 292.181274,347.226074 
	C287.979980,343.184479 292.783325,340.585419 294.675476,337.126404 
	C296.636719,336.659149 297.876190,336.148987 299.146729,336.053772 
	C304.739349,335.634674 310.340973,335.335327 315.947205,335.222809 
	C315.955048,335.453033 315.809784,335.890503 315.809784,335.890503 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M283.642609,370.843933 
	C286.783234,373.296295 289.539795,375.784729 291.964294,378.635132 
	C291.100098,379.004364 290.567963,379.011658 289.868591,378.702118 
	C281.725800,373.624786 280.038361,374.053009 279.031921,381.403198 
	C278.618134,382.174469 278.228790,382.629303 277.658691,382.832245 
	C276.991028,382.376648 276.504150,382.172974 276.017273,381.969299 
	C276.017273,381.969330 276.000427,382.003052 276.018677,382.005707 
	C276.594177,379.085602 277.301819,376.181732 277.672729,373.235535 
	C278.202271,369.029266 280.617401,369.806091 283.642609,370.843933 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M295.662048,355.209534 
	C296.283356,355.791626 296.670685,356.346924 297.307556,357.436249 
	C297.330475,359.982605 297.103851,361.994904 296.547729,363.933899 
	C294.389862,360.476837 291.070068,358.518921 287.787415,359.354797 
	C285.557098,359.922729 284.030182,363.252838 282.188690,365.347748 
	C281.426788,364.117188 280.664886,362.886627 280.329468,361.265869 
	C284.102051,356.755493 288.098358,354.652344 293.518738,356.579651 
	C293.797150,356.678650 294.468658,355.672058 294.957153,355.180176 
	C294.957153,355.180176 295.428101,355.182678 295.662048,355.209534 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M315.939331,334.992584 
	C310.340973,335.335327 304.739349,335.634674 299.146729,336.053772 
	C297.876190,336.148987 296.636719,336.659149 294.949707,336.952332 
	C294.718964,336.537231 294.921478,336.148071 295.208191,335.441437 
	C299.408691,332.139984 303.719666,329.748352 309.493958,330.537506 
	C312.031647,331.198334 314.168213,331.911072 316.515381,333.104065 
	C316.463776,334.053741 316.201538,334.523163 315.939331,334.992584 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M282.586975,365.350464 
	C284.030182,363.252838 285.557098,359.922729 287.787415,359.354797 
	C291.070068,358.518921 294.389862,360.476837 296.637787,364.188049 
	C297.082611,364.693573 297.107880,364.871735 297.133118,365.049866 
	C296.566589,365.269440 296.000061,365.489044 295.243439,365.948425 
	C291.030640,365.909851 287.007935,365.631531 282.586975,365.350464 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M294.763519,354.902283 
	C294.468658,355.672058 293.797150,356.678650 293.518738,356.579651 
	C288.098358,354.652344 284.102051,356.755493 280.419495,360.936646 
	C279.492828,357.611694 280.234192,354.788971 284.045837,352.606262 
	C286.416809,351.728302 288.200531,351.260498 289.984253,350.792694 
	C291.512787,352.069916 293.041321,353.347137 294.763519,354.902283 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M289.926300,350.407379 
	C288.200531,351.260498 286.416809,351.728302 284.335236,352.360901 
	C284.047363,350.952972 284.195160,349.366333 284.037933,347.810516 
	C283.732941,344.793518 284.633636,342.738617 288.283295,341.881836 
	C288.844513,344.763977 289.356415,347.393036 289.926300,350.407379 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M271.475891,379.579773 
	C270.589600,379.898743 269.460144,380.149780 268.648315,379.752228 
	C265.143646,378.035919 263.265076,379.642639 261.621765,382.706360 
	C261.054688,381.964600 260.826355,381.227844 260.362244,380.325012 
	C260.938141,378.843079 261.749786,377.527252 262.878723,376.066254 
	C265.923645,377.018524 268.651245,378.115967 271.475891,379.579773 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M264.084900,369.307678 
	C267.103973,369.341370 270.161926,369.739288 273.659271,370.222168 
	C272.622467,374.647736 269.885986,375.380524 266.895081,372.264679 
	C266.020294,371.353394 265.050201,370.533600 264.084900,369.307678 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M273.966125,360.845642 
	C273.746460,361.490295 273.457306,361.812805 273.168121,362.135315 
	C272.780090,361.269501 272.392059,360.403717 272.021301,359.226990 
	C272.657928,359.451874 273.277283,359.987701 273.966125,360.845642 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M290.978363,413.058350 
	C286.819489,412.681580 282.115936,414.290710 278.986359,409.454285 
	C278.886536,409.111725 279.005188,408.983673 279.435577,408.973938 
	C283.587524,409.948395 287.309082,410.932587 291.019531,412.202240 
	C290.998383,412.677948 290.988373,412.868134 290.978363,413.058350 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M291.020020,413.394348 
	C290.988373,412.868134 290.998383,412.677948 291.309021,412.358582 
	C292.819458,413.739227 294.029266,415.248993 295.239075,416.758759 
	C295.239105,416.758759 295.086365,416.912720 295.009277,416.990295 
	C293.642029,415.955383 292.351868,414.842896 291.020020,413.394348 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M313.335846,408.033325 
	C308.825409,408.704865 304.330566,409.627747 299.795898,409.909576 
	C298.240906,410.006195 296.586243,408.498566 295.372559,407.290649 
	C298.845551,405.073242 302.050690,403.472931 304.963806,401.451691 
	C307.720673,399.538879 309.555481,399.618988 311.408508,402.634247 
	C312.092102,403.746582 313.837311,404.206482 315.098328,404.963959 
	C315.098328,404.963959 315.011414,404.945343 315.024658,405.249969 
	C314.470581,406.380859 313.903229,407.207092 313.335846,408.033325 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M315.140137,404.597900 
	C313.837311,404.206482 312.092102,403.746582 311.408508,402.634247 
	C309.555481,399.618988 307.720673,399.538879 304.963806,401.451691 
	C302.050690,403.472931 298.845551,405.073242 295.417297,406.888367 
	C296.482574,403.997314 297.898468,401.075378 299.961517,397.984650 
	C301.436859,397.474487 302.265076,397.133087 303.388977,396.835571 
	C304.168213,396.610016 304.651703,396.340637 305.469788,396.070068 
	C306.471832,396.085297 307.139343,396.101715 307.806824,396.118103 
	C310.265198,398.822693 312.723541,401.527283 315.140137,404.597900 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M295.529541,416.825043 
	C294.029266,415.248993 292.819458,413.739227 291.320129,412.073090 
	C287.309082,410.932587 283.587524,409.948395 279.493073,408.908264 
	C278.068024,407.476257 277.015869,406.100220 276.300507,404.396790 
	C278.775269,404.817322 281.325745,406.635895 282.936462,406.015289 
	C284.583954,405.380524 285.562958,403.921967 287.394531,405.506531 
	C287.443024,405.548553 288.476074,404.452606 289.324219,404.024902 
	C290.358887,404.415955 291.119354,404.669464 291.879822,404.922943 
	C293.466003,408.110138 295.052155,411.297302 296.883545,414.738495 
	C297.138702,415.443451 297.148651,415.894409 297.079285,416.672668 
	C297.000000,417.000000 297.001862,416.997620 297.001862,416.997620 
	C296.607910,416.962189 296.213959,416.926758 295.529541,416.825043 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M289.049988,403.887329 
	C288.476074,404.452606 287.443024,405.548553 287.394531,405.506531 
	C285.562958,403.921967 284.583954,405.380524 282.936462,406.015289 
	C281.325745,406.635895 278.775269,404.817322 276.276825,404.065735 
	C275.307678,402.588501 274.699005,401.114899 274.554932,399.302734 
	C277.419098,398.856445 279.817810,398.699036 282.218567,398.656403 
	C284.231750,398.620667 286.247375,398.718811 288.261902,398.757690 
	C288.261902,398.757690 288.206604,398.926331 288.152039,399.221313 
	C288.414948,400.973297 288.732483,402.430328 289.049988,403.887329 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M313.262817,408.362427 
	C313.903229,407.207092 314.470581,406.380859 315.039490,405.208069 
	C315.308594,404.655334 315.610870,404.564087 316.561340,404.734436 
	C319.256165,404.029602 321.427490,403.345917 323.398712,402.288940 
	C326.670349,400.534668 329.522919,400.864807 332.164429,403.419342 
	C332.164429,403.419342 332.269196,403.796417 331.778442,403.925415 
	C326.512360,406.098907 321.737000,408.143402 316.647888,410.211914 
	C315.874969,410.578583 315.415771,410.921234 314.956604,411.263916 
	C314.367676,410.406464 313.778748,409.548981 313.262817,408.362427 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M290.035797,379.018951 
	C290.567963,379.011658 291.100098,379.004364 292.033813,378.998474 
	C292.733398,379.773895 293.031433,380.547852 293.016113,381.763641 
	C289.067200,385.644379 284.812653,387.124329 279.822205,386.275360 
	C279.395935,385.887878 278.969696,385.500397 278.236725,384.734253 
	C277.899841,383.931793 277.869629,383.507965 277.839447,383.084167 
	C278.228790,382.629303 278.618134,382.174469 279.423676,381.381836 
	C283.346649,380.913483 287.199432,382.524933 290.035797,379.018951 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M288.200653,398.425842 
	C286.247375,398.718811 284.231750,398.620667 282.218567,398.656403 
	C279.817810,398.699036 277.419098,398.856445 274.629944,398.958008 
	C275.619812,393.346039 279.636322,391.543610 284.096466,394.622650 
	C285.550171,395.626160 286.797638,396.928375 288.200653,398.425842 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M292.905823,395.283539 
	C292.672577,392.498749 292.439331,389.713989 292.489288,386.439453 
	C293.136932,385.777588 293.501343,385.605499 294.314514,385.324310 
	C297.298431,385.231781 299.833618,385.248322 302.598755,385.515869 
	C303.119110,386.613708 303.409485,387.460510 303.226746,388.237152 
	C296.891785,386.489655 296.069885,391.480469 293.699341,394.887848 
	C293.246246,395.080627 293.076019,395.182098 292.905823,395.283539 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M314.972839,411.638123 
	C315.415771,410.921234 315.874969,410.578583 316.931152,410.456726 
	C319.412354,410.518799 321.344421,410.568542 323.168549,410.148926 
	C325.473969,409.618652 327.691376,408.705933 329.881775,408.272339 
	C329.492676,409.370056 329.168518,410.153625 328.844360,410.937195 
	C328.004272,411.423401 327.164185,411.909607 326.130280,412.607544 
	C322.210358,413.594635 318.367828,415.949310 314.972839,411.638123 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M293.865784,385.433380 
	C293.501343,385.605499 293.136932,385.777588 292.563629,386.004944 
	C288.420898,388.933868 284.516235,392.208740 279.906891,386.617371 
	C284.812653,387.124329 289.067200,385.644379 293.057373,382.090027 
	C293.618591,382.048950 293.825195,382.123291 294.115784,382.729370 
	C294.088440,383.985168 293.977112,384.709290 293.865784,385.433380 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M263.041260,388.323547 
	C267.105743,392.065125 271.763062,389.015686 276.580566,389.028442 
	C276.916473,394.662354 272.953674,393.928253 269.682495,392.917358 
	C267.263153,392.169708 265.238831,390.143646 263.041260,388.323547 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M292.982788,395.627380 
	C293.076019,395.182098 293.246246,395.080627 294.060303,394.974976 
	C297.966797,393.888947 301.229431,392.807037 304.600403,392.053192 
	C304.170227,393.851440 303.631744,395.321564 303.093262,396.791718 
	C302.265076,397.133087 301.436859,397.474487 300.272491,397.831543 
	C299.149506,397.467712 298.398132,396.942596 297.568115,396.740601 
	C296.090424,396.381073 294.565125,396.217041 292.982788,395.627380 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M289.324219,404.024902 
	C288.732483,402.430328 288.414948,400.973297 288.150055,399.132599 
	C289.405670,400.579651 290.608704,402.410400 291.845764,404.582031 
	C291.119354,404.669464 290.358887,404.415955 289.324219,404.024902 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M306.622498,412.969299 
	C305.553925,413.335632 304.132935,413.660919 302.354706,413.968384 
	C303.421692,413.609802 304.845856,413.269012 306.622498,412.969299 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M277.658691,382.832245 
	C277.869629,383.507965 277.899841,383.931793 277.951385,384.674011 
	C277.788727,385.006195 277.604675,385.019928 277.143616,385.042908 
	C276.435425,384.224152 276.004242,383.396118 275.795166,382.268707 
	C276.504150,382.172974 276.991028,382.376648 277.658691,382.832245 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M811.173828,357.870789 
	C811.210999,358.478546 810.996765,358.743652 810.694092,359.249390 
	C809.387939,362.380981 808.170166,365.271973 806.967041,368.876953 
	C807.007996,370.041077 807.034363,370.491211 806.909546,371.205200 
	C806.940674,372.620148 807.123047,373.771271 807.305359,374.922363 
	C806.836914,375.151001 806.368469,375.379669 805.520325,375.474121 
	C803.342529,374.362427 801.029480,372.133575 799.835876,372.624786 
	C794.765442,374.711639 789.892700,377.484192 789.097778,384.067993 
	C788.228821,384.466156 787.607117,384.760315 786.688171,384.806519 
	C781.662109,383.175201 779.840942,384.658997 777.178040,392.353882 
	C777.061401,393.491150 777.044495,394.257874 776.665894,395.029358 
	C773.940918,391.534912 771.577759,388.035614 769.147278,384.170898 
	C769.048645,382.531036 769.017334,381.256592 768.985962,379.982147 
	C768.985962,379.982147 769.000000,379.998779 769.312012,380.156372 
	C775.234253,384.234436 778.592041,384.172729 781.333130,379.952820 
	C782.400513,378.158997 783.133240,376.517273 783.912048,374.521118 
	C781.977783,371.733521 779.997375,369.300323 778.042358,366.584656 
	C778.072449,365.924652 778.077148,365.547119 778.323120,364.914795 
	C778.593018,363.747528 778.621582,362.835022 778.670532,361.574219 
	C775.907654,354.184570 773.364075,352.977631 766.165283,355.282501 
	C765.557983,354.675568 764.950684,354.068634 764.379089,352.938934 
	C765.589050,351.257904 766.763306,350.099670 767.968445,348.574005 
	C768.024963,347.469940 768.050537,346.733307 768.418701,346.032349 
	C771.357422,348.055481 773.713501,350.594025 776.623230,351.861633 
	C779.091797,352.937042 782.159058,356.229950 785.404419,352.101410 
	C786.521240,352.077057 787.266113,352.075653 788.170898,352.316345 
	C788.882324,352.698181 789.433838,352.837891 789.985413,352.977570 
	C790.248962,353.029633 790.512573,353.081696 790.988159,353.540344 
	C789.615967,355.850861 788.031799,357.754822 786.144165,359.833496 
	C782.567871,365.051025 783.408752,367.592194 789.011719,369.590790 
	C796.833435,372.380798 802.717224,368.632355 801.429565,361.331482 
	C801.178711,360.650940 800.989380,360.279419 800.759644,359.598267 
	C799.918701,357.850098 799.118042,356.411560 798.317444,354.973022 
	C798.902466,354.638580 799.487549,354.304138 800.260864,353.661896 
	C803.940247,354.745422 807.431335,356.136810 811.173828,357.870789 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M777.027588,395.024597 
	C777.044495,394.257874 777.061401,393.491150 777.521973,392.325867 
	C780.890747,390.125366 783.815796,388.323456 787.200806,386.238220 
	C787.277222,386.658264 787.131348,385.856384 786.985474,385.054504 
	C787.607117,384.760315 788.228821,384.466156 789.453430,383.966766 
	C794.025696,378.871704 798.353882,374.789734 805.444336,376.925201 
	C805.657654,378.676727 805.870911,380.428284 805.691284,382.437378 
	C803.908875,383.626617 802.519348,384.558289 800.978821,385.591187 
	C793.544617,383.068298 790.509888,384.751678 789.668518,392.233459 
	C787.315430,392.506226 784.939575,392.781616 782.152649,393.104675 
	C781.843323,394.282074 781.433411,395.842072 781.023560,397.402100 
	C780.539612,397.356201 780.055664,397.310303 779.200439,396.873199 
	C778.228638,395.996185 777.628113,395.510376 777.027588,395.024597 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M765.498230,406.922302 
	C766.005127,406.838196 766.512085,406.754089 767.572937,406.909027 
	C768.347412,407.228668 768.567871,407.309235 768.912720,407.741302 
	C775.006165,411.335083 781.156982,410.464233 787.338440,408.901550 
	C787.732727,408.952759 788.127075,409.003998 788.854858,409.446716 
	C789.088135,410.583893 788.987976,411.329590 788.589478,412.105194 
	C787.551758,412.755676 786.812439,413.376282 785.651123,413.963867 
	C779.638306,415.542297 774.237854,415.828613 769.319092,410.895721 
	C769.133362,412.763763 769.022034,413.883820 768.910645,415.003876 
	C768.910706,415.003876 768.814331,415.304871 768.505920,415.539978 
	C767.438477,416.145599 766.679504,416.516144 765.920532,416.886719 
	C764.558960,416.914886 763.197388,416.943054 761.088013,416.949799 
	C759.881775,416.940308 759.423279,416.952209 758.964783,416.964142 
	C757.106323,416.141510 755.247864,415.318878 753.145996,414.261169 
	C752.061707,412.805786 751.220764,411.585419 750.748169,410.106262 
	C754.188416,411.099335 757.173645,412.733856 760.365356,413.456940 
	C762.225342,413.878296 764.415955,412.840240 766.457764,412.458862 
	C766.116089,411.260254 765.774475,410.061615 765.366699,408.539032 
	C765.366516,407.784119 765.432373,407.353210 765.498230,406.922302 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M781.281555,397.636017 
	C781.433411,395.842072 781.843323,394.282074 782.152649,393.104675 
	C784.939575,392.781616 787.315430,392.506226 789.668518,392.233459 
	C790.509888,384.751678 793.544617,383.068298 800.978821,385.591187 
	C802.519348,384.558289 803.908875,383.626617 805.593262,382.816711 
	C804.335205,389.045563 801.261414,390.813141 792.691528,390.527252 
	C790.082703,399.659882 789.657043,399.940125 781.281555,397.636017 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M788.887817,412.075287 
	C788.987976,411.329590 789.088135,410.583893 789.152710,409.462891 
	C789.117188,409.087616 789.376892,408.920959 789.834229,408.809326 
	C790.509583,408.105927 790.727661,407.514191 790.945740,406.922455 
	C790.945740,406.922455 790.831299,406.977325 791.169861,406.943848 
	C795.172913,405.455597 798.837402,404.000885 803.344604,402.211609 
	C803.830505,402.502869 805.358032,403.418488 806.885559,404.334076 
	C806.732117,405.041992 806.578735,405.749939 805.799194,406.735229 
	C804.517517,408.069824 803.862061,409.127014 803.206604,410.184204 
	C803.206604,410.184204 803.020203,410.041748 802.747925,410.054504 
	C801.313354,410.771240 800.151062,411.475250 798.615112,412.189331 
	C797.495178,412.160553 796.748840,412.121704 795.881714,411.849426 
	C795.108643,411.829041 794.456482,412.042023 793.464722,412.387695 
	C792.426514,412.736053 791.727844,412.951721 790.713135,413.127075 
	C789.893982,412.749634 789.390869,412.412476 788.887817,412.075287 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M818.859375,389.866760 
	C819.007568,390.714752 818.871887,391.339050 818.646851,392.269653 
	C815.446228,393.382721 812.372620,394.421906 809.213562,394.930878 
	C806.050842,395.440399 804.572449,393.812592 805.778748,390.278870 
	C810.338562,391.724487 811.933411,389.270081 813.151306,386.152588 
	C814.697449,385.285645 816.243591,384.418732 818.575439,383.111298 
	C818.575439,386.059692 818.575439,387.851379 818.859375,389.866760 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M787.295654,408.638611 
	C781.156982,410.464233 775.006165,411.335083 769.224731,407.514282 
	C772.514221,404.744934 775.548340,402.517609 779.764648,403.982574 
	C781.443054,404.565735 783.296814,404.644196 785.070740,404.952362 
	C785.070740,404.952362 785.022583,405.005463 785.040283,405.333252 
	C785.559753,406.107056 786.061462,406.553070 786.563171,406.999084 
	C786.793030,407.457947 787.022888,407.916809 787.295654,408.638611 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M785.036743,404.608337 
	C783.296814,404.644196 781.443054,404.565735 779.764648,403.982574 
	C775.548340,402.517609 772.514221,404.744934 769.100342,407.162781 
	C768.567871,407.309235 768.347412,407.228668 767.784241,407.066650 
	C766.511047,401.890839 769.931213,400.103943 774.370911,398.454193 
	C776.000000,398.435120 777.040344,398.606476 778.080750,398.777832 
	C780.388062,400.606628 782.695435,402.435455 785.036743,404.608337 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M807.555725,375.108215 
	C807.123047,373.771271 806.940674,372.620148 807.291748,371.214935 
	C811.266296,370.892395 814.707581,370.823975 818.148804,370.755554 
	C818.310120,370.817535 818.471375,370.879547 818.855896,371.074646 
	C817.597778,373.073425 816.430969,375.395966 814.554626,376.687927 
	C812.265076,378.264313 809.503052,378.416565 807.555725,375.108215 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M807.159180,404.187195 
	C805.358032,403.418488 803.830505,402.502869 803.344604,402.211609 
	C798.837402,404.000885 795.172913,405.455597 791.138428,406.888733 
	C791.544922,405.323883 792.321411,403.780701 793.789917,402.089050 
	C798.712219,400.184662 802.905029,397.949097 807.504822,400.923218 
	C807.504822,400.923218 807.979126,400.943756 808.216797,400.950867 
	C808.113892,401.985413 807.773376,403.012878 807.159180,404.187195 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M805.477295,376.690491 
	C798.353882,374.789734 794.025696,378.871704 789.700745,383.862793 
	C789.892700,377.484192 794.765442,374.711639 799.835876,372.624786 
	C801.029480,372.133575 803.342529,374.362427 805.334778,375.661072 
	C805.528931,375.982178 805.510254,376.455780 805.477295,376.690491 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M778.104858,398.535461 
	C777.040344,398.606476 776.000000,398.435120 774.643799,398.216278 
	C771.950256,394.019257 769.572571,389.869751 767.488953,385.330505 
	C768.260193,384.805969 768.737366,384.671173 769.214539,384.536346 
	C771.577759,388.035614 773.940918,391.534912 776.665894,395.029388 
	C777.628113,395.510376 778.228638,395.996185 778.841858,396.803741 
	C778.612671,397.514709 778.370789,397.903900 778.104858,398.535461 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M807.495117,400.539673 
	C802.905029,397.949097 798.712219,400.184662 794.081299,401.920288 
	C799.247803,394.688477 801.853882,394.359283 807.495117,400.539673 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M812.707031,386.102478 
	C811.933411,389.270081 810.338562,391.724487 805.992554,389.976074 
	C806.155884,388.710358 806.698364,387.475494 807.537415,386.072266 
	C809.310242,385.953369 810.786499,386.002869 812.707031,386.102478 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M790.611389,406.986145 
	C790.727661,407.514191 790.509583,408.105927 789.987793,408.824341 
	C789.881653,408.317261 790.079346,407.683533 790.611389,406.986145 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M786.475586,406.662598 
	C786.061462,406.553070 785.559753,406.107056 785.047119,405.298065 
	C785.486816,405.398773 785.937439,405.862457 786.475586,406.662598 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M814.988892,195.641327 
	C810.338257,197.990051 805.678040,199.956223 800.214050,202.261490 
	C801.384766,194.843018 803.814575,192.770218 811.315552,191.537170 
	C812.794556,192.727539 813.886963,193.993149 814.988892,195.641327 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M793.035583,198.320053 
	C792.879456,198.462402 792.723328,198.604736 791.850891,198.846481 
	C788.075867,198.868896 785.017212,198.791916 781.958496,198.714951 
	C784.562561,194.765442 788.255432,192.675934 792.944458,193.124344 
	C794.052490,193.230316 794.990173,195.117249 796.013184,196.601410 
	C796.020203,197.017899 795.840942,197.240112 795.380005,197.189423 
	C794.291260,197.532501 793.663452,197.926270 793.035583,198.320053 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M781.630981,198.804840 
	C785.017212,198.791916 788.075867,198.868896 791.588135,199.023590 
	C789.509766,203.203751 782.036926,203.400528 779.227051,199.018204 
	C779.974854,198.695206 780.639160,198.794968 781.630981,198.804840 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M793.322632,198.451294 
	C793.663452,197.926270 794.291260,197.532501 795.237305,197.188141 
	C794.906921,197.685898 794.258362,198.134201 793.322632,198.451294 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M287.711914,193.931107 
	C286.919739,192.412750 286.127533,190.894394 285.335358,189.376038 
	C287.251526,188.691284 289.253571,187.280304 291.063416,187.494354 
	C293.687469,187.804718 296.172668,189.289444 298.911865,190.573120 
	C299.106628,190.872986 299.046021,190.945328 298.641235,191.035217 
	C296.017853,192.256134 293.799316,193.387192 291.192078,194.446808 
	C289.760681,194.221756 288.717896,194.068130 287.673462,193.932343 
	C287.671814,193.950165 287.711914,193.931107 287.711914,193.931107 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M287.675140,193.914520 
	C288.717896,194.068130 289.760681,194.221756 291.442749,194.734451 
	C296.270996,195.291870 300.459930,195.490219 304.648865,195.688568 
	C306.390289,198.104309 306.008881,199.686813 302.843079,199.966690 
	C297.200714,200.465546 292.015656,199.540436 287.869446,194.497757 
	C287.601044,194.110077 287.675140,193.914520 287.675140,193.914520 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M304.643372,195.411133 
	C300.459930,195.490219 296.270996,195.291870 291.831421,194.805893 
	C293.799316,193.387192 296.017853,192.256134 298.610718,191.071228 
	C300.185730,191.855530 301.386414,192.693680 302.794464,193.300888 
	C303.547180,193.757858 304.092499,194.445770 304.643372,195.411133 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M284.675598,197.527435 
	C280.216003,196.456894 275.747070,195.099121 271.068390,193.454636 
	C274.262817,193.407776 277.667023,193.647614 281.530518,193.832245 
	C282.881927,194.931427 283.774078,196.085815 284.675598,197.527435 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M287.673462,193.932343 
	C287.675140,193.914520 287.601044,194.110077 287.603333,194.209808 
	C287.605621,194.309540 287.600494,194.034225 287.656189,193.982666 
	C287.711914,193.931107 287.671814,193.950165 287.673462,193.932343 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M776.820557,179.822021 
	C776.006714,179.493820 775.170532,178.879410 774.535400,177.960602 
	C775.423767,178.282730 776.111023,178.909271 776.820557,179.822021 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M810.135437,223.652618 
	C804.606323,223.253540 802.981995,221.583008 804.759827,217.962021 
	C806.429504,218.716476 807.767029,219.561188 809.332764,220.672760 
	C809.739441,221.740646 809.917969,222.541656 810.135437,223.652618 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M814.154236,216.715576 
	C814.019165,216.536011 814.126587,216.364304 814.340210,216.085022 
	C814.439148,215.972916 814.695007,216.364532 814.695007,216.364532 
	C814.695007,216.364532 814.389465,216.718857 814.154236,216.715576 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M818.308289,370.439575 
	C814.707581,370.823975 811.266296,370.892395 807.442871,370.951111 
	C807.034363,370.491211 807.007996,370.041077 807.054443,369.259796 
	C809.232727,366.983337 811.156677,364.763641 813.516052,363.201782 
	C814.805603,362.348175 816.832092,362.607635 818.526245,362.365173 
	C818.712402,363.831482 819.029846,365.296722 819.042053,366.764496 
	C819.051392,367.882538 818.673462,369.003784 818.308289,370.439575 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M297.110321,223.561234 
	C293.556152,224.846420 290.173553,225.880692 286.762695,226.811325 
	C286.004608,227.018143 284.631805,227.177170 284.412781,226.821701 
	C281.407166,221.943466 278.480530,226.006088 275.170197,226.750214 
	C274.850128,226.319733 274.903107,225.936737 275.166809,225.002670 
	C277.953766,221.181747 283.168030,219.878128 282.838135,214.442154 
	C282.838135,214.442154 282.881378,214.102859 282.941956,213.941620 
	C284.163086,215.755798 285.323639,217.731201 286.787750,220.223251 
	C286.812286,220.210907 287.988892,219.619354 289.572083,219.366516 
	C289.796143,223.169479 291.665253,224.057266 294.074554,222.105881 
	C296.517761,220.127045 298.302277,217.334869 300.375244,214.898895 
	C300.427277,216.497528 300.923859,218.261826 300.407074,219.648438 
	C299.884186,221.051270 298.358246,222.080215 297.110321,223.561234 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M282.448425,214.296112 
	C283.168030,219.878128 277.953766,221.181747 275.157837,224.711761 
	C271.034180,221.905380 273.391937,218.731628 274.921082,215.216278 
	C277.396179,214.622040 279.727448,214.386047 282.448425,214.296112 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M797.936401,214.466156 
	C798.967468,214.054520 800.048462,214.009491 801.531738,213.945099 
	C801.976318,214.552994 802.018677,215.180267 802.088379,216.118744 
	C801.620239,216.576553 801.124695,216.723160 800.240845,216.910217 
	C799.461304,216.968460 799.070251,216.986252 798.387268,217.030243 
	C798.059082,216.315216 798.022766,215.574005 797.936401,214.466156 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M459.013184,216.875671 
	C457.616272,216.917496 456.219330,216.959305 454.335266,216.602936 
	C451.909210,214.298233 450.230743,214.111298 449.008667,216.937653 
	C433.308777,216.953476 417.608887,216.969299 401.362854,216.575867 
	C398.327972,214.533829 395.934113,213.698029 394.029877,216.974594 
	C392.241119,217.953156 390.452332,218.931702 387.953857,219.962128 
	C386.527405,220.754501 385.810669,221.494995 385.093933,222.235504 
	C384.658020,222.827362 384.222107,223.419205 383.128601,224.049454 
	C380.651978,226.065933 378.832947,228.044037 377.013916,230.022125 
	C377.013885,230.022110 376.997284,230.003647 376.781219,230.110367 
	C376.282745,230.418732 376.090912,230.685532 375.989624,231.017487 
	C372.676666,234.386887 369.363708,237.756287 365.338623,241.107117 
	C363.739471,241.397919 362.852386,241.707306 361.700928,241.895706 
	C360.961731,241.175690 360.486938,240.576660 360.006531,239.544342 
	C359.551117,235.008484 360.347748,231.630341 363.667786,228.536377 
	C366.042480,226.323364 367.219849,222.825500 368.931488,219.900940 
	C368.931488,219.900940 368.986816,219.989456 369.319122,219.985703 
	C374.342438,217.235779 379.900146,215.371201 380.926270,208.897278 
	C380.926270,208.897278 381.008301,208.964035 381.345795,208.974136 
	C382.491913,208.889572 383.515594,209.079391 384.075623,208.655930 
	C389.269257,204.728882 394.422516,200.744812 399.475861,196.639832 
	C400.203217,196.048965 400.337738,194.728333 400.746643,193.745422 
	C400.746643,193.745422 400.828888,193.767792 401.177582,193.732941 
	C405.325348,191.652542 409.239746,189.789062 412.876007,187.486420 
	C414.761261,186.292557 416.154175,184.321274 417.769531,182.701218 
	C417.769531,182.701233 417.692993,182.786667 418.111542,182.834106 
	C423.187378,180.496796 427.860382,178.141373 432.471466,175.670456 
	C432.833252,175.476593 432.763519,174.477478 432.894348,173.852615 
	C432.894348,173.852615 433.002197,173.911469 433.358124,173.942474 
	C438.136566,172.313858 442.531982,170.577118 446.987457,169.011200 
	C455.476440,166.027679 464.134399,163.478729 472.479980,160.143234 
	C488.619293,153.692734 505.657654,150.754181 522.645386,149.336411 
	C546.628418,147.334824 570.775391,148.508224 594.193115,155.002960 
	C606.292114,158.358551 618.298828,162.345535 629.888550,167.153152 
	C641.075134,171.793564 651.871094,177.496277 662.482361,183.375427 
	C679.434753,192.767929 693.941895,205.478348 708.058228,218.605072 
	C712.240845,222.494446 716.505066,226.419373 719.955139,230.922989 
	C721.771729,233.294174 722.135925,236.918655 722.563782,240.057907 
	C722.626404,240.517502 719.390137,241.426712 717.680298,242.127899 
	C716.391968,241.408524 714.882812,240.919769 713.851440,239.932068 
	C707.445923,233.797562 701.304077,227.376633 694.709045,221.458344 
	C692.948303,219.878326 689.923340,219.065826 687.455811,219.014832 
	C664.982849,218.550461 642.504822,218.328796 620.028137,218.047684 
	C617.182617,218.012100 614.336304,218.042847 611.504761,218.042847 
	C614.850098,215.431305 617.330994,212.572205 620.452698,211.350296 
	C622.937927,210.377487 626.206543,211.386673 629.125488,211.549667 
	C630.569214,211.630325 632.038330,212.031570 633.444214,211.861053 
	C636.976318,211.432632 640.486084,210.800980 643.989990,210.168732 
	C645.459717,209.903549 647.731262,209.872833 648.201599,208.979218 
	C650.777710,204.085785 655.023132,203.671509 659.720520,203.868851 
	C662.292175,203.976883 664.872009,203.888153 667.537842,203.242935 
	C634.965454,177.949753 598.083618,164.193268 557.299377,161.102524 
	C492.979126,156.228165 435.849915,182.221344 417.140106,202.051056 
	C418.154968,202.368591 419.002869,202.903778 419.804016,202.841156 
	C425.457031,202.399307 430.380310,203.551483 433.758545,208.608963 
	C433.939453,208.879776 434.701355,208.762482 435.789673,209.140381 
	C438.040161,210.157288 439.641022,211.236618 441.359253,211.476822 
	C444.183899,211.871689 447.820343,213.866287 448.972046,208.944839 
	C448.972046,208.944839 449.004272,208.993118 449.422974,208.993393 
	C459.157837,209.023773 460.449432,210.133743 459.013184,216.875671 
z"
      />
      <path
        fill="#0D8546"
        opacity="1.000000"
        stroke="none"
        d="
M481.220276,184.908569 
	C481.178101,184.485626 481.135925,184.062668 481.362488,183.102722 
	C481.775146,182.158661 481.919098,181.751587 482.453186,181.380646 
	C486.552460,182.244370 490.261627,183.071945 493.970795,183.899536 
	C494.427155,183.928665 494.883514,183.957794 496.082764,183.976776 
	C501.550293,183.829529 506.229736,182.537613 510.793335,185.628418 
	C514.883789,188.398788 515.660156,193.626068 511.738556,196.853668 
	C506.215088,201.399612 505.994049,207.068680 510.853333,212.274353 
	C512.829773,210.857483 514.546326,209.051834 516.646362,208.246475 
	C520.497864,206.769424 521.149658,205.131348 518.646362,201.652176 
	C515.518677,197.305161 516.538940,194.948944 521.616150,193.023804 
	C523.098267,192.461838 524.503662,191.697693 525.914612,191.040039 
	C525.240479,189.306381 524.130554,187.917404 524.430115,186.977982 
	C526.049133,181.901199 523.006042,180.923508 519.141907,180.189056 
	C516.933838,179.769363 514.276794,179.401138 514.826538,175.975098 
	C514.826538,175.975098 514.978027,175.979065 515.332214,175.865143 
	C522.645081,173.016846 529.778992,167.651306 535.926331,177.099197 
	C535.926331,177.099197 535.986877,177.009979 535.981812,177.435059 
	C536.314880,179.598099 536.652954,181.336044 537.059326,183.425278 
	C543.325684,183.138245 548.717834,181.520905 553.053528,177.091156 
	C558.054016,179.087433 560.096375,182.787979 559.358582,187.643936 
	C558.875671,190.822525 558.954651,194.086487 558.294189,197.826920 
	C557.382935,203.521317 557.340515,208.770798 556.409241,213.857513 
	C555.724365,217.598007 556.858765,218.408081 560.133057,217.819061 
	C561.192993,217.628403 562.247314,217.406860 563.360718,217.188354 
	C563.570923,221.385849 563.762268,225.207092 563.559143,228.968811 
	C561.229065,228.610245 558.751648,227.397247 557.450623,228.168564 
	C551.452209,231.724716 547.459595,228.767761 543.515808,224.765228 
	C542.947876,224.188812 542.033203,223.304794 541.511292,223.442642 
	C539.023987,224.099457 534.852356,224.582733 534.471313,225.991135 
	C532.207092,234.360107 526.141968,235.852707 518.914001,235.584351 
	C518.267090,232.493225 516.628967,228.176163 514.140198,230.727188 
	C510.683258,234.270645 508.975098,232.078171 506.432861,230.839386 
	C506.432861,230.839386 506.181519,230.885239 506.197174,230.566284 
	C506.710541,227.541702 505.910736,225.623413 503.014862,224.977020 
	C503.014862,224.977020 503.000793,225.001419 503.018555,224.762878 
	C503.036316,224.524353 502.956635,224.070389 502.949341,223.739059 
	C502.291046,222.942001 501.640045,222.476257 500.765747,221.948273 
	C500.542450,221.886032 500.078857,221.886993 500.078857,221.886993 
	C500.078857,221.886993 500.015137,221.973190 500.081909,221.700821 
	C500.148712,221.428452 500.030121,220.943863 499.996704,220.620346 
	C499.475220,219.968002 498.987213,219.639191 498.277496,219.163208 
	C497.626770,218.464905 497.197693,217.913803 496.718689,217.059174 
	C496.320129,216.581497 495.971466,216.407349 495.344574,216.067291 
	C493.753204,214.732986 492.440094,213.564590 490.983582,212.110092 
	C489.183807,212.011658 487.527466,212.199326 485.503357,212.505829 
	C483.648407,212.581451 482.161133,212.538269 480.673889,212.495087 
	C480.673889,212.495087 480.565521,212.425507 480.529175,212.105118 
	C480.344910,211.469955 480.196960,211.155182 480.052246,210.461594 
	C481.077698,208.048218 482.099976,206.013657 483.452637,203.798096 
	C484.215668,202.749832 484.648285,201.882599 485.302795,200.826813 
	C485.537384,200.267242 485.550079,199.896194 485.641418,199.165009 
	C485.779846,197.584137 485.839600,196.363419 485.923950,194.801605 
	C485.478302,194.069275 485.008026,193.678040 484.305145,193.192062 
	C483.755005,193.018021 483.437500,192.938721 483.119995,192.859421 
	C483.119995,192.859421 482.985382,192.947861 482.977661,192.597351 
	C482.808105,192.100616 482.646271,191.954407 482.502319,191.658630 
	C482.520203,191.509064 482.265564,191.348038 482.368195,190.971161 
	C482.542236,190.078476 482.613647,189.562668 482.971954,188.909027 
	C483.029449,187.803375 482.800049,186.835541 482.380798,185.656799 
	C481.867401,185.266769 481.543823,185.087662 481.220276,184.908569 
z"
      />
      <path
        fill="#0A1A20"
        opacity="1.000000"
        stroke="none"
        d="
M603.013428,350.997620 
	C603.942688,350.344452 604.872009,349.691284 605.945435,348.725769 
	C606.456482,348.606903 606.823486,348.800415 607.426025,349.511780 
	C607.911804,350.917206 608.161926,351.804840 608.296692,353.106476 
	C608.464661,355.092987 608.566956,356.729797 609.094360,358.215729 
	C609.451111,359.221100 610.405884,360.014252 611.093201,360.902313 
	C611.770813,359.995667 612.448364,359.089050 613.222717,357.867615 
	C613.479370,356.694275 613.639221,355.835663 613.799072,354.977081 
	C615.163208,351.675934 617.276733,348.480560 617.760071,345.055145 
	C619.714722,331.202484 621.703613,317.314423 622.625671,303.369751 
	C623.295471,293.239502 622.309021,282.999756 622.392822,272.461670 
	C623.200867,272.102295 623.677063,272.090118 624.423706,271.954834 
	C624.766541,270.888794 624.838928,269.945892 624.887207,268.682983 
	C624.523499,267.391052 624.183777,266.419037 623.884766,265.014709 
	C624.850891,263.354767 625.584961,261.330353 626.738892,261.053101 
	C629.850830,260.305359 633.182922,260.514709 636.342041,259.902466 
	C637.673828,259.644379 638.790588,258.276489 640.393250,257.301025 
	C641.856262,257.121155 642.931091,257.053345 644.281616,257.206909 
	C646.710205,257.220642 648.863037,257.012970 651.327759,256.841766 
	C652.054626,256.841034 652.469604,256.803833 653.342651,256.881531 
	C657.856567,256.987701 661.912415,256.978943 666.256470,257.271790 
	C670.756226,258.133698 674.967773,258.694000 679.179382,259.254272 
	C677.055115,261.275513 674.930847,263.296783 672.238770,265.643585 
	C667.723816,266.357269 666.635620,268.632568 666.976196,272.366211 
	C667.495300,278.055573 667.657776,283.777496 667.548340,289.550598 
	C665.437988,289.501068 663.750977,289.386505 662.046997,288.857208 
	C662.059143,280.992889 661.856445,273.576569 659.961365,266.403107 
	C659.270020,266.437225 658.578613,266.471375 657.887268,266.505493 
	C657.599670,273.945709 657.312073,281.385925 656.802856,288.917114 
	C656.249084,289.078979 655.994324,289.259216 655.488464,289.561310 
	C654.081726,289.410736 653.003479,289.247650 651.937012,288.630249 
	C651.368225,281.188568 650.787598,274.201202 650.206909,267.213806 
	C649.376892,267.238525 648.546936,267.263245 647.716919,267.287964 
	C647.182983,274.565826 646.649048,281.843689 645.713257,289.217773 
	C644.229004,289.196381 643.146667,289.078735 642.054077,288.494904 
	C641.962341,282.411072 642.002075,276.787201 641.715698,271.180023 
	C641.642273,269.742340 640.539246,268.357269 639.909241,266.948029 
	C639.280945,267.129974 638.652649,267.311890 638.024353,267.493835 
	C637.355408,274.673462 636.686523,281.853119 635.573975,289.102020 
	C632.829224,289.194214 630.493103,288.974915 628.235718,289.300964 
	C625.378601,289.713654 625.733154,290.883789 627.919556,292.470947 
	C629.041199,298.007965 630.422302,303.086792 631.264526,308.253479 
	C631.929138,312.330231 633.790955,314.463043 638.047241,314.539124 
	C638.732483,314.670288 639.371887,314.544739 640.406372,314.349579 
	C643.207214,314.510559 645.612976,314.741089 648.054932,315.354675 
	C648.868958,323.554382 646.387207,331.044373 640.977966,335.798584 
	C635.292664,340.795441 631.017395,346.134399 628.730408,353.048492 
	C627.156372,357.807190 626.469910,362.859528 625.481323,367.999664 
	C625.576904,368.573700 625.420532,368.833862 625.106689,368.999237 
	C623.431885,371.463623 621.233459,373.723053 620.174622,376.428497 
	C615.986877,387.128387 612.212097,397.989410 608.101746,408.720825 
	C607.716431,409.726898 606.050537,410.242493 604.599731,410.994080 
	C604.044495,403.984222 603.868774,396.966095 603.705811,389.039551 
	C603.630310,378.341827 603.541992,368.552551 603.549011,358.471863 
	C603.517273,357.802765 603.390198,357.425110 603.329468,356.617737 
	C603.268433,354.457916 603.140930,352.727753 603.013428,350.997620 
M632.678345,277.855743 
	C632.469238,274.041168 634.419739,269.831512 630.504517,265.654541 
	C628.117432,270.645874 628.862610,274.700989 630.141724,279.585724 
	C630.573853,281.580536 631.006042,283.575378 631.438171,285.570190 
	C631.940918,285.469696 632.443665,285.369202 632.946411,285.268707 
	C632.821594,283.089294 632.696716,280.909882 632.678345,277.855743 
z"
      />
      <path
        fill="#0B6A39"
        opacity="1.000000"
        stroke="none"
        d="
M563.953613,229.028336 
	C563.762268,225.207092 563.570923,221.385849 563.360718,217.188354 
	C562.247314,217.406860 561.192993,217.628403 560.133057,217.819061 
	C556.858765,218.408081 555.724365,217.598007 556.409241,213.857513 
	C557.340515,208.770798 557.382935,203.521317 558.151367,198.198608 
	C559.543762,199.041153 560.591248,200.026733 561.367249,200.756897 
	C563.376038,198.920776 565.122131,197.145050 567.064026,195.618454 
	C568.195007,194.729324 569.580566,193.861313 570.955322,193.646088 
	C574.115356,193.151337 577.338806,193.061829 580.536560,192.807861 
	C580.711182,192.297852 580.885803,191.787857 581.060425,191.277863 
	C583.973633,194.995972 586.886780,198.714081 590.036560,202.734146 
	C588.504822,204.626312 586.900146,206.608459 584.555969,209.504166 
	C587.747009,210.103638 590.057617,210.822769 592.393555,210.917419 
	C597.320190,211.117081 599.003418,213.041458 598.123230,218.002350 
	C597.965149,218.893829 597.378662,220.259186 597.746033,220.606857 
	C600.643616,223.349091 599.562622,225.797180 597.665039,228.462708 
	C597.230286,229.073456 597.378601,230.332214 597.644470,231.170380 
	C599.163452,235.959778 599.203064,235.947205 595.959290,239.010193 
	C591.461426,238.252167 587.731262,237.623520 583.203735,236.968185 
	C581.267883,237.262802 580.129333,237.584122 578.602234,237.879608 
	C575.914978,236.526764 571.147583,238.370850 571.892456,232.780960 
	C571.595093,232.267090 571.323975,232.090042 570.583008,232.023926 
	C569.121460,232.031372 568.058472,232.036896 566.837769,231.789886 
	C566.130249,231.353302 565.580505,231.169266 564.912354,230.731766 
	C564.513794,229.994995 564.233765,229.511673 563.953613,229.028336 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M625.112488,369.387360 
	C625.420532,368.833862 625.576904,368.573700 625.771301,367.765076 
	C628.549316,360.499573 631.039001,353.650055 633.777893,346.901672 
	C634.485535,345.158203 635.629578,343.105560 637.161072,342.260895 
	C647.979980,336.293854 649.310608,325.243622 652.447754,314.782349 
	C653.396851,313.668457 653.966675,312.600647 654.835938,311.909424 
	C659.880859,307.897705 665.067993,304.062561 670.061584,299.989319 
	C673.167786,297.455536 676.016907,294.606720 678.981445,291.899261 
	C682.006348,289.183472 685.459717,286.805939 687.941833,283.661682 
	C690.706055,280.160217 692.460022,275.879761 694.895142,272.093628 
	C696.579041,269.475525 698.383850,266.811920 700.637756,264.707489 
	C706.682190,259.063904 713.017273,253.732407 719.167603,248.199890 
	C719.677673,247.741043 719.664673,246.700623 720.212646,245.482666 
	C721.865112,244.725052 723.199463,244.415146 724.533875,244.105255 
	C724.356995,247.418427 724.180115,250.731583 723.638062,254.570969 
	C721.452148,256.628540 719.631348,258.159912 717.486572,259.807556 
	C709.104980,265.010498 702.745544,271.075470 700.980713,281.278931 
	C700.360962,284.862183 697.173523,288.542969 694.208862,291.061005 
	C688.795410,295.658875 682.593445,299.314850 676.871704,303.567383 
	C671.768005,307.360596 666.868713,311.428802 661.503296,315.474060 
	C660.295410,316.938202 659.196838,318.209961 658.676819,319.685638 
	C656.211487,326.681915 653.903931,333.733795 651.222046,340.859406 
	C643.067749,345.052399 638.228271,351.480835 635.682800,360.009125 
	C632.437073,359.785828 631.283813,360.977783 630.867188,363.925629 
	C630.354492,367.553680 629.414307,371.379547 624.700806,372.057190 
	C624.839966,371.296631 624.979126,370.536041 625.112488,369.387360 
z"
      />
      <path
        fill="#0F181C"
        opacity="1.000000"
        stroke="none"
        d="
M468.088623,259.172852 
	C466.945251,260.663452 465.801910,262.154083 464.064117,263.845978 
	C462.337433,264.380005 461.205200,264.712799 459.645020,265.028992 
	C457.795380,265.022095 456.373627,265.031738 454.533752,265.036804 
	C450.733582,264.714050 451.003479,267.052887 451.007507,269.253479 
	C451.019470,275.761108 451.000854,282.268768 450.585022,288.837219 
	C448.799347,288.867554 447.422821,288.837128 446.022186,288.370300 
	C445.487640,280.352234 444.977234,272.770630 444.466797,265.188995 
	C443.852753,265.105377 443.238708,265.021790 442.624664,264.938171 
	C442.098389,266.764008 441.184906,268.575470 441.116638,270.418243 
	C440.889954,276.538666 440.967194,282.670410 440.547211,288.848846 
	C438.729950,288.638428 437.293304,288.376953 435.895447,287.640991 
	C435.466644,280.144562 436.865906,272.893524 434.064484,266.158051 
	C433.433868,266.153442 432.803253,266.148804 432.172668,266.144196 
	C431.761322,273.412048 431.350006,280.679901 430.533051,288.041229 
	C428.479919,288.030945 426.832428,287.927185 425.205872,287.410522 
	C425.527557,281.020233 425.916779,275.044647 426.039795,269.063568 
	C426.059723,268.094421 424.898132,267.100983 424.282684,266.118774 
	C423.216309,266.911194 421.988831,267.566620 421.150177,268.552673 
	C420.718414,269.060333 420.979065,270.156860 420.488892,271.004883 
	C419.171936,271.093719 418.292938,271.164886 417.329285,270.846375 
	C418.208191,265.592041 415.654236,264.270142 411.403473,264.657227 
	C409.179077,262.337341 406.954651,260.017487 405.002014,257.390503 
	C406.198669,256.768066 407.123535,256.452789 408.512329,256.177124 
	C415.594452,255.906586 422.212616,255.596420 429.199402,255.466431 
	C430.656494,255.613556 431.744995,255.580536 433.283112,255.697968 
	C437.087036,255.839554 440.441345,255.830673 444.265808,255.897125 
	C451.446564,256.302826 458.164368,256.539551 464.860687,257.055267 
	C465.984375,257.141785 467.014984,258.436401 468.088623,259.172852 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M678.595947,291.877686 
	C676.016907,294.606720 673.167786,297.455536 670.061584,299.989319 
	C665.067993,304.062561 659.880859,307.897705 654.835938,311.909424 
	C653.966675,312.600647 653.396851,313.668457 652.030273,314.727722 
	C650.254150,314.919312 649.136475,314.945465 648.018738,314.971649 
	C645.612976,314.741089 643.207214,314.510559 640.081055,314.235596 
	C638.907654,314.221588 638.454529,314.251984 638.001465,314.282379 
	C633.790955,314.463043 631.929138,312.330231 631.264526,308.253479 
	C630.422302,303.086792 629.041199,298.007965 628.385986,292.383362 
	C644.294617,291.823669 659.709778,291.771820 675.124939,291.719971 
	C676.153442,291.765350 677.181946,291.810730 678.595947,291.877686 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M724.672180,243.663635 
	C723.199463,244.415146 721.865112,244.725052 720.186646,245.133301 
	C719.171143,244.420090 718.499695,243.608521 717.754272,242.462433 
	C719.390137,241.426712 722.626404,240.517502 722.563782,240.057907 
	C722.135925,236.918655 721.771729,233.294174 719.955139,230.922989 
	C716.505066,226.419373 712.240845,222.494446 708.058228,218.605072 
	C693.941895,205.478348 679.434753,192.767929 662.482361,183.375427 
	C651.871094,177.496277 641.075134,171.793564 629.888550,167.153152 
	C618.298828,162.345535 606.292114,158.358551 594.193115,155.002960 
	C570.775391,148.508224 546.628418,147.334824 522.645386,149.336411 
	C505.657654,150.754181 488.619293,153.692734 472.479980,160.143234 
	C464.134399,163.478729 455.476440,166.027679 446.987457,169.011200 
	C442.531982,170.577118 438.136566,172.313858 433.297363,173.933533 
	C438.444580,171.045212 443.847778,167.811234 449.599426,165.413040 
	C479.543884,152.927429 510.757507,146.338348 543.239014,146.417969 
	C570.952942,146.485916 597.743958,151.775269 623.493835,162.014191 
	C657.794922,175.653320 688.653381,194.677643 714.548950,221.242477 
	C718.245117,225.034241 721.390686,229.362686 724.969727,233.737732 
	C725.035767,237.095840 724.923157,240.158920 724.672180,243.663635 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M578.990784,237.905426 
	C580.129333,237.584122 581.267883,237.262802 582.776306,237.009659 
	C583.782715,245.586212 584.678284,254.087784 584.903198,262.607056 
	C584.973694,265.278503 583.239380,267.997620 582.205322,271.068878 
	C578.227661,267.396912 574.422119,264.996979 572.177856,261.573547 
	C567.885193,255.025421 564.858337,253.354767 557.101196,254.309830 
	C554.569397,254.621567 551.776489,253.605774 549.226318,252.804733 
	C544.423523,251.296127 539.709839,249.503799 534.960327,247.826035 
	C534.037170,247.499908 532.864319,247.410965 532.241760,246.781937 
	C528.883362,243.388718 525.439880,242.404358 520.541870,243.925674 
	C518.837402,244.455109 515.587646,241.255676 513.585022,239.225281 
	C511.624237,237.237274 510.723328,234.167236 507.125824,234.184143 
	C506.808655,234.185638 506.483459,232.488434 506.297424,231.209808 
	C508.975098,232.078171 510.683258,234.270645 514.140198,230.727188 
	C516.628967,228.176163 518.267090,232.493225 518.643311,235.845856 
	C517.287109,239.933075 519.005615,241.089371 522.135010,241.048920 
	C526.588379,240.991364 531.127625,240.347305 534.461975,244.575577 
	C535.147278,245.444687 536.900085,245.470032 538.159302,245.888916 
	C540.927673,246.809784 543.661377,248.352203 546.471008,248.504883 
	C550.263672,248.710968 551.134155,254.046661 556.343201,252.416351 
	C564.557068,249.845581 569.536865,252.650818 573.918457,258.839844 
	C575.344177,260.853790 577.105896,262.663910 578.909668,264.358978 
	C579.605774,265.013184 580.845520,265.089020 581.837585,265.428345 
	C582.107483,264.392181 582.699585,263.320648 582.590515,262.326050 
	C582.159424,258.394379 581.522095,254.484741 580.935486,250.570816 
	C580.302307,246.346756 579.640259,242.127045 578.990784,237.905426 
M515.220215,234.651581 
	C515.270996,234.273239 515.321777,233.894897 515.372559,233.516556 
	C515.102234,233.514648 514.831909,233.512756 514.561584,233.510864 
	C514.603516,233.889954 514.645386,234.269058 515.220215,234.651581 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M406.098297,294.428467 
	C405.363220,294.987915 404.008728,295.618011 403.894928,295.442688 
	C400.291992,289.892334 396.865417,284.227783 393.284149,278.662964 
	C391.592773,276.034851 390.712189,272.190857 385.604675,272.915283 
	C381.984039,269.736237 379.117798,266.562592 375.860504,263.860321 
	C372.070374,260.715973 367.937866,257.984406 364.110077,254.757599 
	C367.434998,250.854858 363.569519,247.452316 364.192749,243.924164 
	C364.394073,243.910736 364.796478,243.942154 364.796478,243.942154 
	C370.274170,248.487396 375.252380,253.904678 381.337250,257.389801 
	C392.739502,263.920410 396.707611,275.183746 401.882721,285.885376 
	C402.513947,287.190643 404.098145,288.035095 405.603546,289.337463 
	C405.966400,289.581757 405.885101,289.985413 405.575806,290.039856 
	C405.363342,291.063629 405.460144,292.032959 405.556976,293.002289 
	C405.723755,293.376068 405.890533,293.749847 406.098297,294.428467 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M468.477661,259.007629 
	C467.014984,258.436401 465.984375,257.141785 464.860687,257.055267 
	C458.164368,256.539551 451.446564,256.302826 444.286743,255.592712 
	C443.552002,254.444366 443.266571,253.675751 443.384827,252.921936 
	C446.202423,252.707413 448.616333,252.478104 451.231689,252.439270 
	C451.988190,252.063797 452.543213,251.497833 453.502533,250.931183 
	C454.400208,250.903473 455.288910,250.980270 455.327332,250.833832 
	C455.853760,248.828415 456.411987,246.804672 456.583954,244.753723 
	C456.621674,244.303970 455.181458,243.730301 454.421875,243.213684 
	C453.930359,244.789017 453.325989,246.340790 452.990387,247.948654 
	C452.794250,248.888046 453.027466,249.917068 452.748352,250.926758 
	C452.005127,250.927963 451.581024,250.908173 451.079956,250.688965 
	C451.002960,250.489563 450.888031,250.077789 450.941345,249.618713 
	C450.974182,246.090103 450.953735,243.020584 450.810974,239.615204 
	C449.161377,238.811676 447.634125,238.343979 445.846039,237.665588 
	C444.705688,237.187424 443.826111,236.919937 441.929016,236.343002 
	C444.868530,236.081467 446.748962,235.914154 448.945374,235.718735 
	C448.623474,234.010406 448.356537,232.593887 448.089600,231.177383 
	C450.635254,232.805130 453.171936,234.447083 455.729950,236.055191 
	C457.220856,236.992477 458.745789,237.875565 460.856079,239.048813 
	C462.964905,239.247559 464.473083,239.180527 465.981262,239.113495 
	C469.306519,238.804077 470.864899,240.137939 470.449341,243.632034 
	C469.847412,248.693329 469.387299,253.771484 468.477661,259.007629 
M464.582092,244.385132 
	C461.053040,242.793274 461.053040,242.793274 460.664459,250.639114 
	C466.276978,252.007523 464.804443,247.966583 464.582092,244.385132 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M514.485474,176.040436 
	C514.276794,179.401138 516.933838,179.769363 519.141907,180.189056 
	C523.006042,180.923508 526.049133,181.901199 524.430115,186.977982 
	C524.130554,187.917404 525.240479,189.306381 525.914612,191.040039 
	C524.503662,191.697693 523.098267,192.461838 521.616150,193.023804 
	C516.538940,194.948944 515.518677,197.305161 518.646362,201.652176 
	C521.149658,205.131348 520.497864,206.769424 516.646362,208.246475 
	C514.546326,209.051834 512.829773,210.857483 510.853333,212.274353 
	C505.994049,207.068680 506.215088,201.399612 511.738556,196.853668 
	C515.660156,193.626068 514.883789,188.398788 510.793335,185.628418 
	C506.229736,182.537613 501.550293,183.829529 496.410553,183.866150 
	C496.665924,182.915649 497.249542,181.422073 498.020660,181.318024 
	C503.885834,180.526627 509.636841,181.024918 514.333191,185.051193 
	C515.670227,186.197464 516.082642,188.384338 517.051208,190.015549 
	C517.487915,190.750992 518.222290,191.761307 518.869202,191.797546 
	C519.563538,191.836472 520.602722,191.036728 520.992004,190.328461 
	C523.232544,186.251907 521.287598,183.949356 517.573181,182.172089 
	C515.197998,181.035629 511.238525,180.391983 514.485474,176.040436 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M679.537842,259.072144 
	C674.967773,258.694000 670.756226,258.133698 666.252563,256.853577 
	C666.028931,255.020538 666.097351,253.907349 666.485474,252.644165 
	C667.531494,250.708649 668.776550,248.915558 668.750549,247.141052 
	C668.738831,246.335083 666.209351,245.565918 664.846191,244.409729 
	C666.225281,242.747162 667.580200,241.454956 668.935120,240.162750 
	C672.710938,240.162766 676.486755,240.162766 681.358459,240.162766 
	C680.823547,247.014038 680.359924,252.952026 679.537842,259.072144 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M614.319031,250.923187 
	C614.063477,241.520325 611.681396,240.115479 623.808777,239.975449 
	C624.607300,239.966232 625.401672,239.590042 626.900085,239.043228 
	C629.518677,238.182236 631.435181,237.662567 633.165039,237.422119 
	C633.705750,238.132767 634.421387,238.915970 635.162109,238.940567 
	C641.691345,239.157257 648.225159,239.239044 654.758667,239.660187 
	C653.376038,241.117432 651.992249,242.275253 651.362610,242.802078 
	C649.060974,242.305939 647.273926,241.920731 645.142334,241.461243 
	C645.142334,242.994110 645.142334,244.127792 645.123108,245.435364 
	C645.103882,245.609268 644.974487,245.934402 644.568665,245.953247 
	C643.078979,245.988007 641.995056,246.003922 640.695251,245.701462 
	C638.833130,245.587067 637.186951,245.791016 635.197021,246.004150 
	C633.936279,246.010971 633.019226,246.008606 631.844238,245.704712 
	C629.879089,245.600372 628.171814,245.797546 626.136230,246.000122 
	C624.932312,246.009613 624.056763,246.013672 622.905273,245.746826 
	C616.636963,243.688507 619.452942,248.904785 617.877869,250.961578 
	C616.424561,250.957718 615.371826,250.940460 614.319031,250.923187 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M432.833496,255.547516 
	C431.744995,255.580536 430.656494,255.613556 429.075867,255.164337 
	C421.381531,254.209457 414.179321,253.736847 405.929596,253.195480 
	C407.294678,255.090897 407.671539,255.614197 408.048431,256.137482 
	C407.123535,256.452789 406.198669,256.768066 404.898865,257.049713 
	C404.116974,255.656479 403.709930,254.296906 403.712402,252.520172 
	C406.638000,249.388947 407.509003,246.821121 403.462891,244.690445 
	C402.241669,240.737732 404.331848,239.412613 407.817749,239.259644 
	C409.913116,239.167709 412.012360,239.164505 414.791840,239.401581 
	C420.961914,239.807129 426.450012,239.932510 431.950745,240.420654 
	C432.389679,241.595810 432.815979,242.408203 433.152405,243.634186 
	C433.051758,246.018494 433.041046,247.989227 433.023346,250.342316 
	C433.022308,251.490067 433.028229,252.255447 433.039978,253.340271 
	C432.975006,254.289001 432.904266,254.918259 432.833496,255.547516 
M427.081146,248.231308 
	C426.706512,246.759216 426.331909,245.287140 425.853851,243.159592 
	C424.924957,242.747635 423.996063,242.335663 422.587006,241.529160 
	C421.178345,242.086151 419.769714,242.643158 417.784302,243.385803 
	C416.784149,243.347427 415.784027,243.309052 413.953156,242.955002 
	C411.657959,242.529755 409.362732,242.104523 407.067535,241.679291 
	C407.010956,241.956512 406.954376,242.233749 406.897797,242.510971 
	C408.523682,242.900742 410.149567,243.290497 411.350250,243.578339 
	C410.546326,246.709381 409.869141,249.346802 409.199219,251.991653 
	C412.989624,251.991653 416.784546,252.102203 420.568726,251.948669 
	C422.711243,251.861755 424.836151,251.341370 426.968079,250.360184 
	C426.980438,249.923477 426.992767,249.486755 427.081146,248.231308 
M430.489471,248.849960 
	C430.894409,247.381683 431.299347,245.913422 431.704285,244.445160 
	C430.958862,244.366791 430.213440,244.288437 429.468048,244.210068 
	C429.564819,245.683014 429.661621,247.155960 430.489471,248.849960 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M654.757568,239.360748 
	C648.225159,239.239044 641.691345,239.157257 635.162109,238.940567 
	C634.421387,238.915970 633.705750,238.132767 633.554260,237.417419 
	C637.799011,236.418640 641.450806,235.262024 645.142090,235.117722 
	C648.586426,234.983063 651.156067,234.055252 652.968323,231.147598 
	C659.663696,231.197586 665.383301,233.054947 668.759399,239.870560 
	C667.580200,241.454956 666.225281,242.747162 664.590698,244.473511 
	C664.136108,244.926270 663.961182,244.944916 663.502197,244.808807 
	C662.955688,243.189804 662.693176,241.725540 662.362793,239.882202 
	C660.155762,239.730881 657.456665,239.545822 654.757568,239.360748 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M411.288086,265.102905 
	C415.654236,264.270142 418.208191,265.592041 417.287476,271.203247 
	C417.161041,274.957245 416.991791,277.964691 416.642365,281.380035 
	C416.348724,283.843018 416.235229,285.898102 415.686890,287.988037 
	C413.251312,287.964294 411.250549,287.905670 409.249817,287.847046 
	C409.890778,280.414215 410.531738,272.981415 411.288086,265.102905 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M667.971680,289.485596 
	C667.657776,283.777496 667.495300,278.055573 666.976196,272.366211 
	C666.635620,268.632568 667.723816,266.357269 672.031006,265.923157 
	C673.240173,273.278229 674.089172,280.679260 674.610352,288.520935 
	C673.837036,289.193329 673.391479,289.425018 672.529175,289.682556 
	C670.732117,289.634094 669.351929,289.559845 667.971680,289.485596 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M409.016113,288.128967 
	C411.250549,287.905670 413.251312,287.964294 416.041565,288.080444 
	C417.553223,288.107574 418.275360,288.077209 419.308502,288.128906 
	C420.024048,288.078796 420.428650,287.946564 421.268738,287.826721 
	C422.864471,287.833862 424.024689,287.828644 425.184937,287.823425 
	C426.832428,287.927185 428.479919,288.030945 430.943176,288.071808 
	C433.124847,288.044434 434.490784,288.079956 435.856689,288.115479 
	C437.293304,288.376953 438.729950,288.638428 440.971436,288.912109 
	C443.199646,288.885101 444.622955,288.845886 446.046295,288.806702 
	C447.422821,288.837128 448.799347,288.867554 451.024536,288.899078 
	C453.959625,288.912476 456.046082,288.924744 458.132568,288.937012 
	C458.123352,289.391785 458.114166,289.846527 458.043762,290.638794 
	C440.940308,290.861359 423.898041,290.746460 406.391083,290.428162 
	C405.926361,290.224792 405.885101,289.985413 405.885101,289.985413 
	C405.885101,289.985413 405.966400,289.581757 406.002686,289.380981 
	C406.953461,288.923767 407.867950,288.667358 409.016113,288.128967 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M667.548340,289.550598 
	C669.351929,289.559845 670.732117,289.634094 672.838989,289.790070 
	C674.002441,289.860168 674.439392,289.848572 674.876282,289.836975 
	C674.935303,290.255432 674.994324,290.673889 675.089111,291.406158 
	C659.709778,291.771820 644.294617,291.823669 628.413086,291.963074 
	C625.733154,290.883789 625.378601,289.713654 628.235718,289.300964 
	C630.493103,288.974915 632.829224,289.194214 636.004761,289.140869 
	C638.607544,289.060669 640.335876,289.010864 642.064270,288.961090 
	C643.146667,289.078735 644.229004,289.196381 646.127380,289.253418 
	C648.603943,289.156769 650.264587,289.120667 651.925171,289.084564 
	C653.003479,289.247650 654.081726,289.410736 655.841248,289.667480 
	C656.756653,289.687592 656.990906,289.614044 657.632935,289.563904 
	C659.381714,289.482208 660.722839,289.377075 662.063904,289.271942 
	C663.750977,289.386505 665.437988,289.501068 667.548340,289.550598 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M652.684692,230.853821 
	C651.156067,234.055252 648.586426,234.983063 645.142090,235.117722 
	C641.450806,235.262024 637.799011,236.418640 633.740845,237.138184 
	C631.435181,237.662567 629.518677,238.182236 627.253052,238.845428 
	C628.849426,236.758209 630.480530,233.078171 632.800842,232.574707 
	C639.179688,231.190674 645.847595,231.138947 652.684692,230.853821 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M417.900757,235.929169 
	C421.955719,228.805130 429.528931,230.755219 435.687744,229.200699 
	C437.784271,228.671478 440.195038,229.387161 442.569489,230.198425 
	C441.093658,231.891739 439.639191,233.367874 437.903717,233.866867 
	C432.386200,235.453308 425.939362,233.183975 420.805206,237.935043 
	C419.605713,237.282135 418.753235,236.605667 417.900757,235.929169 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M421.152222,237.911469 
	C425.939362,233.183975 432.386200,235.453308 437.903717,233.866867 
	C439.639191,233.367874 441.093658,231.891739 442.817078,230.524551 
	C444.461090,230.367142 445.964813,230.548019 447.779053,230.953140 
	C448.356537,232.593887 448.623474,234.010406 448.945374,235.718735 
	C446.748962,235.914154 444.868530,236.081467 441.929016,236.343002 
	C443.826111,236.919937 444.705688,237.187424 445.453003,237.752594 
	C443.232635,238.351440 441.144531,238.652618 438.753174,238.661713 
	C432.684021,238.216919 426.918121,238.064194 421.152222,237.911469 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M614.225037,251.256699 
	C615.371826,250.940460 616.424561,250.957718 618.132446,251.200378 
	C624.660278,253.204483 622.324585,248.314392 623.181152,246.017731 
	C624.056763,246.013672 624.932312,246.009613 626.190918,246.427124 
	C626.917908,248.833923 625.625122,252.148941 629.388977,251.528656 
	C630.469666,251.350555 631.133545,248.567093 631.954224,246.960617 
	C632.093323,246.688370 632.057312,246.326645 632.102173,246.006256 
	C633.019226,246.008606 633.936279,246.010971 635.281860,246.438599 
	C635.351501,250.754883 636.551392,252.658585 641.141296,250.822464 
	C642.716125,250.906357 643.862000,250.954758 645.121338,251.211594 
	C645.446411,251.674179 645.714783,251.831772 645.933594,252.159042 
	C645.540466,252.675949 645.253601,252.926605 644.506836,253.130157 
	C637.682800,253.380615 631.318726,253.678207 624.576294,253.970917 
	C623.437683,253.991669 622.677490,254.017288 621.482971,254.047684 
	C619.012451,254.042984 616.976257,254.033524 614.940002,254.024048 
	C614.670349,253.212753 614.400696,252.401474 614.225037,251.256699 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M640.005066,257.413086 
	C638.790588,258.276489 637.673828,259.644379 636.342041,259.902466 
	C633.182922,260.514709 629.850830,260.305359 626.738892,261.053101 
	C625.584961,261.330353 624.850891,263.354767 623.488159,265.064301 
	C622.009705,265.390106 620.968506,265.234039 619.927307,265.078003 
	C619.042419,263.585785 618.157532,262.093597 617.081787,259.909241 
	C616.918884,258.628693 616.946777,258.040314 617.395630,257.577332 
	C624.521301,257.401917 631.226074,257.101105 638.266418,256.936768 
	C639.069702,257.186554 639.537354,257.299835 640.005066,257.413086 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M459.473816,216.929321 
	C460.449432,210.133743 459.157837,209.023773 449.396301,208.982071 
	C453.117706,205.099884 456.719574,204.847015 460.393738,209.096939 
	C463.259186,212.411423 465.993378,214.911118 470.693451,214.239151 
	C471.291779,214.153625 472.056183,215.229858 472.513306,216.982986 
	C468.320343,216.982986 464.127411,216.982986 459.473816,216.929321 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M535.951599,176.673370 
	C529.778992,167.651306 522.645081,173.016846 515.329407,175.789429 
	C517.658569,170.788864 529.995117,167.486496 534.377502,170.981796 
	C535.559021,171.924149 535.478210,174.449066 535.951599,176.673370 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M485.899353,195.142700 
	C485.839600,196.363419 485.779846,197.584137 485.444977,199.366135 
	C485.140228,200.290054 485.110596,200.652710 485.080933,201.015350 
	C484.648285,201.882599 484.215668,202.749832 483.141144,203.544464 
	C481.274628,204.324020 479.300812,204.979935 479.013336,206.077545 
	C478.646362,207.478607 479.641174,209.236374 480.049042,210.840393 
	C480.196960,211.155182 480.344910,211.469955 480.525238,212.040863 
	C478.870605,211.723389 477.183624,211.149780 475.496643,210.576172 
	C476.635345,207.638275 477.007446,203.074905 479.072418,202.101013 
	C483.365051,200.076538 483.091888,197.150772 483.074799,193.299988 
	C483.437500,192.938721 483.755005,193.018021 484.382324,193.481049 
	C485.094513,194.290756 485.496948,194.716736 485.899353,195.142700 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M552.641846,177.049011 
	C548.717834,181.520905 543.325684,183.138245 537.059326,183.425278 
	C536.652954,181.336044 536.314880,179.598099 535.937561,177.465851 
	C540.137329,180.602646 544.394958,180.821304 548.891602,177.421707 
	C549.666260,176.836060 551.100586,177.122986 552.641846,177.049011 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M500.030121,220.943848 
	C500.030121,220.943863 500.148712,221.428452 500.129944,221.677063 
	C497.990143,220.895645 495.437988,220.306427 493.838989,218.742630 
	C490.642853,215.616821 487.145142,214.410492 482.790863,214.877319 
	C482.045197,214.957245 481.172791,213.854675 480.516418,212.896729 
	C482.161133,212.538269 483.648407,212.581451 485.923706,212.657349 
	C488.183533,212.592087 489.655243,212.494141 491.126984,212.396210 
	C492.440094,213.564590 493.753204,214.732986 495.447266,216.332275 
	C496.141663,216.963013 496.455170,217.162842 496.768646,217.362686 
	C497.197693,217.913803 497.626770,218.464905 498.364441,219.448730 
	C499.125427,220.235580 499.577789,220.589722 500.030121,220.943848 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M420.805206,237.935059 
	C426.918121,238.064194 432.684021,238.216919 438.731750,238.919617 
	C438.992706,239.640732 438.971771,239.811844 438.516876,239.977539 
	C436.034637,240.000702 433.986389,240.029312 431.938110,240.057907 
	C426.450012,239.932510 420.961914,239.807129 415.240784,239.414185 
	C415.768341,238.157745 416.528931,237.168839 417.595154,236.054565 
	C418.753235,236.605667 419.605713,237.282135 420.805206,237.935059 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M493.931702,183.528625 
	C490.261627,183.071945 486.552460,182.244370 482.318115,181.242981 
	C481.540802,181.005249 481.284729,180.974838 481.024658,180.977966 
	C481.114044,179.851166 481.203430,178.724380 481.326294,177.175583 
	C485.752808,179.282791 489.822723,181.220245 493.931702,183.528625 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M460.072937,265.045563 
	C461.205200,264.712799 462.337433,264.380005 463.827087,264.056335 
	C464.357452,265.901520 464.530426,267.737640 464.821747,269.958130 
	C464.960938,271.015442 464.981750,271.688324 464.987671,272.698181 
	C463.682526,273.120575 462.392334,273.205963 460.526428,272.986755 
	C459.991486,270.136597 460.032227,267.591095 460.072937,265.045563 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M437.521057,203.375015 
	C435.982239,203.902237 434.800323,204.311859 433.618408,204.721481 
	C433.240997,204.357468 432.863617,203.993439 432.486206,203.629425 
	C433.729065,202.109131 435.044556,199.270584 436.200104,199.334290 
	C438.864960,199.481171 441.452148,201.037079 444.070862,202.021347 
	C443.873932,202.594498 443.677002,203.167664 443.480103,203.740814 
	C441.612701,203.579681 439.745331,203.418549 437.521057,203.375015 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M448.602539,209.021912 
	C447.820343,213.866287 444.183899,211.871689 441.359253,211.476822 
	C439.641022,211.236618 438.040161,210.157288 436.147430,209.154297 
	C438.211334,208.881317 440.514618,208.896545 442.817352,208.940445 
	C444.622925,208.974869 446.427826,209.044830 448.602539,209.021912 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M619.897400,265.471008 
	C620.968506,265.234039 622.009705,265.390106 623.447510,265.496582 
	C624.183777,266.419037 624.523499,267.391052 624.669373,268.924438 
	C624.368103,270.349854 624.260681,271.213898 624.153259,272.077911 
	C623.677063,272.090118 623.200867,272.102295 622.367493,272.085815 
	C621.339905,271.803772 620.669434,271.550354 619.710388,271.285828 
	C619.570374,269.471130 619.718933,267.667603 619.897400,265.471008 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M616.974670,257.451904 
	C616.946777,258.040314 616.918884,258.628693 616.866272,259.658447 
	C616.186890,258.343445 615.532166,256.587097 614.908691,254.427399 
	C616.976257,254.033524 619.012451,254.042984 621.447021,254.392227 
	C620.221741,255.638641 618.598206,256.545288 616.974670,257.451904 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M403.311676,245.150879 
	C407.509003,246.821121 406.638000,249.388947 403.760925,252.193115 
	C403.320099,250.059250 403.240295,247.835281 403.311676,245.150879 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M482.685059,189.046844 
	C482.613647,189.562668 482.542236,190.078476 482.400635,191.028076 
	C482.330444,191.461868 482.484406,191.808182 482.484406,191.808182 
	C482.646271,191.954407 482.808105,192.100616 483.050262,192.563568 
	C479.562744,191.295181 479.786377,188.436508 480.915161,185.142426 
	C481.543823,185.087662 481.867401,185.266769 482.278381,185.972687 
	C482.472198,187.348602 482.578644,188.197723 482.685059,189.046844 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M377.348999,229.960297 
	C378.832947,228.044037 380.651978,226.065933 382.836029,224.093536 
	C381.362061,226.032318 379.523071,227.965393 377.348999,229.960297 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M394.462341,217.012283 
	C395.934113,213.698029 398.327972,214.533829 400.894348,216.531296 
	C398.946259,216.947327 396.920502,216.998642 394.462341,217.012283 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M503.005798,225.356369 
	C505.910736,225.623413 506.710541,227.541702 506.088318,230.633102 
	C504.974792,229.257828 503.985779,227.496780 503.005798,225.356369 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M449.422668,216.977509 
	C450.230743,214.111298 451.909210,214.298233 453.918213,216.553299 
	C452.604462,216.940369 451.220551,216.978867 449.422668,216.977509 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M465.751770,238.868622 
	C464.473083,239.180527 462.964905,239.247559 461.234863,239.058472 
	C462.516113,238.742813 464.019196,238.683289 465.751770,238.868622 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M364.886353,243.596359 
	C364.796478,243.942154 364.394073,243.910736 363.923462,243.821106 
	C362.956970,243.159882 362.461121,242.588287 361.965302,242.016693 
	C362.852386,241.707306 363.739471,241.397919 364.991821,241.115891 
	C365.230164,241.845688 365.103210,242.548126 364.886353,243.596359 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M508.702942,271.090881 
	C508.180023,271.744720 507.347931,272.265045 506.236359,272.896423 
	C506.769165,272.324097 507.581482,271.640747 508.702942,271.090881 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M502.956635,224.070389 
	C502.956635,224.070389 503.036316,224.524353 503.030518,224.754730 
	C502.020630,224.205704 501.016571,223.426300 500.045685,222.266937 
	C500.078857,221.886993 500.542450,221.886032 500.834473,222.242447 
	C501.736542,223.089371 502.346588,223.579880 502.956635,224.070389 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M385.401062,222.149323 
	C385.810669,221.494995 386.527405,220.754501 387.607849,220.007370 
	C387.217102,220.688202 386.462646,221.375671 385.401062,222.149323 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M480.982788,181.320328 
	C481.284729,180.974838 481.540802,181.005249 481.927979,181.206848 
	C481.919098,181.751587 481.775146,182.158661 481.386475,182.784821 
	C481.074829,182.556854 481.007874,182.109772 480.982788,181.320328 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M674.903809,289.605133 
	C674.439392,289.848572 674.002441,289.860168 673.255737,289.764221 
	C673.391479,289.425018 673.837036,289.193329 674.539673,288.943909 
	C674.796814,288.926147 674.931396,289.373291 674.903809,289.605133 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M376.231262,230.933945 
	C376.090912,230.685532 376.282745,230.418732 376.792419,230.112793 
	C376.837433,230.289139 376.655151,230.569778 376.231262,230.933945 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M368.596069,219.960297 
	C367.219849,222.825500 366.042480,226.323364 363.667786,228.536377 
	C360.347748,231.630341 359.551117,235.008484 359.659760,239.581024 
	C359.086273,240.057281 358.853973,240.063568 358.621704,240.069839 
	C358.448639,237.630585 358.275604,235.191315 357.997070,232.330383 
	C361.347961,227.945694 364.804291,223.982681 368.596069,219.960297 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M400.406860,193.791840 
	C400.337738,194.728333 400.203217,196.048965 399.475861,196.639832 
	C394.422516,200.744812 389.269257,204.728882 384.075623,208.655930 
	C383.515594,209.079391 382.491913,208.889572 381.296570,208.955017 
	C387.295563,203.896606 393.681335,198.867432 400.406860,193.791840 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M417.415833,182.721970 
	C416.154175,184.321274 414.761261,186.292557 412.876007,187.486420 
	C409.239746,189.789062 405.325348,191.652542 401.153168,193.767868 
	C406.207428,190.139343 411.634766,186.441040 417.415833,182.721970 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M380.586792,208.942368 
	C379.900146,215.371201 374.342438,217.235779 369.276611,219.955444 
	C372.683594,216.281769 376.465454,212.634613 380.586792,208.942368 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M432.532715,173.874542 
	C432.763519,174.477478 432.833252,175.476593 432.471466,175.670456 
	C427.860382,178.141373 423.187378,180.496796 418.132294,182.780609 
	C422.546692,179.751923 427.358917,176.824203 432.532715,173.874542 
z"
      />
      <path
        fill="#30655D"
        opacity="1.000000"
        stroke="none"
        d="
M420.267609,175.454712 
	C419.420837,176.534500 418.314667,177.386841 417.208527,178.239182 
	C416.883759,177.603577 416.558990,176.967957 416.234222,176.332352 
	C417.492218,175.963989 418.750244,175.595642 420.267609,175.454712 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M603.263062,357.047455 
	C603.390198,357.425110 603.517273,357.802765 603.186340,358.689697 
	C602.153137,362.331879 601.101074,365.464783 601.100830,368.597778 
	C601.100403,375.402924 601.637024,382.208099 601.954163,389.013245 
	C601.954163,397.344025 601.954163,405.674774 601.954163,414.005554 
	C601.363159,414.014954 600.772156,414.024384 600.181213,414.033783 
	C600.112183,412.944519 600.043152,411.855225 599.983643,409.919312 
	C599.832764,386.087891 599.672546,363.103088 599.512268,340.118256 
	C599.013062,340.121216 598.513916,340.124146 598.014709,340.127075 
	C598.014709,363.418976 598.014709,386.710907 598.014709,410.002838 
	C597.821777,411.767975 597.628906,413.533081 597.435974,415.298218 
	C597.068176,415.272583 596.700317,415.246948 596.332520,415.221313 
	C596.221375,414.065857 596.110229,412.910431 596.003296,410.908508 
	C596.007568,386.727509 596.007568,363.392975 596.007568,340.058411 
	C595.360352,340.056427 594.713196,340.054443 594.065979,340.052460 
	C594.065979,363.710022 594.065979,387.367584 594.065979,411.025146 
	C594.023865,411.986084 593.981750,412.947021 593.939697,413.907990 
	C593.754944,413.932373 593.570251,413.956757 593.385498,413.981140 
	C593.242371,413.225037 593.099304,412.468964 592.965332,410.898041 
	C592.974487,387.092957 592.974487,364.102722 592.974487,341.112488 
	C592.333618,341.102356 591.692749,341.092224 591.051941,341.082092 
	C590.947449,364.386993 590.993042,387.695190 591.021240,411.002991 
	C590.823547,412.421356 590.625854,413.839691 590.428162,415.258057 
	C590.022766,415.232269 589.617371,415.206512 589.211975,415.180756 
	C589.139832,413.718445 589.067749,412.256134 589.000610,409.929932 
	C589.005493,386.269867 589.005493,363.473755 589.005493,340.677643 
	C588.663086,340.672089 588.320679,340.666534 587.978333,340.660980 
	C587.667847,364.107971 587.357300,387.554962 587.046814,411.001953 
	C586.969299,412.480682 586.891846,413.959381 586.814331,415.438110 
	C586.368530,415.467499 585.922729,415.496918 585.476929,415.526306 
	C585.317627,414.280304 585.158386,413.034271 585.002014,410.924500 
	C585.004883,387.031403 585.004883,364.002106 585.004883,340.972778 
	C584.665833,340.967651 584.326843,340.962494 583.987793,340.957367 
	C583.987793,364.300201 583.987793,387.643036 583.987793,410.985870 
	C583.719971,411.855347 583.452209,412.724854 582.976013,414.271271 
	C582.527588,413.066803 582.259338,412.346191 581.993896,410.845764 
	C581.996765,387.384003 581.996765,364.702087 581.996765,342.020142 
	C581.341858,342.018036 580.686890,342.015900 580.031982,342.013763 
	C580.031982,365.011536 580.031982,388.009308 580.031982,411.007080 
	C580.031982,412.767639 580.031982,414.528198 580.031982,416.288788 
	C579.513306,416.327881 578.994629,416.367004 578.475952,416.406097 
	C578.322449,414.224701 578.168945,412.043274 578.015076,408.977966 
	C578.338562,403.974274 578.913269,399.856232 578.941956,395.734406 
	C579.056702,379.258942 579.029724,362.782227 578.968506,346.306274 
	C578.962097,344.576019 578.383118,342.847839 578.069824,341.118713 
	C578.069824,341.118713 577.825989,340.790558 577.707520,340.578186 
	C577.588989,340.365845 577.539429,340.269745 577.539429,340.269745 
	C577.620361,340.074585 577.701294,339.879395 577.834351,339.372803 
	C585.629639,338.077148 593.372742,337.092926 601.378784,336.096161 
	C601.764526,337.460663 601.887329,338.837708 601.804810,340.718018 
	C601.730774,341.480011 601.862000,341.738678 601.993225,341.997345 
	C601.993225,341.997345 602.186768,342.281525 602.114746,342.801361 
	C602.030884,343.556702 602.019043,343.792175 602.007263,344.027649 
	C601.975586,344.200531 601.943848,344.373444 601.661987,344.948669 
	C601.551941,345.884583 601.692078,346.418182 601.832214,346.951782 
	C601.900452,348.012695 601.968628,349.073608 601.776001,350.783142 
	C601.181274,353.588898 599.565674,356.145020 603.263062,357.047455 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M497.026367,338.944336 
	C498.480011,338.935028 499.933655,338.925690 501.701569,339.442139 
	C502.002838,354.974701 501.989838,369.981567 501.976868,384.988403 
	C501.536133,394.574127 501.095398,404.159851 500.654663,413.745544 
	C500.423492,413.754211 500.192352,413.762878 499.961182,413.771545 
	C499.961182,407.166718 499.961182,400.561859 499.976593,393.018982 
	C499.992004,375.090546 499.992004,358.100189 499.992004,341.109802 
	C497.034332,358.351807 498.406311,375.705688 498.009460,393.006989 
	C498.009460,400.111603 498.009460,407.216217 498.009460,414.320831 
	C497.592682,414.379578 497.175903,414.438324 496.759125,414.497070 
	C496.506805,413.584045 496.254456,412.670990 496.004120,410.908936 
	C496.346191,386.354736 496.686279,362.649536 497.026367,338.944336 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M621.651733,430.140564 
	C625.215271,430.267151 628.384094,430.394562 631.846436,430.220337 
	C640.133362,430.611664 648.126831,431.304626 656.947021,431.997009 
	C658.528931,432.012146 659.283997,432.027863 660.039062,432.043579 
	C660.437378,432.064819 660.835632,432.086029 661.809937,432.367554 
	C664.270752,433.102631 666.136536,433.680634 668.044128,434.030792 
	C672.050781,434.766235 674.490784,436.624603 674.884521,438.503326 
	C668.434387,436.831940 661.501038,435.035309 654.567749,433.238708 
	C654.448120,433.700409 654.328491,434.162109 654.208862,434.623840 
	C657.374084,435.416718 660.571594,436.101166 663.695312,437.033173 
	C666.766052,437.949371 666.976440,439.349670 664.041626,440.692932 
	C664.052429,440.479523 664.050781,440.052216 664.223267,439.801453 
	C660.283264,438.588715 656.170837,437.626770 651.750793,436.442078 
	C639.971985,435.502258 628.500793,434.785187 616.565735,434.046906 
	C610.067932,433.352722 604.033997,432.679779 598.003967,431.692261 
	C598.009399,430.959595 598.010864,430.541534 598.012329,430.123474 
	C599.095825,430.117188 600.179321,430.110870 601.966187,430.405029 
	C606.503357,430.762695 610.337036,430.819916 614.170715,430.877136 
	C616.532837,430.631897 618.894897,430.386658 621.651733,430.140564 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M497.983215,465.011780 
	C501.834808,462.662689 505.707214,460.346924 509.531555,457.954285 
	C512.794189,455.913147 516.001465,453.783569 519.579285,451.151489 
	C519.539551,449.223358 519.550354,446.973663 518.705750,446.585510 
	C511.330505,443.196594 503.734314,440.286530 496.378021,436.860107 
	C494.941498,436.191010 493.937073,434.013794 493.346680,432.318604 
	C492.972290,431.243500 493.732239,429.773376 493.983398,428.480408 
	C495.187164,427.512177 496.390961,426.543976 498.502228,424.845856 
	C498.502228,427.446716 498.502228,428.610565 498.545410,430.236786 
	C497.855835,431.834778 497.123077,432.970459 496.390320,434.106140 
	C497.214478,434.417572 498.038635,434.729034 499.109741,435.307495 
	C502.770142,436.834564 506.233032,437.976837 509.584656,439.384247 
	C513.841858,441.171906 518.235962,442.799774 522.157898,445.177856 
	C527.235291,448.256622 527.120911,450.838593 522.219482,453.816345 
	C518.561951,456.038422 514.737793,457.986359 510.641602,460.113159 
	C506.191345,461.783936 502.087311,463.397888 497.983215,465.011780 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M515.030518,452.013489 
	C513.938171,452.378052 512.845886,452.742584 511.145752,452.890839 
	C510.252319,448.926697 507.577698,447.417389 504.516571,446.326935 
	C498.574219,444.210144 492.402100,442.589050 486.733673,439.901093 
	C482.408997,437.850372 476.857758,436.793823 475.585724,430.786438 
	C477.541290,430.039581 479.219452,429.477264 480.897614,428.914948 
	C484.001862,428.957672 487.106140,429.000366 490.583069,429.417328 
	C489.036346,431.208649 487.116974,432.625732 484.637115,434.456604 
	C486.664032,435.810333 488.131683,437.189301 489.872437,437.879517 
	C495.410950,440.075562 501.108459,441.873291 506.632172,444.103241 
	C510.370422,445.612335 514.846924,446.613831 515.030518,452.013489 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M498.862793,435.040497 
	C498.038635,434.729034 497.214478,434.417572 496.390320,434.106140 
	C497.123077,432.970459 497.855835,431.834778 498.790009,430.460327 
	C502.703857,428.780121 506.416290,427.338684 510.128693,425.897217 
	C510.487488,426.421021 510.846283,426.944794 511.205048,427.468567 
	C509.125580,428.895844 507.046082,430.323151 504.966583,431.750427 
	C505.281891,432.097382 505.597198,432.444366 505.912506,432.791351 
	C510.326111,430.986633 514.629700,428.785736 519.192566,427.518158 
	C522.173950,426.689911 525.531494,427.215302 528.346802,427.548462 
	C526.564209,428.297333 525.164185,428.677368 523.744629,428.958466 
	C519.390747,429.820648 516.859375,432.201355 516.798706,437.160278 
	C513.589478,436.868347 510.614410,436.171356 507.600342,435.760376 
	C504.708832,435.366150 501.776947,435.268494 498.862793,435.040497 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M515.401001,451.975006 
	C514.846924,446.613831 510.370422,445.612335 506.632172,444.103241 
	C501.108459,441.873291 495.410950,440.075562 489.872437,437.879517 
	C488.131683,437.189301 486.664032,435.810333 484.637115,434.456604 
	C487.116974,432.625732 489.036346,431.208649 491.017151,429.458862 
	C491.810394,428.989136 492.542267,428.852112 493.628754,428.597748 
	C493.732239,429.773376 492.972290,431.243500 493.346680,432.318604 
	C493.937073,434.013794 494.941498,436.191010 496.378021,436.860107 
	C503.734314,440.286530 511.330505,443.196594 518.705750,446.585510 
	C519.550354,446.973663 519.539551,449.223358 519.681519,450.799713 
	C518.215637,451.305176 516.993530,451.620850 515.401001,451.975006 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M598.000000,432.006836 
	C604.033997,432.679779 610.067932,433.352722 616.554504,434.372375 
	C616.997620,435.154968 616.988098,435.590790 616.531250,436.021484 
	C614.089600,435.961853 612.086670,436.007507 610.102417,435.836884 
	C595.451599,434.577209 580.808289,433.227417 566.151123,432.049377 
	C564.465881,431.913940 562.709717,432.660583 560.521729,433.004089 
	C557.927246,433.010376 555.768005,433.233948 553.674744,432.957581 
	C550.748962,432.571320 547.872375,431.812042 545.433594,431.153931 
	C549.667236,431.095459 553.442017,431.095459 557.216736,431.095459 
	C557.286011,430.650360 557.355286,430.205261 557.424561,429.760162 
	C556.028015,429.146210 554.631470,428.532257 553.234924,427.918304 
	C555.535706,427.632233 557.836426,427.346191 560.552979,427.398315 
	C561.643250,428.500732 562.317749,429.264954 562.992310,430.029175 
	C564.409851,430.043274 565.827454,430.057343 568.097656,430.103638 
	C572.313904,430.074646 575.677368,430.013428 579.040894,429.952209 
	C579.471680,429.969330 579.902405,429.986481 580.924500,430.317566 
	C587.010559,431.089935 592.505249,431.548370 598.000000,432.006836 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M553.502625,340.028229 
	C554.287903,341.118652 554.656738,342.196808 554.687988,343.637482 
	C553.905090,344.004028 553.459778,344.008057 553.002319,343.683594 
	C552.683594,342.968079 552.377014,342.581024 552.070435,342.193970 
	C552.050781,342.358154 552.013855,342.522339 552.014038,342.686493 
	C552.022339,351.449341 552.033813,360.212189 552.034058,369.445129 
	C552.017029,383.268768 552.010986,396.622345 552.004883,409.975922 
	C551.537170,410.301697 551.069397,410.627502 550.302063,410.974182 
	C550.001160,388.924255 549.989685,366.853363 550.014404,344.782532 
	C550.016846,342.605408 549.193298,339.749756 553.502625,340.028229 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M496.711029,338.911072 
	C496.686279,362.649536 496.346191,386.354736 495.998230,410.528137 
	C495.549225,410.997131 495.108124,410.997955 494.329651,410.528870 
	C494.286926,386.647064 494.581543,363.235107 494.876160,339.823181 
	C495.382690,339.508026 495.889191,339.192902 496.711029,338.911072 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M539.254395,414.887939 
	C538.995117,390.219604 538.995117,365.449432 538.995117,340.679260 
	C539.663757,340.679962 540.332458,340.680695 541.001099,340.681396 
	C541.001099,364.809845 541.001099,388.938263 540.993408,413.536011 
	C540.495056,414.265564 540.004333,414.525848 539.254395,414.887939 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M453.911255,429.519714 
	C455.892639,427.672150 457.907776,426.227509 459.948975,424.444580 
	C461.992950,424.528564 464.010773,424.950806 465.555908,425.655975 
	C462.528748,427.261292 459.974274,428.583618 457.419800,429.905975 
	C457.604706,430.276947 457.789581,430.647888 457.974487,431.018860 
	C460.940521,429.967438 463.906586,428.916046 466.872620,427.864624 
	C463.198486,432.281647 463.313690,434.199219 467.712067,436.879395 
	C468.676514,437.467072 469.827972,437.747803 470.923492,438.529236 
	C470.942566,439.615204 470.931427,440.341858 470.920349,441.068481 
	C466.966156,440.178833 462.886108,439.643738 459.093903,438.297760 
	C455.458679,437.007446 453.027985,434.329224 453.911255,429.519714 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M591.339722,411.004089 
	C590.993042,387.695190 590.947449,364.386993 591.051941,341.082092 
	C591.692749,341.092224 592.333618,341.102356 592.974487,341.112488 
	C592.974487,364.102722 592.974487,387.092957 592.952332,410.554321 
	C592.506226,411.018707 592.082214,411.011932 591.339722,411.004089 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M542.381348,413.014465 
	C542.364380,390.091461 542.662598,367.163635 543.009155,344.236542 
	C543.027344,343.030579 543.455078,341.830780 544.017151,340.737732 
	C544.017151,364.509613 544.017151,388.281525 544.013428,412.520752 
	C543.575378,412.995331 543.140991,413.002563 542.381348,413.014465 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M546.350098,412.006805 
	C546.355164,388.568909 546.686768,365.129761 547.018372,341.690643 
	C547.346191,341.695007 547.673950,341.699371 548.001770,341.703766 
	C548.001770,364.824066 548.001770,387.944397 547.992310,411.533569 
	C547.547485,412.003479 547.112061,412.004547 546.350098,412.006805 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M598.339355,410.003296 
	C598.014709,386.710907 598.014709,363.418976 598.014709,340.127075 
	C598.513916,340.124146 599.013062,340.121216 599.512268,340.118256 
	C599.672546,363.103088 599.832764,386.087891 599.977173,409.542542 
	C599.528870,410.009491 599.096375,410.006622 598.339355,410.003296 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M594.386780,411.018677 
	C594.065979,387.367584 594.065979,363.710022 594.065979,340.052460 
	C594.713196,340.054443 595.360352,340.056427 596.007568,340.058411 
	C596.007568,363.392975 596.007568,386.727509 596.000122,410.530548 
	C595.564331,411.003418 595.135925,411.007782 594.386780,411.018677 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M584.238464,410.990051 
	C583.987793,387.643036 583.987793,364.300201 583.987793,340.957367 
	C584.326843,340.962494 584.665833,340.967651 585.004883,340.972778 
	C585.004883,364.002106 585.004883,387.031403 584.997681,410.528992 
	C584.823364,410.996246 584.656250,410.995209 584.238464,410.990051 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M587.296936,410.891693 
	C587.357300,387.554962 587.667847,364.107971 587.978333,340.660980 
	C588.320679,340.666534 588.663086,340.672089 589.005493,340.677643 
	C589.005493,363.473755 589.005493,386.269867 588.997192,409.535095 
	C588.508301,410.263306 588.027710,410.522369 587.296936,410.891693 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M503.948456,339.114014 
	C504.405060,339.069397 504.861664,339.024811 505.662781,338.981598 
	C505.668427,362.338470 505.329498,385.694000 504.992249,409.516205 
	C504.993896,410.945190 504.993896,411.907471 504.993896,412.869751 
	C504.608490,412.900421 504.223083,412.931061 503.837677,412.961731 
	C503.567017,410.058746 503.183746,407.160675 503.056976,404.251404 
	C502.926727,401.263397 502.930420,398.258240 503.089691,395.272003 
	C503.256531,392.144440 503.678040,389.030518 503.993469,384.991516 
	C503.981964,369.086273 503.965210,354.100128 503.948456,339.114014 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M487.338928,410.004456 
	C487.013519,387.415283 487.013519,364.825653 487.013519,342.236053 
	C487.672943,342.235840 488.332397,342.235626 488.991821,342.235413 
	C488.991821,364.514740 488.991821,386.794037 488.978485,409.543396 
	C488.531555,410.010315 488.097961,410.007172 487.338928,410.004456 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M484.268250,405.005798 
	C484.007355,384.427795 484.007355,363.847076 484.007355,343.266388 
	C484.541382,343.240234 485.075409,343.214111 485.609436,343.187958 
	C485.740143,343.794800 485.984467,344.401520 485.985077,345.008514 
	C486.003937,363.992004 486.003693,382.975525 485.981812,401.959015 
	C485.980896,402.772217 485.746277,403.585175 485.335693,404.699829 
	C484.876984,405.001984 484.703033,405.002533 484.268250,405.005798 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M492.145905,339.865967 
	C492.145905,339.865967 492.571411,339.915558 492.772003,340.440399 
	C492.980255,356.583160 493.018127,372.201202 492.952881,387.818817 
	C492.945618,389.548187 492.349213,391.275116 492.026001,393.003174 
	C491.853973,393.003082 491.681976,393.003021 491.251892,393.002075 
	C491.005432,375.660339 491.017029,358.319489 491.029724,340.515381 
	C491.030792,340.052185 491.021942,340.016693 491.309814,339.992859 
	C491.780396,339.934662 491.963135,339.900299 492.145905,339.865967 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M535.262390,413.888733 
	C535.416077,389.894531 535.829712,365.794739 536.243286,341.694977 
	C536.500427,341.696594 536.757629,341.698212 537.014771,341.699829 
	C537.014771,365.151794 537.014771,388.603760 537.009827,412.523254 
	C536.510681,413.254913 536.016479,413.519043 535.262390,413.888733 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M498.333588,393.005981 
	C498.406311,375.705688 497.034332,358.351807 499.992004,341.109802 
	C499.992004,358.100189 499.992004,375.090546 499.972260,392.551819 
	C499.520905,393.016815 499.089325,393.010864 498.333588,393.005981 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M578.046997,341.574585 
	C578.383118,342.847839 578.962097,344.576019 578.968506,346.306274 
	C579.029724,362.782227 579.056702,379.258942 578.941956,395.734406 
	C578.913269,399.856232 578.338562,403.974274 578.012085,408.543030 
	C577.840088,408.992676 577.670654,408.993408 577.246948,408.991821 
	C577.336548,386.669830 577.680359,364.350128 578.046997,341.574585 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M529.155151,429.844421 
	C530.548767,429.658875 531.942444,429.473328 533.962097,429.523438 
	C536.381775,430.212189 538.175476,430.665222 539.814819,431.404114 
	C538.413147,432.748535 537.165710,433.807098 535.539795,434.945374 
	C534.125916,435.028503 533.090515,435.031921 531.852539,434.769043 
	C530.780151,435.030579 529.910400,435.558350 529.026367,436.429504 
	C529.005188,437.001892 528.998352,437.230896 528.605042,437.371704 
	C526.801514,437.564148 525.384460,437.844757 523.622314,438.054626 
	C519.060486,434.289368 519.260254,432.853546 524.337463,431.078369 
	C525.896545,430.533234 527.546692,430.248413 529.155151,429.844421 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M492.020813,393.471130 
	C492.349213,391.275116 492.945618,389.548187 492.952881,387.818817 
	C493.018127,372.201202 492.980255,356.583160 492.977600,340.500519 
	C493.405090,339.997101 493.827606,339.958405 494.563141,339.871460 
	C494.581543,363.235107 494.286926,386.647064 493.998718,410.527039 
	C494.001801,411.162811 493.998444,411.330475 493.667053,411.746948 
	C492.905273,411.984467 492.471527,411.973236 492.037720,411.962006 
	C492.030365,405.954376 492.022980,399.946747 492.020813,393.471130 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M503.629639,339.066345 
	C503.965210,354.100128 503.981964,369.086273 503.988434,384.542358 
	C503.533722,385.006805 503.089264,385.001312 502.310852,384.992126 
	C501.989838,369.981567 502.002838,354.974701 502.019043,339.503540 
	C502.451782,339.032379 502.881287,339.025513 503.629639,339.066345 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M602.205750,389.013977 
	C601.637024,382.208099 601.100403,375.402924 601.100830,368.597778 
	C601.101074,365.464783 602.153137,362.331879 603.091003,358.981079 
	C603.541992,368.552551 603.630310,378.341827 603.590210,388.587524 
	C603.127014,389.034180 602.792175,389.024445 602.205750,389.013977 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M580.356079,411.004944 
	C580.031982,388.009308 580.031982,365.011536 580.031982,342.013763 
	C580.686890,342.015900 581.341858,342.018036 581.996765,342.020142 
	C581.996765,364.702087 581.996765,387.384003 581.986694,410.534943 
	C581.544434,411.003571 581.112305,411.003174 580.356079,411.004944 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M532.325684,381.010925 
	C532.000061,378.298187 531.990356,375.584808 531.991394,372.871399 
	C531.994629,364.082764 532.001953,355.294098 532.007324,346.505463 
	C532.008301,344.904510 532.007507,343.303558 532.007507,341.702637 
	C532.663208,341.688721 533.318909,341.674835 533.974609,341.660950 
	C533.974609,354.472290 533.974609,367.283661 533.950928,380.567810 
	C533.500427,381.030457 533.073486,381.020355 532.325684,381.010925 
z"
      />
      <path
        fill="#D2E8C8"
        opacity="1.000000"
        stroke="none"
        d="
M552.333130,409.984802 
	C552.010986,396.622345 552.017029,383.268768 552.352478,369.453156 
	C553.107239,368.987946 553.532532,368.984802 553.957886,368.981628 
	C553.967102,382.335968 553.976379,395.690338 553.979614,409.510742 
	C553.536194,409.982391 553.098755,409.988037 552.333130,409.984802 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M470.893311,438.169891 
	C469.827972,437.747803 468.676514,437.467072 467.712067,436.879395 
	C463.313690,434.199219 463.198486,432.281647 466.872620,427.864624 
	C463.906586,428.916046 460.940521,429.967438 457.974487,431.018860 
	C457.789581,430.647888 457.604706,430.276947 457.419800,429.905975 
	C459.974274,428.583618 462.528748,427.261292 465.435303,425.952148 
	C468.608032,426.627899 471.428680,427.290405 474.635498,428.195618 
	C475.021667,428.438293 475.022766,428.898285 474.675476,428.992859 
	C467.507324,432.903656 467.507324,432.903656 472.015015,437.966827 
	C471.389771,438.067352 471.141541,438.118622 470.893311,438.169891 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M598.003967,431.692261 
	C592.505249,431.548370 587.010559,431.089935 581.246338,430.349060 
	C584.416382,428.384705 587.161987,424.561279 591.661377,426.123444 
	C593.808533,426.868988 595.715820,428.305176 597.872009,429.776001 
	C598.010864,430.541534 598.009399,430.959595 598.003967,431.692261 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M529.096252,429.518311 
	C527.546692,430.248413 525.896545,430.533234 524.337463,431.078369 
	C519.260254,432.853546 519.060486,434.289368 523.792236,438.268860 
	C524.894958,438.965912 525.482605,439.377960 525.884766,440.063782 
	C523.491272,439.254089 521.283325,438.170593 518.813354,437.046600 
	C518.374817,436.998108 518.198303,436.990173 517.769287,436.966064 
	C517.349854,436.926697 517.182861,436.903503 517.015808,436.880310 
	C516.859375,432.201355 519.390747,429.820648 523.744629,428.958466 
	C525.164185,428.677368 526.564209,428.297333 528.341309,427.931335 
	C528.818787,428.330841 528.928040,428.761505 529.096252,429.518311 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M614.119141,430.470581 
	C610.337036,430.819916 606.503357,430.762695 602.371094,430.443878 
	C602.084961,429.684326 602.004578,428.775513 602.123718,428.748596 
	C604.952759,428.108307 607.797241,427.221161 610.652832,427.170593 
	C611.773621,427.150726 612.928345,429.042725 614.119141,430.470581 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M539.969116,431.118317 
	C538.175476,430.665222 536.381775,430.212189 534.313782,429.536835 
	C534.451294,428.883270 534.863220,428.451996 535.869873,428.259674 
	C539.503967,428.296814 542.543274,428.095001 545.582520,427.893219 
	C547.940796,428.104675 550.299011,428.316101 552.946106,428.222900 
	C554.631470,428.532257 556.028015,429.146210 557.424561,429.760162 
	C557.355286,430.205261 557.286011,430.650360 557.216736,431.095459 
	C553.442017,431.095459 549.667236,431.095459 545.017822,431.120056 
	C542.751831,431.135864 541.360474,431.127106 539.969116,431.118317 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M579.036011,429.551849 
	C575.677368,430.013428 572.313904,430.074646 568.522949,430.113831 
	C568.853149,428.754211 569.792114,426.199829 570.338318,426.281219 
	C573.343262,426.728943 577.718262,423.687408 579.036011,429.551849 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M475.022766,428.898285 
	C475.022766,428.898285 475.021667,428.438293 475.027924,428.208069 
	C478.316620,426.801453 481.599060,425.625122 484.881500,424.448761 
	C485.115967,424.957703 485.350403,425.466614 485.584869,425.975555 
	C484.188263,426.801483 482.791626,427.627411 481.146301,428.684143 
	C479.219452,429.477264 477.541290,430.039581 475.503052,430.446533 
	C475.102905,429.826874 475.062836,429.362579 475.022766,428.898285 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M545.604980,427.523254 
	C542.543274,428.095001 539.503967,428.296814 536.182373,428.214600 
	C538.891602,424.531525 542.254883,425.784698 545.604980,427.523254 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M562.991089,429.670166 
	C562.317749,429.264954 561.643250,428.500732 560.975220,427.413361 
	C561.651123,427.830536 562.320496,428.570831 562.991089,429.670166 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M492.049622,412.281372 
	C492.471527,411.973236 492.905273,411.984467 493.664642,411.998474 
	C493.920013,412.782745 493.849762,413.564209 493.686462,415.381165 
	C492.805054,413.873016 492.433258,413.236877 492.049622,412.281372 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M536.580688,635.571411 
	C534.307373,637.114929 532.034058,638.658386 529.264587,640.538757 
	C530.047363,635.290649 530.470459,630.589417 531.546021,626.042542 
	C532.071045,623.823242 533.538696,622.330139 536.765381,623.547791 
	C539.160278,624.451599 542.240479,623.358154 544.950256,623.688782 
	C546.227966,623.844727 548.183533,625.082336 548.401184,626.127808 
	C549.297241,630.430298 549.644287,634.847229 550.274719,639.871765 
	C548.233643,638.219360 546.761230,637.027283 544.273621,635.013306 
	C545.282715,638.516907 545.948425,640.828552 546.757629,643.638062 
	C542.864014,643.638062 539.121582,643.638062 535.178955,643.638062 
	C535.907104,641.392395 536.611267,639.220764 537.496948,636.487427 
	C537.633118,635.669067 537.587830,635.412415 537.542480,635.155762 
	C537.221863,635.294312 536.901306,635.432861 536.580688,635.571411 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M561.996460,658.021179 
	C566.164185,662.018555 564.452026,667.260376 564.723267,672.688721 
	C564.330811,673.944275 564.176697,674.542969 563.666809,675.118469 
	C562.603882,675.006775 561.896667,674.918274 561.147888,674.620789 
	C561.106323,674.411804 561.136963,673.986755 561.425415,673.788696 
	C563.666626,669.731018 561.182129,665.255920 555.951904,663.213379 
	C555.299622,664.485291 554.648254,665.757629 553.626282,667.023315 
	C551.870728,666.453369 550.485718,665.890076 549.526001,665.499817 
	C549.327881,662.096802 555.811646,659.327454 549.010254,656.679199 
	C549.223572,655.599426 549.568604,654.820740 550.291138,654.049927 
	C551.278381,653.604065 551.888184,653.150452 552.497986,652.696777 
	C551.514221,652.493347 550.530518,652.289917 549.370361,651.968262 
	C549.016357,651.611145 548.940735,651.343445 548.948792,650.807861 
	C548.898621,650.209534 548.713623,649.967163 548.266602,649.617798 
	C548.157715,649.393921 547.963684,648.935547 547.961426,648.973511 
	C547.959167,649.011414 547.883301,649.006714 547.883301,649.006714 
	C548.084229,649.023132 548.285156,649.039612 549.021851,649.027710 
	C549.557556,648.999329 550.027405,649.028259 550.054810,649.359863 
	C551.552734,649.761902 553.023315,649.832397 553.945801,649.876587 
	C555.867493,653.756653 557.789551,657.637512 560.022766,662.146729 
	C561.057495,659.983887 561.526978,659.002563 561.996460,658.021179 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M515.806641,652.822266 
	C516.177063,650.831970 516.547546,648.841675 517.184631,646.212952 
	C517.322021,643.846924 517.167725,642.120667 517.071228,640.391235 
	C516.988281,638.904297 516.971497,637.413574 517.239685,635.930786 
	C518.426453,634.949097 519.298889,633.961121 520.342896,632.966614 
	C520.514404,632.960083 520.857727,632.962769 521.008911,633.210083 
	C521.447998,633.713562 521.735901,633.969849 522.168579,634.463135 
	C522.868042,635.428711 523.422791,636.157227 523.977539,636.885742 
	C525.891357,640.273926 527.805237,643.662048 529.899292,647.595276 
	C530.045288,648.624512 530.010986,649.108643 529.972717,649.967651 
	C529.893616,650.579651 529.818542,650.816833 529.600342,651.127319 
	C529.457275,651.200623 529.209167,650.995483 528.823425,651.056152 
	C527.918396,651.074341 527.399170,651.031799 526.894409,650.642700 
	C524.640076,648.456726 522.371216,646.617432 520.507568,645.106567 
	C518.799255,649.020569 517.438965,652.137329 516.023071,654.849731 
	C515.913940,653.904358 515.860229,653.363342 515.806641,652.822266 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M574.958374,653.617920 
	C573.205994,653.912048 571.624268,653.912048 569.851074,653.912048 
	C568.420776,658.072815 566.030823,659.122070 562.265320,655.208069 
	C561.654358,654.101807 561.328857,653.509155 561.006104,652.489380 
	C561.380981,649.700989 561.753174,647.339783 562.125366,644.978516 
	C563.084229,648.365540 564.043152,651.752563 565.002014,655.139587 
	C565.620483,654.963318 566.238953,654.787048 566.857483,654.610840 
	C566.521423,652.960327 565.903564,651.303589 565.940247,649.661438 
	C565.968628,648.392517 566.487366,646.492004 567.380188,646.038940 
	C568.644958,645.397095 571.366516,645.200623 571.860535,645.918457 
	C573.363525,648.102356 574.096375,650.816284 574.958374,653.617920 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M515.449341,652.783203 
	C515.860229,653.363342 515.913940,653.904358 515.972778,655.017090 
	C515.978027,655.588806 515.880615,655.927734 515.880615,655.927734 
	C513.369629,657.393188 510.717255,659.703979 509.414856,654.312317 
	C509.517548,653.361511 509.473236,652.920288 509.428894,652.479004 
	C509.130280,652.857422 508.831665,653.235840 508.533020,653.614258 
	C507.140686,653.683594 505.748383,653.752991 504.268280,653.826660 
	C505.131409,645.903687 506.678528,644.531677 512.312134,645.651978 
	C513.303467,648.181152 514.197754,650.462708 515.449341,652.783203 
z"
      />
      <path
        fill="#394746"
        opacity="1.000000"
        stroke="none"
        d="
M529.976746,649.592834 
	C530.010986,649.108643 530.045288,648.624512 530.119263,647.899658 
	C534.464539,647.268982 538.766846,646.673706 543.077393,646.606934 
	C544.470459,646.585327 545.885010,647.951538 547.586487,648.844788 
	C547.883301,649.006714 547.959167,649.011414 547.663940,648.946289 
	C547.205078,649.244690 547.041382,649.608215 546.509155,649.965027 
	C545.642822,649.991394 544.910400,649.822266 544.681885,650.087402 
	C540.171814,655.320068 535.809509,653.728394 531.419922,649.929260 
	C531.089355,649.643188 530.464722,649.697021 529.976746,649.592834 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M515.144958,660.056519 
	C515.522888,660.025085 515.900757,659.993652 516.952515,659.980164 
	C518.748169,658.917236 519.863586,657.829529 520.993530,656.757202 
	C522.346130,655.473572 523.711121,654.202881 525.224487,653.206055 
	C528.049744,655.591919 527.761963,657.439026 525.187927,659.539612 
	C521.929749,662.198486 518.903015,665.140930 515.470703,667.964783 
	C514.757507,667.974426 514.349915,667.980347 513.942383,667.986206 
	C513.919250,666.614014 513.896118,665.241882 514.035950,663.186157 
	C514.514282,661.687317 514.829590,660.871887 515.144958,660.056519 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M551.513184,644.486938 
	C552.666443,642.301331 553.819702,640.115784 554.669861,638.504578 
	C553.469971,636.428101 551.409119,634.468994 551.761047,633.157043 
	C552.669373,629.771057 555.255676,627.563843 559.592407,628.313538 
	C560.322449,629.834839 560.942627,630.904846 560.907104,631.952637 
	C560.884216,632.628479 559.899658,633.271790 559.121582,633.833374 
	C556.622131,637.510437 554.347229,641.283813 551.934326,644.912903 
	C551.796326,644.768555 551.513184,644.486938 551.513184,644.486938 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M525.070740,652.926636 
	C523.711121,654.202881 522.346130,655.473572 520.993530,656.757202 
	C519.863586,657.829529 518.748169,658.917236 517.231079,659.922852 
	C516.701477,658.690979 516.567078,657.534302 516.156616,656.152710 
	C515.880615,655.927734 515.978027,655.588806 516.028320,655.421387 
	C517.438965,652.137329 518.799255,649.020569 520.507568,645.106567 
	C522.371216,646.617432 524.640076,648.456726 526.672485,650.793823 
	C525.980957,651.836609 525.525879,652.381653 525.070740,652.926636 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M559.346069,633.929688 
	C559.899658,633.271790 560.884216,632.628479 560.907104,631.952637 
	C560.942627,630.904846 560.322449,629.834839 559.982605,628.400513 
	C567.255615,630.437622 569.427002,637.415466 563.188232,642.790894 
	C561.677307,640.866150 560.752747,638.927368 559.837891,636.598083 
	C559.680420,635.448242 559.513245,634.688965 559.346069,633.929688 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M513.794556,668.257996 
	C514.349915,667.980347 514.757507,667.974426 515.528442,668.366760 
	C515.947083,670.382507 516.002380,672.000000 515.938232,673.953369 
	C515.006409,675.264038 514.194031,676.239014 512.708435,678.021912 
	C516.023132,678.021912 518.503845,678.021912 520.998291,678.375854 
	C520.996033,679.438049 520.980103,680.146240 520.964172,680.854431 
	C520.964172,680.854431 521.074890,681.045532 521.065796,681.155640 
	C518.938843,681.227600 516.821045,681.189514 514.221191,680.755249 
	C512.863586,678.260315 511.987915,676.161377 511.112274,674.062500 
	C511.112274,674.062500 511.035400,674.008057 511.372864,673.913574 
	C512.247864,672.879822 512.785461,671.940613 513.323059,671.001343 
	C513.430969,670.177490 513.538879,669.353638 513.794556,668.257996 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M559.828186,636.988647 
	C560.752747,638.927368 561.677307,640.866150 562.880310,642.970154 
	C562.891235,643.589478 562.623657,644.043457 562.240723,644.737976 
	C561.753174,647.339783 561.380981,649.700989 560.618164,652.461548 
	C557.446289,647.636780 557.365906,642.344727 559.828186,636.988647 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M516.925415,635.924561 
	C516.971497,637.413574 516.988281,638.904297 517.071228,640.391235 
	C517.167725,642.120667 517.322021,643.846924 517.167480,645.813660 
	C515.408386,642.599304 513.649963,639.229065 512.597351,635.651245 
	C512.177551,634.224487 513.316956,632.338989 514.208923,630.666687 
	C514.671326,630.671021 515.012390,631.012329 515.012085,631.358521 
	C515.649658,633.111267 516.287537,634.517944 516.925415,635.924561 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M524.351929,636.902893 
	C523.422791,636.157227 522.868042,635.428711 522.077271,634.168579 
	C521.513428,633.412292 521.185547,633.187500 520.857727,632.962769 
	C520.857727,632.962769 520.514404,632.960083 520.333862,632.758545 
	C520.153320,632.556946 520.214783,632.144287 520.433350,631.867798 
	C520.751648,630.431580 520.851379,629.271851 520.951111,628.112183 
	C522.846558,629.314636 525.287231,630.156555 526.417175,631.865234 
	C527.020935,632.778137 525.363342,635.186584 524.351929,636.902893 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M520.749268,627.837585 
	C520.851379,629.271851 520.751648,630.431580 520.156677,631.696350 
	C518.662903,628.291382 516.455017,631.905945 515.012390,631.012329 
	C515.012390,631.012329 514.671326,630.671021 514.523926,630.478027 
	C516.433472,629.377747 518.490417,628.470337 520.749268,627.837585 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M510.749451,674.099976 
	C511.987915,676.161377 512.863586,678.260315 513.923218,680.650940 
	C513.125122,680.900330 512.142944,680.857910 511.160767,680.815491 
	C511.939392,678.469299 506.572662,676.835449 510.749451,674.099976 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M514.751770,660.040771 
	C514.829590,660.871887 514.514282,661.687317 514.010864,662.774170 
	C512.917969,662.870361 512.013123,662.695068 511.108337,662.519775 
	C512.191772,661.688171 513.275208,660.856567 514.751770,660.040771 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M550.027466,649.028259 
	C550.027405,649.028259 549.557556,648.999329 549.322449,648.995117 
	C549.723083,647.624878 550.358826,646.258850 551.253906,644.689941 
	C551.513184,644.486938 551.796326,644.768555 551.894043,645.241455 
	C551.336975,646.818970 550.682190,647.923645 550.027466,649.028259 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M512.940552,671.037598 
	C512.785461,671.940613 512.247864,672.879822 511.388916,673.957886 
	C511.564362,673.089050 512.061218,672.081482 512.940552,671.037598 
z"
      />
      <path
        fill="#A49D32"
        opacity="1.000000"
        stroke="none"
        d="
M357.365387,411.267395 
	C358.177704,410.777618 358.807526,410.740448 359.736053,410.594482 
	C374.593475,412.745911 389.152191,415.006104 403.710938,417.266296 
	C403.948608,417.799805 404.186249,418.333313 404.423920,418.866821 
	C401.253784,420.982025 398.083649,423.097198 394.638794,425.395691 
	C402.241974,424.377106 409.680756,423.380524 417.119537,422.383942 
	C417.387543,423.095917 417.655579,423.807892 417.923584,424.519867 
	C414.882263,426.045105 411.978943,428.033752 408.768188,428.990204 
	C403.569519,430.538940 398.168945,431.409790 392.867828,433.165588 
	C391.190186,434.961731 389.498291,436.159180 387.806396,437.356628 
	C387.436310,437.296692 387.066223,437.236786 386.042816,437.095062 
	C384.886932,437.025543 384.384338,437.037811 383.881775,437.050049 
	C382.926910,437.656036 381.483795,438.060760 381.131592,438.915222 
	C380.602325,440.198975 380.837402,441.797821 379.756378,443.437500 
	C379.349335,441.386780 378.942291,439.336029 378.446106,436.836273 
	C375.759674,437.492798 373.366272,438.077698 370.268341,438.834778 
	C370.322784,438.919281 369.702271,437.956543 368.506775,436.101776 
	C367.664307,438.778839 367.115051,440.524170 366.474365,442.560059 
	C365.947083,440.470001 365.503632,438.712158 365.060150,436.954285 
	C364.669708,436.944672 364.279236,436.935059 363.888763,436.925446 
	C363.277710,438.975677 362.666626,441.025940 361.678467,444.341400 
	C360.590973,440.668610 362.044983,436.661560 357.525452,436.304749 
	C357.243286,436.282471 356.950592,434.210480 356.955322,433.093353 
	C356.985504,425.968689 357.097717,418.844360 357.365387,411.267395 
z"
      />
      <path
        fill="#9A932D"
        opacity="1.000000"
        stroke="none"
        d="
M475.215027,458.957703 
	C465.286499,463.313354 455.285004,467.420990 445.214478,471.351715 
	C443.610657,471.977722 441.696777,471.809326 439.529663,471.886414 
	C439.038727,467.624542 438.964844,463.483765 438.843018,459.344452 
	C438.757660,456.444092 437.604523,455.082275 434.335876,454.744232 
	C432.190613,454.522369 430.379028,452.033905 428.177765,451.179779 
	C424.382355,449.707153 420.370514,448.800446 416.521545,447.450775 
	C415.790802,447.194519 415.394196,445.985352 414.962555,444.523560 
	C416.521667,439.001740 421.218079,441.486786 424.070282,439.829407 
	C440.296906,445.533783 456.527863,451.226013 472.738403,456.975739 
	C473.619263,457.288177 474.329529,458.081635 475.215027,458.957703 
z"
      />
      <path
        fill="#9A932D"
        opacity="1.000000"
        stroke="none"
        d="
M387.824066,437.758179 
	C389.498291,436.159180 391.190186,434.961731 392.951477,433.419800 
	C393.764648,433.042206 394.508453,433.009125 395.663757,433.341492 
	C396.399780,434.001801 396.724274,434.296570 397.048767,434.591370 
	C397.371124,434.101776 397.693512,433.612152 398.015869,433.122559 
	C400.711609,433.113373 403.407349,433.104156 406.618744,433.492645 
	C409.156616,436.295044 412.398254,438.317627 409.735474,442.190491 
	C408.855103,443.739227 407.974731,445.287964 407.177002,446.691345 
	C406.560913,445.180664 405.738800,443.164917 404.916718,441.149139 
	C404.544189,441.180023 404.171631,441.210907 403.799103,441.241821 
	C403.399017,442.866882 402.998932,444.491974 402.566315,446.249237 
	C401.904510,443.871033 401.272888,441.601257 400.641235,439.331482 
	C400.237183,439.350403 399.833130,439.369324 399.429047,439.388245 
	C399.190674,441.305420 398.952271,443.222595 398.740265,444.927582 
	C397.678162,442.849213 396.560303,440.661713 395.442444,438.474182 
	C395.072479,438.572083 394.702515,438.670013 394.332520,438.767914 
	C394.140076,440.596619 393.947601,442.425323 393.659271,445.165131 
	C392.981323,441.982330 392.504242,439.742615 392.027161,437.502899 
	C391.603455,437.530609 391.179718,437.558289 390.755981,437.585968 
	C390.331726,439.627899 389.907471,441.669800 389.483215,443.711700 
	C389.113007,443.714203 388.742828,443.716675 388.372650,443.719177 
	C388.195679,441.866028 388.018707,440.012878 387.824066,437.758179 
z"
      />
      <path
        fill="#A49D32"
        opacity="1.000000"
        stroke="none"
        d="
M409.753754,442.175385 
	C412.398254,438.317627 409.156616,436.295044 407.060577,433.575439 
	C410.798676,434.402954 414.646362,435.441193 418.406982,436.732941 
	C420.215332,437.354065 421.859344,438.453735 423.824036,439.583038 
	C421.218079,441.486786 416.521667,439.001740 414.945160,444.204498 
	C414.512390,444.537415 414.215820,444.499451 413.376465,444.195679 
	C411.828857,443.337524 410.823669,442.747650 409.818512,442.157776 
	C409.818512,442.157776 409.772034,442.160278 409.753754,442.175385 
z"
      />
      <path
        fill="#9A932D"
        opacity="1.000000"
        stroke="none"
        d="
M409.877747,442.533325 
	C410.823669,442.747650 411.828857,443.337524 413.160461,444.131775 
	C412.904480,446.047211 412.322083,447.758240 411.689545,449.616547 
	C411.084198,447.299652 410.510620,445.104279 409.877747,442.533325 
z"
      />
      <path
        fill="#9A932D"
        opacity="1.000000"
        stroke="none"
        d="
M383.862976,437.450562 
	C384.384338,437.037811 384.886932,437.025543 385.766907,437.040649 
	C385.708130,438.786255 385.271912,440.504456 384.835693,442.222626 
	C384.505188,442.232208 384.174683,442.241791 383.844177,442.251373 
	C383.844177,440.784607 383.844177,439.317841 383.862976,437.450562 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M657.580627,500.060760 
	C656.361206,499.580353 655.425842,498.910431 654.177612,498.095734 
	C658.153809,489.760193 662.196899,481.425354 666.864563,473.456360 
	C668.511047,470.645325 671.684509,468.728729 674.434692,465.856201 
	C675.137329,464.534485 675.565918,463.760284 676.370117,462.991638 
	C677.497009,462.995819 678.248169,462.994415 679.014282,463.251770 
	C679.057251,463.681091 679.085266,463.851624 678.949707,464.314117 
	C678.487000,465.708374 678.187744,466.810638 677.888550,467.912903 
	C679.909363,467.759155 682.222534,468.185822 683.895935,467.342651 
	C688.864197,464.839325 693.637512,461.928345 698.378967,459.001617 
	C703.031067,456.130035 707.550659,453.043732 712.128418,450.051636 
	C714.840149,449.703461 717.551880,449.355255 720.690247,449.041138 
	C717.208740,451.757965 713.374634,454.557251 709.375183,457.096130 
	C703.405334,460.885834 697.318970,464.491974 691.001709,468.383545 
	C689.528259,469.479828 688.335388,470.368835 687.142578,471.257874 
	C679.711365,473.909637 673.001892,477.295837 668.750916,484.613708 
	C665.626343,489.992432 661.528687,494.805878 657.580627,500.060760 
M674.601440,469.515778 
	C674.601440,469.515778 674.481201,469.587646 674.601440,469.515778 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M687.169739,471.612061 
	C688.335388,470.368835 689.528259,469.479828 691.095459,468.719116 
	C691.280579,469.856415 691.091370,470.865448 690.614502,472.535034 
	C687.266907,482.149445 684.206970,491.103271 680.856812,499.843445 
	C681.099915,497.300659 681.617737,494.967896 682.170593,492.643433 
	C682.804749,489.977081 683.469910,487.318115 684.418762,483.442108 
	C674.719666,490.237305 670.284851,503.483887 674.507935,509.776306 
	C676.078308,508.523132 677.648804,507.270081 679.223694,506.401733 
	C678.136841,509.919952 677.045532,513.053467 675.954224,516.187012 
	C675.442261,517.007141 674.930298,517.827271 674.215454,518.855286 
	C673.027344,514.147522 671.900024,509.254272 671.117371,504.306549 
	C670.732422,501.872498 670.985718,499.337494 670.888062,496.379822 
	C676.282898,487.929718 681.739868,479.947998 687.169739,471.612061 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M676.298340,516.098694 
	C677.045532,513.053467 678.136841,509.919952 679.419556,506.116211 
	C680.123047,503.649689 680.635071,501.853394 681.147034,500.057098 
	C684.206970,491.103271 687.266907,482.149445 690.598633,472.925110 
	C690.808594,477.434723 690.823181,482.217682 690.648315,486.993713 
	C690.576416,488.957855 689.778320,490.919647 689.855347,492.860901 
	C690.272705,503.375854 684.098328,510.039581 676.298340,516.098694 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M637.068237,655.125610 
	C630.507446,653.289734 623.939209,651.144409 617.458435,648.761047 
	C615.885132,648.182373 614.600403,646.819275 613.130493,645.479614 
	C624.496460,641.350525 632.661316,644.609741 637.068237,655.125610 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M606.881958,653.020203 
	C606.733276,654.292542 606.584656,655.564880 606.435974,656.837219 
	C602.671631,656.071289 598.280701,656.252930 595.309326,654.287903 
	C591.960815,652.073486 589.025146,648.229858 591.661926,643.000122 
	C595.006409,645.536499 597.671570,648.567017 600.803650,650.995178 
	C602.395996,652.229675 604.828979,652.379883 606.881958,653.020203 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M606.826050,652.650024 
	C604.828979,652.379883 602.395996,652.229675 600.803650,650.995178 
	C597.671570,648.567017 595.006409,645.536499 591.841125,642.649414 
	C591.480774,642.228333 591.444092,641.911011 591.454346,641.353271 
	C591.841248,641.024109 592.197937,640.933472 592.778809,640.672913 
	C602.729553,642.108521 604.945129,644.003784 606.826050,652.650024 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M622.524963,631.785034 
	C622.241455,632.921875 621.930237,634.241089 621.146118,634.647217 
	C617.612183,636.477844 614.003967,638.201233 610.304199,639.663818 
	C607.662415,640.708191 605.531616,640.119873 605.227234,637.974304 
	C611.268616,635.697144 616.774109,633.622070 622.524963,631.785034 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M751.485168,190.809921 
	C752.648315,191.382782 753.811401,191.955643 754.901001,192.492294 
	C753.295715,193.626312 752.190613,194.406998 751.029419,195.611786 
	C750.973328,196.035889 750.802612,196.212891 750.802612,196.212891 
	C748.774658,197.478470 746.746643,198.744034 744.343079,199.981857 
	C743.128052,198.369232 742.394470,196.715439 741.420105,195.218369 
	C740.396667,193.645630 739.142456,192.222977 738.308167,190.521423 
	C740.211914,190.670059 741.793274,191.312119 743.382141,191.331406 
	C746.080627,191.364212 748.783936,191.004623 751.485168,190.809921 
M745.451477,195.639740 
	C745.451477,195.639740 745.557739,195.434113 745.557739,195.434113 
	C745.557739,195.434113 745.334900,195.471558 745.451477,195.639740 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M751.457153,190.514374 
	C748.783936,191.004623 746.080627,191.364212 743.382141,191.331406 
	C741.793274,191.312119 740.211914,190.670059 738.301758,190.149475 
	C736.614685,188.204926 737.177063,187.039749 739.515381,186.312042 
	C740.417664,186.031235 741.165100,185.252945 741.991577,184.350708 
	C742.000000,184.000122 742.010986,183.988434 742.010986,183.988434 
	C742.803345,183.995789 743.595703,184.003128 744.994385,184.271240 
	C747.549622,186.032349 749.498474,187.532715 751.447327,189.033051 
	C751.441284,189.428299 751.435181,189.823563 751.457153,190.514374 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M751.663330,188.851166 
	C749.498474,187.532715 747.549622,186.032349 745.390625,184.273651 
	C745.180481,184.015289 745.177673,183.547348 745.395752,183.114471 
	C745.733398,182.119980 745.852905,181.558365 745.972412,180.996735 
	C745.979858,180.248062 745.987305,179.499405 746.008301,178.156433 
	C746.021851,177.562149 746.027527,177.121872 746.027527,177.121872 
	C746.458252,177.103241 746.889038,177.084610 747.642456,177.051895 
	C747.965149,177.037796 747.986389,177.010574 748.001221,177.346527 
	C748.673279,178.159424 749.330505,178.636368 749.987732,179.113327 
	C751.171814,180.393524 752.355896,181.673721 753.895935,182.974060 
	C754.662842,184.862030 755.073853,186.729843 755.500549,188.669250 
	C754.061768,188.669250 752.970520,188.669250 751.663330,188.851166 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M739.997559,182.002441 
	C739.486450,181.698196 738.975281,181.393967 738.464172,181.089752 
	C738.646484,180.879333 738.828796,180.668884 739.011108,180.458435 
	C739.317505,180.781616 739.623840,181.104797 739.965088,181.713989 
	C740.000000,182.000000 739.997559,182.002441 739.997559,182.002441 
z"
      />
      <path
        fill="#F7EBD5"
        opacity="1.000000"
        stroke="none"
        d="
M731.393494,192.953705 
	C731.790466,192.711563 732.185547,192.713287 732.578430,192.743790 
	C732.589661,192.744659 732.577209,193.050858 732.575806,193.214691 
	C732.181030,193.210358 731.786133,193.206009 731.393494,192.953705 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M745.673462,181.033676 
	C745.852905,181.558365 745.733398,182.119980 745.401855,182.880585 
	C745.251404,182.409912 745.312927,181.740265 745.673462,181.033676 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M741.993896,184.005615 
	C741.351074,183.555405 740.714294,183.099701 740.037598,182.323212 
	C739.997559,182.002441 740.000000,182.000000 740.001221,181.998871 
	C740.642334,182.448395 741.282227,182.899048 741.966553,183.669067 
	C742.010986,183.988434 742.000000,184.000122 741.993896,184.005615 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M751.002869,170.003082 
	C751.244568,169.489426 751.463440,168.960846 751.753174,168.474442 
	C751.782043,168.425903 752.242004,168.634079 752.501892,168.723129 
	C752.191772,169.121887 751.881592,169.520630 751.282715,169.956833 
	C750.993958,169.994278 751.000000,170.000000 751.002869,170.003082 
z"
      />
      <path
        fill="#F7EBD5"
        opacity="1.000000"
        stroke="none"
        d="
M749.391846,163.953735 
	C749.789673,163.710876 750.185547,163.712570 750.579163,163.742920 
	C750.590210,163.743759 750.577759,164.050613 750.576233,164.214783 
	C750.180664,164.210617 749.785034,164.206451 749.391846,163.953735 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M745.878418,176.878754 
	C746.027527,177.121872 746.021851,177.562149 746.009705,177.781982 
	C745.493713,177.560120 744.989929,177.118408 744.486084,176.676712 
	C744.900513,176.663010 745.314941,176.649323 745.878418,176.878754 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M756.002441,166.997620 
	C755.464050,166.766968 754.923157,166.538727 754.382324,166.310486 
	C754.716736,165.897598 755.051147,165.484726 755.692749,165.035919 
	C756.000000,165.000000 755.997559,164.998215 755.997559,164.998215 
	C755.996338,165.444138 755.995056,165.890045 755.994446,166.670532 
	C755.995117,167.005096 756.000000,167.000000 756.002441,166.997620 
z"
      />
      <path
        fill="#F7EBD5"
        opacity="1.000000"
        stroke="none"
        d="
M735.740784,196.353790 
	C735.992432,196.368607 736.129639,196.503143 736.266907,196.637665 
	C736.053406,196.582947 735.839905,196.528229 735.740784,196.353790 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M756.001221,165.001404 
	C756.125427,164.553619 756.248352,164.104431 756.371216,163.655243 
	C756.385803,164.015091 756.400391,164.374924 756.206238,164.866486 
	C755.997559,164.998215 756.000000,165.000000 756.001221,165.001404 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M745.361694,172.263367 
	C745.376099,172.009491 745.510010,171.871460 745.643921,171.733398 
	C745.589661,171.948669 745.535461,172.163956 745.361694,172.263367 
z"
      />
      <path
        fill="#A49D32"
        opacity="1.000000"
        stroke="none"
        d="
M397.678101,433.064056 
	C397.693512,433.612152 397.371124,434.101776 397.048767,434.591370 
	C396.724274,434.296570 396.399780,434.001801 396.028107,433.425049 
	C396.434082,433.097229 396.887207,433.051392 397.678101,433.064056 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M379.994690,623.459229 
	C380.043945,623.132141 380.056183,622.803711 379.961884,621.885864 
	C378.930481,620.864014 377.968567,620.430115 377.003479,619.998108 
	C377.000275,620.000000 377.004028,619.993347 376.995605,619.627686 
	C376.522644,618.447266 376.214233,617.470947 375.566986,616.845215 
	C372.496002,613.876160 369.332611,611.002686 366.202118,608.095215 
	C366.409790,607.679138 366.617462,607.263000 366.825134,606.846924 
	C372.682495,607.733337 378.539825,608.619812 385.691528,609.702087 
	C383.244049,610.779541 381.682770,611.045715 380.813721,611.965881 
	C379.914856,612.917542 379.327118,614.500366 379.314148,615.814148 
	C379.307312,616.507629 380.832520,617.841248 381.635590,617.818359 
	C387.754089,617.643921 393.960419,617.711243 399.928162,616.584351 
	C402.106201,616.173035 403.711273,612.727478 405.793549,610.427979 
	C403.434845,609.189636 402.210602,608.546936 400.996094,607.909302 
	C402.283417,603.032593 406.063263,603.619202 409.395264,603.440918 
	C409.390564,603.537354 409.267639,603.686279 409.300903,604.046204 
	C410.544769,604.943481 411.755402,605.480835 412.982666,606.008057 
	C412.999329,605.997925 412.983459,606.033386 413.020447,606.377136 
	C413.983856,608.180420 414.910217,609.639893 415.846161,611.114502 
	C415.253387,611.614380 414.907196,611.951660 414.517609,612.227722 
	C411.356415,614.467285 408.187134,616.695435 404.763916,619.132874 
	C404.462677,620.192871 404.417816,621.047058 404.005585,621.946716 
	C402.913391,622.476746 402.188568,622.961304 401.463745,623.445862 
	C401.568848,623.981384 401.673981,624.516846 401.779114,625.052307 
	C404.820435,624.719788 408.144867,625.051941 410.838989,623.904297 
	C415.257904,622.022034 419.444397,619.424622 423.355316,616.609741 
	C424.755371,615.602112 425.695831,613.071655 425.641968,611.272339 
	C425.611511,610.254456 423.135986,609.309753 421.735138,608.317810 
	C421.708527,608.303528 421.649078,608.314209 421.763611,607.910583 
	C422.174011,602.610474 417.794525,602.640869 415.004883,600.611572 
	C414.981140,599.474731 414.963043,598.716309 414.997498,597.598999 
	C416.713531,594.477478 418.376984,591.714905 420.193512,589.251282 
	C423.218475,592.034424 426.090363,594.518555 429.688812,597.631165 
	C429.810120,594.902283 429.874847,593.446228 429.939575,591.990173 
	C432.566650,590.595581 432.982239,591.930725 433.040527,594.271790 
	C433.168091,599.391663 433.757721,604.510559 433.678070,609.622375 
	C433.586060,615.525452 437.086029,619.227539 440.794373,622.973633 
	C441.127350,623.309937 441.008728,624.093384 440.648376,624.950439 
	C439.744324,625.339417 439.291718,625.447083 438.539093,625.438599 
	C437.836761,625.177673 437.434448,625.032837 437.014282,624.524170 
	C434.457245,619.400024 430.427582,623.195312 427.660431,623.344116 
	C423.548431,623.565308 419.745117,627.758911 415.536713,628.366821 
	C409.167725,629.286682 402.495422,629.142578 396.081116,628.373596 
	C391.269104,627.796753 386.660156,625.525757 381.632507,623.918762 
	C380.867706,623.705383 380.431183,623.582336 379.994690,623.459229 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M455.530640,603.871216 
	C455.852905,604.818298 455.939056,605.534302 455.762817,606.831055 
	C454.346832,609.935913 453.193237,612.459839 451.865051,614.693115 
	C448.104645,608.438232 444.598969,602.423096 440.874146,596.546997 
	C439.991058,595.153931 438.372864,594.226807 436.908386,592.843506 
	C436.172913,592.383179 435.621796,592.164734 435.070709,591.946228 
	C433.949707,588.921143 432.828705,585.896057 431.351807,581.910583 
	C441.374939,587.641479 450.203766,593.498962 455.530640,603.871216 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M437.092804,593.085388 
	C438.372864,594.226807 439.991058,595.153931 440.874146,596.546997 
	C444.598969,602.423096 448.104645,608.438232 451.894958,615.042847 
	C454.234039,616.930603 456.368622,618.177917 458.641968,619.852539 
	C458.839264,621.173523 458.897766,622.067200 458.956299,622.960876 
	C457.140808,623.945007 455.325317,624.929199 453.330750,625.572510 
	C452.966125,623.802612 452.780579,622.373535 452.420654,620.633057 
	C443.519379,613.287903 438.271454,604.318665 437.092804,593.085388 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M484.009216,610.990845 
	C484.443695,611.963501 484.872559,612.943909 485.651306,613.964172 
	C486.165955,614.317383 486.330750,614.630737 486.379333,615.589722 
	C486.868378,618.858643 487.473663,621.481873 488.326172,625.176758 
	C485.530701,623.379211 483.724213,622.217651 481.917725,621.056030 
	C477.455994,615.046326 472.994232,609.036682 468.246948,602.508301 
	C466.841156,601.247375 465.720825,600.505066 464.600525,599.762756 
	C464.472900,599.383118 464.345245,599.003479 464.363159,598.249756 
	C464.982635,597.611938 465.456543,597.348145 465.930420,597.084351 
	C469.638123,599.433899 473.345795,601.783447 477.393524,604.221802 
	C478.068298,604.723511 478.403015,605.136536 478.878113,606.133057 
	C480.039001,607.438538 481.059540,608.160461 482.080109,608.882324 
	C482.080109,608.882324 482.052368,608.979187 482.072205,609.276001 
	C482.733704,610.043701 483.375336,610.514648 484.016968,610.985657 
	C484.016968,610.985657 484.003601,610.998474 484.009216,610.990845 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M446.120331,639.990234 
	C445.026672,639.683594 444.314819,639.345459 443.035583,638.877197 
	C442.104279,638.595032 441.740356,638.443054 441.175537,638.070129 
	C440.235840,637.790649 439.496979,637.732117 438.368988,637.546875 
	C436.345428,637.309326 434.710968,637.198364 432.842529,636.824829 
	C430.828430,635.835083 429.048309,635.107910 426.956848,634.253540 
	C428.027161,633.075684 428.779480,632.247742 429.877533,631.419006 
	C431.137329,631.306885 432.051361,631.195557 433.135101,631.291260 
	C433.985504,631.134644 434.666229,630.771118 435.671021,630.371826 
	C436.645477,630.288940 437.295868,630.241760 438.262604,630.433960 
	C441.481903,630.384949 444.951782,632.902344 447.114136,628.948669 
	C448.694580,631.166138 450.945770,633.225525 451.524353,635.679199 
	C451.754791,636.656677 448.286560,638.506226 446.120331,639.990234 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M436.908386,592.843506 
	C438.271454,604.318665 443.519379,613.287903 451.977905,620.645386 
	C447.752594,620.020996 443.795715,619.072815 439.838837,618.124634 
	C439.563263,617.969360 439.335175,617.761902 438.962128,617.060791 
	C438.487366,616.444580 438.205048,616.269775 437.922760,616.095032 
	C433.551910,608.795471 435.047485,600.732849 434.987305,592.414856 
	C435.621796,592.164734 436.172913,592.383179 436.908386,592.843506 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M429.682312,591.722839 
	C429.874847,593.446228 429.810120,594.902283 429.688812,597.631165 
	C426.090363,594.518555 423.218475,592.034424 420.145752,588.897583 
	C418.630432,585.167297 417.315979,582.089783 416.001526,579.012268 
	C419.353546,579.981567 422.705566,580.950928 426.429443,581.875488 
	C427.675842,585.038940 428.550446,588.247253 429.682312,591.722839 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M487.272308,640.608521 
	C483.992584,644.616272 480.579102,648.399719 476.820282,651.801697 
	C475.819397,652.707520 473.760345,652.444275 471.830444,652.647217 
	C473.410614,642.488831 478.299927,638.606689 487.272308,640.608521 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M432.965424,631.084290 
	C432.051361,631.195557 431.137329,631.306885 429.471558,631.316528 
	C424.135986,632.139893 419.552063,633.064880 414.982819,633.681519 
	C415.006714,632.961609 415.015961,632.549988 415.381195,632.043823 
	C418.669403,630.459961 421.601624,628.970703 424.851440,627.600769 
	C425.821259,627.267090 426.473511,626.814087 427.425659,626.249512 
	C428.145508,626.068542 428.565491,625.999146 429.122803,626.152222 
	C429.884033,626.058289 430.507904,625.741943 431.543915,625.331238 
	C433.648071,625.120605 435.340088,625.004272 437.032104,624.888000 
	C437.434448,625.032837 437.836761,625.177673 438.693604,625.720825 
	C439.935028,626.191589 440.721924,626.263977 441.508789,626.336365 
	C442.325714,626.635803 443.142639,626.935242 443.962952,627.763733 
	C441.959595,628.926758 439.952942,629.560669 437.946259,630.194580 
	C437.295868,630.241760 436.645477,630.288940 435.335358,630.263611 
	C434.105560,630.488831 433.535492,630.786560 432.965424,631.084290 
z"
      />
      <path
        fill="#0C1C1F"
        opacity="1.000000"
        stroke="none"
        d="
M459.003998,623.312988 
	C458.897766,622.067200 458.839264,621.173523 458.680847,619.557983 
	C458.659698,618.234497 458.738464,617.632874 458.817230,617.031250 
	C460.254730,617.021118 461.692200,617.011047 463.560516,617.001709 
	C464.627777,623.293518 467.872833,628.333191 472.855621,633.038879 
	C469.900818,633.338074 468.085114,633.521973 465.800659,633.951843 
	C464.850739,633.939392 464.369537,633.680908 463.888336,633.422363 
	C462.276123,630.169983 460.663910,626.917542 459.003998,623.312988 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M467.239441,604.207275 
	C469.542389,609.501953 471.845337,614.796631 473.844849,620.562500 
	C472.321747,622.397461 471.102081,623.761108 469.882446,625.124756 
	C465.368866,619.088684 465.388580,611.971619 465.336731,604.475525 
	C466.150146,604.079346 466.694794,604.143311 467.239441,604.207275 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M446.136780,654.544189 
	C445.531281,654.907410 445.100464,654.962830 444.373352,655.156372 
	C443.454742,655.041687 442.832458,654.788940 442.015625,654.258789 
	C442.924408,652.452637 444.027771,650.923950 445.798645,649.186890 
	C451.631592,647.654846 456.796997,646.331116 461.987274,645.371216 
	C461.999329,646.462891 461.986542,647.190613 461.973724,647.918396 
	C456.752991,650.024475 451.532227,652.130493 446.136780,654.544189 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M469.961578,625.449463 
	C471.102081,623.761108 472.321747,622.397461 473.882965,620.922363 
	C474.224518,620.811035 474.168732,620.888428 474.131653,621.263550 
	C474.897644,622.073730 475.700684,622.508850 476.503754,622.943970 
	C479.090149,625.104187 481.676544,627.264343 484.262970,629.424500 
	C484.107635,629.883179 483.952271,630.341797 483.796936,630.800476 
	C482.119446,630.944885 480.441956,631.089294 478.370483,631.366638 
	C475.331238,629.591125 472.685974,627.682678 469.961578,625.449463 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M463.536621,633.314819 
	C464.369537,633.680908 464.850739,633.939392 465.599121,634.266724 
	C468.491028,635.072693 471.115753,635.809814 473.884583,636.587402 
	C472.496033,638.939453 470.449982,640.124451 466.897461,638.045288 
	C463.142029,635.847412 459.116425,634.111206 455.208862,632.173340 
	C455.443207,631.570374 455.677551,630.967468 455.911865,630.364563 
	C458.336212,631.312073 460.760559,632.259644 463.536621,633.314819 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M439.916199,618.450195 
	C443.795715,619.072815 447.752594,620.020996 452.152252,620.956848 
	C452.780579,622.373535 452.966125,623.802612 452.936554,625.491211 
	C452.165619,625.697815 451.609802,625.644775 450.590576,625.402344 
	C449.758179,625.070435 449.389130,624.927795 449.020111,624.785217 
	C449.020111,624.785217 448.778503,624.637329 448.474548,624.386108 
	C447.441101,623.777771 446.711609,623.420654 445.982117,623.063477 
	C443.985931,621.634216 441.989716,620.205017 439.916199,618.450195 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M461.962402,645.007324 
	C456.796997,646.331116 451.631592,647.654846 446.067810,649.026917 
	C450.239410,642.039856 457.040100,642.020020 464.466583,643.613525 
	C463.799316,644.368225 462.880859,644.687805 461.962402,645.007324 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M438.262604,630.433960 
	C439.952942,629.560669 441.959595,628.926758 444.232025,627.950256 
	C445.222992,627.915222 445.948181,628.222778 446.893768,628.739502 
	C444.951782,632.902344 441.481903,630.384949 438.262604,630.433960 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M467.481018,603.825317 
	C466.694794,604.143311 466.150146,604.079346 465.327820,604.028625 
	C464.809631,602.847778 464.569061,601.653748 464.464508,600.111206 
	C465.720825,600.505066 466.841156,601.247375 467.974915,602.284668 
	C467.899750,602.867554 467.811188,603.155518 467.481018,603.825317 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M461.987274,645.371216 
	C462.880859,644.687805 463.799316,644.368225 464.793457,643.749512 
	C465.594757,644.067505 466.320312,644.684692 466.990112,645.648376 
	C465.500488,646.584412 464.066620,647.173950 462.303253,647.840942 
	C461.986542,647.190613 461.999329,646.462891 461.987274,645.371216 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M465.890228,596.807983 
	C465.456543,597.348145 464.982635,597.611938 464.252808,597.969971 
	C464.086304,597.108582 464.175751,596.152771 464.589508,595.178589 
	C465.225922,595.617249 465.537994,596.074402 465.890228,596.807983 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M446.049469,623.411011 
	C446.711609,623.420654 447.441101,623.777771 448.334930,624.410034 
	C447.705109,624.376404 446.910950,624.067505 446.049469,623.411011 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M441.402893,626.157715 
	C440.721924,626.263977 439.935028,626.191589 438.993652,625.836975 
	C439.291718,625.447083 439.744324,625.339417 440.549774,625.244751 
	C440.961639,625.537781 441.093079,625.778198 441.402893,626.157715 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M437.962463,616.356567 
	C438.205048,616.269775 438.487366,616.444580 438.827698,616.870728 
	C438.591217,616.954102 438.296692,616.786133 437.962463,616.356567 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M449.169556,625.065674 
	C449.389130,624.927795 449.758179,625.070435 450.311829,625.451416 
	C450.103973,625.575256 449.711517,625.460693 449.169556,625.065674 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M405.575806,290.039856 
	C405.885101,289.985413 405.926361,290.224792 405.926819,290.343079 
	C405.860565,291.029449 405.793823,291.597565 405.642029,292.583984 
	C405.460144,292.032959 405.363342,291.063629 405.575806,290.039856 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M358.307953,291.230713 
	C358.516907,286.601868 358.725861,281.973022 359.526672,277.076630 
	C362.682587,279.415131 365.301117,281.970306 367.796112,284.640869 
	C370.580566,287.621277 374.093231,290.292480 375.829712,293.817169 
	C383.692474,309.777252 391.039764,325.991272 398.147339,342.053833 
	C395.316925,341.376282 392.911774,340.758759 390.506622,340.141235 
	C390.147736,340.633118 389.788818,341.125000 389.429901,341.616913 
	C393.197205,345.626892 396.964478,349.636902 400.816956,354.005920 
	C405.835907,360.681244 410.769684,366.997559 415.777710,373.640381 
	C417.183441,375.599823 418.514893,377.232727 419.846375,378.865631 
	C420.252960,378.588776 420.659546,378.311920 421.066132,378.035065 
	C419.365570,374.359650 417.665009,370.684265 415.919830,366.643555 
	C411.210663,352.710510 406.546082,339.142761 402.268890,325.606384 
	C407.871765,330.614777 412.929260,335.772552 418.352112,340.512329 
	C422.788849,344.390167 425.649078,348.912445 426.284149,355.158813 
	C427.665253,360.583679 429.127014,365.613617 430.588745,370.643555 
	C431.122131,370.506805 431.655518,370.370026 432.188904,370.233276 
	C430.948425,364.388458 429.707947,358.543671 428.415741,352.356567 
	C428.313660,351.324646 428.263306,350.635071 428.470856,349.696655 
	C431.610687,347.139679 433.159607,346.888214 434.252502,351.385345 
	C435.281860,355.621124 433.436646,360.924469 438.187775,364.013916 
	C438.725098,365.457214 439.262421,366.900543 439.660400,368.783142 
	C439.642548,369.485443 439.764008,369.748474 439.885468,370.011505 
	C439.937103,370.751709 439.988770,371.491882 439.747620,372.859406 
	C439.734711,375.855469 439.312469,378.635742 440.417328,380.520996 
	C444.952454,388.259277 449.814728,395.818512 454.850983,403.243988 
	C456.799377,406.116730 457.898773,408.265076 453.971069,410.098877 
	C452.603088,410.005981 451.235077,409.913086 449.345612,409.408203 
	C445.348389,408.329376 441.898132,407.343079 438.391541,407.063568 
	C431.519379,406.515808 424.924255,406.230591 421.464355,398.480225 
	C420.428131,396.158936 417.112579,394.855133 414.841248,393.085175 
	C412.519073,390.052216 410.196899,387.019287 407.903748,383.241882 
	C407.507965,378.749603 405.904297,375.947296 401.946014,375.033661 
	C401.617188,374.606628 401.288361,374.179596 400.963196,373.063354 
	C401.207153,370.100983 400.539490,368.680939 397.901733,369.111938 
	C397.901733,369.111938 397.969025,369.079407 397.961182,368.693756 
	C397.572113,365.423462 396.813477,362.878754 393.137604,362.961761 
	C391.989044,362.298981 390.840485,361.636169 389.282745,360.549011 
	C385.464233,358.326569 383.870758,355.737854 383.812256,351.652374 
	C383.775391,349.076508 382.117798,346.523834 381.187195,343.960724 
	C381.088562,342.597748 380.989899,341.234741 381.199829,339.186646 
	C381.547363,335.249908 383.840973,331.657867 380.070984,328.981384 
	C379.500000,327.805817 378.929047,326.630219 378.340179,324.854919 
	C375.657959,319.833862 372.993652,315.412537 370.210693,310.638733 
	C368.871582,307.789001 367.900085,305.125824 366.372162,302.833527 
	C364.096222,299.418945 361.427551,296.266144 358.926025,293.001923 
	C358.926025,293.001923 358.998138,292.999756 358.963165,292.781677 
	C358.721436,292.119324 358.514679,291.675018 358.307953,291.230713 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M438.187256,363.590790 
	C433.436646,360.924469 435.281860,355.621124 434.252502,351.385345 
	C433.159607,346.888214 431.610687,347.139679 428.109558,349.550781 
	C425.987946,343.250397 432.314514,347.617432 433.975983,344.620880 
	C429.054504,340.171692 424.017761,335.618347 419.032562,330.729675 
	C420.379242,329.268280 421.674347,328.142242 422.969452,327.016174 
	C426.107117,329.905731 429.244812,332.795288 432.673462,335.834747 
	C434.232117,339.428192 435.499725,342.871765 436.886749,346.650391 
	C436.850616,349.962921 436.434875,352.956726 436.620361,355.912781 
	C436.773590,358.354218 437.637665,360.751068 438.187256,363.590790 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M454.242981,410.343079 
	C457.898773,408.265076 456.799377,406.116730 454.850983,403.243988 
	C449.814728,395.818512 444.952454,388.259277 440.417328,380.520996 
	C439.312469,378.635742 439.734711,375.855469 439.742157,373.230530 
	C442.868225,385.080414 451.784027,393.751007 457.645325,404.148315 
	C458.899353,406.372833 460.084259,408.636322 461.801270,411.805023 
	C458.596527,411.269440 456.555695,410.928345 454.242981,410.343079 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M414.880005,393.444580 
	C417.112579,394.855133 420.428131,396.158936 421.464355,398.480225 
	C424.924255,406.230591 431.519379,406.515808 438.391541,407.063568 
	C441.898132,407.343079 445.348389,408.329376 448.942108,409.330994 
	C442.992981,409.135590 436.927399,408.587219 430.858276,408.080963 
	C426.157562,407.688843 422.331085,406.043579 419.978302,401.572998 
	C418.545197,398.849945 416.621857,396.384949 414.880005,393.444580 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M370.329346,310.991211 
	C372.993652,315.412537 375.657959,319.833862 378.203003,324.545685 
	C377.004120,323.589752 375.924530,322.343292 374.592896,320.906616 
	C372.579895,317.723328 370.818909,314.730316 369.340881,311.386749 
	C369.859009,311.021210 370.094177,311.006195 370.329346,310.991211 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M381.127991,344.381470 
	C382.117798,346.523834 383.775391,349.076508 383.812256,351.652374 
	C383.870758,355.737854 385.464233,358.326569 388.958984,360.454773 
	C384.835602,360.874237 382.742706,358.774597 382.366516,354.615936 
	C382.069489,351.332428 381.511139,348.072601 381.127991,344.381470 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M401.987946,375.383698 
	C405.904297,375.947296 407.507965,378.749603 407.873535,382.893921 
	C405.886169,380.771484 403.958038,378.252594 401.987946,375.383698 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M380.005859,329.425140 
	C383.840973,331.657867 381.547363,335.249908 381.197327,338.776062 
	C380.571075,335.990051 380.255920,332.929474 380.005859,329.425140 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M393.231659,363.274963 
	C396.813477,362.878754 397.572113,365.423462 397.924133,368.688965 
	C396.371857,367.242615 394.848785,365.415405 393.231659,363.274963 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M397.942078,369.433777 
	C400.539490,368.680939 401.207153,370.100983 400.923645,372.785889 
	C399.914398,372.050293 398.948425,370.902924 397.942078,369.433777 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M439.911377,369.756226 
	C439.764008,369.748474 439.642548,369.485443 439.653748,369.116455 
	C439.836700,369.173950 439.886993,369.337433 439.911377,369.756226 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M550.054810,649.359863 
	C550.682190,647.923645 551.336975,646.818970 552.032043,645.385742 
	C554.347229,641.283813 556.622131,637.510437 559.121582,633.833374 
	C559.513245,634.688965 559.680420,635.448242 559.837891,636.598083 
	C557.365906,642.344727 557.446289,647.636780 560.615479,652.888672 
	C561.328857,653.509155 561.654358,654.101807 562.009399,654.931763 
	C562.021545,655.803833 562.003967,656.438721 561.991455,657.547363 
	C561.526978,659.002563 561.057495,659.983887 560.022766,662.146729 
	C557.789551,657.637512 555.867493,653.756653 553.945801,649.876587 
	C553.023315,649.832397 551.552734,649.761902 550.054810,649.359863 
M560.467590,656.594299 
	C560.467590,656.594299 560.412476,656.494080 560.467590,656.594299 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M521.353210,680.960693 
	C520.980103,680.146240 520.996033,679.438049 521.299072,678.348145 
	C522.068848,677.653564 522.551575,677.340637 523.358459,677.005859 
	C524.115601,676.971069 524.548523,676.958130 525.224976,677.058899 
	C525.993835,676.813416 526.519348,676.454224 527.308350,676.127563 
	C527.745056,676.196899 527.918152,676.233765 528.091614,676.655151 
	C529.527771,677.683105 530.921631,678.752930 532.406433,678.899109 
	C540.396606,679.685242 548.403625,680.352295 556.419800,680.778320 
	C557.902466,680.857178 559.453918,679.642700 561.291626,678.891296 
	C562.931946,678.480591 564.254395,678.203735 565.576782,677.926941 
	C564.158264,681.260010 561.750854,683.145752 558.015869,682.955933 
	C545.923889,682.341370 533.833374,681.698792 521.353210,680.960693 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M565.678101,677.623169 
	C564.254395,678.203735 562.931946,678.480591 560.844849,678.877930 
	C554.871094,678.646179 549.647278,678.422546 544.466187,677.827148 
	C543.493591,677.715332 542.691772,676.117859 542.257812,675.150879 
	C547.280334,675.627991 551.846619,676.358276 556.437561,676.582092 
	C557.989380,676.657776 559.603699,675.450684 561.189453,674.829773 
	C561.896667,674.918274 562.603882,675.006775 563.771484,675.323975 
	C564.646973,675.729431 565.062073,675.906128 565.477234,676.082886 
	C565.577942,676.495056 565.678650,676.907227 565.678101,677.623169 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M565.725830,675.791870 
	C565.062073,675.906128 564.646973,675.729431 564.127197,675.347229 
	C564.176697,674.542969 564.330811,673.944275 564.724731,673.140503 
	C565.301086,673.790527 565.637756,674.645691 565.725830,675.791870 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M675.994507,462.986053 
	C675.565918,463.760284 675.137329,464.534485 674.547424,465.501343 
	C670.488770,466.340393 666.591309,466.986755 661.962097,467.797302 
	C660.091553,468.444000 658.391052,468.608826 657.908386,469.462341 
	C655.424622,473.854797 653.463257,478.548248 650.895813,482.885803 
	C649.319397,485.549194 646.982361,487.762451 644.986877,490.177856 
	C644.986877,490.177856 644.948669,490.095337 644.927979,490.054565 
	C648.294678,483.284546 651.829346,476.624054 655.014709,469.800476 
	C656.943970,465.667480 659.924927,463.149780 664.907837,461.987213 
	C666.058777,461.647736 666.532471,461.334930 667.006165,461.022064 
	C668.712402,461.010162 670.418640,460.998291 672.738770,461.238159 
	C674.233276,461.988647 675.113892,462.487366 675.994507,462.986053 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M644.989014,490.536530 
	C646.982361,487.762451 649.319397,485.549194 650.895813,482.885803 
	C653.463257,478.548248 655.424622,473.854797 657.908386,469.462341 
	C658.391052,468.608826 660.091553,468.444000 661.611694,467.977539 
	C658.683105,475.328796 655.617126,482.792236 651.881531,489.903961 
	C651.011658,491.560028 647.864807,492.020050 645.370605,493.048279 
	C644.980835,492.342499 644.986023,491.618835 644.989014,490.536530 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M724.044556,343.427429 
	C720.473999,347.291504 716.963745,350.702026 713.451904,354.110870 
	C711.669922,355.840546 709.885132,357.567261 707.776184,359.367981 
	C708.251892,345.477875 708.216858,331.158478 724.104126,322.432404 
	C724.104126,329.705231 724.104126,336.339203 724.044556,343.427429 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M664.281372,415.863190 
	C662.817383,415.713440 661.621643,415.520691 660.204956,415.563171 
	C658.500610,415.703857 657.017151,415.609283 655.320312,415.147614 
	C655.287659,414.276154 655.468445,413.771820 655.945068,413.181030 
	C658.570618,411.245087 660.780640,409.214813 663.251709,407.578857 
	C671.775085,401.936188 679.352600,395.671143 683.086609,385.535980 
	C684.275513,382.308929 687.617493,379.875122 689.974243,377.078339 
	C689.613708,378.782745 689.253235,380.487152 688.636719,382.827240 
	C688.264343,384.653351 688.147949,385.843781 688.031616,387.034210 
	C687.347595,389.431732 686.663574,391.829224 685.707520,394.830383 
	C683.397095,398.184784 681.609070,401.175110 679.260864,403.629395 
	C675.839233,407.205505 672.014587,410.395844 668.062378,413.770142 
	C667.050842,414.417572 666.338623,415.045563 665.626465,415.673584 
	C665.267517,415.722473 664.908630,415.771332 664.281372,415.863190 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M666.045593,415.836182 
	C666.338623,415.045563 667.050842,414.417572 668.511841,413.843567 
	C673.547852,414.599060 677.866211,415.151855 682.114685,416.039001 
	C687.690308,417.203217 690.384888,414.158417 692.178589,409.604828 
	C694.515503,403.671997 696.848328,397.737030 699.117065,391.777924 
	C701.482300,385.565430 704.751221,379.564545 703.856262,372.544586 
	C707.980469,368.684448 712.104675,364.824280 716.568420,360.935974 
	C714.546814,364.398529 711.679749,367.655151 709.933289,371.430206 
	C706.628845,378.572845 704.007812,386.029449 701.028320,393.325195 
	C698.079956,400.544708 695.176025,407.789246 691.925232,414.872589 
	C691.268921,416.302643 689.097412,418.032867 687.707581,417.963348 
	C680.611633,417.608215 673.542969,416.708191 666.045593,415.836182 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M500.793823,538.837036 
	C501.084473,539.124634 501.056213,539.450500 501.111877,540.606079 
	C506.974854,545.576416 513.563232,545.047729 520.117615,544.715454 
	C521.372375,544.421753 522.627136,544.128113 523.916016,543.460999 
	C524.622925,544.822998 525.295715,546.558411 526.448608,549.532349 
	C522.023132,549.532349 518.536133,549.715515 515.076233,549.487732 
	C510.341705,549.176025 505.484406,547.492920 501.274780,551.120911 
	C500.638184,551.669556 500.401825,552.682495 499.720398,554.106873 
	C493.358643,557.634705 487.256866,560.536377 480.914001,563.319336 
	C480.494293,563.186707 480.315674,563.172791 480.137024,563.158875 
	C479.510925,561.948792 478.884827,560.738708 478.283691,558.923767 
	C481.964966,556.001709 485.621246,553.684509 489.610107,551.322021 
	C490.973938,550.935425 492.005157,550.594177 493.339294,550.223877 
	C494.125702,549.880310 494.609192,549.565796 495.510986,549.274353 
	C497.899963,549.135803 499.870667,548.974121 502.344025,548.771179 
	C500.879486,546.483704 499.882111,544.925842 498.884705,543.367981 
	C499.350342,541.847595 496.598602,539.188416 500.793823,538.837036 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M441.437866,541.949951 
	C441.099457,541.871338 441.045624,541.436279 441.011475,541.219727 
	C439.987122,537.886780 438.996918,534.770386 438.047363,531.253662 
	C439.081299,531.255676 440.074554,531.657959 441.490753,532.503479 
	C445.677673,535.323730 449.593628,537.495667 453.160889,540.138306 
	C456.401489,542.538940 458.809113,542.402161 461.258301,538.822510 
	C464.073364,537.434875 466.551514,536.154724 469.361389,534.806091 
	C471.108368,534.119812 472.523682,533.502136 473.938995,532.884399 
	C471.595398,541.119812 456.158020,548.196411 448.970459,546.797791 
	C446.361816,546.290100 444.162384,543.679626 441.437866,541.949951 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M498.469788,543.289917 
	C499.882111,544.925842 500.879486,546.483704 502.344025,548.771179 
	C499.870667,548.974121 497.899963,549.135803 495.463684,548.878784 
	C492.194122,546.618591 488.664612,544.002258 486.306824,547.617554 
	C484.164551,550.902283 482.025848,551.019653 479.015839,550.499207 
	C474.536377,549.724731 470.057373,548.947815 465.578156,548.171936 
	C471.341278,541.798401 477.804993,538.221741 486.798798,541.505371 
	C490.292786,542.781006 494.287994,542.683777 498.469788,543.289917 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M465.350800,548.421326 
	C470.057373,548.947815 474.536377,549.724731 479.015839,550.499207 
	C482.025848,551.019653 484.164551,550.902283 486.306824,547.617554 
	C488.664612,544.002258 492.194122,546.618591 495.045380,548.855713 
	C494.609192,549.565796 494.125702,549.880310 493.194275,549.881592 
	C491.813202,549.166687 490.880066,548.765076 489.946960,548.363464 
	C489.723816,549.364746 489.500671,550.366028 489.277527,551.367310 
	C485.621246,553.684509 481.964966,556.001709 478.140045,558.607422 
	C474.214478,556.930176 470.334747,555.156433 466.777832,552.878418 
	C465.749756,552.220093 465.649200,550.113403 465.350800,548.421326 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M501.471619,563.534912 
	C496.116516,568.422729 490.416534,570.728943 483.144226,565.796387 
	C482.055878,565.400940 481.586700,565.109558 481.117554,564.818176 
	C481.117554,564.818176 481.064667,564.383789 481.131500,564.064575 
	C481.198334,563.745361 481.354034,563.544067 481.734833,563.641113 
	C488.567627,563.670471 495.019623,563.602661 501.471619,563.534912 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M473.969604,532.667114 
	C472.523682,533.502136 471.108368,534.119812 469.211914,534.508911 
	C467.982025,532.779602 467.233276,531.278870 466.484497,529.778137 
	C469.080139,525.757935 472.214020,522.791199 477.999023,524.253784 
	C477.582672,526.269958 476.713257,528.158813 475.703613,530.375000 
	C475.563385,530.702271 475.248840,530.745728 474.845093,530.881287 
	C474.334473,531.353821 474.227600,531.690735 474.120667,532.027710 
	C474.120667,532.027710 474.000244,532.449768 473.969604,532.667114 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M477.584412,571.005310 
	C477.536682,571.710449 477.105164,572.338196 475.979675,573.035889 
	C471.248260,573.429077 467.210815,573.752319 463.173340,574.075562 
	C463.309753,573.050598 463.061127,571.563904 463.645721,571.076477 
	C467.137482,568.165100 472.828094,568.212402 477.584412,571.005310 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M463.104492,574.370605 
	C467.210815,573.752319 471.248260,573.429077 475.706482,573.150024 
	C472.992157,576.767639 469.144928,577.523193 464.353699,576.099731 
	C463.656769,575.640015 463.346222,575.152832 463.104492,574.370605 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M481.067902,565.180420 
	C481.586700,565.109558 482.055878,565.400940 482.764954,565.839233 
	C482.541962,566.314270 482.079071,566.642395 481.316772,566.987061 
	C481.017639,566.516602 481.017944,566.029602 481.067902,565.180420 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M480.178406,563.388794 
	C480.315674,563.172791 480.494293,563.186707 480.966675,563.339600 
	C481.260498,563.478577 481.354034,563.544067 481.354034,563.544067 
	C481.354034,563.544067 481.198334,563.745361 481.120728,563.846008 
	C480.695007,564.022217 480.420563,563.912903 480.178406,563.388794 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M474.318756,531.891663 
	C474.227600,531.690735 474.334473,531.353821 474.721283,530.980713 
	C474.939453,531.274414 474.778015,531.544800 474.318756,531.891663 
z"
      />
      <path
        fill="#925627"
        opacity="1.000000"
        stroke="none"
        d="
M422.892883,326.688171 
	C421.674347,328.142242 420.379242,329.268280 418.723694,330.591309 
	C413.102295,327.730499 407.841248,324.672760 402.299194,321.396790 
	C396.697357,319.474823 393.519348,315.826569 392.063507,310.479431 
	C391.589081,308.736908 390.813812,307.048920 389.982544,305.435730 
	C386.515594,298.707764 384.200623,290.821838 379.136047,285.631195 
	C373.426453,279.779419 365.217163,276.366608 358.095062,271.893005 
	C358.336365,265.602844 358.577667,259.312683 359.188751,252.678711 
	C361.023651,253.247833 362.488800,254.160782 363.953918,255.073715 
	C367.937866,257.984406 372.070374,260.715973 375.860504,263.860321 
	C379.117798,266.562592 381.984039,269.736237 385.182007,272.976624 
	C388.587341,281.050201 391.594879,288.961334 395.194153,296.593384 
	C396.706024,299.799225 399.213776,302.661743 401.713379,305.251190 
	C408.622406,312.408417 415.765656,319.339569 422.892883,326.688171 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M760.997009,194.002136 
	C760.721191,193.686783 760.448975,193.368729 760.176758,193.050690 
	C760.354248,192.912506 760.531799,192.774323 760.709351,192.636124 
	C760.829773,192.906769 760.950195,193.177414 761.040283,193.719482 
	C761.009888,193.990875 761.000610,193.999451 760.997009,194.002136 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M751.062073,195.950775 
	C751.310303,196.053055 751.469727,196.240463 751.629211,196.427887 
	C751.427124,196.461624 751.224976,196.495346 750.912720,196.370987 
	C750.802612,196.212891 750.973328,196.035889 751.062073,195.950775 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M520.403503,334.008240 
	C520.005676,337.436157 519.276245,340.969269 518.267212,344.749512 
	C515.679565,340.793854 517.179810,337.320374 520.403503,334.008240 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M512.444824,298.016632 
	C511.971344,297.609283 511.956482,297.265900 512.404297,296.619995 
	C516.348022,296.274902 519.829102,296.232300 523.332214,296.221985 
	C523.354309,296.254272 523.432251,296.247894 523.432251,296.247894 
	C523.625488,296.620453 523.818787,296.992981 524.002197,297.682983 
	C520.296021,298.027130 516.599670,298.053894 512.444824,298.016632 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M524.354980,309.001709 
	C524.632812,310.095917 524.608093,311.301514 524.321777,312.757751 
	C524.057678,311.709930 524.055054,310.411530 524.354980,309.001709 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M523.372192,317.976837 
	C523.607788,318.782715 523.557678,319.680573 523.229736,320.784790 
	C522.996765,320.016998 523.041626,319.042938 523.372192,317.976837 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M512.504883,338.471252 
	C512.504395,338.500488 512.505310,338.442047 512.504883,338.471252 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M554.015015,580.015503 
	C552.895020,580.616943 551.827454,581.385681 550.636047,581.759521 
	C549.875000,581.998291 548.930786,581.653015 548.015747,581.244995 
	C550.617981,575.882629 553.273071,570.844727 556.121704,565.051819 
	C557.043579,560.364807 558.292847,556.363220 554.804688,552.994812 
	C553.925476,551.572937 553.043945,550.152405 552.167480,548.728882 
	C548.884888,543.397644 545.603882,538.065491 542.999573,531.692566 
	C547.076904,533.795227 551.154236,535.897827 555.903687,538.161011 
	C560.972656,542.302063 564.273438,546.911926 564.746460,553.196350 
	C564.993469,554.263000 565.496704,555.131470 566.009888,556.442261 
	C565.952942,559.239746 565.886047,561.594910 565.517151,563.964050 
	C564.807678,563.988525 564.400146,563.999023 563.681030,563.878052 
	C562.662170,563.833313 561.482483,563.695557 561.318542,564.040588 
	C558.805603,569.327820 556.424988,574.677979 554.007874,580.008301 
	C554.002136,580.003174 554.015015,580.015503 554.015015,580.015503 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M530.006897,519.982971 
	C530.006897,519.982971 529.516663,520.042053 528.883667,520.022156 
	C523.184937,518.295959 518.119263,516.589722 512.978577,514.536865 
	C511.843597,513.487061 510.874939,512.477295 509.708923,512.129822 
	C501.398041,509.653137 492.976532,507.523895 484.751038,504.798706 
	C482.260315,503.973511 480.276611,501.617950 478.417725,500.043152 
	C480.414154,500.494965 482.053528,500.866974 484.094849,501.261475 
	C489.004486,501.949768 493.512115,502.615601 498.106445,503.616699 
	C503.148834,505.625183 508.104553,507.298340 513.441284,509.003815 
	C515.859619,509.652466 517.906921,510.237946 519.932617,510.890259 
	C529.303101,513.907776 538.667603,516.943787 548.211365,520.252930 
	C549.235901,520.709473 550.083313,520.886292 550.939697,521.074463 
	C550.948608,521.085754 550.918396,521.091431 550.845703,521.348450 
	C550.728516,521.777893 550.684082,521.950378 550.295288,522.101196 
	C548.334473,522.360840 546.717834,522.642151 544.904541,522.693481 
	C544.142151,522.270020 543.576416,522.076538 542.949707,521.541504 
	C540.905884,520.815002 538.922913,520.430054 536.583984,519.993164 
	C533.146790,518.591492 530.065613,517.241699 526.819885,515.819824 
	C528.083984,517.471069 529.045410,518.727051 530.006897,519.982971 
M522.197571,514.772827 
	C522.135864,514.592896 522.074158,514.412964 522.012451,514.233032 
	C521.954346,514.413391 521.896179,514.593689 522.197571,514.772827 
M524.523315,515.388916 
	C524.523315,515.388916 524.426392,515.546509 524.426392,515.546509 
	C524.426392,515.546509 524.621643,515.528198 524.523315,515.388916 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M525.895752,587.781128 
	C523.547363,588.560242 521.199036,589.339417 518.421143,589.731567 
	C517.970276,589.076416 517.948914,588.808411 517.927612,588.540466 
	C522.184509,585.920715 526.441467,583.300903 530.853638,580.381836 
	C537.342041,576.477783 541.903259,571.240662 545.155029,564.781616 
	C546.026794,563.049988 546.987000,561.362854 548.232727,559.328003 
	C548.745667,558.984497 548.932434,558.968262 549.119263,558.952087 
	C549.060181,560.350464 549.001099,561.748779 548.672119,563.790649 
	C544.985107,576.154541 535.548279,582.071777 525.895752,587.781128 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M525.936279,588.215332 
	C535.548279,582.071777 544.985107,576.154541 548.665771,564.210632 
	C550.010803,564.976990 551.092285,565.966858 552.518005,566.951660 
	C550.465698,574.584717 544.992493,579.781006 538.657288,584.046814 
	C535.000732,586.508911 530.806091,588.171997 526.494995,590.293701 
	C526.083130,589.811646 526.029968,589.230591 525.936279,588.215332 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M565.002808,552.998230 
	C564.273438,546.911926 560.972656,542.302063 556.271606,538.166748 
	C555.705261,537.258789 555.443115,536.505676 555.446106,535.428162 
	C556.268127,535.062012 556.825012,535.020264 557.700806,535.019897 
	C568.137573,541.160767 573.515137,560.368103 566.599060,566.817444 
	C566.311523,565.760315 566.065369,564.855225 565.819214,563.950073 
	C565.886047,561.594910 565.952942,559.239746 566.013306,556.103882 
	C565.672119,554.548218 565.337463,553.773254 565.002808,552.998230 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M557.381836,534.978516 
	C556.825012,535.020264 556.268127,535.062012 555.294983,535.161560 
	C552.117798,533.226196 549.356934,531.232971 546.140015,528.814941 
	C543.454468,526.939148 541.225037,525.488281 538.826477,523.784424 
	C538.087708,523.376038 537.517944,523.220642 536.948242,523.065186 
	C536.541321,523.021851 536.134399,522.978516 535.328613,522.597046 
	C533.944763,521.860229 532.959656,521.461487 531.974609,521.062805 
	C531.513123,520.737305 531.051636,520.411865 530.298523,520.034668 
	C529.045410,518.727051 528.083984,517.471069 526.819885,515.819824 
	C530.065613,517.241699 533.146790,518.591492 536.890503,520.139099 
	C539.367676,521.224915 541.182251,522.112854 543.244751,523.143433 
	C543.981812,523.584473 544.471130,523.882874 545.131470,524.426208 
	C546.183228,525.134216 547.063843,525.597168 548.141235,526.282410 
	C548.878357,526.745422 549.418823,526.986084 550.091675,527.472900 
	C550.823486,528.129639 551.422729,528.540222 552.339722,529.022034 
	C553.088135,529.085266 553.518738,529.077271 553.923218,529.080261 
	C553.896973,529.091309 553.871155,529.141968 553.902283,529.485535 
	C555.082886,531.545593 556.232361,533.262085 557.381836,534.978516 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M513.053589,514.883423 
	C518.119263,516.589722 523.184937,518.295959 528.638672,520.052612 
	C528.839539,520.951782 528.652405,521.800720 528.191284,522.845703 
	C523.186401,521.055908 518.455505,519.070068 513.365234,516.686279 
	C513.021790,515.820129 513.037659,515.351746 513.053589,514.883423 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M528.130249,576.705933 
	C525.220032,578.632996 522.496704,580.299988 519.773376,581.966980 
	C519.424683,581.429260 519.075989,580.891541 518.727295,580.353760 
	C522.657104,577.535767 526.656921,574.816101 531.682129,573.008911 
	C530.811218,574.155029 529.564209,575.300415 528.130249,576.705933 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M554.852417,553.416138 
	C558.292847,556.363220 557.043579,560.364807 556.132935,564.663940 
	C555.270386,565.047363 554.590271,565.063660 553.576904,565.125610 
	C553.795837,561.393311 554.347961,557.615356 554.852417,553.416138 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M538.995544,524.037415 
	C541.225037,525.488281 543.454468,526.939148 545.820435,528.692139 
	C543.342651,527.890015 540.728271,526.785828 538.271362,525.223877 
	C538.696533,524.584595 538.885437,524.341675 538.995544,524.037415 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M547.968567,553.007324 
	C547.579956,551.275146 547.191284,549.542908 546.802673,547.810730 
	C547.464905,547.622437 548.127197,547.434143 548.789429,547.245850 
	C549.196655,548.887878 549.603882,550.529846 549.671631,552.580566 
	C548.877625,552.995300 548.423096,553.001343 547.968567,553.007324 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M547.974121,553.432739 
	C548.423096,553.001343 548.877625,552.995300 549.673096,552.984863 
	C549.896790,554.797729 549.779663,556.614990 549.390869,558.692139 
	C548.932434,558.968262 548.745667,558.984497 548.278564,558.975708 
	C547.992126,557.253174 547.985901,555.555664 547.974121,553.432739 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M531.982666,521.397827 
	C532.959656,521.461487 533.944763,521.860229 535.021851,522.586853 
	C534.072876,522.520813 533.031799,522.126831 531.982666,521.397827 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M538.826477,523.784424 
	C538.885437,524.341675 538.696533,524.584595 538.219849,524.870972 
	C537.679138,524.531067 537.347351,524.086304 536.981934,523.353394 
	C537.517944,523.220642 538.087708,523.376038 538.826477,523.784424 
z"
      />
      <path
        fill="#9A8870"
        opacity="1.000000"
        stroke="none"
        d="
M613.585449,354.703735 
	C613.639221,355.835663 613.479370,356.694275 612.861206,357.791382 
	C611.072632,356.250763 609.742310,354.471619 608.412048,352.692505 
	C608.161926,351.804840 607.911804,350.917206 607.685303,349.685272 
	C607.847412,347.990265 608.204956,346.620636 608.090393,345.291748 
	C607.027039,332.965546 605.962341,320.638031 604.684509,308.333069 
	C604.465332,306.222931 603.236938,304.217590 602.558105,302.028656 
	C604.067322,301.217133 605.429810,300.264526 606.931824,299.920074 
	C610.434021,299.116882 614.003296,298.606262 617.545410,297.977142 
	C617.557495,306.651825 618.115967,315.369324 617.439819,323.990021 
	C616.640503,334.180481 614.775085,344.287323 613.585449,354.703735 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M618.185425,277.246094 
	C617.918518,281.907471 617.651611,286.568878 616.752014,291.498932 
	C614.408752,291.792145 612.698242,291.816681 610.683838,291.629822 
	C608.343811,291.355469 606.307678,291.292511 604.227966,290.753784 
	C604.597900,275.192719 600.600037,276.737762 618.185425,277.246094 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M618.533936,277.155884 
	C600.600037,276.737762 604.597900,275.192719 604.145874,291.157043 
	C603.966064,298.287720 605.310425,299.220673 611.428284,296.853271 
	C613.568542,296.858215 615.277588,296.827240 616.986633,296.796265 
	C617.083069,296.991333 617.179504,297.186432 617.410645,297.679352 
	C614.003296,298.606262 610.434021,299.116882 606.931824,299.920074 
	C605.429810,300.264526 604.067322,301.217133 602.250977,301.801147 
	C601.840820,301.508759 601.821045,301.308685 601.760498,300.809143 
	C601.651184,296.633301 601.582764,292.756927 601.500366,288.458130 
	C601.581177,286.378876 601.724121,284.723175 601.762634,283.065002 
	C601.982056,273.624207 599.887085,274.218018 610.988342,274.214539 
	C614.230713,274.213501 617.473083,274.214386 620.715393,274.214386 
	C620.784851,274.636322 620.854248,275.058228 620.923706,275.480164 
	C620.243286,276.008667 619.562927,276.537170 618.533936,277.155884 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M616.966064,296.394287 
	C615.277588,296.827240 613.568542,296.858215 611.433594,296.440552 
	C611.001038,294.608337 610.994385,293.224762 610.987671,291.841187 
	C612.698242,291.816681 614.408752,291.792145 616.538696,291.859558 
	C616.953979,293.298431 616.949768,294.645386 616.966064,296.394287 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M575.026978,509.914703 
	C573.743103,508.519470 572.357971,507.202881 571.198975,505.710632 
	C569.438171,503.443420 567.834229,501.054352 566.083557,498.604950 
	C577.343567,504.863739 587.740112,511.199036 598.648010,516.477478 
	C604.343994,519.233826 610.981995,519.997559 617.105591,521.941406 
	C619.173828,522.597961 620.968384,524.116760 622.980103,525.920410 
	C623.715637,527.067017 624.359070,527.534729 625.002441,528.002441 
	C625.002441,528.002441 625.000000,528.000000 625.189819,528.277039 
	C628.915405,531.040833 632.451172,533.527649 635.986877,536.014404 
	C638.968872,539.108459 641.950928,542.202454 644.592041,545.639771 
	C641.501160,544.166260 638.779602,542.304382 635.991638,540.547974 
	C634.025330,539.309143 631.968872,538.213501 629.965759,537.042358 
	C629.978882,537.030823 629.965149,537.038940 629.942810,536.682861 
	C627.341125,531.550354 622.740662,530.099304 617.682251,529.026733 
	C617.454529,529.026550 617.000000,528.997559 616.945801,528.648682 
	C615.900818,527.875000 614.909912,527.450256 613.596680,526.877563 
	C607.862061,524.480896 602.449890,522.232300 596.692200,519.921143 
	C589.240112,516.543945 582.133545,513.229309 575.026978,509.914703 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M629.952637,537.053894 
	C631.968872,538.213501 634.025330,539.309143 635.991638,540.547974 
	C638.779602,542.304382 641.501160,544.166260 644.627441,545.985718 
	C649.598999,550.815918 650.681946,556.739014 647.441284,559.520630 
	C647.108154,559.806641 646.518372,559.793640 645.718567,559.905151 
	C645.327637,559.698303 645.265747,559.505676 645.202271,559.006836 
	C646.995361,554.705750 645.669128,551.704956 641.517334,548.644714 
	C640.562317,551.557312 639.979980,554.154419 638.837769,556.476135 
	C638.251282,557.668518 636.665649,558.369324 635.239014,558.757385 
	C634.265686,555.858276 633.584900,553.494019 632.938965,550.780334 
	C632.970520,550.196838 632.967224,549.962708 633.223450,549.514099 
	C635.763489,548.745239 636.615967,547.791443 635.032104,545.484375 
	C633.178467,542.784363 631.632202,539.873352 629.952637,537.053894 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M635.990662,535.634766 
	C632.451172,533.527649 628.915405,531.040833 625.187988,528.275818 
	C628.532532,529.475708 632.068787,530.953857 635.804932,532.704102 
	C636.001343,533.735718 635.997864,534.495422 635.990662,535.634766 
z"
      />
      <path
        fill="#0C1C1F"
        opacity="1.000000"
        stroke="none"
        d="
M649.584229,547.607971 
	C649.497803,547.678711 649.460449,547.422607 649.460449,547.422607 
	C649.460449,547.422607 649.670654,547.537231 649.584229,547.607971 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M476.371216,309.011475 
	C476.657532,310.093872 476.641754,311.290375 476.386230,312.752808 
	C476.120728,311.721008 476.094940,310.423248 476.371216,309.011475 
z"
      />
      <path
        fill="#0C1C1F"
        opacity="1.000000"
        stroke="none"
        d="
M517.531860,588.640381 
	C517.948914,588.808411 517.970276,589.076416 518.046631,589.745483 
	C517.307373,589.947205 516.513184,589.747864 515.615784,589.255371 
	C516.053711,588.888184 516.594910,588.814209 517.531860,588.640381 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M601.831787,630.745605 
	C600.015930,631.370056 598.010010,631.791321 595.984680,631.929932 
	C595.802063,631.942444 595.494568,630.131165 595.734863,629.271362 
	C596.809143,629.220398 597.393616,629.064880 597.978149,628.909424 
	C597.978149,628.909424 597.894714,628.926636 597.877563,628.887939 
	C599.119141,629.388245 600.377808,629.927124 601.831787,630.745605 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M589.308960,623.791504 
	C589.221191,622.792603 589.385620,621.535583 589.837769,620.121887 
	C589.937439,621.154602 589.749329,622.343994 589.308960,623.791504 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M610.914673,604.930054 
	C611.011108,604.498901 611.145203,604.097046 611.279297,603.695251 
	C611.336365,604.070496 611.393433,604.445679 611.238953,604.919312 
	C611.027405,605.017639 610.952271,604.959290 610.914673,604.930054 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M590.699951,618.445007 
	C590.527588,618.221802 590.589355,617.806152 590.947083,617.242920 
	C591.140076,617.481079 591.037109,617.866821 590.699951,618.445007 
z"
      />
      <path
        fill="#975624"
        opacity="1.000000"
        stroke="none"
        d="
M691.950134,368.646423 
	C691.526917,368.993103 691.120300,369.026764 690.074158,369.182617 
	C688.512634,369.767700 687.590759,370.230591 686.715759,370.669891 
	C685.735046,365.087402 684.821411,359.886932 684.050415,354.427002 
	C685.122070,353.425415 686.051086,352.683289 687.101196,352.126648 
	C687.522156,352.100891 687.821960,351.889618 688.254150,351.400696 
	C689.206970,349.998505 690.027405,348.873962 691.228088,347.228271 
	C689.800598,347.228271 688.938171,347.228271 688.185059,346.945129 
	C687.947205,345.849915 687.737671,344.434143 687.231506,344.318665 
	C681.862122,343.093719 676.445618,342.075562 671.041992,340.616913 
	C671.427673,338.479553 671.813293,336.725739 672.299316,334.734375 
	C672.394531,334.325104 672.389526,334.153290 672.570435,333.726807 
	C677.518188,329.610107 682.565247,326.040344 686.933044,321.774963 
	C689.492554,319.275452 691.087585,315.734039 692.893433,312.535431 
	C694.164673,310.283569 694.512939,307.280182 696.221252,305.546326 
	C702.865112,298.803070 709.887573,292.432770 717.141113,285.942017 
	C719.643005,286.314789 721.772949,286.669250 723.902832,287.023712 
	C723.919983,287.761597 723.937195,288.499451 723.555786,289.693878 
	C721.699402,296.049164 718.623413,301.072998 715.099915,305.959839 
	C713.341980,308.397919 712.427368,311.444122 711.131348,314.215271 
	C709.681702,316.174652 708.231995,318.134033 706.329956,319.900330 
	C705.196960,319.113586 704.516235,318.519958 703.990540,317.623840 
	C706.009338,314.786438 707.873108,312.251556 709.736877,309.716644 
	C709.344788,309.426270 708.952698,309.135895 708.560547,308.845551 
	C701.131653,315.280579 695.051147,322.821411 691.058960,332.179230 
	C692.911438,330.421814 694.763855,328.664398 696.916626,327.057007 
	C697.500244,328.811798 697.783508,330.416595 698.066833,332.021393 
	C698.033691,332.462280 698.000610,332.903137 697.611450,333.716370 
	C697.317810,334.946472 697.115479,335.954102 697.498474,336.630341 
	C698.264465,337.983185 699.351013,339.154572 700.305298,340.400879 
	C700.269043,341.056519 700.232788,341.712158 699.750000,342.692139 
	C694.865173,345.470978 692.985229,351.904022 695.801514,355.000061 
	C695.595520,355.806854 695.389526,356.613647 694.681274,357.752747 
	C692.871826,358.623016 691.564636,359.160919 690.512207,359.594025 
	C691.075806,362.338989 691.562744,364.710419 692.049622,367.081848 
	C692.022034,367.499023 691.994385,367.916229 691.950134,368.646423 
z"
      />
      <path
        fill="#975624"
        opacity="1.000000"
        stroke="none"
        d="
M661.879211,315.375671 
	C666.868713,311.428802 671.768005,307.360596 676.871704,303.567383 
	C682.593445,299.314850 688.795410,295.658875 694.208862,291.061005 
	C697.173523,288.542969 700.360962,284.862183 700.980713,281.278931 
	C702.745544,271.075470 709.104980,265.010498 717.658447,260.149597 
	C720.087341,261.255035 722.020325,262.134705 723.953247,263.014343 
	C723.961182,268.689209 723.969116,274.364105 723.560242,280.516663 
	C721.409241,282.036560 719.675049,283.078796 717.655823,283.982819 
	C715.952881,284.359467 714.337952,284.595490 713.149902,285.435455 
	C706.512146,290.128754 700.163269,295.256744 693.336792,299.647034 
	C689.371887,302.196960 686.523010,305.176422 686.483765,309.809326 
	C686.429565,316.198730 682.177673,319.071350 677.564697,321.831665 
	C676.151794,322.677124 674.606567,323.301544 672.879517,324.122131 
	C672.423706,324.483459 672.210388,324.749878 671.770874,325.102783 
	C671.140015,325.448669 670.735413,325.708069 669.953186,325.964600 
	C668.131592,325.454407 666.688293,324.523468 665.243347,324.520844 
	C661.247253,324.513611 660.685974,322.433624 661.403076,319.178986 
	C661.676819,317.936584 661.727051,316.644897 661.879211,315.375671 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M711.457764,314.110474 
	C712.427368,311.444122 713.341980,308.397919 715.099915,305.959839 
	C718.623413,301.072998 721.699402,296.049164 723.512024,290.060974 
	C725.101135,296.234955 722.469604,301.066040 718.395630,305.525818 
	C715.985596,308.164062 713.974670,311.166870 711.457764,314.110474 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M698.331299,331.822632 
	C697.783508,330.416595 697.500244,328.811798 697.064575,326.737488 
	C699.220032,323.487396 701.527771,320.706848 703.835571,317.926331 
	C704.516235,318.519958 705.196960,319.113586 706.016418,320.035889 
	C703.635376,324.117676 701.115540,327.870758 698.331299,331.822632 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M695.994690,354.675171 
	C692.985229,351.904022 694.865173,345.470978 699.686523,343.014587 
	C698.775696,346.791931 697.481812,350.571106 695.994690,354.675171 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M724.002319,262.565186 
	C722.020325,262.134705 720.087341,261.255035 717.982483,260.033325 
	C719.631348,258.159912 721.452148,256.628540 723.584778,254.986221 
	C723.948181,257.288849 723.999817,259.702454 724.002319,262.565186 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M717.940918,284.121063 
	C719.675049,283.078796 721.409241,282.036560 723.514893,280.980530 
	C723.934021,282.699371 723.981628,284.432037 723.966064,286.594177 
	C721.772949,286.669250 719.643005,286.314789 717.264160,285.696411 
	C717.323792,284.995361 717.632324,284.558228 717.940918,284.121063 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M692.337952,366.858032 
	C691.562744,364.710419 691.075806,362.338989 690.512207,359.594025 
	C691.564636,359.160919 692.871826,358.623016 694.528198,358.039246 
	C694.126953,360.873657 693.376648,363.753937 692.337952,366.858032 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M700.607544,340.245728 
	C699.351013,339.154572 698.264465,337.983185 697.498474,336.630341 
	C697.115479,335.954102 697.317810,334.946472 697.560486,334.044128 
	C699.554077,335.693146 703.575684,336.220703 700.607544,340.245728 
z"
      />
      <path
        fill="#0A2624"
        opacity="1.000000"
        stroke="none"
        d="
M578.352661,488.034485 
	C576.259460,487.413483 574.593018,486.757141 572.461121,485.697723 
	C571.020569,484.424561 570.045471,483.554443 569.078491,482.286560 
	C569.443359,479.645294 569.800110,477.401794 570.439453,475.208984 
	C571.102844,475.261566 571.483582,475.263428 571.926636,475.440796 
	C571.988892,475.616302 572.112976,475.967529 571.832153,476.177673 
	C570.998291,481.698853 575.459595,480.040863 578.078613,481.422974 
	C579.796936,482.174438 581.500549,483.003479 583.090820,482.824615 
	C590.596008,481.980530 598.078003,480.914337 605.552856,479.821533 
	C611.383057,478.969147 617.190552,477.961334 623.247314,477.102905 
	C623.945740,477.375427 624.404968,477.567596 625.199097,477.857117 
	C626.088989,478.325562 626.644043,478.696655 627.162964,479.285065 
	C627.126831,479.502411 627.157227,479.942017 626.998291,480.221069 
	C626.455322,481.246277 626.071228,481.992432 625.396484,482.760437 
	C624.719727,482.830444 624.333740,482.878540 623.561523,482.912903 
	C622.151855,482.966095 621.128479,483.033051 620.105042,483.099976 
	C609.760132,484.220367 599.411377,485.306641 589.072571,486.480408 
	C585.628418,486.871429 582.209717,487.486511 578.352661,488.034485 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M620.001160,483.453186 
	C621.128479,483.033051 622.151855,482.966095 623.644653,483.294250 
	C625.868713,483.915009 627.639099,484.414398 629.375061,484.314575 
	C634.399658,484.025543 639.410461,483.495575 644.426636,483.060150 
	C643.951904,484.431396 643.477234,485.802612 642.992676,487.546295 
	C642.509766,488.242615 642.036682,488.566498 641.275269,488.901672 
	C637.264282,488.121643 633.375183,486.211792 629.848633,486.737000 
	C616.237915,488.764099 602.743042,491.568726 588.842102,494.081787 
	C588.232239,494.040741 587.985168,494.001587 587.603027,493.650024 
	C590.987061,491.880157 594.506226,490.422699 598.025391,488.965271 
	C603.369568,487.967468 608.733459,487.062164 614.047729,485.924591 
	C616.056641,485.494568 617.950806,484.528259 620.001160,483.453186 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M597.595581,488.969360 
	C594.506226,490.422699 590.987061,491.880157 587.231812,493.595337 
	C584.212952,495.012573 581.430115,496.172089 578.792969,497.270966 
	C580.414185,492.234131 585.673218,489.800476 597.595581,488.969360 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M593.573364,501.448486 
	C593.607910,501.508392 593.538757,501.388611 593.573364,501.448486 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M589.001587,503.998596 
	C589.127625,504.159637 589.251953,504.322144 589.376343,504.484619 
	C589.275940,504.431335 589.175537,504.378052 589.036133,504.164337 
	C588.997070,504.003906 589.000000,504.000000 589.001587,503.998596 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M570.156860,475.158295 
	C569.800110,477.401794 569.443359,479.645294 568.695801,482.303528 
	C559.008362,485.542297 556.431213,494.228302 563.016846,500.540924 
	C562.994446,501.180603 562.972046,501.820251 562.576904,502.746216 
	C559.829285,500.537598 557.454285,498.042755 555.077393,495.183380 
	C555.413269,492.570557 555.751160,490.322235 556.299438,487.958069 
	C556.775696,487.641235 556.956177,487.381042 557.198608,486.990601 
	C557.209045,486.928589 557.072266,486.937653 556.717224,487.047729 
	C556.225952,487.339111 556.032471,487.590607 555.563721,487.955383 
	C549.702209,491.988037 549.588013,497.002289 555.106689,500.326294 
	C556.954529,502.381897 558.630432,504.153442 559.852051,506.017090 
	C559.107178,506.207092 558.816528,506.304932 558.193481,506.325256 
	C548.923035,501.108734 546.193726,496.554749 547.871826,488.996704 
	C551.796875,485.262146 555.445496,481.649689 559.465210,477.998779 
	C563.276489,477.026306 566.716675,476.092316 570.156860,475.158295 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M560.306335,505.924957 
	C558.630432,504.153442 556.954529,502.381897 555.120117,499.882507 
	C555.000854,497.952423 555.040100,496.750153 555.079346,495.547913 
	C557.454285,498.042755 559.829285,500.537598 562.543396,503.064453 
	C562.882568,503.096466 562.914368,503.074493 562.961243,503.384460 
	C563.658020,504.148468 564.307861,504.602478 564.957764,505.056488 
	C564.957764,505.056488 565.000671,505.029816 565.143616,505.286377 
	C565.849243,505.718384 566.411865,505.893768 566.974548,506.069153 
	C566.974548,506.069183 567.001282,506.006104 567.149536,506.270691 
	C567.857483,506.726624 568.417236,506.917999 568.976929,507.109375 
	C570.761963,508.040955 572.546997,508.972534 574.679504,509.909424 
	C582.133545,513.229309 589.240112,516.543945 596.515564,520.166138 
	C596.121521,520.657715 595.558655,520.841736 594.626831,520.968018 
	C586.534363,517.904968 578.810730,514.899475 570.902710,511.652039 
	C570.164368,511.154785 569.610474,510.899567 568.852600,510.386047 
	C565.867798,508.726776 563.087097,507.325867 560.306335,505.924957 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M563.054077,500.083435 
	C556.431213,494.228302 559.008362,485.542297 568.687622,482.701294 
	C570.045471,483.554443 571.020569,484.424561 572.114990,485.640259 
	C566.291016,488.591705 562.134155,492.394836 563.054077,500.083435 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M564.934204,504.725220 
	C564.307861,504.602478 563.658020,504.148468 562.977051,503.376648 
	C563.600830,503.503845 564.255676,503.948883 564.934204,504.725220 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M625.003723,527.665527 
	C624.359070,527.534729 623.715637,527.067017 623.036865,526.268921 
	C623.445496,525.953918 623.889465,525.969299 624.666748,525.982544 
	C625.001648,526.429749 625.003296,526.879150 625.003723,527.665527 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M566.822510,505.803162 
	C566.411865,505.893768 565.849243,505.718384 565.121948,505.291931 
	C565.528381,505.206329 566.099426,505.371765 566.822510,505.803162 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M568.826965,506.836975 
	C568.417236,506.917999 567.857483,506.726624 567.122437,506.291504 
	C567.523682,506.220062 568.100342,506.392303 568.826965,506.836975 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M571.087158,511.894043 
	C578.810730,514.899475 586.534363,517.904968 594.833252,521.248535 
	C598.609009,523.070557 601.809570,524.554443 605.010071,526.038330 
	C603.374268,526.806396 601.738464,527.574463 599.704834,528.635376 
	C597.799622,528.293274 596.292175,527.658325 594.784729,527.023376 
	C594.621582,527.293274 594.458435,527.563232 594.295227,527.833191 
	C595.193604,528.892883 596.091919,529.952515 596.673462,531.053467 
	C595.914185,532.275879 595.471741,533.457153 594.908081,534.962158 
	C592.840576,533.584900 590.958679,531.931091 588.768005,531.018799 
	C587.407288,530.452148 585.578613,531.009338 583.640076,530.928101 
	C577.503967,527.906250 571.687805,525.018250 566.007935,521.843506 
	C566.679016,520.506531 567.208313,519.453552 567.750000,518.407043 
	C568.186157,517.564331 568.637329,516.729492 569.459595,515.885803 
	C573.218445,516.913086 576.599670,517.945618 580.033752,519.328308 
	C582.799744,521.383728 585.512756,523.089050 588.225769,524.794312 
	C588.540649,524.255493 588.855469,523.716614 589.170288,523.177795 
	C586.079224,521.480347 582.988098,519.782898 579.546997,518.029785 
	C576.422546,516.028076 573.648071,514.082031 570.927490,512.075989 
	C570.981445,512.015991 571.087158,511.894043 571.087158,511.894043 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M605.361084,526.072998 
	C601.809570,524.554443 598.609009,523.070557 595.202148,521.306213 
	C595.558655,520.841736 596.121521,520.657715 596.861084,520.228638 
	C602.449890,522.232300 607.862061,524.480896 613.760620,527.155884 
	C615.164612,528.053955 616.082336,528.525757 617.000000,528.997559 
	C617.000000,528.997559 617.454529,529.026550 617.856934,529.319214 
	C622.161255,532.087585 626.063171,534.563293 629.965149,537.038940 
	C629.965149,537.038940 629.978882,537.030823 629.965759,537.042358 
	C631.632202,539.873352 633.178467,542.784363 635.032104,545.484375 
	C636.615967,547.791443 635.763489,548.745239 632.976807,549.323486 
	C629.689453,545.841431 626.908081,542.335510 624.126709,538.829590 
	C621.113586,536.401672 618.222839,533.797607 615.051819,531.597168 
	C612.093384,529.544312 608.837219,527.920471 605.361084,526.072998 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M596.990295,531.012207 
	C596.091919,529.952515 595.193604,528.892883 594.295227,527.833191 
	C594.458435,527.563232 594.621582,527.293274 594.784729,527.023376 
	C596.292175,527.658325 597.799622,528.293274 599.658447,528.959961 
	C608.084961,534.755005 616.352966,540.338074 619.635620,550.604492 
	C617.222961,548.935181 615.114197,546.961121 613.005371,544.987122 
	C612.693237,544.875305 612.440125,544.685059 612.102051,543.846924 
	C606.968872,539.189087 601.979614,535.100647 596.990295,531.012207 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M613.041321,545.345093 
	C615.114197,546.961121 617.222961,548.935181 619.675293,550.963135 
	C623.131714,556.030945 622.679321,561.145874 618.341736,565.950806 
	C618.574097,558.706543 617.438965,551.815430 613.041321,545.345093 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M632.904053,551.129761 
	C633.584900,553.494019 634.265686,555.858276 634.999146,558.601257 
	C634.709778,562.501099 634.367615,566.022217 633.373657,569.895020 
	C632.344055,570.575439 631.966309,570.904175 631.588501,571.232971 
	C631.624695,567.124023 631.660828,563.015015 631.569214,558.563599 
	C631.384766,557.424377 631.328186,556.627563 631.441284,555.233643 
	C631.162842,553.982483 630.714905,553.328552 630.266907,552.674561 
	C630.245667,552.313232 630.224487,551.951843 630.513428,551.305542 
	C631.517090,551.056885 632.210571,551.093323 632.904053,551.129761 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M632.938965,550.780334 
	C632.210571,551.093323 631.517090,551.056885 630.477173,551.036377 
	C627.951782,547.121826 625.772766,543.191406 623.860229,539.045288 
	C626.908081,542.335510 629.689453,545.841431 632.717407,549.537964 
	C632.967224,549.962708 632.970520,550.196838 632.938965,550.780334 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M630.201782,553.029907 
	C630.714905,553.328552 631.162842,553.982483 631.428040,554.838501 
	C630.875732,554.488831 630.506165,553.937073 630.201782,553.029907 
z"
      />
      <path
        fill="#9A8870"
        opacity="1.000000"
        stroke="none"
        d="
M473.013000,276.148438 
	C474.386505,276.079987 475.760040,276.011536 477.544617,275.965271 
	C477.474426,280.924500 476.993164,285.861511 475.962494,290.945740 
	C475.270966,291.002289 475.128876,290.911682 474.901978,290.467346 
	C470.973297,289.724060 467.129456,289.334564 463.285645,288.945068 
	C463.228943,286.923584 463.172241,284.902161 463.523499,282.392822 
	C466.958618,279.986084 469.985809,278.067261 473.013000,276.148438 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M474.986816,290.821106 
	C475.128876,290.911682 475.270966,291.002289 475.620300,291.238037 
	C475.686127,292.461151 475.544708,293.539124 475.162781,294.846252 
	C474.485352,295.053925 474.048401,295.032410 473.313110,294.771118 
	C473.014771,294.531311 473.027313,294.211243 473.201599,294.057556 
	C473.613617,293.697357 473.780182,293.444061 473.869507,292.701813 
	C473.829468,291.966827 473.795410,291.673981 473.947449,291.252258 
	C474.418243,291.023407 474.702698,290.922668 474.986816,290.821106 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M511.564148,291.383118 
	C511.394867,290.575836 511.082092,289.769409 511.077515,288.961182 
	C510.984924,272.642517 508.667236,276.231750 523.582275,276.382507 
	C524.335999,277.523468 524.633667,278.255341 524.931396,278.987213 
	C524.936401,282.338165 524.941406,285.689148 524.623718,289.532227 
	C523.861694,290.375305 523.422363,290.726288 522.530212,291.095001 
	C518.572998,291.202850 515.068604,291.292969 511.564148,291.383118 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M522.982971,291.077271 
	C523.422363,290.726288 523.861694,290.375305 524.594238,289.986450 
	C524.673584,291.919800 524.459839,293.891083 523.839111,296.055115 
	C523.432251,296.247894 523.354309,296.254272 523.276001,295.796265 
	C523.126099,293.917908 523.054565,292.497589 522.982971,291.077271 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M525.195129,278.812378 
	C524.633667,278.255341 524.335999,277.523468 524.042847,276.476013 
	C524.505798,276.122833 524.964233,276.085236 525.758362,276.130127 
	C525.882385,277.020905 525.670593,277.829224 525.195129,278.812378 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M665.183716,604.174500 
	C671.710205,599.294128 678.236694,594.413818 685.277832,589.163513 
	C686.893921,587.904541 687.995483,587.015564 689.097046,586.126648 
	C693.743225,581.981689 698.389465,577.836670 703.272217,573.270630 
	C703.750000,572.709900 703.907471,572.505615 703.981140,572.236694 
	C707.898315,569.385315 711.815430,566.533997 716.227539,563.231995 
	C717.808350,560.689819 718.894287,558.598267 719.985962,556.500671 
	C719.991638,556.494568 719.997559,556.478943 720.145020,556.545227 
	C720.292542,556.611511 720.607300,556.537598 721.004761,556.607056 
	C722.931641,555.711914 724.461060,554.747314 726.236694,553.967651 
	C726.272949,555.056519 726.063110,555.960388 725.609863,557.089844 
	C725.187195,558.162415 725.007996,559.009399 724.502319,559.899292 
	C723.042847,560.830078 721.909973,561.717957 720.517029,562.823608 
	C717.117554,565.965454 713.978149,568.889587 710.559570,571.988159 
	C708.500488,573.761780 706.720581,575.360901 704.633179,577.098755 
	C701.259705,580.180908 698.193787,583.124390 694.754944,586.006287 
	C688.914368,589.947205 683.446716,593.949768 677.697266,598.047607 
	C676.921692,598.740723 676.427917,599.338562 675.693726,600.047424 
	C675.338074,600.477234 675.222839,600.796082 674.794861,601.056030 
	C673.958069,601.288818 673.434082,601.580566 672.606812,602.016357 
	C667.997986,605.612366 663.692383,609.064270 658.777527,613.004639 
	C664.472595,615.511292 667.409302,623.258240 675.344116,619.486694 
	C675.512573,619.919250 675.680969,620.351807 675.550293,620.984253 
	C673.989258,623.840271 671.847839,624.406799 669.233521,623.711914 
	C669.281067,623.687012 669.264221,623.580994 669.187500,623.273804 
	C667.433350,621.941772 665.755859,620.916931 664.034058,619.911499 
	C663.989746,619.930969 664.085083,619.919373 663.922974,619.648071 
	C662.864868,618.854370 661.968872,618.331970 660.903503,617.569397 
	C659.892151,616.864441 659.050110,616.399780 658.067200,615.704407 
	C657.622864,615.291260 657.319336,615.108765 656.858215,614.645996 
	C656.836670,613.036133 656.972778,611.706543 657.391846,610.277954 
	C658.091370,609.772522 658.507996,609.366211 659.156494,608.893005 
	C659.701355,608.694946 659.927124,608.474487 660.341797,608.049194 
	C661.133667,607.350525 661.649353,606.767151 662.173340,606.190308 
	C662.181641,606.196777 662.195679,606.212891 662.501709,606.157959 
	C663.581177,605.445862 664.354553,604.788757 665.144165,604.138184 
	C665.160461,604.144836 665.183716,604.174500 665.183716,604.174500 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M701.405029,551.139160 
	C702.397949,549.853882 703.390869,548.568542 704.655396,547.141479 
	C705.287415,551.379333 705.647705,555.758911 705.730225,560.788574 
	C703.136169,567.708862 700.911377,568.875488 695.247742,566.789734 
	C695.392029,565.162170 695.536316,563.534607 695.948486,561.303589 
	C697.496765,557.808105 698.777100,554.916199 700.057434,552.024231 
	C700.057434,552.024231 700.006226,551.995972 700.284424,551.941406 
	C700.843445,551.637573 701.124207,551.388367 701.405029,551.139160 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M711.318970,548.935852 
	C711.374390,547.917603 711.429810,546.899292 711.788452,545.267212 
	C713.699402,541.379211 715.307007,538.105164 717.121155,534.492310 
	C718.167175,534.957275 719.619019,535.678101 719.741028,536.579041 
	C720.296631,540.680725 720.478271,544.833069 720.617554,549.095825 
	C720.245483,549.449768 720.113770,549.707520 719.701660,549.948242 
	C717.112610,545.948914 714.099976,548.409485 711.318970,548.935852 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M695.121826,567.196777 
	C700.911377,568.875488 703.136169,567.708862 705.735840,561.239075 
	C705.336731,564.508179 704.654236,567.976929 703.976440,571.841187 
	C703.907471,572.505615 703.750000,572.709900 703.323792,572.919189 
	C696.954102,574.836304 695.404663,573.811646 695.121826,567.196777 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M714.690735,522.120544 
	C715.511230,522.077942 716.331665,522.035339 717.577637,521.998047 
	C718.003052,522.003235 718.031738,522.033630 718.021606,522.485352 
	C718.048279,525.102905 718.085144,527.268616 718.095947,529.747803 
	C717.173157,531.383728 716.276245,532.706299 714.971375,533.993774 
	C713.230896,533.595459 711.898499,533.232117 710.566040,532.868835 
	C710.524109,531.385620 710.482178,529.902405 711.035156,528.197632 
	C715.232239,527.511047 716.694153,525.891418 714.643250,522.312500 
	C714.637634,522.245056 714.690735,522.120544 714.690735,522.120544 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M711.176880,549.323181 
	C714.099976,548.409485 717.112610,545.948914 719.898254,549.948242 
	C720.438965,549.997803 720.832336,550.022156 720.856201,550.345154 
	C720.828430,551.096191 720.776733,551.524170 720.433044,552.026245 
	C717.093323,552.400635 714.045532,552.700928 710.997803,553.001221 
	C711.010132,551.904297 711.022461,550.807434 711.176880,549.323181 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M710.892395,553.397705 
	C714.045532,552.700928 717.093323,552.400635 720.499512,552.341919 
	C720.575928,553.387695 720.293884,554.191956 719.939087,555.366211 
	C719.910156,555.983826 719.953857,556.231384 719.997559,556.478943 
	C719.997559,556.478943 719.991638,556.494568 719.581604,556.585205 
	C716.476501,557.071960 713.781372,557.468018 711.086304,557.864136 
	C710.986572,556.507507 710.886780,555.150818 710.892395,553.397705 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M711.091064,558.214050 
	C713.781372,557.468018 716.476501,557.071960 719.575928,556.591309 
	C718.894287,558.598267 717.808350,560.689819 716.406250,562.953369 
	C714.425232,561.604919 712.760498,560.084473 711.091064,558.214050 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M716.914612,534.831055 
	C715.307007,538.105164 713.699402,541.379211 711.891724,544.895508 
	C711.227905,543.664124 710.764160,542.190552 710.670898,540.263428 
	C712.394531,538.172302 713.747803,536.534729 715.402832,534.932495 
	C716.107910,534.922302 716.511292,534.876709 716.914612,534.831055 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M715.101013,534.897156 
	C713.747803,536.534729 712.394531,538.172302 710.752686,539.889526 
	C710.381775,537.832458 710.299438,535.695679 710.391602,533.213867 
	C711.898499,533.232117 713.230896,533.595459 714.914001,534.214722 
	C715.264648,534.470703 715.101013,534.897156 715.101013,534.897156 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M714.648865,522.379883 
	C716.694153,525.891418 715.232239,527.511047 711.241699,527.966797 
	C711.810547,526.297546 712.767761,524.637634 714.046021,522.726562 
	C714.367126,522.475403 714.648865,522.379883 714.648865,522.379883 
z"
      />
      <path
        fill="#0C1C1F"
        opacity="1.000000"
        stroke="none"
        d="
M714.643250,522.312500 
	C714.648865,522.379883 714.367126,522.475403 714.231995,522.409363 
	C714.096863,522.343323 714.094238,522.124390 714.092896,522.014648 
	C714.091492,521.904968 714.382996,522.040222 714.536865,522.080383 
	C714.690735,522.120544 714.637634,522.245056 714.643250,522.312500 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M470.923492,438.529236 
	C471.141541,438.118622 471.389771,438.067352 472.356567,437.980896 
	C480.670868,441.402679 488.956207,443.619110 494.932678,450.397980 
	C494.990387,451.166199 495.002655,451.607147 494.694305,452.014587 
	C493.586975,451.654480 492.800293,451.327881 492.013580,451.001282 
	C492.013580,451.001282 492.003235,450.998840 492.000916,450.992706 
	C487.879974,448.693665 483.761353,446.400787 479.266235,444.130981 
	C477.156799,443.500488 475.423828,442.846893 473.194214,441.890564 
	C472.106171,441.431183 471.514862,441.274536 470.923523,441.117859 
	C470.923523,441.117859 470.907623,441.090179 470.913971,441.079346 
	C470.931427,440.341858 470.942566,439.615204 470.923492,438.529236 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M470.967896,441.396149 
	C471.514862,441.274536 472.106171,441.431183 472.846222,441.871155 
	C472.334045,441.994446 471.673126,441.834442 470.967896,441.396149 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M411.206207,499.316925 
	C412.247070,501.214142 413.351166,503.404083 414.091064,505.710876 
	C415.851837,511.200531 417.585175,516.788269 409.917297,519.959351 
	C402.769348,517.078857 395.719940,513.818420 388.364380,510.397858 
	C388.235321,507.141571 389.992432,508.373932 391.741943,508.676697 
	C393.089020,508.909882 394.574554,508.342987 396.054016,507.752808 
	C397.568970,507.579010 399.028412,507.784271 401.162292,507.780762 
	C403.265961,506.525909 404.695221,505.479767 406.124481,504.433655 
	C407.784271,502.843353 409.444092,501.253082 411.206207,499.316925 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M406.091980,504.023865 
	C404.695221,505.479767 403.265961,506.525909 401.488098,507.603516 
	C399.235016,506.393555 397.139313,505.363281 395.475311,503.856323 
	C393.467773,502.038269 391.826538,499.815826 389.966095,497.433472 
	C394.754913,498.330963 399.633118,499.467163 404.423981,500.895996 
	C405.172791,501.119324 405.524292,502.674683 406.091980,504.023865 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M388.978333,496.658203 
	C388.365601,496.577576 387.700775,496.170990 386.958008,495.459625 
	C387.562134,495.547302 388.244171,495.939758 388.978333,496.658203 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M410.262573,497.264404 
	C410.628082,497.076477 410.832306,497.233734 410.991882,497.692932 
	C410.746826,497.760559 410.464813,497.632141 410.262573,497.264404 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M460.921356,538.929932 
	C458.809113,542.402161 456.401489,542.538940 453.160889,540.138306 
	C449.593628,537.495667 445.677673,535.323730 441.790314,532.631348 
	C446.414276,532.111389 451.161621,531.906799 456.402222,532.075928 
	C458.237427,534.609741 459.579407,536.769836 460.921356,538.929932 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M461.258301,538.822510 
	C459.579407,536.769836 458.237427,534.609741 456.818298,532.068481 
	C459.440704,529.584473 461.929138,526.609558 466.159485,529.631592 
	C467.233276,531.278870 467.982025,532.779602 468.880249,534.577515 
	C466.551514,536.154724 464.073364,537.434875 461.258301,538.822510 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M419.940826,510.216827 
	C418.985352,507.722076 418.029877,505.227356 417.452545,502.313324 
	C418.933472,501.531708 420.036285,501.169373 421.139099,500.807068 
	C422.812775,501.227997 424.486420,501.648926 426.527557,502.111267 
	C431.450562,503.106171 435.984985,504.182617 440.568787,504.971924 
	C443.849457,505.536804 447.196350,505.716949 450.905243,506.218750 
	C449.905731,511.093048 447.096313,513.770203 441.025513,512.861206 
	C433.452698,511.941162 426.696777,511.078979 419.940826,510.216827 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M421.105286,500.481720 
	C420.036285,501.169373 418.933472,501.531708 417.489624,501.945587 
	C416.768646,500.904785 416.388763,499.812439 416.091736,498.370422 
	C418.337433,497.516144 420.563171,496.867310 421.105286,500.481720 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M677.993042,431.342957 
	C682.181458,425.947113 687.741272,429.424927 692.658020,428.782562 
	C693.784302,428.635437 694.967041,428.920227 696.526306,429.012421 
	C699.472656,429.845215 702.016541,430.671844 704.792297,432.120056 
	C705.975952,434.157104 706.927673,435.572571 707.912231,437.377319 
	C707.372864,439.575684 707.127625,441.590210 706.150757,443.144989 
	C704.729309,445.407257 702.780823,447.338379 701.057007,449.410675 
	C691.281677,456.883301 679.316528,456.869446 668.001831,459.079285 
	C663.771912,459.905426 659.541382,460.728546 654.468018,461.420105 
	C651.478577,461.224060 649.322449,460.998138 647.187622,461.126404 
	C638.474060,461.650024 629.767029,462.281952 621.096924,462.498383 
	C622.284607,461.419159 623.375671,460.243408 624.591309,460.096069 
	C629.119019,459.547302 633.683411,459.242279 638.242737,459.039368 
	C640.421021,458.942413 642.282776,458.868103 642.394775,455.901459 
	C646.544678,455.564056 650.278137,455.280487 654.010681,454.987000 
	C658.026672,454.671295 662.041992,454.346344 666.485107,454.029114 
	C676.484741,453.852936 684.717407,450.058472 692.413086,444.715668 
	C684.288696,447.223694 676.513977,450.978455 667.857971,450.824707 
	C673.570618,448.552856 679.283325,446.281006 684.998413,444.005188 
	C685.000793,444.001221 685.010193,443.999695 685.349915,443.964600 
	C686.465454,442.954590 687.241272,441.979736 688.253357,440.827759 
	C687.968201,439.759552 687.446716,438.868408 686.783691,437.675323 
	C684.432190,436.251770 682.222229,435.130157 680.007690,434.003906 
	C680.003235,433.999268 679.992432,433.987946 679.992432,433.987946 
	C679.339417,433.210083 678.686340,432.432220 677.993042,431.342957 
M696.899109,433.673523 
	C696.798340,433.628235 696.697632,433.582947 696.596863,433.537628 
	C696.718872,433.701721 696.840942,433.865814 696.979797,434.796356 
	C697.352661,437.856140 699.229187,440.917786 696.686584,444.101593 
	C696.800354,444.079346 696.914124,444.057068 697.761963,444.025696 
	C699.411316,442.674896 701.060730,441.324097 702.710083,439.973297 
	C700.816040,437.970398 698.922058,435.967468 696.899109,433.673523 
M694.400391,443.481720 
	C694.400391,443.481720 694.518921,443.409821 694.400391,443.481720 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M686.925232,437.977264 
	C687.446716,438.868408 687.968201,439.759552 687.911255,440.859772 
	C686.558655,442.045807 685.784424,443.022766 685.010193,443.999695 
	C685.010193,443.999695 685.000793,444.001221 684.595642,443.999695 
	C675.768433,445.987305 667.346313,447.976379 658.920776,449.634521 
	C658.263367,448.458099 657.609375,447.612610 656.960938,446.359009 
	C656.746521,443.431946 657.318237,441.757080 660.430664,441.947388 
	C661.605103,442.019196 662.829285,441.277283 664.030823,440.906311 
	C666.976440,439.349670 666.766052,437.949371 663.695312,437.033173 
	C660.571594,436.101166 657.374084,435.416718 654.208862,434.623840 
	C654.328491,434.162109 654.448120,433.700409 654.567749,433.238708 
	C661.501038,435.035309 668.434387,436.831940 674.884521,438.503326 
	C674.490784,436.624603 672.050781,434.766235 668.044128,434.030792 
	C666.136536,433.680634 664.270752,433.102631 662.109131,432.370911 
	C665.683167,432.498077 669.535950,432.864929 673.384277,433.273529 
	C675.302917,433.477234 677.213440,433.757324 679.560059,433.995392 
	C679.992432,433.987946 680.003235,433.999268 680.056274,434.349854 
	C682.381287,435.792725 684.653259,436.885010 686.925232,437.977264 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M630.022156,428.699036 
	C628.551941,428.956543 627.058289,428.956543 625.564636,428.956543 
	C625.546570,428.439667 625.528564,427.922791 625.510498,427.405914 
	C626.835999,427.405914 628.161438,427.405914 629.729309,427.665558 
	C629.980713,428.097321 629.989746,428.269440 630.022156,428.699036 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M659.983154,431.706116 
	C659.283997,432.027863 658.528931,432.012146 657.397705,431.980682 
	C657.990112,431.766205 658.958740,431.567444 659.983154,431.706116 
z"
      />
      <path
        fill="#F9EDD2"
        opacity="1.000000"
        stroke="none"
        d="
M676.370117,462.991638 
	C675.113892,462.487366 674.233276,461.988647 673.165161,461.236664 
	C679.036987,459.697144 685.172546,458.686432 691.131348,457.037079 
	C695.849915,455.731018 700.335815,453.597809 704.957031,451.919952 
	C707.021790,451.170319 709.164978,450.636566 711.700439,450.028198 
	C707.550659,453.043732 703.031067,456.130035 698.378967,459.001617 
	C693.637512,461.928345 688.864197,464.839325 683.895935,467.342651 
	C682.222534,468.185822 679.909363,467.759155 677.888550,467.912903 
	C678.187744,466.810638 678.487000,465.708374 679.222717,464.269836 
	C679.932678,463.497345 680.206116,463.061127 680.479614,462.624939 
	C679.986206,462.747620 679.492798,462.870331 678.999390,462.993011 
	C678.248169,462.994415 677.497009,462.995819 676.370117,462.991638 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M624.864258,477.759766 
	C624.404968,477.567596 623.945740,477.375427 623.242615,476.758301 
	C622.966858,475.875488 622.934875,475.417603 623.121521,474.774170 
	C623.861267,474.076477 624.382446,473.564301 625.256714,473.007294 
	C626.737427,472.640076 627.865051,472.317719 629.442932,472.004700 
	C636.829407,471.608948 643.765625,471.203857 650.701843,470.798767 
	C650.392639,471.727814 650.083435,472.656921 649.000122,473.813782 
	C641.489624,474.356750 634.743530,474.552826 628.026672,475.104553 
	C626.907410,475.196503 625.915222,476.835632 624.864258,477.759766 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M650.905273,470.620361 
	C643.765625,471.203857 636.829407,471.608948 629.386658,471.667236 
	C627.914978,470.633850 626.949829,469.947296 625.490784,468.909393 
	C632.011047,468.555328 638.024902,468.228729 644.494690,467.921753 
	C647.468689,467.954620 649.986816,467.967926 652.504883,467.981232 
	C652.039490,468.801483 651.574036,469.621735 650.905273,470.620361 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M654.423584,462.510071 
	C654.194763,463.532593 653.965881,464.555115 652.991577,465.806152 
	C649.511414,466.064453 646.776733,466.094238 643.581299,466.085999 
	C636.106262,466.317261 629.091919,466.586609 622.047363,466.543152 
	C622.008484,465.809937 621.999878,465.389618 622.413086,464.952698 
	C629.288086,464.618896 635.748535,464.405273 642.191589,463.947052 
	C646.282288,463.656158 650.347107,463.001587 654.423584,462.510071 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M654.450317,462.387177 
	C650.347107,463.001587 646.282288,463.656158 642.191589,463.947052 
	C635.748535,464.405273 629.288086,464.618896 622.246765,464.719513 
	C621.123840,464.315338 620.589172,464.127777 620.151733,463.707214 
	C620.518555,463.274109 620.788025,463.074005 621.057556,462.873962 
	C629.767029,462.281952 638.474060,461.650024 647.187622,461.126404 
	C649.322449,460.998138 651.478577,461.224060 654.091675,461.531311 
	C654.558472,461.775513 654.477173,462.264282 654.450317,462.387177 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M707.879395,436.988037 
	C706.927673,435.572571 705.975952,434.157104 705.031189,432.400940 
	C705.449036,432.052582 705.859924,432.044861 706.797180,432.290802 
	C715.859741,438.448090 715.859741,438.448090 713.007019,446.994263 
	C711.566040,447.272827 710.125000,447.551361 708.376465,447.377197 
	C708.914490,445.496735 710.163574,444.160034 710.511047,442.619904 
	C711.034058,440.301788 712.643311,437.013367 707.879395,436.988037 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M625.199097,477.857147 
	C625.915222,476.835632 626.907410,475.196503 628.026672,475.104553 
	C634.743530,474.552826 641.489624,474.356750 648.707764,474.039795 
	C649.015320,474.602356 648.840942,475.166626 647.984009,475.887756 
	C643.197571,476.355103 639.069397,476.487152 634.998413,477.039734 
	C632.355591,477.398438 629.796021,478.370514 627.199158,479.067749 
	C626.644043,478.696655 626.088989,478.325562 625.199097,477.857147 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M627.162964,479.285095 
	C629.796021,478.370514 632.355591,477.398438 634.998413,477.039734 
	C639.069397,476.487152 643.197571,476.355103 647.755981,476.079224 
	C647.436523,477.709656 646.662476,479.305542 645.507202,481.005005 
	C645.126038,481.108551 644.901123,480.906799 644.854248,480.530762 
	C643.488159,479.796539 642.159241,479.103302 640.851257,479.140747 
	C636.282715,479.271515 631.721313,479.654724 627.157227,479.942017 
	C627.157227,479.942017 627.126831,479.502411 627.162964,479.285095 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M713.377319,447.052368 
	C715.859741,438.448090 715.859741,438.448090 707.105713,432.281158 
	C716.388489,432.578491 720.455017,438.807648 716.013000,446.444641 
	C715.218933,446.906097 714.483215,447.008301 713.377319,447.052368 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M707.912231,437.377319 
	C712.643311,437.013367 711.034058,440.301788 710.511047,442.619904 
	C710.163574,444.160034 708.914490,445.496735 708.002075,447.256775 
	C705.902893,448.145966 703.870605,448.702972 701.447632,449.335327 
	C702.780823,447.338379 704.729309,445.407257 706.150757,443.144989 
	C707.127625,441.590210 707.372864,439.575684 707.912231,437.377319 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M644.641479,482.914886 
	C639.410461,483.495575 634.399658,484.025543 629.375061,484.314575 
	C627.639099,484.414398 625.868713,483.915009 624.030884,483.307983 
	C624.333740,482.878540 624.719727,482.830444 625.833374,482.816284 
	C632.674377,482.202423 638.787720,481.554596 644.901123,480.906799 
	C644.901123,480.906799 645.126038,481.108551 645.240967,481.207275 
	C645.189453,481.793854 645.022949,482.281738 644.641479,482.914886 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M644.041992,466.124054 
	C646.776733,466.094238 649.511414,466.064453 652.707825,466.089905 
	C653.061707,466.637543 652.953979,467.129883 652.675537,467.801727 
	C649.986816,467.967926 647.468689,467.954620 644.486145,467.625916 
	C644.028442,466.915039 644.035217,466.519562 644.041992,466.124054 
z"
      />
      <path
        fill="#F9EDD2"
        opacity="1.000000"
        stroke="none"
        d="
M666.706421,461.035034 
	C666.532471,461.334930 666.058777,461.647736 665.286377,461.979065 
	C665.460754,461.681030 665.933777,461.364502 666.706421,461.035034 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M338.490326,443.904083 
	C340.269623,445.461731 342.048950,447.019379 344.102570,448.643585 
	C346.241791,459.598175 347.939362,470.518707 350.046021,481.359772 
	C351.019226,486.367981 352.791229,491.221008 354.266174,496.528168 
	C349.960022,496.557220 352.611389,499.909912 351.518799,501.825684 
	C350.199249,500.898956 349.273346,499.640381 348.347473,498.381805 
	C348.517792,498.070618 348.538116,497.749878 348.266144,496.817352 
	C346.756195,492.129425 345.388550,488.043823 344.020874,483.958191 
	C343.916809,483.260315 343.812744,482.562408 343.680725,481.230286 
	C343.399384,480.063446 343.146027,479.530823 342.892700,478.998230 
	C342.777069,478.444489 342.661469,477.890747 342.411316,476.726532 
	C341.947937,474.993683 341.619110,473.871338 341.290283,472.748962 
	C341.249420,472.358887 341.208557,471.968842 341.151459,470.896179 
	C340.720154,468.463837 340.305054,466.714050 339.889984,464.964294 
	C339.698151,463.868408 339.506287,462.772491 339.446625,461.087708 
	C339.356934,459.333435 339.135010,458.168060 338.913147,457.002686 
	C338.864105,456.288910 338.815063,455.575134 338.804077,454.082581 
	C338.724854,450.170593 338.607605,447.037323 338.490326,443.904083 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M348.249481,498.812164 
	C349.273346,499.640381 350.199249,500.898956 351.461182,502.211914 
	C351.797211,502.266327 351.935028,502.183746 351.759766,502.477020 
	C352.036469,503.698212 352.488495,504.626129 352.940491,505.554047 
	C355.555176,512.562683 358.164551,519.573242 360.789520,526.578064 
	C361.249451,527.805359 361.774780,529.007996 361.969635,530.630981 
	C361.404785,531.096008 361.140198,531.152039 360.467743,531.196838 
	C359.714417,536.454895 359.368927,541.724243 358.928436,547.322083 
	C358.877991,548.103882 358.922516,548.557129 358.744598,549.214966 
	C359.009949,550.952576 359.497711,552.485718 359.985901,554.410034 
	C359.967468,555.583557 359.948578,556.365723 359.624359,556.999023 
	C355.459351,552.324036 351.599609,547.797974 347.958862,542.967957 
	C351.930328,542.783203 355.234741,541.779053 355.807831,537.606689 
	C356.190918,534.817688 355.532196,531.885620 355.199768,528.635498 
	C354.498779,525.953125 353.937744,523.652832 353.695679,521.178589 
	C353.324554,520.345154 352.634399,519.685608 351.768555,518.762329 
	C351.510498,518.303955 351.428162,518.109375 351.447327,517.770386 
	C351.488983,517.350586 351.318146,517.217529 350.912109,516.943359 
	C350.556244,516.114685 350.324615,515.569580 350.092987,515.024414 
	C352.234344,515.131775 353.085876,514.523254 352.240875,512.150696 
	C350.727570,507.901459 349.499084,503.550781 348.249481,498.812164 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M360.875610,531.208069 
	C361.140198,531.152039 361.404785,531.096008 362.078125,531.001587 
	C364.694885,534.230591 366.902863,537.497925 369.428436,540.798645 
	C369.322083,542.100586 368.898132,543.369141 367.925781,544.635681 
	C366.285461,542.723877 365.193573,540.814087 364.056641,538.551941 
	C362.966248,535.869080 361.920929,533.538574 360.875610,531.208069 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M352.947021,505.156525 
	C352.488495,504.626129 352.036469,503.698212 351.746094,502.397827 
	C352.256348,502.936584 352.604980,503.847809 352.947021,505.156525 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M624.703491,372.124817 
	C629.414307,371.379547 630.354492,367.553680 630.867188,363.925629 
	C631.283813,360.977783 632.437073,359.785828 635.624634,360.386780 
	C632.900024,369.686157 629.823730,378.606323 626.747437,387.526520 
	C627.059082,387.702942 627.370789,387.879395 627.682495,388.055817 
	C630.692078,385.859253 633.701660,383.662689 636.787842,381.911224 
	C637.615051,383.912933 638.365601,385.469513 639.069824,387.365540 
	C631.170715,394.588745 623.317993,401.472534 615.343445,407.956970 
	C616.464539,403.407043 617.641541,399.235199 618.969849,395.112152 
	C620.156372,391.429260 621.602478,387.827148 622.681519,384.115967 
	C622.829102,383.608276 621.514954,382.675537 620.877563,381.939606 
	C620.989746,381.384949 621.101929,380.830292 621.810486,380.077271 
	C626.170593,378.282318 626.746887,375.701874 624.739075,372.323730 
	C624.739075,372.323730 624.706116,372.192444 624.703491,372.124817 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M655.649292,413.267456 
	C655.468445,413.771820 655.287659,414.276154 654.951172,415.153442 
	C648.549316,415.333069 642.301453,415.182800 636.057495,414.935791 
	C627.939148,414.614655 619.823853,414.216675 611.295776,413.469116 
	C611.324219,412.436035 611.764099,411.785614 612.401855,411.043579 
	C612.854248,410.783752 613.022522,410.552734 613.395630,410.177429 
	C614.046204,409.913849 614.405457,409.731689 615.014893,409.903076 
	C619.478271,410.840179 623.674927,411.682739 627.908203,411.954010 
	C637.145325,412.545990 646.401123,412.847351 655.649292,413.267456 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M613.104431,410.258850 
	C613.022522,410.552734 612.854248,410.783752 612.039612,410.789276 
	C611.116760,410.157288 610.754028,409.687927 610.391296,409.218597 
	C613.725708,400.302673 617.060181,391.386749 620.636108,382.205200 
	C621.514954,382.675537 622.829102,383.608276 622.681519,384.115967 
	C621.602478,387.827148 620.156372,391.429260 618.969849,395.112152 
	C617.641541,399.235199 616.464539,403.407043 615.297119,407.947784 
	C615.372620,408.337921 615.290649,408.298645 614.925415,408.239105 
	C614.074951,408.872681 613.589722,409.565765 613.104431,410.258850 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M624.441284,372.560730 
	C626.746887,375.701874 626.170593,378.282318 622.031189,379.889404 
	C622.484802,377.532501 623.314209,375.165131 624.441284,372.560730 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M610.115112,409.443176 
	C610.754028,409.687927 611.116760,410.157288 611.841736,410.880920 
	C611.764099,411.785614 611.324219,412.436035 610.821167,413.373535 
	C607.051453,413.112305 609.744751,411.090881 610.115112,409.443176 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M568.410706,322.551117 
	C567.639282,323.734924 566.741455,324.456207 566.063538,325.345245 
	C564.156494,327.846344 562.339966,330.416473 560.102295,332.973053 
	C559.411377,320.942932 559.105835,308.899200 559.255981,296.498962 
	C563.635559,296.605743 567.559387,297.068939 571.483276,297.532135 
	C570.450439,305.743134 569.417542,313.954163 568.410706,322.551117 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M571.249268,276.818359 
	C571.617676,281.491821 571.547729,286.178833 570.739014,291.056030 
	C566.348328,291.179016 562.696533,291.111816 559.044678,291.044617 
	C555.515747,278.581421 556.754089,277.085602 571.249268,276.818359 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M558.978516,291.456726 
	C562.696533,291.111816 566.348328,291.179016 570.428711,291.390747 
	C571.138794,293.380096 571.420288,295.224915 571.592529,297.300903 
	C567.559387,297.068939 563.635559,296.605743 559.344727,296.093140 
	C558.955994,294.652130 558.934143,293.260498 558.978516,291.456726 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M703.541626,372.723969 
	C704.751221,379.564545 701.482300,385.565430 699.117065,391.777924 
	C696.848328,397.737030 694.515503,403.671997 692.178589,409.604828 
	C690.384888,414.158417 687.690308,417.203217 682.114685,416.039001 
	C677.866211,415.151855 673.547852,414.599060 668.811157,413.824097 
	C672.014587,410.395844 675.839233,407.205505 679.260864,403.629395 
	C681.609070,401.175110 683.397095,398.184784 685.692261,395.205688 
	C691.597473,393.544525 692.080627,388.174042 694.573181,384.030090 
	C695.559326,383.992401 696.651367,384.273499 696.819946,383.995178 
	C699.031677,380.343933 701.113037,376.613739 703.541626,372.723969 
z"
      />
      <path
        fill="#0C1C1F"
        opacity="1.000000"
        stroke="none"
        d="
M631.817749,571.438171 
	C631.966309,570.904175 632.344055,570.575439 633.087891,570.141479 
	C632.984985,570.571960 632.515930,571.107666 631.817749,571.438171 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M458.459229,288.921814 
	C456.046082,288.924744 453.959625,288.912476 451.433655,288.838318 
	C451.000854,282.268768 451.019470,275.761108 451.007507,269.253479 
	C451.003479,267.052887 450.733582,264.714050 454.544250,265.477570 
	C455.317505,272.093353 455.532867,278.276642 456.143890,284.420563 
	C456.237335,285.360291 458.158386,286.118286 459.453278,286.974762 
	C459.672394,286.989197 460.111420,286.999847 460.111420,286.999847 
	C460.141144,287.439331 460.170837,287.878815 460.146271,288.644501 
	C459.656616,288.949341 459.221252,288.928009 458.459229,288.921814 
z"
      />
      <path
        fill="#0A2624"
        opacity="1.000000"
        stroke="none"
        d="
M459.234161,286.960327 
	C458.158386,286.118286 456.237335,285.360291 456.143890,284.420563 
	C455.532867,278.276642 455.317505,272.093353 454.962372,265.482178 
	C456.373627,265.031738 457.795380,265.022095 459.645050,265.028992 
	C460.032227,267.591095 459.991486,270.136597 460.143280,273.055237 
	C459.956329,277.231750 459.576874,281.035217 459.188202,285.587891 
	C459.197388,286.544891 459.215759,286.752594 459.234161,286.960327 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M472.558899,276.090454 
	C469.985809,278.067261 466.958618,279.986084 463.582153,281.962341 
	C463.232910,280.259369 463.232910,278.498932 463.232910,276.032501 
	C466.365265,276.032501 469.235046,276.032501 472.558899,276.090454 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M474.901978,290.467346 
	C474.702698,290.922668 474.418243,291.023407 473.601501,291.250183 
	C471.406281,291.300873 469.743073,291.224731 467.708496,291.117004 
	C466.845703,291.147369 466.354279,291.209320 465.582245,291.232819 
	C464.929108,291.144348 464.556580,291.094299 464.184052,291.044281 
	C463.848083,290.558289 463.512115,290.072266 463.230896,289.265686 
	C467.129456,289.334564 470.973297,289.724060 474.901978,290.467346 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M468.079834,291.148590 
	C469.743073,291.224731 471.406281,291.300873 473.415405,291.379089 
	C473.795410,291.673981 473.829468,291.966827 473.633606,292.663452 
	C473.278229,293.448578 473.152802,293.829926 473.027344,294.211243 
	C473.027313,294.211243 473.014771,294.531311 472.994995,294.690247 
	C471.593658,295.170929 470.212097,295.492676 468.434113,295.370178 
	C468.051758,293.666809 468.065796,292.407684 468.079834,291.148590 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M464.067444,291.424561 
	C464.556580,291.094299 464.929108,291.144348 465.634705,291.599731 
	C465.950165,293.243927 465.932526,294.482788 465.914917,295.721619 
	C465.260193,294.416016 464.605499,293.110413 464.067444,291.424561 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M466.274719,295.807068 
	C465.932526,294.482788 465.950165,293.243927 465.915314,291.638184 
	C466.354279,291.209320 466.845703,291.147369 467.708496,291.117004 
	C468.065796,292.407684 468.051758,293.666809 468.062317,295.303223 
	C467.602814,295.751221 467.118652,295.821899 466.274719,295.807068 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M459.453278,286.974762 
	C459.215759,286.752594 459.197388,286.544891 459.204346,286.025391 
	C459.535675,285.943237 459.841705,286.172882 460.129578,286.701172 
	C460.111420,286.999847 459.672394,286.989197 459.453278,286.974762 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M347.739868,543.271851 
	C351.599609,547.797974 355.459351,552.324036 359.646118,556.974426 
	C359.973175,557.098694 359.946594,557.039612 360.046936,557.348633 
	C361.362488,558.899902 362.577667,560.142151 363.792877,561.384399 
	C366.018951,563.453125 368.245056,565.521790 370.716980,567.801147 
	C376.029541,572.285583 381.096252,576.559387 386.660553,581.244751 
	C388.332062,582.935730 389.506012,584.215149 390.412567,585.682678 
	C389.991241,586.019409 389.837311,586.168152 389.408539,586.195496 
	C387.937439,585.370789 386.741180,584.667603 385.300171,583.675598 
	C384.377960,583.238281 383.700470,583.089722 383.049957,582.959351 
	C383.076935,582.977539 383.112457,582.923096 383.049530,582.583435 
	C380.273529,579.863586 377.560455,577.483459 374.766418,574.810303 
	C373.871704,573.988281 373.058014,573.459106 372.070129,572.631348 
	C366.585175,567.555725 361.274445,562.778625 355.985352,558.000122 
	C356.006989,557.998718 356.000916,558.042358 355.972839,557.713562 
	C354.967010,556.242371 353.989258,555.099976 352.820007,553.688904 
	C349.454529,549.970520 346.280579,546.520813 343.078674,542.849854 
	C342.789581,542.061218 342.528473,541.493896 341.944397,540.880737 
	C341.408630,540.879456 341.195801,540.923889 340.986938,540.990723 
	C340.990967,541.013062 341.035217,541.003052 341.047333,540.729492 
	C340.824921,540.182739 340.590393,539.909607 340.265533,539.302979 
	C337.796387,535.660400 335.417572,532.351196 332.905579,528.739502 
	C331.609375,526.898804 330.446350,525.360535 329.059265,523.548462 
	C328.209808,521.695984 327.584412,520.117310 326.958984,518.538635 
	C327.371307,518.332825 327.783661,518.126953 328.195984,517.921082 
	C329.369049,519.334839 330.542114,520.748535 331.852295,522.480225 
	C337.239594,529.622742 342.489716,536.447327 347.739868,543.271851 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M364.101685,538.904297 
	C365.193573,540.814087 366.285461,542.723877 367.647522,544.832031 
	C368.193451,546.708130 368.469208,548.385803 368.407349,550.497681 
	C367.379059,551.958679 366.688446,552.985474 365.620361,554.025879 
	C364.246429,553.946777 363.249969,553.854065 362.168762,553.442871 
	C361.045074,551.752991 360.006073,550.381714 358.967041,549.010376 
	C358.922516,548.557129 358.877991,548.103882 359.239044,547.152771 
	C361.130310,544.071411 362.615997,541.487854 364.101685,538.904297 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M372.772278,559.031006 
	C372.805939,555.981323 372.839600,552.931580 372.920013,549.110107 
	C372.999146,547.898132 373.031525,547.458008 373.063934,547.017822 
	C373.539673,546.377869 374.015442,545.737915 374.971466,545.141785 
	C376.697052,547.430664 377.942383,549.675720 378.840515,551.964722 
	C378.358215,553.078186 377.948242,554.199036 378.137054,555.207825 
	C378.837433,558.949524 377.669739,561.870422 374.698090,564.148682 
	C374.301819,563.531250 373.905579,562.913879 373.277344,561.768921 
	C372.954346,560.504578 372.863312,559.767822 372.772278,559.031006 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M374.698120,564.499512 
	C377.669739,561.870422 378.837433,558.949524 378.137054,555.207825 
	C377.948242,554.199036 378.358215,553.078186 379.129944,552.114258 
	C380.856476,553.827698 381.946411,555.435547 383.036316,557.043457 
	C383.244507,558.136108 383.452698,559.228699 383.433197,560.896240 
	C382.562988,563.242554 381.920471,565.014099 381.190552,567.026550 
	C379.447266,567.026550 377.713745,567.026550 375.980225,567.026550 
	C375.980225,567.026550 375.649963,566.863220 375.466003,566.864258 
	C375.087402,566.193604 374.892792,565.521973 374.698120,564.499512 
M380.107056,561.282959 
	C380.191040,561.328674 380.274994,561.374329 380.358978,561.420044 
	C380.248352,561.273499 380.137726,561.126953 379.901733,560.710876 
	C379.813354,560.663757 379.725006,560.616638 379.636627,560.569519 
	C379.751282,560.722107 379.865906,560.874695 380.107056,561.282959 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M383.387878,557.049805 
	C381.946411,555.435547 380.856476,553.827698 379.477142,552.070251 
	C377.942383,549.675720 376.697052,547.430664 375.187439,544.925659 
	C375.038361,543.925476 375.153534,543.185303 375.438599,542.102661 
	C378.879883,546.159790 382.151337,550.559326 385.767639,555.053650 
	C385.321472,555.784302 384.530487,556.420288 383.387878,557.049805 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M362.253479,553.761353 
	C363.249969,553.854065 364.246429,553.946777 365.798798,554.286133 
	C367.166168,554.645752 367.977631,554.758850 368.789124,554.872009 
	C367.772675,555.959534 366.756195,557.047058 365.017273,558.065552 
	C362.845398,557.677490 361.395996,557.358582 359.946594,557.039612 
	C359.946594,557.039612 359.973175,557.098694 359.951416,557.123291 
	C359.948578,556.365723 359.967468,555.583557 360.365967,554.390076 
	C361.248199,553.906311 361.750854,553.833862 362.253479,553.761353 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M360.046936,557.348633 
	C361.395996,557.358582 362.845398,557.677490 364.652924,558.125488 
	C364.696106,559.084900 364.381134,559.915161 363.929504,561.064941 
	C362.577667,560.142151 361.362488,558.899902 360.046936,557.348633 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M368.810730,554.859680 
	C367.977631,554.758850 367.166168,554.645752 366.176270,554.272461 
	C366.688446,552.985474 367.379059,551.958679 368.372101,550.863098 
	C368.813690,551.590759 368.952881,552.387085 368.995026,553.789795 
	C368.897980,554.396057 368.860718,554.806580 368.860718,554.806580 
	C368.860718,554.806580 368.832367,554.847351 368.810730,554.859680 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M372.561218,559.244141 
	C372.863312,559.767822 372.954346,560.504578 373.046234,561.614258 
	C372.814789,561.143799 372.582489,560.300598 372.561218,559.244141 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M372.833069,547.134888 
	C373.031525,547.458008 372.999146,547.898132 372.871307,548.655518 
	C372.717957,548.399170 372.660095,547.825562 372.833069,547.134888 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M369.043854,554.791138 
	C368.860718,554.806580 368.897980,554.396057 368.953186,554.197510 
	C369.161102,554.167053 369.324463,554.327820 369.453400,554.512512 
	C369.469849,554.536072 369.306854,554.684875 369.043854,554.791138 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M643.662354,593.133545 
	C643.981323,593.177429 644.044312,593.351746 644.134705,594.102661 
	C644.193237,595.133911 644.224426,595.588440 644.150879,596.399841 
	C644.121094,597.488464 644.196106,598.220215 644.207520,599.288879 
	C644.230103,600.069519 644.316345,600.513306 644.307007,601.408691 
	C643.419678,606.569885 642.627991,611.279480 641.485474,615.984863 
	C640.388916,616.951721 639.643005,617.922668 638.563843,618.880310 
	C637.434692,618.022644 636.638916,617.178345 636.073853,616.578796 
	C634.479736,617.075684 633.160278,617.487000 631.764099,617.541382 
	C637.604614,610.971069 640.621155,603.520203 641.147461,595.007141 
	C641.900452,594.426025 642.653442,593.844971 643.662354,593.133545 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M640.804321,595.077393 
	C640.621155,603.520203 637.604614,610.971069 631.788574,617.567322 
	C631.889771,617.950073 631.956177,617.921265 631.622437,617.808350 
	C630.501526,618.446899 629.714355,619.198303 628.965942,619.956360 
	C629.004639,619.963074 628.952637,619.904175 628.714233,619.841187 
	C628.475830,619.778259 628.022400,619.972290 627.702637,619.947510 
	C626.885803,619.593262 626.388733,619.263855 625.891663,618.934509 
	C630.748169,611.005554 635.604675,603.076599 640.804321,595.077393 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M625.621338,618.736877 
	C626.388733,619.263855 626.885803,619.593262 627.618408,620.205627 
	C627.887512,620.877136 627.921082,621.265625 627.954712,621.654175 
	C628.287354,621.070801 628.619995,620.487488 628.952637,619.904175 
	C628.952637,619.904175 629.004639,619.963074 629.335083,619.986694 
	C630.429016,619.314026 631.192627,618.617615 631.956177,617.921265 
	C631.956177,617.921265 631.889771,617.950073 631.865295,617.924194 
	C633.160278,617.487000 634.479736,617.075684 636.073853,616.578796 
	C636.638916,617.178345 637.434692,618.022644 638.692383,619.024048 
	C639.154236,619.181213 639.407410,619.469177 639.235718,619.722778 
	C638.290649,620.939331 637.517395,621.902344 636.431152,622.937012 
	C635.547668,623.617371 634.977051,624.226013 634.406433,624.834595 
	C631.041870,625.287292 627.677246,625.739990 624.122925,626.218201 
	C622.604309,621.868958 618.860779,618.422974 621.539062,613.217651 
	C622.955078,614.804199 624.153076,616.671692 625.621338,618.736877 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M680.980103,636.893372 
	C672.812134,641.118591 664.087341,642.514832 654.846130,641.658142 
	C660.659485,640.459290 666.614929,639.612183 672.570435,638.765076 
	C672.547974,638.200989 672.525513,637.636902 672.503052,637.072815 
	C666.312805,637.246521 661.103027,632.362549 654.584900,634.227966 
	C647.151367,633.128296 639.717834,632.028687 632.258606,630.587341 
	C634.275757,629.189453 636.318604,628.133301 638.869507,626.858154 
	C639.907898,626.481873 640.438293,626.324585 641.413208,626.209717 
	C645.584167,626.639648 649.310608,627.027161 653.127991,627.437744 
	C653.218872,627.460938 653.369019,627.348511 653.576416,627.627319 
	C654.838013,628.322876 655.892334,628.739746 657.116150,629.399170 
	C657.845398,629.800598 658.405029,629.959351 659.189209,630.389404 
	C666.003174,633.408142 672.424133,637.248901 680.086609,634.133423 
	C680.465759,635.255981 680.722900,636.074646 680.980103,636.893372 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M654.696472,634.596863 
	C661.103027,632.362549 666.312805,637.246521 672.503052,637.072815 
	C672.525513,637.636902 672.547974,638.200989 672.570435,638.765076 
	C666.614929,639.612183 660.659485,640.459290 654.401550,641.550354 
	C653.648987,642.070068 653.198792,642.345825 652.150879,642.845093 
	C649.006531,641.526306 646.459839,639.983887 643.913147,638.441406 
	C646.160095,637.933533 648.441467,637.540039 650.641724,636.877136 
	C652.090942,636.440674 653.423340,635.616333 654.696472,634.596863 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M643.506226,638.501038 
	C646.459839,639.983887 649.006531,641.526306 651.855957,643.108582 
	C653.501526,644.759277 654.844238,646.370117 656.451599,648.197021 
	C656.716187,648.413147 656.770081,648.753174 656.891357,648.875305 
	C657.010437,649.758606 657.008301,650.519714 656.984131,651.662109 
	C650.171387,648.802856 643.380615,645.562378 636.130493,642.102661 
	C636.821228,638.949890 640.110840,638.985962 643.506226,638.501038 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M596.673462,531.053467 
	C601.979614,535.100647 606.968872,539.189087 611.993774,543.632324 
	C611.253418,544.052917 610.477539,544.118774 610.189880,544.143188 
	C611.807068,549.478821 613.365295,554.619751 614.923462,559.760681 
	C614.449890,560.004211 613.976318,560.247681 613.502686,560.491211 
	C613.010620,560.282410 612.470642,560.143372 612.039062,559.846558 
	C611.542053,559.504822 611.140930,559.023865 610.487488,558.403198 
	C609.965515,560.644958 609.530762,562.512390 609.113892,564.769226 
	C608.690857,566.671448 608.249756,568.184326 607.536865,569.904846 
	C605.225891,570.734253 603.186646,571.355957 600.804565,571.973267 
	C600.465088,571.237366 600.468384,570.505920 600.864136,569.261475 
	C601.148926,565.017395 601.041260,561.286377 600.933594,557.555298 
	C600.371338,557.593262 599.809082,557.631226 599.246826,557.669189 
	C599.102539,560.728577 598.958313,563.787964 598.814026,566.847351 
	C597.626709,567.480896 596.439331,568.114441 594.906128,568.869873 
	C594.656128,567.634827 594.752136,566.277893 595.030029,564.184692 
	C595.211914,561.584656 595.211914,559.720825 595.211914,557.856995 
	C594.860657,557.858276 594.509338,557.859558 594.158081,557.860901 
	C593.798645,559.924805 593.439209,561.988770 593.079834,564.052673 
	C591.242371,567.573914 589.404846,571.095093 586.948547,574.851013 
	C585.845764,575.989746 585.361816,576.893860 584.877869,577.797913 
	C582.690979,580.009155 580.504089,582.220398 578.092529,584.678528 
	C575.621704,584.852844 573.375610,584.780273 571.057434,584.349060 
	C573.385803,579.918030 575.786194,575.845703 578.091797,571.387085 
	C577.997131,571.000732 578.007385,571.032715 578.348145,571.037781 
	C579.389709,569.700623 580.090515,568.358398 581.112732,566.785522 
	C581.637634,564.691040 581.841064,562.827209 582.384399,561.036926 
	C583.472595,562.236267 584.220886,563.361938 584.990234,564.519531 
	C588.384644,559.741211 586.818542,549.359558 582.042480,544.630493 
	C579.596680,541.188965 577.227600,538.092224 575.180664,534.856079 
	C576.754395,534.053833 578.006042,533.390991 579.595337,532.810303 
	C581.985901,533.915283 584.038696,534.938232 586.120850,536.291748 
	C587.732666,537.779419 589.315125,538.936584 590.978577,540.433838 
	C594.443848,544.000671 597.828064,547.227417 601.700989,550.920044 
	C600.684021,544.995667 597.784790,541.290283 593.082031,538.501709 
	C592.310608,537.803711 591.662720,537.380554 590.885498,536.669067 
	C589.862854,535.887634 588.969482,535.394531 587.900269,534.634644 
	C586.469543,533.265930 585.214783,532.164001 583.959961,531.062134 
	C585.578613,531.009338 587.407288,530.452148 588.768005,531.018799 
	C590.958679,531.931091 592.840576,533.584900 594.908081,534.962158 
	C595.471741,533.457153 595.914185,532.275879 596.673462,531.053467 
M603.464478,553.256958 
	C603.178772,553.054321 602.893066,552.851746 602.607361,552.649109 
	C602.791321,552.950806 602.975281,553.252441 603.464478,553.256958 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M328.894775,191.608826 
	C329.806702,191.051666 330.732147,190.821106 331.657623,190.590546 
	C331.907593,192.038330 332.157562,193.486115 332.093781,194.994019 
	C330.502838,195.234833 329.225616,195.415512 327.487762,195.661362 
	C328.006927,194.299667 328.457611,193.117569 328.894775,191.608826 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M320.142029,183.982162 
	C320.863007,183.977707 321.584015,183.973267 322.664612,183.999908 
	C323.001038,184.780045 322.977814,185.529114 322.919006,186.652466 
	C321.503693,186.687836 320.123993,186.348907 318.377686,186.009644 
	C317.511200,184.815674 317.011292,183.622009 317.038513,182.397552 
	C318.424408,182.905228 319.283234,183.443695 320.142029,183.982162 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M678.781433,569.764709 
	C677.991455,569.561523 676.563721,569.459351 676.512939,569.138977 
	C676.122864,566.677979 676.000305,564.174561 675.885803,561.332214 
	C679.542480,558.049011 683.108093,555.117981 686.395508,552.415527 
	C687.174133,555.143921 687.918640,557.752625 688.436768,560.719727 
	C687.213684,561.768555 686.216858,562.458984 685.083984,562.968140 
	C684.633362,562.884155 684.318787,562.981567 684.003296,563.041016 
	C684.002258,563.003113 684.078125,563.002380 683.800049,563.154053 
	C683.360657,563.891174 683.199280,564.476624 683.021118,565.033203 
	C683.004333,565.004395 683.068359,565.023254 682.789917,565.066162 
	C682.350464,565.427307 682.189392,565.745483 682.023254,566.030273 
	C682.018127,565.996887 682.068542,566.042053 681.711182,566.006653 
	C680.496277,567.235718 679.638855,568.500183 678.781433,569.764709 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M679.451599,581.490234 
	C679.704285,578.832886 679.956970,576.175476 680.833252,573.221924 
	C683.288025,572.290100 685.119141,571.654541 686.734985,571.093750 
	C687.874390,572.584351 688.791931,573.784668 689.709473,574.985046 
	C689.709473,574.985046 690.006531,574.838196 690.002014,575.210815 
	C689.993896,576.050903 689.990356,576.518494 689.986816,576.986023 
	C689.561462,578.259277 689.136169,579.532593 688.298340,581.276855 
	C685.074402,581.661926 682.263000,581.576111 679.451599,581.490234 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M689.845154,574.586670 
	C688.791931,573.784668 687.874390,572.584351 686.734985,571.093750 
	C685.119141,571.654541 683.288025,572.290100 681.064087,572.942505 
	C680.747253,572.230164 680.823303,571.500977 681.076172,570.095947 
	C681.524841,568.294006 681.796692,567.168030 682.068542,566.042053 
	C682.068542,566.042053 682.018127,565.996887 682.310913,566.002441 
	C682.758606,565.679688 682.913513,565.351501 683.068359,565.023254 
	C683.068359,565.023254 683.004333,565.004395 683.371460,564.923462 
	C683.851685,564.229126 683.964905,563.615784 684.078125,563.002380 
	C684.078125,563.002380 684.002258,563.003113 684.296509,563.247314 
	C684.800476,563.377441 685.010315,563.263428 685.220093,563.149414 
	C686.216858,562.458984 687.213684,561.768555 688.514038,561.038696 
	C689.178772,562.758240 689.539978,564.517029 689.623535,566.849243 
	C689.528381,568.279419 689.710876,569.136230 689.893372,569.992981 
	C689.922546,571.391418 689.951660,572.789856 689.845154,574.586670 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M679.337097,581.868530 
	C682.263000,581.576111 685.074402,581.661926 688.229248,581.604736 
	C688.555969,582.875366 688.539246,584.289001 688.809814,585.914673 
	C687.995483,587.015564 686.893921,587.904541 685.516113,588.914734 
	C683.234131,586.772888 681.228394,584.509766 679.337097,581.868530 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M699.704956,551.967651 
	C698.777100,554.916199 697.496765,557.808105 695.977173,560.894043 
	C694.520081,560.302856 693.302185,559.517639 692.055542,558.346313 
	C694.468689,555.943787 696.910522,553.927368 699.704956,551.967651 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M689.998657,569.629028 
	C689.710876,569.136230 689.528381,568.279419 689.568848,567.232788 
	C689.895813,567.783630 689.999878,568.524292 689.998657,569.629028 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M690.216553,576.867065 
	C689.990356,576.518494 689.993896,576.050903 690.157715,575.267334 
	C690.360779,575.550232 690.403503,576.149170 690.216553,576.867065 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M390.679962,585.494629 
	C389.506012,584.215149 388.332062,582.935730 386.955811,581.397522 
	C387.444092,580.565491 388.134705,579.992188 388.970703,579.107178 
	C389.569122,579.148865 390.022156,579.502197 390.695984,580.419922 
	C392.352264,582.308899 393.607666,584.141785 395.299988,584.741638 
	C396.134796,585.037537 397.776764,583.055969 399.053497,582.104980 
	C399.394745,579.325195 399.735992,576.545410 400.325928,573.183716 
	C401.053131,571.091370 401.531647,569.580994 402.010132,568.070618 
	C402.331268,565.984070 402.652435,563.897522 403.013702,561.405518 
	C404.203033,561.591064 405.352264,562.182129 406.802490,562.924683 
	C407.139252,565.797852 407.175018,568.519531 406.820831,571.547363 
	C406.248779,571.916199 406.066650,571.978821 405.655396,572.082520 
	C405.141022,572.352966 405.075958,572.633667 405.129974,573.374634 
	C405.351959,579.194092 405.674988,584.604431 406.005066,590.373291 
	C408.223206,592.112427 410.434265,593.493042 412.645325,594.873657 
	C413.178345,592.253113 413.711334,589.632629 414.258179,586.606445 
	C413.461395,583.482422 412.650696,580.763977 411.840027,578.045593 
	C412.621796,578.053650 413.403564,578.061768 414.688934,578.338867 
	C415.405609,578.842041 415.669983,578.972107 415.985657,578.998047 
	C415.985657,578.998047 415.998688,578.997681 416.000122,579.005005 
	C417.315979,582.089783 418.630432,585.167297 419.992676,588.598511 
	C418.376984,591.714905 416.713531,594.477478 414.614258,597.611938 
	C412.698059,598.362793 411.217712,598.741821 409.421295,599.022827 
	C402.963470,594.448059 396.821716,589.971313 390.679962,585.494629 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M390.744873,559.139771 
	C393.044464,564.110962 396.061523,569.210510 396.710205,574.595337 
	C397.267914,579.225281 392.815857,577.418457 389.691071,576.926514 
	C389.693665,571.077576 390.064087,565.234802 390.744873,559.139771 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M375.998077,567.383911 
	C377.713745,567.026550 379.447266,567.026550 381.190552,567.026550 
	C381.920471,565.014099 382.562988,563.242554 383.465485,561.228516 
	C385.874084,564.393982 385.734467,567.631409 382.370789,570.033813 
	C379.476898,572.100708 377.517212,570.239746 375.998077,567.383911 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M386.728271,553.133545 
	C386.579254,552.240356 386.730469,551.182495 387.161621,549.955322 
	C387.303864,550.846985 387.166168,551.907898 386.728271,553.133545 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M391.469482,554.386230 
	C391.656006,555.297180 391.636230,556.474182 391.326294,557.869873 
	C391.111816,556.943176 391.187531,555.797729 391.469482,554.386230 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M416.816406,524.650269 
	C416.933350,521.430054 417.067780,518.392639 417.181824,515.815125 
	C421.716125,516.878967 425.136230,517.681396 429.131348,518.253418 
	C430.793243,518.375183 431.880157,518.727417 433.009277,519.399414 
	C434.426025,521.244324 435.800568,522.769409 437.175110,524.294495 
	C437.014740,524.826416 436.854401,525.358337 436.042816,525.967957 
	C433.598541,526.706665 431.805481,527.367737 429.595123,527.945862 
	C427.765015,527.889587 426.352173,527.916199 424.777710,527.629578 
	C422.134735,526.536377 419.653351,525.756531 417.171997,524.976624 
	C417.171997,524.976624 416.833862,524.833130 416.816406,524.650269 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M437.514709,524.251099 
	C435.800568,522.769409 434.426025,521.244324 433.389374,519.359619 
	C434.490662,518.984863 435.253998,518.969604 436.017365,518.954346 
	C437.946991,519.682434 439.876617,520.410400 441.903107,521.486267 
	C440.618073,522.625305 439.236176,523.416565 437.514709,524.251099 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M430.012421,528.028809 
	C431.805481,527.367737 433.598541,526.706665 435.772034,526.062012 
	C436.126099,526.520813 436.099701,526.963196 436.106689,528.026489 
	C436.203766,529.049011 436.267456,529.450745 436.331116,529.852417 
	C435.666107,530.482666 435.001099,531.112854 433.767700,531.741638 
	C432.137024,530.503052 431.074738,529.265930 430.012421,528.028809 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M436.617004,529.829163 
	C436.267456,529.450745 436.203766,529.049011 436.193085,528.348511 
	C436.831665,528.473694 437.417236,528.897705 438.023132,529.622375 
	C437.663300,529.884033 437.283112,529.844971 436.617004,529.829163 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M324.354218,220.049500 
	C324.083191,221.086639 323.627014,222.533066 323.066162,222.574844 
	C317.307526,223.003952 311.524353,223.242096 306.306641,219.119507 
	C305.792725,214.647552 308.812408,213.575317 312.099945,213.613327 
	C317.004486,213.670059 321.547455,214.969513 324.354218,220.049500 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M300.285767,214.510025 
	C298.302277,217.334869 296.517761,220.127045 294.074554,222.105881 
	C291.665253,224.057266 289.796143,223.169479 289.912292,219.304840 
	C291.351868,215.177948 293.006195,211.546021 298.015533,212.254944 
	C298.814484,212.367996 299.472900,213.474136 300.285767,214.510025 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M653.369019,627.348511 
	C653.369019,627.348511 653.218872,627.460938 652.945557,627.066162 
	C648.771057,626.503296 644.869873,626.335266 640.968750,626.167297 
	C640.438293,626.324585 639.907898,626.481873 639.113159,626.609375 
	C637.666748,626.100952 636.484741,625.622375 634.854553,624.989197 
	C634.977051,624.226013 635.547668,623.617371 636.831726,622.977539 
	C638.676941,621.583069 639.808655,620.219727 640.991394,618.571899 
	C641.394043,617.864563 641.745605,617.441711 642.462585,616.968750 
	C646.541138,613.506775 647.364563,605.159485 644.402588,600.957092 
	C644.316345,600.513306 644.230103,600.069519 644.412415,599.095154 
	C644.539185,597.724060 644.397400,596.883545 644.255676,596.043030 
	C644.224426,595.588440 644.193237,595.133911 644.261780,594.349854 
	C645.532593,593.458435 646.703674,592.896423 647.875244,592.335571 
	C650.821472,597.951172 651.582764,598.210327 655.174683,594.332458 
	C655.433655,593.931824 655.871277,593.898438 656.121826,593.825317 
	C656.561157,593.470642 656.749939,593.189209 657.099487,592.615662 
	C660.095764,589.556519 662.931335,586.789429 665.700256,584.450806 
	C665.362671,586.581787 665.091675,588.284180 664.596436,590.142334 
	C664.307312,590.837891 664.242554,591.377747 664.061035,592.289062 
	C664.353210,594.354980 664.762207,596.049500 665.171265,597.744019 
	C665.137207,599.580933 665.103149,601.417786 665.126404,603.714600 
	C665.183716,604.174500 665.160461,604.144836 664.769470,604.100220 
	C663.650879,604.774719 662.923279,605.493774 662.195679,606.212891 
	C662.195679,606.212891 662.181641,606.196777 661.824341,606.170166 
	C660.999939,606.817261 660.532776,607.490967 660.065613,608.164612 
	C659.927124,608.474487 659.701355,608.694946 658.839539,608.934204 
	C657.896851,609.487244 657.502869,609.932129 657.108887,610.377014 
	C656.972778,611.706543 656.836670,613.036133 656.972473,614.899780 
	C657.565613,615.601013 657.886841,615.768005 658.208069,615.935059 
	C659.050110,616.399780 659.892151,616.864441 660.925659,617.937012 
	C662.106445,619.003052 663.095764,619.461243 664.085083,619.919434 
	C664.085083,619.919373 663.989746,619.930969 664.043701,620.273682 
	C665.819824,621.604675 667.542053,622.592834 669.264221,623.580994 
	C669.264221,623.580994 669.281067,623.687012 669.413391,624.068481 
	C672.714905,625.064697 676.498535,626.736023 675.849365,620.784363 
	C675.680969,620.351807 675.512573,619.919250 675.344116,619.486694 
	C667.409302,623.258240 664.472595,615.511292 658.777527,613.004639 
	C663.692383,609.064270 667.997986,605.612366 672.810669,602.292419 
	C674.189514,602.614868 675.061157,602.805420 676.174683,603.151611 
	C676.928894,603.561218 677.441345,603.815125 678.001831,604.428101 
	C678.560303,605.398438 679.007385,606.470886 679.590698,606.550964 
	C687.112549,607.584229 694.635498,608.791443 702.200195,609.228577 
	C704.767578,609.376953 707.452515,607.491760 710.424622,606.378235 
	C712.009033,605.893494 713.252563,605.566467 714.496094,605.239441 
	C714.499573,604.857910 714.503052,604.476379 714.506531,604.094910 
	C709.979370,602.441406 705.452148,600.787964 701.113770,598.772583 
	C706.249390,597.939697 711.337097,598.033936 716.104553,596.844360 
	C721.217285,595.568665 726.028748,593.085632 731.130981,590.999634 
	C731.290222,590.869751 731.701111,590.863647 731.701111,590.863647 
	C732.706360,591.694885 733.711670,592.526062 734.578369,593.861206 
	C725.515930,602.338135 716.585327,610.303894 707.672363,618.289185 
	C705.398865,620.326050 703.181213,622.425293 700.572144,624.611938 
	C697.113220,626.571228 694.020020,628.414551 690.579346,630.405396 
	C689.495361,630.707642 688.758972,630.862366 687.833130,631.050720 
	C687.393433,631.173035 687.193420,631.326843 686.720459,631.662964 
	C685.949951,631.879761 685.502563,631.979370 684.816711,631.785278 
	C683.789368,631.368713 682.831421,630.892700 682.237549,631.177063 
	C675.692200,634.311646 669.525574,632.903503 663.317505,630.061584 
	C662.125122,629.515686 660.428650,630.070923 658.964722,630.118103 
	C658.405029,629.959351 657.845398,629.800598 657.071472,628.999573 
	C655.694519,628.021057 654.531738,627.684753 653.369019,627.348511 
M699.441711,617.915833 
	C699.795349,617.515747 700.148926,617.115723 700.502563,616.715576 
	C699.946472,616.551025 699.390381,616.386475 698.094299,616.126465 
	C692.768982,614.516418 687.465576,612.824036 682.091370,611.398010 
	C681.401245,611.214905 680.343750,612.416199 678.821655,612.875061 
	C678.611816,613.621399 677.975220,614.670471 678.257202,615.067932 
	C681.590698,619.767029 689.827515,620.936279 697.584473,617.750366 
	C697.995178,617.758545 698.405823,617.766724 699.441711,617.915833 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M653.955078,577.389465 
	C659.353455,573.299438 664.655029,569.545044 670.045898,565.463989 
	C670.135071,565.137329 670.586914,565.065491 671.113892,565.073120 
	C672.046570,565.104553 672.452271,565.128357 672.857971,565.152161 
	C672.834106,565.820923 672.810242,566.489624 672.540039,567.841187 
	C672.204590,570.540100 672.115662,572.556152 672.031128,574.708740 
	C671.936340,575.048035 671.781982,575.107544 671.181091,575.025818 
	C664.534485,577.683228 658.279297,580.338379 652.024109,582.993530 
	C652.635498,581.237366 653.246887,579.481262 653.955078,577.389465 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M671.572510,575.023560 
	C671.781982,575.107544 671.936340,575.048035 672.340210,574.508057 
	C672.790588,573.973206 672.936218,573.775452 673.081909,573.577759 
	C673.596130,577.714050 674.110291,581.850403 674.192871,586.325195 
	C671.369324,584.156555 669.344910,584.846985 667.421021,587.309387 
	C666.659607,588.284058 665.693604,589.098999 664.820679,589.986694 
	C665.091675,588.284180 665.362671,586.581787 665.855225,584.188354 
	C667.908630,580.672791 669.740601,577.848145 671.572510,575.023560 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M664.596436,590.142334 
	C665.693604,589.098999 666.659607,588.284058 667.421021,587.309387 
	C669.344910,584.846985 671.369324,584.156555 674.047119,586.752930 
	C674.440063,587.546509 674.547180,588.250854 674.297607,589.456726 
	C671.068665,592.515503 668.324097,595.709045 664.177795,591.917603 
	C664.242554,591.377747 664.307312,590.837891 664.596436,590.142334 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M664.061035,592.289062 
	C668.324097,595.709045 671.068665,592.515503 674.244263,589.818970 
	C673.889099,596.447876 671.037903,599.145081 665.499756,597.836060 
	C664.762207,596.049500 664.353210,594.354980 664.061035,592.289062 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M681.711182,566.006653 
	C681.796692,567.168030 681.524841,568.294006 681.065308,569.729614 
	C680.410706,569.996399 679.943726,569.953430 679.129150,569.837585 
	C679.638855,568.500183 680.496277,567.235718 681.711182,566.006653 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M673.066895,573.172424 
	C672.936218,573.775452 672.790588,573.973206 672.335815,574.371582 
	C672.115662,572.556152 672.204590,570.540100 672.527588,568.175903 
	C672.858398,569.474243 672.955139,571.120667 673.066895,573.172424 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M672.796631,564.884888 
	C672.452271,565.128357 672.046570,565.104553 671.339478,565.034851 
	C671.603821,564.865173 672.169556,564.741394 672.796631,564.884888 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M481.950500,621.408813 
	C483.724213,622.217651 485.530701,623.379211 488.326172,625.176758 
	C487.473663,621.481873 486.868378,618.858643 486.442871,615.848328 
	C489.912079,619.366150 490.307404,623.851074 489.825165,628.511841 
	C489.255768,628.870056 488.686340,629.228210 488.116913,629.586365 
	C486.072388,626.978088 484.027863,624.369873 481.950500,621.408813 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M476.352356,622.633545 
	C475.700684,622.508850 474.897644,622.073730 474.084290,621.258179 
	C474.782959,621.359497 475.491943,621.841248 476.352356,622.633545 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M522.530212,291.094971 
	C523.054565,292.497589 523.126099,293.917908 523.253906,295.763977 
	C519.829102,296.232300 516.348022,296.274902 512.402588,296.361877 
	C511.774719,294.969452 511.611237,293.532593 511.505981,291.739441 
	C515.068604,291.292969 518.572998,291.202850 522.530212,291.094971 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M595.998291,495.997559 
	C596.098572,495.965820 596.200562,495.936493 596.153564,495.955200 
	C596.004700,496.003174 596.000000,496.000000 595.998291,495.997559 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M633.782593,489.060242 
	C633.773865,489.211884 633.475525,489.342224 633.053711,489.327667 
	C633.117737,489.134857 633.305359,489.086884 633.782593,489.060242 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M481.734833,563.641113 
	C481.354034,563.544067 481.260498,563.478577 481.207794,563.458252 
	C487.256866,560.536377 493.358643,557.634705 499.734039,554.493652 
	C505.978149,552.859802 511.123352,555.214417 516.531494,557.987122 
	C514.478149,558.682922 512.106262,559.213196 509.138977,559.553284 
	C508.125336,560.037598 507.707153,560.712097 507.288940,561.386597 
	C505.590637,562.123596 503.892334,562.860596 501.832825,563.566284 
	C495.019623,563.602661 488.567627,563.670471 481.734833,563.641113 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M507.571625,561.273560 
	C507.707153,560.712097 508.125336,560.037598 508.760010,559.572998 
	C508.602417,560.242126 508.228363,560.701355 507.571625,561.273560 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M738.998779,482.019836 
	C738.885010,482.423035 738.771179,482.826263 738.391968,483.806427 
	C735.113281,492.000580 732.100037,499.617767 729.039917,506.891296 
	C728.440796,505.750458 727.888428,504.953247 727.914551,504.991028 
	C726.267761,506.258179 725.135132,507.129700 724.002441,508.001221 
	C724.002441,508.001221 723.723755,507.775513 723.581787,507.659576 
	C728.946411,493.699860 733.855347,479.688232 735.372986,464.734131 
	C735.640198,462.100861 735.828003,459.459534 736.463989,456.549957 
	C738.463623,457.477509 740.051697,458.677063 741.755493,460.303131 
	C740.913696,467.826385 739.956238,474.923126 738.998779,482.019836 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M741.639832,459.876587 
	C740.051697,458.677063 738.463623,457.477509 736.593140,456.112000 
	C736.353943,453.834778 736.397156,451.723572 736.972290,449.420044 
	C739.107544,449.857269 740.710815,450.486847 742.447998,451.409729 
	C742.267822,454.427551 741.953857,457.152069 741.639832,459.876587 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M742.314148,451.116394 
	C740.710815,450.486847 739.107544,449.857269 737.161743,449.086304 
	C736.765442,447.562653 736.711731,446.180420 737.168457,444.396210 
	C738.449463,443.983704 739.220032,443.973175 739.990540,443.962616 
	C739.990540,443.962616 740.478394,444.003326 740.747070,444.293152 
	C741.364746,444.903748 741.713684,445.224487 742.062683,445.545227 
	C742.062683,445.545227 742.362976,445.696777 742.456665,445.836456 
	C742.550354,445.976135 742.811646,445.904694 742.821228,446.300751 
	C742.658569,448.170013 742.486328,449.643188 742.314148,451.116394 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M739.957520,443.623657 
	C739.220032,443.973175 738.449463,443.983704 737.293335,443.998718 
	C736.837158,443.244965 736.766602,442.486694 736.827393,441.367126 
	C737.947266,441.765411 738.935913,442.525055 739.957520,443.623657 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M398.680115,582.020020 
	C397.776764,583.055969 396.134796,585.037537 395.299988,584.741638 
	C393.607666,584.141785 392.352264,582.308899 390.895386,580.630249 
	C393.351593,580.829224 395.829193,581.382202 398.680115,582.020020 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M401.729919,568.136841 
	C401.531647,569.580994 401.053131,571.091370 400.298431,572.806030 
	C399.444611,571.554993 398.866974,570.099670 398.247375,568.538452 
	C399.588684,568.397949 400.519196,568.300476 401.729919,568.136841 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M512.978638,514.536865 
	C513.037659,515.351746 513.021790,515.820129 513.006592,516.638672 
	C500.466522,512.518799 487.925751,508.048615 475.134521,502.950592 
	C473.926361,501.884460 472.968689,501.446198 472.010986,501.007904 
	C472.010986,501.007904 472.000397,501.000214 471.974945,500.643982 
	C469.463257,496.371185 466.977020,492.454620 464.562927,488.651642 
	C464.547821,488.705872 464.239288,489.813965 463.930786,490.922028 
	C463.071045,489.791260 462.211365,488.660492 461.172485,487.265503 
	C462.737732,483.718292 464.376068,480.370575 466.306641,477.200867 
	C466.749603,476.473511 468.197662,476.358276 469.627869,476.273315 
	C471.735718,478.081757 472.249115,477.802826 472.998932,474.995453 
	C472.998932,474.995453 473.000000,475.000000 472.997742,474.999390 
	C476.735138,475.528931 480.713318,478.188293 484.315796,473.353607 
	C488.488525,470.923553 492.245026,468.917358 496.325317,466.885620 
	C497.105560,466.235992 497.562042,465.611908 498.018494,464.987854 
	C498.018494,464.987823 497.996796,464.994049 497.990021,465.002930 
	C502.087311,463.397888 506.191345,461.783936 510.695129,460.440796 
	C512.727173,460.525970 514.359436,460.340302 516.377075,460.097046 
	C521.797119,457.989044 526.831665,455.938690 532.244507,453.913879 
	C537.077515,452.289459 541.532227,450.639557 545.990356,449.415466 
	C545.988281,451.265869 545.982910,452.690430 545.664795,454.303345 
	C538.689636,457.096008 532.027100,459.700317 524.964844,462.227539 
	C518.029053,465.412781 511.493011,468.675171 504.659851,472.099243 
	C502.579437,475.152771 500.796082,478.044647 498.887329,480.957245 
	C498.761932,480.977966 498.511658,481.022552 498.093689,481.050720 
	C495.718842,481.080688 493.578339,480.586121 491.856323,481.223022 
	C490.114075,481.867432 488.786011,483.631683 487.010315,485.065674 
	C486.606995,486.766174 486.469879,488.306396 485.982086,489.883850 
	C485.092468,490.320160 484.553528,490.719238 483.747192,491.005310 
	C482.874359,490.498596 482.268951,490.104950 481.794647,489.796539 
	C481.925049,491.797913 482.043762,493.619385 481.887085,495.428009 
	C481.683502,496.006561 481.755249,496.597931 481.946533,497.427795 
	C482.322327,498.105896 482.578583,498.545563 482.507599,498.910889 
	C476.284973,496.554016 473.928864,491.537598 472.389374,484.999176 
	C470.400452,490.078918 469.817017,493.779907 474.641357,496.460236 
	C476.008057,497.219513 476.933075,498.773743 478.060669,499.963379 
	C480.276611,501.617950 482.260315,503.973511 484.751038,504.798706 
	C492.976532,507.523895 501.398041,509.653137 509.708923,512.129822 
	C510.874939,512.477295 511.843597,513.487061 512.978638,514.536865 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M472.109436,501.265564 
	C472.968689,501.446198 473.926361,501.884460 474.923401,502.670654 
	C474.545624,502.996979 474.128540,502.975342 473.399658,502.936798 
	C472.794525,502.454346 472.501190,501.988770 472.109436,501.265564 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M656.760254,530.540771 
	C656.689209,531.069031 656.381592,531.351990 655.909302,531.907715 
	C651.720459,530.541626 647.696228,528.902710 643.365479,527.085144 
	C647.547119,528.036133 652.035461,529.165833 656.760254,530.540771 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M701.198975,550.947388 
	C701.124207,551.388367 700.843445,551.637573 700.292847,551.969360 
	C700.346375,551.619873 700.669617,551.187744 701.198975,550.947388 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M597.687134,628.638428 
	C597.393616,629.064880 596.809143,629.220398 596.071533,629.125549 
	C596.411011,628.705933 596.903564,628.536621 597.687134,628.638428 
z"
      />
      <path
        fill="#0C1C1F"
        opacity="1.000000"
        stroke="none"
        d="
M763.011108,199.989014 
	C762.587891,199.879257 762.156067,199.778198 761.724304,199.677139 
	C762.070862,199.651947 762.417358,199.626770 762.876465,199.809174 
	C762.988953,200.016769 763.002502,199.997711 763.011108,199.989014 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M773.985962,183.009247 
	C774.104309,183.120377 774.232910,183.224213 774.361511,183.328049 
	C774.297180,183.281616 774.232910,183.235184 774.088318,183.084961 
	C774.008057,182.981171 773.996216,183.001968 773.985962,183.009247 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M406.979156,534.231445 
	C404.119995,536.723450 396.630402,535.567139 393.739960,532.086975 
	C392.385406,530.455994 391.247009,528.645508 389.976654,526.582092 
	C395.099030,528.343811 400.255432,530.439880 405.935211,532.793457 
	C406.632111,533.444458 406.805634,533.837952 406.979156,534.231445 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M399.155182,522.331482 
	C401.164246,518.799805 403.340057,519.171997 406.135040,521.516296 
	C408.436584,523.446777 411.281433,524.729370 413.950653,526.644287 
	C412.859894,527.079529 411.565796,527.551514 410.572662,527.191956 
	C406.764252,525.813354 403.052460,524.167786 399.155182,522.331482 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M407.361450,534.252869 
	C406.805634,533.837952 406.632111,533.444458 406.324341,532.880493 
	C405.840057,531.047363 405.490021,529.384644 404.879791,526.485962 
	C408.147583,528.171570 410.458740,529.363708 412.807251,531.161255 
	C412.379181,532.363464 411.913757,532.960266 411.448334,533.557129 
	C410.213470,533.796204 408.978607,534.035217 407.361450,534.252869 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M417.135254,525.238159 
	C419.653351,525.756531 422.134735,526.536377 424.539917,527.872803 
	C422.390381,529.430908 420.317017,530.432495 418.243652,531.434021 
	C418.051727,531.088135 417.859833,530.742310 417.229675,530.159546 
	C416.509399,529.847107 416.223846,529.829895 415.934814,529.870972 
	C415.920837,529.698486 415.906860,529.526001 415.873840,529.127563 
	C415.854858,528.901672 415.755768,528.994263 415.755768,528.994263 
	C416.155731,528.611328 416.555695,528.228333 416.958313,527.412964 
	C416.960938,526.980530 416.984161,527.047363 417.245483,526.990845 
	C417.351776,526.631104 417.196716,526.327942 417.041656,526.024780 
	C417.060608,525.849731 417.079590,525.674683 417.135254,525.238159 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M415.555817,530.009460 
	C416.223846,529.829895 416.509399,529.847107 417.008850,529.960083 
	C415.550110,531.264771 413.874023,532.532104 411.823120,533.678284 
	C411.913757,532.960266 412.379181,532.363464 412.945312,531.499023 
	C413.756256,530.870300 414.466553,530.509094 415.555817,530.009460 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M415.779236,528.947815 
	C415.755768,528.994263 415.854858,528.901672 415.864807,528.868164 
	C415.874786,528.834656 415.802734,528.901367 415.779236,528.947815 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M358.011780,272.253723 
	C365.217163,276.366608 373.426453,279.779419 379.136047,285.631195 
	C384.200623,290.821838 386.515594,298.707764 389.982544,305.435730 
	C390.813812,307.048920 391.589081,308.736908 392.063507,310.479431 
	C393.519348,315.826569 396.697357,319.474823 401.996338,321.576477 
	C401.943542,323.174561 401.912537,324.374756 401.881531,325.574982 
	C406.546082,339.142761 411.210663,352.710510 415.676880,366.841888 
	C415.553558,369.374939 415.628540,371.344421 415.703491,373.313873 
	C410.769684,366.997559 405.835907,360.681244 401.286682,353.835510 
	C402.692871,352.959290 403.714539,352.612427 405.367584,352.051208 
	C402.908600,348.454987 400.740631,345.284393 398.572662,342.113831 
	C391.039764,325.991272 383.692474,309.777252 375.829712,293.817169 
	C374.093231,290.292480 370.580566,287.621277 367.796112,284.640869 
	C365.301117,281.970306 362.682587,279.415131 359.806335,276.719696 
	C358.972260,275.291687 358.450348,273.953094 358.011780,272.253723 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M364.110077,254.757599 
	C362.488800,254.160782 361.023651,253.247833 359.243134,252.269943 
	C358.772095,248.461807 358.616455,244.718613 358.541260,240.522629 
	C358.853973,240.063568 359.086273,240.057281 359.665344,240.014313 
	C360.486938,240.576660 360.961731,241.175690 361.700928,241.895706 
	C362.461121,242.588287 362.956970,243.159882 363.722107,243.834534 
	C363.569519,247.452316 367.434998,250.854858 364.110077,254.757599 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M370.210693,310.638733 
	C370.094177,311.006195 369.859009,311.021210 369.270355,311.042969 
	C367.559723,309.080048 366.202576,307.110352 364.601685,304.922241 
	C362.564850,301.048126 360.771790,297.392426 358.952393,293.369324 
	C361.427551,296.266144 364.096222,299.418945 366.372162,302.833527 
	C367.900085,305.125824 368.871582,307.789001 370.210693,310.638733 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M358.284302,291.490601 
	C358.514679,291.675018 358.721436,292.119324 358.963898,292.817749 
	C358.753265,292.631409 358.506927,292.190979 358.284302,291.490601 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M436.258301,518.687378 
	C435.253998,518.969604 434.490662,518.984863 433.347168,519.039856 
	C431.880157,518.727417 430.793243,518.375183 429.366241,517.964722 
	C426.023468,515.565735 423.020752,513.225037 419.979431,510.550568 
	C426.696777,511.078979 433.452698,511.941162 440.611816,512.915222 
	C441.559326,516.540955 439.761902,518.094116 436.258301,518.687378 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M451.567993,506.225220 
	C451.458435,505.950409 451.629578,505.608582 452.103180,505.220337 
	C452.220001,505.502045 452.034332,505.830109 451.567993,506.225220 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M405.884552,572.041504 
	C406.066650,571.978821 406.248779,571.916199 406.718201,571.884949 
	C408.425568,573.850769 409.845612,575.785095 411.552826,577.882507 
	C412.650696,580.763977 413.461395,583.482422 413.943420,586.463928 
	C412.336456,585.344482 411.058136,583.961853 409.593323,582.377563 
	C408.286285,585.153992 407.142181,587.584351 405.998047,590.014709 
	C405.674988,584.604431 405.351959,579.194092 405.324341,573.294678 
	C405.865723,572.605652 405.953979,572.350952 405.884552,572.041504 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M415.894836,578.778503 
	C415.669983,578.972107 415.405609,578.842041 415.071869,578.420166 
	C415.296387,578.182251 415.580688,578.291077 415.894836,578.778503 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M416.975250,526.280396 
	C417.196716,526.327942 417.351776,526.631104 417.280823,526.989014 
	C417.006134,526.874512 416.957489,526.705322 416.975250,526.280396 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M641.556213,524.475220 
	C641.597107,524.536255 641.515320,524.414246 641.556213,524.475220 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M494.887299,450.070679 
	C488.956207,443.619110 480.670868,441.402679 472.733582,437.931641 
	C467.507324,432.903656 467.507324,432.903656 474.675476,428.992859 
	C475.062836,429.362579 475.102905,429.826874 475.225647,430.631073 
	C476.857758,436.793823 482.408997,437.850372 486.733673,439.901093 
	C492.402100,442.589050 498.574219,444.210144 504.516571,446.326935 
	C507.577698,447.417389 510.252319,448.926697 510.801514,452.950378 
	C508.624268,454.797028 506.183502,456.367828 503.410767,457.602844 
	C503.705048,455.598846 504.661743,453.962402 504.826660,452.249664 
	C504.917511,451.305725 503.678253,450.233734 503.038635,449.219482 
	C502.291351,449.848602 501.544098,450.477753 500.511841,451.030029 
	C498.447021,450.658997 496.667175,450.364807 494.887299,450.070679 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M500.796814,451.106934 
	C501.544098,450.477753 502.291351,449.848602 503.038635,449.219482 
	C503.678253,450.233734 504.917511,451.305725 504.826660,452.249664 
	C504.661743,453.962402 503.705048,455.598846 503.048279,457.640564 
	C500.109772,459.181641 497.201843,460.349274 494.045654,461.253662 
	C494.861572,459.893707 495.925720,458.797028 497.478210,457.347626 
	C498.909973,455.032257 499.853394,453.069611 500.796814,451.106934 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M496.001526,466.911133 
	C492.245026,468.917358 488.488525,470.923553 484.382904,473.008240 
	C484.292236,472.234222 484.550690,471.381714 484.921326,470.278198 
	C488.476166,468.446472 491.918823,466.865784 495.695557,465.494812 
	C496.020264,466.106781 496.010895,466.508942 496.001526,466.911133 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M496.325317,466.885620 
	C496.010895,466.508942 496.020264,466.106781 496.036743,465.403473 
	C496.481812,465.037292 496.919708,464.972198 497.688080,464.947479 
	C497.562042,465.611908 497.105560,466.235992 496.325317,466.885620 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M492.019287,339.696655 
	C491.963135,339.900299 491.780396,339.934662 491.320679,339.999176 
	C491.326721,339.862030 491.609680,339.694702 492.019287,339.696655 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M598.864136,567.191284 
	C598.958313,563.787964 599.102539,560.728577 599.246826,557.669189 
	C599.809082,557.631226 600.371338,557.593262 600.933594,557.555298 
	C601.041260,561.286377 601.148926,565.017395 600.966553,568.905945 
	C600.389404,569.041260 600.102234,569.019043 599.384155,568.957458 
	C598.940247,568.457092 598.927246,567.996094 598.864136,567.191284 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M419.850403,556.484741 
	C419.378571,556.167603 419.206421,555.965393 418.750366,555.797607 
	C418.837708,553.954712 419.123749,552.150146 420.167358,550.183350 
	C425.971588,551.030090 431.018219,552.039001 436.064819,553.047974 
	C433.665863,554.329163 431.266907,555.610352 428.678192,557.166443 
	C425.737427,557.136597 422.986389,556.831909 419.850403,556.484741 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M436.427124,553.014160 
	C431.018219,552.039001 425.971588,551.030090 420.491394,550.037476 
	C423.997375,545.519531 428.870270,545.303162 434.559265,547.055054 
	C436.395874,548.525269 437.831268,549.946472 439.403564,551.692017 
	C438.623413,552.337585 437.706390,552.658936 436.427124,553.014160 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M418.303467,531.733948 
	C420.317017,530.432495 422.390381,529.430908 424.701538,528.186157 
	C426.352173,527.916199 427.765015,527.889587 429.595123,527.945862 
	C431.074738,529.265930 432.137024,530.503052 433.465881,531.914795 
	C433.778778,532.266418 433.825134,532.443420 433.918274,533.080078 
	C433.899384,533.712891 433.833801,533.885986 433.318268,534.022644 
	C428.285614,533.995300 423.702911,534.004456 419.120239,534.013672 
	C419.120239,534.013672 418.776215,533.857178 418.587341,533.861572 
	C418.386749,533.255249 418.375000,532.644531 418.303467,531.733948 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M419.217407,534.345703 
	C423.702911,534.004456 428.285614,533.995300 433.606506,534.115234 
	C434.525635,534.333984 434.706573,534.423645 434.887543,534.513367 
	C434.653015,534.652466 434.534058,534.858276 434.504822,535.311035 
	C429.271759,538.059204 424.152740,538.985046 419.217407,534.345703 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M438.880737,539.713867 
	C438.250336,539.993225 437.501617,539.996216 436.378601,540.003296 
	C436.435181,539.216187 436.866058,538.425049 437.296936,537.633972 
	C437.785431,538.235107 438.273926,538.836243 438.880737,539.713867 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M434.864075,534.231934 
	C434.706573,534.423645 434.525635,534.333984 434.056488,534.151733 
	C433.833801,533.885986 433.899384,533.712891 434.091888,533.292725 
	C434.426025,533.347351 434.633301,533.648926 434.864075,534.231934 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M655.945068,413.181030 
	C646.401123,412.847351 637.145325,412.545990 627.908203,411.954010 
	C623.674927,411.682739 619.478271,410.840179 615.113525,409.696045 
	C615.184265,408.900787 615.293823,408.621857 615.290649,408.298645 
	C615.290649,408.298645 615.372620,408.337921 615.418945,408.347107 
	C623.317993,401.472534 631.170715,394.588745 639.265381,387.100708 
	C650.710144,380.828186 658.251465,371.578308 664.756348,360.912994 
	C665.687988,359.145172 666.303772,357.470123 666.924805,355.415802 
	C667.393921,353.066437 667.857727,351.096344 668.535828,348.952332 
	C668.996277,347.234619 669.242432,345.690826 669.680603,343.923920 
	C670.262451,342.800690 670.652222,341.900543 671.042053,341.000427 
	C676.445618,342.075562 681.862122,343.093719 687.231506,344.318665 
	C687.737671,344.434143 687.947205,345.849915 687.978333,347.206451 
	C686.090637,348.672791 684.291809,349.352386 682.995483,350.567871 
	C680.439758,352.964325 677.106812,355.265656 675.977539,358.305573 
	C673.121826,365.992859 671.308350,374.067352 668.792297,382.222321 
	C667.252075,386.956970 665.996826,391.456055 664.741577,395.955139 
	C665.307495,396.128845 665.873474,396.302521 666.439392,396.476227 
	C668.010254,391.701263 669.581116,386.926331 671.349670,381.849365 
	C673.996826,374.505585 676.235779,367.378998 679.017212,360.470825 
	C679.912659,358.246857 682.237061,356.598267 683.907776,354.686462 
	C684.821411,359.886932 685.735046,365.087402 686.715759,370.669891 
	C687.590759,370.230591 688.512634,369.767700 689.767822,369.187378 
	C690.084534,371.440002 690.067932,373.810120 690.012756,376.629272 
	C687.617493,379.875122 684.275513,382.308929 683.086609,385.535980 
	C679.352600,395.671143 671.775085,401.936188 663.251709,407.578857 
	C660.780640,409.214813 658.570618,411.245087 655.945068,413.181030 
M671.725159,358.119965 
	C671.532654,357.575104 671.340210,357.030243 671.147705,356.485413 
	C670.868530,356.613190 670.589417,356.740997 670.310242,356.868774 
	C670.636658,357.429565 670.963074,357.990356 671.725159,358.119965 
M671.737915,349.184906 
	C671.623657,349.027130 671.509338,348.869385 671.395142,348.711609 
	C671.418213,348.931244 671.441345,349.150909 671.737915,349.184906 
M673.474304,357.371277 
	C673.528564,357.159393 673.582886,356.947479 673.637146,356.735596 
	C673.503906,356.871643 673.370605,357.007690 673.474304,357.371277 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M688.376099,386.967468 
	C688.147949,385.843781 688.264343,384.653351 688.630127,383.202271 
	C688.826538,384.261322 688.773621,385.581024 688.376099,386.967468 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M553.966064,368.515411 
	C553.532532,368.984802 553.107239,368.987946 552.363403,368.983093 
	C552.033813,360.212189 552.022339,351.449341 552.014038,342.686493 
	C552.013855,342.522339 552.050781,342.358154 552.070435,342.193970 
	C552.377014,342.581024 552.683594,342.968079 552.996216,344.055664 
	C553.003967,345.500763 553.005676,346.245270 553.007324,346.989807 
	C553.329651,354.009613 553.651917,361.029388 553.966064,368.515411 
z"
      />
      <path
        fill="#F1F0D4"
        opacity="1.000000"
        stroke="none"
        d="
M553.361450,346.996948 
	C553.005676,346.245270 553.003967,345.500763 553.008362,344.384155 
	C553.459778,344.008057 553.905090,344.004028 554.684937,344.004517 
	C555.067322,344.760834 555.115295,345.512665 555.149780,346.641663 
	C554.662781,347.013947 554.189148,347.009003 553.361450,346.996948 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M577.516235,340.248352 
	C577.539429,340.269745 577.588989,340.365845 577.583313,340.415833 
	C577.577637,340.465820 577.454468,340.278290 577.464844,340.222351 
	C577.475220,340.166443 577.493103,340.226929 577.516235,340.248352 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M557.700806,535.019958 
	C556.232361,533.262085 555.082886,531.545593 554.282776,529.431519 
	C559.104187,527.308228 560.770508,531.685913 563.721130,533.247498 
	C567.190918,535.083740 570.574463,537.082886 574.038940,539.356323 
	C575.731079,541.122375 577.379822,542.543579 579.021362,544.367615 
	C579.010803,545.844421 579.007446,546.918396 578.643799,548.059692 
	C577.923889,548.771606 577.098877,549.614807 577.276123,550.030273 
	C579.181580,554.495667 576.981323,557.834656 574.716797,561.396973 
	C573.362000,563.528198 572.810913,566.170410 571.898560,568.582947 
	C569.635193,571.203003 567.599670,574.076050 565.047058,576.375061 
	C562.248169,578.895874 558.972473,580.887207 555.575562,583.225647 
	C554.839722,582.481201 554.432800,581.620422 554.020447,580.387573 
	C554.015015,580.015503 554.002136,580.003174 554.355103,579.971069 
	C560.190857,576.020935 562.654297,570.343079 563.992676,564.009521 
	C564.400146,563.999023 564.807678,563.988525 565.517212,563.964050 
	C566.065369,564.855225 566.311523,565.760315 566.599060,566.817444 
	C573.515137,560.368103 568.137573,541.160767 557.700806,535.019958 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M572.137756,568.821838 
	C572.810913,566.170410 573.362000,563.528198 574.716797,561.396973 
	C576.981323,557.834656 579.181580,554.495667 577.276123,550.030273 
	C577.098877,549.614807 577.923889,548.771606 578.641724,548.063477 
	C579.000000,548.000000 579.007568,547.996704 579.033875,548.347473 
	C579.711365,550.134033 580.362488,551.569763 581.031006,553.406372 
	C581.380432,556.192627 581.712463,558.577942 582.044495,560.963318 
	C581.841064,562.827209 581.637634,564.691040 580.853149,566.675232 
	C579.517151,568.207947 578.762268,569.620300 578.007385,571.032715 
	C578.007385,571.032715 577.997131,571.000732 578.013428,570.999634 
	C577.567322,571.274902 577.104858,571.551331 576.054321,571.918457 
	C574.569397,571.657227 573.672485,571.305298 572.775635,570.953369 
	C572.642761,570.322510 572.509827,569.691589 572.137756,568.821838 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M572.541199,571.176331 
	C573.672485,571.305298 574.569397,571.657227 575.825928,572.070190 
	C573.389587,575.411377 570.593506,578.691589 567.476318,582.064453 
	C566.783691,581.636414 566.412109,581.115906 566.002197,580.264648 
	C568.078064,577.089050 570.192444,574.244141 572.541199,571.176331 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M414.968170,633.989929 
	C419.552063,633.064880 424.135986,632.139893 429.125854,631.317322 
	C428.779480,632.247742 428.027161,633.075684 426.956848,634.253540 
	C429.048309,635.107910 430.828430,635.835083 432.867310,637.122925 
	C433.100403,638.450745 433.323944,639.749756 433.008118,639.897644 
	C431.125305,640.779724 429.117981,641.396057 427.152466,642.101562 
	C426.909393,641.741028 426.666321,641.380493 426.063599,640.455322 
	C419.923523,638.787231 414.143097,637.683716 408.362671,636.580200 
	C408.341553,635.965942 408.320465,635.351624 408.299347,634.737366 
	C410.522278,634.488220 412.745239,634.239075 414.968170,633.989929 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M414.982819,633.681519 
	C412.745239,634.239075 410.522278,634.488220 408.299347,634.737366 
	C408.320465,635.351624 408.341553,635.965942 408.362671,636.580200 
	C414.143097,637.683716 419.923523,638.787231 425.811829,640.239929 
	C424.545563,640.705444 423.171448,640.821838 421.385681,641.017578 
	C420.555664,640.999146 420.137329,640.901367 419.066711,640.633972 
	C410.466553,638.159912 402.518646,635.855469 394.697662,633.039185 
	C394.908844,632.186035 394.993103,631.844666 395.484650,631.639282 
	C399.878998,632.053162 403.862549,632.443665 407.854401,632.566956 
	C410.237976,632.640564 412.634491,632.295349 415.025208,632.138428 
	C415.015961,632.549988 415.006714,632.961609 414.982819,633.681519 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M426.983002,642.348511 
	C429.117981,641.396057 431.125305,640.779724 433.008118,639.897644 
	C433.323944,639.749756 433.100403,638.450745 433.101318,637.385498 
	C434.710968,637.198364 436.345428,637.309326 438.548553,637.793091 
	C439.870300,638.207642 440.623352,638.249390 441.376404,638.291077 
	C441.740356,638.443054 442.104279,638.595032 442.735596,638.873779 
	C442.976318,639.329285 443.041138,639.902344 442.909882,639.951416 
	C437.035431,642.149536 431.143738,644.301453 425.254089,646.458923 
	C425.145813,646.155457 425.037567,645.852051 424.850677,645.163513 
	C425.452545,644.050781 426.133026,643.323120 426.983002,642.348511 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M431.072693,648.188416 
	C431.136475,647.960815 431.299225,647.905640 431.719299,647.866333 
	C431.708252,648.041809 431.439941,648.201355 431.072693,648.188416 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M427.092072,649.216187 
	C427.140350,648.997742 427.295990,648.936340 427.702515,648.867859 
	C427.702057,649.031616 427.450775,649.202393 427.092072,649.216187 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M742.015137,445.304199 
	C741.713684,445.224487 741.364746,444.903748 740.991577,444.303467 
	C741.300781,444.370331 741.634155,444.716766 742.015137,445.304199 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M775.326416,223.835510 
	C771.802185,224.266068 768.590149,224.749283 765.376770,224.758545 
	C763.589966,224.763702 761.800781,223.978745 759.774658,223.207581 
	C765.053833,215.182022 771.143433,214.087784 777.536255,219.897873 
	C777.082275,221.307846 776.360168,222.499008 775.326416,223.835510 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M496.066345,532.292114 
	C489.097961,538.170776 483.299286,537.464172 479.218231,530.233765 
	C484.832306,530.555359 490.347809,531.230896 496.066345,532.292114 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M472.660156,474.994629 
	C472.249115,477.802826 471.735718,478.081757 470.019470,476.266632 
	C470.279907,475.840912 470.536377,475.654968 470.850464,475.178711 
	C471.417267,474.976044 471.869293,474.984924 472.660156,474.994629 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M671.181091,575.025818 
	C669.740601,577.848145 667.908630,580.672791 665.921753,583.759827 
	C662.931335,586.789429 660.095764,589.556519 656.877197,592.728577 
	C656.210938,593.326904 656.003296,593.581848 655.871277,593.898438 
	C655.871277,593.898438 655.433655,593.931824 655.216797,593.965881 
	C653.913025,594.205811 652.825989,594.411682 650.901489,594.776123 
	C651.087341,590.822876 651.257874,587.194885 651.726257,583.280212 
	C658.279297,580.338379 664.534485,577.683228 671.181091,575.025818 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M794.588867,223.856445 
	C791.320923,222.587387 787.926147,221.549393 784.879578,219.877045 
	C784.170837,219.488022 784.647095,216.940170 784.821899,215.162659 
	C789.609680,214.144562 791.906555,216.952942 793.994873,221.030319 
	C794.316406,222.397415 794.452637,223.126938 794.588867,223.856445 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M794.821045,223.908737 
	C794.452637,223.126938 794.316406,222.397415 794.230469,221.298172 
	C795.291443,220.311890 796.302185,219.695328 797.614868,219.025467 
	C799.537842,221.354904 802.764709,224.037384 796.399963,224.992706 
	C795.690125,224.642151 795.371643,224.301590 794.821045,223.908737 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M595.006226,586.603516 
	C594.229614,586.992554 593.450195,586.976013 592.281372,586.911987 
	C592.717285,585.654175 593.542542,584.443787 594.660645,583.091309 
	C594.970154,584.032043 594.986755,585.114990 595.006226,586.603516 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M520.039429,544.391357 
	C513.563232,545.047729 506.974854,545.576416 501.182526,541.091614 
	C508.306946,537.806763 516.175049,539.196777 520.039429,544.391357 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M593.372559,564.052246 
	C593.439209,561.988770 593.798645,559.924805 594.158081,557.860901 
	C594.509338,557.859558 594.860657,557.858276 595.211914,557.856995 
	C595.211914,559.720825 595.211914,561.584656 595.021729,563.776794 
	C594.442749,564.087341 594.054016,564.069580 593.372559,564.052246 
z"
      />
      <path
        fill="#33716A"
        opacity="1.000000"
        stroke="none"
        d="
M585.190186,577.724609 
	C585.361816,576.893860 585.845764,575.989746 586.664917,575.042358 
	C586.500854,575.883179 586.001709,576.767273 585.190186,577.724609 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M463.955688,491.341919 
	C464.239288,489.813965 464.547821,488.705872 464.562927,488.651642 
	C466.977020,492.454620 469.463257,496.371185 471.970337,500.639648 
	C471.253876,500.978851 470.516602,500.966095 469.412415,500.925720 
	C468.439148,499.971497 468.024933,498.512817 467.192566,498.212280 
	C463.913727,497.028442 463.803894,494.523346 463.955688,491.341919 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M603.329468,356.617737 
	C599.565674,356.145020 601.181274,353.588898 601.813721,351.180817 
	C602.112183,350.929901 602.558289,351.023224 602.785889,351.010437 
	C603.140930,352.727753 603.268433,354.457916 603.329468,356.617737 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M601.880249,346.637299 
	C601.692078,346.418182 601.551941,345.884583 601.607178,345.206604 
	C601.844421,345.482391 601.886414,345.902618 601.880249,346.637299 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M602.244995,343.925568 
	C602.019043,343.792175 602.030884,343.556702 602.072510,342.968018 
	C602.229126,343.017700 602.355957,343.420593 602.244995,343.925568 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M602.025269,341.750610 
	C601.862000,341.738678 601.730774,341.480011 601.752991,341.125458 
	C601.906433,341.029602 602.057373,341.503845 602.025269,341.750610 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M729.086731,507.234924 
	C732.100037,499.617767 735.113281,492.000580 738.349548,484.118042 
	C738.609192,485.523621 739.041565,487.308716 738.599609,488.841705 
	C737.695129,491.978821 736.041443,494.911896 735.266174,498.068939 
	C734.914612,499.500397 735.922119,501.265594 736.719543,503.350037 
	C736.852051,505.869232 736.578064,507.917786 736.135864,510.373291 
	C735.965454,512.534729 735.963379,514.289307 735.908630,516.438904 
	C737.228760,519.725830 738.307129,522.831482 740.155762,525.377991 
	C740.703552,526.132629 744.750244,525.705933 744.915466,525.147095 
	C745.677673,522.568848 745.635681,519.752808 745.840942,516.712646 
	C745.338684,515.304382 744.877502,514.205383 744.368225,512.720337 
	C742.542175,508.625854 740.764160,504.917419 738.986206,501.208984 
	C740.114441,497.309967 741.242676,493.410980 742.727661,489.736572 
	C742.979309,496.308838 741.603638,502.928040 746.987305,508.454468 
	C748.713501,510.130035 750.414734,511.459320 752.116089,512.788574 
	C753.061707,511.162628 754.007324,509.536652 754.970215,507.503174 
	C753.589478,502.800049 752.191589,498.504425 751.156982,494.151794 
	C754.673462,495.051666 757.826721,496.008606 761.137878,497.213013 
	C761.839600,497.638611 762.383545,497.816681 762.894775,498.346222 
	C761.206055,502.067688 759.549927,505.437714 757.613037,509.012878 
	C748.856628,521.825745 740.380981,534.433411 731.646362,547.237488 
	C729.588440,549.550171 727.789490,551.666443 725.990540,553.782715 
	C724.461060,554.747314 722.931641,555.711914 721.066711,556.299438 
	C720.491455,555.613586 720.251648,555.304871 720.011841,554.996155 
	C720.293884,554.191956 720.575928,553.387695 720.791504,552.267822 
	C720.776733,551.524170 720.828430,551.096191 720.916565,550.079041 
	C720.900085,549.315613 720.847229,549.141357 720.794312,548.967163 
	C720.478271,544.833069 720.296631,540.680725 719.741028,536.579041 
	C719.619019,535.678101 718.167175,534.957275 717.121155,534.492310 
	C716.511292,534.876709 716.107910,534.922302 715.402832,534.932495 
	C715.101013,534.897156 715.264648,534.470703 715.322021,534.249756 
	C716.276245,532.706299 717.173157,531.383728 718.412598,529.584839 
	C719.173279,528.078674 719.591431,527.048950 720.282532,525.791565 
	C721.153137,523.735535 721.750732,521.907104 722.348389,520.078674 
	C722.921387,519.264221 723.494446,518.449829 724.384399,517.134888 
	C726.163086,513.501160 727.624878,510.368042 729.086731,507.234924 
M733.690002,524.943359 
	C732.893250,522.217712 732.096497,519.492004 730.895081,515.382263 
	C726.736267,522.307251 723.443726,527.847290 724.245178,534.662354 
	C724.541016,537.178711 724.178040,540.556030 728.390808,540.887695 
	C732.755676,541.231384 733.976807,538.262512 734.330444,535.092346 
	C734.671204,532.037781 734.042358,528.875183 733.690002,524.943359 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M729.039917,506.891296 
	C727.624878,510.368042 726.163086,513.501160 724.436401,516.835815 
	C723.629272,516.006775 722.597595,514.949097 722.652954,513.951782 
	C722.749573,512.212830 723.515869,510.511230 724.001953,508.397614 
	C725.135132,507.129700 726.267761,506.258179 727.914551,504.991028 
	C727.888428,504.953247 728.440796,505.750458 729.039917,506.891296 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M721.939331,520.049438 
	C721.750732,521.907104 721.153137,523.735535 720.039551,525.607056 
	C719.026306,524.444641 718.528992,523.239136 718.031738,522.033630 
	C718.031738,522.033630 718.003052,522.003235 717.988403,521.987549 
	C719.159302,521.321350 720.344849,520.670776 721.939331,520.049438 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M320.117035,183.630066 
	C319.283234,183.443695 318.424408,182.905228 317.292450,182.195587 
	C317.019287,182.024414 317.018585,181.527954 317.009460,181.280151 
	C317.437714,180.714844 317.875092,180.397324 318.595032,180.078430 
	C319.282410,181.144028 319.687225,182.210999 320.117035,183.630066 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M500.511841,451.030029 
	C499.853394,453.069611 498.909973,455.032257 497.645660,457.063843 
	C495.452576,456.447388 493.580353,455.762054 491.343994,455.044678 
	C490.855835,454.736511 490.731842,454.460388 491.147034,454.091370 
	C492.795807,453.348328 493.905365,452.698181 495.014923,452.048065 
	C495.002655,451.607147 494.990387,451.166199 494.932678,450.397949 
	C496.667175,450.364807 498.447021,450.658997 500.511841,451.030029 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M481.980988,608.576233 
	C481.059540,608.160461 480.039001,607.438538 479.004700,606.369507 
	C479.954590,606.771606 480.918213,607.520874 481.980988,608.576233 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M484.000732,610.664429 
	C483.375336,610.514648 482.733704,610.043701 482.103333,609.236328 
	C482.737885,609.380981 483.361206,609.862061 484.000732,610.664429 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M458.747986,616.619019 
	C458.738464,617.632874 458.659698,618.234497 458.542053,619.130737 
	C456.368622,618.177917 454.234039,616.930603 452.069519,615.333557 
	C453.193237,612.459839 454.346832,609.935913 455.783081,607.191711 
	C456.065735,606.971497 456.478973,606.992554 456.676331,607.053589 
	C457.135559,608.370056 457.397461,609.625366 457.888550,611.088257 
	C458.304749,612.932861 458.491760,614.569885 458.747986,616.619019 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M494.694305,452.014587 
	C493.905365,452.698181 492.795807,453.348328 491.301819,453.994385 
	C490.917419,453.990265 490.875427,453.519135 490.817963,453.289734 
	C491.152130,452.587128 491.543762,452.113953 491.974487,451.321045 
	C492.800293,451.327881 493.586975,451.654480 494.694305,452.014587 
z"
      />
      <path
        fill="#336054"
        opacity="1.000000"
        stroke="none"
        d="
M593.449463,145.532990 
	C593.415649,145.476593 593.483276,145.589371 593.449463,145.532990 
z"
      />
      <path
        fill="#E9E2C8"
        opacity="1.000000"
        stroke="none"
        d="
M518.015747,91.761253 
	C517.812988,88.487968 517.645813,85.679672 517.482544,82.935265 
	C522.735413,80.856270 526.105530,81.764130 528.198059,85.698479 
	C530.292908,89.637253 529.635864,95.722519 526.413818,97.480873 
	C524.549866,98.498085 521.456848,99.235031 519.947937,98.346779 
	C518.586548,97.545341 518.628418,94.360168 518.015747,91.761253 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M647.666321,118.860611 
	C650.046082,116.629135 652.146973,114.646912 654.893005,112.055962 
	C654.893005,116.941315 654.893005,120.888206 654.893005,124.851952 
	C647.902588,124.557449 645.325867,122.477081 647.666321,118.860611 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M338.154327,193.677185 
	C338.018005,193.975845 337.521301,194.014389 337.272705,194.027985 
	C336.788300,191.721344 336.552460,189.401077 336.618713,187.017303 
	C338.057495,187.617493 339.194122,188.281189 340.665405,188.972443 
	C341.000000,189.000000 340.996948,188.996841 340.996948,188.996841 
	C340.094849,190.457397 339.192749,191.917969 338.154327,193.677185 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M330.019440,171.321106 
	C330.626221,171.458328 331.271606,171.922699 331.952606,172.715607 
	C331.344818,172.578873 330.701447,172.113556 330.019440,171.321106 
z"
      />
      <path
        fill="#8D8B84"
        opacity="1.000000"
        stroke="none"
        d="
M323.304199,184.040558 
	C323.008118,183.805252 322.984863,183.585953 322.990295,183.035034 
	C323.551208,182.775925 324.083344,182.848434 324.615509,182.920944 
	C324.269318,183.299484 323.923157,183.678024 323.304199,184.040558 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M336.807617,194.104797 
	C336.944305,194.342300 336.758423,194.605103 336.248016,194.889038 
	C336.113220,194.650772 336.300385,194.390762 336.807617,194.104797 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M333.541504,185.576569 
	C333.465851,185.628326 333.441345,185.422974 333.441345,185.422974 
	C333.441345,185.422974 333.617157,185.524811 333.541504,185.576569 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M327.985291,169.243027 
	C328.065308,169.045380 328.258728,169.036163 328.742554,169.037766 
	C328.721558,169.176208 328.410126,169.303818 327.985291,169.243027 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M749.954529,178.774841 
	C749.330505,178.636368 748.673279,178.159424 747.992554,177.351974 
	C748.619751,177.493103 749.270569,177.964722 749.954529,178.774841 
z"
      />
      <path
        fill="#CAC2B5"
        opacity="1.000000"
        stroke="none"
        d="
M753.365784,179.673950 
	C753.510559,179.867447 753.488464,180.179291 753.466370,180.491135 
	C753.377197,180.258194 753.288025,180.025253 753.365784,179.673950 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M751.554932,175.461975 
	C751.590698,175.520264 751.519104,175.403671 751.554932,175.461975 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M341.001465,189.001587 
	C341.476593,188.598816 341.931183,188.165695 342.446594,187.824402 
	C342.515594,187.778717 342.891937,188.197205 343.125977,188.400757 
	C342.610016,188.601822 342.094055,188.802887 341.287537,189.000397 
	C340.996948,188.996841 341.000000,189.000000 341.001465,189.001587 
z"
      />
      <path
        fill="#F7EBD5"
        opacity="1.000000"
        stroke="none"
        d="
M346.450867,185.534821 
	C346.416687,185.477570 346.485016,185.592087 346.450867,185.534821 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M341.854492,204.013351 
	C341.685852,204.544846 341.464417,204.810852 341.242981,205.076874 
	C341.060699,204.530685 340.878387,203.984512 340.696075,203.438324 
	C341.064636,203.541519 341.433167,203.644699 341.854492,204.013351 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M342.994110,195.754913 
	C342.880585,195.582092 342.936981,195.409195 342.993408,195.236298 
	C343.050262,195.409134 343.107147,195.581985 342.994110,195.754913 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M343.002686,181.003571 
	C342.513947,181.589981 342.022278,182.172562 341.265320,182.877579 
	C341.000000,183.000000 341.001221,183.001221 341.001221,183.001221 
	C341.449097,182.353485 341.896973,181.705750 342.668274,181.024948 
	C342.991699,180.991898 342.999756,180.999725 343.002686,181.003571 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M340.999390,182.999390 
	C340.644165,183.252213 340.289520,183.505646 339.934906,183.759064 
	C339.846771,183.631653 339.758606,183.504242 339.670441,183.376831 
	C339.950409,183.254593 340.230408,183.132339 340.755798,183.005646 
	C341.001221,183.001221 341.000000,183.000000 340.999390,182.999390 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M731.905396,547.041138 
	C740.380981,534.433411 748.856628,521.825745 757.656494,509.327454 
	C758.654541,509.616699 759.328369,509.796570 760.339722,510.014587 
	C761.129272,510.044678 761.581299,510.036591 762.029968,510.441223 
	C763.180664,514.864746 766.459412,513.079346 768.326416,512.488953 
	C774.034241,510.683899 779.523560,508.187469 785.411377,505.945801 
	C786.143127,505.893677 786.561340,505.855713 786.979553,505.817749 
	C784.227539,508.168915 781.475464,510.520111 778.019165,512.975220 
	C772.215271,516.133240 766.632385,516.111816 761.216492,514.777161 
	C757.877136,513.954285 756.674561,515.123718 755.825073,517.819031 
	C754.750488,519.535889 753.575867,521.202820 752.675293,523.006531 
	C752.464355,523.428955 753.181030,524.314514 753.732666,525.440186 
	C754.378906,526.935852 754.955994,528.918823 755.120178,528.885254 
	C761.853516,527.506592 768.549683,525.946533 775.526855,524.379883 
	C776.914062,524.314758 778.025024,524.279236 779.135986,524.243652 
	C779.190308,524.582581 779.130371,524.899902 778.539612,525.538818 
	C777.824768,526.023682 777.513367,526.142944 777.230103,526.310059 
	C768.369995,531.537598 759.311584,535.564026 748.744873,531.386719 
	C748.355164,531.232666 747.523621,532.196411 746.898010,532.639282 
	C745.890564,533.515991 744.883118,534.392761 743.516907,535.790649 
	C742.019043,537.863220 740.778320,539.356384 739.827942,541.015869 
	C739.641357,541.341675 740.577148,542.310425 741.050110,543.370117 
	C741.890625,544.229492 742.663452,545.085022 743.464111,545.111877 
	C749.370544,545.309875 755.282654,545.342468 761.056580,545.761353 
	C754.523438,547.069580 748.152222,548.347839 741.719055,548.890076 
	C738.464661,549.164490 735.734375,544.945190 731.905396,547.041138 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M731.646362,547.237549 
	C735.734375,544.945190 738.464661,549.164490 741.719055,548.890076 
	C748.152222,548.347839 754.523438,547.069580 761.396118,545.675476 
	C763.327637,544.603760 764.783325,543.952209 766.581299,543.266724 
	C767.593628,543.081665 768.263611,542.930542 768.933655,542.779358 
	C766.318176,548.130798 761.163330,548.934021 756.118286,550.018311 
	C753.748474,550.527588 751.436035,551.303955 749.097595,551.959290 
	C749.197815,552.443726 749.298096,552.928223 749.398315,553.412720 
	C751.841431,553.881836 754.284607,554.351013 756.405823,555.246094 
	C750.384399,555.802429 744.684814,555.932861 738.603760,555.992310 
	C735.803162,556.599121 733.384094,557.276855 730.589783,557.933594 
	C728.823975,558.454163 727.433472,558.995728 726.011108,559.092285 
	C725.937256,558.052917 725.895264,557.458618 725.853271,556.864258 
	C726.063110,555.960388 726.272949,555.056519 726.236694,553.967651 
	C727.789490,551.666443 729.588440,549.550171 731.646362,547.237549 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M710.838745,571.813660 
	C713.978149,568.889587 717.117554,565.965454 720.918823,562.904236 
	C732.757690,568.997864 743.425354,565.909546 754.000061,561.046875 
	C754.006836,561.097961 754.043030,561.194275 754.043030,561.194275 
	C753.716736,567.247864 747.737122,564.405334 744.924255,566.820984 
	C743.229797,568.276245 740.070801,568.026062 736.850159,568.690857 
	C740.681519,569.957581 743.739868,570.968750 746.485046,572.393433 
	C735.249939,570.355042 724.374817,570.651672 713.153076,573.235840 
	C712.123169,572.677551 711.480957,572.245605 710.838745,571.813660 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M762.033386,510.028503 
	C761.581299,510.036591 761.129272,510.044678 760.350220,509.650421 
	C761.208252,506.790070 762.257385,504.253265 763.622314,501.899658 
	C764.668701,500.095245 766.113647,498.522034 767.535339,497.200684 
	C777.473755,499.280518 784.768005,494.866302 791.391541,487.925934 
	C793.093506,486.828064 794.497070,485.866943 795.900574,484.905792 
	C795.891541,491.268524 790.593872,492.978394 786.458191,495.797272 
	C783.866577,497.563751 781.516296,499.684235 778.775146,502.191345 
	C776.615479,503.468445 774.738464,504.200073 772.505920,504.969452 
	C768.778076,506.680939 765.405701,508.354706 762.033386,510.028503 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M713.540771,573.362244 
	C724.374817,570.651672 735.249939,570.355042 746.569946,572.741943 
	C746.760132,573.591614 746.552185,574.506226 745.841064,575.579224 
	C745.337830,575.737549 745.002991,576.080994 744.687195,576.112793 
	C743.762573,576.322083 743.153748,576.499512 742.097168,576.495667 
	C732.770325,576.552307 723.892090,576.852783 715.011475,576.973267 
	C713.308044,576.996460 711.594910,576.311768 710.093506,575.709412 
	C711.380798,574.764221 712.460754,574.063232 713.540771,573.362244 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M800.972229,447.854279 
	C801.363220,454.387451 796.475220,458.614777 793.639404,464.402100 
	C791.174927,465.941498 789.041870,466.962036 786.573059,468.030579 
	C782.368958,471.305634 778.500549,474.532684 774.366394,477.752319 
	C773.718872,477.459045 773.337097,477.173157 773.040283,476.502472 
	C773.791443,471.793793 774.457764,467.469940 775.433350,463.094421 
	C776.159668,463.055695 776.576843,463.068695 777.259399,463.384094 
	C784.987915,464.869385 791.088623,462.884766 795.362000,455.878387 
	C796.250244,454.293091 796.907227,452.943237 797.807617,451.403839 
	C798.409119,450.504669 798.767273,449.795074 799.081299,449.056580 
	C799.037109,449.027649 799.078430,449.124847 799.334351,449.040985 
	C799.738770,448.641388 799.887146,448.325653 800.269531,447.969666 
	C800.503479,447.929413 800.972229,447.854279 800.972229,447.854279 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M695.127869,586.067871 
	C698.193787,583.124390 701.259705,580.180908 704.867126,577.363647 
	C706.962219,577.972412 708.515869,578.454895 710.283325,578.987915 
	C710.497192,579.038391 710.904907,579.202332 711.009277,579.551880 
	C718.133118,583.465088 725.493103,583.528015 733.004883,582.030701 
	C732.672119,583.980713 732.339355,585.930664 731.444214,588.193054 
	C729.299683,588.098206 727.726624,587.650940 726.133850,587.290466 
	C717.836304,585.412781 709.529663,583.640808 700.592651,586.054810 
	C698.474854,586.070435 696.782837,586.075195 695.093628,586.068604 
	C695.096558,586.057190 695.127869,586.067871 695.127869,586.067871 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M797.929504,467.828857 
	C798.465698,473.784637 793.181030,475.612701 790.037781,478.959869 
	C788.761414,480.319153 787.491821,481.684723 786.095337,483.687439 
	C784.352905,485.038696 782.734192,485.749908 780.904419,486.469177 
	C780.455383,486.791260 780.217529,487.105316 779.619873,487.430908 
	C779.049866,487.558075 778.839539,487.673676 778.280273,487.786133 
	C774.618042,489.530182 771.304871,491.277435 767.995789,492.634460 
	C769.347900,487.923492 770.695923,483.602722 772.384766,479.412079 
	C774.185303,480.035156 775.681885,481.038696 777.098633,480.936371 
	C785.052307,480.361877 791.268250,476.679077 795.745361,469.654480 
	C796.227844,468.951050 796.510193,468.463135 797.075562,467.929565 
	C797.548950,467.865570 797.739258,467.847198 797.929504,467.828857 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M775.041931,436.993896 
	C777.457153,437.332184 779.918152,438.144928 782.278687,437.916992 
	C788.575684,437.308990 793.274475,438.806885 794.756653,446.211792 
	C793.710876,447.416473 792.749329,448.063385 791.439575,448.750000 
	C786.612915,452.471252 782.134460,456.152740 777.418701,459.773651 
	C777.181458,459.713074 776.694519,459.766388 776.648560,459.763580 
	C776.602661,459.760773 776.510681,459.756592 776.444336,459.368652 
	C776.562134,455.300934 776.746216,451.621155 777.351379,447.954834 
	C781.167908,447.318542 784.628662,446.888153 787.924683,445.905060 
	C789.145752,445.540802 789.979736,443.878540 790.990234,442.808228 
	C789.713989,441.862976 788.514038,440.258575 787.146729,440.100311 
	C783.543213,439.683167 779.867004,439.894073 776.030823,439.593140 
	C775.575195,438.552246 775.308594,437.773071 775.041931,436.993896 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M776.930176,447.941345 
	C776.746216,451.621155 776.562134,455.300934 776.309692,459.664917 
	C776.493286,460.862274 776.745117,461.375488 776.991028,462.186920 
	C776.988098,462.683960 776.991028,462.882812 776.994019,463.081665 
	C776.576843,463.068695 776.159668,463.055695 775.106934,463.047363 
	C774.032349,463.040497 773.593262,463.028961 773.086548,462.777832 
	C773.018860,462.538208 772.941406,462.046295 773.007141,461.607361 
	C772.239807,457.411591 771.406677,453.654724 770.494995,449.478729 
	C769.907288,446.033081 769.398071,443.006622 768.888855,439.980133 
	C768.872742,438.873718 768.856689,437.767303 768.905396,436.246521 
	C770.356689,435.898163 771.743164,435.964233 773.545410,436.038025 
	C774.237000,436.212982 774.486450,436.413055 774.875732,436.819916 
	C775.308594,437.773071 775.575195,438.552246 775.964233,440.007629 
	C776.367798,443.102997 776.648987,445.522186 776.930176,447.941345 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M700.937866,624.495850 
	C703.181213,622.425293 705.398865,620.326050 707.672363,618.289185 
	C716.585327,610.303894 725.515930,602.338135 734.721191,594.179443 
	C735.666748,593.260437 736.331055,592.527100 737.316223,591.319092 
	C738.755798,590.217834 739.874512,589.591248 740.993164,588.964722 
	C739.630676,591.157471 738.688599,593.824524 736.837158,595.465698 
	C725.238159,605.746948 713.436462,615.799438 701.336304,625.593140 
	C700.959839,625.004395 700.948914,624.750122 700.937866,624.495850 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M775.250549,524.409424 
	C768.549683,525.946533 761.853516,527.506592 755.120178,528.885254 
	C754.955994,528.918823 754.378906,526.935852 754.069092,525.533203 
	C758.849548,523.826904 763.555420,522.480835 768.733459,521.593262 
	C771.220642,522.837708 773.235596,523.623535 775.250549,524.409424 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M701.018311,586.043884 
	C709.529663,583.640808 717.836304,585.412781 726.133850,587.290466 
	C727.726624,587.650940 729.299683,588.098206 731.278320,588.591797 
	C731.722595,589.223572 731.770325,589.768982 731.759583,590.589050 
	C731.701111,590.863647 731.290222,590.869751 730.758179,590.988037 
	C728.507324,591.438416 726.788452,591.770508 724.868042,591.814087 
	C718.497559,586.989380 711.797913,584.877319 704.105957,586.760193 
	C703.190063,586.984375 702.052917,586.304626 701.018311,586.043884 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M747.124756,532.980164 
	C747.523621,532.196411 748.355164,531.232666 748.744873,531.386719 
	C759.311584,535.564026 768.369995,531.537598 777.230103,526.310059 
	C777.513367,526.142944 777.824768,526.023682 778.459534,525.771362 
	C774.779663,528.393860 771.063110,532.620544 766.675049,533.500916 
	C760.494690,534.740845 753.816711,533.500732 747.124756,532.980164 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M769.197998,542.560059 
	C768.263611,542.930542 767.593628,543.081665 766.505859,542.838318 
	C764.550049,541.586182 762.983337,539.953430 761.478882,540.008850 
	C755.821167,540.217407 750.183716,540.976074 744.780823,541.265686 
	C746.762634,540.041016 748.502258,539.079224 750.241821,538.117432 
	C757.993408,538.407837 765.744995,538.698303 773.496521,538.988708 
	C773.548523,539.606750 773.600586,540.224731 773.652588,540.842712 
	C772.255798,541.342041 770.859070,541.841370 769.197998,542.560059 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M781.115540,486.461121 
	C782.734192,485.749908 784.352905,485.038696 786.175415,484.069031 
	C789.821411,483.319305 793.263489,482.828064 797.153381,482.272919 
	C796.756042,483.098816 796.452271,483.730316 796.024536,484.633789 
	C794.497070,485.866943 793.093506,486.828064 790.966064,487.889160 
	C787.240906,487.235016 783.519531,490.782288 781.115540,486.461121 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M733.371033,582.006348 
	C725.493103,583.528015 718.133118,583.465088 711.424316,579.521973 
	C721.607971,581.456177 731.404236,581.220520 741.030884,578.579224 
	C739.275024,579.907898 737.606689,580.915833 735.938293,581.923706 
	C735.204590,581.943115 734.470886,581.962524 733.371033,582.006348 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M772.861389,504.931702 
	C774.738464,504.200073 776.615479,503.468445 778.785400,502.570099 
	C782.983643,501.860077 786.889160,501.316772 790.794617,500.773438 
	C790.955261,501.169495 791.115906,501.565552 791.276489,501.961609 
	C790.025452,503.140625 788.774414,504.319641 787.251465,505.658203 
	C786.561340,505.855713 786.143127,505.893677 785.117310,505.655914 
	C780.626953,505.230682 776.744202,505.081177 772.861389,504.931702 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M756.304077,517.858521 
	C756.674561,515.123718 757.877136,513.954285 761.216492,514.777161 
	C766.632385,516.111816 772.215271,516.133240 777.693726,513.087158 
	C774.566833,514.722778 771.199646,516.945312 767.514709,517.803894 
	C764.114807,518.596130 760.373840,517.924683 756.304077,517.858521 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M738.985291,556.063293 
	C744.684814,555.932861 750.384399,555.802429 756.544373,555.579346 
	C757.755432,556.075623 758.506104,556.664551 758.794067,557.659180 
	C756.873779,558.701355 755.416016,559.337952 753.603149,559.969727 
	C752.543701,560.060791 751.839355,560.156677 750.898071,559.923706 
	C746.769104,558.417603 742.877197,557.240479 738.985291,556.063293 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M798.060303,467.517761 
	C797.739258,467.847198 797.548950,467.865570 796.685303,467.915771 
	C794.335632,468.436859 792.669983,469.256104 790.979736,469.310486 
	C789.638367,469.353638 788.266907,468.460175 786.908813,467.982544 
	C789.041870,466.962036 791.174927,465.941498 793.589966,464.787598 
	C796.027588,464.404083 798.183105,464.153900 801.366943,463.784363 
	C799.829773,465.440887 799.010437,466.323792 798.060303,467.517761 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M736.170532,582.206787 
	C737.606689,580.915833 739.275024,579.907898 741.239868,578.406006 
	C741.872498,577.500305 742.208679,577.088623 742.544922,576.676941 
	C743.153748,576.499512 743.762573,576.322083 744.773926,576.318604 
	C745.389343,576.719238 745.650146,576.850769 745.958923,576.887268 
	C746.031006,580.217285 746.686218,583.941528 741.046143,582.140076 
	C739.675415,581.702332 737.959839,582.344360 736.170532,582.206787 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M749.825317,538.068237 
	C748.502258,539.079224 746.762634,540.041016 744.469055,541.333801 
	C742.941833,542.104126 741.968567,542.543396 740.995300,542.982605 
	C740.577148,542.310425 739.641357,541.341675 739.827942,541.015869 
	C740.778320,539.356384 742.019043,537.863220 743.410522,536.118530 
	C745.578308,536.623169 747.493530,537.321106 749.825317,538.068237 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M775.526855,524.379883 
	C773.235596,523.623535 771.220642,522.837708 769.140747,521.696533 
	C773.081604,521.170776 777.087402,521.000244 781.485413,521.165039 
	C781.629700,522.017456 781.381714,522.534424 781.133789,523.051392 
	C780.657288,523.381775 780.180725,523.712097 779.420044,524.143066 
	C778.025024,524.279236 776.914062,524.314758 775.526855,524.379883 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M791.787842,448.710266 
	C792.749329,448.063385 793.710876,447.416473 794.886108,446.568604 
	C797.128174,445.745148 799.156555,445.122620 801.768250,444.321075 
	C801.495911,445.582092 801.316833,446.410889 801.055054,447.546997 
	C800.972229,447.854279 800.503479,447.929413 800.015137,448.057800 
	C799.377380,448.499054 799.227905,448.811951 799.078430,449.124847 
	C799.078430,449.124847 799.037109,449.027649 798.681763,449.061157 
	C796.146851,448.966553 793.967346,448.838409 791.787842,448.710266 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M753.958313,559.974548 
	C755.416016,559.337952 756.873779,558.701355 758.679688,558.052124 
	C757.602295,559.025574 756.176636,560.011658 754.396973,561.096008 
	C754.043030,561.194275 754.006836,561.097961 754.010254,560.790955 
	C753.995239,560.314148 753.976807,560.144348 753.958313,559.974548 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M740.995605,588.983765 
	C739.874512,589.591248 738.755798,590.217834 737.351440,591.011597 
	C738.176025,589.794495 739.286194,588.410278 740.737183,587.359985 
	C741.039062,588.129517 740.999939,588.564941 740.960876,589.000427 
	C740.960876,589.000427 740.998108,589.002808 740.995605,588.983765 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M741.320312,588.983459 
	C740.999939,588.564941 741.039062,588.129517 741.129883,587.370239 
	C742.251099,586.327515 743.320618,585.608582 744.693604,584.747070 
	C743.891235,586.058533 742.785461,587.512512 741.320312,588.983459 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M781.477905,523.041504 
	C781.381714,522.534424 781.629700,522.017456 781.947083,521.216553 
	C782.619812,520.955566 783.223022,520.978577 783.826294,521.001526 
	C783.158203,521.678223 782.490173,522.354858 781.477905,523.041504 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M745.943359,576.597839 
	C745.650146,576.850769 745.389343,576.719238 745.089722,576.286743 
	C745.002991,576.080994 745.337830,575.737549 745.576721,575.738647 
	C745.852966,575.929260 745.890381,576.118835 745.943359,576.597839 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M778.650146,361.922485 
	C778.621582,362.835022 778.593018,363.747528 777.996216,364.913574 
	C776.933716,365.767975 776.439392,366.368866 775.792725,367.070984 
	C775.396240,367.309906 775.170166,367.284973 774.962219,367.097382 
	C773.243408,366.615601 771.524536,366.133850 769.189026,365.341431 
	C768.222168,365.684875 767.872009,366.338989 767.521851,366.993073 
	C767.539185,367.365540 767.556519,367.738037 767.275879,368.544464 
	C766.674988,370.001160 766.372192,371.023865 766.069336,372.046600 
	C766.069336,372.046600 766.011902,372.012695 765.635864,371.998505 
	C761.171875,371.659485 757.084045,371.334656 752.996155,371.009796 
	C751.573547,368.357025 750.150940,365.704254 749.159973,362.583405 
	C754.455505,363.715118 759.319519,365.314880 764.613342,367.056030 
	C764.754150,365.178162 764.859985,363.767731 764.965759,362.357269 
	C765.006470,362.114319 765.047241,361.871338 765.449341,361.293213 
	C770.090454,361.279541 774.370300,361.601013 778.650146,361.922485 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M788.010986,352.074249 
	C787.266113,352.075653 786.521240,352.077057 785.092896,351.886230 
	C776.357483,349.728912 769.947571,345.609070 766.675537,337.891296 
	C772.418457,339.431152 777.891907,340.645538 783.078674,342.614990 
	C786.142578,343.778320 788.752808,346.136566 791.567017,347.957520 
	C791.235596,349.118805 790.904236,350.280121 790.095337,351.338013 
	C789.082275,351.514496 788.546631,351.794373 788.010986,352.074249 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M791.567810,347.548096 
	C788.752808,346.136566 786.142578,343.778320 783.078674,342.614990 
	C777.891907,340.645538 772.418457,339.431152 766.454407,337.756683 
	C765.673584,337.589844 765.503906,337.565735 765.334167,337.541595 
	C765.126221,333.540192 768.562439,334.299286 770.618774,333.856812 
	C780.280334,331.778046 789.207336,337.555817 791.567810,347.548096 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M801.004883,329.001709 
	C801.288696,332.094666 801.572571,335.187683 801.927673,338.673676 
	C801.998901,339.066681 801.999634,339.006256 801.586548,338.951477 
	C797.738220,338.650146 794.302917,338.403595 790.867615,338.157043 
	C790.048828,335.493134 789.230042,332.829254 788.778015,330.006439 
	C792.548889,329.566040 795.953064,329.284546 799.758301,328.964691 
	C800.159424,328.926331 800.077698,328.979584 800.115967,329.132568 
	C800.437805,329.190918 800.721375,329.096313 801.004883,329.001709 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M768.076111,345.996674 
	C768.050537,346.733307 768.024963,347.469940 767.569153,348.601013 
	C760.421997,351.913147 755.496826,347.624725 750.210999,344.786621 
	C749.526062,343.705353 748.841187,342.624084 748.574585,341.116302 
	C750.733826,340.754272 752.566406,340.490845 754.197754,340.947021 
	C758.457458,342.138062 762.629211,343.644043 767.016113,345.112488 
	C767.489502,345.465881 767.782776,345.731262 768.076111,345.996674 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M766.835999,345.024475 
	C762.629211,343.644043 758.457458,342.138062 754.197754,340.947021 
	C752.566406,340.490845 750.733826,340.754272 748.656738,340.796112 
	C747.628235,335.296997 747.939758,334.671814 753.528992,335.442780 
	C756.796265,335.893524 759.883911,337.646637 763.433716,339.356598 
	C764.822021,341.607727 765.828979,343.316101 766.835999,345.024475 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M764.645386,362.180206 
	C764.859985,363.767731 764.754150,365.178162 764.613342,367.056030 
	C759.319519,365.314880 754.455505,363.715118 749.203735,362.217712 
	C748.446960,361.143921 748.078125,359.967743 747.545959,358.270752 
	C754.006348,357.699890 759.669128,357.437500 764.645386,362.180206 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M786.447632,359.658752 
	C788.031799,357.754822 789.615967,355.850861 791.378174,353.641846 
	C793.597656,353.768494 795.639038,354.200226 797.998901,354.802490 
	C799.118042,356.411560 799.918701,357.850098 800.325439,359.619080 
	C795.999023,360.188354 791.626526,358.933014 788.588623,362.985748 
	C787.680176,361.731781 787.063904,360.695251 786.447632,359.658752 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M774.657227,367.313538 
	C775.170166,367.284973 775.396240,367.309906 776.138428,367.038574 
	C777.096619,366.892365 777.556824,366.879761 778.016968,366.867126 
	C779.997375,369.300323 781.977783,371.733521 783.526245,374.520508 
	C778.773193,374.279633 774.233276,371.391113 770.381287,376.127014 
	C770.058350,375.386322 769.745544,374.668823 769.432739,373.951355 
	C771.072510,371.810822 772.712341,369.670258 774.657227,367.313538 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M769.208862,374.288513 
	C769.745544,374.668823 770.058350,375.386322 770.381287,376.127014 
	C774.233276,371.391113 778.773193,374.279633 783.480103,374.874939 
	C783.133240,376.517273 782.400513,378.158997 781.130371,379.671326 
	C776.735413,379.355042 772.877808,379.168152 769.020203,378.981232 
	C769.020203,378.981232 768.898804,378.502808 768.810547,378.003204 
	C768.643982,377.335480 768.565735,377.167389 768.487549,376.999268 
	C768.653381,376.208069 768.819214,375.416840 769.208862,374.288513 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M778.670532,361.574219 
	C774.370300,361.601013 770.090454,361.279541 765.521851,360.930847 
	C765.527466,359.275818 765.821838,357.648010 766.140747,355.651337 
	C773.364075,352.977631 775.907654,354.184570 778.670532,361.574219 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M767.016113,345.112488 
	C765.828979,343.316101 764.822021,341.607727 763.714050,339.546600 
	C764.040405,338.871033 764.467712,338.548248 765.114624,337.883545 
	C765.503906,337.565735 765.673584,337.589844 766.064453,337.748596 
	C769.947571,345.609070 776.357483,349.728912 784.720947,351.909180 
	C782.159058,356.229950 779.091797,352.937042 776.623230,351.861633 
	C773.713501,350.594025 771.357422,348.055481 768.418701,346.032349 
	C767.782776,345.731262 767.489502,345.465881 767.016113,345.112488 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M750.168335,345.158447 
	C755.496826,347.624725 760.421997,351.913147 767.538208,348.968445 
	C766.763306,350.099670 765.589050,351.257904 764.201904,352.664307 
	C763.989014,352.912445 763.493530,352.953857 762.995850,352.979156 
	C762.331970,353.024384 762.165833,353.044281 761.999634,353.064209 
	C756.060059,353.676025 751.720337,351.766388 750.168335,345.158447 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M757.295532,381.900482 
	C757.286865,381.549591 757.278137,381.198730 757.229065,380.587158 
	C760.457642,378.693054 763.680176,376.252075 767.566772,380.256042 
	C766.550781,381.819641 765.212158,382.875458 763.873535,383.931274 
	C762.946594,384.082092 762.019592,384.232880 760.621338,384.717743 
	C759.754883,385.027252 759.359741,385.002716 759.071106,384.660431 
	C758.550293,383.528656 757.922913,382.714569 757.295532,381.900482 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M749.235779,318.068909 
	C752.649719,317.417328 756.010437,316.608215 759.310486,316.806915 
	C762.317322,316.988007 765.258301,318.262421 768.638184,319.028107 
	C769.081177,319.759583 769.114380,320.517853 768.706787,321.654236 
	C765.628296,321.100830 763.050842,319.709473 760.337708,319.354187 
	C756.944702,318.909912 753.440063,319.317474 749.983643,319.357330 
	C749.983643,319.357330 749.698303,319.345551 749.572388,319.411987 
	C749.349731,319.102478 749.252930,318.726532 749.235779,318.068909 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M790.843689,338.515869 
	C794.302917,338.403595 797.738220,338.650146 801.615173,338.961395 
	C802.050720,339.468445 802.044617,339.910797 801.697021,340.725220 
	C800.891663,341.401062 800.427917,341.704834 799.964172,342.008606 
	C795.868896,344.019409 792.320557,344.434326 790.843689,338.515869 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M768.981262,379.229675 
	C772.877808,379.168152 776.735413,379.355042 780.795776,379.823456 
	C778.592041,384.172729 775.234253,384.234436 769.303650,380.146637 
	C768.969604,379.812225 768.955933,379.645172 768.981262,379.229675 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M753.037720,371.360840 
	C757.084045,371.334656 761.171875,371.659485 765.653992,372.026459 
	C765.086975,375.855164 762.637024,376.615417 759.357422,375.139984 
	C757.189453,374.164642 755.166931,372.865875 753.037720,371.360840 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M746.185974,352.764191 
	C747.746521,352.634186 749.234680,352.813080 750.722839,352.991974 
	C747.399109,355.966095 747.399109,355.966095 746.185974,352.764191 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M764.185425,384.068420 
	C765.212158,382.875458 766.550781,381.819641 767.894287,380.417206 
	C768.078491,380.033508 768.257812,379.996399 768.711548,379.970703 
	C769.017334,381.256592 769.048645,382.531036 769.147278,384.170898 
	C768.737366,384.671173 768.260193,384.805969 767.418213,385.003815 
	C766.201416,384.779724 765.349426,384.492615 764.185425,384.068420 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M766.435669,371.990997 
	C766.372192,371.023865 766.674988,370.001160 767.271973,368.824158 
	C767.311401,369.758392 767.056702,370.846893 766.435669,371.990997 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M800.055542,342.291382 
	C800.427917,341.704834 800.891663,341.401062 801.642273,341.052551 
	C801.966309,341.451813 802.003479,341.895813 802.012512,342.674194 
	C801.652771,343.023956 801.321777,343.048859 800.742493,343.070099 
	C800.377991,342.896027 800.262512,342.735107 800.055542,342.291382 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M788.170898,352.316345 
	C788.546631,351.794373 789.082275,351.514496 789.806763,351.406769 
	C790.003174,351.812164 790.010742,352.045441 790.001831,352.628113 
	C789.433838,352.837891 788.882324,352.698181 788.170898,352.316345 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M767.877563,366.842102 
	C767.872009,366.338989 768.222168,365.684875 768.765503,365.198181 
	C768.716919,365.807465 768.475098,366.249298 767.877563,366.842102 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M762.094238,353.223907 
	C762.165833,353.044281 762.331970,353.024384 762.749023,353.009583 
	C762.729614,353.137665 762.459229,353.260620 762.094238,353.223907 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M799.786438,351.112671 
	C800.040649,351.157898 800.126953,351.314148 800.204407,351.738098 
	C800.003235,351.745117 799.810852,351.484406 799.786438,351.112671 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M768.381592,377.128235 
	C768.565735,377.167389 768.643982,377.335480 768.703125,377.781006 
	C768.547913,377.791321 768.411804,377.524261 768.381592,377.128235 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M750.793701,494.208832 
	C752.191589,498.504425 753.589478,502.800049 754.528442,507.508667 
	C751.700500,507.983826 749.331421,508.045990 746.962341,508.108154 
	C741.603638,502.928040 742.979309,496.308838 743.012085,489.507629 
	C743.399170,488.433594 743.858643,487.813080 744.761780,487.555176 
	C747.104370,489.977875 749.003357,492.037994 750.863831,494.114685 
	C750.825317,494.131195 750.793701,494.208832 750.793701,494.208832 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M748.755005,476.930786 
	C749.511353,475.066681 750.267700,473.202576 751.427979,471.830750 
	C753.307861,474.478424 754.652710,476.739532 756.287292,478.767120 
	C759.670898,482.964386 762.299927,487.410919 761.723145,493.052399 
	C751.447815,490.576538 750.114990,488.866302 748.755005,476.930786 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M762.116699,493.038391 
	C762.299927,487.410919 759.670898,482.964386 756.287292,478.767120 
	C754.652710,476.739532 753.307861,474.478424 751.762146,472.012421 
	C752.298584,467.653076 752.904724,463.604340 753.936646,459.678497 
	C754.627930,461.512512 754.893433,463.223602 755.064880,465.322693 
	C755.164185,467.013641 755.357544,468.316559 755.414307,469.979858 
	C757.041321,473.233215 758.550781,476.326538 760.633545,478.967987 
	C763.172241,482.187775 766.172974,482.751556 769.057983,479.040283 
	C769.190186,479.134277 769.455383,479.321228 769.375000,479.692291 
	C767.395996,485.687317 765.497375,491.311279 763.444397,497.080078 
	C763.110962,497.459656 763.023743,497.724731 762.999634,498.027954 
	C762.970764,498.035858 762.927429,497.994751 762.927429,497.994751 
	C762.383545,497.816681 761.839600,497.638611 761.323486,496.959503 
	C761.606384,495.318481 761.861511,494.178436 762.116699,493.038391 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M772.941406,462.046295 
	C772.941406,462.046295 773.018860,462.538208 773.008057,463.087402 
	C772.962463,464.061371 772.927612,464.486176 772.677368,465.141846 
	C772.456604,465.978973 772.451172,466.585205 772.398926,467.602356 
	C771.386475,471.782562 770.420898,475.551910 769.455383,479.321228 
	C769.455383,479.321228 769.190186,479.134277 769.058472,478.633484 
	C768.847351,477.324799 768.767944,476.516907 768.685547,475.353394 
	C766.810242,471.621460 764.937866,468.245209 762.922607,464.570404 
	C760.529053,461.514709 758.278320,458.757568 756.027588,456.000366 
	C756.020813,452.824860 755.973328,449.648743 756.022217,446.474121 
	C756.052368,444.520996 756.229797,442.570160 756.682373,440.672546 
	C757.122009,441.471008 757.220276,442.215240 757.246826,443.330139 
	C757.220642,444.454437 757.266235,445.208038 757.252930,446.344360 
	C758.154663,449.789276 759.115234,452.851471 760.057861,456.274078 
	C763.707825,464.871277 766.243103,465.934784 772.941406,462.046295 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M761.723145,493.052399 
	C761.861511,494.178436 761.606384,495.318481 761.165649,496.712036 
	C757.826721,496.008606 754.673462,495.051666 751.156921,494.151794 
	C750.793701,494.208832 750.825317,494.131195 750.916626,493.725922 
	C750.007568,489.883850 749.007202,486.447052 748.006836,483.010223 
	C748.048035,481.053101 748.089172,479.095978 748.442627,477.034821 
	C750.114990,488.866302 751.447815,490.576538 761.723145,493.052399 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M742.447998,451.409729 
	C742.486328,449.643188 742.658569,448.170013 742.949463,446.344482 
	C742.874390,454.997314 742.887207,464.014313 742.371277,473.000916 
	C742.198486,476.009094 740.675964,478.939758 739.384644,481.962830 
	C739.956238,474.923126 740.913696,467.826385 741.755493,460.303131 
	C741.953857,457.152069 742.267822,454.427551 742.447998,451.409729 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M757.318542,442.959473 
	C757.220276,442.215240 757.122009,441.471008 756.941162,440.359985 
	C757.998230,439.784363 759.620605,438.998108 760.188477,439.472931 
	C762.023132,441.007080 763.470032,443.004944 765.419312,445.358521 
	C766.517944,447.251343 767.263489,448.609680 767.812988,450.204346 
	C764.773987,448.943695 761.931091,447.446747 759.062378,445.950256 
	C759.036682,445.950714 759.059570,445.904633 759.058228,445.575592 
	C758.477478,444.484192 757.898010,443.721832 757.318542,442.959473 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M736.304077,509.966339 
	C736.578064,507.917786 736.852051,505.869232 737.101562,503.429321 
	C737.545410,502.492065 738.013611,501.946136 738.734009,501.304565 
	C740.764160,504.917419 742.542175,508.625854 743.952026,512.687134 
	C741.157288,512.015503 738.730652,510.990906 736.304077,509.966339 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M755.714966,456.087219 
	C758.278320,458.757568 760.529053,461.514709 762.706177,464.855957 
	C760.141357,465.271576 757.650146,465.103149 755.158936,464.934692 
	C754.893433,463.223602 754.627930,461.512512 754.269165,459.437317 
	C754.584778,458.106873 754.993591,457.140472 755.714966,456.087219 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M747.732422,483.209229 
	C749.007202,486.447052 750.007568,489.883850 750.955139,493.709412 
	C749.003357,492.037994 747.104370,489.977875 745.078430,487.623749 
	C745.786987,486.022583 746.622559,484.715393 747.732422,483.209229 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M768.009094,449.968048 
	C767.263489,448.609680 766.517944,447.251343 765.671143,445.571167 
	C766.515686,443.684296 767.461426,442.119263 768.648010,440.267181 
	C769.398071,443.006622 769.907288,446.033081 770.019043,449.549408 
	C769.306824,450.086487 768.992004,450.133728 768.516296,450.108704 
	C768.355469,450.036407 768.009094,449.968048 768.009094,449.968048 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M685.055176,632.078979 
	C685.502563,631.979370 685.949951,631.879761 686.932373,631.719727 
	C687.767639,631.544861 687.952698,631.330750 688.022583,631.017090 
	C688.758972,630.862366 689.495361,630.707642 690.615845,630.870239 
	C691.056030,631.491333 691.112183,631.795105 691.168274,632.098816 
	C688.017944,633.739319 684.867554,635.379822 681.348633,636.956787 
	C680.722900,636.074646 680.465759,635.255981 680.376099,633.940796 
	C682.047424,632.989258 683.551331,632.534119 685.055176,632.078979 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M691.505920,632.046143 
	C691.112183,631.795105 691.056030,631.491333 690.963379,630.722656 
	C694.020020,628.414551 697.113220,626.571228 700.572144,624.611938 
	C700.948914,624.750122 700.959839,625.004395 700.991821,625.639893 
	C697.956421,628.011963 694.900024,630.002686 691.505920,632.046143 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M769.309448,415.009216 
	C769.022034,413.883820 769.133362,412.763763 769.319092,410.895721 
	C774.237854,415.828613 779.638306,415.542297 785.638062,414.312744 
	C784.780334,416.491943 783.513611,418.289337 782.246887,420.086731 
	C778.067383,418.395996 773.887817,416.705261 769.309448,415.009216 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M782.175415,420.403931 
	C783.513611,418.289337 784.780334,416.491943 786.060059,414.345703 
	C786.812439,413.376282 787.551758,412.755676 788.589478,412.105194 
	C789.390869,412.412476 789.893982,412.749634 790.738892,413.383667 
	C791.105774,413.851593 791.130798,414.022614 791.155762,414.193665 
	C788.330017,416.793762 785.504211,419.393860 782.312500,422.003296 
	C781.998962,421.582153 782.051453,421.151611 782.175415,420.403931 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M766.131531,417.167480 
	C766.679504,416.516144 767.438477,416.145599 768.516052,415.697662 
	C768.003906,416.229553 767.173218,416.838898 766.131531,417.167480 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M759.110962,417.196747 
	C759.423279,416.952209 759.881775,416.940308 760.680542,416.981201 
	C760.432983,417.165802 759.845093,417.297577 759.110962,417.196747 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M765.261353,406.643372 
	C765.432373,407.353210 765.366516,407.784119 764.995667,408.689026 
	C763.017334,409.062500 761.298096,409.172028 759.679871,408.818665 
	C756.078125,408.032135 752.526794,407.014130 748.954956,406.090454 
	C748.260620,404.700806 747.566223,403.311157 746.578430,401.334320 
	C754.123535,400.077545 759.887756,402.046204 765.261353,406.643372 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M748.888672,406.426758 
	C752.526794,407.014130 756.078125,408.032135 759.679871,408.818665 
	C761.298096,409.172028 763.017334,409.062500 765.061768,409.013000 
	C765.774475,410.061615 766.116089,411.260254 766.457764,412.458862 
	C764.415955,412.840240 762.225342,413.878296 760.365356,413.456940 
	C757.173645,412.733856 754.188416,411.099335 750.768555,409.789490 
	C749.887878,408.742004 749.355103,407.752533 748.888672,406.426758 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M745.201172,388.520752 
	C746.172546,387.802002 747.213989,387.424225 748.485352,387.412750 
	C749.377747,388.197906 750.034424,388.967163 750.703674,388.978241 
	C754.790710,389.046021 758.880615,388.941650 763.126953,389.172516 
	C763.879150,389.626923 764.473999,389.803528 765.068787,389.980133 
	C765.370056,390.459412 765.671326,390.938690 766.012939,391.716858 
	C758.552368,394.744019 751.912109,391.800629 745.201172,388.520752 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M762.969604,388.894684 
	C758.880615,388.941650 754.790710,389.046021 750.703674,388.978241 
	C750.034424,388.967163 749.377747,388.197906 748.825867,387.474609 
	C750.406555,386.486267 751.876648,385.802399 753.668823,384.962769 
	C754.159790,384.850464 754.328735,384.893890 755.143921,384.947571 
	C756.848328,384.964630 757.906433,384.971375 758.964539,384.978149 
	C759.359741,385.002716 759.754883,385.027252 760.447021,385.035583 
	C760.855164,385.367065 760.966492,385.714691 761.105835,386.536743 
	C761.415588,387.070068 761.697327,387.129028 761.979065,387.187958 
	C762.323669,387.193665 762.598999,387.334686 762.879578,388.041870 
	C762.954102,388.472656 762.969604,388.894684 762.969604,388.894684 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M763.126953,389.172516 
	C762.969604,388.894684 762.954102,388.472656 762.971863,388.262329 
	C763.642334,388.489655 764.295105,388.927368 765.008301,389.672607 
	C764.473999,389.803528 763.879150,389.626923 763.126953,389.172516 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M761.835754,386.962158 
	C761.697327,387.129028 761.415588,387.070068 761.154419,386.806091 
	C761.347534,386.646179 761.520020,386.691284 761.835754,386.962158 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M759.071106,384.660431 
	C757.906433,384.971375 756.848328,384.964630 755.399597,384.891968 
	C755.533508,383.889313 756.057983,382.952576 756.939026,381.958160 
	C757.922913,382.714569 758.550293,383.528656 759.071106,384.660431 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M791.539185,414.188904 
	C791.130798,414.022614 791.105774,413.851593 791.054993,413.423950 
	C791.727844,412.951721 792.426514,412.736053 793.727295,412.586548 
	C794.887146,412.462738 795.444824,412.272797 796.002563,412.082855 
	C796.748840,412.121704 797.495178,412.160553 798.799133,412.400208 
	C799.903198,412.725403 800.449524,412.849854 800.995911,412.974304 
	C798.391907,416.530426 795.092651,414.872589 791.539185,414.188904 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M801.309875,412.880890 
	C800.449524,412.849854 799.903198,412.725403 799.172791,412.390106 
	C800.151062,411.475250 801.313354,410.771240 802.831726,410.136658 
	C802.666443,411.066559 802.145142,411.927032 801.309875,412.880890 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M803.540649,410.151306 
	C803.862061,409.127014 804.517517,408.069824 805.515137,406.968018 
	C805.196472,407.988434 804.535522,409.053406 803.540649,410.151306 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M409.399933,603.344543 
	C406.063263,603.619202 402.283417,603.032593 400.996094,607.909302 
	C402.210602,608.546936 403.434845,609.189636 405.793549,610.427979 
	C403.711273,612.727478 402.106201,616.173035 399.928162,616.584351 
	C393.960419,617.711243 387.754089,617.643921 381.635590,617.818359 
	C380.832520,617.841248 379.307312,616.507629 379.314148,615.814148 
	C379.327118,614.500366 379.914856,612.917542 380.813721,611.965881 
	C381.682770,611.045715 383.244049,610.779541 385.691528,609.702087 
	C378.539825,608.619812 372.682495,607.733337 366.825134,606.846924 
	C366.617462,607.263000 366.409790,607.679138 366.202118,608.095215 
	C369.332611,611.002686 372.496002,613.876160 375.566986,616.845215 
	C376.214233,617.470947 376.522644,618.447266 376.679962,619.501343 
	C368.063721,612.723267 359.594635,605.883850 351.511047,598.615723 
	C347.280701,594.812073 343.727203,590.255615 339.868011,586.039185 
	C342.078888,586.064758 344.289764,586.090271 346.950836,586.525818 
	C350.219269,588.140320 353.037537,589.344788 356.002075,590.862244 
	C365.312439,595.201172 374.556244,593.908386 383.726624,591.339539 
	C385.029602,590.974487 385.929169,589.169434 387.042664,587.776733 
	C387.090393,587.353333 387.110962,587.184143 387.462952,587.028992 
	C388.455353,587.073547 389.116272,587.104187 389.984711,587.407227 
	C393.843811,590.378296 397.532227,593.030518 401.089508,595.848328 
	C401.440979,596.126770 400.989899,597.418335 400.591370,598.110596 
	C399.172241,597.680969 398.072998,597.380371 396.777039,596.833496 
	C395.986816,596.605774 395.393250,596.624207 394.518372,596.540161 
	C393.840729,596.394043 393.444458,596.350342 392.641846,596.133179 
	C390.487274,596.006592 388.738983,596.053528 386.656311,596.095642 
	C385.894745,596.196716 385.467590,596.302551 384.652100,596.354858 
	C377.599152,598.168274 370.934448,600.035278 364.269775,601.902283 
	C364.366455,602.498169 364.463165,603.093994 364.559845,603.689880 
	C366.282532,603.898438 368.005249,604.107056 369.710266,604.441711 
	C369.692627,604.567749 369.797302,604.799805 370.028717,605.069824 
	C376.270355,605.879578 382.327759,607.131531 388.276123,606.737488 
	C393.181061,606.412476 398.807495,606.192017 402.401123,600.972168 
	C406.716949,596.884705 407.345154,601.959717 409.399933,603.344543 
M389.547821,610.884888 
	C386.971832,611.863647 384.395844,612.842468 381.819824,613.821289 
	C390.304718,616.372986 397.350922,615.004761 401.794922,609.953003 
	C397.272034,610.231873 393.815735,610.445007 389.547821,610.884888 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M331.715179,522.162292 
	C330.542114,520.748535 329.369049,519.334839 328.195984,517.921082 
	C327.783661,518.126953 327.371307,518.332825 326.958984,518.538635 
	C327.584412,520.117310 328.209808,521.695984 328.956299,523.926636 
	C329.036896,524.835938 328.996460,525.093201 328.664795,525.201172 
	C327.586060,524.696655 326.798553,524.341370 325.868256,523.692627 
	C324.454498,522.696716 323.183563,521.994263 322.048370,520.960693 
	C322.508179,519.364136 322.832214,518.098694 323.156281,516.833252 
	C321.662170,516.843811 320.102142,516.601929 318.700958,516.968018 
	C317.967224,517.159790 317.512360,518.418701 316.506836,519.181702 
	C311.385071,518.742859 306.688049,518.317993 301.990997,517.893066 
	C302.988190,516.507751 303.985413,515.122498 305.378906,513.414856 
	C311.525909,515.324524 317.264557,514.909790 323.300354,513.138550 
	C323.848785,512.337097 324.557129,511.216370 324.263275,510.516541 
	C322.194061,505.589294 319.918640,500.748657 318.134888,495.901184 
	C321.835571,494.983337 325.110443,494.044678 328.270416,493.474426 
	C327.210999,497.815430 326.266510,501.788055 325.233612,506.124207 
	C325.436584,509.851837 327.278687,509.980896 329.920685,508.926971 
	C335.386658,506.746460 338.899567,498.546265 337.357544,491.655151 
	C337.520599,491.596924 337.765137,491.842041 337.765137,491.842041 
	C338.825562,494.003021 339.885986,496.164001 340.888245,499.046265 
	C338.318390,504.507812 335.806702,509.248047 333.213562,514.363953 
	C333.206757,517.119568 333.281372,519.499451 332.944458,521.942261 
	C332.260315,522.057495 331.987732,522.109863 331.715179,522.162292 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M387.131500,587.015015 
	C387.110962,587.184143 387.090393,587.353333 386.659485,587.815979 
	C379.914764,589.097229 373.606140,590.346069 367.236328,590.973633 
	C363.493103,591.342468 359.652557,590.723755 355.855804,590.549194 
	C353.037537,589.344788 350.219269,588.140320 347.420288,586.602112 
	C347.439514,586.268433 347.776581,586.305908 348.313385,586.221680 
	C358.898132,583.579956 369.012299,581.859253 379.630676,583.988647 
	C382.278198,585.177063 384.704834,586.096069 387.131500,587.015015 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M333.336243,573.173401 
	C334.144470,572.170959 334.804382,570.506592 335.787811,570.286255 
	C339.166290,569.529358 342.657990,569.278076 346.986145,568.860779 
	C350.582184,568.896606 353.298645,568.905823 356.015076,568.915039 
	C356.452637,569.001709 356.890198,569.088440 357.927185,569.546082 
	C361.961853,570.633972 365.397064,571.350891 368.904541,572.437988 
	C366.095917,574.162231 363.191589,576.697571 360.338715,576.640930 
	C352.839203,576.491882 345.362122,575.214661 337.510529,574.234619 
	C335.875397,573.779358 334.605835,573.476379 333.336243,573.173401 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M293.993622,498.312439 
	C295.183167,497.591339 296.372742,496.870239 298.257080,495.727966 
	C295.694916,493.692169 293.104340,492.043091 291.044128,489.887177 
	C288.767273,487.504608 286.976318,484.657745 285.270508,481.739532 
	C286.664673,482.351807 287.761993,483.237671 288.929047,484.454468 
	C295.486267,493.071503 304.366455,495.141266 314.652740,494.615448 
	C315.936005,497.540771 317.510254,500.627747 318.567230,503.882751 
	C318.839996,504.722687 317.487915,506.090271 316.661682,506.956726 
	C308.958618,503.902771 301.476105,501.107605 293.993622,498.312439 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M343.106628,543.071167 
	C346.280579,546.520813 349.454529,549.970520 352.818085,554.070923 
	C352.994141,555.483765 352.980591,556.245850 352.595947,556.970093 
	C342.962067,552.218445 333.090973,551.792725 323.018158,552.788940 
	C325.045990,549.210876 321.940979,547.793884 320.424133,545.492554 
	C322.663300,545.638550 324.547729,546.395508 326.488708,546.591187 
	C332.370361,547.184204 338.351562,547.921631 343.106628,543.071167 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M368.832275,572.067871 
	C365.397064,571.350891 361.961853,570.633972 358.237793,569.670410 
	C358.875671,567.795105 359.802399,566.166321 360.729126,564.537598 
	C358.487610,564.402344 356.070221,563.651672 354.033630,564.233643 
	C342.479187,567.535522 332.473907,564.350525 323.534546,557.202332 
	C332.954895,561.514526 342.736176,561.417664 352.516876,560.874146 
	C353.715332,560.807556 354.817108,559.001526 355.963684,558.001587 
	C361.274445,562.778625 366.585175,567.555725 371.710175,572.628418 
	C370.627014,572.638672 369.729645,572.353271 368.832275,572.067871 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M379.409821,583.719238 
	C369.012299,581.859253 358.898132,583.579956 348.439362,586.108154 
	C348.989471,583.139282 349.101898,580.868225 344.885101,580.851501 
	C343.953033,580.847778 343.026764,579.398499 342.476227,578.270386 
	C353.897461,581.276123 364.651520,581.353149 374.847382,575.103271 
	C377.560455,577.483459 380.273529,579.863586 382.578339,582.653748 
	C381.250000,583.282227 380.329926,583.500732 379.409821,583.719238 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M286.090546,479.079132 
	C286.899628,478.006897 287.708679,476.934662 288.298828,476.152557 
	C285.542694,471.725220 282.786041,467.297028 280.360046,462.560974 
	C281.964813,463.451965 283.238892,464.650818 284.525146,466.170258 
	C287.004395,469.051178 289.471527,471.611481 292.002350,474.504913 
	C295.227661,476.520538 298.259155,478.596710 301.610748,479.704529 
	C303.087585,480.192657 305.214905,478.712860 307.039185,478.091187 
	C307.031494,478.055786 307.102081,478.039581 307.398438,478.039825 
	C308.089752,478.041595 308.484711,478.043121 309.048370,478.372772 
	C309.907501,481.319611 310.597961,483.938385 311.125671,486.895996 
	C310.614319,487.894073 310.265686,488.553253 309.584351,489.114227 
	C307.291992,487.897430 305.332306,486.778870 303.105835,485.424377 
	C297.256226,483.152008 291.673370,481.115570 286.090546,479.079132 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M355.985352,558.000122 
	C354.817108,559.001526 353.715332,560.807556 352.516876,560.874146 
	C342.736176,561.417664 332.954895,561.514526 323.503601,556.852905 
	C323.131378,556.831421 322.819244,556.639465 322.479431,556.414429 
	C321.870483,555.964905 321.561310,555.866516 321.212036,555.894043 
	C318.913544,553.771973 320.522186,553.340210 322.731506,552.916626 
	C333.090973,551.792725 342.962067,552.218445 352.816284,557.233521 
	C354.272125,557.704041 355.136505,557.873169 356.000916,558.042358 
	C356.000916,558.042358 356.006989,557.998718 355.985352,558.000122 
M340.139343,554.967712 
	C336.390503,555.261963 332.641693,555.556274 328.892853,555.850586 
	C334.747986,558.865601 340.587219,559.752686 346.537994,558.451782 
	C346.633942,557.968689 346.729858,557.485596 346.825806,557.002502 
	C344.886932,556.330811 342.948059,555.659180 340.139343,554.967712 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M293.599854,498.369324 
	C301.476105,501.107605 308.958618,503.902771 316.684448,507.244171 
	C316.973724,508.171692 317.019714,508.553009 317.034271,508.967285 
	C317.002838,509.000275 316.943939,509.069794 316.537720,509.063354 
	C309.980896,507.806244 303.830292,506.555573 297.368042,505.216675 
	C296.430542,504.967377 295.804688,504.806305 295.178864,504.645203 
	C292.854187,502.844818 290.529480,501.044434 287.148804,498.426239 
	C290.115814,498.426239 291.660950,498.426239 293.599854,498.369324 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M333.038757,529.041992 
	C335.417572,532.351196 337.796387,535.660400 340.037598,539.540039 
	C339.750336,540.268066 339.600677,540.425537 339.090210,540.504883 
	C337.511841,540.213928 336.294281,540.001099 334.893585,539.506287 
	C333.819702,539.122253 332.929016,539.020203 332.036224,538.945312 
	C332.034149,538.972351 332.080292,538.942139 331.887909,538.633179 
	C328.180725,537.499268 324.665894,536.674316 321.151093,535.849365 
	C320.282959,534.903931 319.505096,533.848267 318.522064,533.043091 
	C317.480377,532.189941 316.243713,531.574829 315.446899,530.494507 
	C320.601044,529.875610 325.400513,529.617859 330.444458,529.300171 
	C330.851257,529.197754 331.013550,529.155273 331.486572,529.124756 
	C332.211090,529.105164 332.624939,529.073608 333.038757,529.041992 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M339.666504,585.930603 
	C343.727203,590.255615 347.280701,594.812073 351.511047,598.615723 
	C359.594635,605.883850 368.063721,612.723267 376.688416,619.867004 
	C377.004028,619.993347 377.000275,620.000000 377.145203,620.293701 
	C377.779572,621.042053 378.269043,621.496704 378.758484,621.951355 
	C378.758484,621.951355 378.419281,622.085144 377.840607,622.036499 
	C376.995422,621.997986 376.728882,622.008118 376.462372,622.018250 
	C372.202698,619.048950 367.596558,616.466980 363.755127,613.030212 
	C355.622162,605.753906 347.854706,598.066101 340.024323,590.457520 
	C338.748657,589.217957 337.918335,587.520142 336.939301,585.530273 
	C336.996399,585.026367 337.313416,584.686890 337.586182,584.771729 
	C338.235168,584.923340 338.611389,584.990051 338.987610,585.056763 
	C339.051056,585.371643 339.210175,585.626709 339.666504,585.930603 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M281.898895,460.419250 
	C282.926270,458.551178 283.953674,456.683105 285.030060,454.376770 
	C285.079071,453.938538 285.213104,453.826111 285.499634,453.995026 
	C289.500000,456.476410 293.213837,458.788879 297.035645,461.470184 
	C299.732239,462.227570 302.320862,462.616150 304.940918,463.417358 
	C305.547668,465.895508 306.123047,467.961060 306.306152,470.105774 
	C304.913208,470.481415 303.912506,470.777924 302.622833,470.908081 
	C300.530426,469.548553 298.726959,468.355408 296.755493,466.854004 
	C291.691315,464.503632 286.795105,462.461426 281.898895,460.419250 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M374.766418,574.810303 
	C364.651520,581.353149 353.897461,581.276123 342.454773,577.888550 
	C341.579681,577.559570 341.104370,577.267883 340.166748,576.715027 
	C339.094940,575.764893 338.485504,575.075928 337.876099,574.386963 
	C345.362122,575.214661 352.839203,576.491882 360.338715,576.640930 
	C363.191589,576.697571 366.095917,574.162231 368.904541,572.438049 
	C369.729645,572.353271 370.627014,572.638672 371.884369,572.927002 
	C373.058014,573.459106 373.871704,573.988281 374.766418,574.810303 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M343.078674,542.849854 
	C338.351562,547.921631 332.370361,547.184204 326.488708,546.591187 
	C324.547729,546.395508 322.663300,545.638550 320.358490,545.171021 
	C319.593719,545.094849 319.223480,544.986023 318.341919,544.606873 
	C316.251801,543.519775 314.673004,542.702881 313.094238,541.885986 
	C313.094238,541.885986 312.997833,541.931580 312.955597,541.660278 
	C312.601532,540.947266 312.289703,540.505615 312.347107,540.021729 
	C313.458374,540.015259 314.200378,540.051086 315.241211,540.346069 
	C322.023499,541.420166 328.494507,542.381348 335.000122,542.936768 
	C336.448029,543.060303 338.017883,541.754761 339.907166,541.076233 
	C340.533539,541.031128 340.784393,541.017090 341.035217,541.003052 
	C341.035217,541.003052 340.990967,541.013062 341.079437,541.213928 
	C341.534393,541.252014 341.900879,541.089233 342.267334,540.926514 
	C342.528473,541.493896 342.789581,542.061218 343.078674,542.849854 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M295.146545,505.013855 
	C295.804688,504.806305 296.430542,504.967377 297.504547,505.534729 
	C301.070618,507.302521 304.080200,509.075775 307.331268,509.931030 
	C312.467865,511.282318 317.766418,512.017944 322.996429,513.014099 
	C317.264557,514.909790 311.525909,515.324524 305.378265,513.054932 
	C301.692261,510.472443 298.403229,507.927490 295.146545,505.013855 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M281.590698,460.365356 
	C286.795105,462.461426 291.691315,464.503632 296.768311,467.220398 
	C297.257660,470.487518 296.443695,471.307770 293.895721,470.059723 
	C290.819000,468.552582 287.644928,467.244080 284.513000,465.849640 
	C283.238892,464.650818 281.964813,463.451965 280.376984,462.194824 
	C280.469635,461.528168 280.876068,460.919830 281.590698,460.365356 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M285.747803,479.217316 
	C291.673370,481.115570 297.256226,483.152008 302.916321,485.692444 
	C302.246826,487.179871 301.500061,488.163361 300.596313,489.353607 
	C296.636841,487.589233 292.748077,485.856384 288.859314,484.123535 
	C287.761993,483.237671 286.664673,482.351807 285.287170,481.376343 
	C285.139740,480.643005 285.272400,479.999237 285.747803,479.217316 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M314.942383,540.086914 
	C314.200378,540.051086 313.458374,540.015259 312.026428,539.908203 
	C310.294556,539.415039 309.252594,538.993164 308.210632,538.571289 
	C308.644165,537.810486 309.025391,536.429932 309.519653,536.388184 
	C313.094910,536.086304 316.693024,536.054871 320.717499,535.893555 
	C324.665894,536.674316 328.180725,537.499268 331.425049,538.650879 
	C325.750488,539.347290 320.346436,539.717102 314.942383,540.086914 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M279.752991,441.161621 
	C281.916351,441.743408 283.823639,442.488190 286.332153,443.460938 
	C291.000427,446.794525 295.067474,449.900177 298.746277,452.997711 
	C296.699829,452.315613 295.069336,451.559937 293.377502,450.984802 
	C289.961639,449.823669 286.512421,448.760620 282.876465,447.678223 
	C282.675995,447.699402 282.276917,447.756836 282.130371,447.462555 
	C281.040619,446.003662 280.097351,444.839020 279.154114,443.674408 
	C279.268402,442.891144 279.382690,442.107880 279.752991,441.161621 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M301.641968,517.956909 
	C306.688049,518.317993 311.385071,518.742859 316.639618,519.458496 
	C318.078461,520.168091 318.959839,520.586914 319.387756,520.986145 
	C316.808624,520.978455 314.645874,520.747009 312.566772,521.064209 
	C310.007324,521.454590 307.517609,522.302246 304.710175,522.955200 
	C304.242493,523.023926 304.062378,523.089722 303.882263,523.155457 
	C301.889435,521.815735 299.896606,520.476013 297.073212,518.578003 
	C299.032654,518.319214 300.162811,518.169983 301.641968,517.956909 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M330.199982,529.360168 
	C325.400513,529.617859 320.601044,529.875610 315.383636,530.116333 
	C311.656128,528.339905 308.346527,526.580505 305.024353,524.402222 
	C305.011749,523.983276 305.201050,523.797363 305.585052,523.857666 
	C307.255890,524.076233 308.542755,524.234436 310.028748,524.660889 
	C312.817627,525.916077 315.407318,526.902954 318.270203,528.204529 
	C322.428955,528.799500 326.314453,529.079834 330.199982,529.360168 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M279.091309,444.039917 
	C280.097351,444.839020 281.040619,446.003662 282.061768,447.812378 
	C283.164124,450.246368 284.188629,452.036255 285.213104,453.826111 
	C285.213104,453.826111 285.079071,453.938538 285.012390,453.996277 
	C281.170380,451.943542 277.729523,449.627899 279.091309,444.039917 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M355.810974,568.601196 
	C353.298645,568.905823 350.582184,568.896606 347.423767,568.798218 
	C349.856781,568.568481 352.731842,568.427917 355.810974,568.601196 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M337.510529,574.234619 
	C338.485504,575.075928 339.094940,575.764893 339.879089,576.685059 
	C337.796234,575.929260 335.538635,574.942322 333.308655,573.564331 
	C334.605835,573.476379 335.875397,573.779358 337.510529,574.234619 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M333.698700,582.982910 
	C332.388245,583.318359 331.077759,583.653809 329.470337,583.893677 
	C330.409424,583.196350 331.645508,582.594727 333.313507,582.230957 
	C333.729858,582.640198 333.714294,582.811584 333.698700,582.982910 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M308.175781,538.967590 
	C309.252594,538.993164 310.294556,539.415039 311.657196,539.950439 
	C312.289703,540.505615 312.601532,540.947266 313.004395,541.645996 
	C311.443909,541.056641 309.792389,540.210266 308.175781,538.967590 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M313.098389,542.270447 
	C314.673004,542.702881 316.251801,543.519775 318.051941,544.596741 
	C316.549683,544.122864 314.826111,543.388855 313.098389,542.270447 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M333.894440,583.252258 
	C333.714294,582.811584 333.729858,582.640198 333.673950,582.219971 
	C334.504120,582.213989 335.405792,582.456909 336.665222,583.145081 
	C337.119781,583.955872 337.216583,584.321411 337.313416,584.686890 
	C337.313416,584.686890 336.996399,585.026367 336.843506,585.204590 
	C335.823822,584.762329 334.957001,584.141968 333.894440,583.252258 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M337.586182,584.771729 
	C337.216583,584.321411 337.119781,583.955872 336.979065,583.308960 
	C337.596588,583.482056 338.258026,583.936584 338.953552,584.723938 
	C338.611389,584.990051 338.235168,584.923340 337.586182,584.771729 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M321.313293,556.152832 
	C321.561310,555.866516 321.870483,555.964905 322.299377,556.380493 
	C322.110931,556.518250 321.762726,556.464905 321.313293,556.152832 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M304.027161,523.334595 
	C304.062378,523.089722 304.242493,523.023926 304.762634,523.166199 
	C305.102692,523.374207 305.201050,523.797363 305.201050,523.797363 
	C305.201050,523.797363 305.011749,523.983276 304.915497,524.075806 
	C304.613342,523.940369 304.397614,523.722229 304.027161,523.334595 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M328.385315,493.106018 
	C325.110443,494.044678 321.835571,494.983337 317.955261,495.629089 
	C311.264618,480.507050 306.027435,465.510803 308.452271,448.730072 
	C309.181274,444.367310 309.966736,440.326813 310.015442,436.277405 
	C310.030518,435.028381 308.036438,433.755188 306.962311,432.493042 
	C308.115631,432.311707 309.268921,432.130341 310.788818,431.972168 
	C311.421387,433.105530 311.687378,434.215698 311.949890,435.997681 
	C311.946442,437.102448 311.946503,437.535492 311.946533,437.968506 
	C311.933105,438.430176 311.919678,438.891876 311.911957,439.928040 
	C311.917694,440.502563 311.932434,440.959900 311.932434,440.959900 
	C312.428497,441.978149 312.924591,442.996368 313.723999,444.431641 
	C311.551514,449.150238 309.644684,453.529602 311.728973,458.685059 
	C319.511963,454.094391 323.349518,447.612274 323.596832,439.023193 
	C324.099915,442.939575 324.603027,446.855957 325.025787,450.147003 
	C326.096069,453.155853 327.347321,455.655579 327.829620,458.295807 
	C328.388580,461.355774 328.271942,464.539215 328.767792,468.283691 
	C327.494110,471.382080 325.762146,473.789337 324.343109,476.368713 
	C322.531830,479.661194 320.708069,482.996826 319.437714,486.511902 
	C318.936707,487.898163 319.912720,489.818237 320.216156,491.495239 
	C321.755035,490.855194 323.804993,490.632690 324.734650,489.494812 
	C327.277435,486.382446 329.348358,482.884552 331.742828,479.965332 
	C330.949677,484.395996 330.019867,488.400665 329.067139,492.597168 
	C328.897064,493.045471 328.677429,493.151123 328.385315,493.106018 
M313.523346,468.529053 
	C313.338287,470.843323 313.153259,473.157562 312.950714,475.690460 
	C322.881744,473.671143 327.729187,464.893555 325.178528,453.255432 
	C321.053955,458.537750 317.439728,463.166473 313.523346,468.529053 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M331.852295,522.480225 
	C331.987732,522.109863 332.260315,522.057495 333.308411,521.971802 
	C340.320007,523.232361 341.562042,522.585449 343.360779,516.181885 
	C344.102966,513.539612 344.153259,510.702972 344.518250,507.954742 
	C345.504578,509.656830 346.490936,511.358887 347.824524,513.548706 
	C347.397644,519.735291 346.623566,525.434204 345.826233,531.518738 
	C346.746033,534.366272 347.689087,536.828186 348.632111,539.290039 
	C349.151917,539.259949 349.671753,539.229919 350.191559,539.199890 
	C351.022064,537.680115 351.894440,536.181396 352.672302,534.635193 
	C353.603638,532.783875 354.454193,530.891968 355.339661,529.017578 
	C355.532196,531.885620 356.190918,534.817688 355.807831,537.606689 
	C355.234741,541.779053 351.930328,542.783203 347.958862,542.967957 
	C342.489716,536.447327 337.239594,529.622742 331.852295,522.480225 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M331.606201,479.539368 
	C329.348358,482.884552 327.277435,486.382446 324.734650,489.494812 
	C323.804993,490.632690 321.755035,490.855194 320.216156,491.495239 
	C319.912720,489.818237 318.936707,487.898163 319.437714,486.511902 
	C320.708069,482.996826 322.531830,479.661194 324.343109,476.368713 
	C325.762146,473.789337 327.494110,471.382080 329.117676,468.548889 
	C329.766266,468.341736 330.825073,468.342651 330.924103,468.651367 
	C331.307343,469.846344 331.384766,471.139374 331.634399,473.116089 
	C331.663879,475.737305 331.635040,477.638336 331.606201,479.539368 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M323.597870,438.695099 
	C323.349518,447.612274 319.511963,454.094391 311.728973,458.685059 
	C309.644684,453.529602 311.551514,449.150238 314.098022,444.489838 
	C316.344696,441.723663 318.437714,439.234009 320.720978,436.933136 
	C322.828125,434.809753 323.791321,435.572296 323.597870,438.695099 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M328.270416,493.474426 
	C328.677429,493.151123 328.897064,493.045471 329.360168,492.401733 
	C331.530792,489.743652 333.385498,487.472900 335.240173,485.202148 
	C335.810242,485.609863 336.380371,486.017609 336.964600,486.995880 
	C337.110504,488.095673 337.242310,488.624908 337.374146,489.154175 
	C337.420288,489.837921 337.466431,490.521698 337.638855,491.523743 
	C337.765137,491.842041 337.520599,491.596924 337.080841,491.789734 
	C334.081360,495.762939 331.621735,499.617737 328.901154,503.278656 
	C328.080597,504.382782 326.535339,504.948395 325.322021,505.760651 
	C326.266510,501.788055 327.210999,497.815430 328.270416,493.474426 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M344.349243,507.634857 
	C344.153259,510.702972 344.102966,513.539612 343.360779,516.181885 
	C341.562042,522.585449 340.320007,523.232361 333.719971,521.908936 
	C333.281372,519.499451 333.206757,517.119568 333.421112,514.360046 
	C333.710114,513.980469 334.122345,514.035400 334.094849,514.404419 
	C334.159332,515.956055 334.251312,517.138733 334.349457,518.400330 
	C340.093140,516.401001 341.356110,511.884705 342.380066,507.002106 
	C342.984009,506.907501 343.328430,506.853363 343.672821,506.799194 
	C343.841980,506.971130 344.011108,507.143066 344.349243,507.634857 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M334.122345,514.035400 
	C334.122345,514.035400 333.710114,513.980469 333.502563,513.984375 
	C335.806702,509.248047 338.318390,504.507812 340.928345,499.442932 
	C341.803345,500.558228 342.580078,501.998138 343.426270,504.102722 
	C343.653778,505.200317 343.811859,505.633240 343.969940,506.066162 
	C343.969940,506.066162 343.819580,506.432861 343.746216,506.616028 
	C343.328430,506.853363 342.984009,506.907501 342.016022,507.029205 
	C340.582062,508.261017 339.942383,509.612305 338.920502,510.544769 
	C337.468445,511.869781 335.735352,512.886780 334.122345,514.035400 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M345.849487,531.133057 
	C346.623566,525.434204 347.397644,519.735291 348.187225,513.646301 
	C348.766876,513.652039 349.331024,514.047974 349.994080,514.734131 
	C350.324615,515.569580 350.556244,516.114685 350.914398,517.075256 
	C351.082123,517.675415 351.183746,517.816833 351.345795,517.914856 
	C351.428162,518.109375 351.510498,518.303955 351.731537,519.001465 
	C351.870209,519.504456 351.906647,519.987854 351.653900,520.219604 
	C350.461121,522.356140 349.549896,524.275818 348.572418,526.161133 
	C347.702911,527.838196 346.760010,529.477234 345.849487,531.133057 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M334.899963,485.014221 
	C333.385498,487.472900 331.530792,489.743652 329.383057,492.209869 
	C330.019867,488.400665 330.949677,484.395996 331.742859,479.965332 
	C331.635040,477.638336 331.663879,475.737305 331.794983,473.431824 
	C335.677338,474.535736 333.454285,477.656525 333.802063,480.090393 
	C334.028229,481.672821 334.305389,483.247925 334.899963,485.014221 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M343.738983,484.210632 
	C345.388550,488.043823 346.756195,492.129425 348.135376,496.607788 
	C343.776520,493.871399 343.266113,489.298431 343.738983,484.210632 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M338.457703,443.511597 
	C338.607605,447.037323 338.724854,450.170593 338.725952,453.733154 
	C338.193298,449.654938 337.776825,445.147400 337.642578,440.347839 
	C338.091553,441.076904 338.258331,442.097992 338.457703,443.511597 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M339.672974,465.223206 
	C340.305054,466.714050 340.720154,468.463837 341.097473,470.606995 
	C340.525146,469.160950 339.990570,467.321533 339.672974,465.223206 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M338.677673,457.238953 
	C339.135010,458.168060 339.356934,459.333435 339.399292,460.757141 
	C338.960571,459.835388 338.701385,458.655304 338.677673,457.238953 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M342.701904,479.159363 
	C343.146027,479.530823 343.399384,480.063446 343.563751,480.896637 
	C343.153564,480.571655 342.832367,479.946075 342.701904,479.159363 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M341.208893,473.131653 
	C341.619110,473.871338 341.947937,474.993683 342.277527,476.475800 
	C341.894714,475.728485 341.511108,474.621429 341.208893,473.131653 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M312.251953,437.943573 
	C311.946503,437.535492 311.946442,437.102448 311.960754,436.345062 
	C312.501312,436.249390 313.027466,436.478058 313.553589,436.706726 
	C313.221527,437.110687 312.889435,437.514679 312.251953,437.943573 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M337.680054,489.053833 
	C337.242310,488.624908 337.110504,488.095673 337.049988,487.293274 
	C337.409515,487.664612 337.697754,488.309082 337.680054,489.053833 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M344.210449,505.900116 
	C343.811859,505.633240 343.653778,505.200317 343.560486,504.423096 
	C343.900452,504.630554 344.175690,505.182312 344.210449,505.900116 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M312.192749,440.957520 
	C311.932434,440.959900 311.917694,440.502563 311.921082,440.274353 
	C312.343201,440.235901 312.761902,440.425629 313.180573,440.615356 
	C312.938080,440.728638 312.695587,440.841888 312.192749,440.957520 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M329.227905,410.929688 
	C329.168518,410.153625 329.492676,409.370056 330.045898,408.048584 
	C330.825134,407.019745 331.375244,406.528809 331.925354,406.037872 
	C332.112488,406.031189 332.299622,406.024536 332.768188,406.016846 
	C331.903564,407.651276 330.757507,409.286713 329.227905,410.929688 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M307.863708,395.734955 
	C307.139343,396.101715 306.471832,396.085297 305.516998,395.712646 
	C307.716522,390.550446 310.323517,385.799988 312.589966,380.892273 
	C313.048706,379.898926 312.220490,378.311249 311.984253,376.738770 
	C311.991760,376.307617 312.000549,376.135315 312.009338,375.962982 
	C315.065552,376.296783 318.121796,376.630615 321.598816,376.904724 
	C323.603302,378.359924 325.186981,379.874908 326.608643,381.987000 
	C324.579437,382.667725 322.712158,382.751312 320.844910,382.834869 
	C318.462341,383.403931 315.158325,383.197845 313.890686,384.704742 
	C311.317719,387.763458 309.846130,391.748566 307.863708,395.734955 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M320.539307,383.011536 
	C322.712158,382.751312 324.579437,382.667725 326.719208,382.307678 
	C329.736694,383.113739 332.481628,384.196259 335.556183,385.463623 
	C329.536469,387.080170 323.187195,388.511810 316.411438,389.979797 
	C314.923798,386.198547 317.815277,384.840546 320.539307,383.011536 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M332.461121,403.180756 
	C329.522919,400.864807 326.670349,400.534668 323.398712,402.288940 
	C321.427490,403.345917 319.256165,404.029602 316.761047,404.871185 
	C320.984100,400.063690 326.743256,398.216064 334.123779,398.179260 
	C333.586090,400.054016 333.171936,401.498077 332.461121,403.180756 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M331.947876,406.033386 
	C331.375244,406.528809 330.825134,407.019745 330.110870,407.734436 
	C327.691376,408.705933 325.473969,409.618652 323.168549,410.148926 
	C321.344421,410.568542 319.412354,410.518799 317.244934,410.432739 
	C321.737000,408.143402 326.512360,406.098907 331.678894,404.093872 
	C332.087891,404.376343 332.105652,404.619324 331.980286,405.171631 
	C331.837128,405.480957 331.678772,405.799622 331.678772,405.799622 
	C331.678772,405.799622 331.952637,406.061981 331.952637,406.061981 
	C331.952637,406.061981 331.970428,406.028931 331.947876,406.033386 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M331.976685,405.941925 
	C331.952637,406.061981 331.678772,405.799622 331.678772,405.799622 
	C331.678772,405.799622 331.837128,405.480957 331.961395,405.536591 
	C332.085663,405.592224 332.000732,405.821869 331.976685,405.941925 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M299.134491,453.005829 
	C295.067474,449.900177 291.000427,446.794525 286.680634,443.426147 
	C290.881073,443.412292 289.062042,438.699585 291.584869,437.042236 
	C291.963074,436.962158 291.996613,436.996674 291.991669,437.409058 
	C291.474915,442.440765 294.090485,443.915466 298.144470,443.952789 
	C300.107422,443.970886 302.070251,444.003326 304.038788,444.398621 
	C304.158966,445.491669 304.273499,446.215332 304.338501,447.289124 
	C304.328613,448.107910 304.368225,448.576660 304.289246,449.456177 
	C303.708557,451.700439 303.246460,453.533905 302.494080,455.242432 
	C301.180634,454.413605 300.157562,453.709717 299.134491,453.005829 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M304.407867,449.045380 
	C304.368225,448.576660 304.328613,448.107910 304.524597,447.040436 
	C304.806213,445.604492 304.852203,444.767334 304.901947,443.495605 
	C304.866882,441.312134 304.828064,439.563232 304.852356,437.435730 
	C304.993103,436.039246 305.070679,435.021332 305.148224,434.003418 
	C305.567352,433.579803 305.986511,433.156219 306.683960,432.612823 
	C308.036438,433.755188 310.030518,435.028381 310.015442,436.277405 
	C309.966736,440.326813 309.181274,444.367310 308.176056,448.841919 
	C306.812927,449.848083 305.953308,450.423553 305.060791,450.732971 
	C304.821228,449.993042 304.614563,449.519196 304.407867,449.045380 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M304.723419,434.046875 
	C305.070679,435.021332 304.993103,436.039246 304.454529,437.488831 
	C299.994568,437.612549 295.995575,437.304626 291.996613,436.996674 
	C291.996613,436.996674 291.963074,436.962158 291.946106,436.943970 
	C293.359314,436.282257 294.733215,435.354614 296.232086,435.057617 
	C298.880798,434.532745 301.605652,434.391937 304.723419,434.046875 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M318.149658,358.461334 
	C319.902863,357.417725 321.656067,356.374115 323.627808,355.188324 
	C327.499481,355.264893 331.152588,355.483673 334.907898,355.951111 
	C334.187164,358.356140 333.501160,360.577515 332.514648,362.656281 
	C329.934296,368.093323 324.426575,371.008789 318.760223,369.439850 
	C317.376404,369.056671 316.172913,366.706787 315.633911,365.022003 
	C315.233704,363.771027 316.041748,362.133514 316.228210,360.256592 
	C316.144806,359.845001 316.147369,359.812836 316.237000,359.813751 
	C316.537994,359.715912 316.752594,359.624939 317.229980,359.440613 
	C317.709625,359.046814 317.929657,358.754089 318.149658,358.461334 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M298.708282,368.823395 
	C299.245026,367.828918 299.781769,366.834473 300.766174,365.458679 
	C302.156769,364.715118 303.099670,364.352844 304.363647,364.034790 
	C305.530518,364.168152 306.376404,364.257294 307.222260,364.346436 
	C308.557129,366.000885 309.891968,367.655365 310.814819,369.654053 
	C306.494202,369.194092 302.518555,367.646698 298.971558,370.656097 
	C298.872986,369.796906 298.790649,369.310150 298.708282,368.823395 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M307.553406,364.064087 
	C306.376404,364.257294 305.530518,364.168152 304.406952,363.633087 
	C304.133026,362.114105 304.136841,361.041046 304.510986,359.916412 
	C308.637299,359.986542 312.372894,355.686188 316.147369,359.812836 
	C316.147369,359.812836 316.144806,359.845001 316.165039,359.838257 
	C313.418396,361.148285 310.651489,362.465027 307.553406,364.064087 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M298.987762,371.028534 
	C302.518555,367.646698 306.494202,369.194092 310.835327,370.021088 
	C311.418030,370.361237 311.568207,370.678589 311.500641,371.643463 
	C311.263519,373.193939 311.244202,374.096893 310.860779,375.003174 
	C310.011566,374.988586 309.526459,374.970673 308.814758,374.926941 
	C308.588196,374.901154 308.135040,374.857544 308.044434,374.499298 
	C305.952881,373.457306 303.951935,372.773590 301.640045,372.075897 
	C300.917969,372.101929 300.506775,372.141876 299.853088,372.050049 
	C299.402985,371.621643 299.195374,371.325104 298.987762,371.028534 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M309.041351,374.952759 
	C309.526459,374.970673 310.011566,374.988586 311.065491,375.011719 
	C311.634277,375.016937 312.044403,375.077576 312.044403,375.077576 
	C312.044403,375.077576 311.994202,375.520203 312.001770,375.741577 
	C312.000549,376.135315 311.991760,376.307617 311.836670,377.013855 
	C311.122650,377.784119 310.554932,378.020508 309.908020,377.988220 
	C309.552795,377.476654 309.276794,377.233795 309.004333,376.651550 
	C309.019043,375.859009 309.030182,375.405884 309.041351,374.952759 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M312.269592,374.862244 
	C312.044403,375.077576 311.634277,375.016937 311.429565,375.008392 
	C311.244202,374.096893 311.263519,373.193939 311.542542,371.908295 
	C312.033112,372.566040 312.263947,373.606476 312.269592,374.862244 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M334.456604,332.982971 
	C334.442383,334.623688 334.046234,336.173798 333.125854,337.733704 
	C330.291382,337.884491 327.928497,337.767670 325.683167,338.226349 
	C322.215912,338.934601 318.829071,340.036530 315.597351,340.584778 
	C315.903259,339.146942 316.019958,338.095734 316.136658,337.044556 
	C316.136688,337.044556 316.041138,337.059692 316.341980,337.399902 
	C317.166718,336.983032 317.690613,336.225952 318.214539,335.468903 
	C323.203156,332.774933 328.397797,331.349335 334.456604,332.982971 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M318.138428,335.107910 
	C317.690613,336.225952 317.166718,336.983032 316.359436,337.444977 
	C316.039459,336.938324 316.002808,336.726746 315.887939,336.202820 
	C315.809784,335.890503 315.955048,335.453033 315.947205,335.222809 
	C316.201538,334.523163 316.463776,334.053741 316.783813,333.306580 
	C317.248535,333.601532 317.655426,334.174225 318.138428,335.107910 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M324.283203,314.361176 
	C327.092499,314.428223 329.901825,314.495270 333.137695,314.822876 
	C333.443573,315.590332 333.322937,316.097260 332.772156,316.859161 
	C331.042267,318.101471 329.745483,319.092804 328.442139,320.075409 
	C323.907196,323.494415 317.040497,323.511108 314.274231,320.056488 
	C317.865051,318.119751 321.074127,316.240479 324.283203,314.361176 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M313.892517,320.113953 
	C317.040497,323.511108 323.907196,323.494415 328.442139,320.075409 
	C329.745483,319.092804 331.042267,318.101471 332.695190,317.111023 
	C331.123291,325.200836 321.127808,328.004974 314.697357,324.957550 
	C313.013489,324.159546 310.604279,324.892059 308.165283,324.820007 
	C309.373047,323.106750 310.943756,321.495148 313.019257,319.916473 
	C313.524078,319.949402 313.892517,320.113953 313.892517,320.113953 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M281.148193,331.126678 
	C282.709717,326.212677 286.290192,323.911133 291.206970,322.920776 
	C291.997742,323.721680 292.508545,324.545929 293.221191,325.579956 
	C293.458893,326.843414 293.494751,327.897156 293.345032,329.300659 
	C289.217377,330.241058 285.275330,330.831726 281.148193,331.126678 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M300.272888,328.000336 
	C300.293304,327.833252 300.563690,327.713226 300.924042,327.753876 
	C300.850281,327.958862 300.686584,328.003113 300.272888,328.000336 
z"
      />
      <path
        fill="#894E24"
        opacity="1.000000"
        stroke="none"
        d="
M297.040466,327.325195 
	C297.246826,327.074860 297.531403,327.162598 297.915405,327.556274 
	C298.053925,327.735596 297.573486,327.781830 297.573486,327.781830 
	C297.573486,327.781830 297.157806,327.536621 297.040466,327.325195 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M315.408142,340.971466 
	C318.829071,340.036530 322.215912,338.934601 325.683167,338.226349 
	C327.928497,337.767670 330.291382,337.884491 332.922638,338.013977 
	C333.273560,338.672455 333.303436,339.060455 333.394318,339.736694 
	C333.193909,340.615784 332.932495,341.206604 332.321350,342.270569 
	C326.930420,348.094696 321.344025,350.954590 314.186584,346.636322 
	C314.186584,346.636322 314.186157,346.299286 314.142609,345.806610 
	C314.535431,343.866455 314.971771,342.418945 315.408142,340.971466 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M314.155182,347.032623 
	C321.344025,350.954590 326.930420,348.094696 332.274933,342.592438 
	C331.519501,344.440948 330.460724,346.440826 328.881165,348.759308 
	C327.888184,349.698059 327.416046,350.318176 326.943909,350.938293 
	C326.171722,351.268738 325.399536,351.599213 324.310425,351.949677 
	C322.122894,351.620148 320.105225,351.593628 318.423859,350.828339 
	C316.809265,350.093414 315.543060,348.592957 314.155182,347.032623 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M327.271606,350.919037 
	C327.416046,350.318176 327.888184,349.698059 328.677734,349.036621 
	C328.529846,349.630127 328.064575,350.264954 327.271606,350.919037 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M296.998413,417.001343 
	C297.143829,417.146515 297.290802,417.290283 297.437775,417.434082 
	C297.332245,417.392090 297.226715,417.350128 297.061523,417.152893 
	C297.001862,416.997620 297.000000,417.000000 296.998413,417.001343 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M314.274231,320.056488 
	C313.892517,320.113953 313.524078,319.949402 313.363892,319.826385 
	C313.128021,319.001251 313.052307,318.299164 312.923828,317.243835 
	C312.948517,316.703613 313.025970,316.516541 313.300537,316.097351 
	C316.815918,315.295044 320.134155,314.724823 323.867798,314.257874 
	C321.074127,316.240479 317.865051,318.119751 314.274231,320.056488 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M269.977844,349.489380 
	C271.780334,346.395782 271.668823,341.747559 276.571503,341.771362 
	C277.881195,341.777710 279.187592,342.459442 280.802612,343.033569 
	C280.395203,350.460236 274.991608,349.734650 269.977844,349.489380 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M395.077332,631.503357 
	C394.993103,631.844666 394.908844,632.186035 394.351990,632.963867 
	C390.917786,631.928711 387.956177,630.457031 384.994598,628.985291 
	C384.542328,628.633301 384.090088,628.281311 383.359253,627.836914 
	C381.957275,626.555603 380.833832,625.366760 379.852539,623.818542 
	C380.431183,623.582336 380.867706,623.705383 381.779358,624.241455 
	C386.528748,626.937439 390.803040,629.220398 395.077332,631.503357 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M378.962280,621.961304 
	C378.269043,621.496704 377.779572,621.042053 377.148376,620.291809 
	C377.968567,620.430115 378.930481,620.864014 379.946594,621.639526 
	C380.000793,621.981079 379.583374,621.981140 379.583374,621.981140 
	C379.583374,621.981140 379.166046,621.971313 378.962280,621.961304 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M376.643066,622.288208 
	C376.728882,622.008118 376.995422,621.997986 377.661865,622.000488 
	C377.649139,622.194763 377.236450,622.376465 376.643066,622.288208 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M385.030945,629.337036 
	C387.956177,630.457031 390.917786,631.928711 394.225037,633.475708 
	C402.518646,635.855469 410.466553,638.159912 418.744812,640.676392 
	C415.104492,640.880249 411.011230,641.483398 407.192474,640.717712 
	C401.734039,639.623169 396.305145,637.918640 391.207336,635.688843 
	C388.755005,634.616272 387.089233,631.745300 385.030945,629.337036 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M750.182617,319.682373 
	C753.440063,319.317474 756.944702,318.909912 760.337708,319.354187 
	C763.050842,319.709473 765.628296,321.100830 768.656250,322.032959 
	C767.313354,323.384003 765.697083,325.673920 763.824707,325.907043 
	C758.406860,326.581573 753.921021,324.135925 750.182617,319.682373 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M787.428223,320.874237 
	C787.889526,321.682098 787.996399,322.461609 787.665649,323.617523 
	C782.811340,323.578888 778.652161,319.626343 773.957825,323.028381 
	C773.045044,321.868347 772.132263,320.708313 771.260254,319.205750 
	C777.028381,315.786835 781.967285,318.982880 787.428223,320.874237 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M774.097046,323.349213 
	C778.652161,319.626343 782.811340,323.578888 787.622437,324.013092 
	C787.959717,324.698883 787.902466,325.365479 787.756775,326.353210 
	C782.406921,329.178497 778.147339,327.203552 774.097046,323.349213 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M800.765381,328.923035 
	C800.721375,329.096313 800.437805,329.190918 800.089478,329.091644 
	C800.191772,328.879944 800.358887,328.862122 800.765381,328.923035 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M315.597351,340.584778 
	C314.971771,342.418945 314.535431,343.866455 314.071960,345.653625 
	C312.860931,345.657288 311.676971,345.321259 310.120514,344.907043 
	C311.656006,342.294586 313.563995,339.760284 315.804321,337.135254 
	C316.019958,338.095734 315.903259,339.146942 315.597351,340.584778 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M304.779144,356.064697 
	C307.274780,354.435303 309.612671,352.292633 312.350464,351.451019 
	C313.327209,351.150757 315.272888,354.002472 316.265503,355.683350 
	C312.096222,355.989014 308.437683,356.026855 304.779144,356.064697 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M304.140656,359.968018 
	C304.136841,361.041046 304.133026,362.114105 304.085938,363.588867 
	C303.099670,364.352844 302.156769,364.715118 300.924683,365.156616 
	C299.760162,365.168671 298.884766,365.101501 297.571228,365.042114 
	C297.107880,364.871735 297.082611,364.693573 296.967285,364.261322 
	C297.103851,361.994904 297.330475,359.982605 297.493958,357.613495 
	C299.243439,357.500854 301.056091,357.745056 303.361816,358.311035 
	C303.950134,359.077881 304.045410,359.522949 304.140656,359.968018 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M304.510986,359.916412 
	C304.045410,359.522949 303.950134,359.077881 303.752380,358.307556 
	C303.857788,357.440094 304.065674,356.897919 304.526367,356.210205 
	C308.437683,356.026855 312.096222,355.989014 316.192261,355.942932 
	C316.719543,356.103607 316.809265,356.272552 316.815857,357.137268 
	C316.811920,358.402557 316.891113,358.972137 316.970337,359.541687 
	C316.752594,359.624939 316.537994,359.715912 316.237000,359.813751 
	C312.372894,355.686188 308.637299,359.986542 304.510986,359.916412 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M320.395233,354.471161 
	C319.941467,354.354279 319.666077,354.066681 319.390717,353.779053 
	C319.510010,353.665253 319.726898,353.445892 319.734528,353.452911 
	C320.026154,353.722504 320.298645,354.012817 320.395233,354.471161 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M317.229980,359.440613 
	C316.891113,358.972137 316.811920,358.402557 316.888184,357.414978 
	C317.342133,357.285431 317.640594,357.573883 318.044342,358.161865 
	C317.929657,358.754089 317.709625,359.046814 317.229980,359.440613 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M309.987213,378.256927 
	C310.554932,378.020508 311.122650,377.784119 311.837952,377.272644 
	C312.220490,378.311249 313.048706,379.898926 312.589966,380.892273 
	C310.323517,385.799988 307.716522,390.550446 305.182434,395.713806 
	C304.651703,396.340637 304.168213,396.610016 303.388977,396.835571 
	C303.631744,395.321564 304.170227,393.851440 304.654053,391.798859 
	C304.585297,390.869324 304.571198,390.522186 304.631958,389.942291 
	C304.684387,389.355896 304.522308,389.086182 304.144958,388.789642 
	C303.975342,388.526062 303.852203,388.402191 303.699860,388.307343 
	C303.409485,387.460510 303.119110,386.613708 302.540283,385.109070 
	C300.837189,383.264282 299.422577,382.077332 298.007935,380.890350 
	C298.238617,380.327087 298.469330,379.763824 299.349609,379.122040 
	C303.328491,378.781311 306.657867,378.519104 309.987213,378.256927 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M309.908020,377.988220 
	C306.657867,378.519104 303.328491,378.781311 299.623810,378.969421 
	C299.201904,378.431885 299.155334,377.968445 299.307678,377.073425 
	C299.506592,376.641846 299.852417,376.540344 300.297180,376.694397 
	C303.494904,376.895905 306.247833,376.943420 309.000763,376.990936 
	C309.276794,377.233795 309.552795,377.476654 309.908020,377.988220 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M297.702454,381.000671 
	C299.422577,382.077332 300.837189,383.264282 302.310303,384.858063 
	C299.833618,385.248322 297.298431,385.231781 294.314514,385.324310 
	C293.977112,384.709290 294.088440,383.985168 294.376984,382.929993 
	C295.501801,382.102905 296.449402,381.606934 297.702454,381.000671 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M299.852417,376.540344 
	C299.852417,376.540344 299.506592,376.641846 299.347870,376.725159 
	C296.908722,374.557129 295.791443,372.143585 298.421417,369.035400 
	C298.790649,369.310150 298.872986,369.796906 298.971558,370.656097 
	C299.195374,371.325104 299.402985,371.621643 299.827148,372.415649 
	C299.979950,374.122162 299.916199,375.331268 299.852417,376.540344 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M289.868591,378.702118 
	C287.199432,382.524933 283.346649,380.913483 279.448120,381.065430 
	C280.038361,374.053009 281.725800,373.624786 289.868591,378.702118 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M303.226746,388.237152 
	C303.852203,388.402191 303.975342,388.526062 304.097595,389.020721 
	C304.158661,389.692261 304.302399,389.963104 304.557068,390.175079 
	C304.571198,390.522186 304.585297,390.869324 304.545746,391.470764 
	C301.229431,392.807037 297.966797,393.888947 294.343201,394.883728 
	C296.069885,391.480469 296.891785,386.489655 303.226746,388.237152 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M786.144165,359.833466 
	C787.063904,360.695251 787.680176,361.731781 788.657471,363.323334 
	C792.652893,368.403748 796.302246,367.748962 801.491028,361.640472 
	C802.717224,368.632355 796.833435,372.380798 789.011719,369.590790 
	C783.408752,367.592194 782.567871,365.051025 786.144165,359.833466 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M801.429565,361.331482 
	C796.302246,367.748962 792.652893,368.403748 788.949646,363.540771 
	C791.626526,358.933014 795.999023,360.188354 800.365845,359.928711 
	C800.989380,360.279419 801.178711,360.650940 801.429565,361.331482 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M786.688171,384.806519 
	C787.131348,385.856384 787.277222,386.658264 787.200806,386.238220 
	C783.815796,388.323456 780.890747,390.125366 777.621704,391.955292 
	C779.840942,384.658997 781.662109,383.175201 786.688171,384.806519 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M778.042358,366.584656 
	C777.556824,366.879761 777.096619,366.892365 776.290771,366.937378 
	C776.439392,366.368866 776.933716,365.767975 777.755005,365.168335 
	C778.077148,365.547119 778.072449,365.924652 778.042358,366.584656 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M795.881714,411.849426 
	C795.444824,412.272797 794.887146,412.462738 794.066833,412.453857 
	C794.456482,412.042023 795.108643,411.829041 795.881714,411.849426 
z"
      />
      <path
        fill="#0AA34D"
        opacity="1.000000"
        stroke="none"
        d="
M578.602234,237.879608 
	C579.640259,242.127045 580.302307,246.346756 580.935486,250.570816 
	C581.522095,254.484741 582.159424,258.394379 582.590515,262.326050 
	C582.699585,263.320648 582.107483,264.392181 581.837585,265.428345 
	C580.845520,265.089020 579.605774,265.013184 578.909668,264.358978 
	C577.105896,262.663910 575.344177,260.853790 573.918457,258.839844 
	C569.536865,252.650818 564.557068,249.845581 556.343201,252.416351 
	C551.134155,254.046661 550.263672,248.710968 546.471008,248.504883 
	C543.661377,248.352203 540.927673,246.809784 538.159302,245.888916 
	C536.900085,245.470032 535.147278,245.444687 534.461975,244.575577 
	C531.127625,240.347305 526.588379,240.991364 522.135010,241.048920 
	C519.005615,241.089371 517.287109,239.933075 518.650146,236.221710 
	C526.141968,235.852707 532.207092,234.360107 534.471313,225.991135 
	C534.852356,224.582733 539.023987,224.099457 541.511292,223.442642 
	C542.033203,223.304794 542.947876,224.188812 543.515808,224.765228 
	C547.459595,228.767761 551.452209,231.724716 557.450623,228.168564 
	C558.751648,227.397247 561.229065,228.610245 563.559204,228.968811 
	C564.233765,229.511673 564.513794,229.994995 564.930603,231.025513 
	C565.710022,231.729279 566.352783,231.885864 566.995483,232.042450 
	C568.058472,232.036896 569.121460,232.031372 570.697388,232.237885 
	C571.412781,232.716400 571.672668,232.902695 571.989990,233.008820 
	C571.147583,238.370850 575.914978,236.526764 578.602234,237.879608 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M480.052246,210.461594 
	C479.641174,209.236374 478.646362,207.478607 479.013336,206.077545 
	C479.300812,204.979935 481.274628,204.324020 482.810760,203.725479 
	C482.099976,206.013657 481.077698,208.048218 480.052246,210.461594 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M490.983582,212.110107 
	C489.655243,212.494141 488.183533,212.592087 486.291443,212.538513 
	C487.527466,212.199326 489.183807,212.011658 490.983582,212.110107 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M482.971985,188.909027 
	C482.578644,188.197723 482.472198,187.348602 482.468201,186.183609 
	C482.800049,186.835541 483.029449,187.803375 482.971985,188.909027 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M502.949341,223.739059 
	C502.346588,223.579880 501.736542,223.089371 501.057739,222.304688 
	C501.640045,222.476257 502.291046,222.942001 502.949341,223.739059 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M485.923950,194.801605 
	C485.496948,194.716736 485.094513,194.290756 484.614929,193.575806 
	C485.008026,193.678040 485.478302,194.069275 485.923950,194.801605 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M499.996704,220.620331 
	C499.577789,220.589722 499.125427,220.235580 498.586121,219.595917 
	C498.987213,219.639191 499.475220,219.968002 499.996704,220.620331 
z"
      />
      <path
        fill="#F9EDD2"
        opacity="1.000000"
        stroke="none"
        d="
M482.502319,191.658630 
	C482.484406,191.808182 482.330444,191.461868 482.298004,191.404953 
	C482.265564,191.348038 482.520203,191.509064 482.502319,191.658630 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M496.718689,217.059174 
	C496.455170,217.162842 496.141663,216.963013 495.725525,216.498169 
	C495.971466,216.407349 496.320129,216.581497 496.718689,217.059174 
z"
      />
      <path
        fill="#429E61"
        opacity="1.000000"
        stroke="none"
        d="
M485.302795,200.826813 
	C485.110596,200.652710 485.140228,200.290054 485.366333,199.726288 
	C485.550079,199.896194 485.537384,200.267242 485.302795,200.826813 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M648.054932,315.354675 
	C649.136475,314.945465 650.254150,314.919312 651.789307,314.947754 
	C649.310608,325.243622 647.979980,336.293854 637.161072,342.260895 
	C635.629578,343.105560 634.485535,345.158203 633.777893,346.901672 
	C631.039001,353.650055 628.549316,360.499573 625.676758,367.546021 
	C626.469910,362.859528 627.156372,357.807190 628.730408,353.048492 
	C631.017395,346.134399 635.292664,340.795441 640.977966,335.798584 
	C646.387207,331.044373 648.868958,323.554382 648.054932,315.354675 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M642.054077,288.494904 
	C640.335876,289.010864 638.607544,289.060669 636.448364,289.071594 
	C636.686523,281.853119 637.355408,274.673462 638.024353,267.493835 
	C638.652649,267.311890 639.280945,267.129974 639.909241,266.948029 
	C640.539246,268.357269 641.642273,269.742340 641.715698,271.180023 
	C642.002075,276.787201 641.962341,282.411072 642.054077,288.494904 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M662.046997,288.857208 
	C660.722839,289.377075 659.381714,289.482208 657.594360,289.382141 
	C657.148071,289.176971 657.024475,288.826141 657.024475,288.826141 
	C657.312073,281.385925 657.599670,273.945709 657.887268,266.505493 
	C658.578613,266.471375 659.270020,266.437225 659.961365,266.403107 
	C661.856445,273.576569 662.059143,280.992889 662.046997,288.857208 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M651.937012,288.630249 
	C650.264587,289.120667 648.603943,289.156769 646.529297,289.157227 
	C646.649048,281.843689 647.182983,274.565826 647.716919,267.287964 
	C648.546936,267.263245 649.376892,267.238525 650.206909,267.213806 
	C650.787598,274.201202 651.368225,281.188568 651.937012,288.630249 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M666.165771,252.794159 
	C666.097351,253.907349 666.028931,255.020538 665.964355,256.551941 
	C661.912415,256.978943 657.856567,256.987701 653.279785,256.558685 
	C651.500916,255.355103 650.242920,254.589325 649.290527,253.831329 
	C649.999878,253.805969 650.403503,253.772797 651.254272,253.822449 
	C655.745667,253.276443 659.790039,252.647644 664.132874,252.094727 
	C665.009521,252.378479 665.587646,252.586319 666.165771,252.794159 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M630.332397,278.774048 
	C628.862610,274.700989 628.117432,270.645874 630.504517,265.654541 
	C634.419739,269.831512 632.469238,274.041168 632.351929,278.361420 
	C631.461121,278.836090 630.896790,278.805054 630.332397,278.774048 
z"
      />
      <path
        fill="#A89066"
        opacity="1.000000"
        stroke="none"
        d="
M640.393250,257.301025 
	C639.537354,257.299835 639.069702,257.186554 638.163696,256.564331 
	C636.030884,255.693497 634.348328,255.255569 632.639160,254.987579 
	C630.087524,254.587494 627.517090,254.307114 624.954651,253.975800 
	C631.318726,253.678207 637.682800,253.380615 644.485229,253.432343 
	C644.626648,254.544205 644.329651,255.306747 644.020142,256.298157 
	C644.007568,256.527069 644.005920,256.985535 644.005920,256.985535 
	C642.931091,257.053345 641.856262,257.121155 640.393250,257.301025 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M608.296692,353.106476 
	C609.742310,354.471619 611.072632,356.250763 612.764404,358.106140 
	C612.448364,359.089050 611.770813,359.995667 611.093201,360.902313 
	C610.405884,360.014252 609.451111,359.221100 609.094360,358.215729 
	C608.566956,356.729797 608.464661,355.092987 608.296692,353.106476 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M644.032654,256.069275 
	C644.329651,255.306747 644.626648,254.544205 644.945190,253.479477 
	C645.253601,252.926605 645.540466,252.675949 646.239258,252.066498 
	C647.069824,251.760178 647.488281,251.812607 648.006958,252.129272 
	C648.399719,252.870193 648.692322,253.346878 648.984924,253.823547 
	C650.242920,254.589325 651.500916,255.355103 652.821777,256.443726 
	C652.469604,256.803833 652.054626,256.841034 651.038452,256.586273 
	C648.302368,256.219299 646.167542,256.144287 644.032654,256.069275 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M630.237061,279.179871 
	C630.896790,278.805054 631.461121,278.836090 632.298706,278.798767 
	C632.696716,280.909882 632.821594,283.089294 632.946411,285.268707 
	C632.443665,285.369202 631.940918,285.469696 631.438171,285.570190 
	C631.006042,283.575378 630.573853,281.580536 630.237061,279.179871 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M644.020142,256.298157 
	C646.167542,256.144287 648.302368,256.219299 650.726562,256.549805 
	C648.863037,257.012970 646.710205,257.220642 644.281616,257.206909 
	C644.005920,256.985535 644.007568,256.527069 644.020142,256.298157 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M624.423706,271.954834 
	C624.260681,271.213898 624.368103,270.349854 624.693359,269.244385 
	C624.838928,269.945892 624.766541,270.888794 624.423706,271.954834 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M638.047241,314.539124 
	C638.454529,314.251984 638.907654,314.221588 639.686035,314.305176 
	C639.371887,314.544739 638.732483,314.670288 638.047241,314.539124 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M656.802856,288.917114 
	C657.024475,288.826141 657.148071,289.176971 657.186646,289.358704 
	C656.990906,289.614044 656.756653,289.687592 656.169678,289.654968 
	C655.994324,289.259216 656.249084,289.078979 656.802856,288.917114 
z"
      />
      <path
        fill="#0D8546"
        opacity="1.000000"
        stroke="none"
        d="
M566.837769,231.789886 
	C566.352783,231.885864 565.710022,231.729279 565.049072,231.278961 
	C565.580505,231.169266 566.130249,231.353302 566.837769,231.789886 
z"
      />
      <path
        fill="#0D8546"
        opacity="1.000000"
        stroke="none"
        d="
M571.892456,232.780960 
	C571.672668,232.902695 571.412781,232.716400 571.095947,232.235962 
	C571.323975,232.090042 571.595093,232.267090 571.892456,232.780960 
z"
      />
      <path
        fill="#925627"
        opacity="1.000000"
        stroke="none"
        d="
M636.711243,381.466125 
	C633.701660,383.662689 630.692078,385.859253 627.682495,388.055817 
	C627.370789,387.879395 627.059082,387.702942 626.747437,387.526520 
	C629.823730,378.606323 632.900024,369.686157 636.034424,360.388306 
	C638.228271,351.480835 643.067749,345.052399 651.469360,340.984985 
	C652.194458,341.108032 652.354248,341.199036 652.404053,341.641418 
	C651.565491,344.017822 650.836853,346.042877 649.773743,348.083740 
	C649.289856,349.065063 649.140381,350.030548 648.950195,351.357330 
	C645.977844,360.580139 643.046143,369.441620 640.038574,378.605255 
	C638.878845,379.760315 637.795044,380.613220 636.711243,381.466125 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M661.503296,315.474060 
	C661.727051,316.644897 661.676819,317.936584 661.403076,319.178986 
	C660.685974,322.433624 661.247253,324.513611 665.243347,324.520844 
	C666.688293,324.523468 668.131592,325.454407 669.783203,326.267059 
	C669.265686,327.356384 668.540527,328.140381 667.528564,328.959778 
	C666.688110,329.152557 666.134399,329.309998 665.343262,329.177917 
	C663.580566,329.670074 661.684021,330.112946 660.601807,331.298920 
	C657.718689,334.458435 655.186035,337.937836 652.514038,341.290100 
	C652.354248,341.199036 652.194458,341.108032 651.787476,340.891418 
	C653.903931,333.733795 656.211487,326.681915 658.676819,319.685638 
	C659.196838,318.209961 660.295410,316.938202 661.503296,315.474060 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M446.022186,288.370270 
	C444.622955,288.845886 443.199646,288.885101 441.352081,288.861023 
	C440.967194,282.670410 440.889954,276.538666 441.116638,270.418243 
	C441.184906,268.575470 442.098389,266.764008 442.624664,264.938171 
	C443.238708,265.021790 443.852753,265.105377 444.466797,265.188995 
	C444.977234,272.770630 445.487640,280.352234 446.022186,288.370270 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M425.205872,287.410553 
	C424.024689,287.828644 422.864471,287.833862 421.270538,287.467041 
	C420.781342,286.382111 420.725830,285.669220 420.759399,284.518555 
	C420.928650,281.401550 421.008820,278.722229 421.271667,275.771271 
	C421.278534,273.995483 421.102692,272.491394 420.926819,270.987274 
	C420.979065,270.156860 420.718414,269.060333 421.150177,268.552673 
	C421.988831,267.566620 423.216309,266.911194 424.282684,266.118774 
	C424.898132,267.100983 426.059723,268.094421 426.039795,269.063568 
	C425.916779,275.044647 425.527557,281.020233 425.205872,287.410553 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M435.895447,287.640991 
	C434.490784,288.079956 433.124847,288.044434 431.348816,287.978333 
	C431.350006,280.679901 431.761322,273.412048 432.172668,266.144196 
	C432.803253,266.148804 433.433868,266.153442 434.064484,266.158051 
	C436.865906,272.893524 435.466644,280.144562 435.895447,287.640991 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M408.512329,256.177124 
	C407.671539,255.614197 407.294678,255.090897 405.929596,253.195480 
	C414.179321,253.736847 421.381531,254.209457 428.707275,254.984161 
	C422.212616,255.596420 415.594452,255.906586 408.512329,256.177124 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M433.283142,255.697968 
	C432.904266,254.918259 432.975006,254.289001 433.448486,253.336487 
	C436.894501,252.977875 439.937836,252.942505 442.981140,252.907135 
	C443.266571,253.675751 443.552002,254.444366 443.816528,255.517380 
	C440.441345,255.830673 437.087036,255.839554 433.283142,255.697968 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M420.488892,271.004883 
	C421.102692,272.491394 421.278534,273.995483 420.891968,275.758057 
	C419.160583,277.668396 417.991547,279.320282 416.822510,280.972137 
	C416.991791,277.964691 417.161041,274.957245 417.372131,271.592926 
	C418.292938,271.164886 419.171936,271.093719 420.488892,271.004883 
z"
      />
      <path
        fill="#0D8546"
        opacity="1.000000"
        stroke="none"
        d="
M514.953735,234.649872 
	C514.645386,234.269058 514.603516,233.889954 514.561584,233.510864 
	C514.831909,233.512756 515.102234,233.514648 515.372559,233.516556 
	C515.321777,233.894897 515.270996,234.273239 514.953735,234.649872 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M443.384827,252.921936 
	C439.937836,252.942505 436.894501,252.977875 433.442688,253.017029 
	C433.028229,252.255447 433.022308,251.490067 433.434692,250.410339 
	C440.129517,250.609100 437.057770,245.983963 437.892456,243.235718 
	C438.835419,243.023605 439.457977,242.905655 440.077423,242.788300 
	C439.668243,241.769424 439.309540,240.876205 438.950836,239.982971 
	C438.971771,239.811844 438.992706,239.640732 439.035034,239.211700 
	C441.144531,238.652618 443.232635,238.351440 445.713806,237.963287 
	C447.634125,238.343979 449.161377,238.811676 450.458069,239.676605 
	C448.537933,241.010986 446.940948,242.445694 445.139374,242.781006 
	C441.471252,243.463699 441.426880,246.190720 442.259277,248.346390 
	C442.743378,249.600037 445.332550,250.288498 447.098969,250.710815 
	C448.246002,250.985031 449.617249,250.321289 450.888031,250.077789 
	C450.888031,250.077789 451.002960,250.489563 451.034607,251.028015 
	C451.054260,251.793915 451.042267,252.021332 451.030243,252.248779 
	C448.616333,252.478104 446.202423,252.707413 443.384827,252.921936 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M450.941345,249.618713 
	C449.617249,250.321289 448.246002,250.985031 447.098969,250.710815 
	C445.332550,250.288498 442.743378,249.600037 442.259277,248.346390 
	C441.426880,246.190720 441.471252,243.463699 445.139374,242.781006 
	C446.940948,242.445694 448.537933,241.010986 450.580383,240.012436 
	C450.953735,243.020584 450.974182,246.090103 450.941345,249.618713 
z"
      />
      <path
        fill="#0A2624"
        opacity="1.000000"
        stroke="none"
        d="
M464.728577,244.761627 
	C464.804443,247.966583 466.276978,252.007523 460.664459,250.639114 
	C461.053040,242.793274 461.053040,242.793274 464.728577,244.761627 
z"
      />
      <path
        fill="#0A1A20"
        opacity="1.000000"
        stroke="none"
        d="
M453.067505,250.905762 
	C453.027466,249.917068 452.794250,248.888046 452.990387,247.948654 
	C453.325989,246.340790 453.930359,244.789017 454.421875,243.213684 
	C455.181458,243.730301 456.621674,244.303970 456.583954,244.753723 
	C456.411987,246.804672 455.853760,248.828415 455.327332,250.833832 
	C455.288910,250.980270 454.400208,250.903473 453.460144,250.960434 
	C453.013519,250.990402 453.067505,250.905762 453.067505,250.905762 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M451.231689,252.439255 
	C451.042267,252.021332 451.054260,251.793915 451.111572,251.227432 
	C451.581024,250.908173 452.005127,250.927963 452.748352,250.926758 
	C453.067505,250.905762 453.013519,250.990402 453.055908,250.961151 
	C452.543213,251.497833 451.988190,252.063797 451.231689,252.439255 
z"
      />
      <path
        fill="#0A1A20"
        opacity="1.000000"
        stroke="none"
        d="
M666.485474,252.644165 
	C665.587646,252.586319 665.009521,252.378479 664.110779,251.654755 
	C663.788818,249.080444 663.787537,247.021988 663.786194,244.963547 
	C663.961182,244.944916 664.136108,244.926270 664.566528,244.843857 
	C666.209351,245.565918 668.738831,246.335083 668.750549,247.141052 
	C668.776550,248.915558 667.531494,250.708649 666.485474,252.644165 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M663.502197,244.808807 
	C663.787537,247.021988 663.788818,249.080444 663.812256,251.578857 
	C659.790039,252.647644 655.745667,253.276443 651.323181,253.431976 
	C650.945740,252.153793 650.946472,251.348862 650.826538,250.161560 
	C651.248108,245.321655 649.456543,243.738266 645.142334,245.261475 
	C645.142334,244.127792 645.142334,242.994110 645.142334,241.461243 
	C647.273926,241.920731 649.060974,242.305939 651.362610,242.802078 
	C651.992249,242.275253 653.376038,241.117432 654.758667,239.660187 
	C657.456665,239.545822 660.155762,239.730881 662.362793,239.882202 
	C662.693176,241.725540 662.955688,243.189804 663.502197,244.808807 
M655.768311,245.188858 
	C655.952515,247.169266 656.136658,249.149673 656.320862,251.130081 
	C657.275696,251.035477 658.811768,251.258759 659.071472,250.783981 
	C659.731140,249.577866 660.346497,247.884399 659.961792,246.723282 
	C659.676392,245.861816 657.794983,245.529099 655.768311,245.188858 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M645.123108,245.435364 
	C649.456543,243.738266 651.248108,245.321655 650.559448,250.375092 
	C649.577637,251.269012 648.742188,251.567017 647.906799,251.865051 
	C647.488281,251.812607 647.069824,251.760178 646.345581,251.800262 
	C645.714783,251.831772 645.446411,251.674179 645.223755,250.798019 
	C645.133240,248.762146 645.053894,247.348267 644.974487,245.934402 
	C644.974487,245.934402 645.103882,245.609268 645.123108,245.435364 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M631.844299,245.704727 
	C632.057312,246.326645 632.093323,246.688370 631.954224,246.960617 
	C631.133545,248.567093 630.469666,251.350555 629.388977,251.528656 
	C625.625122,252.148941 626.917908,248.833923 626.519226,246.421722 
	C628.171814,245.797546 629.879089,245.600372 631.844299,245.704727 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M622.905273,245.746826 
	C622.324585,248.314392 624.660278,253.204483 618.532959,251.186981 
	C619.452942,248.904785 616.636963,243.688507 622.905273,245.746826 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M640.712280,250.786972 
	C636.551392,252.658585 635.351501,250.754883 635.625549,246.429413 
	C637.186951,245.791016 638.833130,245.587067 640.599670,246.090973 
	C640.717468,248.128204 640.714844,249.457596 640.712280,250.786972 
z"
      />
      <path
        fill="#9E907A"
        opacity="1.000000"
        stroke="none"
        d="
M641.141296,250.822464 
	C640.714844,249.457596 640.717468,248.128204 640.815613,246.409332 
	C641.995056,246.003922 643.078979,245.988007 644.568665,245.953247 
	C645.053894,247.348267 645.133240,248.762146 645.110229,250.589584 
	C643.862000,250.954758 642.716125,250.906357 641.141296,250.822464 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M426.968994,251.016235 
	C424.836151,251.341370 422.711243,251.861755 420.568726,251.948669 
	C416.784546,252.102203 412.989624,251.991653 409.195587,251.987946 
	C409.869141,249.346802 410.546326,246.709381 411.350250,243.578339 
	C410.149567,243.290497 408.523682,242.900742 406.897797,242.510971 
	C406.954376,242.233749 407.010956,241.956512 407.067535,241.679291 
	C409.362732,242.104523 411.657959,242.529755 414.122406,243.477875 
	C414.195312,244.983490 413.746552,246.115479 414.084747,246.914230 
	C414.598602,248.127762 415.658600,249.110046 416.486603,250.190552 
	C417.376068,249.117462 418.673065,248.163773 419.032898,246.935516 
	C419.351166,245.849243 418.625732,244.457214 418.361084,243.200165 
	C419.769714,242.643158 421.178345,242.086151 422.812073,242.044464 
	C423.375122,243.050797 423.713104,243.541840 424.036499,244.445435 
	C424.034729,246.233932 424.047546,247.609909 423.808075,249.185776 
	C424.693512,249.929199 425.831268,250.472717 426.968994,251.016235 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M437.572021,243.329880 
	C437.057770,245.983963 440.129517,250.609100 433.441681,250.027954 
	C433.041046,247.989227 433.051758,246.018494 433.515686,243.611954 
	C435.169952,243.227386 436.371002,243.278641 437.572021,243.329880 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M418.072693,243.292984 
	C418.625732,244.457214 419.351166,245.849243 419.032898,246.935516 
	C418.673065,248.163773 417.376068,249.117462 416.486603,250.190552 
	C415.658600,249.110046 414.598602,248.127762 414.084747,246.914230 
	C413.746552,246.115479 414.195312,244.983490 414.537781,243.635712 
	C415.784027,243.309052 416.784149,243.347427 418.072693,243.292984 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M437.892456,243.235718 
	C436.371002,243.278641 435.169952,243.227386 433.605621,243.198364 
	C432.815979,242.408203 432.389679,241.595810 431.950745,240.420654 
	C433.986389,240.029312 436.034637,240.000702 438.516876,239.977539 
	C439.309540,240.876205 439.668243,241.769424 440.077423,242.788300 
	C439.457977,242.905655 438.835419,243.023605 437.892456,243.235718 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M430.123932,248.739441 
	C429.661621,247.155960 429.564819,245.683014 429.468048,244.210068 
	C430.213440,244.288437 430.958862,244.366791 431.704285,244.445160 
	C431.299347,245.913422 430.894409,247.381683 430.123932,248.739441 
z"
      />
      <path
        fill="#171712"
        opacity="1.000000"
        stroke="none"
        d="
M424.060364,248.985870 
	C424.047546,247.609909 424.034729,246.233932 424.354492,244.407333 
	C425.110504,243.909485 425.533875,243.862274 425.957275,243.815048 
	C426.331909,245.287140 426.706512,246.759216 426.675079,248.668243 
	C425.532806,249.065399 424.796570,249.025635 424.060364,248.985870 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M423.808075,249.185776 
	C424.796570,249.025635 425.532806,249.065399 426.637085,249.077606 
	C426.992767,249.486755 426.980438,249.923477 426.968536,250.688202 
	C425.831268,250.472717 424.693512,249.929199 423.808075,249.185776 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M425.905579,243.487320 
	C425.533875,243.862274 425.110504,243.909485 424.369080,243.994781 
	C423.713104,243.541840 423.375122,243.050797 423.052185,242.241730 
	C423.996063,242.335663 424.924957,242.747635 425.905579,243.487320 
z"
      />
      <path
        fill="#0F181C"
        opacity="1.000000"
        stroke="none"
        d="
M416.642395,281.380035 
	C417.991547,279.320282 419.160583,277.668396 420.709290,276.029724 
	C421.008820,278.722229 420.928650,281.401550 420.447815,284.610504 
	C419.697235,286.109039 419.347382,287.077942 418.997498,288.046814 
	C418.275360,288.077209 417.553223,288.107574 416.476379,288.045563 
	C416.235229,285.898102 416.348724,283.843018 416.642395,281.380035 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M419.308472,288.128937 
	C419.347382,287.077942 419.697235,286.109039 420.358704,285.048218 
	C420.725830,285.669220 420.781342,286.382111 420.835022,287.454681 
	C420.428650,287.946564 420.024048,288.078796 419.308472,288.128937 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M624.576294,253.970917 
	C627.517090,254.307114 630.087524,254.587494 632.639160,254.987579 
	C634.348328,255.255569 636.030884,255.693497 637.828125,256.427826 
	C631.226074,257.101105 624.521301,257.401917 617.395630,257.577332 
	C618.598206,256.545288 620.221741,255.638641 621.881226,254.387451 
	C622.677490,254.017288 623.437683,253.991669 624.576294,253.970917 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M664.041626,440.692932 
	C662.829285,441.277283 661.605103,442.019196 660.430664,441.947388 
	C657.318237,441.757080 656.746521,443.431946 656.599243,446.430481 
	C655.496399,446.938477 654.760864,446.966888 653.954346,446.725891 
	C653.795471,446.292969 653.707458,446.129456 653.738647,445.623810 
	C652.674988,444.735229 651.492188,444.188751 650.285156,443.476196 
	C650.260925,443.310150 650.082764,443.025818 650.072632,442.629822 
	C649.712769,441.313751 649.363098,440.393707 648.996460,439.084869 
	C647.632385,438.118317 646.293030,437.062042 644.936768,437.040039 
	C635.633301,436.888702 626.326294,436.954041 617.016479,436.718628 
	C617.012512,436.487579 616.978577,436.026642 616.978577,436.026642 
	C616.988098,435.590790 616.997620,435.154968 617.018311,434.393616 
	C628.500793,434.785187 639.971985,435.502258 651.850464,436.822266 
	C655.645752,440.738129 659.769653,440.748138 664.050781,440.052216 
	C664.050781,440.052216 664.052429,440.479523 664.041626,440.692932 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M664.223267,439.801453 
	C659.769653,440.748138 655.645752,440.738129 652.157959,437.045013 
	C656.170837,437.626770 660.283264,438.588715 664.223267,439.801453 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M515.991699,460.154663 
	C514.359436,460.340302 512.727173,460.525970 511.041382,460.384003 
	C514.737793,457.986359 518.561951,456.038422 522.219482,453.816345 
	C527.120911,450.838593 527.235291,448.256622 522.157898,445.177856 
	C518.235962,442.799774 513.841858,441.171906 509.584656,439.384247 
	C506.233032,437.976837 502.770142,436.834564 499.109741,435.307495 
	C501.776947,435.268494 504.708832,435.366150 507.600342,435.760376 
	C510.614410,436.171356 513.589478,436.868347 516.798706,437.160278 
	C517.182861,436.903503 517.349854,436.926697 517.847534,437.140106 
	C518.477173,437.249237 518.776245,437.168182 519.075317,437.087128 
	C521.283325,438.170593 523.491272,439.254089 526.252258,440.149048 
	C529.158203,440.601990 531.511230,441.243469 533.918335,442.277802 
	C535.408630,443.821838 536.844849,444.973053 539.113647,446.791626 
	C537.300842,447.563263 535.609009,448.283356 533.621094,448.838989 
	C531.289551,447.066742 529.254211,445.458923 527.218872,443.851135 
	C526.954468,444.218475 526.690063,444.585846 526.425659,444.953186 
	C530.511047,450.837494 530.391113,452.207947 525.378845,455.078857 
	C524.096741,455.813202 522.621094,456.205780 521.323486,456.917847 
	C519.502502,457.917145 517.764954,459.068420 515.991699,460.154663 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M539.814819,431.404144 
	C541.360474,431.127106 542.751831,431.135864 544.558960,431.178528 
	C547.872375,431.812042 550.748962,432.571320 553.674744,432.957581 
	C555.768005,433.233948 557.927246,433.010376 560.980286,433.010925 
	C570.269226,433.686676 578.634888,434.361359 587.104065,435.298096 
	C588.140625,437.009155 589.073730,438.458130 589.989807,440.223267 
	C589.967773,440.750458 589.962646,440.961456 589.603271,441.153564 
	C588.786499,441.210785 588.324097,441.286865 587.892578,441.245514 
	C587.923462,441.128052 588.040283,440.915131 587.957275,440.548737 
	C586.216736,439.807068 584.559326,439.431763 582.492310,439.061218 
	C573.267700,438.021332 564.467590,436.819611 555.632751,435.984009 
	C549.084534,435.364716 542.491394,435.221161 535.918274,434.865662 
	C537.165710,433.807098 538.413147,432.748535 539.814819,431.404144 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M587.000610,435.036011 
	C578.634888,434.361359 570.269226,433.686676 561.444946,433.005127 
	C562.709717,432.660583 564.465881,431.913940 566.151123,432.049377 
	C580.808289,433.227417 595.451599,434.577209 610.102417,435.836884 
	C612.086670,436.007507 614.089600,435.961853 616.531250,436.021484 
	C616.978577,436.026642 617.012512,436.487579 617.012451,436.736938 
	C617.012329,436.986267 616.979126,436.997559 616.602783,436.997375 
	C615.472900,437.012451 614.719360,437.027679 613.505249,437.033234 
	C607.338501,436.671936 601.632385,436.320282 595.566345,435.796143 
	C592.471191,435.427765 589.735901,435.231903 587.000610,435.036011 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M528.991577,437.459900 
	C528.998352,437.230896 529.005188,437.001892 529.406006,436.433533 
	C530.565491,436.124481 531.330933,436.154694 532.462158,436.286743 
	C539.249207,437.199341 545.670471,438.010193 552.494019,438.905029 
	C561.909241,440.714447 570.922302,442.439880 579.935364,444.165314 
	C579.878540,444.717896 579.821655,445.270508 579.764832,445.823090 
	C577.544678,446.171509 575.324463,446.519897 573.017883,446.502350 
	C563.594727,444.406616 554.258057,442.676849 544.643005,440.931580 
	C543.995483,440.894257 543.626343,440.872467 542.926147,440.622833 
	C538.060669,439.416595 533.526123,438.438263 528.991577,437.459900 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M552.091797,438.821045 
	C545.670471,438.010193 539.249207,437.199341 532.461548,435.998077 
	C532.081787,435.416840 532.068481,435.226074 532.055176,435.035339 
	C533.090515,435.031921 534.125916,435.028503 535.539795,434.945374 
	C542.491394,435.221161 549.084534,435.364716 555.632751,435.984009 
	C564.467590,436.819611 573.267700,438.021332 582.661865,439.299500 
	C583.836670,440.008667 584.432495,440.484222 584.596313,440.993408 
	C579.944885,440.459229 575.740540,439.639465 571.502197,439.382385 
	C565.044434,438.990723 558.563110,438.988586 552.091797,438.821045 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M528.605042,437.371704 
	C533.526123,438.438263 538.060669,439.416595 542.616577,440.699158 
	C542.435181,441.060883 542.232422,441.118439 541.648315,441.128845 
	C540.499878,441.084717 539.732666,441.087708 538.729492,441.060364 
	C538.493469,441.029999 538.019958,441.077454 537.640076,441.049194 
	C536.498657,441.027802 535.737122,441.034637 534.733704,441.096375 
	C534.178589,441.324524 533.993958,441.587952 533.922302,441.923889 
	C533.906738,441.906189 533.864197,441.884949 533.864197,441.884949 
	C531.511230,441.243469 529.158203,440.601990 526.437744,439.875244 
	C525.482605,439.377960 524.894958,438.965912 524.137390,438.339661 
	C525.384460,437.844757 526.801514,437.564148 528.605042,437.371704 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M531.852539,434.769043 
	C532.068481,435.226074 532.081787,435.416840 532.095825,435.896301 
	C531.330933,436.154694 530.565491,436.124481 529.420288,436.090210 
	C529.910400,435.558350 530.780151,435.030579 531.852539,434.769043 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M518.813354,437.046600 
	C518.776245,437.168182 518.477173,437.249237 518.099915,437.156250 
	C518.198303,436.990173 518.374817,436.998108 518.813354,437.046600 
z"
      />
      <path
        fill="#F0E5CF"
        opacity="1.000000"
        stroke="none"
        d="
M536.754761,635.749573 
	C536.901306,635.432861 537.221863,635.294312 537.542480,635.155762 
	C537.587830,635.412415 537.633118,635.669067 537.481323,636.101196 
	C537.284241,636.276672 536.928833,635.927734 536.754761,635.749573 
z"
      />
      <path
        fill="#2C4E1C"
        opacity="1.000000"
        stroke="none"
        d="
M561.147888,674.620789 
	C559.603699,675.450684 557.989380,676.657776 556.437561,676.582092 
	C551.846619,676.358276 547.280334,675.627991 541.922974,675.110229 
	C540.463745,675.135986 539.785950,675.147156 538.682495,675.108521 
	C535.799133,675.412781 533.341309,675.766968 530.532288,676.105347 
	C529.484436,676.150024 528.787903,676.210327 528.091309,676.270630 
	C527.918152,676.233765 527.745056,676.196899 527.007935,676.113647 
	C525.956421,676.359924 525.468994,676.652588 524.981506,676.945251 
	C524.548523,676.958130 524.115601,676.971069 523.129761,676.731201 
	C520.963562,675.498779 519.350220,674.519104 517.989136,673.302429 
	C521.145447,671.871277 524.049500,670.677063 526.968140,669.800781 
	C527.920837,670.432373 528.970032,671.169739 529.770752,670.959656 
	C530.949951,670.650269 531.951904,669.665527 533.023315,668.974609 
	C533.017212,668.980774 533.018677,668.984192 533.105957,669.189514 
	C533.359070,669.661926 533.596008,669.826965 533.938721,670.168701 
	C533.990295,670.634216 534.007019,670.820801 533.852051,671.091736 
	C533.800598,671.441162 533.920898,671.706238 534.023376,671.987671 
	C534.005615,672.004028 534.025085,671.960693 534.150757,672.187927 
	C534.811646,672.296387 535.346863,672.177551 536.147461,672.041504 
	C536.589661,672.012329 536.766541,672.000488 537.152466,672.205322 
	C538.535583,671.960449 539.709656,671.498962 541.240723,671.007690 
	C543.105225,670.294373 544.612610,669.610901 546.542847,668.872437 
	C548.925232,668.892334 550.884827,668.967285 553.019348,669.340576 
	C555.841858,671.088257 558.489441,672.537476 561.136963,673.986755 
	C561.136963,673.986755 561.106323,674.411804 561.147888,674.620789 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M540.883667,671.037476 
	C539.709656,671.498962 538.535583,671.960449 537.242981,671.742859 
	C536.904480,667.562073 536.448486,664.055298 536.522522,660.559814 
	C536.621643,655.881409 533.434692,654.370300 529.958740,652.992188 
	C529.955261,653.035645 530.038818,653.060425 530.320557,652.758911 
	C530.316040,651.989563 530.029724,651.521851 529.743408,651.054077 
	C529.818542,650.816833 529.893616,650.579651 529.972717,649.967651 
	C530.464722,649.697021 531.089355,649.643188 531.419922,649.929260 
	C535.809509,653.728394 540.171814,655.320068 544.681885,650.087402 
	C544.910400,649.822266 545.642822,649.991394 546.884888,649.946655 
	C547.878052,649.903870 548.126770,649.872742 548.375427,649.841614 
	C548.713623,649.967163 548.898621,650.209534 548.615234,650.860352 
	C546.680969,652.573975 544.775085,653.784363 543.524719,655.478516 
	C542.309143,657.125610 540.758667,659.510071 541.149719,661.140320 
	C541.830444,663.977966 542.590637,666.329651 540.370911,668.771118 
	C540.072266,669.099609 540.690186,670.261536 540.883667,671.037476 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M541.240723,671.007690 
	C540.690186,670.261536 540.072266,669.099609 540.370911,668.771118 
	C542.590637,666.329651 541.830444,663.977966 541.149719,661.140320 
	C540.758667,659.510071 542.309143,657.125610 543.524719,655.478516 
	C544.775085,653.784363 546.680969,652.573975 548.633545,651.099365 
	C548.940735,651.343445 549.016357,651.611145 549.451294,652.290894 
	C549.777039,653.168518 549.845337,653.605286 549.913696,654.042114 
	C549.568604,654.820740 549.223572,655.599426 548.956909,657.077148 
	C548.063477,661.493225 547.091736,665.210327 546.120056,668.927368 
	C544.612610,669.610901 543.105225,670.294373 541.240723,671.007690 
z"
      />
      <path
        fill="#EDE5CC"
        opacity="1.000000"
        stroke="none"
        d="
M561.425415,673.788696 
	C558.489441,672.537476 555.841858,671.088257 553.304199,669.209290 
	C553.608337,668.196350 553.802612,667.613159 553.996887,667.029968 
	C554.648254,665.757629 555.299622,664.485291 555.951904,663.213379 
	C561.182129,665.255920 563.666626,669.731018 561.425415,673.788696 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M553.626282,667.023315 
	C553.802612,667.613159 553.608337,668.196350 553.129150,668.910889 
	C550.884827,668.967285 548.925232,668.892334 546.542847,668.872437 
	C547.091736,665.210327 548.063477,661.493225 549.088562,657.378296 
	C555.811646,659.327454 549.327881,662.096802 549.526001,665.499817 
	C550.485718,665.890076 551.870728,666.453369 553.626282,667.023315 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M550.291138,654.049927 
	C549.845337,653.605286 549.777039,653.168518 549.627686,652.409058 
	C550.530518,652.289917 551.514221,652.493347 552.497986,652.696777 
	C551.888184,653.150452 551.278381,653.604065 550.291138,654.049927 
z"
      />
      <path
        fill="#F0E5CF"
        opacity="1.000000"
        stroke="none"
        d="
M548.266602,649.617798 
	C548.126770,649.872742 547.878052,649.903870 547.253479,649.953369 
	C547.041382,649.608215 547.205078,649.244690 547.666260,648.908325 
	C547.963684,648.935547 548.157715,649.393921 548.266602,649.617798 
z"
      />
      <path
        fill="#DCD4C2"
        opacity="1.000000"
        stroke="none"
        d="
M526.953613,669.482910 
	C524.049500,670.677063 521.145447,671.871277 517.709778,673.320068 
	C516.804688,673.588867 516.431213,673.603210 516.057678,673.617554 
	C516.002380,672.000000 515.947083,670.382507 515.834106,668.362976 
	C518.903015,665.140930 521.929749,662.198486 525.187927,659.539612 
	C527.761963,657.439026 528.049744,655.591919 525.224487,653.206055 
	C525.525879,652.381653 525.980957,651.836609 526.657959,651.140442 
	C527.399170,651.031799 527.918396,651.074341 528.774414,651.372742 
	C529.420349,652.105896 529.729553,652.583130 530.038818,653.060425 
	C530.038818,653.060425 529.955261,653.035645 529.949829,653.447144 
	C530.851807,658.314331 531.759216,662.770081 532.267029,667.206848 
	C530.229492,667.952881 528.591553,668.717896 526.953613,669.482910 
z"
      />
      <path
        fill="#925627"
        opacity="1.000000"
        stroke="none"
        d="
M515.012085,631.358521 
	C516.455017,631.905945 518.662903,628.291382 519.938110,631.972900 
	C520.214783,632.144287 520.153320,632.556946 520.162354,632.765015 
	C519.298889,633.961121 518.426453,634.949097 517.239685,635.930786 
	C516.287537,634.517944 515.649658,633.111267 515.012085,631.358521 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M530.320557,652.758911 
	C529.729553,652.583130 529.420349,652.105896 529.160156,651.312012 
	C529.209167,650.995483 529.457275,651.200623 529.600342,651.127319 
	C530.029724,651.521851 530.316040,651.989563 530.320557,652.758911 
z"
      />
      <path
        fill="#925627"
        opacity="1.000000"
        stroke="none"
        d="
M521.008911,633.210083 
	C521.185547,633.187500 521.513428,633.412292 521.932495,633.931580 
	C521.735901,633.969849 521.447998,633.713562 521.008911,633.210083 
z"
      />
      <path
        fill="#F0E5CF"
        opacity="1.000000"
        stroke="none"
        d="
M508.697845,653.750183 
	C508.831665,653.235840 509.130280,652.857422 509.428894,652.479004 
	C509.473236,652.920288 509.517548,653.361511 509.376953,653.980469 
	C509.192078,654.158203 508.862640,653.886108 508.697845,653.750183 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M515.938232,673.953369 
	C516.431213,673.603210 516.804688,673.588867 517.457520,673.557007 
	C519.350220,674.519104 520.963562,675.498779 522.805542,676.753113 
	C522.551575,677.340637 522.068848,677.653564 521.285339,677.994141 
	C518.503845,678.021912 516.023132,678.021912 512.708435,678.021912 
	C514.194031,676.239014 515.006409,675.264038 515.938232,673.953369 
z"
      />
      <path
        fill="#F4E8CB"
        opacity="1.000000"
        stroke="none"
        d="
M679.014282,463.251770 
	C679.492798,462.870331 679.986206,462.747620 680.479614,462.624939 
	C680.206116,463.061127 679.932678,463.497345 679.386230,463.977844 
	C679.085266,463.851624 679.057251,463.681091 679.014282,463.251770 
z"
      />
      <path
        fill="#F9EDD2"
        opacity="1.000000"
        stroke="none"
        d="
M674.541321,469.551697 
	C674.481201,469.587646 674.601440,469.515778 674.541321,469.551697 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M680.856812,499.843445 
	C680.635071,501.853394 680.123047,503.649689 679.415161,505.731506 
	C677.648804,507.270081 676.078308,508.523132 674.507935,509.776306 
	C670.284851,503.483887 674.719666,490.237305 684.418762,483.442108 
	C683.469910,487.318115 682.804749,489.977081 682.170593,492.643433 
	C681.617737,494.967896 681.099915,497.300659 680.856812,499.843445 
z"
      />
      <path
        fill="#F3E8D0"
        opacity="1.000000"
        stroke="none"
        d="
M745.393188,195.555649 
	C745.334900,195.471558 745.557739,195.434113 745.557739,195.434113 
	C745.557739,195.434113 745.451477,195.639740 745.393188,195.555649 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M409.395264,603.440918 
	C407.345154,601.959717 406.716949,596.884705 402.091827,600.893799 
	C401.338257,601.004150 401.132690,600.951782 400.937683,600.566406 
	C400.935944,599.568787 400.923615,598.904236 400.911285,598.239624 
	C400.989899,597.418335 401.440979,596.126770 401.089508,595.848328 
	C397.532227,593.030518 393.843811,590.378296 389.995880,587.198608 
	C389.799561,586.717529 389.683380,586.316956 389.683380,586.316956 
	C389.837311,586.168152 389.991241,586.019409 390.412567,585.682678 
	C396.821716,589.971313 402.963470,594.448059 409.606903,599.262451 
	C410.748566,600.062012 411.388550,600.523987 412.169800,601.266113 
	C413.169861,602.116577 414.028656,602.686951 415.055542,603.505737 
	C416.342163,604.552368 417.460693,605.350586 418.741180,606.404236 
	C419.227386,606.893616 419.551605,607.127686 420.048096,607.566772 
	C420.696564,607.952637 421.172821,608.133423 421.649078,608.314209 
	C421.649078,608.314209 421.708527,608.303528 421.826019,608.654846 
	C422.163574,610.311340 422.977112,612.466736 422.512512,612.791077 
	C417.472900,616.309082 412.264496,619.592651 406.996674,622.765076 
	C406.482178,623.074951 405.264343,622.217041 404.372955,621.901245 
	C404.417816,621.047058 404.462677,620.192871 405.065216,619.321228 
	C412.498779,620.391235 415.091064,614.146179 420.672668,611.453857 
	C417.530518,609.238831 415.256989,607.636108 412.983459,606.033386 
	C412.983459,606.033386 412.999329,605.997925 412.834595,605.706421 
	C411.535767,604.838745 410.401703,604.262512 409.267639,603.686279 
	C409.267639,603.686279 409.390564,603.537354 409.395264,603.440918 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M395.484619,631.639282 
	C390.803040,629.220398 386.528748,626.937439 382.107666,624.331787 
	C386.660156,625.525757 391.269104,627.796753 396.081116,628.373596 
	C402.495422,629.142578 409.167725,629.286682 415.536713,628.366821 
	C419.745117,627.758911 423.548431,623.565308 427.660431,623.344116 
	C430.427582,623.195312 434.457245,619.400024 437.014282,624.524170 
	C435.340088,625.004272 433.648071,625.120605 431.256470,625.222778 
	C430.033112,625.449036 429.509308,625.689453 428.985474,625.929810 
	C428.565491,625.999146 428.145508,626.068542 427.121094,626.166138 
	C425.855743,626.623352 425.194763,627.052368 424.533813,627.481445 
	C421.601624,628.970703 418.669403,630.459961 415.381195,632.043823 
	C412.634491,632.295349 410.237976,632.640564 407.854401,632.566956 
	C403.862549,632.443665 399.878998,632.053162 395.484619,631.639282 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M404.005585,621.946716 
	C405.264343,622.217041 406.482178,623.074951 406.996674,622.765076 
	C412.264496,619.592651 417.472900,616.309082 422.512512,612.791077 
	C422.977112,612.466736 422.163574,610.311340 421.852631,608.669128 
	C423.135986,609.309753 425.611511,610.254456 425.641968,611.272339 
	C425.695831,613.071655 424.755371,615.602112 423.355316,616.609741 
	C419.444397,619.424622 415.257904,622.022034 410.838989,623.904297 
	C408.144867,625.051941 404.820435,624.719788 401.779114,625.052307 
	C401.673981,624.516846 401.568848,623.981384 401.463745,623.445862 
	C402.188568,622.961304 402.913391,622.476746 404.005585,621.946716 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M413.020447,606.377136 
	C415.256989,607.636108 417.530518,609.238831 420.672668,611.453857 
	C415.091064,614.146179 412.498779,620.391235 405.321594,619.115417 
	C408.187134,616.695435 411.356415,614.467285 414.517609,612.227722 
	C414.907196,611.951660 415.253387,611.614380 415.846161,611.114502 
	C414.910217,609.639893 413.983856,608.180420 413.020447,606.377136 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M418.579224,606.148865 
	C417.460693,605.350586 416.342163,604.552368 415.086182,603.138123 
	C414.947510,602.033264 414.946289,601.544434 414.961426,601.039185 
	C414.977783,601.022766 415.010498,600.989929 415.010498,600.989929 
	C417.794525,602.640869 422.174011,602.610474 421.763611,607.910583 
	C421.172821,608.133423 420.696564,607.952637 419.955780,607.253662 
	C419.320557,606.539917 418.949890,606.344421 418.579224,606.148865 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M412.028534,600.985901 
	C411.388550,600.523987 410.748566,600.062012 409.922974,599.360474 
	C411.217712,598.741821 412.698059,598.362793 414.561676,597.970825 
	C414.963043,598.716309 414.981140,599.474731 415.004883,600.611572 
	C415.010498,600.989929 414.977783,601.022766 414.598083,601.025879 
	C413.488403,601.014648 412.758484,601.000244 412.028534,600.985901 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M409.300903,604.046204 
	C410.401703,604.262512 411.535767,604.838745 412.817932,605.716553 
	C411.755402,605.480835 410.544769,604.943481 409.300903,604.046204 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M441.175537,638.070129 
	C440.623352,638.249390 439.870300,638.207642 438.937683,637.919739 
	C439.496979,637.732117 440.235840,637.790649 441.175537,638.070129 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M433.135101,631.291260 
	C433.535492,630.786560 434.105560,630.488831 435.011292,630.299438 
	C434.666229,630.771118 433.985504,631.134644 433.135101,631.291260 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M429.122803,626.152222 
	C429.509308,625.689453 430.033112,625.449036 430.844360,625.317078 
	C430.507904,625.741943 429.884033,626.058289 429.122803,626.152222 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M424.851410,627.600708 
	C425.194763,627.052368 425.855743,626.623352 426.821228,626.277710 
	C426.473511,626.814087 425.821259,627.267090 424.851410,627.600708 
z"
      />
      <path
        fill="#E6DEB1"
        opacity="1.000000"
        stroke="none"
        d="
M402.268860,325.606384 
	C401.912537,324.374756 401.943542,323.174561 402.277405,321.794678 
	C407.841248,324.672760 413.102295,327.730499 418.672180,330.926636 
	C424.017761,335.618347 429.054504,340.171692 433.975983,344.620880 
	C432.314514,347.617432 425.987946,343.250397 427.851685,349.799561 
	C428.263306,350.635071 428.313660,351.324646 428.268372,352.658783 
	C427.570068,353.790192 426.967438,354.277100 426.364807,354.763977 
	C425.649078,348.912445 422.788849,344.390167 418.352112,340.512329 
	C412.929260,335.772552 407.871765,330.614777 402.268860,325.606384 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M398.147339,342.053833 
	C400.740631,345.284393 402.908600,348.454987 405.367584,352.051208 
	C403.714539,352.612427 402.692871,352.959290 401.201477,353.476532 
	C396.964478,349.636902 393.197205,345.626892 389.429901,341.616913 
	C389.788818,341.125000 390.147736,340.633118 390.506622,340.141235 
	C392.911774,340.758759 395.316925,341.376282 398.147339,342.053833 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M426.284180,355.158844 
	C426.967438,354.277100 427.570068,353.790192 428.320068,353.001099 
	C429.707947,358.543671 430.948425,364.388458 432.188904,370.233276 
	C431.655518,370.370026 431.122131,370.506805 430.588745,370.643555 
	C429.127014,365.613617 427.665253,360.583679 426.284180,355.158844 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M415.777710,373.640381 
	C415.628540,371.344421 415.553558,369.374939 415.721497,367.207153 
	C417.665009,370.684265 419.365570,374.359650 421.066132,378.035065 
	C420.659546,378.311920 420.252960,378.588776 419.846375,378.865631 
	C418.514893,377.232727 417.183441,375.599823 415.777710,373.640381 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M560.440063,656.544189 
	C560.412476,656.494080 560.467590,656.594299 560.440063,656.544189 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M539.108154,675.158386 
	C539.785950,675.147156 540.463745,675.135986 541.476318,675.165344 
	C542.691772,676.117859 543.493591,677.715332 544.466187,677.827148 
	C549.647278,678.422546 554.871094,678.646179 560.526855,679.011841 
	C559.453918,679.642700 557.902466,680.857178 556.419800,680.778320 
	C548.403625,680.352295 540.396606,679.685242 532.406433,678.899109 
	C530.921631,678.752930 529.527771,677.683105 528.091614,676.655151 
	C528.787903,676.210327 529.484436,676.150024 530.653259,676.473083 
	C534.103149,677.779541 537.442261,680.401794 539.108154,675.158386 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M525.224976,677.058899 
	C525.468994,676.652588 525.956421,676.359924 526.744385,676.081177 
	C526.519348,676.454224 525.993835,676.813416 525.224976,677.058899 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M489.610107,551.322021 
	C489.500671,550.366028 489.723816,549.364746 489.946960,548.363464 
	C490.880066,548.765076 491.813202,549.166687 492.891357,549.910583 
	C492.005157,550.594177 490.973938,550.935425 489.610107,551.322021 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M563.681030,563.878052 
	C562.654297,570.343079 560.190857,576.020935 554.360840,579.976196 
	C556.424988,574.677979 558.805603,569.327820 561.318542,564.040588 
	C561.482483,563.695557 562.662170,563.833313 563.681030,563.878052 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M564.746460,553.196350 
	C565.337463,553.773254 565.672119,554.548218 566.003357,555.661621 
	C565.496704,555.131470 564.993469,554.263000 564.746460,553.196350 
z"
      />
      <path
        fill="#1A1F1C"
        opacity="1.000000"
        stroke="none"
        d="
M482.834808,498.985199 
	C482.578583,498.545563 482.322327,498.105896 482.010254,497.136139 
	C482.023743,496.217621 482.093109,495.829224 482.162476,495.440826 
	C482.043762,493.619385 481.925049,491.797913 481.794647,489.796539 
	C482.268951,490.104950 482.874359,490.498596 484.049988,491.246521 
	C497.729401,493.555878 510.831177,495.564606 523.959839,497.378906 
	C525.207886,497.551392 526.624023,496.506714 527.973267,496.382843 
	C529.695679,496.503479 531.407043,496.268372 533.541260,496.090698 
	C535.560852,496.148102 537.157532,496.148102 538.990662,496.148102 
	C539.298706,498.862549 539.571655,501.267609 539.595337,503.695618 
	C539.203247,503.804779 539.060425,503.891022 538.607788,504.172668 
	C538.255859,505.103760 538.213806,505.839447 537.774414,506.509003 
	C533.170044,506.790192 528.966614,507.346405 524.754761,507.420288 
	C521.226013,507.482239 517.687378,506.980927 513.804016,506.505371 
	C508.309906,505.281616 503.164825,504.281525 498.019775,503.281403 
	C493.512115,502.615601 489.004486,501.949768 484.149841,500.921783 
	C483.480194,500.034790 483.157501,499.510010 482.834808,498.985199 
M498.701263,498.983856 
	C505.900879,500.257050 513.100464,501.530243 520.300110,502.803406 
	C520.370789,502.309540 520.441528,501.815704 520.512207,501.321838 
	C511.708923,499.814301 502.905670,498.306763 494.102386,496.799225 
	C494.035004,497.086761 493.967621,497.374268 493.900269,497.661804 
	C495.232513,498.089142 496.564789,498.516479 498.701263,498.983856 
M486.480713,496.620361 
	C487.960083,496.740753 489.439423,496.861176 490.918793,496.981567 
	C490.906433,496.541626 490.894073,496.101654 490.881683,495.661713 
	C489.235474,495.845520 487.589264,496.029358 486.480713,496.620361 
M531.158447,501.053040 
	C530.310730,501.404144 529.463013,501.755280 528.615356,502.106415 
	C528.872009,502.508484 529.128662,502.910583 529.385315,503.312653 
	C530.183228,502.583588 530.981201,501.854553 531.158447,501.053040 
M524.337646,502.663544 
	C524.572021,502.965210 524.806396,503.266846 525.040710,503.568451 
	C525.236450,503.386230 525.432190,503.204010 525.627930,503.021851 
	C525.328796,502.786469 525.029663,502.551117 524.337646,502.663544 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M514.153076,506.729034 
	C517.687378,506.980927 521.226013,507.482239 524.754761,507.420288 
	C528.966614,507.346405 533.170044,506.790192 537.888672,506.789917 
	C541.940491,509.421173 545.480652,511.705414 548.853455,514.230713 
	C548.135376,514.631104 547.584717,514.790466 546.853760,514.717285 
	C546.058228,514.392761 545.443054,514.300842 544.827881,514.208862 
	C544.801880,514.420349 544.775818,514.631897 544.749817,514.843445 
	C545.481140,514.915039 546.212524,514.986694 547.182861,515.322815 
	C550.000305,516.364258 552.578613,517.141174 555.460693,518.055786 
	C557.512390,519.121704 559.260315,520.050049 560.967163,521.320557 
	C557.590149,521.472351 554.254272,521.281860 550.918396,521.091431 
	C550.918396,521.091431 550.948608,521.085754 550.773315,520.786865 
	C549.743469,520.316345 548.888855,520.144775 548.034241,519.973206 
	C538.667603,516.943787 529.303101,513.907776 519.932617,510.890259 
	C517.906921,510.237946 515.859619,509.652466 513.507751,508.758789 
	C513.513184,507.897308 513.833130,507.313171 514.153076,506.729034 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M550.845703,521.348450 
	C554.254272,521.281860 557.590149,521.472351 561.330566,521.286621 
	C563.113953,521.317017 564.492798,521.723633 565.871582,522.130249 
	C571.687805,525.018250 577.503967,527.906250 583.640076,530.928162 
	C585.214783,532.164001 586.469543,533.265930 587.739868,534.890259 
	C587.200806,535.595459 586.646118,535.778320 586.091492,535.961182 
	C584.038696,534.938232 581.985901,533.915283 579.460938,532.498230 
	C574.219849,529.884644 569.486633,527.578308 564.625061,525.584839 
	C564.157471,525.393127 562.892334,527.146362 561.633484,527.999878 
	C557.726196,526.042969 554.182922,524.082886 550.639587,522.122803 
	C550.684082,521.950378 550.728516,521.777893 550.845703,521.348450 
M560.631042,524.514648 
	C560.631042,524.514648 560.488525,524.596191 560.631042,524.514648 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M550.295288,522.101196 
	C554.182922,524.082886 557.726196,526.042969 561.824219,528.278564 
	C564.896118,530.036987 567.413391,531.519958 569.975281,533.341553 
	C571.345093,535.457275 572.670227,537.234375 573.995422,539.011414 
	C570.574463,537.082886 567.190918,535.083740 563.721130,533.247498 
	C560.770508,531.685913 559.104187,527.308228 554.251648,529.087952 
	C553.871155,529.141968 553.896973,529.091309 553.907471,528.775635 
	C553.527405,528.112305 553.136841,527.764526 552.746277,527.416809 
	C552.504822,527.928162 552.263428,528.439453 552.022034,528.950806 
	C551.422729,528.540222 550.823486,528.129639 550.086182,527.149536 
	C549.280334,526.406738 548.612366,526.233459 547.944458,526.060120 
	C547.063843,525.597168 546.183228,525.134216 545.161682,524.110535 
	C545.047546,523.341125 545.074402,523.132324 545.101257,522.923462 
	C546.717834,522.642151 548.334473,522.360840 550.295288,522.101196 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M482.507599,498.910889 
	C483.157501,499.510010 483.480194,500.034790 483.747894,500.899292 
	C482.053528,500.866974 480.414154,500.494965 478.417725,500.043152 
	C476.933075,498.773743 476.008057,497.219513 474.641357,496.460236 
	C469.817017,493.779907 470.400452,490.078918 472.389374,484.999176 
	C473.928864,491.537598 476.284973,496.554016 482.507599,498.910889 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M513.804016,506.505371 
	C513.833130,507.313171 513.513184,507.897308 513.126770,508.726471 
	C508.104553,507.298340 503.148834,505.625183 498.106445,503.616699 
	C503.164825,504.281525 508.309906,505.281616 513.804016,506.505371 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M542.996887,523.000793 
	C541.182251,522.112854 539.367676,521.224915 537.246521,520.191040 
	C538.922913,520.430054 540.905884,520.815002 542.945068,521.821655 
	C542.999878,522.629150 542.998413,522.814941 542.996887,523.000793 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M543.244751,523.143433 
	C542.998413,522.814941 542.999878,522.629150 543.006042,522.163208 
	C543.576416,522.076538 544.142151,522.270020 544.904541,522.693481 
	C545.074402,523.132324 545.047546,523.341125 544.990601,523.865540 
	C544.471130,523.882874 543.981812,523.584473 543.244751,523.143433 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M548.211365,520.252930 
	C548.888855,520.144775 549.743469,520.316345 550.764404,520.775513 
	C550.083313,520.886292 549.235901,520.709473 548.211365,520.252930 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M522.017822,514.773438 
	C521.896179,514.593689 521.954346,514.413391 522.012451,514.233032 
	C522.074158,514.412964 522.135864,514.592896 522.017822,514.773438 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M524.572510,515.458557 
	C524.621643,515.528198 524.426392,515.546509 524.426392,515.546509 
	C524.426392,515.546509 524.523315,515.388916 524.572510,515.458557 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M548.141235,526.282410 
	C548.612366,526.233459 549.280334,526.406738 549.953735,526.903442 
	C549.418823,526.986084 548.878357,526.745422 548.141235,526.282410 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M552.339722,529.022034 
	C552.263428,528.439453 552.504822,527.928162 552.746277,527.416809 
	C553.136841,527.764526 553.527405,528.112305 553.933716,528.764648 
	C553.518738,529.077271 553.088135,529.085266 552.339722,529.022034 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M610.683838,291.629822 
	C610.994385,293.224762 611.001038,294.608337 611.002380,296.404602 
	C605.310425,299.220673 603.966064,298.287720 604.189453,291.632874 
	C606.307678,291.292511 608.343811,291.355469 610.683838,291.629822 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M629.942810,536.682861 
	C626.063171,534.563293 622.161255,532.087585 618.084656,529.319458 
	C622.740662,530.099304 627.341125,531.550354 629.942810,536.682861 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M616.945801,528.648682 
	C616.082336,528.525757 615.164612,528.053955 614.083008,527.303833 
	C614.909912,527.450256 615.900818,527.875000 616.945801,528.648682 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M667.815369,328.924438 
	C668.540527,328.140381 669.265686,327.356384 670.160767,326.269958 
	C670.735413,325.708069 671.140015,325.448669 672.049194,325.083557 
	C672.743164,324.660950 672.932556,324.344055 673.121948,324.027161 
	C674.606567,323.301544 676.151794,322.677124 677.564697,321.831665 
	C682.177673,319.071350 686.429565,316.198730 686.483765,309.809326 
	C686.523010,305.176422 689.371887,302.196960 693.336792,299.647034 
	C700.163269,295.256744 706.512146,290.128754 713.149902,285.435455 
	C714.337952,284.595490 715.952881,284.359467 717.655762,283.982819 
	C717.632324,284.558228 717.323792,284.995361 716.892212,285.678101 
	C709.887573,292.432770 702.865112,298.803070 696.221252,305.546326 
	C694.512939,307.280182 694.164673,310.283569 692.893433,312.535431 
	C691.087585,315.734039 689.492554,319.275452 686.933044,321.774963 
	C682.565247,326.040344 677.518188,329.610107 672.256042,333.743652 
	C671.283630,334.300110 670.811646,334.584961 670.339661,334.869781 
	C670.959412,334.903809 671.579224,334.937866 672.198975,334.971924 
	C671.813293,336.725739 671.427673,338.479553 671.041992,340.616913 
	C670.652222,341.900543 670.262451,342.800690 669.245361,343.830902 
	C665.549255,339.613403 666.398804,335.619263 672.262146,328.528259 
	C670.429565,328.691528 669.122498,328.807983 667.815369,328.924438 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M684.050415,354.427002 
	C682.237061,356.598267 679.912659,358.246857 679.017212,360.470825 
	C676.235779,367.378998 673.996826,374.505585 671.003784,381.808197 
	C669.999207,382.041565 669.538330,382.014160 669.077393,381.986755 
	C671.308350,374.067352 673.121826,365.992859 675.977539,358.305573 
	C677.106812,355.265656 680.439758,352.964325 682.995483,350.567871 
	C684.291809,349.352386 686.090637,348.672791 687.868958,347.489594 
	C688.938171,347.228271 689.800598,347.228271 691.228088,347.228271 
	C690.027405,348.873962 689.206970,349.998505 687.954834,351.409973 
	C687.342163,351.778290 687.161133,351.859711 686.980103,351.941132 
	C686.051086,352.683289 685.122070,353.425415 684.050415,354.427002 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M703.990540,317.623840 
	C701.527771,320.706848 699.220032,323.487396 696.764282,326.587463 
	C694.763855,328.664398 692.911438,330.421814 691.058960,332.179230 
	C695.051147,322.821411 701.131653,315.280579 708.560547,308.845551 
	C708.952698,309.135895 709.344788,309.426270 709.736877,309.716644 
	C707.873108,312.251556 706.009338,314.786438 703.990540,317.623840 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M672.299316,334.734406 
	C671.579224,334.937866 670.959412,334.903809 670.339661,334.869781 
	C670.811646,334.584961 671.283630,334.300110 672.070068,333.998383 
	C672.389526,334.153290 672.394531,334.325104 672.299316,334.734406 
z"
      />
      <path
        fill="#8F5122"
        opacity="1.000000"
        stroke="none"
        d="
M687.101196,352.126648 
	C687.161133,351.859711 687.342163,351.778290 687.822449,351.687592 
	C687.821960,351.889618 687.522156,352.100891 687.101196,352.126648 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M672.879517,324.122131 
	C672.932556,324.344055 672.743164,324.660950 672.275391,324.997070 
	C672.210388,324.749878 672.423706,324.483459 672.879517,324.122131 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M624.903687,473.052185 
	C624.382446,473.564301 623.861267,474.076477 622.701050,474.775452 
	C618.309753,475.507874 614.561157,476.080475 610.804443,476.593872 
	C599.875305,478.087311 588.942932,479.557129 578.011780,481.036163 
	C575.459595,480.040863 570.998291,481.698853 572.233032,476.155182 
	C576.152710,476.154175 579.390625,476.385803 583.068604,476.707123 
	C591.852783,475.810272 600.219177,474.976013 608.529785,473.760803 
	C611.768555,473.287201 614.881958,471.955688 618.419800,471.008575 
	C620.826050,471.685547 622.864868,472.368866 624.903687,473.052185 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M578.078613,481.422974 
	C588.942932,479.557129 599.875305,478.087311 610.804443,476.593872 
	C614.561157,476.080475 618.309753,475.507874 622.482544,474.960999 
	C622.934875,475.417603 622.966858,475.875488 623.003479,476.677979 
	C617.190552,477.961334 611.383057,478.969147 605.552856,479.821533 
	C598.078003,480.914337 590.596008,481.980530 583.090820,482.824615 
	C581.500549,483.003479 579.796936,482.174438 578.078613,481.422974 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M582.628540,476.617432 
	C579.390625,476.385803 576.152710,476.154175 572.513916,475.945038 
	C572.112976,475.967529 571.988892,475.616302 571.969727,475.071899 
	C571.970642,474.033142 571.990662,473.538788 572.372192,472.986176 
	C574.782898,472.268158 576.832153,471.608398 579.092834,471.205231 
	C580.135193,471.630463 580.966187,471.799103 581.697754,472.258881 
	C581.941833,473.905823 582.285156,475.261627 582.628540,476.617432 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M644.854248,480.530762 
	C638.787720,481.554596 632.674377,482.202423 626.124023,482.794373 
	C626.071228,481.992432 626.455322,481.246277 626.998291,480.221069 
	C631.721313,479.654724 636.282715,479.271515 640.851257,479.140747 
	C642.159241,479.103302 643.488159,479.796539 644.854248,480.530762 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M572.010742,473.044434 
	C571.990662,473.538788 571.970642,474.033142 571.907471,474.896393 
	C571.483582,475.263428 571.102844,475.261566 570.439453,475.208984 
	C566.716675,476.092316 563.276489,477.026306 559.420471,477.975037 
	C559.004639,477.989746 558.985962,477.891846 559.037109,477.542175 
	C563.395691,475.809845 567.703247,474.427124 572.010742,473.044434 
z"
      />
      <path
        fill="#DCECD5"
        opacity="1.000000"
        stroke="none"
        d="
M547.595398,489.118835 
	C546.193726,496.554749 548.923035,501.108734 558.342529,506.615417 
	C559.527100,508.025330 560.230164,509.067535 561.381836,510.774902 
	C559.424133,510.437195 558.231384,510.231445 556.776001,510.004364 
	C556.338135,509.988525 556.162842,509.993988 555.860352,509.676056 
	C549.708130,504.991180 540.554688,502.781952 543.915588,491.724609 
	C543.725647,490.640930 543.436890,489.863953 543.587280,489.065369 
	C545.216064,489.068787 546.405762,489.093811 547.595398,489.118835 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M557.038574,510.025696 
	C558.231384,510.231445 559.424133,510.437195 561.381836,510.774902 
	C560.230164,509.067535 559.527100,508.025330 558.675049,506.692932 
	C558.816528,506.304932 559.107178,506.207092 559.852051,506.017090 
	C563.087097,507.325867 565.867798,508.726776 568.819763,510.736328 
	C568.981079,511.577057 568.971191,511.809174 568.633179,512.003357 
	C567.217834,512.272583 566.130737,512.579651 564.955933,513.261108 
	C564.801880,513.882874 564.735474,514.130432 564.338501,514.245422 
	C561.684875,512.750488 559.361755,511.388092 557.038574,510.025696 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M547.871826,488.996704 
	C546.405762,489.093811 545.216064,489.068787 543.664551,488.734192 
	C545.220886,486.449493 546.867554,484.051514 549.123779,482.602783 
	C552.165466,480.649750 555.676392,479.427643 558.985962,477.891846 
	C558.985962,477.891846 559.004639,477.989746 559.049377,478.013489 
	C555.445496,481.649689 551.796875,485.262146 547.871826,488.996704 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M555.077393,495.183380 
	C555.040100,496.750153 555.000854,497.952423 554.948242,499.598450 
	C549.588013,497.002289 549.702209,491.988037 555.604248,488.000183 
	C555.999512,487.992920 556.089050,488.073944 556.089050,488.073944 
	C555.751160,490.322235 555.413269,492.570557 555.077393,495.183380 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M556.935486,486.946686 
	C557.072266,486.937653 557.209045,486.928589 557.170898,486.959778 
	C556.995911,487.000031 556.935486,486.946686 556.935486,486.946686 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M555.958984,487.948120 
	C556.032471,487.590607 556.225952,487.339111 556.717224,487.047729 
	C556.935486,486.946686 556.995911,487.000031 557.023621,487.030823 
	C556.956177,487.381042 556.775696,487.641235 556.299438,487.958069 
	C556.089050,488.073944 555.999512,487.992920 555.958984,487.948120 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M568.961304,512.041260 
	C568.971191,511.809174 568.981079,511.577057 569.023804,510.994659 
	C569.610474,510.899567 570.164368,511.154785 570.902710,511.652039 
	C571.087158,511.894043 570.981445,512.015991 570.610596,512.071167 
	C569.813538,512.097961 569.387451,512.069641 568.961304,512.041260 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M564.669006,514.377991 
	C564.735474,514.130432 564.801880,513.882874 565.263428,513.322266 
	C566.440613,513.634399 567.222656,514.259705 568.100769,515.130859 
	C568.477661,515.575562 568.758545,515.774536 569.038086,515.946777 
	C569.036743,515.920166 569.081848,515.891113 569.081848,515.891113 
	C568.637329,516.729492 568.186157,517.564331 567.750000,518.407043 
	C567.208313,519.453552 566.679016,520.506531 566.007935,521.843506 
	C564.492798,521.723633 563.113953,521.317017 561.371704,520.944336 
	C559.260315,520.050049 557.512390,519.121704 555.377686,517.738525 
	C553.627502,516.243408 552.264099,515.203125 551.083618,513.874146 
	C551.895752,513.331421 552.524780,513.077454 553.540894,512.856201 
	C556.564697,513.724609 559.170166,514.696899 561.857178,515.314087 
	C562.679382,515.502991 563.725464,514.717346 564.669006,514.377991 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M568.004761,514.885010 
	C567.222656,514.259705 566.440613,513.634399 565.351074,512.947937 
	C566.130737,512.579651 567.217834,512.272583 568.633179,512.003357 
	C569.387451,512.069641 569.813538,512.097961 570.556641,512.131165 
	C573.648071,514.082031 576.422546,516.028076 579.567383,518.252625 
	C579.937683,518.531128 579.980835,518.978149 579.980835,518.978149 
	C576.599670,517.945618 573.218445,516.913086 569.459595,515.885803 
	C569.081848,515.891113 569.036743,515.920166 568.960693,515.693604 
	C568.591370,515.273010 568.298035,515.078979 568.004761,514.885010 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M580.033752,519.328308 
	C579.980835,518.978149 579.937683,518.531128 579.917358,518.308228 
	C582.988098,519.782898 586.079224,521.480347 589.170288,523.177795 
	C588.855469,523.716614 588.540649,524.255493 588.225769,524.794312 
	C585.512756,523.089050 582.799744,521.383728 580.033752,519.328308 
z"
      />
      <path
        fill="#394746"
        opacity="1.000000"
        stroke="none"
        d="
M473.201599,294.057556 
	C473.152802,293.829926 473.278229,293.448578 473.639618,293.105591 
	C473.780182,293.444061 473.613617,293.697357 473.201599,294.057556 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M725.069641,592.102661 
	C726.788452,591.770508 728.507324,591.438416 730.598938,591.117920 
	C726.028748,593.085632 721.217285,595.568665 716.104553,596.844360 
	C711.337097,598.033936 706.249390,597.939697 700.686462,598.733276 
	C699.121094,598.954651 698.169373,598.746887 697.223083,598.769470 
	C691.860657,598.897034 686.499451,599.079895 680.756836,599.164185 
	C679.600952,599.165894 678.826233,599.247253 678.034790,598.984497 
	C678.005066,598.411011 677.992065,598.181641 677.979126,597.952332 
	C683.446716,593.949768 688.914368,589.947205 694.754944,586.006287 
	C695.127869,586.067871 695.096558,586.057190 695.075256,586.417236 
	C694.353027,587.617676 693.652100,588.458008 692.590698,589.730469 
	C703.441101,594.716919 714.096313,595.342712 725.069641,592.102661 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M753.603149,559.969727 
	C753.976807,560.144348 753.995239,560.314148 754.003540,560.739868 
	C743.425354,565.909546 732.757690,568.997864 721.178955,562.686523 
	C721.909973,561.717957 723.042847,560.830078 724.602905,559.982910 
	C725.030029,560.023499 725.225037,560.187195 725.261597,560.546509 
	C731.728088,563.803650 738.338501,563.616150 745.400452,562.066528 
	C747.559631,561.466309 749.347351,560.859436 751.135071,560.252563 
	C751.839355,560.156677 752.543701,560.060791 753.603149,559.969727 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M710.069458,578.937378 
	C708.515869,578.454895 706.962219,577.972412 705.174561,577.224976 
	C706.720581,575.360901 708.500488,573.761780 710.559570,571.988159 
	C711.480957,572.245605 712.123169,572.677551 713.153076,573.235840 
	C712.460754,574.063232 711.380798,574.764221 709.834900,575.852051 
	C709.602478,577.138428 709.835999,578.037903 710.069458,578.937378 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M675.550293,620.984253 
	C676.498535,626.736023 672.714905,625.064697 669.365845,624.093384 
	C671.847839,624.406799 673.989258,623.840271 675.550293,620.984253 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M669.187500,623.273804 
	C667.542053,622.592834 665.819824,621.604675 664.088013,620.254272 
	C665.755859,620.916931 667.433350,621.941772 669.187500,623.273804 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M662.501709,606.157898 
	C662.923279,605.493774 663.650879,604.774719 664.753174,604.093628 
	C664.354553,604.788757 663.581177,605.445862 662.501709,606.157898 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M675.932800,602.995972 
	C675.061157,602.805420 674.189514,602.614868 673.113953,602.148315 
	C673.434082,601.580566 673.958069,601.288818 674.845703,601.106262 
	C675.209290,601.215393 675.309326,601.317383 675.311646,601.341431 
	C675.313904,601.365540 675.252136,601.360657 675.465332,601.751587 
	C675.763306,602.426941 675.848022,602.711426 675.932800,602.995972 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M663.922974,619.648071 
	C663.095764,619.461243 662.106445,619.003052 661.094971,618.177246 
	C661.968872,618.331970 662.864868,618.854370 663.922974,619.648071 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M660.341797,608.049194 
	C660.532776,607.490967 660.999939,606.817261 661.816040,606.163696 
	C661.649353,606.767151 661.133667,607.350525 660.341797,608.049194 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M677.697266,598.047607 
	C677.992065,598.181641 678.005066,598.411011 677.870605,599.204712 
	C677.201294,599.920349 676.679565,600.071594 676.103271,600.150146 
	C676.048767,600.077454 675.934143,599.936401 675.934143,599.936401 
	C676.427917,599.338562 676.921692,598.740723 677.697266,598.047607 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M725.609863,557.089844 
	C725.895264,557.458618 725.937256,558.052917 725.916626,559.244141 
	C725.667236,559.998047 725.457642,560.113464 725.225037,560.187195 
	C725.225037,560.187195 725.030029,560.023499 724.929443,559.939941 
	C725.007996,559.009399 725.187195,558.162415 725.609863,557.089844 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M657.391846,610.277954 
	C657.502869,609.932129 657.896851,609.487244 658.607666,609.001099 
	C658.507996,609.366211 658.091370,609.772522 657.391846,610.277954 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M719.939087,555.366211 
	C720.251648,555.304871 720.491455,555.613586 720.669312,556.229980 
	C720.607300,556.537598 720.292542,556.611511 720.145020,556.545227 
	C719.953857,556.231384 719.910156,555.983826 719.939087,555.366211 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M675.158447,601.165161 
	C675.222839,600.796082 675.338074,600.477234 675.693726,600.047424 
	C675.934143,599.936401 676.048767,600.077454 675.912842,600.448120 
	C675.606567,600.982910 675.436279,601.146973 675.286011,601.292175 
	C675.306152,601.273376 675.309326,601.317383 675.309326,601.317383 
	C675.309326,601.317383 675.209290,601.215393 675.158447,601.165161 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M658.067200,615.704407 
	C657.886841,615.768005 657.565613,615.601013 657.130127,615.180176 
	C657.319336,615.108765 657.622864,615.291260 658.067200,615.704407 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M720.617615,549.095825 
	C720.847229,549.141357 720.900085,549.315613 720.892700,549.756042 
	C720.832336,550.022156 720.438965,549.997803 720.242310,549.997803 
	C720.113770,549.707520 720.245483,549.449768 720.617615,549.095825 
z"
      />
      <path
        fill="#A67643"
        opacity="1.000000"
        stroke="none"
        d="
M718.021606,522.485352 
	C718.528992,523.239136 719.026306,524.444641 719.766541,525.834717 
	C719.591431,527.048950 719.173279,528.078674 718.438599,529.271362 
	C718.085144,527.268616 718.048279,525.102905 718.021606,522.485352 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M621.096924,462.498352 
	C620.788025,463.074005 620.518555,463.274109 620.138428,463.717224 
	C620.027832,463.960236 620.029236,463.981171 619.701111,463.829010 
	C614.234009,459.711212 608.575989,462.118744 603.155701,462.518311 
	C596.441650,463.013275 589.763000,463.987823 583.054932,464.356842 
	C583.669556,462.987518 584.177734,461.285797 584.945862,461.159027 
	C592.252991,459.952881 599.614075,459.076904 606.934265,457.942688 
	C608.321838,457.727692 609.597961,456.793396 611.395752,456.135437 
	C619.800903,455.726990 627.733582,455.292023 635.672241,455.076477 
	C637.764709,455.019684 639.875488,455.640991 641.977905,455.950928 
	C642.282776,458.868103 640.421021,458.942413 638.242737,459.039368 
	C633.683411,459.242279 629.119019,459.547302 624.591309,460.096069 
	C623.375671,460.243408 622.284607,461.419159 621.096924,462.498352 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M642.394775,455.901459 
	C639.875488,455.640991 637.764709,455.019684 635.672241,455.076477 
	C627.733582,455.292023 619.800903,455.726990 611.009216,456.089050 
	C608.130615,456.373840 606.108826,456.649506 603.885864,456.693909 
	C602.836060,455.998566 601.987366,455.534485 601.569702,455.074615 
	C604.665527,454.708588 607.330261,454.338318 610.446838,454.014587 
	C614.056702,454.109711 617.223389,454.305756 620.367615,454.120514 
	C621.359192,454.062073 622.290649,452.982330 623.698975,452.326630 
	C629.769592,452.160767 635.390930,452.038330 640.989868,452.304077 
	C642.612427,453.031342 644.257324,453.370422 646.298889,453.797791 
	C647.497192,453.815277 648.298889,453.744537 649.397400,453.743134 
	C650.095398,453.766113 650.496460,453.719788 651.286377,453.758759 
	C653.444031,453.557678 655.212952,453.271271 657.422180,453.007446 
	C660.594238,453.361786 663.325867,453.693604 666.057556,454.025391 
	C662.041992,454.346344 658.026672,454.671295 654.010681,454.987000 
	C650.278137,455.280487 646.544678,455.564056 642.394775,455.901459 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M666.485107,454.029114 
	C663.325867,453.693604 660.594238,453.361786 657.394409,452.689880 
	C656.556946,451.870605 656.187561,451.391418 655.944702,450.734985 
	C656.071228,450.557709 656.375916,450.246429 656.697998,450.244202 
	C657.654785,450.149780 658.289551,450.057617 658.924255,449.965454 
	C667.346313,447.976379 675.768433,445.987305 684.593262,444.003662 
	C679.283325,446.281006 673.570618,448.552856 667.857971,450.824707 
	C676.513977,450.978455 684.288696,447.223694 692.413086,444.715668 
	C684.717407,450.058472 676.484741,453.852936 666.485107,454.029114 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M696.968262,443.974243 
	C699.229187,440.917786 697.352661,437.856140 696.988953,434.398041 
	C696.998108,433.999725 697.028076,433.964539 697.028076,433.964539 
	C698.922058,435.967468 700.816040,437.970398 702.710083,439.973297 
	C701.060730,441.324097 699.411316,442.674896 697.381226,444.013916 
	C697.000488,444.002106 696.968262,443.974243 696.968262,443.974243 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M686.783691,437.675323 
	C684.653259,436.885010 682.381287,435.792725 680.060791,434.354492 
	C682.222229,435.130157 684.432190,436.251770 686.783691,437.675323 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M685.349915,443.964600 
	C685.784424,443.022766 686.558655,442.045807 687.674927,441.036865 
	C687.241272,441.979736 686.465454,442.954590 685.349915,443.964600 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M696.980591,434.014801 
	C696.840942,433.865814 696.718872,433.701721 696.596863,433.537659 
	C696.697632,433.582947 696.798340,433.628235 696.963623,433.819031 
	C697.028076,433.964539 696.998108,433.999725 696.980591,434.014801 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M694.459656,443.445770 
	C694.518921,443.409821 694.400391,443.481720 694.459656,443.445770 
z"
      />
      <path
        fill="#2C9583"
        opacity="1.000000"
        stroke="none"
        d="
M697.014160,444.018433 
	C696.914124,444.057068 696.800354,444.079346 696.827393,444.037903 
	C696.968262,443.974243 697.000488,444.002106 697.014160,444.018433 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M658.920776,449.634521 
	C658.289551,450.057617 657.654785,450.149780 656.572754,449.883759 
	C655.344971,449.030701 654.564514,448.535797 653.814819,447.772705 
	C653.905457,447.334778 653.965393,447.165039 654.025269,446.995300 
	C654.760864,446.966888 655.496399,446.938477 656.593689,446.838562 
	C657.609375,447.612610 658.263367,448.458099 658.920776,449.634521 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M625.256714,473.007324 
	C622.864868,472.368866 620.826050,471.685547 618.419922,470.778564 
	C618.052551,470.554901 618.088806,470.096008 618.451843,470.036560 
	C619.335876,468.974426 619.856812,467.971741 620.661743,466.967194 
	C621.322998,466.928864 621.700317,466.892395 622.077637,466.855957 
	C629.091919,466.586609 636.106262,466.317261 643.581299,466.085999 
	C644.035217,466.519562 644.028442,466.915039 644.030212,467.606354 
	C638.024902,468.228729 632.011047,468.555328 625.490784,468.909393 
	C626.949829,469.947296 627.914978,470.633850 628.936401,471.657898 
	C627.865051,472.317719 626.737427,472.640076 625.256714,473.007324 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M622.047363,466.543091 
	C621.700317,466.892395 621.322998,466.928864 620.584106,466.582397 
	C620.146973,465.948639 620.071289,465.697784 619.985840,465.202423 
	C619.967651,464.630920 619.985352,464.305328 620.029236,463.981171 
	C620.029236,463.981171 620.027832,463.960236 620.041138,463.950226 
	C620.589172,464.127777 621.123840,464.315338 621.824890,464.736084 
	C621.999878,465.389618 622.008484,465.809937 622.047363,466.543091 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M345.826233,531.518738 
	C346.760010,529.477234 347.702911,527.838196 348.572418,526.161133 
	C349.549896,524.275818 350.461121,522.356140 351.886108,520.328735 
	C352.706268,520.588135 353.041473,520.970337 353.376709,521.352478 
	C353.937744,523.652832 354.498779,525.953125 355.199768,528.635498 
	C354.454193,530.891968 353.603638,532.783875 352.672302,534.635193 
	C351.894440,536.181396 351.022064,537.680115 350.191559,539.199890 
	C349.671753,539.229919 349.151917,539.259949 348.632111,539.290039 
	C347.689087,536.828186 346.746033,534.366272 345.826233,531.518738 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M364.056641,538.551941 
	C362.615997,541.487854 361.130310,544.071411 359.334045,546.824219 
	C359.368927,541.724243 359.714417,536.454895 360.467743,531.196838 
	C361.920929,533.538574 362.966248,535.869080 364.056641,538.551941 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M362.168762,553.442871 
	C361.750854,553.833862 361.248199,553.906311 360.365509,553.998779 
	C359.497711,552.485718 359.009949,550.952576 358.744629,549.214966 
	C360.006073,550.381714 361.045074,551.752991 362.168762,553.442871 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M353.695679,521.178589 
	C353.041473,520.970337 352.706268,520.588135 352.138855,520.096924 
	C351.906647,519.987854 351.870209,519.504456 351.907227,519.265259 
	C352.634399,519.685608 353.324554,520.345154 353.695679,521.178589 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M351.447327,517.770386 
	C351.183746,517.816833 351.082123,517.675415 351.038635,517.358765 
	C351.318146,517.217529 351.488983,517.350586 351.447327,517.770386 
z"
      />
      <path
        fill="#F4D3A1"
        opacity="1.000000"
        stroke="none"
        d="
M667.528564,328.959778 
	C669.122498,328.807983 670.429565,328.691528 672.262146,328.528259 
	C666.398804,335.619263 665.549255,339.613403 669.053345,344.054016 
	C669.242432,345.690826 668.996277,347.234619 668.169495,348.896606 
	C665.777893,349.366089 663.966980,349.717316 661.763306,350.144745 
	C663.752197,352.836700 664.870667,354.350433 665.753784,356.122864 
	C665.159180,357.922913 664.799805,359.464355 664.440491,361.005768 
	C658.251465,371.578308 650.710144,380.828186 639.311707,386.761292 
	C638.365601,385.469513 637.615051,383.912933 636.787842,381.911255 
	C637.795044,380.613220 638.878845,379.760315 640.382996,378.544037 
	C645.751465,372.446838 650.771362,366.772430 655.600830,360.940369 
	C656.924255,359.342224 658.061096,357.381042 658.625549,355.399109 
	C661.076538,346.792969 663.284485,338.117615 665.580688,329.467407 
	C666.134399,329.309998 666.688110,329.152557 667.528564,328.959778 
z"
      />
      <path
        fill="#ECC490"
        opacity="1.000000"
        stroke="none"
        d="
M614.925415,408.239105 
	C615.293823,408.621857 615.184265,408.900787 614.863403,409.342468 
	C614.405457,409.731689 614.046204,409.913849 613.395630,410.177429 
	C613.589722,409.565765 614.074951,408.872681 614.925415,408.239105 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M389.408539,586.195496 
	C389.683380,586.316956 389.799561,586.717529 389.788391,586.926147 
	C389.116272,587.104187 388.455353,587.073547 387.462952,587.028992 
	C384.704834,586.096069 382.278198,585.177063 379.630676,583.988647 
	C380.329926,583.500732 381.250000,583.282227 382.641266,582.993408 
	C383.112457,582.923096 383.076935,582.977539 383.246765,583.268250 
	C384.126007,583.694092 384.835480,583.829224 385.544922,583.964355 
	C386.741180,584.667603 387.937439,585.370789 389.408539,586.195496 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M332.905579,528.739502 
	C332.624939,529.073608 332.211090,529.105164 331.329498,528.835815 
	C330.226532,527.473389 329.591309,526.411926 328.956055,525.350403 
	C328.996460,525.093201 329.036896,524.835938 329.180328,524.200439 
	C330.446350,525.360535 331.609375,526.898804 332.905579,528.739502 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M355.972839,557.713562 
	C355.136505,557.873169 354.272125,557.704041 353.187378,557.271423 
	C352.980591,556.245850 352.994141,555.483765 353.009613,554.339600 
	C353.989258,555.099976 354.967010,556.242371 355.972839,557.713562 
z"
      />
      <path
        fill="#1A1611"
        opacity="1.000000"
        stroke="none"
        d="
M385.300171,583.675598 
	C384.835480,583.829224 384.126007,583.694092 383.219788,583.250122 
	C383.700470,583.089722 384.377960,583.238281 385.300171,583.675598 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M341.047333,540.729492 
	C340.784393,541.017090 340.533539,541.031128 339.876038,540.946838 
	C339.469391,540.848450 339.451050,540.583008 339.451050,540.583008 
	C339.600677,540.425537 339.750336,540.268066 340.127930,539.873535 
	C340.590393,539.909607 340.824921,540.182739 341.047333,540.729492 
z"
      />
      <path
        fill="#231D14"
        opacity="1.000000"
        stroke="none"
        d="
M341.944427,540.880737 
	C341.900879,541.089233 341.534393,541.252014 341.075439,541.191528 
	C341.195801,540.923889 341.408630,540.879456 341.944427,540.880737 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M379.980560,561.027283 
	C379.865906,560.874695 379.751282,560.722107 379.636627,560.569519 
	C379.725006,560.616638 379.813354,560.663757 379.951324,560.855957 
	C380.000916,561.000977 379.980560,561.027283 379.980560,561.027283 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M380.014008,560.990723 
	C380.137726,561.126953 380.248352,561.273499 380.358978,561.420044 
	C380.274994,561.374329 380.191040,561.328674 380.043823,561.155151 
	C379.980560,561.027283 380.000916,561.000977 380.014008,560.990723 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M644.307007,601.408691 
	C647.364563,605.159485 646.541138,613.506775 642.420044,616.705566 
	C641.953430,616.324646 641.894836,616.156799 641.836243,615.989014 
	C642.627991,611.279480 643.419678,606.569885 644.307007,601.408691 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M641.485474,615.984863 
	C641.894836,616.156799 641.953430,616.324646 642.054626,616.755676 
	C641.745605,617.441711 641.394043,617.864563 640.724976,618.645447 
	C640.074158,619.158752 639.740784,619.313965 639.407410,619.469177 
	C639.407410,619.469177 639.154236,619.181213 639.025696,619.037476 
	C639.643005,617.922668 640.388916,616.951721 641.485474,615.984863 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M644.150879,596.399841 
	C644.397400,596.883545 644.539185,597.724060 644.476074,598.758301 
	C644.196106,598.220215 644.121094,597.488464 644.150879,596.399841 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M631.622437,617.808350 
	C631.192627,618.617615 630.429016,619.314026 629.296326,619.979980 
	C629.714355,619.198303 630.501526,618.446899 631.622437,617.808350 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M628.714233,619.841187 
	C628.619995,620.487488 628.287354,621.070801 627.954712,621.654175 
	C627.921082,621.265625 627.887512,620.877136 627.938171,620.230469 
	C628.022400,619.972290 628.475830,619.778259 628.714233,619.841187 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M639.235718,619.722778 
	C639.740784,619.313965 640.074158,619.158752 640.673950,618.929932 
	C639.808655,620.219727 638.676941,621.583069 637.144653,622.905884 
	C637.517395,621.902344 638.290649,620.939331 639.235718,619.722778 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M684.816711,631.785278 
	C683.551331,632.534119 682.047424,632.989258 680.254028,633.636963 
	C672.424133,637.248901 666.003174,633.408142 659.189209,630.389404 
	C660.428650,630.070923 662.125122,629.515686 663.317505,630.061584 
	C669.525574,632.903503 675.692200,634.311646 682.237549,631.177063 
	C682.831421,630.892700 683.789368,631.368713 684.816711,631.785278 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M641.413208,626.209717 
	C644.869873,626.335266 648.771057,626.503296 652.854614,627.042969 
	C649.310608,627.027161 645.584167,626.639648 641.413208,626.209717 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M653.576416,627.627319 
	C654.531738,627.684753 655.694519,628.021057 656.901917,628.756958 
	C655.892334,628.739746 654.838013,628.322876 653.576416,627.627319 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M582.384399,561.036926 
	C581.712463,558.577942 581.380432,556.192627 581.275330,553.197388 
	C580.670715,551.057312 579.839172,549.526978 579.007568,547.996704 
	C579.007568,547.996704 579.000000,548.000000 579.002075,547.996216 
	C579.007446,546.918396 579.010803,545.844421 579.321777,544.501221 
	C580.459351,544.479675 581.289307,544.727478 582.119202,544.975220 
	C586.818542,549.359558 588.384644,559.741211 584.990234,564.519531 
	C584.220886,563.361938 583.472595,562.236267 582.384399,561.036926 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M569.930664,533.002930 
	C567.413391,531.519958 564.896118,530.036987 562.188110,528.275391 
	C562.892334,527.146362 564.157471,525.393127 564.625061,525.584839 
	C569.486633,527.578308 574.219849,529.884644 579.123169,532.416138 
	C578.006042,533.390991 576.754395,534.053833 574.849609,534.825684 
	C572.774475,534.290771 571.352600,533.646851 569.930664,533.002930 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M569.975281,533.341553 
	C571.352600,533.646851 572.774475,534.290771 574.527466,534.965088 
	C577.227600,538.092224 579.596680,541.188965 582.042480,544.630493 
	C581.289307,544.727478 580.459351,544.479675 579.328979,544.098389 
	C577.379822,542.543579 575.731079,541.122375 574.038940,539.356323 
	C572.670227,537.234375 571.345093,535.457275 569.975281,533.341553 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M593.205566,538.776550 
	C597.784790,541.290283 600.684021,544.995667 601.700989,550.920044 
	C597.828064,547.227417 594.443848,544.000671 591.035706,540.379028 
	C591.011780,539.984070 591.122681,539.873962 591.436279,539.875366 
	C592.235107,539.510071 592.720337,539.143311 593.205566,538.776550 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M586.120850,536.291748 
	C586.646118,535.778320 587.200806,535.595459 587.915771,535.157043 
	C588.969482,535.394531 589.862854,535.887634 590.888123,537.035950 
	C591.054260,538.418762 591.088501,539.146362 591.122681,539.873962 
	C591.122681,539.873962 591.011780,539.984070 590.954651,540.038879 
	C589.315125,538.936584 587.732666,537.779419 586.120850,536.291748 
z"
      />
      <path
        fill="#0C3D3C"
        opacity="1.000000"
        stroke="none"
        d="
M578.348145,571.037781 
	C578.762268,569.620300 579.517151,568.207947 580.531616,566.905884 
	C580.090515,568.358398 579.389709,569.700623 578.348145,571.037781 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M591.436279,539.875366 
	C591.088501,539.146362 591.054260,538.418762 591.017456,537.324219 
	C591.662720,537.380554 592.310608,537.803711 593.082031,538.501709 
	C592.720337,539.143311 592.235107,539.510071 591.436279,539.875366 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M603.311890,553.405518 
	C602.975281,553.252441 602.791321,552.950806 602.607361,552.649109 
	C602.893066,552.851746 603.178772,553.054321 603.311890,553.405518 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M683.800049,563.154053 
	C683.964905,563.615784 683.851685,564.229126 683.388184,564.952271 
	C683.199280,564.476624 683.360657,563.891174 683.800049,563.154053 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M685.083984,562.968140 
	C685.010315,563.263428 684.800476,563.377441 684.297485,563.285217 
	C684.318787,562.981567 684.633362,562.884155 685.083984,562.968140 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M682.789917,565.066162 
	C682.913513,565.351501 682.758606,565.679688 682.316040,566.035828 
	C682.189392,565.745483 682.350464,565.427307 682.789917,565.066162 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M406.005066,590.373291 
	C407.142181,587.584351 408.286285,585.153992 409.593323,582.377563 
	C411.058136,583.961853 412.336456,585.344482 413.929565,586.869568 
	C413.711334,589.632629 413.178345,592.253113 412.645325,594.873657 
	C410.434265,593.493042 408.223206,592.112427 406.005066,590.373291 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M405.655396,572.082520 
	C405.953979,572.350952 405.865723,572.605652 405.425354,572.885498 
	C405.075958,572.633667 405.141022,572.352966 405.655396,572.082520 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M681.137878,599.243896 
	C686.499451,599.079895 691.860657,598.897034 697.223083,598.769470 
	C698.169373,598.746887 699.121094,598.954651 700.497681,599.095215 
	C705.452148,600.787964 709.979370,602.441406 714.506531,604.094910 
	C714.503052,604.476379 714.499573,604.857910 714.496094,605.239441 
	C713.252563,605.566467 712.009033,605.893494 709.974060,606.268433 
	C705.798523,606.349731 702.414429,606.383240 698.837891,606.071899 
	C696.626038,605.320190 694.606628,604.913269 692.472839,604.483337 
	C694.116577,601.331177 692.648376,600.301453 689.879578,600.066528 
	C686.963440,599.819214 684.051575,599.520264 681.137878,599.243896 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M680.756836,599.164185 
	C684.051575,599.520264 686.963440,599.819214 689.879578,600.066528 
	C692.648376,600.301453 694.116577,601.331177 692.472839,604.483337 
	C694.606628,604.913269 696.626038,605.320190 698.516907,606.299683 
	C691.576782,605.937866 684.765259,605.003418 677.953735,604.069031 
	C677.441345,603.815125 676.928894,603.561218 676.174683,603.151611 
	C675.848022,602.711426 675.763306,602.426941 675.591187,601.843628 
	C675.503723,601.544739 675.685242,601.795715 675.903442,601.812866 
	C676.223145,601.729004 676.324646,601.627930 676.426086,601.526917 
	C676.205811,601.394348 675.985535,601.261841 675.652466,601.207703 
	C675.539673,601.286133 675.265930,601.310974 675.265930,601.310974 
	C675.436279,601.146973 675.606567,600.982910 675.967407,600.520813 
	C676.679565,600.071594 677.201294,599.920349 677.887207,599.548828 
	C678.826233,599.247253 679.600952,599.165894 680.756836,599.164185 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M678.001831,604.428101 
	C684.765259,605.003418 691.576782,605.937866 698.709351,606.644470 
	C702.414429,606.383240 705.798523,606.349731 709.633179,606.426086 
	C707.452515,607.491760 704.767578,609.376953 702.200195,609.228577 
	C694.635498,608.791443 687.112549,607.584229 679.590698,606.550964 
	C679.007385,606.470886 678.560303,605.398438 678.001831,604.428101 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M696.975342,617.850647 
	C689.827515,620.936279 681.590698,619.767029 678.257202,615.067932 
	C677.975220,614.670471 678.611816,613.621399 679.437012,613.190918 
	C685.693420,614.954773 691.334351,616.402710 696.975342,617.850647 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M697.279907,617.800537 
	C691.334351,616.402710 685.693420,614.954773 679.754456,613.241455 
	C680.343750,612.416199 681.401245,611.214905 682.091370,611.398010 
	C687.465576,612.824036 692.768982,614.516418 698.456055,616.432800 
	C698.817322,617.084412 698.816895,617.429626 698.816528,617.774902 
	C698.405823,617.766724 697.995178,617.758545 697.279907,617.800537 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M699.129089,617.845337 
	C698.816895,617.429626 698.817322,617.084412 698.826050,616.480469 
	C699.390381,616.386475 699.946472,616.551025 700.502563,616.715576 
	C700.148926,617.115723 699.795349,617.515747 699.129089,617.845337 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M687.833130,631.050720 
	C687.952698,631.330750 687.767639,631.544861 687.255493,631.602539 
	C687.193420,631.326843 687.393433,631.173035 687.833130,631.050720 
z"
      />
      <path
        fill="#291C0D"
        opacity="1.000000"
        stroke="none"
        d="
M656.121826,593.825317 
	C656.003296,593.581848 656.210938,593.326904 656.716553,593.020630 
	C656.749939,593.189209 656.561157,593.470642 656.121826,593.825317 
z"
      />
      <path
        fill="#0A2624"
        opacity="1.000000"
        stroke="none"
        d="
M552.494019,438.905029 
	C558.563110,438.988586 565.044434,438.990723 571.502197,439.382385 
	C575.740540,439.639465 579.944885,440.459229 584.973999,441.002930 
	C586.535767,440.957611 587.288025,440.936371 588.040283,440.915131 
	C588.040283,440.915131 587.923462,441.128052 588.004883,441.549835 
	C588.854309,442.202362 589.622314,442.433105 590.755676,442.708435 
	C593.233643,443.707520 595.346252,444.662018 597.458923,445.616547 
	C597.445984,446.265656 597.432983,446.914764 597.420044,447.563873 
	C592.581970,449.238678 587.743896,450.913452 582.510620,452.624817 
	C579.075989,453.438507 576.036621,454.215637 572.597168,454.940674 
	C569.338562,455.582855 566.417236,456.087524 563.633301,457.007599 
	C555.950378,459.546783 548.324890,462.259674 540.317932,464.898529 
	C532.350281,468.030792 525.305420,471.940735 520.401367,479.186218 
	C520.043335,479.772858 519.871643,480.211151 519.510254,480.920349 
	C519.240662,481.396759 519.160767,481.602264 518.907227,481.963989 
	C518.446777,482.690735 518.159851,483.261292 517.476135,483.831268 
	C513.897156,483.302368 510.715057,482.774078 507.624390,481.857300 
	C509.535889,478.377502 510.864105,474.809113 513.291382,472.306946 
	C516.908813,468.578003 521.301697,465.601410 525.364624,462.304657 
	C532.027100,459.700317 538.689636,457.096008 546.052979,454.318695 
	C548.870361,453.470184 550.986877,452.794678 553.503906,452.111450 
	C560.304443,450.358582 566.704346,448.613434 573.104309,446.868286 
	C575.324463,446.519897 577.544678,446.171509 579.764832,445.823090 
	C579.821655,445.270508 579.878540,444.717896 579.935364,444.165314 
	C570.922302,442.439880 561.909241,440.714447 552.494019,438.905029 
z"
      />
      <path
        fill="#DCBC86"
        opacity="1.000000"
        stroke="none"
        d="
M507.532928,482.245789 
	C510.715057,482.774078 513.897156,483.302368 517.845642,483.954285 
	C520.358948,484.403931 522.105957,484.729980 524.238281,485.060974 
	C525.139099,485.041656 525.654541,485.017487 526.294067,485.263611 
	C526.904114,486.947845 527.390137,488.361816 527.437500,489.851501 
	C524.084045,489.746613 521.153625,489.295929 518.258911,489.463196 
	C515.492798,489.623016 512.763916,490.425995 510.009338,490.973022 
	C510.000000,490.999817 510.040375,490.960083 510.002380,490.654846 
	C509.645386,489.881989 509.326355,489.414429 508.934052,488.699829 
	C508.565155,488.323669 508.269531,488.194550 507.594299,487.962463 
	C506.173889,487.954163 505.133118,488.048798 503.731384,488.084747 
	C501.881500,487.443054 500.392578,486.860046 498.487335,486.208191 
	C494.472870,485.727997 490.874695,485.316681 487.276550,484.905396 
	C488.786011,483.631683 490.114075,481.867432 491.856323,481.223022 
	C493.578339,480.586121 495.718842,481.080688 498.438354,481.317749 
	C501.978271,481.786346 504.755585,482.016083 507.532928,482.245789 
z"
      />
      <path
        fill="#9A8870"
        opacity="1.000000"
        stroke="none"
        d="
M498.903656,486.277069 
	C500.392578,486.860046 501.881500,487.443054 503.703156,488.482178 
	C503.548492,492.303894 505.599335,492.387604 508.204132,491.992188 
	C508.669189,491.906464 508.883362,491.759583 509.321594,491.440552 
	C509.746521,491.218109 509.893433,491.089111 510.040375,490.960083 
	C510.040375,490.960083 510.000000,490.999817 509.913055,491.377747 
	C515.412170,493.584686 520.890198,496.698517 526.941589,493.167267 
	C527.089050,493.081238 527.660400,493.721588 528.254272,494.175598 
	C528.303772,494.894409 528.132996,495.460754 527.962158,496.027100 
	C526.624023,496.506714 525.207886,497.551392 523.959839,497.378906 
	C510.831177,495.564606 497.729401,493.555878 484.317383,491.359589 
	C484.553528,490.719238 485.092468,490.320160 486.388123,489.907410 
	C491.845642,490.333618 496.546478,490.773438 501.635559,491.249573 
	C500.378662,488.961853 499.641144,487.619476 498.903656,486.277069 
z"
      />
      <path
        fill="#2D8276"
        opacity="1.000000"
        stroke="none"
        d="
M507.624390,481.857300 
	C504.755585,482.016083 501.978271,481.786346 498.856293,481.289581 
	C498.511658,481.022552 498.761932,480.977966 499.274841,480.989929 
	C503.563995,479.971283 505.595215,476.409607 504.956970,471.937561 
	C511.493011,468.675171 518.029053,465.412781 524.964844,462.227539 
	C521.301697,465.601410 516.908813,468.578003 513.291382,472.306946 
	C510.864105,474.809113 509.535889,478.377502 507.624390,481.857300 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M534.975586,441.041443 
	C535.737122,441.034637 536.498657,441.027802 537.724976,441.199219 
	C538.448303,441.281860 538.706909,441.186279 538.965515,441.090698 
	C539.732666,441.087708 540.499878,441.084717 541.852783,441.355835 
	C543.239441,441.783905 544.040344,441.937836 544.902954,442.290955 
	C544.964600,442.490143 545.035767,442.901062 545.027954,443.262848 
	C545.360535,444.750275 545.701050,445.875885 546.028198,447.332825 
	C546.005554,448.105957 545.996277,448.547821 545.986938,448.989655 
	C541.532227,450.639557 537.077515,452.289459 532.312683,453.589966 
	C532.640808,451.828217 533.278992,450.415833 533.917236,449.003479 
	C535.609009,448.283356 537.300842,447.563263 539.113647,446.791626 
	C536.844849,444.973053 535.408630,443.821838 533.918335,442.277802 
	C533.864197,441.884949 533.906738,441.906189 534.149231,441.844025 
	C534.679443,441.608490 534.874084,441.361694 534.975586,441.041443 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M498.487335,486.208191 
	C499.641144,487.619476 500.378662,488.961853 501.635559,491.249573 
	C496.546478,490.773438 491.845642,490.333618 486.738770,489.870239 
	C486.469879,488.306396 486.606995,486.766174 487.010315,485.065674 
	C490.874695,485.316681 494.472870,485.727997 498.487335,486.208191 
z"
      />
      <path
        fill="#8DD4BC"
        opacity="1.000000"
        stroke="none"
        d="
M533.621094,448.838989 
	C533.278992,450.415833 532.640808,451.828217 531.934448,453.564453 
	C526.831665,455.938690 521.797119,457.989044 516.377075,460.097046 
	C517.764954,459.068420 519.502502,457.917145 521.323486,456.917847 
	C522.621094,456.205780 524.096741,455.813202 525.378845,455.078857 
	C530.391113,452.207947 530.511047,450.837494 526.425659,444.953186 
	C526.690063,444.585846 526.954468,444.218475 527.218872,443.851135 
	C529.254211,445.458923 531.289551,447.066742 533.621094,448.838989 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M545.990356,449.415466 
	C545.996277,448.547821 546.005554,448.105957 546.403442,447.321472 
	C547.526123,445.681854 548.260193,444.384888 549.370239,443.092773 
	C554.585938,444.720306 552.543640,448.903870 553.103394,452.119171 
	C550.986877,452.794678 548.870361,453.470184 546.365723,454.130341 
	C545.982910,452.690430 545.988281,451.265869 545.990356,449.415466 
z"
      />
      <path
        fill="#1E675E"
        opacity="1.000000"
        stroke="none"
        d="
M504.659851,472.099243 
	C505.595215,476.409607 503.563995,479.971283 499.400238,480.969177 
	C500.796082,478.044647 502.579437,475.152771 504.659851,472.099243 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M481.887146,495.428009 
	C482.093109,495.829224 482.023743,496.217621 481.890686,496.897644 
	C481.755249,496.597931 481.683502,496.006561 481.887146,495.428009 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M668.792358,382.222321 
	C669.538330,382.014160 669.999207,382.041565 670.806030,382.110168 
	C669.581116,386.926331 668.010254,391.701263 666.439392,396.476227 
	C665.873474,396.302521 665.307495,396.128845 664.741577,395.955139 
	C665.996826,391.456055 667.252075,386.956970 668.792358,382.222321 
z"
      />
      <path
        fill="#F1CE9C"
        opacity="1.000000"
        stroke="none"
        d="
M665.989075,355.864197 
	C664.870667,354.350433 663.752197,352.836700 661.763306,350.144745 
	C663.966980,349.717316 665.777893,349.366089 667.955200,349.070557 
	C667.857727,351.096344 667.393921,353.066437 666.694702,355.465454 
	C666.459290,355.894348 665.989075,355.864197 665.989075,355.864197 
z"
      />
      <path
        fill="#975624"
        opacity="1.000000"
        stroke="none"
        d="
M665.753784,356.122864 
	C665.989075,355.864197 666.459290,355.894348 666.689453,355.844727 
	C666.303772,357.470123 665.687988,359.145172 664.756348,360.912994 
	C664.799805,359.464355 665.159180,357.922913 665.753784,356.122864 
z"
      />
      <path
        fill="#975624"
        opacity="1.000000"
        stroke="none"
        d="
M671.507324,358.335571 
	C670.963074,357.990356 670.636658,357.429565 670.310242,356.868774 
	C670.589417,356.740997 670.868530,356.613190 671.147705,356.485413 
	C671.340210,357.030243 671.532654,357.575104 671.507324,358.335571 
z"
      />
      <path
        fill="#975624"
        opacity="1.000000"
        stroke="none"
        d="
M671.601196,349.277710 
	C671.441345,349.150909 671.418213,348.931244 671.395142,348.711609 
	C671.509338,348.869385 671.623657,349.027130 671.601196,349.277710 
z"
      />
      <path
        fill="#975624"
        opacity="1.000000"
        stroke="none"
        d="
M673.355835,357.257507 
	C673.370605,357.007690 673.503906,356.871643 673.637146,356.735596 
	C673.582886,356.947479 673.528564,357.159393 673.355835,357.257507 
z"
      />
      <path
        fill="#379D8A"
        opacity="1.000000"
        stroke="none"
        d="
M579.033875,548.347473 
	C579.839172,549.526978 580.670715,551.057312 581.257935,552.796570 
	C580.362488,551.569763 579.711365,550.134033 579.033875,548.347473 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M733.764771,525.351685 
	C734.042358,528.875183 734.671204,532.037781 734.330444,535.092346 
	C733.976807,538.262512 732.755676,541.231384 728.390808,540.887695 
	C724.178040,540.556030 724.541016,537.178711 724.245178,534.662354 
	C723.443726,527.847290 726.736267,522.307251 730.895081,515.382263 
	C732.096497,519.492004 732.893250,522.217712 733.764771,525.351685 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M769.375000,479.692291 
	C770.420898,475.551910 771.386475,471.782562 772.565674,467.353241 
	C772.817200,466.099152 772.854980,465.505035 772.892761,464.910950 
	C772.927612,464.486176 772.962463,464.061371 773.075745,463.327026 
	C773.593262,463.028961 774.032349,463.040497 774.797791,463.099060 
	C774.457764,467.469940 773.791443,471.793793 772.791992,476.730377 
	C772.320557,477.989410 772.182251,478.635681 772.043945,479.281952 
	C770.695923,483.602722 769.347900,487.923492 767.996460,492.613953 
	C767.993103,492.983704 768.035156,492.979218 767.782471,493.141846 
	C767.689697,494.010773 767.849609,494.717041 768.016479,495.638489 
	C767.809448,496.184418 767.595398,496.515228 767.381348,496.846008 
	C766.113647,498.522034 764.668701,500.095245 763.622314,501.899658 
	C762.257385,504.253265 761.208252,506.790070 760.012695,509.612244 
	C759.328369,509.796570 758.654541,509.616699 757.937256,509.122284 
	C759.549927,505.437714 761.206055,502.067688 762.894775,498.346222 
	C762.927429,497.994751 762.970764,498.035858 763.182129,497.899292 
	C763.627686,497.528015 763.696106,497.252197 763.598694,496.935242 
	C765.497375,491.311279 767.395996,485.687317 769.375000,479.692291 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M736.135803,510.373291 
	C738.730652,510.990906 741.157288,512.015503 744.000122,513.073242 
	C744.877502,514.205383 745.338684,515.304382 745.588501,516.991272 
	C745.096497,518.956421 744.815918,520.333618 744.590820,521.438782 
	C738.649048,523.952515 737.915405,519.097351 735.961365,516.043823 
	C735.963379,514.289307 735.965454,512.534729 736.135803,510.373291 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M735.908630,516.438904 
	C737.915405,519.097351 738.649048,523.952515 744.590820,521.438782 
	C744.815918,520.333618 745.096497,518.956421 745.629517,517.300659 
	C745.635681,519.752808 745.677673,522.568848 744.915466,525.147095 
	C744.750244,525.705933 740.703552,526.132629 740.155762,525.377991 
	C738.307129,522.831482 737.228760,519.725830 735.908630,516.438904 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M746.987305,508.454468 
	C749.331421,508.045990 751.700500,507.983826 754.511292,507.916168 
	C754.007324,509.536652 753.061707,511.162628 752.116089,512.788574 
	C750.414734,511.459320 748.713501,510.130035 746.987305,508.454468 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M741.050110,543.370117 
	C741.968567,542.543396 742.941833,542.104126 744.226868,541.596741 
	C750.183716,540.976074 755.821167,540.217407 761.478882,540.008850 
	C762.983337,539.953430 764.550049,541.586182 766.163574,542.872314 
	C764.783325,543.952209 763.327637,544.603760 761.532471,545.341187 
	C755.282654,545.342468 749.370544,545.309875 743.464111,545.111877 
	C742.663452,545.085022 741.890625,544.229492 741.050110,543.370117 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M772.505920,504.969421 
	C776.744202,505.081177 780.626953,505.230682 784.803833,505.670074 
	C779.523560,508.187469 774.034241,510.683899 768.326416,512.488953 
	C766.459412,513.079346 763.180664,514.864746 762.029968,510.441223 
	C765.405701,508.354706 768.778076,506.680939 772.505920,504.969421 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M725.261597,560.546509 
	C725.457642,560.113464 725.667236,559.998047 725.948486,559.689087 
	C727.433472,558.995728 728.823975,558.454163 730.819519,558.209534 
	C735.959351,559.690918 740.494202,560.875366 745.028992,562.059814 
	C738.338501,563.616150 731.728088,563.803650 725.261597,560.546509 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M745.400452,562.066528 
	C740.494202,560.875366 735.959351,559.690918 731.194824,558.230591 
	C733.384094,557.276855 735.803162,556.599121 738.603760,555.992310 
	C742.877197,557.240479 746.769104,558.417603 750.898071,559.923706 
	C749.347351,560.859436 747.559631,561.466309 745.400452,562.066528 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M767.535339,497.200653 
	C767.595398,496.515228 767.809448,496.184418 768.095154,495.225037 
	C768.122925,494.057373 768.079041,493.518280 768.035156,492.979218 
	C768.035156,492.979218 767.993103,492.983704 767.992432,493.004211 
	C771.304871,491.277435 774.618042,489.530182 778.483398,487.982483 
	C779.350281,487.927826 779.664978,487.673615 779.979736,487.419373 
	C780.217529,487.105316 780.455383,486.791260 780.904419,486.469177 
	C783.519531,490.782288 787.240906,487.235016 790.667603,488.025879 
	C784.768005,494.866302 777.473755,499.280518 767.535339,497.200653 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M710.283325,578.987915 
	C709.835999,578.037903 709.602478,577.138428 709.627686,576.096252 
	C711.594910,576.311768 713.308044,576.996460 715.011475,576.973267 
	C723.892090,576.852783 732.770325,576.552307 742.097168,576.495667 
	C742.208679,577.088623 741.872498,577.500305 741.327393,578.085205 
	C731.404236,581.220520 721.607971,581.456177 711.319946,579.172424 
	C710.904907,579.202332 710.497192,579.038391 710.283325,578.987915 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M772.384766,479.412079 
	C772.182251,478.635681 772.320557,477.989410 772.707153,477.115204 
	C773.337097,477.173157 773.718872,477.459045 774.609924,478.007385 
	C776.455505,477.943878 777.871948,477.801971 779.114136,477.260223 
	C784.618530,474.859497 790.072815,472.343964 795.545288,469.869995 
	C791.268250,476.679077 785.052307,480.361877 777.098633,480.936371 
	C775.681885,481.038696 774.185303,480.035156 772.384766,479.412079 
z"
      />
      <path
        fill="#925627"
        opacity="1.000000"
        stroke="none"
        d="
M777.259399,463.384094 
	C776.991028,462.882812 776.988098,462.683960 776.959961,461.833374 
	C776.854797,460.709900 776.774658,460.238129 776.694519,459.766388 
	C776.694519,459.766388 777.181458,459.713074 777.653870,460.035522 
	C779.755249,459.952728 781.384155,459.547516 783.383057,459.148865 
	C785.137512,458.736481 786.522034,458.317566 788.280579,457.903046 
	C790.813232,457.309540 792.971985,456.711670 795.130676,456.113800 
	C791.088623,462.884766 784.987915,464.869385 777.259399,463.384094 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M795.745361,469.654480 
	C790.072815,472.343964 784.618530,474.859497 779.114136,477.260223 
	C777.871948,477.801971 776.455505,477.943878 774.875732,478.014771 
	C778.500549,474.532684 782.368958,471.305634 786.573059,468.030579 
	C788.266907,468.460175 789.638367,469.353638 790.979736,469.310486 
	C792.669983,469.256104 794.335632,468.436859 796.402222,467.961426 
	C796.510193,468.463135 796.227844,468.951050 795.745361,469.654480 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M783.013123,459.142303 
	C781.384155,459.547516 779.755249,459.952728 777.891113,460.096069 
	C782.134460,456.152740 786.612915,452.471252 791.439575,448.750031 
	C793.967346,448.838409 796.146851,448.966553 798.725952,449.090088 
	C798.767273,449.795074 798.409119,450.504669 797.443359,451.292664 
	C794.616394,452.339203 792.397034,453.307343 789.983276,453.992432 
	C785.864685,453.443176 783.939331,455.669708 783.013123,459.142303 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M790.177734,454.275513 
	C792.397034,453.307343 794.616394,452.339203 797.199951,451.482239 
	C796.907227,452.943237 796.250244,454.293091 795.362000,455.878387 
	C792.971985,456.711670 790.813232,457.309540 788.345703,457.594330 
	C788.750549,456.279327 789.464172,455.277435 790.177734,454.275513 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M799.334351,449.040985 
	C799.227905,448.811951 799.377380,448.499054 799.781189,448.098022 
	C799.887146,448.325653 799.738770,448.641388 799.334351,449.040985 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M724.868042,591.814087 
	C714.096313,595.342712 703.441101,594.716919 692.590698,589.730469 
	C693.652100,588.458008 694.353027,587.617676 695.072388,586.428589 
	C696.782837,586.075195 698.474854,586.070435 700.592651,586.054810 
	C702.052917,586.304626 703.190063,586.984375 704.105957,586.760193 
	C711.797913,584.877319 718.497559,586.989380 724.868042,591.814087 
z"
      />
      <path
        fill="#DFCEA9"
        opacity="1.000000"
        stroke="none"
        d="
M779.619934,487.430908 
	C779.664978,487.673615 779.350281,487.927826 778.832397,487.985657 
	C778.839539,487.673676 779.049866,487.558075 779.619934,487.430908 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M777.351318,447.954834 
	C776.648987,445.522186 776.367798,443.102997 776.153198,440.269348 
	C779.867004,439.894073 783.543213,439.683167 787.146729,440.100311 
	C788.514038,440.258575 789.713989,441.862976 790.990234,442.808228 
	C789.979736,443.878540 789.145752,445.540802 787.924683,445.905060 
	C784.628662,446.888153 781.167908,447.318542 777.351318,447.954834 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M776.648560,459.763580 
	C776.774658,460.238129 776.854797,460.709900 776.965942,461.535156 
	C776.745117,461.375488 776.493286,460.862274 776.376038,460.052856 
	C776.510681,459.756592 776.602661,459.760773 776.648560,459.763580 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M768.677124,450.181000 
	C768.992004,450.133728 769.306824,450.086487 770.097656,449.968567 
	C771.406677,453.654724 772.239807,457.411591 773.007141,461.607361 
	C766.243103,465.934784 763.707825,464.871277 760.397705,456.275818 
	C761.206970,455.875702 761.658508,455.834198 762.243286,455.923401 
	C762.376587,456.054108 762.710205,456.221649 762.773071,456.587646 
	C763.618347,460.008179 765.667114,461.644867 768.660400,460.819550 
	C769.636963,460.550293 770.054993,458.255615 770.708069,456.538757 
	C770.017517,454.187164 769.347290,452.184082 768.677124,450.181000 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M755.064880,465.322693 
	C757.650146,465.103149 760.141357,465.271576 762.848999,465.154480 
	C764.937866,468.245209 766.810242,471.621460 768.343445,475.437500 
	C763.969788,477.581207 761.016174,476.046478 758.544312,472.820190 
	C757.660156,471.666260 756.555115,470.681519 755.550903,469.619507 
	C755.357544,468.316559 755.164185,467.013641 755.064880,465.322693 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M755.414307,469.979858 
	C756.555115,470.681519 757.660156,471.666260 758.544312,472.820190 
	C761.016174,476.046478 763.969788,477.581207 768.346436,475.793121 
	C768.767944,476.516907 768.847351,477.324799 768.926270,478.539490 
	C766.172974,482.751556 763.172241,482.187775 760.633545,478.967987 
	C758.550781,476.326538 757.041321,473.233215 755.414307,469.979858 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M763.444397,497.080078 
	C763.696106,497.252197 763.627686,497.528015 763.210938,497.891357 
	C763.023743,497.724731 763.110962,497.459656 763.444397,497.080078 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M762.110046,455.792694 
	C761.658508,455.834198 761.206970,455.875702 760.415649,455.915466 
	C759.115234,452.851471 758.154663,449.789276 757.543579,446.328125 
	C758.281921,445.921021 758.670715,445.912811 759.059570,445.904602 
	C759.059570,445.904633 759.036682,445.950714 759.037720,446.332916 
	C760.062500,449.740967 761.086304,452.766846 762.110046,455.792694 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M759.058228,445.575562 
	C758.670715,445.912811 758.281921,445.921021 757.602417,445.945435 
	C757.266235,445.208038 757.220642,444.454437 757.246826,443.330139 
	C757.898010,443.721832 758.477478,444.484192 759.058228,445.575562 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M772.677368,465.141846 
	C772.854980,465.505035 772.817200,466.099152 772.612610,466.942322 
	C772.451172,466.585205 772.456604,465.978973 772.677368,465.141846 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M762.243286,455.923401 
	C761.086304,452.766846 760.062500,449.740967 759.063416,446.332458 
	C761.931091,447.446747 764.773987,448.943695 767.812988,450.204346 
	C768.009094,449.968048 768.355469,450.036407 768.516296,450.108704 
	C769.347290,452.184082 770.017517,454.187164 770.362305,456.579468 
	C768.213928,455.850647 766.390869,454.732635 764.300415,453.450623 
	C764.191956,454.404724 764.101746,455.197876 764.005737,455.995483 
	C764.000000,455.999939 763.991577,456.010986 763.667664,456.041992 
	C763.132568,456.122559 762.921387,456.172119 762.710205,456.221649 
	C762.710205,456.221649 762.376587,456.054108 762.243286,455.923401 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M400.591370,598.110596 
	C400.923615,598.904236 400.935944,599.568787 400.555237,600.645264 
	C397.274628,601.752441 394.420959,602.774109 391.492767,603.078369 
	C384.279175,603.827820 377.031372,604.247559 369.797302,604.799805 
	C369.797302,604.799805 369.692627,604.567749 369.834412,604.054077 
	C371.949097,602.680115 374.021881,601.992126 375.872101,600.920105 
	C378.833618,599.204102 383.385406,600.725647 385.040405,596.408386 
	C385.467590,596.302551 385.894745,596.196716 386.923950,596.329346 
	C389.366699,596.480713 391.207458,596.393677 393.048187,596.306641 
	C393.444458,596.350342 393.840729,596.394043 394.616394,596.769531 
	C395.655090,597.094116 396.314423,597.086914 396.973755,597.079712 
	C398.072998,597.380371 399.172241,597.680969 400.591370,598.110596 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M370.028717,605.069824 
	C377.031372,604.247559 384.279175,603.827820 391.492767,603.078369 
	C394.420959,602.774109 397.274628,601.752441 400.544647,600.978271 
	C401.132690,600.951782 401.338257,601.004150 401.853149,601.134888 
	C398.807495,606.192017 393.181061,606.412476 388.276123,606.737488 
	C382.327759,607.131531 376.270355,605.879578 370.028717,605.069824 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M389.953613,610.771484 
	C393.815735,610.445007 397.272034,610.231873 401.794922,609.953003 
	C397.350922,615.004761 390.304718,616.372986 381.819824,613.821289 
	C384.395844,612.842468 386.971832,611.863647 389.953613,610.771484 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M356.002075,590.862183 
	C359.652557,590.723755 363.493103,591.342468 367.236328,590.973633 
	C373.606140,590.346069 379.914764,589.097229 386.632263,588.070190 
	C385.929169,589.169434 385.029602,590.974487 383.726624,591.339539 
	C374.556244,593.908386 365.312439,595.201172 356.002075,590.862183 
z"
      />
      <path
        fill="#C7AC79"
        opacity="1.000000"
        stroke="none"
        d="
M384.652100,596.354858 
	C383.385406,600.725647 378.833618,599.204102 375.872101,600.920105 
	C374.021881,601.992126 371.949097,602.680115 369.852051,603.928101 
	C368.005249,604.107056 366.282532,603.898438 364.559845,603.689880 
	C364.463165,603.093994 364.366455,602.498169 364.269775,601.902283 
	C370.934448,600.035278 377.599152,598.168274 384.652100,596.354858 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M392.641846,596.133179 
	C391.207458,596.393677 389.366699,596.480713 387.258362,596.334106 
	C388.738983,596.053528 390.487274,596.006592 392.641846,596.133179 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M396.777039,596.833557 
	C396.314423,597.086914 395.655090,597.094116 394.897736,596.871948 
	C395.393250,596.624207 395.986816,596.605774 396.777039,596.833557 
z"
      />
      <path
        fill="#AF844F"
        opacity="1.000000"
        stroke="none"
        d="
M305.093658,450.999054 
	C305.953308,450.423553 306.812927,449.848083 307.948792,449.160736 
	C306.027435,465.510803 311.264618,480.507050 317.529449,495.608246 
	C319.918640,500.748657 322.194061,505.589294 324.263275,510.516541 
	C324.557129,511.216370 323.848785,512.337097 323.300354,513.138550 
	C317.766418,512.017944 312.467865,511.282318 307.331268,509.931030 
	C304.080200,509.075775 301.070618,507.302521 297.816223,505.622925 
	C303.830292,506.555573 309.980896,507.806244 316.651062,509.303070 
	C317.528870,509.812531 317.887054,510.075836 318.245239,510.339172 
	C318.365662,510.134155 318.486145,509.929138 318.606628,509.724121 
	C318.092987,509.460876 317.579346,509.197571 317.065704,508.934296 
	C317.019714,508.553009 316.973724,508.171692 316.904968,507.502930 
	C317.487915,506.090271 318.839996,504.722687 318.567230,503.882751 
	C317.510254,500.627747 315.936005,497.540771 314.652740,494.615448 
	C304.366455,495.141266 295.486267,493.071503 288.929047,484.454468 
	C292.748077,485.856384 296.636841,487.589233 300.596313,489.353607 
	C301.500061,488.163361 302.246826,487.179871 303.183075,485.928345 
	C305.332306,486.778870 307.291992,487.897430 309.738739,489.381836 
	C311.022766,490.314972 311.819702,490.882263 312.616638,491.449585 
	C312.827637,491.268524 313.038635,491.087463 313.249634,490.906403 
	C312.595886,489.456635 311.942139,488.006897 311.288391,486.557129 
	C310.597961,483.938385 309.907501,481.319611 309.029663,478.008606 
	C308.127655,474.886414 307.413025,472.456512 306.698395,470.026611 
	C306.123047,467.961060 305.547668,465.895508 304.999512,463.034149 
	C304.984406,461.210114 304.942108,460.181915 304.937592,458.700958 
	C305.014801,455.831848 305.054230,453.415436 305.093658,450.999054 
z"
      />
      <path
        fill="#A46F37"
        opacity="1.000000"
        stroke="none"
        d="
M325.233612,506.124207 
	C326.535339,504.948395 328.080597,504.382782 328.901154,503.278656 
	C331.621735,499.617737 334.081360,495.762939 336.917786,491.847931 
	C338.899567,498.546265 335.386658,506.746460 329.920685,508.926971 
	C327.278687,509.980896 325.436584,509.851837 325.233612,506.124207 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M305.585052,523.857666 
	C305.201050,523.797363 305.102692,523.374207 305.050232,523.163208 
	C307.517609,522.302246 310.007324,521.454590 312.566772,521.064209 
	C314.645874,520.747009 316.808624,520.978455 319.737579,521.002869 
	C320.998108,521.123413 321.455383,521.207581 321.912628,521.291809 
	C323.183563,521.994263 324.454498,522.696716 325.660889,523.955933 
	C324.732300,524.678345 323.868256,524.844116 322.651978,524.846191 
	C318.143066,524.585815 313.986328,524.489197 309.829590,524.392578 
	C308.542755,524.234436 307.255890,524.076233 305.585052,523.857666 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M323.004181,525.009888 
	C323.868256,524.844116 324.732300,524.678345 325.803711,524.249390 
	C326.798553,524.341370 327.586060,524.696655 328.664795,525.201172 
	C329.591309,526.411926 330.226532,527.473389 331.018799,528.823853 
	C331.013550,529.155273 330.851257,529.197754 330.444458,529.300171 
	C326.314453,529.079834 322.428955,528.799500 318.521210,527.952759 
	C320.000702,526.594238 321.502441,525.802063 323.004181,525.009888 
z"
      />
      <path
        fill="#0A1619"
        opacity="1.000000"
        stroke="none"
        d="
M322.048370,520.960693 
	C321.455383,521.207581 320.998108,521.123413 320.191040,521.022461 
	C318.959839,520.586914 318.078461,520.168091 317.064331,519.472412 
	C317.512360,518.418701 317.967224,517.159790 318.700958,516.968018 
	C320.102142,516.601929 321.662170,516.843811 323.156281,516.833252 
	C322.832214,518.098694 322.508179,519.364136 322.048370,520.960693 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M284.525146,466.170258 
	C287.644928,467.244080 290.819000,468.552582 293.895721,470.059723 
	C296.443695,471.307770 297.257660,470.487518 296.936340,467.528625 
	C298.726959,468.355408 300.530426,469.548553 302.776733,471.211517 
	C304.513733,473.800751 305.807892,475.920166 307.102081,478.039581 
	C307.102081,478.039581 307.031494,478.055786 306.658264,478.043457 
	C301.502899,476.744690 296.720795,475.458221 291.938660,474.171783 
	C289.471527,471.611481 287.004395,469.051178 284.525146,466.170258 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M292.002350,474.504913 
	C296.720795,475.458221 301.502899,476.744690 306.665955,478.078857 
	C305.214905,478.712860 303.087585,480.192657 301.610748,479.704529 
	C298.259155,478.596710 295.227661,476.520538 292.002350,474.504913 
z"
      />
      <path
        fill="#5B361A"
        opacity="1.000000"
        stroke="none"
        d="
M307.398438,478.039825 
	C305.807892,475.920166 304.513733,473.800751 303.065674,471.377869 
	C303.912506,470.777924 304.913208,470.481415 306.306152,470.105774 
	C307.413025,472.456512 308.127655,474.886414 308.860962,477.680481 
	C308.484711,478.043121 308.089752,478.041595 307.398438,478.039825 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M311.125671,486.895996 
	C311.942139,488.006897 312.595886,489.456635 313.249634,490.906403 
	C313.038635,491.087463 312.827637,491.268524 312.616638,491.449585 
	C311.819702,490.882263 311.022766,490.314972 310.071411,489.480072 
	C310.265686,488.553253 310.614319,487.894073 311.125671,486.895996 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M340.574280,554.977661 
	C342.948059,555.659180 344.886932,556.330811 346.825806,557.002502 
	C346.729858,557.485596 346.633942,557.968689 346.537994,558.451782 
	C340.587219,559.752686 334.747986,558.865601 328.892853,555.850586 
	C332.641693,555.556274 336.390503,555.261963 340.574280,554.977661 
z"
      />
      <path
        fill="#DEAE6D"
        opacity="1.000000"
        stroke="none"
        d="
M339.090210,540.504883 
	C339.451050,540.583008 339.469391,540.848450 339.500488,540.977844 
	C338.017883,541.754761 336.448029,543.060303 335.000122,542.936768 
	C328.494507,542.381348 322.023499,541.420166 315.241211,540.346069 
	C320.346436,539.717102 325.750488,539.347290 331.617432,538.959839 
	C332.080292,538.942139 332.034149,538.972351 332.065674,539.289673 
	C333.090393,539.667419 334.083557,539.727905 335.076752,539.788330 
	C336.294281,540.001099 337.511841,540.213928 339.090210,540.504883 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M334.893585,539.506287 
	C334.083557,539.727905 333.090393,539.667419 332.067749,539.262573 
	C332.929016,539.020203 333.819702,539.122253 334.893585,539.506287 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M305.060791,450.732971 
	C305.054230,453.415436 305.014801,455.831848 304.600220,458.819153 
	C301.792633,459.960510 299.360138,460.530945 296.927673,461.101379 
	C293.213837,458.788879 289.500000,456.476410 285.499634,453.995026 
	C284.188629,452.036255 283.164124,450.246368 282.208282,448.106689 
	C282.276917,447.756836 282.675995,447.699402 283.131073,447.920959 
	C288.847687,451.175201 294.078918,454.262482 299.387390,457.210632 
	C301.217804,458.227173 303.069275,458.584564 302.784393,455.367371 
	C303.246460,453.533905 303.708557,451.700439 304.289246,449.456177 
	C304.614563,449.519196 304.821228,449.993042 305.060791,450.732971 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M297.035645,461.470215 
	C299.360138,460.530945 301.792633,459.960510 304.562439,459.271881 
	C304.942108,460.181915 304.984406,461.210114 304.968109,462.621552 
	C302.320862,462.616150 299.732239,462.227570 297.035645,461.470215 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M302.494080,455.242432 
	C303.069275,458.584564 301.217804,458.227173 299.387390,457.210632 
	C294.078918,454.262482 288.847687,451.175201 283.331543,447.899780 
	C286.512421,448.760620 289.961639,449.823669 293.377502,450.984802 
	C295.069336,451.559937 296.699829,452.315613 298.746277,452.997711 
	C300.157562,453.709717 301.180634,454.413605 302.494080,455.242432 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M322.651978,524.846191 
	C321.502441,525.802063 320.000702,526.594238 318.247986,527.638184 
	C315.407318,526.902954 312.817627,525.916077 310.028748,524.660889 
	C313.986328,524.489197 318.143066,524.585815 322.651978,524.846191 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M313.674438,468.162109 
	C317.439728,463.166473 321.053955,458.537750 325.178528,453.255432 
	C327.729187,464.893555 322.881744,473.671143 312.950714,475.690460 
	C313.153259,473.157562 313.338287,470.843323 313.674438,468.162109 
z"
      />
      <path
        fill="#E2B980"
        opacity="1.000000"
        stroke="none"
        d="
M334.094849,514.404419 
	C335.735352,512.886780 337.468445,511.869781 338.920502,510.544769 
	C339.942383,509.612305 340.582062,508.261017 341.756470,507.069641 
	C341.356110,511.884705 340.093140,516.401001 334.349457,518.400330 
	C334.251312,517.138733 334.159332,515.956055 334.094849,514.404419 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M291.991669,437.409058 
	C295.995575,437.304626 299.994568,437.612549 304.391357,437.867401 
	C304.828064,439.563232 304.866882,441.312134 304.687103,443.528870 
	C304.468475,443.996674 304.033142,444.029266 304.033142,444.029266 
	C302.070251,444.003326 300.107422,443.970886 298.144470,443.952789 
	C294.090485,443.915466 291.474915,442.440765 291.991669,437.409058 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M304.038788,444.398621 
	C304.033142,444.029266 304.468475,443.996674 304.683319,443.963409 
	C304.852203,444.767334 304.806213,445.604492 304.574158,446.690369 
	C304.273499,446.215332 304.158966,445.491669 304.038788,444.398621 
z"
      />
      <path
        fill="#B07B40"
        opacity="1.000000"
        stroke="none"
        d="
M300.297211,376.694397 
	C299.916199,375.331268 299.979950,374.122162 300.069641,372.547485 
	C300.506775,372.141876 300.917969,372.101929 301.703735,372.442230 
	C304.097260,373.500854 306.116150,374.179230 308.135040,374.857544 
	C308.135040,374.857544 308.588196,374.901154 308.814758,374.926941 
	C309.030182,375.405884 309.019043,375.859009 309.004333,376.651550 
	C306.247833,376.943420 303.494904,376.895905 300.297211,376.694397 
z"
      />
      <path
        fill="#C4904D"
        opacity="1.000000"
        stroke="none"
        d="
M308.044434,374.499329 
	C306.116150,374.179230 304.097260,373.500854 302.014648,372.456177 
	C303.951935,372.773590 305.952881,373.457306 308.044434,374.499329 
z"
      />
      <path
        fill="#754A28"
        opacity="1.000000"
        stroke="none"
        d="
M304.631958,389.942291 
	C304.302399,389.963104 304.158661,389.692261 304.173279,389.131409 
	C304.522308,389.086182 304.684387,389.355896 304.631958,389.942291 
z"
      />
      <path
        fill="#D7BE95"
        opacity="1.000000"
        stroke="none"
        d="
M648.006958,252.129272 
	C648.742188,251.567017 649.577637,251.269012 650.680115,250.757477 
	C650.946472,251.348862 650.945740,252.153793 650.876099,253.349182 
	C650.403503,253.772797 649.999878,253.805969 649.290527,253.831345 
	C648.692322,253.346878 648.399719,252.870193 648.006958,252.129272 
z"
      />
      <path
        fill="#1F1B16"
        opacity="1.000000"
        stroke="none"
        d="
M665.343262,329.177917 
	C663.284485,338.117615 661.076538,346.792969 658.625549,355.399109 
	C658.061096,357.381042 656.924255,359.342224 655.600830,360.940369 
	C650.771362,366.772430 645.751465,372.446838 640.458862,378.241882 
	C643.046143,369.441620 645.977844,360.580139 649.110840,351.082397 
	C649.577454,349.653412 649.842834,348.860657 650.108215,348.067902 
	C650.836853,346.042877 651.565491,344.017822 652.404053,341.641449 
	C655.186035,337.937836 657.718689,334.458435 660.601807,331.298920 
	C661.684021,330.112946 663.580566,329.670074 665.343262,329.177917 
z"
      />
      <path
        fill="#7F4A22"
        opacity="1.000000"
        stroke="none"
        d="
M649.773743,348.083740 
	C649.842834,348.860657 649.577454,349.653412 649.151550,350.721069 
	C649.140381,350.030548 649.289856,349.065063 649.773743,348.083740 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M656.196411,245.074860 
	C657.794983,245.529099 659.676392,245.861816 659.961792,246.723282 
	C660.346497,247.884399 659.731140,249.577866 659.071472,250.783981 
	C658.811768,251.258759 657.275696,251.035477 656.320862,251.130081 
	C656.136658,249.149673 655.952515,247.169266 656.196411,245.074860 
z"
      />
      <path
        fill="#AEABA1"
        opacity="1.000000"
        stroke="none"
        d="
M617.016357,436.967957 
	C626.326294,436.954041 635.633301,436.888702 644.936768,437.040039 
	C646.293030,437.062042 647.632385,438.118317 648.566040,439.161865 
	C646.114136,439.722565 644.075684,439.817474 641.875610,439.715454 
	C641.006653,439.754700 640.299255,439.990845 639.247070,440.295776 
	C637.730896,440.403839 636.559509,440.443085 635.253174,440.239197 
	C634.285645,440.181061 633.453003,440.366058 632.245117,440.560455 
	C630.369507,440.564453 628.869202,440.559021 627.243225,440.300201 
	C626.389526,440.096558 625.661560,440.146301 624.505432,440.161102 
	C622.073059,440.141785 620.068726,440.157379 617.806030,439.981934 
	C617.355286,439.696320 617.163025,439.601776 616.976074,439.199677 
	C616.980652,438.260590 616.979919,437.629089 616.979126,436.997559 
	C616.979126,436.997559 617.012329,436.986267 617.016357,436.967957 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M653.954346,446.725891 
	C653.965393,447.165039 653.905457,447.334778 653.370117,447.755859 
	C644.450134,448.006897 635.993103,447.730347 627.565918,448.111237 
	C622.622620,448.334717 617.726685,449.604889 612.445251,450.271240 
	C610.808655,450.022797 609.536194,449.907349 608.180725,449.541504 
	C607.986633,449.154694 607.875671,449.018219 607.840027,448.494690 
	C608.673157,443.108154 612.390442,445.608337 615.134277,445.677490 
	C616.976257,446.363525 618.694397,446.989929 620.397705,446.951813 
	C631.473389,446.703705 642.545837,446.311127 653.619385,445.965912 
	C653.707458,446.129456 653.795471,446.292969 653.954346,446.725891 
z"
      />
      <path
        fill="#1F1910"
        opacity="1.000000"
        stroke="none"
        d="
M653.738647,445.623810 
	C642.545837,446.311127 631.473389,446.703705 620.397705,446.951813 
	C618.694397,446.989929 616.976257,446.363525 615.424438,445.554016 
	C615.998291,445.006531 616.412659,444.949493 617.300415,444.976807 
	C628.618896,444.588196 639.464111,444.115234 650.309326,443.642273 
	C651.492188,444.188751 652.674988,444.735229 653.738647,445.623810 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M618.064453,440.172974 
	C620.068726,440.157379 622.073059,440.141785 624.747070,440.394623 
	C626.067444,440.626587 626.718201,440.590088 627.368896,440.553589 
	C628.869202,440.559021 630.369507,440.564453 632.704773,440.691528 
	C634.155823,440.702911 634.771973,440.592621 635.388062,440.482330 
	C636.559509,440.443085 637.730896,440.403839 639.554932,440.478333 
	C640.817444,440.365540 641.427368,440.138977 642.037231,439.912415 
	C644.075684,439.817474 646.114136,439.722565 648.583008,439.550659 
	C649.363098,440.393707 649.712769,441.313751 649.595703,442.623474 
	C640.024780,443.052246 630.920410,443.068817 621.816467,443.147034 
	C619.684570,443.165344 617.672302,443.242889 618.064453,440.172974 
z"
      />
      <path
        fill="#6A6960"
        opacity="1.000000"
        stroke="none"
        d="
M617.806030,439.981934 
	C617.672302,443.242889 619.684570,443.165344 621.816467,443.147034 
	C630.920410,443.068817 640.024780,443.052246 649.605896,443.019470 
	C650.082764,443.025818 650.260925,443.310150 650.285156,443.476196 
	C639.464111,444.115234 628.618896,444.588196 617.270203,444.621918 
	C616.834778,442.624207 616.902771,441.065735 616.970764,439.507233 
	C617.163025,439.601776 617.355286,439.696320 617.806030,439.981934 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M607.764709,448.881775 
	C607.875671,449.018219 607.986633,449.154694 607.821289,449.738770 
	C602.033325,451.130768 596.521667,452.075073 590.612610,453.011475 
	C588.814209,453.003601 587.413269,453.003601 586.012329,453.003601 
	C586.010376,453.336945 586.008484,453.670319 586.006531,454.003662 
	C587.671814,454.003662 589.337158,454.003662 591.468872,454.007294 
	C597.986267,453.743164 604.037292,453.475403 610.070679,453.398499 
	C610.053101,453.589294 609.994934,453.968079 609.994934,453.968079 
	C607.330261,454.338318 604.665527,454.708588 601.089355,455.043335 
	C595.428162,455.281250 590.675293,455.750793 585.931458,455.672729 
	C584.906250,455.655853 583.913513,453.668152 582.905823,452.588257 
	C587.743896,450.913452 592.581970,449.238678 597.420044,447.563873 
	C597.432983,446.914764 597.445984,446.265656 597.458923,445.616547 
	C595.346252,444.662018 593.233643,443.707520 590.658081,442.467010 
	C590.115967,441.844849 590.036743,441.508667 589.957520,441.172485 
	C589.962646,440.961456 589.967773,440.750458 590.416931,440.244141 
	C592.572144,439.953094 594.283264,439.957306 596.209717,440.235535 
	C599.311035,442.006104 602.197021,443.502655 605.070801,445.379700 
	C605.960693,446.800690 606.862671,447.841248 607.764709,448.881775 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M595.994385,439.961517 
	C594.283264,439.957306 592.572144,439.953094 590.433899,439.927979 
	C589.073730,438.458130 588.140625,437.009155 587.104065,435.298126 
	C589.735901,435.231903 592.471191,435.427765 595.826965,436.080811 
	C601.037048,437.358246 605.607178,438.346069 610.229797,438.881195 
	C611.388672,439.015350 612.715942,437.694855 613.965820,437.042908 
	C614.719360,437.027679 615.472900,437.012451 616.602783,436.997375 
	C616.979919,437.629089 616.980652,438.260590 616.976074,439.199677 
	C616.902771,441.065735 616.834778,442.624207 616.796875,444.537598 
	C616.412659,444.949493 615.998291,445.006531 615.293701,445.187012 
	C612.390442,445.608337 608.673157,443.108154 607.840027,448.494690 
	C606.862671,447.841248 605.960693,446.800690 605.359558,445.220245 
	C605.533569,443.541901 605.613220,441.491608 605.247253,441.408722 
	C602.209534,440.720642 599.089539,440.395996 595.994385,439.961517 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M587.957275,440.548737 
	C587.288025,440.936371 586.535767,440.957611 585.405884,440.969299 
	C584.432495,440.484222 583.836670,440.008667 583.071411,439.294800 
	C584.559326,439.431763 586.216736,439.807068 587.957275,440.548737 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M589.603210,441.153564 
	C590.036743,441.508667 590.115967,441.844849 590.292725,442.422424 
	C589.622314,442.433105 588.854309,442.202362 587.973999,441.667297 
	C588.324097,441.286865 588.786499,441.210785 589.603210,441.153564 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M613.505249,437.033234 
	C612.715942,437.694855 611.388672,439.015350 610.229797,438.881195 
	C605.607178,438.346069 601.037048,437.358246 596.186829,436.253326 
	C601.632385,436.320282 607.338501,436.671936 613.505249,437.033234 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M553.503906,452.111450 
	C552.543640,448.903870 554.585938,444.720306 548.976013,443.045105 
	C547.149109,442.962067 546.092407,442.931549 545.035767,442.901062 
	C545.035767,442.901062 544.964600,442.490143 544.944275,442.005676 
	C544.923096,441.329865 544.922241,441.138458 544.921326,440.947083 
	C554.258057,442.676849 563.594727,444.406616 573.017883,446.502319 
	C566.704346,448.613434 560.304443,450.358582 553.503906,452.111450 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M544.643005,440.931580 
	C544.922241,441.138458 544.923096,441.329865 544.882629,441.806519 
	C544.040344,441.937836 543.239441,441.783905 542.234009,441.402954 
	C542.232422,441.118439 542.435181,441.060883 542.947571,440.927002 
	C543.626343,440.872467 543.995483,440.894257 544.643005,440.931580 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M534.733704,441.096375 
	C534.874084,441.361694 534.679443,441.608490 534.164795,441.861694 
	C533.993958,441.587952 534.178589,441.324524 534.733704,441.096375 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M538.729492,441.060333 
	C538.706909,441.186279 538.448303,441.281860 538.104858,441.227478 
	C538.019958,441.077454 538.493469,441.029999 538.729492,441.060333 
z"
      />
      <path
        fill="#21241F"
        opacity="1.000000"
        stroke="none"
        d="
M532.666626,667.225830 
	C531.759216,662.770081 530.851807,658.314331 529.953369,653.403687 
	C533.434692,654.370300 536.621643,655.881409 536.522522,660.559814 
	C536.448486,664.055298 536.904480,667.562073 537.033875,671.526245 
	C536.766541,672.000488 536.589661,672.012329 535.839905,672.014648 
	C534.853027,671.990295 534.439087,671.975525 534.025085,671.960693 
	C534.025085,671.960693 534.005615,672.004028 534.026611,671.746582 
	C534.047668,671.489136 534.023743,671.007324 534.023743,671.007324 
	C534.007019,670.820801 533.990295,670.634216 533.848328,669.968506 
	C533.564087,669.215637 533.329285,669.047180 533.018677,668.984192 
	C533.018677,668.984192 533.017212,668.980774 533.071228,668.738403 
	C532.972351,668.072632 532.819458,667.649231 532.666626,667.225830 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M538.682495,675.108521 
	C537.442261,680.401794 534.103149,677.779541 531.004517,676.488770 
	C533.341309,675.766968 535.799133,675.412781 538.682495,675.108521 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M532.267029,667.206848 
	C532.819458,667.649231 532.972351,668.072632 533.077332,668.732178 
	C531.951904,669.665527 530.949951,670.650269 529.770752,670.959656 
	C528.970032,671.169739 527.920837,670.432373 526.968140,669.800781 
	C528.591553,668.717896 530.229492,667.952881 532.267029,667.206848 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M534.150757,672.187988 
	C534.439087,671.975525 534.853027,671.990295 535.574585,672.031921 
	C535.346863,672.177551 534.811646,672.296387 534.150757,672.187988 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M533.852051,671.091736 
	C534.023743,671.007324 534.047668,671.489136 534.044434,671.730225 
	C533.920898,671.706238 533.800598,671.441162 533.852051,671.091736 
z"
      />
      <path
        fill="#454B43"
        opacity="1.000000"
        stroke="none"
        d="
M533.105957,669.189514 
	C533.329285,669.047180 533.564087,669.215637 533.813599,669.689697 
	C533.596008,669.826965 533.359070,669.661926 533.105957,669.189514 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M412.169800,601.266113 
	C412.758484,601.000244 413.488403,601.014648 414.581726,601.042297 
	C414.946289,601.544434 414.947510,602.033264 414.918091,602.889771 
	C414.028656,602.686951 413.169861,602.116577 412.169800,601.266113 
z"
      />
      <path
        fill="#2C1E11"
        opacity="1.000000"
        stroke="none"
        d="
M418.741180,606.404236 
	C418.949890,606.344421 419.320557,606.539917 419.783569,607.048584 
	C419.551605,607.127686 419.227386,606.893616 418.741180,606.404236 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M543.816772,492.031311 
	C540.554688,502.781952 549.708130,504.991180 555.468079,509.670288 
	C550.083496,507.882782 544.964050,505.777710 539.844543,503.672668 
	C539.571655,501.267609 539.298706,498.862549 538.990662,496.148102 
	C537.157532,496.148102 535.560852,496.148102 533.521851,495.771851 
	C533.701721,494.692963 534.323914,493.990356 534.619080,493.657013 
	C533.983765,492.664612 533.455444,491.839417 533.215210,491.012085 
	C533.694519,491.000671 533.885803,490.991333 534.361694,491.119568 
	C535.436707,491.507599 536.226929,491.757996 537.248901,492.281830 
	C539.592712,492.380615 541.704712,492.205963 543.816772,492.031311 
z"
      />
      <path
        fill="#A7DCC8"
        opacity="1.000000"
        stroke="none"
        d="
M539.595337,503.695618 
	C544.964050,505.777710 550.083496,507.882782 555.595215,509.993652 
	C556.162842,509.993988 556.338135,509.988525 556.776001,510.004364 
	C559.361755,511.388092 561.684875,512.750488 564.338501,514.245422 
	C563.725464,514.717346 562.679382,515.502991 561.857178,515.314087 
	C559.170166,514.696899 556.564697,513.724609 553.321045,512.576599 
	C548.115356,509.501984 543.516479,506.739624 538.917603,503.977264 
	C539.060425,503.891022 539.203247,503.804779 539.595337,503.695618 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M532.927185,491.014191 
	C533.455444,491.839417 533.983765,492.664612 534.619080,493.657013 
	C534.323914,493.990356 533.701721,494.692963 533.098999,495.714417 
	C531.407043,496.268372 529.695679,496.503479 527.973267,496.382874 
	C528.132996,495.460754 528.303772,494.894409 528.225708,493.850525 
	C527.943298,492.173920 527.909668,490.974854 527.876099,489.775787 
	C527.390137,488.361816 526.904114,486.947845 526.482544,485.009216 
	C527.651733,485.116882 528.834778,485.646210 529.840149,486.409424 
	C530.935181,487.240662 531.865356,488.288940 532.871582,489.536896 
	C532.892944,490.225525 532.910034,490.619873 532.927185,491.014191 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M498.299133,498.963837 
	C496.564789,498.516479 495.232513,498.089142 493.900269,497.661804 
	C493.967621,497.374268 494.035004,497.086761 494.102386,496.799225 
	C502.905670,498.306763 511.708923,499.814301 520.512207,501.321838 
	C520.441528,501.815704 520.370789,502.309540 520.300110,502.803406 
	C513.100464,501.530243 505.900879,500.257050 498.299133,498.963837 
z"
      />
      <path
        fill="#79C2A9"
        opacity="1.000000"
        stroke="none"
        d="
M538.607788,504.172668 
	C543.516479,506.739624 548.115356,509.501984 552.934082,512.543945 
	C552.524780,513.077454 551.895752,513.331421 550.771484,513.836426 
	C549.857849,514.054871 549.439331,514.022278 549.020874,513.989685 
	C545.480652,511.705414 541.940491,509.421173 538.286011,506.856018 
	C538.213806,505.839447 538.255859,505.103760 538.607788,504.172668 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M486.211884,496.416748 
	C487.589264,496.029358 489.235474,495.845520 490.881683,495.661713 
	C490.894073,496.101654 490.906433,496.541626 490.918793,496.981567 
	C489.439423,496.861176 487.960083,496.740753 486.211884,496.416748 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M531.468750,501.089264 
	C530.981201,501.854553 530.183228,502.583588 529.385315,503.312653 
	C529.128662,502.910583 528.872009,502.508484 528.615356,502.106415 
	C529.463013,501.755280 530.310730,501.404144 531.468750,501.089264 
z"
      />
      <path
        fill="#254444"
        opacity="1.000000"
        stroke="none"
        d="
M524.534058,502.489655 
	C525.029663,502.551117 525.328796,502.786469 525.627930,503.021820 
	C525.432190,503.204010 525.236450,503.386230 525.040771,503.568481 
	C524.806396,503.266846 524.572021,502.965210 524.534058,502.489655 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M548.853455,514.230713 
	C549.439331,514.022278 549.857849,514.054871 550.588501,514.125183 
	C552.264099,515.203125 553.627502,516.243408 555.073975,517.600830 
	C552.578613,517.141174 550.000305,516.364258 547.206665,515.296753 
	C546.991394,515.006104 547.034058,514.949829 547.034058,514.949829 
	C547.584717,514.790466 548.135376,514.631104 548.853455,514.230713 
z"
      />
      <path
        fill="#C7DBC6"
        opacity="1.000000"
        stroke="none"
        d="
M546.967651,515.032227 
	C546.212524,514.986694 545.481140,514.915039 544.749817,514.843445 
	C544.775818,514.631897 544.801880,514.420349 544.827881,514.208862 
	C545.443054,514.300842 546.058228,514.392761 546.853760,514.717285 
	C547.034058,514.949829 546.991394,515.006104 546.967651,515.032227 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M560.559814,524.555420 
	C560.488525,524.596191 560.631042,524.514648 560.559814,524.555420 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M618.088806,470.096008 
	C618.088806,470.096008 618.052551,470.554901 618.052490,470.784912 
	C614.881958,471.955688 611.768555,473.287201 608.529785,473.760803 
	C600.219177,474.976013 591.852783,475.810272 583.068604,476.707123 
	C582.285156,475.261627 581.941833,473.905823 582.091675,472.237946 
	C587.928406,468.139801 594.030518,468.907379 600.174805,469.335236 
	C602.630798,470.078033 605.016296,471.094666 607.220703,470.791931 
	C610.241699,470.377106 613.125122,468.960785 616.255493,467.953888 
	C616.443420,467.934113 616.817810,467.881897 616.885376,468.210846 
	C617.331543,469.058533 617.710205,469.577271 618.088806,470.096008 
z"
      />
      <path
        fill="#4CAF9A"
        opacity="1.000000"
        stroke="none"
        d="
M543.915588,491.724579 
	C541.704712,492.205963 539.592712,492.380615 537.515747,492.032471 
	C537.865723,490.077087 537.705078,488.181488 538.574341,487.288849 
	C543.400818,482.332458 547.019104,476.032104 554.264709,473.700195 
	C557.348633,472.707672 560.082947,470.628998 563.348755,468.987244 
	C565.354919,468.404816 566.988525,467.879089 569.952454,466.925293 
	C567.704590,466.393799 566.847412,466.191101 566.042236,465.651398 
	C567.055908,464.218933 568.017517,463.123505 569.298462,461.967468 
	C569.910339,461.580933 570.202881,461.254974 570.495422,460.929016 
	C569.327026,460.616882 568.158630,460.304779 567.161926,459.676880 
	C569.229309,458.569397 571.124939,457.777710 573.422729,456.989380 
	C577.107788,457.505493 580.382874,458.341278 583.676453,458.421478 
	C586.009583,458.478302 588.350037,457.207245 590.718384,457.070892 
	C595.162659,456.815002 599.629517,456.951752 604.086975,456.925171 
	C606.108826,456.649506 608.130615,456.373840 610.538940,456.144592 
	C609.597961,456.793396 608.321838,457.727692 606.934265,457.942688 
	C599.614075,459.076904 592.252991,459.952881 584.945862,461.159027 
	C584.177734,461.285797 583.669556,462.987518 582.755493,464.564819 
	C581.045105,465.951538 579.619934,466.731934 578.182007,467.519379 
	C578.435181,468.760590 578.658264,469.854614 578.881409,470.948639 
	C576.832153,471.608398 574.782898,472.268158 572.372192,472.986145 
	C567.703247,474.427124 563.395691,475.809845 559.037109,477.542175 
	C555.676392,479.427643 552.165466,480.649750 549.123779,482.602783 
	C546.867554,484.051514 545.220886,486.449493 543.225464,488.755798 
	C543.436890,489.863953 543.725647,490.640930 543.915588,491.724579 
z"
      />
      <path
        fill="#D29E5D"
        opacity="1.000000"
        stroke="none"
        d="
M579.092834,471.205231 
	C578.658264,469.854614 578.435181,468.760590 578.182007,467.519379 
	C579.619934,466.731934 581.045105,465.951538 582.769653,464.963135 
	C589.763000,463.987823 596.441650,463.013275 603.155701,462.518311 
	C608.575989,462.118744 614.234009,459.711212 619.701111,463.829010 
	C619.985352,464.305328 619.967651,464.630920 619.650635,465.292358 
	C618.489380,466.378540 617.653564,467.130219 616.817810,467.881897 
	C616.817810,467.881897 616.443420,467.934113 616.002197,467.615112 
	C610.381836,467.871063 605.202698,468.446014 600.023621,469.020966 
	C594.030518,468.907379 587.928406,468.139801 582.191040,471.946808 
	C580.966187,471.799103 580.135193,471.630463 579.092834,471.205231 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M568.100769,515.130859 
	C568.298035,515.078979 568.591370,515.273010 568.962036,515.720215 
	C568.758545,515.774536 568.477661,515.575562 568.100769,515.130859 
z"
      />
      <path
        fill="#0D1316"
        opacity="1.000000"
        stroke="none"
        d="
M675.311646,601.341431 
	C675.309326,601.317383 675.306152,601.273376 675.286011,601.292175 
	C675.265930,601.310974 675.539673,601.286133 675.542603,601.362183 
	C675.545471,601.438293 675.685242,601.795715 675.685242,601.795715 
	C675.685242,601.795715 675.503723,601.544739 675.377930,601.452698 
	C675.252136,601.360657 675.313904,601.365540 675.311646,601.341431 
z"
      />
      <path
        fill="#0A2624"
        opacity="1.000000"
        stroke="none"
        d="
M612.809448,450.404236 
	C617.726685,449.604889 622.622620,448.334717 627.565918,448.111237 
	C635.993103,447.730347 644.450134,448.006897 653.339294,448.024048 
	C654.564514,448.535797 655.344971,449.030701 656.250671,449.885986 
	C656.375916,450.246429 656.071228,450.557709 655.548950,450.669922 
	C653.683594,450.850555 652.340515,450.918976 650.659485,450.944885 
	C649.873291,450.963776 649.425049,451.025116 648.609802,451.034241 
	C647.504822,451.026306 646.766907,451.070648 645.643066,451.044189 
	C643.842224,451.287567 642.427246,451.601746 641.012268,451.915894 
	C635.390930,452.038330 629.769592,452.160767 623.282043,452.137756 
	C619.246094,451.720490 616.076355,451.448700 612.862427,450.986267 
	C612.818298,450.795593 612.809448,450.404236 612.809448,450.404236 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M603.885864,456.693909 
	C599.629517,456.951752 595.162659,456.815002 590.718384,457.070892 
	C588.350037,457.207245 586.009583,458.478302 583.676453,458.421478 
	C580.382874,458.341278 577.107788,457.505493 573.417847,456.657349 
	C573.006348,455.878906 573.001770,455.435852 572.997192,454.992767 
	C576.036621,454.215637 579.075989,453.438507 582.510620,452.624817 
	C583.913513,453.668152 584.906250,455.655853 585.931458,455.672729 
	C590.675293,455.750793 595.428162,455.281250 600.658203,455.039124 
	C601.987366,455.534485 602.836060,455.998566 603.885864,456.693909 
z"
      />
      <path
        fill="#3F8C82"
        opacity="1.000000"
        stroke="none"
        d="
M612.906616,451.176941 
	C616.076355,451.448700 619.246094,451.720490 622.832764,452.181183 
	C622.290649,452.982330 621.359192,454.062073 620.367615,454.120514 
	C617.223389,454.305756 614.056702,454.109711 610.446838,454.014618 
	C609.994934,453.968079 610.053101,453.589294 610.363159,453.315552 
	C611.417725,452.420166 612.162170,451.798553 612.906616,451.176941 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M650.997498,450.987366 
	C652.340515,450.918976 653.683594,450.850555 655.422424,450.847229 
	C656.187561,451.391418 656.556946,451.870605 656.954102,452.667358 
	C655.212952,453.271271 653.444031,453.557678 651.312500,453.428558 
	C650.965759,452.337830 650.981628,451.662598 650.997498,450.987366 
z"
      />
      <path
        fill="#3F8C82"
        opacity="1.000000"
        stroke="none"
        d="
M640.989868,452.304108 
	C642.427246,451.601746 643.842224,451.287567 645.634644,451.370483 
	C645.975403,452.414886 645.938782,453.062164 645.902222,453.709473 
	C644.257324,453.370422 642.612427,453.031342 640.989868,452.304108 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M646.298828,453.797760 
	C645.938782,453.062164 645.975403,452.414886 646.020508,451.441284 
	C646.766907,451.070648 647.504822,451.026306 648.616211,451.360229 
	C649.026611,452.383606 649.063538,453.028717 649.100525,453.673798 
	C648.298889,453.744537 647.497192,453.815277 646.298828,453.797760 
z"
      />
      <path
        fill="#3F8C82"
        opacity="1.000000"
        stroke="none"
        d="
M649.397400,453.743134 
	C649.063538,453.028717 649.026611,452.383606 648.983276,451.412506 
	C649.425049,451.025116 649.873291,450.963776 650.659485,450.944885 
	C650.981628,451.662598 650.965759,452.337830 650.923706,453.343262 
	C650.496460,453.719788 650.095398,453.766113 649.397400,453.743134 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M616.885376,468.210846 
	C617.653564,467.130219 618.489380,466.378540 619.660400,465.536926 
	C620.071289,465.697784 620.146973,465.948639 620.300171,466.584259 
	C619.856812,467.971741 619.335876,468.974426 618.451843,470.036560 
	C617.710205,469.577271 617.331543,469.058533 616.885376,468.210846 
z"
      />
      <path
        fill="#8E785E"
        opacity="1.000000"
        stroke="none"
        d="
M675.903442,601.812866 
	C675.685242,601.795715 675.545471,601.438293 675.655396,601.283813 
	C675.985535,601.261841 676.205811,601.394348 676.426086,601.526917 
	C676.324646,601.627930 676.223145,601.729004 675.903442,601.812866 
z"
      />
      <path
        fill="#40A390"
        opacity="1.000000"
        stroke="none"
        d="
M562.976196,469.043945 
	C560.082947,470.628998 557.348633,472.707672 554.264709,473.700195 
	C547.019104,476.032104 543.400818,482.332458 538.574341,487.288849 
	C537.705078,488.181488 537.865723,490.077087 537.284058,491.759003 
	C536.226929,491.757996 535.436707,491.507599 534.382324,490.742401 
	C535.920227,485.292145 537.722290,480.356659 539.524292,475.421204 
	C534.930115,479.014374 532.506592,483.513062 532.867371,489.242615 
	C531.865356,488.288940 530.935181,487.240662 529.840149,486.409424 
	C528.834778,485.646210 527.651733,485.116882 526.358521,484.738892 
	C525.654541,485.017487 525.139099,485.041656 524.217407,484.692352 
	C522.234436,483.481812 520.657593,482.644806 519.080811,481.807770 
	C519.160767,481.602264 519.240662,481.396759 519.818481,480.970398 
	C520.406860,480.178955 520.497314,479.608429 520.587708,479.037872 
	C525.305420,471.940735 532.350281,468.030792 540.749573,464.924255 
	C545.150818,463.915192 548.711670,462.620544 552.385193,461.899933 
	C556.877747,461.018677 561.464661,460.618713 565.738281,460.293488 
	C558.394653,462.392334 551.323669,464.208252 544.252625,466.024170 
	C544.399780,466.539795 544.546936,467.055450 544.694153,467.571075 
	C552.789124,465.723389 560.884094,463.875732 568.979126,462.028076 
	C568.017517,463.123505 567.055908,464.218933 565.695679,465.804443 
	C559.552307,468.195343 553.807434,470.096191 548.062622,471.997040 
	C548.246338,472.515747 548.429993,473.034454 548.613708,473.553162 
	C553.401184,472.050079 558.188721,470.546997 562.976196,469.043945 
M545.249512,475.172424 
	C545.415588,475.117188 545.581665,475.061951 545.747742,475.006744 
	C545.580933,474.952972 545.414185,474.899200 545.249512,475.172424 
z"
      />
      <path
        fill="#4DA592"
        opacity="1.000000"
        stroke="none"
        d="
M566.010803,460.010620 
	C561.464661,460.618713 556.877747,461.018677 552.385193,461.899933 
	C548.711670,462.620544 545.150818,463.915192 541.108337,464.929596 
	C548.324890,462.259674 555.950378,459.546783 563.633301,457.007599 
	C566.417236,456.087524 569.338562,455.582855 572.597168,454.940674 
	C573.001770,455.435852 573.006348,455.878906 573.015747,456.653992 
	C571.124939,457.777710 569.229309,458.569397 566.917114,459.681213 
	C566.500610,460.001312 566.010803,460.010620 566.010803,460.010620 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M518.907227,481.963989 
	C520.657593,482.644806 522.234436,483.481812 523.832031,484.687439 
	C522.105957,484.729980 520.358948,484.403931 518.242493,483.954865 
	C518.159851,483.261292 518.446777,482.690735 518.907227,481.963989 
z"
      />
      <path
        fill="#7F7868"
        opacity="1.000000"
        stroke="none"
        d="
M520.401367,479.186218 
	C520.497314,479.608429 520.406860,480.178955 520.008179,480.699463 
	C519.871643,480.211151 520.043335,479.772858 520.401367,479.186218 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M527.437500,489.851501 
	C527.909668,490.974854 527.943298,492.173920 528.005432,493.698059 
	C527.660400,493.721588 527.089050,493.081238 526.941589,493.167267 
	C520.890198,496.698517 515.412170,493.584686 509.922363,491.350983 
	C512.763916,490.425995 515.492798,489.623016 518.258911,489.463196 
	C521.153625,489.295929 524.084045,489.746613 527.437500,489.851501 
z"
      />
      <path
        fill="#4C2F17"
        opacity="1.000000"
        stroke="none"
        d="
M508.007202,492.009735 
	C505.599335,492.387604 503.548492,492.303894 504.064117,488.540863 
	C505.133118,488.048798 506.173889,487.954163 507.607727,488.355347 
	C508.002960,489.903992 508.005066,490.956879 508.007202,492.009735 
z"
      />
      <path
        fill="#785230"
        opacity="1.000000"
        stroke="none"
        d="
M508.204102,491.992188 
	C508.005066,490.956879 508.002960,489.903992 507.987366,488.458282 
	C508.269531,488.194550 508.565155,488.323669 508.942383,489.130188 
	C509.030487,490.383057 509.037018,490.958527 509.043579,491.534027 
	C508.883362,491.759583 508.669189,491.906464 508.204102,491.992188 
z"
      />
      <path
        fill="#513821"
        opacity="1.000000"
        stroke="none"
        d="
M509.321564,491.440552 
	C509.037018,490.958527 509.030487,490.383057 509.015625,489.377197 
	C509.326355,489.414429 509.645386,489.881989 510.002380,490.654846 
	C509.893433,491.089111 509.746521,491.218109 509.321564,491.440552 
z"
      />
      <path
        fill="#40AA95"
        opacity="1.000000"
        stroke="none"
        d="
M545.027954,443.262848 
	C546.092407,442.931549 547.149109,442.962067 548.599976,443.040253 
	C548.260193,444.384888 547.526123,445.681854 546.416748,446.990173 
	C545.701050,445.875885 545.360535,444.750275 545.027954,443.262848 
z"
      />
      <path
        fill="#392513"
        opacity="1.000000"
        stroke="none"
        d="
M767.782471,493.141846 
	C768.079041,493.518280 768.122925,494.057373 768.088135,495.009888 
	C767.849609,494.717041 767.689697,494.010773 767.782471,493.141846 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M789.983276,453.992493 
	C789.464172,455.277435 788.750549,456.279327 787.971802,457.589935 
	C786.522034,458.317566 785.137512,458.736481 783.383057,459.148865 
	C783.939331,455.669708 785.864685,453.443176 789.983276,453.992493 
z"
      />
      <path
        fill="#B98841"
        opacity="1.000000"
        stroke="none"
        d="
M762.773071,456.587646 
	C762.921387,456.172119 763.132568,456.122559 763.724976,456.181335 
	C764.195496,456.337616 764.284851,456.385559 764.374146,456.433472 
	C764.253296,456.286011 764.132446,456.138519 764.011536,455.991028 
	C764.101746,455.197876 764.191956,454.404724 764.300415,453.450623 
	C766.390869,454.732635 768.213928,455.850647 770.382690,456.927948 
	C770.054993,458.255615 769.636963,460.550293 768.660400,460.819550 
	C765.667114,461.644867 763.618347,460.008179 762.773071,456.587646 
z"
      />
      <path
        fill="#D5B27E"
        opacity="1.000000"
        stroke="none"
        d="
M317.034271,508.967285 
	C317.579346,509.197571 318.092987,509.460876 318.606628,509.724121 
	C318.486145,509.929138 318.365662,510.134155 318.245239,510.339172 
	C317.887054,510.075836 317.528870,509.812531 317.057312,509.309509 
	C316.943939,509.069794 317.002838,509.000275 317.034271,508.967285 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M627.243225,440.300232 
	C626.718201,440.590088 626.067444,440.626587 625.175171,440.429535 
	C625.661560,440.146301 626.389526,440.096558 627.243225,440.300232 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M635.253174,440.239197 
	C634.771973,440.592621 634.155823,440.702911 633.080078,440.682129 
	C633.453003,440.366058 634.285645,440.181061 635.253174,440.239197 
z"
      />
      <path
        fill="#93673D"
        opacity="1.000000"
        stroke="none"
        d="
M641.875610,439.715485 
	C641.427368,440.138977 640.817444,440.365540 639.899658,440.409546 
	C640.299255,439.990845 641.006653,439.754700 641.875610,439.715485 
z"
      />
      <path
        fill="#6AB9A5"
        opacity="1.000000"
        stroke="none"
        d="
M612.862427,450.986267 
	C612.162170,451.798553 611.417725,452.420166 610.380737,453.124756 
	C604.037292,453.475403 597.986267,453.743164 591.469238,453.761169 
	C591.003113,453.511444 591.010071,453.019379 591.010071,453.019379 
	C596.521667,452.075073 602.033325,451.130768 607.904358,449.989166 
	C609.536194,449.907349 610.808655,450.022797 612.445251,450.271240 
	C612.809448,450.404236 612.818298,450.795593 612.862427,450.986267 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M596.209717,440.235535 
	C599.089539,440.395996 602.209534,440.720642 605.247253,441.408722 
	C605.613220,441.491608 605.533569,443.541901 605.371704,444.839783 
	C602.197021,443.502655 599.311035,442.006104 596.209717,440.235535 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M590.612610,453.011475 
	C591.010071,453.019379 591.003113,453.511444 591.002808,453.757568 
	C589.337158,454.003662 587.671814,454.003662 586.006531,454.003662 
	C586.008484,453.670319 586.010376,453.336945 586.012329,453.003601 
	C587.413269,453.003601 588.814209,453.003601 590.612610,453.011475 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M532.871582,489.536926 
	C532.506592,483.513062 534.930115,479.014374 539.524292,475.421204 
	C537.722290,480.356659 535.920227,485.292145 534.097656,490.604797 
	C533.885803,490.991333 533.694519,491.000671 533.215210,491.012085 
	C532.910034,490.619873 532.892944,490.225525 532.871582,489.536926 
z"
      />
      <path
        fill="#67401F"
        opacity="1.000000"
        stroke="none"
        d="
M600.174805,469.335236 
	C605.202698,468.446014 610.381836,467.871063 615.814209,467.634888 
	C613.125122,468.960785 610.241699,470.377106 607.220703,470.791931 
	C605.016296,471.094666 602.630798,470.078033 600.174805,469.335236 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M565.738281,460.293518 
	C566.010803,460.010620 566.500610,460.001312 566.745422,459.997009 
	C568.158630,460.304779 569.327026,460.616882 570.495422,460.929016 
	C570.202881,461.254974 569.910339,461.580933 569.298462,461.967468 
	C560.884094,463.875732 552.789124,465.723389 544.694153,467.571075 
	C544.546936,467.055450 544.399780,466.539795 544.252625,466.024170 
	C551.323669,464.208252 558.394653,462.392334 565.738281,460.293518 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M563.348755,468.987244 
	C558.188721,470.546997 553.401184,472.050079 548.613708,473.553162 
	C548.429993,473.034454 548.246338,472.515747 548.062622,471.997040 
	C553.807434,470.096191 559.552307,468.195343 565.643677,466.141479 
	C566.847412,466.191101 567.704590,466.393799 569.952454,466.925293 
	C566.988525,467.879089 565.354919,468.404816 563.348755,468.987244 
z"
      />
      <path
        fill="#5AB6A5"
        opacity="1.000000"
        stroke="none"
        d="
M545.248413,475.008942 
	C545.414185,474.899200 545.580933,474.952972 545.747742,475.006714 
	C545.581665,475.061951 545.415588,475.117188 545.248413,475.008942 
z"
      />
      <path
        fill="#D3A86A"
        opacity="1.000000"
        stroke="none"
        d="
M764.005737,455.995483 
	C764.132446,456.138519 764.253296,456.286011 764.374146,456.433472 
	C764.284851,456.385559 764.195496,456.337616 764.048889,456.150330 
	C763.991577,456.010986 764.000000,455.999939 764.005737,455.995483 
z"
      />
    </svg>
  )
}
